(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[844],{

/***/ 7188:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DataCenterIds = exports.DC_SPECIFIC_SUBDOMAINS = void 0;
exports.getDataCenterById = getDataCenterById;
exports.getDataCenterIdFromCurrentUrl = getDataCenterIdFromCurrentUrl;
exports.getDefaultSubdomainForDataCenter = getDefaultSubdomainForDataCenter;
var _parseDomain = __webpack_require__(3327);
var _dataCenters = _interopRequireDefault(__webpack_require__(4363));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DataCenterIds;
exports.DataCenterIds = DataCenterIds;
(function (DataCenterIds) {
  DataCenterIds["US"] = "0";
  DataCenterIds["CA"] = "1";
  DataCenterIds["EU"] = "2";
})(DataCenterIds || (exports.DataCenterIds = DataCenterIds = {}));
var DC_SPECIFIC_SUBDOMAINS;
/**
 * Returns the data center by id
 * @param {string} dataCenterId
 * @returns {Object} data center details
 * @memberof module:@sm/locale
 */
exports.DC_SPECIFIC_SUBDOMAINS = DC_SPECIFIC_SUBDOMAINS;
(function (DC_SPECIFIC_SUBDOMAINS) {
  DC_SPECIFIC_SUBDOMAINS[DC_SPECIFIC_SUBDOMAINS["eu"] = DataCenterIds.EU] = "eu";
})(DC_SPECIFIC_SUBDOMAINS || (exports.DC_SPECIFIC_SUBDOMAINS = DC_SPECIFIC_SUBDOMAINS = {}));
function getDataCenterById(dataCenterId) {
  return _dataCenters.default.dataCenters[dataCenterId];
}

/**
 * Returns the data center id from the url
 * @param {string} url
 * @param {string} dataCenterAffinityCookie
 * @returns {string} data center id
 * @memberof module:@sm/locale
 */
function getDataCenterIdFromCurrentUrl(url, dataCenterAffinityCookie) {
  var parseResult = (0, _parseDomain.parseDomain)((0, _parseDomain.fromUrl)(url)) || {};
  var subdomain;
  var dataCenterId = DataCenterIds.US;
  if (parseResult.type === _parseDomain.ParseResultType.Listed) {
    subdomain = parseResult.subDomains.join('.');
    if (subdomain) {
      var dcSub = Object.keys(_dataCenters.default.dataCenterSpecificSubdomains).find(function (subSpecific) {
        return subSpecific === subdomain || subdomain.endsWith(".".concat(subSpecific));
      });
      if (dcSub) {
        dataCenterId = _dataCenters.default.dataCenterSpecificSubdomains[dcSub];
      }
    }
  }
  if (dataCenterId === DataCenterIds.US && "".concat(dataCenterAffinityCookie) === DataCenterIds.CA) {
    dataCenterId = DataCenterIds.CA;
  }
  return dataCenterId;
}

// This is currently being used in UserWeb here https://code.corp.surveymonkey.com/devmonkeys/userweb/blob/e7646369dfae9fef0c8d1fa3c23f1bde61a9c906/userweb/lib/language.py#L31
// So I'm leaving this function for when we port the corresponding code in UserWeb.
/**
 * Returns the default subdomain for a data center
 * @param {string} dataCenterId
 * @returns {string} subdomain
 * @memberof module:@sm/locale
 */
function getDefaultSubdomainForDataCenter(dataCenterId) {
  var dc = getDataCenterById(dataCenterId);
  return dc && dc.defaultSubdomain || 'www';
}
//# sourceMappingURL=dataCenters.js.map

/***/ }),

/***/ 7776:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "a2", ({
  enumerable: true,
  get: function get() {
    return _languages.LANGUAGES;
  }
}));
Object.defineProperty(exports, "p_", ({
  enumerable: true,
  get: function get() {
    return _languages.LANGUAGES_BY_CODE;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.LANGUAGES_BY_ID;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.LocaleCode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.MULTILINGUAL_SURVEYS_LOCALE_CODES;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.MultilingualSurveysLocaleCode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.SITE_WIDE_LOCALE_CODES;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.SURVEY_CREATION_LOCALE_CODES;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.SiteWideLocaleCode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.SupportLevels;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languages.SurveyCreationLocaleCode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languageTags.convertLanguageTag;
  }
});
__webpack_unused_export__ = getAudienceSupportedCountries;
__webpack_unused_export__ = getBenchmarksSupportedCountries;
__webpack_unused_export__ = getCookieTransportTLDs;
Object.defineProperty(exports, "dC", ({
  enumerable: true,
  get: function get() {
    return _dataCenters.getDataCenterById;
  }
}));
Object.defineProperty(exports, "Ep", ({
  enumerable: true,
  get: function get() {
    return _dataCenters.getDataCenterIdFromCurrentUrl;
  }
}));
Object.defineProperty(exports, "Rt", ({
  enumerable: true,
  get: function get() {
    return _dataCenters.getDefaultSubdomainForDataCenter;
  }
}));
__webpack_unused_export__ = getEUCountries;
__webpack_unused_export__ = getLanguageCodeFromCountryCode;
__webpack_unused_export__ = getLanguageCodeFromSubdomain;
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languageTags.getLanguageTagByCode;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languageTags.getLanguageTagById;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languageTags.getLanguageTags;
  }
});
__webpack_unused_export__ = getSMSupportedCountries;
__webpack_unused_export__ = getSiteSupportedLanguageCodes;
exports.qA = getSiteSupportedLanguages;
exports.gP = getSubdomainFromLanguageCodeAndDataCenter;
exports.UJ = getTldLanguageInfo;
__webpack_unused_export__ = isDACHCountry;
__webpack_unused_export__ = isEUCountry;
__webpack_unused_export__ = isEUDC;
__webpack_unused_export__ = isEUSubdomain;
__webpack_unused_export__ = isGBCountry;
__webpack_unused_export__ = isGDPRCountry;
__webpack_unused_export__ = isUSTerritory;
__webpack_unused_export__ = void 0;
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languageTags.normalizeLanguageTag;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _languageTags.parseLanguageTag;
  }
});
__webpack_unused_export__ = sanitizeCountryCode;
var _invariant = _interopRequireDefault(__webpack_require__(1143));
var _tlds = _interopRequireDefault(__webpack_require__(7012));
var _localeSets = __webpack_require__(544);
var _languages = __webpack_require__(5597);
var _dataCenters = __webpack_require__(7188);
var _languageTags = __webpack_require__(3501);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
// This is for backward compatibility. Remove for 2.0
var localeSets = {
  GDPR_COUNTRIES: _localeSets.GDPRCountryCodes,
  SM_SUPPORTED_COUNTRIES: _localeSets.SMSupportedCountryCodes,
  EU_COUNTRIES: _localeSets.EUCountryCodes,
  US_TERRITORIES: _localeSets.USTerritoryCountryCodes,
  GB_COUNTRIES: _localeSets.GBCountryCodes,
  DASH_COUNTRIES: _localeSets.DASHCountryCodes
};
__webpack_unused_export__ = localeSets;
/**
 * @param {string} country - code
 * @param {string} fallBackCountry - default country code
 * @returns {string} two letter country code, default to US if a fallback is not provided
 */
function sanitizeCountryCode(country) {
  var fallBackCountry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _localeSets.CountryCodes.US;
  var isString = typeof country === 'string';
  if (!isString) {
    // TODO log this
     true ?  false ? 0 : (0, _invariant.default)(false) : 0;
    return fallBackCountry;
  }
  var isTwoLetterCode = country.length === 2;
  if (!isTwoLetterCode) {
    // TODO log this
     true ?  false ? 0 : (0, _invariant.default)(false) : 0;
    return fallBackCountry;
  }
  return _localeSets.SMSupportedCountryCodes.find(function (c) {
    return c === country.toUpperCase();
  }) || fallBackCountry.toUpperCase();
}

/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if that country has GDPR laws
 */
function isGDPRCountry(country) {
  // if we cannot determine the country, assume GDPR country ie GB
  return _localeSets.GDPRCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}

/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is in DASH country set
 */
function isDACHCountry(country) {
  // if we cannot determine the country, assume non Dash ie. US
  return _localeSets.DASHCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.US));
}

/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is in the United Kingdoms
 * @public
 */
function isGBCountry(country) {
  // if we cannot determine the country, assume GB country
  return _localeSets.GBCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}

/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is a US Territory
 * @public
 */
function isUSTerritory(country) {
  // if we cannot determine the country, assume Non US
  return _localeSets.USTerritoryCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}

/**
 * @param {string} country - Two-letter country code
 * @returns {bool} if country is in European Union
 * @public
 */
function isEUCountry(country) {
  // if we cannot determine the country, assume EU. (joelm: WHY?!?!?!)
  return _localeSets.EUCountryCodes.includes(sanitizeCountryCode(country, _localeSets.CountryCodes.GB));
}

/**
 * @param {string} hostname
 * @returns {bool} if host is a EUDC
 * @public
 */
function isEUDC(hostname) {
  return (0, _dataCenters.getDataCenterIdFromCurrentUrl)(hostname) === _dataCenters.DataCenterIds.EU;
}

/**
 * @param {string} subdomain
 * @returns {bool} if EU Subdomain
 * @public
 */
function isEUSubdomain(subdomain) {
  return !!(subdomain && subdomain.indexOf('eu') !== -1);
}

/**
 * @returns {Array} list of European Union Countries
 * @public
 */
function getEUCountries() {
  return _toConsumableArray(_localeSets.EUCountryCodes);
}

/**
 * @returns {Array} List of SM supported TLDs
 * @public
 */
function getCookieTransportTLDs() {
  return _tlds.default.filter(function (tld) {
    return tld.enabled;
  }).map(function (tld) {
    return tld.tld;
  });
}

/**
 * @returns {Array} Countries that SM Audience supports
 * @public
 */
function getAudienceSupportedCountries() {
  // TODO change this to just return list of country codes
  return {
    US: 'United States',
    AU: 'Australia',
    CA: 'Canada',
    NZ: 'New Zealand',
    SG: 'Singapore',
    GB: 'United Kingdom',
    IE: 'Ireland'
  };
}

/**
 * @returns {Array} Countries that SM Benchmarks supports
 * @public
 */
function getBenchmarksSupportedCountries() {
  // TODO change this to jst return a list of country codes
  return {
    US: 'United States'
  };
}

/**
 * @returns {Array} Countries that SM supports
 * @public
 */
function getSMSupportedCountries() {
  return _toConsumableArray(_localeSets.SMSupportedCountryCodes);
}

/**
 * @returns {Object} Language Object that SM Supports
 * @public
 */
function getSiteSupportedLanguages() {
  return _languages.LANGUAGES.filter(function (language) {
    return language.supportLevel === _languages.SupportLevels.SITE_WIDE;
  });
}

/**
 * @param {string} country - Two-letter country code
 * @returns {string} language code
 */
function getLanguageCodeFromCountryCode(country) {
  var language = _languages.LANGUAGES.find(function (lang) {
    return lang.countries.includes(sanitizeCountryCode(country));
  });
  return language ? language.code : 'en';
}

/**
 * Returns the language code from the subdomain
 * @param {string} subdomain
 * @returns {string} language code
 */
function getLanguageCodeFromSubdomain(subdomain) {
  if (subdomain === 'eu' || subdomain === 'www') {
    return 'en';
  }
  var language = _languages.LANGUAGES_WITH_SUBDOMAINS.find(function (lang) {
    return lang.subdomain === subdomain || "".concat(lang.subdomain, ".eu") === subdomain;
  });
  if (language) {
    return language.code;
  }
  return 'en';
}

/**
 * Returns the subdomain from the language code and data center combination
 * @param {string} languageCode
 * @param {string} dataCenterId
 * @returns {string} subdomain
 */
function getSubdomainFromLanguageCodeAndDataCenter(languageCode, dataCenterId) {
  var language = _languages.LANGUAGES_BY_CODE[languageCode];
  var result = language.subdomain;
  if (dataCenterId === _dataCenters.DataCenterIds.EU) {
    result = "".concat(language.subdomain, ".eu");
  } else if (language.tld === language.subdomain) {
    // override for langs like de and ru which have a cctld
    // only affects www.sm.de || www.sm.ru
    result = 'www';
  }
  return result === 'www.eu' ? 'eu' : result;
}

/**
 * @returns {Array} Language codes that SM Supports
 * @public
 */
function getSiteSupportedLanguageCodes() {
  return _languages.SITE_WIDE_LOCALE_CODES;
}
/**
 * Returns the tld language info
 * @param {string} tld
 * @returns {string} language info
 */
function getTldLanguageInfo(tld) {
  var data = _tlds.default.find(function (i) {
    return i.tld === tld;
  });
  if (!data) {
    return _tlds.default.find(function (i) {
      return i.tld === 'com';
    });
  }
  return data;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3501:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.convertLanguageTag = convertLanguageTag;
exports.getLanguageTagByCode = getLanguageTagByCode;
exports.getLanguageTagById = getLanguageTagById;
exports.getLanguageTags = getLanguageTags;
exports.normalizeLanguageTag = normalizeLanguageTag;
exports.parseLanguageTag = parseLanguageTag;
var _languageTags = _interopRequireDefault(__webpack_require__(4316));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) { k++; } groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var tagRegEx = /*#__PURE__*/_wrapRegExp(/^([a-z]{2,3})(_([A-Z]{1}[a-z]{3}))?(_([A-Z]{2}|[0-9]{3}))?(_([A-Za-z0-9]{5,8}|[0-9][A-Za-z0-9]{3}))?$/, {
  primary: 1,
  script: 3,
  region: 5,
  variant: 7
});
var LANGUAGE_TAGS = _languageTags.default;

/**
 * Break a sting Language Tag into it's components based on IETF BCP 47
 *
 * @param tag - (_casing sensitive_) the language tag to be parsed, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */
function parseLanguageTag(tag) {
  var matches = tagRegEx.exec(tag);
  return matches === null || matches === void 0 ? void 0 : matches.groups;
}

/**
 * Replace the delimiter of the string Language Tag, by default to the ISO standard `-`
 *
 * @param tag - the language tag to be converted, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */
function convertLanguageTag(tag) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  return tag.replace(/[_-]/gi, delimiter);
}

/**
 * Convert the string Language Tag to all lowercase hyphenated representation
 *
 * @example `zh_Hant_TW` becomes `zh-hant-tw`
 *
 * @param tag - the language tag to be normalized, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */
function normalizeLanguageTag(tag) {
  return convertLanguageTag(tag).toLowerCase();
}

/** Get array of all possible `LanguageTagDefinition` */
function getLanguageTags() {
  return LANGUAGE_TAGS;
}

/**
 * Get a specific `LanguageTagDefinition` by its id
 *
 * @param id example `"1"` for _English_ or `"361"` for _Croatian (Bosnia and Herzegovina)_
 * @returns
 */
function getLanguageTagById(id) {
  return LANGUAGE_TAGS.find(function (def) {
    return def.id === id;
  });
}

/**
 * Convert the string Language Tag to all lowercase hyphenated representation
 *
 * @example `zh_Hant_TW` becomes `zh-hant-tw`
 *
 * @param code - the code (aka. language tag) to be searched for, e.g.:
 *   - `pt` for portuguese
 *   - `pt_BR` for brasilia portuguese
 *   - `zh_Hant_TW` for _Chinese (Traditional, Taiwan)_
 *   - `en_US_POSIX` for _English (United States, Computer)_
 */
function getLanguageTagByCode(code) {
  var nt = normalizeLanguageTag;
  return LANGUAGE_TAGS.find(function (def) {
    return nt(def.code) === nt(code);
  });
}
//# sourceMappingURL=languageTags.js.map

/***/ }),

/***/ 544:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.USTerritoryCountryCodes = exports.SMSupportedCountryCodes = exports.GDPRCountryCodes = exports.GBCountryCodes = exports.EUCountryCodes = exports.DASHCountryCodes = exports.CountryCodes = void 0;
var CountryCodes;
exports.CountryCodes = CountryCodes;
(function (CountryCodes) {
  CountryCodes["AE"] = "AE";
  CountryCodes["AR"] = "AR";
  CountryCodes["AU"] = "AU";
  CountryCodes["BR"] = "BR";
  CountryCodes["CA"] = "CA";
  CountryCodes["CH"] = "CH";
  CountryCodes["LI"] = "LI";
  CountryCodes["DK"] = "DK";
  CountryCodes["FO"] = "FO";
  CountryCodes["GL"] = "GL";
  CountryCodes["AD"] = "AD";
  CountryCodes["AL"] = "AL";
  CountryCodes["AT"] = "AT";
  CountryCodes["AX"] = "AX";
  CountryCodes["BA"] = "BA";
  CountryCodes["BE"] = "BE";
  CountryCodes["BG"] = "BG";
  CountryCodes["BY"] = "BY";
  CountryCodes["CY"] = "CY";
  CountryCodes["CZ"] = "CZ";
  CountryCodes["DE"] = "DE";
  CountryCodes["EE"] = "EE";
  CountryCodes["ES"] = "ES";
  CountryCodes["FI"] = "FI";
  CountryCodes["FR"] = "FR";
  CountryCodes["GF"] = "GF";
  CountryCodes["GP"] = "GP";
  CountryCodes["GR"] = "GR";
  CountryCodes["HR"] = "HR";
  CountryCodes["HU"] = "HU";
  CountryCodes["IE"] = "IE";
  CountryCodes["IS"] = "IS";
  CountryCodes["IT"] = "IT";
  CountryCodes["LT"] = "LT";
  CountryCodes["LU"] = "LU";
  CountryCodes["LV"] = "LV";
  CountryCodes["MC"] = "MC";
  CountryCodes["MD"] = "MD";
  CountryCodes["ME"] = "ME";
  CountryCodes["MF"] = "MF";
  CountryCodes["MK"] = "MK";
  CountryCodes["MQ"] = "MQ";
  CountryCodes["MT"] = "MT";
  CountryCodes["NL"] = "NL";
  CountryCodes["PL"] = "PL";
  CountryCodes["PM"] = "PM";
  CountryCodes["PT"] = "PT";
  CountryCodes["RE"] = "RE";
  CountryCodes["RO"] = "RO";
  CountryCodes["RS"] = "RS";
  CountryCodes["RU"] = "RU";
  CountryCodes["SI"] = "SI";
  CountryCodes["SK"] = "SK";
  CountryCodes["SM"] = "SM";
  CountryCodes["TF"] = "TF";
  CountryCodes["TR"] = "TR";
  CountryCodes["UA"] = "UA";
  CountryCodes["VA"] = "VA";
  CountryCodes["YT"] = "YT";
  CountryCodes["GB"] = "GB";
  CountryCodes["GG"] = "GG";
  CountryCodes["GI"] = "GI";
  CountryCodes["GS"] = "GS";
  CountryCodes["IM"] = "IM";
  CountryCodes["JE"] = "JE";
  CountryCodes["HK"] = "HK";
  CountryCodes["IN"] = "IN";
  CountryCodes["JP"] = "JP";
  CountryCodes["KR"] = "KR";
  CountryCodes["MX"] = "MX";
  CountryCodes["NO"] = "NO";
  CountryCodes["NZ"] = "NZ";
  CountryCodes["SE"] = "SE";
  CountryCodes["SG"] = "SG";
  CountryCodes["TW"] = "TW";
  CountryCodes["AF"] = "AF";
  CountryCodes["AG"] = "AG";
  CountryCodes["AI"] = "AI";
  CountryCodes["AM"] = "AM";
  CountryCodes["AN"] = "AN";
  CountryCodes["AO"] = "AO";
  CountryCodes["AQ"] = "AQ";
  CountryCodes["AS"] = "AS";
  CountryCodes["AW"] = "AW";
  CountryCodes["AZ"] = "AZ";
  CountryCodes["BB"] = "BB";
  CountryCodes["BD"] = "BD";
  CountryCodes["BF"] = "BF";
  CountryCodes["BH"] = "BH";
  CountryCodes["BI"] = "BI";
  CountryCodes["BJ"] = "BJ";
  CountryCodes["BL"] = "BL";
  CountryCodes["BM"] = "BM";
  CountryCodes["BN"] = "BN";
  CountryCodes["BO"] = "BO";
  CountryCodes["BS"] = "BS";
  CountryCodes["BT"] = "BT";
  CountryCodes["BV"] = "BV";
  CountryCodes["BW"] = "BW";
  CountryCodes["BZ"] = "BZ";
  CountryCodes["CC"] = "CC";
  CountryCodes["CD"] = "CD";
  CountryCodes["CF"] = "CF";
  CountryCodes["CG"] = "CG";
  CountryCodes["CI"] = "CI";
  CountryCodes["CK"] = "CK";
  CountryCodes["CL"] = "CL";
  CountryCodes["CM"] = "CM";
  CountryCodes["CN"] = "CN";
  CountryCodes["CO"] = "CO";
  CountryCodes["CR"] = "CR";
  CountryCodes["CV"] = "CV";
  CountryCodes["CX"] = "CX";
  CountryCodes["DJ"] = "DJ";
  CountryCodes["DM"] = "DM";
  CountryCodes["DO"] = "DO";
  CountryCodes["DZ"] = "DZ";
  CountryCodes["EC"] = "EC";
  CountryCodes["EG"] = "EG";
  CountryCodes["EH"] = "EH";
  CountryCodes["ER"] = "ER";
  CountryCodes["ET"] = "ET";
  CountryCodes["FJ"] = "FJ";
  CountryCodes["FK"] = "FK";
  CountryCodes["FM"] = "FM";
  CountryCodes["GA"] = "GA";
  CountryCodes["GD"] = "GD";
  CountryCodes["GE"] = "GE";
  CountryCodes["GH"] = "GH";
  CountryCodes["GM"] = "GM";
  CountryCodes["GN"] = "GN";
  CountryCodes["GQ"] = "GQ";
  CountryCodes["GT"] = "GT";
  CountryCodes["GU"] = "GU";
  CountryCodes["GW"] = "GW";
  CountryCodes["GY"] = "GY";
  CountryCodes["HM"] = "HM";
  CountryCodes["HN"] = "HN";
  CountryCodes["HT"] = "HT";
  CountryCodes["ID"] = "ID";
  CountryCodes["IL"] = "IL";
  CountryCodes["IO"] = "IO";
  CountryCodes["IQ"] = "IQ";
  CountryCodes["JM"] = "JM";
  CountryCodes["JO"] = "JO";
  CountryCodes["KE"] = "KE";
  CountryCodes["KG"] = "KG";
  CountryCodes["KH"] = "KH";
  CountryCodes["KI"] = "KI";
  CountryCodes["KM"] = "KM";
  CountryCodes["KN"] = "KN";
  CountryCodes["KP"] = "KP";
  CountryCodes["KW"] = "KW";
  CountryCodes["KY"] = "KY";
  CountryCodes["KZ"] = "KZ";
  CountryCodes["LA"] = "LA";
  CountryCodes["LB"] = "LB";
  CountryCodes["LC"] = "LC";
  CountryCodes["LK"] = "LK";
  CountryCodes["LR"] = "LR";
  CountryCodes["LS"] = "LS";
  CountryCodes["LY"] = "LY";
  CountryCodes["MA"] = "MA";
  CountryCodes["MG"] = "MG";
  CountryCodes["MH"] = "MH";
  CountryCodes["ML"] = "ML";
  CountryCodes["MM"] = "MM";
  CountryCodes["MN"] = "MN";
  CountryCodes["MO"] = "MO";
  CountryCodes["MP"] = "MP";
  CountryCodes["MR"] = "MR";
  CountryCodes["MS"] = "MS";
  CountryCodes["MU"] = "MU";
  CountryCodes["MV"] = "MV";
  CountryCodes["MW"] = "MW";
  CountryCodes["MY"] = "MY";
  CountryCodes["MZ"] = "MZ";
  CountryCodes["NA"] = "NA";
  CountryCodes["NC"] = "NC";
  CountryCodes["NE"] = "NE";
  CountryCodes["NF"] = "NF";
  CountryCodes["NG"] = "NG";
  CountryCodes["NI"] = "NI";
  CountryCodes["NP"] = "NP";
  CountryCodes["NR"] = "NR";
  CountryCodes["NU"] = "NU";
  CountryCodes["OM"] = "OM";
  CountryCodes["PA"] = "PA";
  CountryCodes["PE"] = "PE";
  CountryCodes["PF"] = "PF";
  CountryCodes["PG"] = "PG";
  CountryCodes["PH"] = "PH";
  CountryCodes["PK"] = "PK";
  CountryCodes["PN"] = "PN";
  CountryCodes["PR"] = "PR";
  CountryCodes["PS"] = "PS";
  CountryCodes["PW"] = "PW";
  CountryCodes["PY"] = "PY";
  CountryCodes["QA"] = "QA";
  CountryCodes["RW"] = "RW";
  CountryCodes["SA"] = "SA";
  CountryCodes["SB"] = "SB";
  CountryCodes["SC"] = "SC";
  CountryCodes["SH"] = "SH";
  CountryCodes["SJ"] = "SJ";
  CountryCodes["SL"] = "SL";
  CountryCodes["SN"] = "SN";
  CountryCodes["SO"] = "SO";
  CountryCodes["SR"] = "SR";
  CountryCodes["ST"] = "ST";
  CountryCodes["SV"] = "SV";
  CountryCodes["SY"] = "SY";
  CountryCodes["SZ"] = "SZ";
  CountryCodes["TC"] = "TC";
  CountryCodes["TD"] = "TD";
  CountryCodes["TG"] = "TG";
  CountryCodes["TH"] = "TH";
  CountryCodes["TJ"] = "TJ";
  CountryCodes["TK"] = "TK";
  CountryCodes["TL"] = "TL";
  CountryCodes["TM"] = "TM";
  CountryCodes["TN"] = "TN";
  CountryCodes["TO"] = "TO";
  CountryCodes["TT"] = "TT";
  CountryCodes["TV"] = "TV";
  CountryCodes["TZ"] = "TZ";
  CountryCodes["UG"] = "UG";
  CountryCodes["UM"] = "UM";
  CountryCodes["US"] = "US";
  CountryCodes["UY"] = "UY";
  CountryCodes["UZ"] = "UZ";
  CountryCodes["VC"] = "VC";
  CountryCodes["VE"] = "VE";
  CountryCodes["VG"] = "VG";
  CountryCodes["VI"] = "VI";
  CountryCodes["VN"] = "VN";
  CountryCodes["VU"] = "VU";
  CountryCodes["WF"] = "WF";
  CountryCodes["WS"] = "WS";
  CountryCodes["YE"] = "YE";
  CountryCodes["ZM"] = "ZM";
  CountryCodes["ZW"] = "ZW";
  CountryCodes["ZA"] = "ZA";
})(CountryCodes || (exports.CountryCodes = CountryCodes = {}));
var GDPRCountryCodes = [CountryCodes.AT, CountryCodes.BE, CountryCodes.BG, CountryCodes.CH, CountryCodes.CY, CountryCodes.CZ, CountryCodes.DE, CountryCodes.DK, CountryCodes.EE, CountryCodes.ES, CountryCodes.FI, CountryCodes.FR, CountryCodes.GB, CountryCodes.GR, CountryCodes.HR, CountryCodes.HU, CountryCodes.IE, CountryCodes.IM, CountryCodes.IT, CountryCodes.LT, CountryCodes.LU, CountryCodes.LV, CountryCodes.MC, CountryCodes.MT, CountryCodes.NL, CountryCodes.PL, CountryCodes.PT, CountryCodes.RO, CountryCodes.SE, CountryCodes.SI, CountryCodes.SK, CountryCodes.IS, CountryCodes.LI, CountryCodes.NO];
exports.GDPRCountryCodes = GDPRCountryCodes;
var DASHCountryCodes = [CountryCodes.DE, CountryCodes.AT, CountryCodes.CH];
exports.DASHCountryCodes = DASHCountryCodes;
var GBCountryCodes = [CountryCodes.GB, CountryCodes.GG, CountryCodes.GI, CountryCodes.GS, CountryCodes.IM, CountryCodes.JE];
exports.GBCountryCodes = GBCountryCodes;
var USTerritoryCountryCodes = [CountryCodes.GU, CountryCodes.PR, CountryCodes.UM, CountryCodes.US, CountryCodes.VI];
exports.USTerritoryCountryCodes = USTerritoryCountryCodes;
var EUCountryCodes = [CountryCodes.AT, CountryCodes.BE, CountryCodes.BG, CountryCodes.CY, CountryCodes.CZ, CountryCodes.DE, CountryCodes.DK, CountryCodes.EE, CountryCodes.ES, CountryCodes.FI, CountryCodes.FR, CountryCodes.GB, CountryCodes.GR, CountryCodes.HR, CountryCodes.HU, CountryCodes.IE, CountryCodes.IM, CountryCodes.IT, CountryCodes.LT, CountryCodes.LU, CountryCodes.LV, CountryCodes.MC, CountryCodes.MT, CountryCodes.NL, CountryCodes.PL, CountryCodes.PT, CountryCodes.RO, CountryCodes.SE, CountryCodes.SI, CountryCodes.SK];
exports.EUCountryCodes = EUCountryCodes;
var SMSupportedCountryCodes = [CountryCodes.AE, CountryCodes.AR, CountryCodes.AU, CountryCodes.BR, CountryCodes.CA, CountryCodes.CH, CountryCodes.LI, CountryCodes.DK, CountryCodes.FO, CountryCodes.GL, CountryCodes.AD, CountryCodes.AL, CountryCodes.AT, CountryCodes.AX, CountryCodes.BA, CountryCodes.BE, CountryCodes.BG, CountryCodes.BY, CountryCodes.CY, CountryCodes.CZ, CountryCodes.DE, CountryCodes.EE, CountryCodes.ES, CountryCodes.FI, CountryCodes.FR, CountryCodes.GF, CountryCodes.GP, CountryCodes.GR, CountryCodes.HR, CountryCodes.HU, CountryCodes.IE, CountryCodes.IS, CountryCodes.IT, CountryCodes.LT, CountryCodes.LU, CountryCodes.LV, CountryCodes.MC, CountryCodes.MD, CountryCodes.ME, CountryCodes.MF, CountryCodes.MK, CountryCodes.MQ, CountryCodes.MT, CountryCodes.NL, CountryCodes.PL, CountryCodes.PM, CountryCodes.PT, CountryCodes.RE, CountryCodes.RO, CountryCodes.RS, CountryCodes.RU, CountryCodes.SI, CountryCodes.SK, CountryCodes.SM, CountryCodes.TF, CountryCodes.TR, CountryCodes.UA, CountryCodes.VA, CountryCodes.YT, CountryCodes.GB, CountryCodes.GG, CountryCodes.GI, CountryCodes.GS, CountryCodes.IM, CountryCodes.JE, CountryCodes.HK, CountryCodes.IN, CountryCodes.JP, CountryCodes.KR, CountryCodes.MX, CountryCodes.NO, CountryCodes.NZ, CountryCodes.SE, CountryCodes.SG, CountryCodes.TW, CountryCodes.AF, CountryCodes.AG, CountryCodes.AI, CountryCodes.AM, CountryCodes.AN, CountryCodes.AO, CountryCodes.AQ, CountryCodes.AS, CountryCodes.AW, CountryCodes.AZ, CountryCodes.BB, CountryCodes.BD, CountryCodes.BF, CountryCodes.BH, CountryCodes.BI, CountryCodes.BJ, CountryCodes.BL, CountryCodes.BM, CountryCodes.BN, CountryCodes.BO, CountryCodes.BS, CountryCodes.BT, CountryCodes.BV, CountryCodes.BW, CountryCodes.BZ, CountryCodes.CC, CountryCodes.CD, CountryCodes.CF, CountryCodes.CG, CountryCodes.CI, CountryCodes.CK, CountryCodes.CL, CountryCodes.CM, CountryCodes.CN, CountryCodes.CO, CountryCodes.CR, CountryCodes.CV, CountryCodes.CX, CountryCodes.DJ, CountryCodes.DM, CountryCodes.DO, CountryCodes.DZ, CountryCodes.EC, CountryCodes.EG, CountryCodes.EH, CountryCodes.ER, CountryCodes.ET, CountryCodes.FJ, CountryCodes.FK, CountryCodes.FM, CountryCodes.GA, CountryCodes.GD, CountryCodes.GE, CountryCodes.GH, CountryCodes.GM, CountryCodes.GN, CountryCodes.GQ, CountryCodes.GT, CountryCodes.GU, CountryCodes.GW, CountryCodes.GY, CountryCodes.HM, CountryCodes.HN, CountryCodes.HT, CountryCodes.ID, CountryCodes.IL, CountryCodes.IO, CountryCodes.IQ, CountryCodes.JM, CountryCodes.JO, CountryCodes.KE, CountryCodes.KG, CountryCodes.KH, CountryCodes.KI, CountryCodes.KM, CountryCodes.KN, CountryCodes.KP, CountryCodes.KW, CountryCodes.KY, CountryCodes.KZ, CountryCodes.LA, CountryCodes.LB, CountryCodes.LC, CountryCodes.LK, CountryCodes.LR, CountryCodes.LS, CountryCodes.LY, CountryCodes.MA, CountryCodes.MG, CountryCodes.MH, CountryCodes.ML, CountryCodes.MM, CountryCodes.MN, CountryCodes.MO, CountryCodes.MP, CountryCodes.MR, CountryCodes.MS, CountryCodes.MU, CountryCodes.MV, CountryCodes.MW, CountryCodes.MY, CountryCodes.MZ, CountryCodes.NA, CountryCodes.NC, CountryCodes.NE, CountryCodes.NF, CountryCodes.NG, CountryCodes.NI, CountryCodes.NP, CountryCodes.NR, CountryCodes.NU, CountryCodes.OM, CountryCodes.PA, CountryCodes.PE, CountryCodes.PF, CountryCodes.PG, CountryCodes.PH, CountryCodes.PK, CountryCodes.PN, CountryCodes.PR, CountryCodes.PS, CountryCodes.PW, CountryCodes.PY, CountryCodes.QA, CountryCodes.RW, CountryCodes.SA, CountryCodes.SB, CountryCodes.SC, CountryCodes.SH, CountryCodes.SJ, CountryCodes.SL, CountryCodes.SN, CountryCodes.SO, CountryCodes.SR, CountryCodes.ST, CountryCodes.SV, CountryCodes.SY, CountryCodes.SZ, CountryCodes.TC, CountryCodes.TD, CountryCodes.TG, CountryCodes.TH, CountryCodes.TJ, CountryCodes.TK, CountryCodes.TL, CountryCodes.TM, CountryCodes.TN, CountryCodes.TO, CountryCodes.TT, CountryCodes.TV, CountryCodes.TZ, CountryCodes.UG, CountryCodes.UM, CountryCodes.US, CountryCodes.UY, CountryCodes.UZ, CountryCodes.VC, CountryCodes.VE, CountryCodes.VG, CountryCodes.VI, CountryCodes.VN, CountryCodes.VU, CountryCodes.WF, CountryCodes.WS, CountryCodes.YE, CountryCodes.ZM, CountryCodes.ZW, CountryCodes.ZA];
exports.SMSupportedCountryCodes = SMSupportedCountryCodes;
//# sourceMappingURL=localeSets.js.map

/***/ }),

/***/ 3685:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(6477);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 1833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lq": function() { return /* binding */ getColor; },
/* harmony export */   "kg": function() { return /* binding */ SEMANTIC_COLORS; },
/* harmony export */   "nk": function() { return /* binding */ TYPE_COLORS; },
/* harmony export */   "u5": function() { return /* binding */ LINK_COLORS; },
/* harmony export */   "um": function() { return /* binding */ FONT_SIZES; }
/* harmony export */ });
/* unused harmony exports BACKGROUND_COLORS, BACKGROUND_SEMANTIC_COLORS, BORDER_COLORS, BORDER_KEYS, DATA_COLORS, DATA_VIS_COLORS, ELEVATION_KEYS, ElevateTheme, FONT_ASSETS, FONT_FAMILY_KEYS, FONT_WEIGHTS, GlobalStyles, RADIUS_KEYS, SHADOW_KEYS, SIZES, SPACING_KEYS, WrenchTheme, blueprintBoxStyle, blueprintBoxStyleXl, flexBoxStyle, flexBoxStyleLg, flexBoxStyleMd, flexBoxStyleSm, getDataColor, innerBoxStyle, isBackgroundColor, isBackgroundSemanticColor, isBorderColor, isColorShape, isDataColor, isDataVisColor, isLinkColor, isSemanticColor, isTypeColor, outerBoxStyle, paddingBoxStyle */
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8530);


/// ///////////////////////// GENERIC START ////////////////////////////
var SIZES = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg', 'xl']));
/// ///////////////////////// PALETTE START ////////////////////////////
var SEMANTIC_COLORS = [
    'primary',
    'secondary',
    'success',
    'warning',
    'upgrade',
    'error',
    'info',
    'muted',
];
var LINK_COLORS = ['link'];
var TYPE_COLORS = [
    'dark',
    'light',
    'darkMuted',
    'lightMuted',
    'link',
];
var BACKGROUND_COLORS = [
    'main',
    'light',
    'dark',
    'overlay',
    'accent',
];
var BACKGROUND_SEMANTIC_COLORS = [
    'primary',
    'success',
    'warning',
    'error',
    'info',
    'upgrade',
    'muted'
];
var BORDER_COLORS = ['main', 'active', 'hover', 'muted'];
var DATA_COLORS = [
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
];
/// ///////////////////////// FONT TYPE START ////////////////////////////
var FONT_FAMILY_KEYS = (/* unused pure expression or super */ null && (['base', 'headings', 'icon']));
var FONT_SIZES = [
    'caption',
    'bodySm',
    'body',
    'cardTitle',
    'sectionTitleSm',
    'sectionTitle',
    'pageTitle',
    'hero2',
    'hero1',
];
var FONT_WEIGHTS = ['light', 'regular', 'medium'];
var FONT_ASSETS = (/* unused pure expression or super */ null && (['base', 'path', 'name', 'versions']));
/// ///////////////////////// SPACING START ////////////////////////////
var SPACING_KEYS = (/* unused pure expression or super */ null && ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]));
var BORDER_KEYS = (/* unused pure expression or super */ null && ([
    'main',
    'hover',
    'active',
    'muted',
    'dark',
    'light',
]));
/// ///////////////////////// RADIUS START ////////////////////////////
var RADIUS_KEYS = (/* unused pure expression or super */ null && (['zero', 'small', 'medium', 'large']));
/// ///////////////////////// SHADOW START ////////////////////////////
var SHADOW_KEYS = (/* unused pure expression or super */ null && (['none', 'sky', 'space']));
/// ///////////////////////// ELEVATION START ////////////////////////////
var ELEVATION_KEYS = (/* unused pure expression or super */ null && (['none', 'sky', 'space']));
/// ///////////////////////// DATA VIS ////////////////////////////
var dataTransform = function (arr) {
    return Object.freeze(arr.map(function (x) { return "data-".concat(x); }));
};
var DATA_VIS_COLORS = dataTransform(DATA_COLORS);
var getDataColor = function (s) {
    return s.split('-')[1];
};
/// ///////////////////////// HELPERS ////////////////////////////
var readOnlyIncludes = function (arr, el) {
    return arr.includes(el);
};
/// ///////////////////////// TYPE GUARDS ////////////////////////////
var isColorShape = function (c) {
    return typeof c === 'object' && 'main' in c;
};
var isSemanticColor = function (c) {
    return readOnlyIncludes(SEMANTIC_COLORS, c);
};
var isLinkColor = function (c) {
    return c === 'link';
};
var isTypeColor = function (c) {
    return readOnlyIncludes(TYPE_COLORS, c);
};
var isBackgroundColor = function (c) {
    return readOnlyIncludes(BACKGROUND_COLORS, c);
};
var isBackgroundSemanticColor = function (c) {
    return readOnlyIncludes(BACKGROUND_SEMANTIC_COLORS, c);
};
var isBorderColor = function (c) {
    return readOnlyIncludes(BORDER_COLORS, c);
};
var isDataColor = function (c) {
    return readOnlyIncludes(DATA_COLORS, c);
};
var isDataVisColor = function (c) {
    return readOnlyIncludes(DATA_VIS_COLORS, c);
};
var getColor = function (palette, color, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.semanticKey, semanticKey = _c === void 0 ? 'main' : _c, _d = _b.semanticBackgroundKey, semanticBackgroundKey = _d === void 0 ? 'light' : _d, _e = _b.colorType, colorType = _e === void 0 ? 'semantic' : _e, fallback = _b.fallback;
    var c = fallback !== null && fallback !== void 0 ? fallback : 'currentcolor';
    if (!color)
        return c;
    var cType = colorType;
    // if passed a portion of the Pallette that is the semantic color use that.
    if (isColorShape(color))
        c = color[semanticKey];
    else {
        // Check Semantic
        if (cType === 'semantic') {
            if (isSemanticColor(color))
                c = palette[color][semanticKey];
            else
                cType = 'link';
        }
        // Check type and get Color
        if (cType === 'link') {
            if (isLinkColor(color))
                c = palette[color][semanticKey];
            else
                cType = 'text';
        }
        if (cType === 'text') {
            if (isTypeColor(color))
                c = palette[cType][color];
            else
                cType = 'background';
        }
        if (cType === 'background') {
            if (isBackgroundColor(color))
                c = palette[cType][color];
            if (isBackgroundSemanticColor(color))
                c = palette[cType][color][semanticBackgroundKey];
            else
                cType = 'border';
        }
        if (cType === 'border') {
            if (isBorderColor(color))
                c = palette[cType][color];
            else
                cType = 'data';
        }
        if (cType === 'data') {
            if (isDataVisColor(color))
                c = palette[cType][getDataColor(color)];
            if (isDataColor(color))
                c = palette[cType][color];
        }
    }
    return c;
};

var name$1 = 'Wrench';
var basePath$1 =  false
    ? 0
    : 'cdn.smassets.net';
var fontSize = {
    caption: 12,
    bodySm: 14,
    body: 16,
    cardTitle: 20,
    sectionTitleSm: 24,
    sectionTitle: 28,
    pageTitle: 32,
    hero1: 48,
    hero2: 40,
};
var fontWeight = {
    light: 300,
    regular: 400,
    medium: 500,
};
var fontFamily = {
    base: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
    headings: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
    icon: 'Mateo',
};
var assets = {
    base: "https://".concat(basePath$1, "/assets/wds-core_4_20_1"),
    path: '/fonts/National2Web',
    name: "'National 2'",
    version: 2,
};
var type$1 = {
    assets: assets,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeight: fontWeight,
};
var palette$1 = {
    transparent: {
        clear: 'transparent',
        dark: 'rgba(51,62,72,0.2)',
        light: 'rgba(255, 255, 255, 0.2)',
    },
    primary: {
        main: '#00BF6F',
        contrast: '#FFFFFF',
    },
    secondary: {
        main: '#6B787F',
        contrast: '#FFFFFF',
    },
    success: {
        main: '#00BF6F',
        contrast: '#FFFFFF',
    },
    warning: {
        main: '#F05B24',
        contrast: '#FFFFFF',
    },
    error: {
        main: '#F05B24',
        contrast: '#FFFFFF',
    },
    info: {
        main: '#2DCCD3',
        contrast: '#333E48',
    },
    upgrade: {
        main: '#F9BE00',
        contrast: '#333E48',
    },
    muted: {
        main: '#D0D2D3',
        contrast: '#333E48',
    },
    link: {
        main: '#007FAA',
        contrast: '#FFFFFF',
    },
    text: {
        dark: '#333E48',
        light: '#FFFFFF',
        darkMuted: '#6B787F',
        lightMuted: '#D0D2D3',
        link: '#007FAA',
    },
    background: {
        main: '#F7F8FA',
        light: '#FFFFFF',
        dark: '#333E48',
        overlay: 'rgba(107, 120, 127, .86)',
        accent: '#EDEEEE',
        primary: {
            light: '#E5F9F1',
            medium: '#ADEBD1',
        },
        success: {
            light: '#E5F9F1',
            medium: '#ADEBD1',
        },
        warning: {
            light: '#FDEBE5',
            medium: '#FBD8CA',
        },
        error: {
            light: '#F5E3EB',
            medium: '#EBC7D7',
        },
        info: {
            light: '#E6F9FA',
            medium: '#CDF3F4',
        },
        upgrade: {
            light: '#FEF2CC',
            medium: '#FDE599',
        },
        muted: {
            light: '#EDEEEE',
            medium: '#EDEEEE',
        },
    },
    border: {
        main: '#D0D2D3',
        active: '#404040',
        hover: '#757575',
        muted: '#EDEEEE',
    },
    data: {
        one: '#507CB6',
        two: '#00BF6F',
        three: '#6BC8CD',
        four: '#F9BE00',
        five: '#7D5E90',
        six: '#DB4D5C',
        seven: '#768086',
        eight: '#D25F90',
        nine: '#A38364',
        ten: '#FF8B4F',
    },
};
var spacing$1 = {
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 24,
    6: 32,
    7: 48,
    8: 64,
    9: 96,
    10: 128,
};
var motion$1 = {
    curve: {
        enter: 'cubic-bezier(0, 0, 0, 1)',
        exit: 'cubic-bezier(1, 0, 1, 1)',
        ease: 'cubic-bezier(.2, 0, .1, 1)',
        easeReverse: 'cubic-bezier(.9, 0, .8, 1)',
        bounceStart: 'cubic-bezier(0, 0, .1, 1)',
        bounceEnd: 'cubic-bezier(.2, 0, 0, 1)',
    },
    fade: {
        speed: {
            slow: 300,
            normal: 200,
            fast: 100,
        },
    },
    slide: {
        speed: {
            slow: 450,
            normal: 350,
            fast: 250,
        },
        distance: {
            normal: 25,
            near: 5,
            far: 75,
        },
    },
};
var border$1 = {
    main: [1, 'solid', getColor(palette$1, 'main', { colorType: 'border' })],
    hover: [1, 'solid', getColor(palette$1, 'hover', { colorType: 'border' })],
    active: [1, 'solid', getColor(palette$1, 'active', { colorType: 'border' })],
    muted: [1, 'solid', getColor(palette$1, 'muted', { colorType: 'border' })],
    dark: [1, 'solid', getColor(palette$1, 'dark', { colorType: 'background' })],
    light: [2, 'solid', getColor(palette$1, 'light', { colorType: 'background' })],
};
var radius$1 = {
    zero: 0,
    small: 4,
    medium: 24,
    large: '50%',
};
var shadow$1 = {
    none: 'none',
    sky: '0 2px 4px 0 rgba(0, 0, 0, 0.14)',
    space: '0 2px 8px 0 rgba(0,0,0,0.14)',
};
var breakpoints$1 = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
};
var iconSize$1 = {
    sm: 13,
    md: 16,
    lg: 24,
    xl: 32,
};
var elevation$1 = {
    none: 0,
    sky: 999,
    space: 9999,
};
/**
 * Exported theme is the Surveymonkey theme.
 * See our storybook for more info on the theme shape/breakdown
 * @see {@link [Storybook](http://storybook.jungle.tech/wrench/index.html?path=/story/intro-theme-breakdown--page)}
 */
var theme$1 = {
    name: name$1,
    type: type$1,
    palette: palette$1,
    spacing: spacing$1,
    motion: motion$1,
    border: border$1,
    radius: radius$1,
    shadow: shadow$1,
    breakpoints: breakpoints$1,
    iconSize: iconSize$1,
    elevation: elevation$1,
};

var name = 'Elevate';
var basePath =  false
    ? 0
    : 'cdn.smassets.net';
var type = {
    fontFamily: {
        base: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
        headings: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
        icon: 'Mateo',
    },
    fontSize: {
        caption: 12,
        bodySm: 14,
        body: 16,
        cardTitle: 20,
        sectionTitleSm: 24,
        sectionTitle: 28,
        pageTitle: 32,
        hero1: 48,
        hero2: 40,
    },
    fontWeight: {
        light: 300,
        regular: 400,
        medium: 500,
    },
    assets: {
        base: "https://".concat(basePath, "/assets/wds-core_4_20_1"),
        path: '/fonts/National2Web',
        name: "'National 2'",
        version: 2,
    },
};
var palette = {
    transparent: {
        clear: 'transparent',
        dark: 'rgba(64,64,64,0.2)',
        light: 'rgba(255, 255, 255, 0.2)',
    },
    primary: {
        main: '#008323',
        contrast: '#FFFFFF',
    },
    secondary: {
        main: '#757575',
        contrast: '#FFFFFF',
    },
    success: {
        main: '#008323',
        contrast: '#FFFFFF',
    },
    warning: {
        main: '#F7B500',
        contrast: '#404040',
    },
    error: {
        main: '#CC0000',
        contrast: '#FFFFFF',
    },
    info: {
        main: '#2cb2f1',
        contrast: '#000000',
    },
    upgrade: {
        main: '#ffe11b',
        contrast: '#404040',
    },
    muted: {
        main: '#d0d0d0',
        contrast: '#404040',
    },
    link: {
        main: '#0a7cc1',
        contrast: '#FFFFFF',
    },
    text: {
        dark: '#404040',
        light: '#FFFFFF',
        darkMuted: '#757575',
        lightMuted: '#efefef',
        link: '#0a7cc1',
    },
    background: {
        main: '#f7f7f7',
        light: '#ffffff',
        dark: '#404040',
        overlay: 'rgba(117, 117, 117, .86)',
        accent: '#efefef',
        primary: {
            light: '#E5F3E9',
            medium: '#C2E1CA',
        },
        success: {
            light: '#E5F3E9',
            medium: '#C2E1CA',
        },
        warning: {
            light: '#FFEEC0',
            medium: '#FCE39E',
        },
        error: {
            light: '#FBEAEA',
            medium: '#F4C7C7',
        },
        info: {
            light: '#DCF0FF',
            medium: '#C4E0F0',
        },
        upgrade: {
            light: '#FFF9D1',
            medium: '#FFF3A4',
        },
        muted: {
            light: '#EFEFEF',
            medium: '#EFEFEF',
        },
    },
    border: {
        main: '#d0d0d0',
        active: '#404040',
        hover: '#757575',
        muted: '#EDEEEE',
    },
    data: {
        one: '#507CB6',
        two: '#008323',
        three: '#6BC8CD',
        four: '#F9BE00',
        five: '#7D5E90',
        six: '#DB4D5C',
        seven: '#768086',
        eight: '#D25F90',
        nine: '#A38364',
        ten: '#FF8B4F',
    },
};
var spacing = {
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 24,
    6: 32,
    7: 48,
    8: 64,
    9: 96,
    10: 128,
};
var motion = {
    curve: {
        enter: 'cubic-bezier(0, 0, 0, 1)',
        exit: 'cubic-bezier(1, 0, 1, 1)',
        ease: 'cubic-bezier(.2, 0, .1, 1)',
        easeReverse: 'cubic-bezier(.9, 0, .8, 1)',
        bounceStart: 'cubic-bezier(0, 0, .1, 1)',
        bounceEnd: 'cubic-bezier(.2, 0, 0, 1)',
    },
    fade: {
        speed: {
            slow: 300,
            normal: 200,
            fast: 100,
        },
    },
    slide: {
        speed: {
            slow: 450,
            normal: 350,
            fast: 250,
        },
        distance: {
            normal: 25,
            near: 5,
            far: 75,
        },
    },
};
getColor(palette, 'main', { colorType: 'border' });
var border = {
    main: [1, 'solid', getColor(palette, 'main', { colorType: 'border' })],
    hover: [1, 'solid', getColor(palette, 'hover', { colorType: 'border' })],
    active: [1, 'solid', getColor(palette, 'active', { colorType: 'border' })],
    muted: [1, 'solid', getColor(palette, 'muted', { colorType: 'border' })],
    dark: [1, 'solid', getColor(palette, 'dark', { colorType: 'background' })],
    light: [2, 'solid', getColor(palette, 'light', { colorType: 'background' })],
};
var radius = {
    zero: 0,
    small: 4,
    medium: 24,
    large: '50%',
};
var shadow = {
    none: 'none',
    sky: '0 2px 4px 0 rgba(0, 0, 0, 0.14)',
    space: '0 2px 8px 0 rgba(0, 0, 0, 0.14)',
};
var breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
};
var iconSize = {
    sm: 13,
    md: 16,
    lg: 24,
    xl: 32,
};
var elevation = {
    none: 0,
    sky: 999,
    space: 9999,
};
/**
 * Exported theme is the Momentive theme.
 * See our storybook for more info on the theme shape/breakdown
 * @see {@link [Storybook](http://storybook.jungle.tech/wrench/index.html?path=/story/intro-theme-breakdown--page)}
 */
var theme = {
    name: name,
    type: type,
    palette: palette,
    spacing: spacing,
    motion: motion,
    border: border,
    radius: radius,
    shadow: shadow,
    breakpoints: breakpoints,
    iconSize: iconSize,
    elevation: elevation,
};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var react = {exports: {}};

var react_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReact_production_min;

function requireReact_production_min () {
	if (hasRequiredReact_production_min) return react_production_min;
	hasRequiredReact_production_min = 1;
var l=requireObjectAssign(),n=60103,p=60106;react_production_min.Fragment=60107;react_production_min.StrictMode=60108;react_production_min.Profiler=60114;var q=60109,r=60110,t=60112;react_production_min.Suspense=60113;var u=60115,v=60116;
	if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");react_production_min.Fragment=w("react.fragment");react_production_min.StrictMode=w("react.strict_mode");react_production_min.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");react_production_min.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy");}var x="function"===typeof Symbol&&Symbol.iterator;
	function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return "function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var A={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A;}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState");};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};
	function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A;}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
	function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f;}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return {$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
	function K(a,b){return {$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return "object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return "$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0;}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
	0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d);}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
	function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b);},function(b){0===a._status&&(a._status=2,a._result=b);});}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
	react_production_min.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments);},c);},count:function(a){var b=0;P(a,function(){b++;});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};react_production_min.Component=C;react_production_min.PureComponent=E;react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
	react_production_min.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f]);}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g;}return {$$typeof:n,type:a.type,
	key:d,ref:k,props:e,_owner:h}};react_production_min.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};react_production_min.createElement=J;react_production_min.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};react_production_min.createRef=function(){return {current:null}};react_production_min.forwardRef=function(a){return {$$typeof:t,render:a}};react_production_min.isValidElement=L;
	react_production_min.lazy=function(a){return {$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};react_production_min.memo=function(a,b){return {$$typeof:u,type:a,compare:void 0===b?null:b}};react_production_min.useCallback=function(a,b){return S().useCallback(a,b)};react_production_min.useContext=function(a,b){return S().useContext(a,b)};react_production_min.useDebugValue=function(){};react_production_min.useEffect=function(a,b){return S().useEffect(a,b)};react_production_min.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
	react_production_min.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};react_production_min.useMemo=function(a,b){return S().useMemo(a,b)};react_production_min.useReducer=function(a,b,c){return S().useReducer(a,b,c)};react_production_min.useRef=function(a){return S().useRef(a)};react_production_min.useState=function(a){return S().useState(a)};react_production_min.version="17.0.2";
	return react_production_min;
}

var react_development = {};

/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReact_development;

function requireReact_development () {
	if (hasRequiredReact_development) return react_development;
	hasRequiredReact_development = 1;
	(function (exports) {

		if (false) {}
} (react_development));
	return react_development;
}

(function (module) {

	if (true) {
	  module.exports = requireReact_production_min();
	} else {}
} (react));

var React = /*@__PURE__*/getDefaultExportFromCjs(react.exports);

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_0__/* .createMemoStyles */ .Im)(function (_a) {
    var _b = _a.type, assets = _b.assets, fontFamily = _b.fontFamily, fontWeight = _b.fontWeight, fontSize = _b.fontSize;
    var fontPath = "".concat(assets.base).concat(assets.path);
    var fontFaces = FONT_WEIGHTS.map(function (name) {
        // we need this because the font file names are all National2-<Weight>.2.ext
        var upperCaseName = "".concat(name[0].toUpperCase()).concat(name.slice(1));
        var weight = fontWeight[name];
        return {
            fontFamily: assets.name,
            fontWeight: weight,
            fontDisplay: 'swap',
            src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff2) format('woff2')"),
            fallbacks: [
                {
                    src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff) format('woff')"),
                },
                {
                    src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".eot#iefix) format('embedded-opentype')"),
                },
            ],
        };
    });
    return {
        '@font-face': fontFaces,
        '@global': {
            "[class*='wrench'], [class*='wrench']::before, [class*='wrench']::after": {
                fontFamily: fontFamily.base,
                '-webkit-font-smoothing': 'antialiased',
                fontSize: fontSize.body,
                boxSizing: 'border-box',
                padding: 0,
                margin: 0,
                listStyle: 'none',
            },
        },
    };
});
var GlobalStyles = function () {
    useStyles();
    // return null here for linting rule requirements
    return React.createElement(React.Fragment, null, null);
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var blueprintBoxStyle = {
    border: '2px dashed #2dccd3',
    backgroundColor: 'rgba(45,204,211,.6)',
    padding: '16px',
    fontFamily: 'Roboto, Helvetica, Arial',
};
var blueprintBoxStyleXl = {
    border: '2px dashed #2dccd3',
    backgroundColor: 'rgba(45,204,211,.6)',
    padding: '40px 16px',
};
var innerBoxStyle = {
    border: '2px dashed #2dccd3',
    backgroundColor: 'rgba(45,204,211,.6)',
    fontFamily: 'Roboto, Helvetica, Arial',
};
var outerBoxStyle = __assign(__assign({}, innerBoxStyle), { marginBottom: '16px' });
var paddingBoxStyle = __assign(__assign({}, innerBoxStyle), { backgroundColor: '#ffffff', border: 'none' });
var flexBoxStyle = __assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8 });
var flexBoxStyleSm = __assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8, height: 40 });
var flexBoxStyleMd = __assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8, height: 80 });
var flexBoxStyleLg = __assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8, height: 120 });




/***/ }),

/***/ 8530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$n": function() { return /* reexport safe */ polished__WEBPACK_IMPORTED_MODULE_3__.$n; },
/* harmony export */   "EL": function() { return /* binding */ uniqueId; },
/* harmony export */   "FZ": function() { return /* binding */ defaultFonts; },
/* harmony export */   "Gf": function() { return /* binding */ getDisplayName; },
/* harmony export */   "Im": function() { return /* binding */ createMemoStyles; },
/* harmony export */   "Q6": function() { return /* binding */ safeRest; },
/* harmony export */   "Wy": function() { return /* reexport safe */ clsx__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "_j": function() { return /* reexport safe */ polished__WEBPACK_IMPORTED_MODULE_3__._j; },
/* harmony export */   "jB": function() { return /* binding */ removeUndefinedProperties; },
/* harmony export */   "js": function() { return /* binding */ createSpacingStyles; },
/* harmony export */   "jy": function() { return /* binding */ visuallyHidden; },
/* harmony export */   "rc": function() { return /* binding */ usePreviousState; },
/* harmony export */   "tW": function() { return /* binding */ KEYS; },
/* harmony export */   "yD": function() { return /* binding */ defaultBaseline; }
/* harmony export */ });
/* unused harmony exports clearfix, conditionGuard, deprecate, extractDisplayName, extractType, getContrastColor, getState, guardElement, handlePortal, isBrowser, isControlled, notEmpty, withNested, withSpacing */
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6010);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2307);
/* harmony import */ var lodash_isequal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isequal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_jss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(389);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8770);
/* harmony import */ var lodash_iselement__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4467);
/* harmony import */ var lodash_iselement__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_iselement__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3935);









var clearfix = {
    '&:after': {
        content: '',
        display: 'block',
        clear: 'both',
    },
};

var createMemoStyles = function (styles, options) {
    var useStyles = (0,react_jss__WEBPACK_IMPORTED_MODULE_6__/* .createUseStyles */ .QM)(styles, options);
    var useMemoStyles = function (data) {
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(data);
        if (!ref.current || !lodash_isequal__WEBPACK_IMPORTED_MODULE_1___default()(data, ref.current)) {
            ref.current = data;
        }
        return useStyles(ref.current);
    };
    return useMemoStyles;
};

/**
 * @description
 * This factory function creates a hook that will return the wrenchSpacing class to be used in the component
 * Simply import it and call at the component level to create the hook, then use the hook inside your component
 * Code example: https://code.corp.surveymonkey.com/wrench/wrench/blob/master/packages/box/Box
 */
function createSpacingStyles() {
    return createMemoStyles(function (_a) {
        var spacing = _a.spacing;
        return {
            wrenchSpacing: function (_a) {
                var _b, _c, _d, _e, _f, _g, _h, _j;
                var m = _a.m, mx = _a.mx, my = _a.my, mt = _a.mt, mb = _a.mb, ml = _a.ml, mr = _a.mr, p = _a.p, px = _a.px, py = _a.py, pt = _a.pt, pb = _a.pb, pl = _a.pl, pr = _a.pr;
                var margin = {
                    t: (_b = m !== null && m !== void 0 ? m : my) !== null && _b !== void 0 ? _b : mt,
                    b: (_c = m !== null && m !== void 0 ? m : my) !== null && _c !== void 0 ? _c : mb,
                    l: (_d = m !== null && m !== void 0 ? m : mx) !== null && _d !== void 0 ? _d : ml,
                    r: (_e = m !== null && m !== void 0 ? m : mx) !== null && _e !== void 0 ? _e : mr,
                };
                var padding = {
                    t: (_f = p !== null && p !== void 0 ? p : py) !== null && _f !== void 0 ? _f : pt,
                    b: (_g = p !== null && p !== void 0 ? p : py) !== null && _g !== void 0 ? _g : pb,
                    l: (_h = p !== null && p !== void 0 ? p : px) !== null && _h !== void 0 ? _h : pl,
                    r: (_j = p !== null && p !== void 0 ? p : px) !== null && _j !== void 0 ? _j : pr,
                };
                return {
                    marginTop: margin.t && spacing[margin.t],
                    marginRight: margin.r && spacing[margin.r],
                    marginBottom: margin.b && spacing[margin.b],
                    marginLeft: margin.l && spacing[margin.l],
                    paddingTop: padding.t && spacing[padding.t],
                    paddingRight: padding.r && spacing[padding.r],
                    paddingBottom: padding.b && spacing[padding.b],
                    paddingLeft: padding.l && spacing[padding.l],
                };
            },
        };
    });
}

/* eslint-disable no-bitwise  */
/* Given a hex or rgb color value, checks if the contrasting color should be light or dark */
var getContrastColor = function (color) {
    var _a;
    var r = 0;
    var g = 0;
    var b = 0;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        var colorValues = (_a = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)) !== null && _a !== void 0 ? _a : ['', '', ''];
        r = parseInt(colorValues[1], 10);
        g = parseInt(colorValues[2], 10);
        b = parseInt(colorValues[3], 10);
    }
    else {
        var colorReg = color.length < 5 ? /./g : '';
        var colorValues = +("0x".concat(color.slice(1).replace(colorReg, '$&$&')));
        r = colorValues >> 16;
        g = colorValues >> 8 & 255;
        b = colorValues & 255;
    }
    // HSP equation from http://alienryderflex.com/hsp.html
    var hsp = Math.sqrt(0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b));
    if (hsp > 160) {
        return 'dark';
    }
    return 'light';
};

// https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
var defaultBaseline = {
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    listStyle: 'none',
};

var defaultFonts = function (_a) {
    var type = _a.type;
    return ({
        fontFamily: type.fontFamily.base,
        fontSize: type.fontSize.body,
        '-webkit-font-smoothing': 'antialiased',
    });
};

function deprecate(props, key, value, componentName) {
    if (props[key] === value) {
        // eslint-disable-next-line no-console
        console.warn(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        "[DEPRECATED]: The ".concat(componentName, " prop ").concat(String(key), " with value \"").concat(value, "\" is deprecated and will be removed in the future"));
    }
}

function extractType(node) {
    if ((0,react__WEBPACK_IMPORTED_MODULE_2__.isValidElement)(node))
        return node.type;
    return '';
}
function extractDisplayName(type) {
    var _a, _b;
    return (_b = (_a = type.displayName) !== null && _a !== void 0 ? _a : type.name) !== null && _b !== void 0 ? _b : 'Unknown';
}
var getDisplayName = function (child) {
    var type = extractType(child);
    if (typeof type === 'function' || typeof type === 'object') {
        return extractDisplayName(type);
    }
    return type;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var getState = function (state, newState) { return (__assign(__assign({}, state), newState)); };

var isControlled = function (value) {
    return !(value === undefined || value === null);
};

var isBrowser = typeof window !== 'undefined';

var guardElement = function (e) {
    return isElement(e);
};

function removeUndefinedProperties(obj) {
    var result = {};
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value !== undefined) {
            result[key] = value;
        }
    });
    return result;
}

var safeRest = (function (_a) {
    _a.className; _a.style; var props = __rest(_a, ["className", "style"]);
    return props;
});

var conditionGuard = function (what, conditional) {
    return conditional;
};
var notEmpty = function (value) {
    return value !== null && value !== undefined;
};
var handlePortal = function (content, renderTo) {
    if (!renderTo)
        return content;
    if (conditionGuard(renderTo, isElement(renderTo)))
        return createPortal(content, renderTo);
    if (renderTo.current)
        return createPortal(content, renderTo.current);
    return content;
};

// Taken from lodash: https://github.com/lodash/lodash/blob/master/uniqueId.js
var idCounter = 0;
var uniqueId = function (prefix) {
    var id = ++idCounter; // eslint-disable-line no-plusplus
    if (prefix == null) {
        throw new Error('The value is missing in uniqueId() parameter');
    }
    return "".concat(prefix).concat(id);
};

// send in the state value as a parameter and get the previous value of that state
var usePreviousState = function (value) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
        ref.current = value;
    });
    return ref.current;
};

// https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
var visuallyHidden = {
    border: '0px',
    clip: 'rect(1px, 1px, 1px, 1px)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
    whiteSpace: 'nowrap',
    wordWrap: 'normal',
};

var withNested = function (component, args) {
    return Object.assign(component, args);
};

function withSpacing(Component) {
    /**
     * JSS injects css styles in the order of `createUseStyles` usage
     * Hence, useStyles needs to be instantiated every single time while
     * using this HOC because it should be the last `createUseStyles` usage
     * for a component. With this mechanism, `withSpacing` overwrites the component
     * spacing. Not ideal for a design system, but we are waiting on the
     * below ticket.
     *
     * Note: https://jira.surveymonkey.com/browse/WRENCH-1107
     *
     * If the decision is have `withStyles` NOT overwrite the component spacing,
     * just move this declaration outside of this component. `withSpacing` will then
     * add to the styles and not overwrite them.
     */
    var useStyles = createMemoStyles(function (_a) {
        var spacing = _a.spacing;
        return ({
            wrenchSpacing: function (_a) {
                var margin = _a.margin, padding = _a.padding;
                return ({
                    marginTop: margin.t && spacing[margin.t],
                    marginRight: margin.r && spacing[margin.r],
                    marginBottom: margin.b && spacing[margin.b],
                    marginLeft: margin.l && spacing[margin.l],
                    paddingTop: padding.t && spacing[padding.t],
                    paddingRight: padding.r && spacing[padding.r],
                    paddingBottom: padding.b && spacing[padding.b],
                    paddingLeft: padding.l && spacing[padding.l],
                });
            },
        });
    });
    var WithSpacing = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var m = _a.m, mx = _a.mx, my = _a.my, mt = _a.mt, mb = _a.mb, ml = _a.ml, mr = _a.mr, p = _a.p, px = _a.px, py = _a.py, pt = _a.pt, pb = _a.pb, pl = _a.pl, pr = _a.pr, className = _a.className, rest = __rest(_a, ["m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr", "className"]);
        var margin = {
            t: (_b = m !== null && m !== void 0 ? m : my) !== null && _b !== void 0 ? _b : mt,
            b: (_c = m !== null && m !== void 0 ? m : my) !== null && _c !== void 0 ? _c : mb,
            l: (_d = m !== null && m !== void 0 ? m : mx) !== null && _d !== void 0 ? _d : ml,
            r: (_e = m !== null && m !== void 0 ? m : mx) !== null && _e !== void 0 ? _e : mr,
        };
        var padding = {
            t: (_f = p !== null && p !== void 0 ? p : py) !== null && _f !== void 0 ? _f : pt,
            b: (_g = p !== null && p !== void 0 ? p : py) !== null && _g !== void 0 ? _g : pb,
            l: (_h = p !== null && p !== void 0 ? p : px) !== null && _h !== void 0 ? _h : pl,
            r: (_j = p !== null && p !== void 0 ? p : px) !== null && _j !== void 0 ? _j : pr,
        };
        var classes = useStyles({
            margin: margin,
            padding: padding,
        });
        var Element = Component;
        return (React.createElement(Element, __assign({ spacingClass: classes.wrenchSpacing, className: className }, safeRest(rest))));
    };
    WithSpacing.displayName = "WithSpacing(".concat(getDisplayName(Component), ")");
    WithSpacing.getOriginalComponent = function () { return Component; };
    WithSpacing.defaultProps = {
        m: undefined,
        mx: undefined,
        my: undefined,
        mt: undefined,
        mb: undefined,
        ml: undefined,
        mr: undefined,
        p: undefined,
        px: undefined,
        py: undefined,
        pt: undefined,
        pb: undefined,
        pl: undefined,
        pr: undefined,
        className: undefined,
    };
    return WithSpacing;
}

var KEYS = {
    DOWN: 'ArrowDown',
    END: 'End',
    ESC: 'Escape',
    HOME: 'Home',
    LEFT: 'ArrowLeft',
    PAGE_DOWN: 'PageDown',
    PAGE_UP: 'PageUp',
    RIGHT: 'ArrowRight',
    UP: 'ArrowUp',
    ENTER: 'Enter',
    SPACE: ' ',
    BACKSPACE: 'Backspace',
    TAB: 'Tab',
};




/***/ }),

/***/ 7277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var _wds_icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9224);
/* harmony import */ var _wds_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(295);
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5420);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .createMemoStyles */ .Im)(function (theme) {
    var palette = theme.palette, type = theme.type, spacing = theme.spacing, motion = theme.motion, radius = theme.radius, shadow = theme.shadow;
    var checkbox = {
        bgColorOn: palette.primary.main,
        iconColorOn: palette.primary.contrast,
    };
    var bounceFrames = {
        '@keyframes bounce': {
            '0%': {
                opacity: 0,
                transform: 'scale(0.6)',
                animationTimingFunction: 'cubic-bezier(0, 0, .1, 1)',
            },
            '10%': {
                opacity: 1,
            },
            '33%': {
                opacity: 1,
                transform: 'scale(1.4)',
                animationTimingFunction: 'cubic-bezier(.2, 0, 0, 1)',
            },
            '100%': {
                opacity: 1,
                transform: 'scale(1)',
            },
        },
    };
    var scaleDownFrames = {
        '@keyframes scaleDown': {
            from: {
                opacity: 1,
                transform: 'scale(1)',
                animationTimingFunction: 'cubic-bezier(1, 0, 1, 1)',
            },
            '75%': {
                opacity: 1,
            },
            '100%': {
                opacity: 0,
                transform: 'scale(0.4)',
            },
        },
    };
    return __assign(__assign(__assign({}, bounceFrames), scaleDownFrames), { wrenchCheckbox: function () { return (__assign(__assign(__assign({}, _wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .defaultBaseline */ .yD), (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .defaultFonts */ .FZ)(theme)), { position: 'relative', display: 'inline-flex', minHeight: spacing[5], minWidth: spacing[5], lineHeight: "".concat(spacing[5], "px") })); }, wrenchCheckboxFaux: function () { return (__assign(__assign(__assign({}, _wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .defaultBaseline */ .yD), (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .defaultFonts */ .FZ)(theme)), { content: '""', display: 'inline-block', height: spacing[5], width: spacing[5], flexGrow: 0, flexShrink: 0, fontSize: type.fontSize.body, border: "1px solid ".concat(palette.border.main), background: palette.background.light, borderRadius: radius.small, transition: "all 50ms ".concat(motion.curve.exit, " 100ms"), verticalAlign: 'top', textAlign: 'left', '&:empty::after': {
                content: '3',
                fontFamily: type.fontFamily.icon,
                color: checkbox.iconColorOn,
                lineHeight: 1,
            }, '> svg[class^="wrenchIcons"], &:empty::after': {
                position: 'absolute',
                top: spacing[1],
                left: spacing[1],
                opacity: 0,
                textAlign: 'center',
                fill: checkbox.iconColorOn,
                animation: '$scaleDown 150ms forwards',
            } })); }, wrenchCheckboxLabel: function () { return ({
            padding: [0, 0, 0, spacing[4]],
            whiteSpace: 'normal',
        }); }, wrenchCheckboxIndeterminate: function () { return ({
            '& + $wrenchCheckboxFaux': {
                borderColor: checkbox.bgColorOn,
                background: checkbox.bgColorOn,
                transform: 'scale(1)',
                transition: "transform 200ms ".concat(motion.curve.bounceEnd),
            },
            '& + $wrenchCheckboxFaux > svg[class^="wrenchIcons"]': _wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .visuallyHidden */ .jy,
            '& + $wrenchCheckboxFaux:after': {
                position: 'absolute',
                top: '10px',
                left: '5px',
                display: 'block',
                content: '""',
                background: palette.background.light,
                width: spacing[3],
                height: '2px',
            },
        }); }, wrenchCheckboxNative: function () {
            return __assign(__assign(__assign({}, _wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .defaultBaseline */ .yD), (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .defaultFonts */ .FZ)(theme)), { position: 'absolute', cursor: 'inherit', opacity: 0, width: spacing[5], height: spacing[5], zIndex: 1, left: 0, '&:focus:checked + $wrenchCheckboxFaux': {
                    borderColor: '#fff !important',
                    boxShadow: "0 0 0 1px ".concat(palette.primary.main, " !important"),
                }, '&:focus + $wrenchCheckboxFaux, &:hover + $wrenchCheckboxFaux': {
                    borderColor: palette.border.hover,
                    boxShadow: shadow.sky,
                    transform: 'scale(1.1)',
                    transition: [
                        "transform 200ms ".concat(motion.curve.ease),
                        'border-color 75ms linear 50ms',
                        'box-shadow 75ms linear 50ms',
                    ],
                }, '&:active + $wrenchCheckboxFaux': {
                    transform: 'scale(0.7)',
                    transition: "transform 100ms ".concat(motion.curve.bounceStart),
                }, '&:checked + $wrenchCheckboxFaux': {
                    borderColor: checkbox.bgColorOn,
                    background: checkbox.bgColorOn,
                    transform: 'scale(1)',
                    transition: "transform 200ms ".concat(motion.curve.bounceEnd),
                }, '&:checked + $wrenchCheckboxFaux > svg[class^="wrenchIcons"]': {
                    animation: "$bounce 200ms forwards",
                }, '&:checked + $wrenchCheckboxFaux &:empty::after': {
                    animation: "$bounce 200ms forwards",
                }, '&:disabled + $wrenchCheckboxFaux, &:disabled ~ $wrenchCheckboxLabel': {
                    opacity: '0.5',
                    transform: 'scale(1)',
                } });
        } });
});

var Checkbox = function (_a) {
    var ariaLabel = _a.ariaLabel, checked = _a.checked, _b = _a.defaultChecked, defaultChecked = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, id = _a.id, _d = _a.indeterminate, indeterminate = _d === void 0 ? false : _d, innerRef = _a.innerRef, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, rest = __rest(_a, ["ariaLabel", "checked", "defaultChecked", "disabled", "id", "indeterminate", "innerRef", "label", "name", "onBlur", "onChange"]);
    var _e = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isChecked = _e[0], setChecked = _e[1];
    var _f = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isFocused = _f[0], setFocused = _f[1];
    var _g = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(!!indeterminate), isIndeterminate = _g[0], setIndeterminate = _g[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
        setIndeterminate(indeterminate);
    }, [indeterminate]);
    /**
     * Set the checked state of the checkbox
     * If checked value is passed, it takes precendent over defaultChecked to become
     * controlled input.  If no value is passed, it uses the defaultChecked value
     */
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
        setChecked(checked !== null && checked !== void 0 ? checked : defaultChecked);
    }, [checked, defaultChecked]);
    var inputID = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function () { return id !== null && id !== void 0 ? id : (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .uniqueId */ .EL)('checkbox'); }, [id]);
    var _h = useStyles(), wrenchCheckboxNative = _h.wrenchCheckboxNative, wrenchCheckboxIndeterminate = _h.wrenchCheckboxIndeterminate, wrenchCheckbox = _h.wrenchCheckbox, wrenchCheckboxLabel = _h.wrenchCheckboxLabel, wrenchCheckboxFaux = _h.wrenchCheckboxFaux;
    var nativeClasses = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .clsx */ .Wy)(wrenchCheckboxNative, (isIndeterminate && wrenchCheckboxIndeterminate) || {});
    var handleBlur = function (e) {
        setFocused(!isFocused);
        if (onBlur) {
            onBlur(e);
        }
    };
    var handleFocus = function () {
        setFocused(!isFocused);
    };
    var handleChange = function (e) {
        // if checked is not pass in, manage state internally
        if (typeof checked !== 'boolean') {
            setChecked(!isChecked);
        }
        if (onChange) {
            onChange(e);
        }
        e.persist();
    };
    return (react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", { className: wrenchCheckbox },
        react__WEBPACK_IMPORTED_MODULE_3__.createElement("input", __assign({ "aria-label": ariaLabel, className: nativeClasses, "aria-checked": isChecked, checked: isChecked, disabled: disabled, id: inputID, name: name, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, tabIndex: disabled ? -1 : 0, type: "checkbox", ref: innerRef }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_2__/* .safeRest */ .Q6)(rest))),
        react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", { className: wrenchCheckboxFaux, "aria-hidden": "true" },
            react__WEBPACK_IMPORTED_MODULE_3__.createElement(_wds_icons__WEBPACK_IMPORTED_MODULE_0__/* .IconCheck */ .NOm, { color: "light", "aria-hidden": "true", title: "Check" })),
        label && (react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", { className: wrenchCheckboxLabel },
            react__WEBPACK_IMPORTED_MODULE_3__.createElement("label", { htmlFor: inputID },
                react__WEBPACK_IMPORTED_MODULE_3__.createElement(_wds_typography__WEBPACK_IMPORTED_MODULE_1__/* .Typography */ .ZT, { variant: "body", component: "span" }, label))))));
};




/***/ }),

/***/ 8597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ GridWithSpacing; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5420);



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var GridContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    noGutters: false,
});

var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (theme) {
    var _a;
    var spacing = theme.spacing, breakpoints = theme.breakpoints;
    var grid = {
        gutter: {
            xs: spacing[4],
            sm: spacing[5],
            md: spacing[5],
            lg: spacing[5],
            xl: spacing[5],
        },
        columns: 12,
    };
    var width = function (sizeValue) {
        return sizeValue ? "".concat(100 * (sizeValue / grid.columns), "%") : '0%';
    };
    return {
        wrenchGridItem: (_a = {
                boxSizing: 'border-box',
                flexGrow: 1,
                flexBasis: 0,
                maxWidth: '100%'
            },
            _a["@media (min-width: ".concat(breakpoints.xs, "px)")] = {
                flex: function (_a) {
                    var xs = _a.xs;
                    return xs && "0 0 ".concat(width(xs));
                },
                maxWidth: function (_a) {
                    var xs = _a.xs;
                    return xs && width(xs);
                },
                order: function (_a) {
                    var xsOrder = _a.xsOrder;
                    return xsOrder;
                },
                paddingLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.xs / 2);
                },
                paddingRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.xs / 2);
                },
            },
            _a["@media (min-width: ".concat(breakpoints.sm, "px)")] = {
                flex: function (_a) {
                    var sm = _a.sm;
                    return sm && "0 0 ".concat(width(sm));
                },
                maxWidth: function (_a) {
                    var sm = _a.sm;
                    return sm && width(sm);
                },
                order: function (_a) {
                    var smOrder = _a.smOrder;
                    return smOrder;
                },
                paddingLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.sm / 2);
                },
                paddingRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.sm / 2);
                },
            },
            _a["@media (min-width: ".concat(breakpoints.md, "px)")] = {
                flex: function (_a) {
                    var md = _a.md;
                    return md && "0 0 ".concat(width(md));
                },
                maxWidth: function (_a) {
                    var md = _a.md;
                    return md && width(md);
                },
                order: function (_a) {
                    var mdOrder = _a.mdOrder;
                    return mdOrder;
                },
                paddingLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.md / 2);
                },
                paddingRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.md / 2);
                },
            },
            _a["@media (min-width: ".concat(breakpoints.lg, "px)")] = {
                flex: function (_a) {
                    var lg = _a.lg;
                    return lg && "0 0 ".concat(width(lg));
                },
                maxWidth: function (_a) {
                    var lg = _a.lg;
                    return lg && width(lg);
                },
                order: function (_a) {
                    var lgOrder = _a.lgOrder;
                    return lgOrder;
                },
                paddingLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.lg / 2);
                },
                paddingRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.lg / 2);
                },
            },
            _a["@media (min-width: ".concat(breakpoints.xl, "px)")] = {
                flex: function (_a) {
                    var xl = _a.xl;
                    return xl && "0 0 ".concat(width(xl));
                },
                maxWidth: function (_a) {
                    var xl = _a.xl;
                    return xl && width(xl);
                },
                order: function (_a) {
                    var xlOrder = _a.xlOrder;
                    return xlOrder;
                },
                paddingLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.xl / 2);
                },
                paddingRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return (noGutters ? 0 : grid.gutter.xl / 2);
                },
            },
            _a),
    };
});

var GridItem = function (_a) {
    var children = _a.children, _b = _a.xs, xs = _b === void 0 ? undefined : _b, _c = _a.sm, sm = _c === void 0 ? undefined : _c, _d = _a.md, md = _d === void 0 ? undefined : _d, _e = _a.lg, lg = _e === void 0 ? undefined : _e, _f = _a.xl, xl = _f === void 0 ? undefined : _f, _g = _a.xsOrder, xsOrder = _g === void 0 ? undefined : _g, _h = _a.smOrder, smOrder = _h === void 0 ? undefined : _h, _j = _a.mdOrder, mdOrder = _j === void 0 ? undefined : _j, _k = _a.lgOrder, lgOrder = _k === void 0 ? undefined : _k, _l = _a.xlOrder, xlOrder = _l === void 0 ? undefined : _l, rest = __rest(_a, ["children", "xs", "sm", "md", "lg", "xl", "xsOrder", "smOrder", "mdOrder", "lgOrder", "xlOrder"]);
    var noGutters = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GridContext).noGutters;
    var wrenchGridItem = useStyles({
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
        noGutters: noGutters,
        xsOrder: xsOrder,
        smOrder: smOrder,
        mdOrder: mdOrder,
        lgOrder: lgOrder,
        xlOrder: xlOrder,
    }).wrenchGridItem;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ className: wrenchGridItem }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .safeRest */ .Q6)(rest)), children));
};

var useStylesGrid = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (theme) {
    var _a, _b;
    var breakpoints = theme.breakpoints, spacing = theme.spacing;
    var grid = {
        bleed: {
            xs: spacing[4],
            sm: spacing[6],
            md: spacing[6],
            lg: spacing[6],
            xl: spacing[6],
        },
        gutter: {
            xs: spacing[4],
            sm: spacing[5],
            md: spacing[5],
            lg: spacing[5],
            xl: spacing[5],
        },
        maxWidth: __assign(__assign({}, breakpoints), { xl: 1400 }),
        columns: 12,
    };
    return {
        wrenchGridContainer: __assign(__assign(__assign({}, _wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .defaultBaseline */ .yD), (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .defaultFonts */ .FZ)(theme)), (_a = { display: 'flex', flexDirection: 'column', width: '100%', marginRight: 'auto', marginLeft: 'auto' }, _a["@media (min-width: ".concat(breakpoints.xs, "px)")] = {
            paddingLeft: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.xs;
            },
            paddingRight: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.xs;
            },
        }, _a["@media (min-width: ".concat(breakpoints.sm, "px)")] = {
            maxWidth: function (_a) {
                var fluid = _a.fluid;
                return !fluid && grid.maxWidth.sm;
            },
            paddingLeft: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.sm;
            },
            paddingRight: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.sm;
            },
        }, _a["@media (min-width: ".concat(breakpoints.md, "px)")] = {
            maxWidth: function (_a) {
                var fluid = _a.fluid;
                return !fluid && grid.maxWidth.md;
            },
            paddingLeft: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.md;
            },
            paddingRight: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.md;
            },
        }, _a["@media (min-width: ".concat(breakpoints.lg, "px)")] = {
            maxWidth: function (_a) {
                var fluid = _a.fluid;
                return !fluid && grid.maxWidth.lg;
            },
            paddingLeft: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.lg;
            },
            paddingRight: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.lg;
            },
        }, _a["@media (min-width: ".concat(breakpoints.xl, "px)")] = {
            maxWidth: function (_a) {
                var fluid = _a.fluid;
                return !fluid && grid.maxWidth.xl;
            },
            paddingLeft: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.xl;
            },
            paddingRight: function (_a) {
                var noBleeds = _a.noBleeds;
                return !noBleeds && grid.bleed.xl;
            },
        }, _a)),
        wrenchGrid: (_b = {
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap'
            },
            _b["@media (min-width: ".concat(breakpoints.xs, "px)")] = {
                marginLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.xs / -2;
                },
                marginRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.xs / -2;
                },
            },
            _b["@media (min-width: ".concat(breakpoints.sm, "px)")] = {
                marginLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.sm / -2;
                },
                marginRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.sm / -2;
                },
            },
            _b["@media (min-width: ".concat(breakpoints.md, "px)")] = {
                marginLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.md / -2;
                },
                marginRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.md / -2;
                },
            },
            _b["@media (min-width: ".concat(breakpoints.lg, "px)")] = {
                marginleft: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.lg / -2;
                },
                marginRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.lg / -2;
                },
            },
            _b["@media (min-width: ".concat(breakpoints.xl, "px)")] = {
                marginLeft: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.lg / -2;
                },
                marginRight: function (_a) {
                    var noGutters = _a.noGutters;
                    return noGutters ? 0 : grid.gutter.lg / -2;
                },
            },
            _b),
    };
});

var Grid = function (_a) {
    var children = _a.children, _b = _a.noGutters, noGutters = _b === void 0 ? false : _b, _c = _a.noBleeds, noBleeds = _c === void 0 ? false : _c, _d = _a.fluid, fluid = _d === void 0 ? false : _d, _e = _a.spacingClass, spacingClass = _e === void 0 ? undefined : _e, rest = __rest(_a, ["children", "noGutters", "noBleeds", "fluid", "spacingClass"]);
    var _f = useStylesGrid({
        noGutters: noGutters,
        noBleeds: noBleeds,
        fluid: fluid,
    }), wrenchGrid = _f.wrenchGrid, wrenchGridContainer = _f.wrenchGridContainer;
    var wrenchGridWrapper = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .Wy)(wrenchGridContainer, spacingClass);
    var contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () { return ({
        noGutters: noGutters,
    }); }, [noGutters]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(GridContext.Provider, { value: contextValue },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ className: wrenchGridWrapper }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .safeRest */ .Q6)(rest)),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchGrid }, children))));
};
var GridWithSpacing = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .withNested */ .S4)((0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .withSpacing */ .ii)(Grid), { Item: GridItem });




/***/ }),

/***/ 7634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ./node_modules/@wds/label/dist/index.es.js
var index_es = __webpack_require__(2129);
// EXTERNAL MODULE: ./node_modules/@wds/utils/dist/index.es.js
var dist_index_es = __webpack_require__(5420);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@wds/icons/dist/index.es.js
var icons_dist_index_es = __webpack_require__(9224);
;// CONCATENATED MODULE: ./node_modules/@wds/input-message/dist/index.es.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles$1 = (0,dist_index_es/* createMemoStyles */.Im)(function (_a) {
    var spacing = _a.spacing, border = _a.border;
    return ({
        wrenchBox: function (_a) {
            var _b, _c;
            var display = _a.display, flexProperties = _a.flexProperties, gridProperties = _a.gridProperties, borderColor = _a.borderColor;
            var gap = gridProperties.gap, gridStyleProperties = __rest(gridProperties, ["gap"]);
            var _d = flexProperties.flexItemGrow, flexItemGrow = _d === void 0 ? undefined : _d, _e = flexProperties.flexWrap, flexWrap = _e === void 0 ? undefined : _e, flexStyleProperties = __rest(flexProperties, ["flexItemGrow", "flexWrap"]);
            return (0,dist_index_es/* removeUndefinedProperties */.jB)(__assign$2(__assign$2(__assign$2({}, gridStyleProperties), flexStyleProperties), { justifyContent: (_b = gridStyleProperties.justifyContent) !== null && _b !== void 0 ? _b : flexStyleProperties.justifyContent, alignItems: (_c = gridStyleProperties.alignItems) !== null && _c !== void 0 ? _c : flexStyleProperties.alignItems, flexGrow: flexItemGrow && 1, flexWrap: flexWrap && 'wrap', display: display !== null && display !== void 0 ? display : 'block', gap: gap ? spacing[gap] : null, border: borderColor && border[borderColor] }));
        },
    });
});

/**
 * [IMPORTANT]
 * We have to call createSpacingStyles at the component level
 * Otherwise, the styles will be overridden by the global styles
 * This happens because JSS loads the styles in sequence
 */
var useSpacingStyles = (0,dist_index_es/* createSpacingStyles */.js)();
var Box = function (props) {
    var containerRef = props.containerRef, borderColor = props.borderColor, className = props.className, children = props.children, _a = props.element, element = _a === void 0 ? 'div' : _a, display = props.display, alignItems = props.alignItems, justifyContent = props.justifyContent, flexDirection = props.flexDirection, flexItemGrow = props.flexItemGrow, flexJustify = props.flexJustify, flexAlign = props.flexAlign, flexWrap = props.flexWrap, gridTemplateColumns = props.gridTemplateColumns, gridTemplateRows = props.gridTemplateRows, gridAutoFlow = props.gridAutoFlow, placeItems = props.placeItems, gap = props.gap, m = props.m, mx = props.mx, my = props.my, mt = props.mt, mb = props.mb, ml = props.ml, mr = props.mr, p = props.p, px = props.px, py = props.py, pt = props.pt, pb = props.pb, pl = props.pl, pr = props.pr, rest = __rest(props, ["containerRef", "borderColor", "className", "children", "element", "display", "alignItems", "justifyContent", "flexDirection", "flexItemGrow", "flexJustify", "flexAlign", "flexWrap", "gridTemplateColumns", "gridTemplateRows", "gridAutoFlow", "placeItems", "gap", "m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr"]);
    var flexProperties = {
        alignItems: alignItems !== null && alignItems !== void 0 ? alignItems : flexAlign,
        justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : flexJustify,
        flexDirection: flexDirection,
        flexItemGrow: flexItemGrow,
        flexWrap: flexWrap,
    };
    var gridProperties = {
        justifyContent: justifyContent,
        alignItems: alignItems,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows,
        gridAutoFlow: gridAutoFlow,
        placeItems: placeItems,
        gap: gap,
    };
    var wrenchSpacing = useSpacingStyles({
        m: m,
        mx: mx,
        my: my,
        mt: mt,
        mb: mb,
        ml: ml,
        mr: mr,
        p: p,
        px: px,
        py: py,
        pt: pt,
        pb: pb,
        pl: pl,
        pr: pr,
    }).wrenchSpacing;
    var wrenchBox = useStyles$1({
        flexProperties: flexProperties,
        gridProperties: gridProperties,
        display: display,
        borderColor: borderColor,
    }).wrenchBox;
    // TODO: remove this type coercion when upgrading to React v18
    var Element = element;
    var classNames = (0,dist_index_es/* clsx */.Wy)(className, wrenchBox, wrenchSpacing);
    return (react.createElement(Element, __assign$2({ className: classNames, ref: containerRef }, rest), children));
};
Box.defaultProps = {
    element: 'div',
    containerRef: undefined,
    display: undefined,
    children: null,
    className: undefined,
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

/// ///////////////////////// PALETTE START ////////////////////////////
var SEMANTIC_COLORS = [
    'primary',
    'secondary',
    'success',
    'warning',
    'upgrade',
    'error',
    'info',
    'muted',
];
var TYPE_COLORS = [
    'dark',
    'light',
    'darkMuted',
    'lightMuted',
    'link',
];
var BACKGROUND_COLORS = [
    'main',
    'light',
    'dark',
    'overlay',
    'accent',
];
var BACKGROUND_SEMANTIC_COLORS = [
    'primary',
    'success',
    'warning',
    'error',
    'info',
    'upgrade',
    'muted'
];
var BORDER_COLORS = ['main', 'active', 'hover', 'muted'];
var DATA_COLORS = [
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
];
var FONT_WEIGHTS = ['light', 'regular', 'medium'];
/// ///////////////////////// DATA VIS ////////////////////////////
var dataTransform = function (arr) {
    return Object.freeze(arr.map(function (x) { return "data-".concat(x); }));
};
var DATA_VIS_COLORS = dataTransform(DATA_COLORS);
var getDataColor = function (s) {
    return s.split('-')[1];
};
/// ///////////////////////// HELPERS ////////////////////////////
var readOnlyIncludes = function (arr, el) {
    return arr.includes(el);
};
/// ///////////////////////// TYPE GUARDS ////////////////////////////
var isColorShape = function (c) {
    return typeof c === 'object' && 'main' in c;
};
var isSemanticColor = function (c) {
    return readOnlyIncludes(SEMANTIC_COLORS, c);
};
var isLinkColor = function (c) {
    return c === 'link';
};
var isTypeColor = function (c) {
    return readOnlyIncludes(TYPE_COLORS, c);
};
var isBackgroundColor = function (c) {
    return readOnlyIncludes(BACKGROUND_COLORS, c);
};
var isBackgroundSemanticColor = function (c) {
    return readOnlyIncludes(BACKGROUND_SEMANTIC_COLORS, c);
};
var isBorderColor = function (c) {
    return readOnlyIncludes(BORDER_COLORS, c);
};
var isDataColor = function (c) {
    return readOnlyIncludes(DATA_COLORS, c);
};
var isDataVisColor = function (c) {
    return readOnlyIncludes(DATA_VIS_COLORS, c);
};
var getColor = function (palette, color, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.semanticKey, semanticKey = _c === void 0 ? 'main' : _c, _d = _b.semanticBackgroundKey, semanticBackgroundKey = _d === void 0 ? 'light' : _d, _e = _b.colorType, colorType = _e === void 0 ? 'semantic' : _e, fallback = _b.fallback;
    var c = fallback !== null && fallback !== void 0 ? fallback : 'currentcolor';
    if (!color)
        return c;
    var cType = colorType;
    // if passed a portion of the Pallette that is the semantic color use that.
    if (isColorShape(color))
        c = color[semanticKey];
    else {
        // Check Semantic
        if (cType === 'semantic') {
            if (isSemanticColor(color))
                c = palette[color][semanticKey];
            else
                cType = 'link';
        }
        // Check type and get Color
        if (cType === 'link') {
            if (isLinkColor(color))
                c = palette[color][semanticKey];
            else
                cType = 'text';
        }
        if (cType === 'text') {
            if (isTypeColor(color))
                c = palette[cType][color];
            else
                cType = 'background';
        }
        if (cType === 'background') {
            if (isBackgroundColor(color))
                c = palette[cType][color];
            if (isBackgroundSemanticColor(color))
                c = palette[cType][color][semanticBackgroundKey];
            else
                cType = 'border';
        }
        if (cType === 'border') {
            if (isBorderColor(color))
                c = palette[cType][color];
            else
                cType = 'data';
        }
        if (cType === 'data') {
            if (isDataVisColor(color))
                c = palette[cType][getDataColor(color)];
            if (isDataColor(color))
                c = palette[cType][color];
        }
    }
    return c;
};
 false
    ? 0
    : 'cdn.smassets.net';
var palette$1 = {
    transparent: {
        clear: 'transparent',
        dark: 'rgba(51,62,72,0.2)',
        light: 'rgba(255, 255, 255, 0.2)',
    },
    primary: {
        main: '#00BF6F',
        contrast: '#FFFFFF',
    },
    secondary: {
        main: '#6B787F',
        contrast: '#FFFFFF',
    },
    success: {
        main: '#00BF6F',
        contrast: '#FFFFFF',
    },
    warning: {
        main: '#F05B24',
        contrast: '#FFFFFF',
    },
    error: {
        main: '#F05B24',
        contrast: '#FFFFFF',
    },
    info: {
        main: '#2DCCD3',
        contrast: '#333E48',
    },
    upgrade: {
        main: '#F9BE00',
        contrast: '#333E48',
    },
    muted: {
        main: '#D0D2D3',
        contrast: '#333E48',
    },
    link: {
        main: '#007FAA',
        contrast: '#FFFFFF',
    },
    text: {
        dark: '#333E48',
        light: '#FFFFFF',
        darkMuted: '#6B787F',
        lightMuted: '#D0D2D3',
        link: '#007FAA',
    },
    background: {
        main: '#F7F8FA',
        light: '#FFFFFF',
        dark: '#333E48',
        overlay: 'rgba(107, 120, 127, .86)',
        accent: '#EDEEEE',
        primary: {
            light: '#E5F9F1',
            medium: '#ADEBD1',
        },
        success: {
            light: '#E5F9F1',
            medium: '#ADEBD1',
        },
        warning: {
            light: '#FDEBE5',
            medium: '#FBD8CA',
        },
        error: {
            light: '#F5E3EB',
            medium: '#EBC7D7',
        },
        info: {
            light: '#E6F9FA',
            medium: '#CDF3F4',
        },
        upgrade: {
            light: '#FEF2CC',
            medium: '#FDE599',
        },
        muted: {
            light: '#EDEEEE',
            medium: '#EDEEEE',
        },
    },
    border: {
        main: '#D0D2D3',
        active: '#404040',
        hover: '#757575',
        muted: '#EDEEEE',
    },
    data: {
        one: '#507CB6',
        two: '#00BF6F',
        three: '#6BC8CD',
        four: '#F9BE00',
        five: '#7D5E90',
        six: '#DB4D5C',
        seven: '#768086',
        eight: '#D25F90',
        nine: '#A38364',
        ten: '#FF8B4F',
    },
};
({
    main: [1, 'solid', getColor(palette$1, 'main', { colorType: 'border' })],
    hover: [1, 'solid', getColor(palette$1, 'hover', { colorType: 'border' })],
    active: [1, 'solid', getColor(palette$1, 'active', { colorType: 'border' })],
    muted: [1, 'solid', getColor(palette$1, 'muted', { colorType: 'border' })],
    dark: [1, 'solid', getColor(palette$1, 'dark', { colorType: 'background' })],
    light: [2, 'solid', getColor(palette$1, 'light', { colorType: 'background' })],
});
 false
    ? 0
    : 'cdn.smassets.net';
var palette = {
    transparent: {
        clear: 'transparent',
        dark: 'rgba(64,64,64,0.2)',
        light: 'rgba(255, 255, 255, 0.2)',
    },
    primary: {
        main: '#008323',
        contrast: '#FFFFFF',
    },
    secondary: {
        main: '#757575',
        contrast: '#FFFFFF',
    },
    success: {
        main: '#008323',
        contrast: '#FFFFFF',
    },
    warning: {
        main: '#F7B500',
        contrast: '#404040',
    },
    error: {
        main: '#CC0000',
        contrast: '#FFFFFF',
    },
    info: {
        main: '#2cb2f1',
        contrast: '#000000',
    },
    upgrade: {
        main: '#ffe11b',
        contrast: '#404040',
    },
    muted: {
        main: '#d0d0d0',
        contrast: '#404040',
    },
    link: {
        main: '#0a7cc1',
        contrast: '#FFFFFF',
    },
    text: {
        dark: '#404040',
        light: '#FFFFFF',
        darkMuted: '#757575',
        lightMuted: '#efefef',
        link: '#0a7cc1',
    },
    background: {
        main: '#f7f7f7',
        light: '#ffffff',
        dark: '#404040',
        overlay: 'rgba(117, 117, 117, .86)',
        accent: '#efefef',
        primary: {
            light: '#E5F3E9',
            medium: '#C2E1CA',
        },
        success: {
            light: '#E5F3E9',
            medium: '#C2E1CA',
        },
        warning: {
            light: '#FFEEC0',
            medium: '#FCE39E',
        },
        error: {
            light: '#FBEAEA',
            medium: '#F4C7C7',
        },
        info: {
            light: '#DCF0FF',
            medium: '#C4E0F0',
        },
        upgrade: {
            light: '#FFF9D1',
            medium: '#FFF3A4',
        },
        muted: {
            light: '#EFEFEF',
            medium: '#EFEFEF',
        },
    },
    border: {
        main: '#d0d0d0',
        active: '#404040',
        hover: '#757575',
        muted: '#EDEEEE',
    },
    data: {
        one: '#507CB6',
        two: '#008323',
        three: '#6BC8CD',
        four: '#F9BE00',
        five: '#7D5E90',
        six: '#DB4D5C',
        seven: '#768086',
        eight: '#D25F90',
        nine: '#A38364',
        ten: '#FF8B4F',
    },
};
getColor(palette, 'main', { colorType: 'border' });
({
    main: [1, 'solid', getColor(palette, 'main', { colorType: 'border' })],
    hover: [1, 'solid', getColor(palette, 'hover', { colorType: 'border' })],
    active: [1, 'solid', getColor(palette, 'active', { colorType: 'border' })],
    muted: [1, 'solid', getColor(palette, 'muted', { colorType: 'border' })],
    dark: [1, 'solid', getColor(palette, 'dark', { colorType: 'background' })],
    light: [2, 'solid', getColor(palette, 'light', { colorType: 'background' })],
});

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var index_es_react = {exports: {}};

var react_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReact_production_min;

function requireReact_production_min () {
	if (hasRequiredReact_production_min) return react_production_min;
	hasRequiredReact_production_min = 1;
var l=requireObjectAssign(),n=60103,p=60106;react_production_min.Fragment=60107;react_production_min.StrictMode=60108;react_production_min.Profiler=60114;var q=60109,r=60110,t=60112;react_production_min.Suspense=60113;var u=60115,v=60116;
	if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");react_production_min.Fragment=w("react.fragment");react_production_min.StrictMode=w("react.strict_mode");react_production_min.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");react_production_min.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy");}var x="function"===typeof Symbol&&Symbol.iterator;
	function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return "function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var A={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A;}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState");};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};
	function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A;}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
	function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f;}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return {$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
	function K(a,b){return {$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return "object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return "$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0;}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
	0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d);}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
	function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b);},function(b){0===a._status&&(a._status=2,a._result=b);});}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
	react_production_min.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments);},c);},count:function(a){var b=0;P(a,function(){b++;});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};react_production_min.Component=C;react_production_min.PureComponent=E;react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
	react_production_min.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f]);}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g;}return {$$typeof:n,type:a.type,
	key:d,ref:k,props:e,_owner:h}};react_production_min.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};react_production_min.createElement=J;react_production_min.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};react_production_min.createRef=function(){return {current:null}};react_production_min.forwardRef=function(a){return {$$typeof:t,render:a}};react_production_min.isValidElement=L;
	react_production_min.lazy=function(a){return {$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};react_production_min.memo=function(a,b){return {$$typeof:u,type:a,compare:void 0===b?null:b}};react_production_min.useCallback=function(a,b){return S().useCallback(a,b)};react_production_min.useContext=function(a,b){return S().useContext(a,b)};react_production_min.useDebugValue=function(){};react_production_min.useEffect=function(a,b){return S().useEffect(a,b)};react_production_min.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
	react_production_min.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};react_production_min.useMemo=function(a,b){return S().useMemo(a,b)};react_production_min.useReducer=function(a,b,c){return S().useReducer(a,b,c)};react_production_min.useRef=function(a){return S().useRef(a)};react_production_min.useState=function(a){return S().useState(a)};react_production_min.version="17.0.2";
	return react_production_min;
}

var react_development = {};

/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReact_development;

function requireReact_development () {
	if (hasRequiredReact_development) return react_development;
	hasRequiredReact_development = 1;
	(function (exports) {

		if (false) {}
} (react_development));
	return react_development;
}

(function (module) {

	if (true) {
	  module.exports = requireReact_production_min();
	} else {}
} (index_es_react));

/*@__PURE__*/getDefaultExportFromCjs(index_es_react.exports);

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
(0,dist_index_es/* createMemoStyles */.Im)(function (_a) {
    var _b = _a.type, assets = _b.assets, fontFamily = _b.fontFamily, fontWeight = _b.fontWeight, fontSize = _b.fontSize;
    var fontPath = "".concat(assets.base).concat(assets.path);
    var fontFaces = FONT_WEIGHTS.map(function (name) {
        // we need this because the font file names are all National2-<Weight>.2.ext
        var upperCaseName = "".concat(name[0].toUpperCase()).concat(name.slice(1));
        var weight = fontWeight[name];
        return {
            fontFamily: assets.name,
            fontWeight: weight,
            fontDisplay: 'swap',
            src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff2) format('woff2')"),
            fallbacks: [
                {
                    src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff) format('woff')"),
                },
                {
                    src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".eot#iefix) format('embedded-opentype')"),
                },
            ],
        };
    });
    return {
        '@font-face': fontFaces,
        '@global': {
            "[class*='wrench'], [class*='wrench']::before, [class*='wrench']::after": {
                fontFamily: fontFamily.base,
                '-webkit-font-smoothing': 'antialiased',
                fontSize: fontSize.body,
                boxSizing: 'border-box',
                padding: 0,
                margin: 0,
                listStyle: 'none',
            },
        },
    };
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var innerBoxStyle = {
    border: '2px dashed #2dccd3',
    backgroundColor: 'rgba(45,204,211,.6)',
    fontFamily: 'Roboto, Helvetica, Arial',
};
__assign(__assign({}, innerBoxStyle), { marginBottom: '16px' });
__assign(__assign({}, innerBoxStyle), { backgroundColor: '#ffffff', border: 'none' });
__assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8 });
__assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8, height: 40 });
__assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8, height: 80 });
__assign(__assign({}, innerBoxStyle), { padding: 8, margin: 8, height: 120 });

var useStyles = (0,dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var spacing = theme.spacing, palette = theme.palette, type = theme.type;
    return {
        wrenchInputMessage: function (_a) {
            var color = _a.color;
            return __assign$1(__assign$1(__assign$1({}, dist_index_es/* defaultBaseline */.yD), (0,dist_index_es/* defaultFonts */.FZ)(theme)), { marginTop: spacing[2], color: color ? palette[color].main : getColor(palette, 'darkMuted'), fontSize: type.fontSize.bodySm, fontWeight: type.fontWeight.regular, alignItems: "center", display: "flex" });
        },
    };
});

var InputMessage = function (_a) {
    var _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.color, color = _c === void 0 ? undefined : _c;
    var wrenchInputMessage = useStyles({ color: color }).wrenchInputMessage;
    return (react.createElement("div", { role: "alert", className: wrenchInputMessage },
        react.createElement(Box, { mr: 1, display: "inline-flex", flexAlign: "center" },
            color === 'error' && react.createElement(icons_dist_index_es/* IconError */.Ucq, { title: "error" }),
            color === 'success' && react.createElement(icons_dist_index_es/* IconCheck */.NOm, { title: "success" })),
        children));
};



// EXTERNAL MODULE: ./node_modules/@wds/styles/dist/index.es.js
var styles_dist_index_es = __webpack_require__(4779);
;// CONCATENATED MODULE: ./node_modules/@wds/input/dist/index.es.js






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var index_es_assign = function() {
    index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return index_es_assign.apply(this, arguments);
};

function index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var index_es_useStyles = (0,dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var spacing = theme.spacing, shadow = theme.shadow, palette = theme.palette, type = theme.type, radius = theme.radius;
    var input = {
        height: {
            sm: spacing[6],
            md: 40,
            lg: spacing[7],
        },
        fontSize: type.fontSize.body,
        padding: {
            sm: spacing[2],
            md: spacing[4],
            lg: spacing[4],
        },
    };
    var inputStyles = {
        wrenchInput: function (_a) {
            var size = _a.size, stretched = _a.stretched, color = _a.color, disabled = _a.disabled;
            return (index_es_assign(index_es_assign(index_es_assign(index_es_assign(index_es_assign(index_es_assign(index_es_assign(index_es_assign({}, dist_index_es/* defaultBaseline */.yD), (0,dist_index_es/* defaultFonts */.FZ)(theme)), { outline: 'none', appearance: 'none', boxShadow: 'none', color: palette.text.dark, border: [
                    1,
                    'solid',
                    (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.border.main }),
                ], borderRadius: radius.small, backgroundColor: palette.background.light, lineHeight: 1.5, '&:hover': {
                    borderColor: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, {
                        fallback: palette.border.hover,
                    }),
                    boxShadow: shadow.sky,
                    transition: ['border-color 100ms', 'box-shawdow 100ms'],
                }, '&:focus': {
                    borderColor: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, {
                        fallback: palette.border.active,
                    }),
                    transition: ['border-color', '100ms'],
                } }), (size && { padding: [0, input.padding[size]] })), (size && { height: size && input.height[size] })), ((size === 'md' || size === undefined) && {
                fontSize: input.fontSize,
            })), (stretched && { width: '100%' })), (disabled && {
                pointerEvents: 'none',
                opacity: 0.4,
            })));
        },
    };
    return inputStyles;
});

var Input = (0,react.forwardRef)(function (_a, ref) {
    var ariaLabel = _a.ariaLabel, defaultValue = _a.defaultValue, _b = _a.disabled, disabled = _b === void 0 ? false : _b, color = _a.color, errorMessage = _a.errorMessage, id = _a.id, inputSize = _a.inputSize, label = _a.label, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'md' : _d, _e = _a.stretched, stretched = _e === void 0 ? false : _e, _f = _a.type, type = _f === void 0 ? 'text' : _f, value = _a.value, placeholder = _a.placeholder, min = _a.min, max = _a.max, step = _a.step, otherProps = index_es_rest(_a, ["ariaLabel", "defaultValue", "disabled", "color", "errorMessage", "id", "inputSize", "label", "name", "onBlur", "onChange", "readOnly", "size", "stretched", "type", "value", "placeholder", "min", "max", "step"]);
    (0,dist_index_es/* deprecate */.Rn)({ color: color }, 'color', 'warning', 'Input');
    var wrenchInput = index_es_useStyles({
        size: size,
        stretched: stretched,
        color: color,
        disabled: disabled,
    }).wrenchInput;
    var _g = (0,react.useState)(value), stateValue = _g[0], setStateValue = _g[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var isControlled$1 = (0,react.useMemo)(function () { return (0,dist_index_es/* isControlled */.sI)(value); }, []);
    var inputID = (0,react.useMemo)(function () { return id !== null && id !== void 0 ? id : (0,dist_index_es/* uniqueId */.EL)('input'); }, [id]);
    var handleChange = function (event) {
        if (isControlled$1 && event.target.value !== value) {
            event.persist();
            setStateValue(event.target.value);
            if (onChange) {
                onChange(event);
            }
        }
    };
    return (react.createElement(react.Fragment, null,
        label && react.createElement(index_es/* Label */._, { htmlFor: inputID }, label),
        react.createElement("input", index_es_assign({ "aria-label": ariaLabel, className: wrenchInput, defaultValue: defaultValue, disabled: disabled, id: inputID, name: name, onBlur: onBlur, onChange: handleChange, readOnly: readOnly, ref: ref, size: inputSize, type: type, value: isControlled$1 ? value : stateValue, placeholder: placeholder, min: min, max: max, step: step }, (0,dist_index_es/* safeRest */.Q6)(otherProps))),
        errorMessage && (react.createElement(InputMessage, { color: color }, errorMessage))));
});
Input.displayName = 'Input';




/***/ }),

/***/ 2129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1928);
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5420);




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (theme) {
    var type = theme.type, spacing = theme.spacing, palette = theme.palette;
    return {
        wrenchLabel: function (_a) {
            var muted = _a.muted, plain = _a.plain;
            return (__assign(__assign({ display: 'block', color: palette.text.dark, fontFamily: type.fontFamily.base, '-webkit-font-smoothing': 'antialiased', boxSizing: 'border-box', fontSize: type.fontSize.bodySm, padding: 0, margin: [0, 0, spacing[2]], fontWeight: type.fontWeight.medium }, (plain && {
                fontWeight: type.fontWeight.regular,
                fontSize: type.fontSize.body,
            })), (muted && {
                color: palette.text.darkMuted,
                fontWeight: type.fontWeight.regular,
            })));
        },
    };
});

var Label = function (_a) {
    var children = _a.children, htmlFor = _a.htmlFor, muted = _a.muted, plain = _a.plain, rest = __rest(_a, ["children", "htmlFor", "muted", "plain"]);
    var theme = (0,react_jss__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    var wrenchLabel = useStyles({ theme: theme, muted: muted, plain: plain }).wrenchLabel;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", __assign({ className: wrenchLabel, htmlFor: htmlFor }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .safeRest */ .Q6)(rest)), children));
};
Label.defaultProps = {
    muted: false,
    plain: false,
};




/***/ }),

/***/ 6607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Toast; }
/* harmony export */ });
/* unused harmony export TOAST_COLORS */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _wds_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5420);
/* harmony import */ var _wds_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9224);
/* harmony import */ var _wds_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4661);
/* harmony import */ var _wds_internal_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7153);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);







/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles$3 = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (theme) {
    var palette = theme.palette, type = theme.type;
    var toast = {
        typeColor: palette.text.light,
        titleFontSize: type.fontSize.body,
    };
    var toastStyles = {
        wrenchToastTitle: function () { return ({
            color: toast.typeColor,
            fontSize: toast.titleFontSize,
            // marginLeft: color && spacing[6],
        }); },
    };
    return toastStyles;
});

var ToastTitle = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var wrenchToastTitle = useStyles$3().wrenchToastTitle;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ className: wrenchToastTitle }, rest), children));
};
ToastTitle.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
};

var useStyles$2 = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (theme) {
    var palette = theme.palette, type = theme.type, spacing = theme.spacing;
    var toast = {
        typeColor: palette.text.light,
        bodyTypeSize: type.fontSize.bodySm,
        linkColor: palette.link.contrast,
    };
    var toastStyles = {
        wrenchToastBody: function () { return ({
            color: toast.typeColor,
            fontSize: toast.bodyTypeSize,
            marginTop: spacing[4],
            // marginLeft: color && spacing[6],
            '& > a': {
                color: toast.linkColor,
                textDecoration: 'underline',
            },
        }); },
    };
    return toastStyles;
});

var ToastBody = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var wrenchToastBody = useStyles$2().wrenchToastBody;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ className: wrenchToastBody }, rest), children));
};
ToastBody.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
};

var useStyles$1 = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (theme) {
    var spacing = theme.spacing;
    var toastStyles = {
        wrenchToastFooter: function () { return ({
            marginTop: spacing[4],
            // marginLeft: color && spacing[6],
            '& > *': {
                marginRight: spacing[3],
            },
        }); },
    };
    return toastStyles;
});

var ToastFooter = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var wrenchToastFooter = useStyles$1().wrenchToastFooter;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ className: wrenchToastFooter }, rest), children));
};
ToastFooter.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
};

var useStyles = (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .createMemoStyles */ .Im)(function (theme) {
    var _a;
    var palette = theme.palette, radius = theme.radius, shadow = theme.shadow, type = theme.type, spacing = theme.spacing, iconSize = theme.iconSize, breakpoints = theme.breakpoints;
    var toast = {
        padding: spacing[5],
        bgColor: palette.background.dark,
        typeColor: palette.text.light,
        borderRadius: radius.small,
        width: 350,
        titleFontSize: type.fontSize.body,
        bodyTypeSize: type.fontSize.bodySm,
        linkColor: palette.link.contrast,
        boxShadow: shadow.none,
    };
    var toastStyles = {
        wrenchToastContainer: (_a = {
                position: 'fixed',
                right: spacing[3],
                bottom: spacing[3],
                left: spacing[3],
                zIndex: function (_a) {
                    var elevation = _a.elevation;
                    return elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space;
                }
            },
            _a["@media (min-width:".concat(breakpoints.sm, "px)")] = {
                right: spacing[5],
                bottom: spacing[5],
                width: toast.width,
                left: 'auto',
            },
            _a),
        wrenchToast: function () { return (__assign(__assign({}, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .defaultFonts */ .FZ)(theme)), { boxSizing: 'border-box', margin: 0, padding: toast.padding, backgroundColor: toast.bgColor, color: toast.typeColor, borderRadius: toast.borderRadius, boxShadow: toast.boxShadow })); },
        wrenchToastIcon: function () { return ({
            fontSize: iconSize.md,
            marginRight: spacing[3],
            float: 'left',
            display: 'inline-flex',
        }); },
        wrenchToastContent: function () { return ({
            display: 'inline-flex',
        }); },
    };
    return toastStyles;
});

var TIMEOUT_DELAY = 3000;
var Toast = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? undefined : _b, _c = _a.onClose, onClose = _c === void 0 ? undefined : _c, _d = _a.autoClose, autoClose = _d === void 0 ? true : _d, _e = _a.dismissible, dismissible = _e === void 0 ? false : _e, _f = _a.show, show = _f === void 0 ? true : _f, _g = _a.elevation, elevation = _g === void 0 ? undefined : _g, _h = _a.ariaLabel, ariaLabel = _h === void 0 ? 'Close Toast' : _h, rest = __rest(_a, ["children", "color", "onClose", "autoClose", "dismissible", "show", "elevation", "ariaLabel"]);
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        timeout: undefined,
    });
    var _j = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(show), localShow = _j[0], setLocalShow = _j[1];
    var _k = useStyles({ color: color, elevation: elevation }), wrenchToastContainer = _k.wrenchToastContainer, wrenchToast = _k.wrenchToast, wrenchToastIcon = _k.wrenchToastIcon, wrenchToastContent = _k.wrenchToastContent;
    var ToastIcon = color ? {
        info: _wds_icons__WEBPACK_IMPORTED_MODULE_2__/* .IconInfo */ .aUG,
        warning: _wds_icons__WEBPACK_IMPORTED_MODULE_2__/* .IconWarning */ .FCX,
        error: _wds_icons__WEBPACK_IMPORTED_MODULE_2__/* .IconWarning */ .FCX,
        success: _wds_icons__WEBPACK_IMPORTED_MODULE_2__/* .IconCheck */ .NOm,
        upgrade: _wds_icons__WEBPACK_IMPORTED_MODULE_2__/* .IconLock */ ._V1,
    }[color] : _wds_icons__WEBPACK_IMPORTED_MODULE_2__/* .IconInfo */ .aUG;
    var handleClose = function () {
        if (timeoutRef.current.timeout) {
            clearTimeout(timeoutRef.current.timeout);
        }
        setLocalShow(false);
        if (onClose) {
            onClose();
        }
    };
    var handleMouseEnter = function () {
        if (autoClose && timeoutRef.current.timeout) {
            clearTimeout(timeoutRef.current.timeout);
        }
    };
    var handleMouseExit = function () {
        if (autoClose) {
            timeoutRef.current.timeout = setTimeout(function () { return handleClose(); }, TIMEOUT_DELAY);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (autoClose && show) {
            timeoutRef.current.timeout = setTimeout(function () { return handleClose(); }, TIMEOUT_DELAY);
        }
        else if (timeoutRef.current.timeout) {
            clearTimeout(timeoutRef.current.timeout);
        }
        setLocalShow(show);
        var timeEffectRef = timeoutRef.current.timeout;
        return function () {
            if (timeEffectRef) {
                clearTimeout(timeEffectRef);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchToastContainer },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_wds_motion__WEBPACK_IMPORTED_MODULE_3__/* .Slide */ .Mi, { in: localShow, distance: "far" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", __assign({ onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseExit, className: wrenchToast, role: "alert" }, (0,_wds_utils__WEBPACK_IMPORTED_MODULE_1__/* .safeRest */ .Q6)(rest)),
                    dismissible && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_wds_internal_components__WEBPACK_IMPORTED_MODULE_5__/* .CloseButton */ .PZ, { onClick: handleClose, label: ariaLabel, variant: "light" })),
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchToastContent },
                        color && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: wrenchToastIcon },
                            react__WEBPACK_IMPORTED_MODULE_0__.createElement(ToastIcon, { color: color, title: "".concat(color, " icon.") }))),
                        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, children)))))));
};
Toast.Title = ToastTitle;
Toast.Body = ToastBody;
Toast.Footer = ToastFooter;

var TOAST_COLORS = (/* unused pure expression or super */ null && ([
    'success',
    'warning',
    'error',
    'info',
    'upgrade',
]));




/***/ }),

/***/ 1476:
/***/ (function(module) {

"use strict";


const word = '[a-fA-F\\d:]';
const b = options => options && options.includeBoundaries ?
	`(?:(?<=\\s|^)(?=${word})|(?<=${word})(?=\\s|$))` :
	'';

const v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';

const v6seg = '[a-fA-F\\d]{1,4}';
const v6 = `
(?:
(?:${v6seg}:){7}(?:${v6seg}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${v6seg}:){6}(?:${v4}|:${v6seg}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${v6seg}:){5}(?::${v4}|(?::${v6seg}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${v6seg}:){4}(?:(?::${v6seg}){0,1}:${v4}|(?::${v6seg}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${v6seg}:){3}(?:(?::${v6seg}){0,2}:${v4}|(?::${v6seg}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${v6seg}:){2}(?:(?::${v6seg}){0,3}:${v4}|(?::${v6seg}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${v6seg}:){1}(?:(?::${v6seg}){0,4}:${v4}|(?::${v6seg}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${v6seg}){0,5}:${v4}|(?::${v6seg}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim();

// Pre-compile only the exact regexes because adding a global flag make regexes stateful
const v46Exact = new RegExp(`(?:^${v4}$)|(?:^${v6}$)`);
const v4exact = new RegExp(`^${v4}$`);
const v6exact = new RegExp(`^${v6}$`);

const ip = options => options && options.exact ?
	v46Exact :
	new RegExp(`(?:${b(options)}${v4}${b(options)})|(?:${b(options)}${v6}${b(options)})`, 'g');

ip.v4 = options => options && options.exact ? v4exact : new RegExp(`${b(options)}${v4}${b(options)}`, 'g');
ip.v6 = options => options && options.exact ? v6exact : new RegExp(`${b(options)}${v6}${b(options)}`, 'g');

module.exports = ip;


/***/ }),

/***/ 5003:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

const ipRegex = __webpack_require__(1476);

const isIp = string => ipRegex({exact: true}).test(string);
isIp.v4 = string => ipRegex.v4({exact: true}).test(string);
isIp.v6 = string => ipRegex.v6({exact: true}).test(string);
isIp.version = string => isIp(string) ? (isIp.v4(string) ? 4 : 6) : undefined;

module.exports = isIp;


/***/ }),

/***/ 973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(1169);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 6477:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 5159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_BasePage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@sm/metrics/dist/index.js
var dist = __webpack_require__(6431);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Experiments/index.js
var Experiments = __webpack_require__(4165);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Helmet/index.js + 1 modules
var Helmet = __webpack_require__(6685);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/BasePageHead.js
var _jsxFileName = "/repo/packages/webassets/src/components/BasePage/BasePageHead.js", _this = undefined;



var BasePageHead = function BasePageHead(_ref) {
    var isPrivateLabel = _ref.isPrivateLabel;
    return /*#__PURE__*/ react.createElement(Helmet/* default */.ZP, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 6,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement("title", {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 7,
            columnNumber: 5
        }
    }, "Welcome to SurveyMonkey!"), /*#__PURE__*/ react.createElement("meta", {
        name: "keywords",
        content: "SurveyMonkey,online surveys,online survey,web surveys, web survey,market research,free,research,stats,statistics,polls,voting,analyze,tool,decisions,planning,strategy,Community,forms,formsite,workgroups,cgi,database",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 8,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("meta", {
        name: "description",
        content: "Create and publish online surveys in minutes, and view results graphically and in real time. SurveyMonkey provides free online questionnaire and survey software.",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 12,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("meta", {
        charset: "utf-8",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 16,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("meta", {
        name: "msapplication-config",
        content: "none",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 17,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("meta", {
        name: "author",
        content: "SurveyMonkey",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 18,
            columnNumber: 5
        }
    }), isPrivateLabel ? /*#__PURE__*/ react.createElement("link", {
        rel: "shortcut icon",
        href: "https://cdn.smassets.net/assets/cms/cc/app/static/momentive-favicon.ico",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 21,
            columnNumber: 9
        }
    }) : [
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            href: "/apple-touch-icon-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 27,
                columnNumber: 9
            },
            key: "0"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "57x57",
            href: "/apple-touch-icon-57x57-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 28,
                columnNumber: 9
            },
            key: "1"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "60x60",
            href: "/apple-touch-icon-60x60-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 33,
                columnNumber: 9
            },
            key: "2"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "72x72",
            href: "/apple-touch-icon-72x72-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 38,
                columnNumber: 9
            },
            key: "3"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "76x76",
            href: "/apple-touch-icon-76x76-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 43,
                columnNumber: 9
            },
            key: "4"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "114x114",
            href: "/apple-touch-icon-114x114-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 48,
                columnNumber: 9
            },
            key: "5"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "120x120",
            href: "/apple-touch-icon-120x120-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 53,
                columnNumber: 9
            },
            key: "6"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "144x144",
            href: "/apple-touch-icon-144x144-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 58,
                columnNumber: 9
            },
            key: "7"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "152x152",
            href: "/apple-touch-icon-152x152-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 63,
                columnNumber: 9
            },
            key: "8"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "apple-touch-icon",
            sizes: "180x180",
            href: "/apple-touch-icon-180x180-precomposed.png",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 68,
                columnNumber: 9
            },
            key: "9"
        }),
        /*#__PURE__*/ react.createElement("link", {
            rel: "shortcut icon",
            href: "/favicon.ico",
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 73,
                columnNumber: 9
            },
            key: "10"
        })
    ]);
};
BasePageHead.propTypes = {
    isPrivateLabel: (prop_types_default()).bool
};
BasePageHead.defaultProps = {
    isPrivateLabel: false
};
/* harmony default export */ var BasePage_BasePageHead = (BasePageHead); //# sourceMappingURL=BasePageHead.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/index.js + 265 modules
var webassets_dist = __webpack_require__(4457);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/enums.js
var enums = __webpack_require__(1478);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/BasePageBody.js
var BasePageBody_jsxFileName = "/repo/packages/webassets/src/components/BasePage/BasePageBody.tsx", BasePageBody_this = undefined;



var BasePageBody = function BasePageBody(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "primary" : _ref$color, _ref$headerVariant = _ref.headerVariant, headerVariant = _ref$headerVariant === void 0 ? "default" : _ref$headerVariant, _ref$footerVariant = _ref.footerVariant, footerVariant = _ref$footerVariant === void 0 ? "default" : _ref$footerVariant, errorCtrl = _ref.errorCtrl, _ref$showBillingAddre = _ref.showBillingAddress, showBillingAddress = _ref$showBillingAddre === void 0 ? false : _ref$showBillingAddre, _ref$includeHeader = _ref.includeHeader, includeHeader = _ref$includeHeader === void 0 ? true : _ref$includeHeader, _ref$includeFooter = _ref.includeFooter, includeFooter = _ref$includeFooter === void 0 ? true : _ref$includeFooter, children = _ref.children, _ref$actionFlow = _ref.actionFlow, actionFlow = _ref$actionFlow === void 0 ? "header" : _ref$actionFlow, _ref$showCreateSurvey = _ref.showCreateSurveyButton, showCreateSurveyButton = _ref$showCreateSurvey === void 0 ? true : _ref$showCreateSurvey, _ref$sticky = _ref.sticky, sticky = _ref$sticky === void 0 ? true : _ref$sticky, _ref$isMRX = _ref.isMRX, isMRX = _ref$isMRX === void 0 ? false : _ref$isMRX, _ref$isPrivateLabel = _ref.isPrivateLabel, isPrivateLabel = _ref$isPrivateLabel === void 0 ? false : _ref$isPrivateLabel, _ref$excludeMenuItems = _ref.excludeMenuItems, excludeMenuItems = _ref$excludeMenuItems === void 0 ? [] : _ref$excludeMenuItems, _ref$showLoginButton = _ref.showLoginButton, showLoginButton = _ref$showLoginButton === void 0 ? true : _ref$showLoginButton, _ref$showSignupButton = _ref.showSignupButton, showSignupButton = _ref$showSignupButton === void 0 ? true : _ref$showSignupButton, _ref$displayLICTA = _ref.displayLICTA, displayLICTA = _ref$displayLICTA === void 0 ? true : _ref$displayLICTA, _ref$showDrawer = _ref.showDrawer, showDrawer = _ref$showDrawer === void 0 ? true : _ref$showDrawer, Logo = _ref.Logo, wrenchVariant = _ref.wrenchVariant;
    var _useContext = (0,react.useContext)(webassets_dist/* StaticContext */.vN), user = _useContext.user, url = _useContext.url, environment = _useContext.environment, locale = _useContext.locale, clientConfig = _useContext["client-config"], GDPR = _useContext.GDPR;
    var language = environment.languageCode, country = environment.countryCode, subdomain = environment.subdomain, domain = environment.domain, tld = environment.tld;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, includeHeader ? /*#__PURE__*/ react.createElement(webassets_dist/* SMHeader */.mc, {
        isAnonHeaderSticky: sticky,
        isUserAuthenticated: user.isAuthenticated,
        color: color,
        variant: headerVariant,
        lang: language,
        isEUDC: locale.isEUDC,
        actionFlow: actionFlow,
        user: user,
        showCreateSurveyButton: showCreateSurveyButton,
        isMRX: isMRX,
        excludeMenuItems: excludeMenuItems,
        showLoginButton: showLoginButton,
        showSignupButton: showSignupButton,
        displayLICTA: displayLICTA,
        showDrawer: showDrawer,
        Logo: Logo,
        brand: isPrivateLabel ? enums/* BRAND.MOMENTIVE */.cg.MOMENTIVE : enums/* BRAND.SURVEYMONKEY */.cg.SURVEYMONKEY,
        wrenchVariant: wrenchVariant,
        __self: BasePageBody_this,
        __source: {
            fileName: BasePageBody_jsxFileName,
            lineNumber: 84,
            columnNumber: 9
        }
    }) : null, errorCtrl ? /*#__PURE__*/ react.createElement(webassets_dist/* ErrorController */.hW, Object.assign({}, errorCtrl, {
        __self: BasePageBody_this,
        __source: {
            fileName: BasePageBody_jsxFileName,
            lineNumber: 106,
            columnNumber: 9
        }
    }), children) : /*#__PURE__*/ react.createElement(react.Fragment, null, children), includeFooter ? /*#__PURE__*/ react.createElement(webassets_dist/* SMFooter */.ol, {
        subdomain: subdomain,
        domain: domain,
        lang: language,
        country: country,
        isUserAuthenticated: user.isAuthenticated,
        showBillingAddress: showBillingAddress,
        variant: footerVariant,
        isEUDC: locale.isEUDC,
        isPrivateLabel: isPrivateLabel,
        tld: tld,
        url: url,
        onetrustBannerEnabled: GDPR.onetrustBannerEnabled,
        __self: BasePageBody_this,
        __source: {
            fileName: BasePageBody_jsxFileName,
            lineNumber: 111,
            columnNumber: 9
        }
    }) : null, user.isAuthenticated ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(webassets_dist/* SessionTimeoutModal */.qp, {
        user: user,
        __self: BasePageBody_this,
        __source: {
            fileName: BasePageBody_jsxFileName,
            lineNumber: 128,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement(webassets_dist/* MobileBanner */.BR, {
        downloadLink: clientConfig.mobileBannerDownloadLink,
        deepLinkData: undefined,
        __self: BasePageBody_this,
        __source: {
            fileName: BasePageBody_jsxFileName,
            lineNumber: 129,
            columnNumber: 11
        }
    })) : null, !GDPR.onetrustBannerEnabled ? /*#__PURE__*/ react.createElement(webassets_dist/* CookieBanner */.tM, {
        GDPR: GDPR,
        __self: BasePageBody_this,
        __source: {
            fileName: BasePageBody_jsxFileName,
            lineNumber: 135,
            columnNumber: 38
        }
    }) : null);
};
/* harmony default export */ var BasePage_BasePageBody = (BasePageBody); //# sourceMappingURL=BasePageBody.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/hooks/useGTM.js

var useGTM = function useGTM() {
    var includeGTM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    (0,react.useEffect)(function() {
        if (includeGTM) {
            /* eslint-disable */ (function(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    "gtm.start": new Date().getTime(),
                    event: "gtm.js"
                });
                var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
                j.async = true;
                j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, "script", "dataLayer", "".concat(window.SM.MetricsTracker.getConfig().gtmId));
        /* eslint-enable */ }
    }, [
        includeGTM
    ]);
};
/* harmony default export */ var hooks_useGTM = (useGTM); //# sourceMappingURL=useGTM.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/hooks/useInitialRender.js

var useInitialRender = function useInitialRender() {
    var firstRender = (0,react.useRef)(true);
    (0,react.useEffect)(function() {
        if (firstRender.current) {
            firstRender.current = false;
        }
    });
    return firstRender.current;
};
/* harmony default export */ var hooks_useInitialRender = (useInitialRender); //# sourceMappingURL=useInitialRender.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/hooks/index.js


 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/index.js
var _excluded = [
    "children",
    "pageId",
    "pageMetricsAttributes",
    "legacyWeb",
    "includeGTM",
    "includeExperiments"
];
var BasePage_jsxFileName = "/repo/packages/webassets/src/components/BasePage/index.tsx", BasePage_this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var BasePage = function BasePage(_ref) {
    var children = _ref.children, pageId = _ref.pageId, pageMetricsAttributes = _ref.pageMetricsAttributes, legacyWeb = _ref.legacyWeb, _ref$includeGTM = _ref.includeGTM, includeGTM = _ref$includeGTM === void 0 ? true : _ref$includeGTM, _ref$includeExperimen = _ref.includeExperiments, includeExperiments = _ref$includeExperimen === void 0 ? true : _ref$includeExperimen, bodyProps = _objectWithoutProperties(_ref, _excluded);
    var isInitialRender = hooks_useInitialRender();
    var _useContext = (0,react.useContext)(webassets_dist/* StaticContext */.vN), user = _useContext.user, environment = _useContext.environment, clientConfig = _useContext["client-config"], GDPR = _useContext.GDPR;
    var country = environment.countryCode;
    var gtmId = clientConfig.gtmId, loggingAPIPath = clientConfig.loggingAPIPath, dataAnalyticsAPIPath = clientConfig.dataAnalyticsAPIPath, amplitudeToken = clientConfig.amplitudeToken;
    // init global metrics
    if (isInitialRender) {
        dist.MetricsTracker.initialize({
            user: user,
            dataAnalyticsAPIPath: dataAnalyticsAPIPath,
            loggingAPIPath: loggingAPIPath,
            country: country,
            legacyWeb: legacyWeb,
            pageId: pageId,
            gtmId: gtmId,
            amplitudeToken: amplitudeToken
        });
    }
    hooks_useGTM(includeGTM);
    var BasePageInternals = /*#__PURE__*/ react.createElement(dist.PageMetricsProvider, {
        pageId: pageId,
        attributes: pageMetricsAttributes,
        GDPR: GDPR,
        user: user,
        country: country,
        __self: BasePage_this,
        __source: {
            fileName: BasePage_jsxFileName,
            lineNumber: 55,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(BasePage_BasePageHead, {
        isPrivateLabel: bodyProps.isPrivateLabel,
        __self: BasePage_this,
        __source: {
            fileName: BasePage_jsxFileName,
            lineNumber: 62,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement(BasePage_BasePageBody, Object.assign({}, bodyProps, {
        __self: BasePage_this,
        __source: {
            fileName: BasePage_jsxFileName,
            lineNumber: 63,
            columnNumber: 7
        }
    }), children));
    if (includeExperiments) {
        return /*#__PURE__*/ react.createElement(Experiments/* ExperimentProvider */.II, {
            __self: BasePage_this,
            __source: {
                fileName: BasePage_jsxFileName,
                lineNumber: 68,
                columnNumber: 12
            }
        }, BasePageInternals);
    }
    return BasePageInternals;
};
/* harmony default export */ var components_BasePage = (BasePage); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 5263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Experiments_Treatment; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/react-common/lib/react-common.esm.js
var react_common_esm = __webpack_require__(118);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@apollo/react-components/lib/react-components.esm.js
var react_components_esm = __webpack_require__(5422);
// EXTERNAL MODULE: ./node_modules/ts-invariant/lib/invariant.esm.js
var invariant_esm = __webpack_require__(7591);
;// CONCATENATED MODULE: ./node_modules/@apollo/react-hoc/lib/react-hoc.esm.js








var defaultMapPropsToOptions = function () { return ({}); };
var defaultMapPropsToSkip = function () { return false; };
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function calculateVariablesFromProps(operation, props) {
    var variables = {};
    for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
        var _b = _a[_i], variable = _b.variable, type = _b.type;
        if (!variable.name || !variable.name.value)
            continue;
        var variableName = variable.name.value;
        var variableProp = props[variableName];
        if (typeof variableProp !== 'undefined') {
            variables[variableName] = variableProp;
            continue;
        }
        if (type.kind !== 'NonNullType') {
            variables[variableName] = undefined;
        }
    }
    return variables;
}
var GraphQLBase = (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(GraphQLBase, _super);
    function GraphQLBase(props) {
        var _this = _super.call(this, props) || this;
        _this.withRef = false;
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
        return _this;
    }
    GraphQLBase.prototype.getWrappedInstance = function () {
         true ? (0,invariant_esm/* invariant */.kG)(this.withRef, 2) : 0;
        return this.wrappedInstance;
    };
    GraphQLBase.prototype.setWrappedInstance = function (ref) {
        this.wrappedInstance = ref;
    };
    return GraphQLBase;
}(react.Component));

function withQuery(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var operation = (0,react_common_esm/* parser */.E2)(document);
    var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function') {
        mapPropsToOptions = function () { return options; };
    }
    var mapPropsToSkip = skip;
    if (typeof mapPropsToSkip !== 'function') {
        mapPropsToSkip = function () { return skip; };
    }
    var lastResultProps;
    return function (WrappedComponent) {
        var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
        var GraphQL = (function (_super) {
            (0,tslib_es6/* __extends */.ZT)(GraphQL, _super);
            function GraphQL() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            GraphQL.prototype.render = function () {
                var _this = this;
                var props = this.props;
                var shouldSkip = mapPropsToSkip(props);
                var opts = shouldSkip
                    ? Object.create(null)
                    : (0,tslib_es6/* __assign */.pi)({}, mapPropsToOptions(props));
                if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                    opts.variables = calculateVariablesFromProps(operation, props);
                }
                return (react.createElement(react_components_esm/* Query */.AE, (0,tslib_es6/* __assign */.pi)({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, query: document }), function (_a) {
                    var _b, _c;
                    var _ = _a.client, data = _a.data, r = (0,tslib_es6/* __rest */._T)(_a, ["client", "data"]);
                    if (operationOptions.withRef) {
                        _this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: _this.setWrappedInstance
                        });
                    }
                    if (shouldSkip) {
                        return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, {})));
                    }
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'data';
                    var childProps = (_b = {}, _b[name] = result, _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {},
                            _c[name] = result,
                            _c.ownProps = props,
                            _c);
                        lastResultProps = operationOptions.props(newResult, lastResultProps);
                        childProps = lastResultProps;
                    }
                    return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, childProps)));
                }));
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }(GraphQLBase));
        return hoist_non_react_statics_cjs_default()(GraphQL, WrappedComponent, {});
    };
}

function withMutation(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var operation = (0,react_common_esm/* parser */.E2)(document);
    var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function')
        mapPropsToOptions = function () { return options; };
    return function (WrappedComponent) {
        var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
        var GraphQL = (function (_super) {
            (0,tslib_es6/* __extends */.ZT)(GraphQL, _super);
            function GraphQL() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            GraphQL.prototype.render = function () {
                var props = this.props;
                var opts = mapPropsToOptions(props);
                if (operationOptions.withRef) {
                    this.withRef = true;
                    props = Object.assign({}, props, {
                        ref: this.setWrappedInstance
                    });
                }
                if (!opts.variables && operation.variables.length > 0) {
                    opts.variables = calculateVariablesFromProps(operation, props);
                }
                return (react.createElement(react_components_esm/* Mutation */.mm, (0,tslib_es6/* __assign */.pi)({ ignoreResults: true }, opts, { mutation: document }), function (mutate, _a) {
                    var _b, _c;
                    var data = _a.data, r = (0,tslib_es6/* __rest */._T)(_a, ["data"]);
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'mutate';
                    var resultName = operationOptions.name
                        ? name + "Result"
                        : 'result';
                    var childProps = (_b = {},
                        _b[name] = mutate,
                        _b[resultName] = result,
                        _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {},
                            _c[name] = mutate,
                            _c[resultName] = result,
                            _c.ownProps = props,
                            _c);
                        childProps = operationOptions.props(newResult);
                    }
                    return react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, childProps));
                }));
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }(GraphQLBase));
        return hoist_non_react_statics_cjs_default()(GraphQL, WrappedComponent, {});
    };
}

function withSubscription(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var operation = (0,react_common_esm/* parser */.E2)(document);
    var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
    var mapPropsToOptions = options;
    if (typeof mapPropsToOptions !== 'function')
        mapPropsToOptions = function () { return options; };
    var mapPropsToSkip = skip;
    if (typeof mapPropsToSkip !== 'function')
        mapPropsToSkip = function () { return skip; };
    var lastResultProps;
    return function (WrappedComponent) {
        var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
        var GraphQL = (function (_super) {
            (0,tslib_es6/* __extends */.ZT)(GraphQL, _super);
            function GraphQL(props) {
                var _this = _super.call(this, props) || this;
                _this.state = { resubscribe: false };
                return _this;
            }
            GraphQL.prototype.componentDidUpate = function (prevProps) {
                if (shouldResubscribe) {
                    this.setState({
                        resubscribe: shouldResubscribe(prevProps, this.props)
                    });
                }
            };
            GraphQL.prototype.render = function () {
                var _this = this;
                var props = this.props;
                var shouldSkip = mapPropsToSkip(props);
                var opts = shouldSkip
                    ? Object.create(null)
                    : mapPropsToOptions(props);
                if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                    opts.variables = calculateVariablesFromProps(operation, props);
                }
                return (react.createElement(react_components_esm/* Subscription */.w0, (0,tslib_es6/* __assign */.pi)({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, subscription: document, shouldResubscribe: this.state.resubscribe }), function (_a) {
                    var _b, _c;
                    var data = _a.data, r = (0,tslib_es6/* __rest */._T)(_a, ["data"]);
                    if (operationOptions.withRef) {
                        _this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: _this.setWrappedInstance
                        });
                    }
                    if (shouldSkip) {
                        return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, {})));
                    }
                    var result = Object.assign(r, data || {});
                    var name = operationOptions.name || 'data';
                    var childProps = (_b = {}, _b[name] = result, _b);
                    if (operationOptions.props) {
                        var newResult = (_c = {},
                            _c[name] = result,
                            _c.ownProps = props,
                            _c);
                        lastResultProps = operationOptions.props(newResult, lastResultProps);
                        childProps = lastResultProps;
                    }
                    return (react.createElement(WrappedComponent, (0,tslib_es6/* __assign */.pi)({}, props, childProps)));
                }));
            };
            GraphQL.displayName = graphQLDisplayName;
            GraphQL.WrappedComponent = WrappedComponent;
            return GraphQL;
        }(GraphQLBase));
        return hoist_non_react_statics_cjs_default()(GraphQL, WrappedComponent, {});
    };
}

function graphql(document, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    switch ((0,react_common_esm/* parser */.E2)(document).type) {
        case react_common_esm/* DocumentType.Mutation */.n_.Mutation:
            return withMutation(document, operationOptions);
        case react_common_esm/* DocumentType.Subscription */.n_.Subscription:
            return withSubscription(document, operationOptions);
        case react_common_esm/* DocumentType.Query */.n_.Query:
        default:
            return withQuery(document, operationOptions);
    }
}

function getDisplayName$1(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
function withApollo(WrappedComponent, operationOptions) {
    if (operationOptions === void 0) { operationOptions = {}; }
    var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";
    var WithApollo = (function (_super) {
        __extends(WithApollo, _super);
        function WithApollo(props) {
            var _this = _super.call(this, props) || this;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        WithApollo.prototype.getWrappedInstance = function () {
             true ? invariant(operationOptions.withRef, 1) : 0;
            return this.wrappedInstance;
        };
        WithApollo.prototype.setWrappedInstance = function (ref) {
            this.wrappedInstance = ref;
        };
        WithApollo.prototype.render = function () {
            var _this = this;
            return (React.createElement(ApolloConsumer, null, function (client) {
                var props = Object.assign({}, _this.props, {
                    client: client,
                    ref: operationOptions.withRef
                        ? _this.setWrappedInstance
                        : undefined
                });
                return React.createElement(WrappedComponent, __assign({}, props));
            }));
        };
        WithApollo.displayName = withDisplayName;
        WithApollo.WrappedComponent = WrappedComponent;
        return WithApollo;
    }(React.Component));
    return hoistNonReactStatics(WithApollo, WrappedComponent, {});
}


//# sourceMappingURL=react-hoc.esm.js.map

// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/helpers/errorHandler.js
var errorHandler = __webpack_require__(6589);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Experiments/Treatment/SaveTreatment.graphql
var SaveTreatment_graphql = __webpack_require__(9267);
var SaveTreatment_graphql_default = /*#__PURE__*/__webpack_require__.n(SaveTreatment_graphql);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Experiments/Treatment/index.js




/**
 * If the user is LO and we have values from the Svc,
 * we can set a cookie for experimentsvc to injest
 * @param {Object} cookie
 * @return {null}
 */ var createCookie = function createCookie(cookie) {
    var _getClientEnvironment = (0,dist.getClientEnvironmentDetails)(), isBrowser = _getClientEnvironment.isBrowser;
    // no need to create a cookie if there isn't a cookie to create
    if (cookie.success === false || !cookie.name) return null;
    var name = cookie.name, maxAge = cookie.maxAge, assignments = cookie.assignments;
    if (isBrowser) {
        var host = window.location.host;
        var domain = host.replace(/^[^.]+\./g, "");
        document.cookie = "".concat(name, "=").concat(assignments, "; max-age=").concat(maxAge, "; path=/; domain=").concat(domain);
    }
    return null;
};
/**
 * Component to display a treatment
 * @param {String} when
 * @param {Object} treatments
 * @param {Boolean} control
 * @param {Function|Object} children
 * @returns {*}
 */ var Treatment = function Treatment(_ref) {
    var when = _ref.when, control = _ref.control, children = _ref.children, treatments = _ref.treatments, _ref$mutate = _ref.mutate, mutate = _ref$mutate === void 0 ? function mutate() {
        return null;
    } : _ref$mutate;
    var childElement = typeof children === "function" ? children() : children;
    var allTreatments = Object.keys(treatments);
    // If experiments fails, or the user hasn't been assigned and experiment show the control.
    if (allTreatments.length === 0 && control) {
        return childElement;
    }
    // if our treatment exists in the object
    if (allTreatments.length) {
        if (treatments[when] && treatments[when].treatmentName) {
            // send the data back to experiments that we are showing this treatment
            var _treatments$when = treatments[when], treatmentId = _treatments$when.treatmentId, experimentId = _treatments$when.experimentId, treatmentName = _treatments$when.treatmentName, experimentName = _treatments$when.experimentName, assignmentType = _treatments$when.assignmentType;
            mutate({
                variables: {
                    input: {
                        treatmentId: treatmentId,
                        treatmentName: treatmentName,
                        experimentId: experimentId,
                        experimentName: experimentName,
                        assignmentType: assignmentType
                    }
                }
            }).then(function(_ref2) {
                var data = _ref2.data;
                if (data && data.saveExperimentTreatment) createCookie(data.saveExperimentTreatment);
            }).catch(function(e) {
                return errorHandler/* errorHandler.logError */.P.logError(e, "Unable to save experiment treatment");
            });
            // Let's return the child element without waiting for the mutation as the
            // mutation doesn't really impact the children.
            return childElement;
        }
    }
    return null;
};
/* harmony default export */ var Experiments_Treatment = (graphql((SaveTreatment_graphql_default()))(Treatment)); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 1478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jf": function() { return /* binding */ HEADER_VARIANT; },
/* harmony export */   "Nt": function() { return /* binding */ HEADER_COLOR; },
/* harmony export */   "cg": function() { return /* binding */ BRAND; }
/* harmony export */ });
var HEADER_VARIANT = {
    DEFAULT: "default",
    LIMITED: "limited",
    SLIM: "slim"
};
var HEADER_COLOR = {
    PRIMARY: "primary",
    LIGHT: "light",
    TRANSPARENT: "transparent"
};
var BRAND = {
    SURVEYMONKEY: "surveymonkey",
    MOMENTIVE: "momentive"
}; //# sourceMappingURL=enums.js.map


/***/ }),

/***/ 5078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fc": function() { return /* binding */ MobileTabletScreen; },
/* harmony export */   "g7": function() { return /* binding */ DesktopScreen; },
/* harmony export */   "m6": function() { return /* binding */ TabletScreen; },
/* harmony export */   "vp": function() { return /* binding */ MobileScreen; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_media__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
var _jsxFileName = "/repo/packages/webassets/src/components/MediaComponents/index.js", _this = undefined;



var breakPoints = {
    md: 768,
    lg: 1200
};
var MOBILE_SCREEN = "(max-width: ".concat(breakPoints.md - 1, "px)");
var TABLET_SCREEN = "(min-width: ".concat(breakPoints.md, "px)");
var MOBILE_TABLET_SCREEN = "(max-width: ".concat(breakPoints.lg - 1, "px)");
var DESKTOP_SCREEN = "(min-width: ".concat(breakPoints.lg, "px)");
// add children in props validation
var MobileScreen = function MobileScreen(_ref) {
    var children = _ref.children, defaultMatches = _ref.defaultMatches;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_media__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        defaultMatches: defaultMatches,
        query: MOBILE_SCREEN,
        render: function render() {
            return children;
        },
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 18,
            columnNumber: 5
        }
    });
};
var TabletScreen = function TabletScreen(_ref2) {
    var children = _ref2.children, defaultMatches = _ref2.defaultMatches;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_media__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        defaultMatches: defaultMatches,
        query: TABLET_SCREEN,
        render: function render() {
            return children;
        },
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 28,
            columnNumber: 5
        }
    });
};
var MobileTabletScreen = function MobileTabletScreen(_ref3) {
    var children = _ref3.children, defaultMatches = _ref3.defaultMatches;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_media__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        defaultMatches: defaultMatches,
        query: MOBILE_TABLET_SCREEN,
        render: function render() {
            return children;
        },
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 37,
            columnNumber: 3
        }
    });
};
var DesktopScreen = function DesktopScreen(_ref4) {
    var children = _ref4.children, defaultMatches = _ref4.defaultMatches;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_media__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        defaultMatches: defaultMatches,
        query: DESKTOP_SCREEN,
        render: function render() {
            return children;
        },
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 45,
            columnNumber: 3
        }
    });
};
MobileScreen.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
    defaultMatches: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
MobileScreen.defaultProps = {
    defaultMatches: false
};
TabletScreen.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
    defaultMatches: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
TabletScreen.defaultProps = {
    defaultMatches: false
};
MobileTabletScreen.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
    defaultMatches: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
MobileTabletScreen.defaultProps = {
    defaultMatches: false
};
DesktopScreen.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
    defaultMatches: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
DesktopScreen.defaultProps = {
    defaultMatches: false
}; //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ Recaptcha; },
  "Z": function() { return /* reexport */ hooks_useRecaptcha; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@wds/toast/dist/index.es.js
var dist_index_es = __webpack_require__(6607);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/index.js + 265 modules
var webassets_dist = __webpack_require__(4457);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Recaptcha/hooks/useRecaptcha.js
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}


var MAX_LEN = 90;
var useRecaptcha = function useRecaptcha(_ref) {
    var greSuccessCallback = function greSuccessCallback(token) {
        setGreToken(token);
        if (successCallback) {
            successCallback(token);
        }
    };
    var greErrorCallback = function greErrorCallback(err) {
        var reason = String(err);
        var shortReason = reason.substring(0, MAX_LEN);
        webassets_dist/* clientErrorHandler.logError */.sh.logError("Unable to execute. R: ".concat(shortReason), "gre.getToken.error");
        setShowError(true);
        if (errorCallback) {
            errorCallback(err);
        }
    };
    var executeGRE = function executeGRE() {
        var captchaService = window.grecaptcha;
        if (instanceUseEnterprise) {
            captchaService = window.grecaptcha.enterprise;
        }
        captchaService.execute(instanceSiteKey, {
            action: actionName
        }).then(greSuccessCallback, greErrorCallback);
        return true;
    };
    var fireGRE = function fireGRE() {
        if (!instanceSiteKey) {
            webassets_dist/* clientErrorHandler.logError */.sh.logError("Missing site_key", "gre.fire.noSiteKey");
            return false;
        }
        executeGRE(actionName);
        return true;
    };
    var actionName = _ref.actionName, siteKey = _ref.siteKey, useEnterprise = _ref.useEnterprise, successCallback = _ref.successCallback, errorCallback = _ref.errorCallback;
    var _useState = (0,react.useState)(""), _useState2 = _slicedToArray(_useState, 2), greToken = _useState2[0], setGreToken = _useState2[1];
    var _useState3 = (0,react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), showError = _useState4[0], setShowError = _useState4[1];
    var _useContext = (0,react.useContext)(webassets_dist/* StaticContext */.vN), recaptchaV3 = _useContext.recaptchaV3;
    var instanceSiteKey = siteKey || recaptchaV3.siteKey;
    var instanceUseEnterprise = useEnterprise || recaptchaV3.useEnterprise;
    return {
        greToken: greToken,
        setGreToken: setGreToken,
        showError: showError,
        setShowError: setShowError,
        fireGRE: fireGRE
    };
};
/* harmony default export */ var hooks_useRecaptcha = (useRecaptcha); //# sourceMappingURL=useRecaptcha.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Recaptcha/index.js
var _jsxFileName = "/repo/packages/webassets/src/components/Recaptcha/index.js", _this = undefined;








var ERRORS = (0,dist/* defineMessages */.vU)({
    RECAPTCHA: {
        id: "Recaptcha.ErrorWithRecaptcha",
        defaultMessage: "Sorry, there was an error while getting the reCAPTCHA token.",
        description: "[Type: Button][Vis: High] - Error on getting reCAPTCHA token from Google"
    }
});
var Recaptcha = function Recaptcha(_ref) {
    var greToken = _ref.greToken, showError = _ref.showError, setShowError = _ref.setShowError, siteKey = _ref.siteKey, countryCode = _ref.countryCode;
    var _useContext = (0,react.useContext)(webassets_dist/* StaticContext */.vN), envCountryCode = _useContext.environment.countryCode, recaptchaV3 = _useContext.recaptchaV3;
    (0,react.useEffect)(function() {
        var script = document.createElement("script");
        var country = countryCode || envCountryCode;
        var url = country === "CN" ? recaptchaV3.urlChina : recaptchaV3.url;
        script.src = "".concat(url, "?render=").concat(siteKey || recaptchaV3.siteKey);
        script.async = true;
        script.setAttribute("data-testid", "Recaptcha_tag");
        document.body.appendChild(script);
        return function() {
            document.body.removeChild(script);
        };
    }, [
        envCountryCode,
        recaptchaV3,
        countryCode,
        siteKey
    ]);
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 50,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(index_es/* Box */.x, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("input", {
        type: "hidden",
        name: "gre_token",
        value: greToken,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 52,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement(dist_index_es/* Toast */.F, {
        show: showError,
        autoClose: true,
        dismissible: true,
        onClose: function onClose() {
            return setShowError(false);
        },
        color: "warning",
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 53,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(dist_index_es/* Toast.Title */.F.Title, {
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 60,
            columnNumber: 11
        }
    }, (0,dist.t)(ERRORS.RECAPTCHA)))));
};
Recaptcha.propTypes = {
    greToken: (prop_types_default()).string.isRequired,
    showError: (prop_types_default()).bool.isRequired,
    setShowError: (prop_types_default()).func.isRequired,
    siteKey: (prop_types_default()).string,
    countryCode: (prop_types_default()).string
};
Recaptcha.defaultProps = {
    siteKey: null,
    countryCode: null
};
 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getOverridesFromCookie, getOverridesFromQueryParameters, getOverrides */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4457);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

/**
 * Takes the cookie string from the document and returns an Array of
 * configured release toggle IDs using the key 'sm_release_toggles'.
 *
 * @param {string} cookie: Cookie string from document
 * @return {Array}
 */ var getOverridesFromCookie = function getOverridesFromCookie(cookie) {
    if (!cookie) return [];
    var found = cookie.split(";").filter(function(elem) {
        return elem;
    }).map(function(elem) {
        return elem.split("=");
    }).filter(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], val = _ref2[1];
        return key && val;
    }).map(function(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], val = _ref4[1];
        return {
            key: key.trim(),
            val: val.trim()
        };
    }).find(function(elem) {
        return elem.key === "sm_release_toggles";
    });
    var toggles = [];
    if (found) {
        found.val.split(",").forEach(function(elem) {
            toggles.push(elem.trim());
        });
    }
    return toggles;
};
/**
 * Takes a URL string from the window.location object (must include query
 * params) and returns an Array of the configured release toggle IDs under the
 * key 'smReleaseToggles'.
 *
 * @param {string} url: HREF string from the window.location object
 * @return {*}
 */ var getOverridesFromQueryParameters = function getOverridesFromQueryParameters(url) {
    if (!url) return [];
    var queryStrIndex = url.indexOf("?");
    if (queryStrIndex > -1) {
        var queryStr = url.slice(queryStrIndex + 1);
        var releaseToggles = queryStr.split("&").map(function(elem) {
            return elem.split("=");
        }).find(function(elem) {
            var _elem = _slicedToArray(elem, 1), key = _elem[0];
            return key === "smReleaseToggles";
        });
        if (releaseToggles && releaseToggles.length > 1) {
            return releaseToggles[1].split(",").filter(function(elem) {
                return elem;
            });
        }
    }
    return [];
};
/**
 * Looks for a 'sm_release_toggles' cookie. If it exists, parses out the
 * comma-separated list of toggle IDs and returns a Set of the IDs.
 *
 * @return {Set}: IDs of enabled toggles
 */ var getOverrides = function getOverrides(url, cookies) {
    // We know that this is from the Express req.
    if (typeof url === "object" && typeof cookies === "object") {
        var paramValues = (url.smReleaseToggles || "").split(",").map(function(elem) {
            return elem.trim();
        });
        var cookieValues = (cookies.sm_release_toggles || "").split(",").map(function(elem) {
            return elem.trim();
        });
        return new Set(paramValues.concat(cookieValues));
    }
    return new Set(getOverridesFromCookie(document.cookie).concat(getOverridesFromQueryParameters(window.location.href)));
};
/**
 * Component wraps code that isn't ready to be seen. Children are only
 * rendered if the 'releaseToggles' cookie or query parameter is set
 * where the value is a comma-separated list of toggle IDs
 * (IE. document.cookie="releaseToggles=ID1,ID2,ID3", whitespace is trimmed;
 * or https://localmonkey.com/my_page/?smReleaseToggles=ID1,ID2,ID3, no
 * whitespace trim) and the ID is in the list. If this component is rendered
 * on the client, these values are manually parsed from the window. If not,
 * they must be passed in through the queryParams and cookies props.
 *
 * Component may also have a child that is a function with the signature:
 * (isToggledOn: boolean) => Node which can be used to render a default
 * component in place of the feature component.
 *
 * If there is an error parsing the override cookies or params, it is caught,
 * logged and then the child function is called with false or null is returned.
 */ var ReleaseToggle = function ReleaseToggle(_ref5) {
    var toggleId = _ref5.toggleId, url = _ref5.url, cookies = _ref5.cookies, children = _ref5.children;
    var showToggle;
    try {
        showToggle = getOverrides(url, cookies).has(toggleId);
    } catch (err) {
        showToggle = false;
        // TODO: Remove this cast when clientErrorHandler has been typed
        ___WEBPACK_IMPORTED_MODULE_0__/* .clientErrorHandler.logError */ .sh.logError(err, "There was a problem reading the override cookies and params in a ReleaseToggle");
    }
    if (typeof children === "function") return children(showToggle);
    return showToggle ? children : null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (ReleaseToggle); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 6589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ errorHandler; }
/* harmony export */ });
/* unused harmony export initializeErrorHandler */
/**
 * errorHandler is a singleton which allows users to log errors and get a list of subscribers.
 * It initializes the subscribers if they haven't already been initialized and does so only
 * once per instance.
 */ var errorHandler = function handlerFactory() {
    return {
        getSubscribers: function getSubscribers() {
            return errorHandler.errorSubscribers || {};
        }
    };
}();
function initializeErrorHandler(BUGSNAG_CONFIG_PAYLOAD_KEY) {
    if (typeof errorHandler.errorSubscribers !== "undefined") {
        return;
    }
    errorHandler.errorSubscribers = {};
    if (false) {}
    if (typeof errorHandler.errorSubscribers.bugsnagClient === "undefined" && typeof window.bugsnag !== "undefined" && !window.bugsnag.initialized) {
        var config = BUGSNAG_CONFIG_PAYLOAD_KEY;
        if (config) {
            errorHandler.errorSubscribers.bugsnagClient = window.bugsnag(config);
        }
    } else if (typeof window.bugsnag !== "undefined") {
        errorHandler.errorSubscribers.bugsnagClient = window.bugsnag.client;
    }
    if (typeof errorHandler.errorSubscribers.splunkRum === "undefined" && typeof window.SplunkRum !== "undefined") {
        errorHandler.errorSubscribers.splunkRum = window.SplunkRum;
    }
    errorHandler.errorSubscribers.user = function(err, msg, metaData) {
        // eslint-disable-next-line no-console
        console.error(err.toString(), msg, metaData);
    };
}
function tellBugsnag(err, msg) {
    var metaData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    try {
        var client = errorHandler.getSubscribers().bugsnagClient;
        if (client) {
            var BugsnagReport = client.BugsnagReport;
            var handledState = {
                severity: "warning",
                unhandled: false,
                severityReason: {
                    type: "handledException"
                }
            };
            var report = new BugsnagReport(err.name, msg ? "".concat(err.message, " - ").concat(msg) : err.message, BugsnagReport.getStacktrace(err), handledState);
            report.updateMetaData("extra", metaData);
            client.notify(report);
        }
    } catch (doNothingWithError) {
        console.log(doNothingWithError); // eslint-disable-line
    }
}
function tellSplunkRum(err, msg) {
    var metaData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    try {
        var client = errorHandler.getSubscribers().splunkRum;
        if (client) {
            // This function works like console.error, so we don't really pass in
            // objects to it. If we want to capture that info, we need to pass it in
            // as a string; thus the JSON.stringify so we don't lose granularity.
            client.error(err, msg, JSON.stringify(metaData));
        }
    } catch (doNothingWithError) {
        // eslint-disable-next-line no-console
        console.log(doNothingWithError);
    }
}
function tellUser(err, msg, metaData) {
    var client = errorHandler.getSubscribers().user;
    if (client) {
        client(err, msg, metaData);
    }
}
/**
 *
 * @param {Error} err - Error object
 * @param {string} msg - {optional extra message}
 * @param {Object} metaData - [optional metadata object]
 */ errorHandler.logError = function logError(err) {
    if (!err) return;
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    var message = rest[0], metaData = rest[1];
    if (typeof rest[0] === "object" && rest.length === 1) {
        message = null;
        metaData = rest[0];
    }
    tellBugsnag(err, message, metaData);
    tellSplunkRum(err, message, metaData);
    tellUser(err, message, metaData);
}; //# sourceMappingURL=errorHandler.js.map


/***/ }),

/***/ 4457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tM": function() { return /* reexport */ components_CookieBanner; },
  "g7": function() { return /* reexport */ MediaComponents/* DesktopScreen */.g7; },
  "hW": function() { return /* reexport */ components_ErrorController; },
  "BR": function() { return /* reexport */ MobileBanner_MobileBanner; },
  "vp": function() { return /* reexport */ MediaComponents/* MobileScreen */.vp; },
  "fc": function() { return /* reexport */ MediaComponents/* MobileTabletScreen */.fc; },
  "ol": function() { return /* reexport */ components_Footer; },
  "mc": function() { return /* reexport */ components_Header; },
  "qp": function() { return /* reexport */ components_SessionTimeoutModal; },
  "vN": function() { return /* reexport */ components_StaticContext/* StaticContext */.vN; },
  "sh": function() { return /* reexport */ errorHandler/* errorHandler */.P; },
  "SS": function() { return /* reexport */ getHelpLink_getHelpCenterLink; }
});

// UNUSED EXPORTS: AccountCard, Autocomplete, BasePage, BrowserGuard, CaptiveWindow, ClientError, ClientErrorLinks, ClientErrorPage, ClientErrorSignup, ErrorBoundary, ErrorCard, ExperimentProvider, FiveHundredError, FiveHundredErrorPage, ForbiddenError, FourHundredError, FourHundredErrorPage, FourOhFourError, FourOhFourErrorPage, FourTenError, FourTenErrorPage, GlobalThemeProvider, Helmet, HelmetProvider, Logo, LogoWithText, Recaptcha, ReleaseToggle, SPAPageContent, SeatRequestModal, SkeletonLoader, StaticConsumer, StaticProvider, SurveyTheme, SurveyThemeProvider, TabletScreen, Treatment, WebAssetsTheme, WebAssetsThemeProvider, createSurveyStyles, getFontWeights, getHelpLink, getHelpLinkLangFromCode, getMyTeamMenuItems, getPackageName, initializeClientErrorHandler, theming, useExperiment, useRecaptcha, useSurveyTheme, withClientErrorPage

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/StaticContext/index.js
var components_StaticContext = __webpack_require__(6787);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var src_type_of = __webpack_require__(2222);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/OnScroll.js


function _classCallCheck(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
    } else if (call !== void 0) {
        throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}


var OnScroll = /*#__PURE__*/ function(_Component) {
    _inherits(OnScroll, _Component);
    var _super = _createSuper(OnScroll);
    function OnScroll() {
        var _this;
        _classCallCheck(this, OnScroll);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            x: 0,
            y: 0
        };
        _this.handleScroll = function() {
            _this.setState({
                x: window.scrollX,
                y: window.scrollY
            });
        };
        return _this;
    }
    _createClass(OnScroll, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("scroll", this.handleScroll);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.render(this.state.x, this.state.y);
            }
        }
    ]);
    return OnScroll;
}(react.Component);
OnScroll.propTypes = {
    render: (prop_types_default()).func
};
OnScroll.defaultProps = {
    render: null
};
/* harmony default export */ var Header_OnScroll = (OnScroll); //# sourceMappingURL=OnScroll.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/SMHeaderContext.js

var SMHeaderContext_SMHeaderContext = /*#__PURE__*/ (0,react.createContext)({});
/* harmony default export */ var Header_SMHeaderContext = (SMHeaderContext_SMHeaderContext); //# sourceMappingURL=SMHeaderContext.js.map

// EXTERNAL MODULE: ./node_modules/@sm/utils/dist/index.js
var dist = __webpack_require__(7351);
// EXTERNAL MODULE: ./node_modules/@sm/intl/dist/index.js
var intl_dist = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/@sm/metrics/dist/index.js
var metrics_dist = __webpack_require__(6431);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/MediaComponents/index.js
var MediaComponents = __webpack_require__(5078);
// EXTERNAL MODULE: ./node_modules/@sm/wds-react/dist/wds-react.js
var wds_react = __webpack_require__(370);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/LogInCTA/index.js
var _jsxFileName = "/repo/packages/webassets/src/components/Header/components/LogInCTA/index.js", _this = undefined;





var LogInCTA_COPY = (0,intl_dist/* defineMessages */.vU)({
    LOG_IN: {
        id: "LogInCTA.logInButton",
        defaultMessage: "LOG IN",
        description: "[Type: Label][Vis.: high] - This is the LogIn button on the header."
    }
});
var LogInCTA = function LogInCTA(_ref) {
    var variant = _ref.variant, size = _ref.size, color = _ref.color, className = _ref.className, stretched = _ref.stretched, params = _ref.params;
    return /*#__PURE__*/ react.createElement(wds_react.Button, {
        "data-testid": "LogInCTA__Btn",
        variant: variant,
        size: size,
        color: color,
        stretched: stretched,
        className: className,
        href: (0,dist.createURL)("/login", params),
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 25,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: LogInCTA_COPY.LOG_IN,
        __self: _this,
        __source: {
            fileName: _jsxFileName,
            lineNumber: 34,
            columnNumber: 7
        }
    }));
};
LogInCTA.propTypes = {
    variant: (prop_types_default()).string,
    size: (prop_types_default()).string,
    color: (prop_types_default()).string,
    stretched: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    params: prop_types_default().oneOfType([
        (prop_types_default()).object
    ])
};
LogInCTA.defaultProps = {
    variant: "text",
    size: "sm",
    color: "secondary",
    stretched: false,
    className: "",
    params: null
};
/* harmony default export */ var components_LogInCTA = (LogInCTA); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/SignUpCTA/index.js
var SignUpCTA_jsxFileName = "/repo/packages/webassets/src/components/Header/components/SignUpCTA/index.js", SignUpCTA_this = undefined;





var SignUpCTA_COPY = (0,intl_dist/* defineMessages */.vU)({
    SIGN_UP: {
        id: "SignUpCTA.signUpButton",
        defaultMessage: "Sign Up",
        description: "[Type: Label][Vis.: high] - This is the Sign Up button on the header."
    }
});
var SignUpCTA = function SignUpCTA(_ref) {
    var variant = _ref.variant, size = _ref.size, color = _ref.color, stretched = _ref.stretched, className = _ref.className, params = _ref.params;
    return /*#__PURE__*/ react.createElement(wds_react.Button, {
        "data-testid": "SignUpCTA__Btn",
        variant: variant,
        size: size,
        color: color,
        stretched: stretched,
        className: className,
        href: (0,dist.createURL)("/sign-up/", params),
        __self: SignUpCTA_this,
        __source: {
            fileName: SignUpCTA_jsxFileName,
            lineNumber: 25,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SignUpCTA_COPY.SIGN_UP,
        __self: SignUpCTA_this,
        __source: {
            fileName: SignUpCTA_jsxFileName,
            lineNumber: 34,
            columnNumber: 7
        }
    }));
};
SignUpCTA.propTypes = {
    variant: (prop_types_default()).string,
    size: (prop_types_default()).string,
    color: (prop_types_default()).string,
    stretched: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    params: prop_types_default().oneOfType([
        (prop_types_default()).object
    ])
};
SignUpCTA.defaultProps = {
    variant: "ghost",
    size: "sm",
    color: "alt",
    stretched: false,
    className: "",
    params: null
};
/* harmony default export */ var components_SignUpCTA = (SignUpCTA); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@apollo/react-hooks/lib/react-hooks.esm.js
var react_hooks_esm = __webpack_require__(8499);
// EXTERNAL MODULE: ./node_modules/@wds/modal/dist/index.es.js
var index_es = __webpack_require__(2304);
// EXTERNAL MODULE: ./node_modules/@wds/toast/dist/index.es.js
var dist_index_es = __webpack_require__(6607);
// EXTERNAL MODULE: ./node_modules/@wds/button/dist/index.es.js + 1 modules
var button_dist_index_es = __webpack_require__(7837);
// EXTERNAL MODULE: ./node_modules/@wds/utils/dist/index.es.js
var utils_dist_index_es = __webpack_require__(5420);
;// CONCATENATED MODULE: ./node_modules/@wds/link/dist/index.es.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (_a) {
    var palette = _a.palette, type = _a.type;
    return ({
        wrenchLink: function (_a) {
            var color = _a.color, underline = _a.underline;
            return ({
                fontFamily: type.fontFamily.base,
                '-webkit-font-smoothing': 'antialiased',
                color: color === 'light' ? palette.text.light : palette.text.link,
                border: 'none',
                background: 'none',
                fontWeight: 'inherit',
                fontSize: 'inherit',
                cursor: 'pointer',
                textDecoration: underline ? 'underline' : 'none',
                '&:hover, &:focus': {
                    textDecoration: underline ? 'none' : 'underline',
                },
            });
        },
    });
});

var Link = function (_a) {
    var children = _a.children, color = _a.color, _b = _a.underline, underline = _b === void 0 ? true : _b, rest = __rest(_a, ["children", "color", "underline"]);
    var wrenchLink = index_es_useStyles({ color: color, underline: underline }).wrenchLink;
    return (react.createElement("a", __assign({ className: wrenchLink }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)), children));
};

var LINK_COLORS = (/* unused pure expression or super */ null && (['light', 'dark']));



// EXTERNAL MODULE: ./node_modules/@wds/label/dist/index.es.js
var label_dist_index_es = __webpack_require__(2129);
// EXTERNAL MODULE: ./node_modules/theming/dist/theming.esm.js
var theming_esm = __webpack_require__(1928);
// EXTERNAL MODULE: ./node_modules/@wds/styles/dist/index.es.js
var styles_dist_index_es = __webpack_require__(4779);
;// CONCATENATED MODULE: ./node_modules/@wds/textarea/dist/index.es.js






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var index_es_assign = function() {
    index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return index_es_assign.apply(this, arguments);
};

function index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var dist_index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette, spacing = theme.spacing, radius = theme.radius, shadow = theme.shadow, type = theme.type;
    var textarea = {
        fontSize: type.fontSize.body,
        paddingSm: spacing[2],
        paddingMd: spacing[3],
        paddingLg: spacing[4],
        borderRadius: radius.small,
    };
    return {
        wrenchTextarea: function (_a) {
            var color = _a.color, size = _a.size, stretched = _a.stretched, disabled = _a.disabled;
            var padding = function (s) {
                return {
                    sm: textarea.paddingSm,
                    md: textarea.paddingMd,
                    lg: textarea.paddingLg,
                }[s !== null && s !== void 0 ? s : 'md'];
            };
            return {
                width: stretched ? '100%' : null,
                padding: padding(size),
                boxSizing: 'border-box',
                margin: 0,
                border: "solid 1px ".concat((0,styles_dist_index_es/* getColor */.Lq)(palette, color, {
                    fallback: palette.border.main,
                })),
                borderRadius: textarea.borderRadius,
                color: palette.text.dark,
                fontFamily: type.fontFamily.base,
                outline: 'none',
                '-webkit-appearance': 'none',
                '-webkit-font-smoothing': 'antialiased',
                '-moz-appearance': 'none',
                '-ms-appearance': 'none',
                appearance: 'none',
                boxShadow: 'none',
                backgroundColor: palette.background.light,
                fontSize: textarea.fontSize,
                pointerEvents: disabled ? 'none' : 'auto',
                opacity: disabled ? '0.4' : '1',
                '&:hover': {
                    borderColor: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, {
                        fallback: palette.border.hover,
                    }),
                    boxShadow: shadow.sky,
                },
                '&:focus': {
                    borderColor: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, {
                        fallback: palette.border.active,
                    }),
                },
            };
        },
    };
});

var Textarea = function (_a) {
    var _b = _a.value, value = _b === void 0 ? undefined : _b, _c = _a.color, color = _c === void 0 ? undefined : _c, _d = _a.label, label = _d === void 0 ? undefined : _d, _e = _a.onBlur, onBlur = _e === void 0 ? undefined : _e, _f = _a.onChange, onChange = _f === void 0 ? undefined : _f, _g = _a.id, id = _g === void 0 ? undefined : _g; _a.ariaLabel; var _j = _a.name, name = _j === void 0 ? undefined : _j, _k = _a.stretched, stretched = _k === void 0 ? false : _k, _l = _a.size, size = _l === void 0 ? 'md' : _l, _m = _a.disabled, disabled = _m === void 0 ? false : _m, rest = index_es_rest(_a, ["value", "color", "label", "onBlur", "onChange", "id", "ariaLabel", "name", "stretched", "size", "disabled"]);
    (0,utils_dist_index_es/* deprecate */.Rn)({ color: color }, 'color', 'warning', 'Textarea');
    var _o = (0,react.useState)(value), val = _o[0], setVal = _o[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var isControlled$1 = (0,react.useMemo)(function () { return (0,utils_dist_index_es/* isControlled */.sI)(value); }, []);
    var inputID = (0,react.useMemo)(function () { return id !== null && id !== void 0 ? id : (0,utils_dist_index_es/* uniqueId */.EL)('textarea'); }, [id]);
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var wrenchTextarea = dist_index_es_useStyles({
        color: color,
        size: size,
        stretched: stretched,
        disabled: disabled,
        theme: theme,
    }).wrenchTextarea;
    var handleBlur = function (e) {
        if (onBlur)
            onBlur(e);
    };
    var handleChange = function (e) {
        if (isControlled$1 && e.target.value !== val) {
            e.persist();
            setVal(e.target.value);
            if (onChange)
                onChange(e);
        }
    };
    return (react.createElement(react.Fragment, null,
        label && react.createElement(label_dist_index_es/* Label */._, { htmlFor: inputID }, label),
        react.createElement("textarea", index_es_assign({ className: wrenchTextarea, id: inputID, name: name, onBlur: handleBlur, onChange: handleChange, value: val }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)))));
};



// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/graphql/CreateSeatRequest.graphql
var CreateSeatRequest_graphql = __webpack_require__(4202);
var CreateSeatRequest_graphql_default = /*#__PURE__*/__webpack_require__.n(CreateSeatRequest_graphql);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/SeatRequestCopy.js

/* harmony default export */ var SeatRequestCopy = ((0,intl_dist/* defineMessages */.vU)({
    MODAL_TITLE_PENDING: {
        id: "SeatRequestCopy.RequestPending",
        defaultMessage: "Request pending",
        description: "[Type: Header][Vis: med] - Team invite request pending"
    },
    MODAL_TITLE_AVAILABLE: {
        id: "SeatRequestCopy.RequestAvailable",
        defaultMessage: "Request Power seat",
        description: "[Type: Header][Vis: med] - Team invite request pending"
    },
    MODAL_TITLE_NOT_AVAILABLE: {
        id: "SeatRequestCopy.RequestUnavailable",
        defaultMessage: "Request Unavailable",
        description: "[Type: Header][Vis: med] - Team invite request pending"
    },
    REQUEST_DESC_1: {
        id: "SeatRequestCopy.RequestDesc1",
        defaultMessage: "You have a Casual seat",
        description: "[Type: Header][Vis: med] - Team invite request pending"
    },
    REQUEST_DESC_2: {
        id: "SeatRequestCopy.RequestDesc2",
        defaultMessage: 'To unlock features like unlimited questions, logic, and exporting results, request a Power seat. <span id="help-link">Compare features</span>',
        description: "[Type: Label][Vis: med] - Team invite request empty state message"
    },
    REQUEST_DESC_2_ALLOW_EXPORT: {
        id: "SeatRequestCopy.RequestDesc2AllowExport",
        defaultMessage: 'To collaborate with Power Users, and unlock features like unlimited questions and logic, request a Power seat. <span id="help-link">Compare features</span>',
        description: "[Type: Label][Vis: med] - Team invite request empty state message if Casual is allowed to export"
    },
    REASON_LABEL: {
        id: "SeatRequestCopy.ReasonLabel",
        defaultMessage: "Message to your admin (optional)",
        description: "[Type: Label][Vis: med] - label next to text box for users to specify a reason for their request"
    },
    PENDING_DESC_1: {
        id: "SeatRequestCopy.PendingDesc1",
        defaultMessage: "Request sent: {date}",
        description: "[Type: Label][Vis: med] - field describing when a request was sent"
    },
    PENDING_DESC_2: {
        id: "SeatRequestCopy.PendingDesc2",
        defaultMessage: "Your Power seat request is pending admin review. If you need it soon, send your admin a reminder. If you no longer need it, you can cancel your request.",
        description: "[Type: Label][Vis: med] - Team invite request empty state message"
    },
    PENDING_DESC_3: {
        id: "SeatRequestCopy.PendingDesc3",
        defaultMessage: 'Primary Admin: <span id="email"></span>',
        description: "[Type: Label][Vis: med] - Team invite request empty state message"
    },
    NOT_AVAILABLE_DESC_1: {
        id: "SeatRequestCopy.NotAvailableDesc1",
        defaultMessage: "Seat upgrade is not available for your account.",
        description: "[Type: Paragraph][Vis: med] - "
    },
    NOT_AVAILABLE_DESC_2: {
        id: "SeatRequestCopy.NotAvailableDesc2",
        defaultMessage: 'Please contact your primary admin: <span id="email"></span>',
        description: "[Type: Paragraph][Vis: med] - "
    },
    SEND_BUTTON: {
        id: "SeatRequestCopy.SendButton",
        defaultMessage: "Send request",
        description: "[Type: Label][Vis: high] - Button label for sending request"
    },
    CANCEL_BUTTON: {
        id: "SeatRequestCopy.CancelButton",
        defaultMessage: "Cancel",
        description: "[Type: Label][Vis: med] - Button label for close request modal dialog"
    },
    CANCEL_REQUEST_BUTTON: {
        id: "SeatRequestCopy.CancelRequestButton",
        defaultMessage: "Cancel Request",
        description: "[Type: Label][Vis: med] - Button label for cancelling request"
    },
    SEND_REMINDER_BUTTON: {
        id: "SeatRequestCopy.SendReminderButton",
        defaultMessage: "Send Reminder",
        description: "[Type: Button][Vis: med] - Button label to send a reminder."
    },
    CLOSE_BUTTON: {
        id: "SeatRequestCopy.CloseButton",
        defaultMessage: "Close",
        description: "[Type: Button][Vis: med] - Button label to send a reminder."
    },
    TOAST_REQUEST_SENT: {
        id: "SeatRequestCopy.ToastRequestSent",
        defaultMessage: "Request sent",
        description: "[Type: Toast][Vis: low] - request success toast"
    },
    TOAST_REQUEST_CANCELED: {
        id: "SeatRequestCopy.ToastRequestCanceled",
        defaultMessage: "Request canceled",
        description: "[Type: Toast][Vis: low] - request success cancelled toast"
    },
    TOAST_REMINDER_SENT: {
        id: "SeatRequestCopy.ToastReminderSent",
        defaultMessage: "Reminder sent",
        description: "[Type: Toast][Vis: low] - request reminder sent successfully toast"
    },
    TOAST_ERROR: {
        id: "SeatRequestCopy.ToastError",
        defaultMessage: "Request error - refresh the page and try again",
        description: "[Type: Toast][Vis: low] - request failed error toast"
    }
})); //# sourceMappingURL=SeatRequestCopy.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/constants.js
var STATUS = Object.freeze({
    SUCCESS: "success",
    FAILURE: "failure"
});
var CASUAL_USER_ALLOW_EXPORT = "73"; //# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@sm/locale/dist/index.js
var locale_dist = __webpack_require__(7776);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/helpers/getHelpLink.js


/**
 *
 * @deprecated - The helpLink language codes are not used for the new help center. Instead directly use the regular language code.
 */ var getHelpLinkLangFromCode = function getHelpLinkLangFromCode(lang) {
    var helpLink = LANGUAGES_BY_CODE[lang] && LANGUAGES_BY_CODE[lang].helplink;
    var defaultHelpLink = LANGUAGES_BY_CODE.en.helplink;
    return helpLink || defaultHelpLink;
};
/**
 * @deprecated - please use getHelpCenterLink instead
 */ var getHelpLink = function getHelpLink(lang) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var userData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var helpLang = getHelpLinkLangFromCode(lang);
    var domain = "https://help.surveymonkey.com";
    var articlePath = options.articlePath, params = options.params;
    var helpName = options.helpName, featurePath = options.featurePath, fragment = options.fragment;
    if (!articlePath) articlePath = "articles";
    if (!params) params = {};
    var path = "".concat(domain, "/").concat(articlePath, "/").concat(helpLang, "/kb/").concat(helpName);
    if (featurePath) {
        path = "".concat(domain, "/").concat(featurePath);
        params.l = helpLang;
    } else if (!helpName) {
        path = "".concat(domain, "/");
        params.l = helpLang;
    }
    // add user info if available
    var id = userData.id, username = userData.username, packageId = userData.packageId, datacenterId = userData.datacenterId;
    if (id && username && packageId && datacenterId) {
        var userDataString = "p__userid=".concat(id, "&p__username=").concat(username, "&p__packageid=").concat(packageId, "&p__datacenter=").concat(datacenterId);
        // TODO: encrypt the `userDataString` before adding to the url! (WEBPLAT-793)
        Object.assign(params, {
            uid: userDataString
        });
    }
    var url = createURL(path, params);
    if (fragment) {
        url = "".concat(url, "#").concat(fragment);
    }
    return url;
};
var getHelpLink_getHelpCenterLink = function getHelpCenterLink(lang) {
    var _LANGUAGES_BY_CODE$la;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var path = options.path, params = options.params, fragment = options.fragment;
    var helpLang;
    if ((_LANGUAGES_BY_CODE$la = locale_dist/* LANGUAGES_BY_CODE */.p_[lang]) !== null && _LANGUAGES_BY_CODE$la !== void 0 && _LANGUAGES_BY_CODE$la.helpCenterLangCode) {
        var _LANGUAGES_BY_CODE$la2;
        helpLang = (_LANGUAGES_BY_CODE$la2 = locale_dist/* LANGUAGES_BY_CODE */.p_[lang]) === null || _LANGUAGES_BY_CODE$la2 === void 0 ? void 0 : _LANGUAGES_BY_CODE$la2.helpCenterLangCode;
    } else if (lang === "jp") {
        // 'jp' is special because it also maps so the 'ja' language but not in our language mapping
        helpLang = "ja";
    } else {
        helpLang = "en"; // for all other languages, it will use English
    }
    var domain = "https://help.surveymonkey.com";
    var fullPath = "".concat(domain, "/").concat(helpLang, "/");
    if (path) {
        fullPath += "".concat(path, "/");
    }
    var url = (0,dist.createURL)(fullPath, params);
    if (fragment) {
        url = "".concat(url, "#").concat(fragment);
    }
    return url;
};
/* harmony default export */ var helpers_getHelpLink = ((/* unused pure expression or super */ null && (getHelpLink)));
 //# sourceMappingURL=getHelpLink.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/RequestModalContent.js
var RequestModalContent_jsxFileName = "/repo/packages/webassets/src/components/SeatRequestModal/RequestModalContent.js", RequestModalContent_this = undefined;
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}













var MAX_MESSAGE_LENGTH = 400;
var useArticleHelpLink = function useArticleHelpLink(path) {
    var staticContext = (0,react.useContext)(components_StaticContext/* StaticContext */.vN);
    return getHelpLink_getHelpCenterLink(staticContext === null || staticContext === void 0 ? void 0 : staticContext.user.language, {
        path: path
    });
};
var LinkRenderer = function LinkRenderer(link) {
    var newTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function(_ref) {
        var children = _ref.children;
        return /*#__PURE__*/ react.createElement(Link, {
            target: newTab ? "_blank" : undefined,
            rel: newTab ? "noreferrer noopener" : undefined,
            href: link,
            __self: RequestModalContent_this,
            __source: {
                fileName: RequestModalContent_jsxFileName,
                lineNumber: 27,
                columnNumber: 3
            }
        }, children);
    };
};
LinkRenderer.propTypes = {
    newTab: (prop_types_default()).bool.isRequired,
    helpLink: (prop_types_default()).string.isRequired
};
var RequestModalContent = function RequestModalContent(_ref2) {
    var onModalFinished = _ref2.onModalFinished, sourceCategoryKey = _ref2.sourceCategoryKey, sourceFeatureKey = _ref2.sourceFeatureKey, isCasualUserAllowExport = _ref2.isCasualUserAllowExport;
    var _useState = (0,react.useState)(""), _useState2 = _slicedToArray(_useState, 2), reason = _useState2[0], setReason = _useState2[1];
    var _useMutation = (0,react_hooks_esm/* useMutation */.Db)((CreateSeatRequest_graphql_default()), {
        onError: function onError() {
            onModalFinished({
                status: STATUS.FAILURE,
                message: (0,intl_dist.t)(SeatRequestCopy.TOAST_ERROR)
            });
        },
        onCompleted: function onCompleted() {
            setReason("");
            onModalFinished({
                status: STATUS.SUCCESS,
                message: (0,intl_dist.t)(SeatRequestCopy.TOAST_REQUEST_SENT)
            });
        }
    }), _useMutation2 = _slicedToArray(_useMutation, 2), createSeatRequest = _useMutation2[0], loading = _useMutation2[1].loading;
    var onSubmit = function onSubmit() {
        createSeatRequest({
            variables: {
                input: {
                    seatType: "POWER_USER",
                    reason: reason.length > 0 ? reason : null,
                    sourceCategoryKey: sourceCategoryKey,
                    sourceFeatureKey: sourceFeatureKey
                }
            }
        });
    };
    var helpLink = useArticleHelpLink("teams/enterprise-seats");
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(index_es/* Modal.Header */.u.Header, {
        header: /*#__PURE__*/ react.createElement(intl_dist.T, {
            desc: SeatRequestCopy.MODAL_TITLE_AVAILABLE,
            __self: RequestModalContent_this,
            __source: {
                fileName: RequestModalContent_jsxFileName,
                lineNumber: 83,
                columnNumber: 29
            }
        }),
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 83,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Modal.Body */.u.Body, {
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 84,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("p", {
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 85,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("b", {
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 86,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.REQUEST_DESC_1,
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 87,
            columnNumber: 13
        }
    }))), /*#__PURE__*/ react.createElement("p", {
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 90,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: isCasualUserAllowExport ? SeatRequestCopy.REQUEST_DESC_2_ALLOW_EXPORT : SeatRequestCopy.REQUEST_DESC_2,
        values: {
            "help-link": LinkRenderer(helpLink, true)
        },
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 91,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(Textarea, {
        label: (0,intl_dist.t)(SeatRequestCopy.REASON_LABEL),
        value: reason,
        maxLength: MAX_MESSAGE_LENGTH,
        onChange: function onChange(e) {
            return setReason(e.target.value);
        },
        stretched: true,
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 102,
            columnNumber: 9
        }
    })), /*#__PURE__*/ react.createElement(index_es/* Modal.Footer */.u.Footer, {
        align: "right",
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 110,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        variant: "ghost",
        color: "secondary",
        disabled: loading,
        onClick: onModalFinished,
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 111,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.CANCEL_BUTTON,
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 117,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        onClick: onSubmit,
        disabled: loading,
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 119,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.SEND_BUTTON,
        __self: RequestModalContent_this,
        __source: {
            fileName: RequestModalContent_jsxFileName,
            lineNumber: 120,
            columnNumber: 11
        }
    }))));
};
RequestModalContent.propTypes = {
    onModalFinished: (prop_types_default()).func.isRequired,
    sourceCategoryKey: (prop_types_default()).string.isRequired,
    sourceFeatureKey: (prop_types_default()).string,
    isCasualUserAllowExport: (prop_types_default()).bool
};
RequestModalContent.defaultProps = {
    sourceFeatureKey: null,
    isCasualUserAllowExport: false
};
/* harmony default export */ var SeatRequestModal_RequestModalContent = (RequestModalContent); //# sourceMappingURL=RequestModalContent.js.map

// EXTERNAL MODULE: ./node_modules/@wds/box/dist/index.es.js
var box_dist_index_es = __webpack_require__(1743);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/graphql/CancelSeatRequest.graphql
var CancelSeatRequest_graphql = __webpack_require__(307);
var CancelSeatRequest_graphql_default = /*#__PURE__*/__webpack_require__.n(CancelSeatRequest_graphql);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/graphql/RemindSeatRequest.graphql
var RemindSeatRequest_graphql = __webpack_require__(8571);
var RemindSeatRequest_graphql_default = /*#__PURE__*/__webpack_require__.n(RemindSeatRequest_graphql);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/PendingModalContent.js
var PendingModalContent_jsxFileName = "/repo/packages/webassets/src/components/SeatRequestModal/PendingModalContent.js", PendingModalContent_this = undefined;
function PendingModalContent_slicedToArray(arr, i) {
    return PendingModalContent_arrayWithHoles(arr) || PendingModalContent_iterableToArrayLimit(arr, i) || PendingModalContent_unsupportedIterableToArray(arr, i) || PendingModalContent_nonIterableRest();
}
function PendingModalContent_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PendingModalContent_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PendingModalContent_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PendingModalContent_arrayLikeToArray(o, minLen);
}
function PendingModalContent_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function PendingModalContent_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function PendingModalContent_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}











var PendingModalContent = function PendingModalContent(_ref) {
    var onModalFinished = _ref.onModalFinished, seatRequest = _ref.seatRequest, team = _ref.team;
    var _useMutation = (0,react_hooks_esm/* useMutation */.Db)((CancelSeatRequest_graphql_default()), {
        onError: function onError() {
            onModalFinished({
                status: STATUS.FAILURE,
                message: (0,intl_dist.t)(SeatRequestCopy.TOAST_ERROR)
            });
        },
        onCompleted: function onCompleted() {
            onModalFinished({
                status: STATUS.SUCCESS,
                message: (0,intl_dist.t)(SeatRequestCopy.TOAST_REQUEST_CANCELED)
            });
        }
    }), _useMutation2 = PendingModalContent_slicedToArray(_useMutation, 2), cancelSeatRequest = _useMutation2[0], cancelLoading = _useMutation2[1].loading;
    var _useMutation3 = (0,react_hooks_esm/* useMutation */.Db)((RemindSeatRequest_graphql_default()), {
        onError: function onError() {
            onModalFinished({
                status: STATUS.FAILURE,
                message: (0,intl_dist.t)(SeatRequestCopy.TOAST_ERROR)
            });
        },
        onCompleted: function onCompleted() {
            onModalFinished({
                status: STATUS.SUCCESS,
                message: (0,intl_dist.t)(SeatRequestCopy.TOAST_REMINDER_SENT)
            });
        }
    }), _useMutation4 = PendingModalContent_slicedToArray(_useMutation3, 2), remindSeatRequest = _useMutation4[0], remindLoading = _useMutation4[1].loading;
    var _team$accountOwner = team.accountOwner, _email = _team$accountOwner.email, firstName = _team$accountOwner.firstName, lastName = _team$accountOwner.lastName;
    var emailLabel = firstName ? "".concat(firstName).concat(lastName ? "\xa0".concat(lastName) : "") : _email;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(index_es/* Modal.Header */.u.Header, {
        header: /*#__PURE__*/ react.createElement(intl_dist.T, {
            desc: SeatRequestCopy.MODAL_TITLE_PENDING,
            __self: PendingModalContent_this,
            __source: {
                fileName: PendingModalContent_jsxFileName,
                lineNumber: 56,
                columnNumber: 29
            }
        }),
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 56,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Modal.Body */.u.Body, {
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 57,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("p", {
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 58,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.PENDING_DESC_1,
        values: {
            date: (0,intl_dist/* FormattedDateTime */.k7)({
                date: new Date(seatRequest.request.date)
            })
        },
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 59,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("p", {
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 68,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.PENDING_DESC_2,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 69,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("p", {
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 71,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.PENDING_DESC_3,
        values: {
            email: function email() {
                return /*#__PURE__*/ react.createElement("a", {
                    href: "mailto:".concat(_email),
                    __self: PendingModalContent_this,
                    __source: {
                        fileName: PendingModalContent_jsxFileName,
                        lineNumber: 75,
                        columnNumber: 28
                    }
                }, emailLabel);
            }
        },
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 72,
            columnNumber: 11
        }
    }))), /*#__PURE__*/ react.createElement(index_es/* Modal.Footer */.u.Footer, {
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 80,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        flexDirection: "row",
        display: "flex",
        flexJustify: "space-between",
        flexItemGrow: 1,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 81,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("div", {
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 87,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        variant: "ghost",
        color: "warning",
        onClick: cancelSeatRequest,
        disabled: remindLoading || cancelLoading,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 88,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.CANCEL_REQUEST_BUTTON,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 94,
            columnNumber: 15
        }
    }))), /*#__PURE__*/ react.createElement("div", {
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 97,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        onClick: remindSeatRequest,
        color: "secondary",
        disabled: remindLoading || cancelLoading,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 98,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.SEND_REMINDER_BUTTON,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 103,
            columnNumber: 15
        }
    })), "\xa0", /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        onClick: onModalFinished,
        disabled: remindLoading || cancelLoading,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 106,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.CLOSE_BUTTON,
        __self: PendingModalContent_this,
        __source: {
            fileName: PendingModalContent_jsxFileName,
            lineNumber: 110,
            columnNumber: 15
        }
    }))))));
};
PendingModalContent.propTypes = {
    onModalFinished: (prop_types_default()).func.isRequired,
    seatRequest: prop_types_default().shape({
        request: prop_types_default().shape({
            date: (prop_types_default()).string.isRequired
        }).isRequired
    }).isRequired,
    team: prop_types_default().shape({
        accountOwner: prop_types_default().shape({
            email: (prop_types_default()).string.isRequired,
            firstName: (prop_types_default()).string,
            lastName: (prop_types_default()).string
        }).isRequired
    }).isRequired
};
/* harmony default export */ var SeatRequestModal_PendingModalContent = (PendingModalContent); //# sourceMappingURL=PendingModalContent.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/NotAvailableModalContent.js
var NotAvailableModalContent_jsxFileName = "/repo/packages/webassets/src/components/SeatRequestModal/NotAvailableModalContent.js", NotAvailableModalContent_this = undefined;






var NotAvailableModalContent = function NotAvailableModalContent(_ref) {
    var onModalFinished = _ref.onModalFinished, team = _ref.team;
    var _team$accountOwner = team.accountOwner, _email = _team$accountOwner.email, firstName = _team$accountOwner.firstName, lastName = _team$accountOwner.lastName;
    var emailLabel = firstName ? "".concat(firstName).concat(lastName ? "\xa0".concat(lastName) : "") : _email;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(index_es/* Modal.Header */.u.Header, {
        header: /*#__PURE__*/ react.createElement(intl_dist.T, {
            desc: SeatRequestCopy.MODAL_TITLE_NOT_AVAILABLE,
            __self: NotAvailableModalContent_this,
            __source: {
                fileName: NotAvailableModalContent_jsxFileName,
                lineNumber: 15,
                columnNumber: 29
            }
        }),
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 15,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Modal.Body */.u.Body, {
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 16,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("p", {
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 17,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.NOT_AVAILABLE_DESC_1,
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 18,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("p", {
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 20,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.NOT_AVAILABLE_DESC_2,
        values: {
            email: function email() {
                return /*#__PURE__*/ react.createElement("a", {
                    href: "mailto:".concat(_email),
                    __self: NotAvailableModalContent_this,
                    __source: {
                        fileName: NotAvailableModalContent_jsxFileName,
                        lineNumber: 24,
                        columnNumber: 28
                    }
                }, emailLabel);
            }
        },
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 21,
            columnNumber: 11
        }
    }))), /*#__PURE__*/ react.createElement(index_es/* Modal.Footer */.u.Footer, {
        align: "right",
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 29,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        onClick: onModalFinished,
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 30,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SeatRequestCopy.CLOSE_BUTTON,
        __self: NotAvailableModalContent_this,
        __source: {
            fileName: NotAvailableModalContent_jsxFileName,
            lineNumber: 31,
            columnNumber: 11
        }
    }))));
};
NotAvailableModalContent.propTypes = {
    onModalFinished: (prop_types_default()).func.isRequired,
    team: prop_types_default().shape({
        accountOwner: prop_types_default().shape({
            email: (prop_types_default()).string.isRequired,
            firstName: (prop_types_default()).string,
            lastName: (prop_types_default()).string
        }).isRequired
    }).isRequired
};
/* harmony default export */ var SeatRequestModal_NotAvailableModalContent = (NotAvailableModalContent); //# sourceMappingURL=NotAvailableModalContent.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/graphql/SeatRequest.graphql
var SeatRequest_graphql = __webpack_require__(8212);
var SeatRequest_graphql_default = /*#__PURE__*/__webpack_require__.n(SeatRequest_graphql);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/theme/index.js
var theme = __webpack_require__(9681);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SeatRequestModal/index.js
var SeatRequestModal_jsxFileName = "/repo/packages/webassets/src/components/SeatRequestModal/index.js", SeatRequestModal_this = undefined;
function SeatRequestModal_slicedToArray(arr, i) {
    return SeatRequestModal_arrayWithHoles(arr) || SeatRequestModal_iterableToArrayLimit(arr, i) || SeatRequestModal_unsupportedIterableToArray(arr, i) || SeatRequestModal_nonIterableRest();
}
function SeatRequestModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SeatRequestModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SeatRequestModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SeatRequestModal_arrayLikeToArray(o, minLen);
}
function SeatRequestModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function SeatRequestModal_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function SeatRequestModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}













var SeatRequestModal_SeatRequestModal = function SeatRequestModal(_ref) {
    var _ref2;
    var show = _ref.show, onClose = _ref.onClose, seatRequestData = _ref.seatRequestData, sourceCategoryKey = _ref.sourceCategoryKey, sourceFeatureKey = _ref.sourceFeatureKey, showToasts = _ref.showToasts;
    var _useState = (0,react.useState)(null), _useState2 = SeatRequestModal_slicedToArray(_useState, 2), toastMessage = _useState2[0], setToastMesssage = _useState2[1];
    var _useState3 = (0,react.useState)(null), _useState4 = SeatRequestModal_slicedToArray(_useState3, 2), operationStatus = _useState4[0], setOperationStatus = _useState4[1];
    // we intentionally separate the prop show, from where
    var _useState5 = (0,react.useState)(show), _useState6 = SeatRequestModal_slicedToArray(_useState5, 2), showModal = _useState6[0], setShowModal = _useState6[1];
    (0,react.useEffect)(function() {
        setShowModal(show);
    }, [
        show
    ]);
    // called when user has completed interaction and
    // we either want to show a toast or immediately
    // signal to the parent that we are done.
    var onModalFinished = function onModalFinished(result) {
        setShowModal(false);
        if (showToasts && result !== null && result !== void 0 && result.message && typeof result.message === "string") {
            setToastMesssage(result.message);
            setOperationStatus(result.status);
        } else if ((result === null || result === void 0 ? void 0 : result.status) === STATUS.SUCCESS || (result === null || result === void 0 ? void 0 : result.status) === STATUS.FAILURE) {
            onClose(result);
        } else {
            onClose({
                status: STATUS.SUCCESS,
                message: null
            });
        }
    };
    // called after toasts have finished displaying
    var onOperationFinished = function onOperationFinished() {
        setToastMesssage(null);
        setShowModal(false);
        onClose({
            status: operationStatus,
            message: toastMessage
        });
    };
    var _useQuery = (0,react_hooks_esm/* useQuery */.aM)((SeatRequest_graphql_default()), {
        skip: seatRequestData || !show,
        fetchPolicy: "network-only",
        onError: function onError() {
            onModalFinished({
                status: STATUS.FAILURE,
                message: (0,intl_dist.t)(SeatRequestCopy.TOAST_ERROR)
            });
        }
    }), isLoadingSeatRequest = _useQuery.loading, data = _useQuery.data;
    var seatRequest = (seatRequestData === null || seatRequestData === void 0 ? void 0 : seatRequestData.seatRequest) || (data === null || data === void 0 ? void 0 : data.user.seatRequest);
    var team = (seatRequestData === null || seatRequestData === void 0 ? void 0 : seatRequestData.team) || (data === null || data === void 0 ? void 0 : data.user.team);
    var isCasualUserAllowExport = ((_ref2 = seatRequestData || (data === null || data === void 0 ? void 0 : data.user)) === null || _ref2 === void 0 ? void 0 : _ref2.featureSetId) === CASUAL_USER_ALLOW_EXPORT;
    if (isLoadingSeatRequest || !seatRequest) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: SeatRequestModal_this,
        __source: {
            fileName: SeatRequestModal_jsxFileName,
            lineNumber: 78,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(index_es/* Modal */.u, {
        size: "md",
        show: showModal,
        onClose: onModalFinished,
        __self: SeatRequestModal_this,
        __source: {
            fileName: SeatRequestModal_jsxFileName,
            lineNumber: 79,
            columnNumber: 7
        }
    }, seatRequest.status === "AVAILABLE" || seatRequest.status === "RESPONDED" ? /*#__PURE__*/ react.createElement(SeatRequestModal_RequestModalContent, {
        onModalFinished: onModalFinished,
        sourceCategoryKey: sourceCategoryKey,
        sourceFeatureKey: sourceFeatureKey,
        isCasualUserAllowExport: isCasualUserAllowExport,
        __self: SeatRequestModal_this,
        __source: {
            fileName: SeatRequestModal_jsxFileName,
            lineNumber: 83,
            columnNumber: 11
        }
    }) : // eslint-disable-next-line no-nested-ternary
    seatRequest.status === "PENDING" ? /*#__PURE__*/ react.createElement(SeatRequestModal_PendingModalContent, {
        onModalFinished: onModalFinished,
        seatRequest: seatRequest,
        team: team,
        __self: SeatRequestModal_this,
        __source: {
            fileName: SeatRequestModal_jsxFileName,
            lineNumber: 91,
            columnNumber: 11
        }
    }) : seatRequest.status === "NOT_AVAILABLE" ? /*#__PURE__*/ react.createElement(SeatRequestModal_NotAvailableModalContent, {
        onModalFinished: onModalFinished,
        team: team,
        __self: SeatRequestModal_this,
        __source: {
            fileName: SeatRequestModal_jsxFileName,
            lineNumber: 97,
            columnNumber: 11
        }
    }) : null), !!toastMessage && /*#__PURE__*/ react.createElement(dist_index_es/* Toast */.F, {
        show: !!toastMessage,
        onClose: onOperationFinished,
        dismissible: true,
        __self: SeatRequestModal_this,
        __source: {
            fileName: SeatRequestModal_jsxFileName,
            lineNumber: 104,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(dist_index_es/* Toast.Title */.F.Title, {
        __self: SeatRequestModal_this,
        __source: {
            fileName: SeatRequestModal_jsxFileName,
            lineNumber: 105,
            columnNumber: 11
        }
    }, toastMessage)));
};
SeatRequestModal_SeatRequestModal.propTypes = {
    /** set to true when you want to show the seat request modal */ show: (prop_types_default()).bool.isRequired,
    /** Modal will inform you that the operation is completed */ onClose: (prop_types_default()).func.isRequired,
    /** Optionally pass in the seat request data yourself if you have already queried it.
   *  If this is null, the modal will make it's own request for this data.
   */ seatRequestData: prop_types_default().shape({
        team: prop_types_default().shape({
            accountOwner: prop_types_default().shape({
                email: (prop_types_default()).string.isRequired,
                firstName: (prop_types_default()).string,
                lastName: (prop_types_default()).string
            }).isRequired
        }).isRequired,
        seatRequest: prop_types_default().shape({
            status: (prop_types_default()).string.isRequired
        })
    }),
    /** This is a key that that maps to a category of features that the user is requesting a seat upgrade for
   *  This could be
   */ sourceCategoryKey: (prop_types_default()).string.isRequired,
    /** This represents the specific feature the user is requesting a seat upgrade for.
   *  It should match a feature key in the pricing service.
   */ sourceFeatureKey: (prop_types_default()).string,
    /**
   * Show toasts
   */ showToasts: (prop_types_default()).bool
};
SeatRequestModal_SeatRequestModal.defaultProps = {
    seatRequestData: null,
    sourceFeatureKey: null,
    showToasts: true
};
/* harmony default export */ var components_SeatRequestModal = (SeatRequestModal_SeatRequestModal); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/Addon/SeatUpgradeButton.js
var SeatUpgradeButton_jsxFileName = "/repo/packages/webassets/src/components/Header/components/Addon/SeatUpgradeButton.js", SeatUpgradeButton_this = undefined;
function SeatUpgradeButton_slicedToArray(arr, i) {
    return SeatUpgradeButton_arrayWithHoles(arr) || SeatUpgradeButton_iterableToArrayLimit(arr, i) || SeatUpgradeButton_unsupportedIterableToArray(arr, i) || SeatUpgradeButton_nonIterableRest();
}
function SeatUpgradeButton_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SeatUpgradeButton_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SeatUpgradeButton_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SeatUpgradeButton_arrayLikeToArray(o, minLen);
}
function SeatUpgradeButton_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function SeatUpgradeButton_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function SeatUpgradeButton_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}




var SeatUpgradeButton_COPY = (0,intl_dist/* defineMessages */.vU)({
    SEAT_REQUEST: {
        id: "SeatUpgradeButton.SeatRequest",
        defaultMessage: "REQUEST POWER SEAT",
        description: "[Type: Label][Vis.: high] - This is a button for users to request a seat upgrade."
    }
});
var SeatUpgradeButton_SeatUpgradeButton = function SeatUpgradeButton() {
    var _useState = useState(false), _useState2 = SeatUpgradeButton_slicedToArray(_useState, 2), showModal = _useState2[0], setShowModal = _useState2[1];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "Addon__SeatUpgradeBtn",
        color: "alt",
        size: "sm",
        disabled: showModal,
        onClick: function onClick() {
            setShowModal(true);
        },
        __self: SeatUpgradeButton_this,
        __source: {
            fileName: SeatUpgradeButton_jsxFileName,
            lineNumber: 20,
            columnNumber: 7
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: SeatUpgradeButton_COPY.SEAT_REQUEST,
        __self: SeatUpgradeButton_this,
        __source: {
            fileName: SeatUpgradeButton_jsxFileName,
            lineNumber: 29,
            columnNumber: 9
        }
    })), /*#__PURE__*/ React.createElement(SeatRequestModal, {
        show: showModal,
        onClose: function onClose() {
            return setShowModal(false);
        },
        sourceCategoryKey: "global_header",
        __self: SeatUpgradeButton_this,
        __source: {
            fileName: SeatUpgradeButton_jsxFileName,
            lineNumber: 31,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var Addon_SeatUpgradeButton = ((/* unused pure expression or super */ null && (SeatUpgradeButton_SeatUpgradeButton))); //# sourceMappingURL=SeatUpgradeButton.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/Addon/addon.scss
var addon = __webpack_require__(2165);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/Addon/index.js
var Addon_jsxFileName = "/repo/packages/webassets/src/components/Header/components/Addon/index.js", Addon_this = undefined;












var Addon_COPY = (0,intl_dist/* defineMessages */.vU)({
    UPGRADE: {
        id: "Addon.upgradeButton",
        defaultMessage: "UPGRADE",
        description: "[Type: Label][Vis.: high] - This is the upgrade addon button on the header."
    },
    CREATE_SURVEY: {
        id: "Addon.createSurvey",
        defaultMessage: "CREATE SURVEY",
        description: "[Type: Label][Vis.: high] - This is the create survey addon button on the header."
    },
    CREATE_TEAM: {
        id: "Addon.createTeam",
        defaultMessage: "CREATE TEAM",
        description: "[Type: Label][Vis.: high] - This is the create team addon button on the header."
    },
    ADD_USERS: {
        id: "Addon.addUsers",
        defaultMessage: "ADD USERS",
        description: "[Type: Label][Vis.: high] - This is the add users addon button on the header."
    }
});
var UpgradeButton = function UpgradeButton() {
    var smHeaderContext = useContext(SMHeaderContext);
    return /*#__PURE__*/ React.createElement(Button, {
        color: "upgrade",
        size: "sm",
        "data-sm-metrics": generateMetricsAttribute({
            data: {
                actionType: "webplat_header_upgrade.button_press",
                actionFlow: smHeaderContext.actionFlow
            }
        }),
        href: createURL("/pricing/upgrade/", {
            ut_source: "header_upgrade",
            ut_source3: "webplat"
        }),
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 46,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: Addon_COPY.UPGRADE,
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 60,
            columnNumber: 7
        }
    }));
};
var CreateButton = function CreateButton() {
    return /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "Addon__CreateSurveyBtn",
        color: "alt",
        className: "wds-m-l-3",
        size: "sm",
        href: createURL("/create/", {
            ut_source: "header"
        }),
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 67,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: Addon_COPY.CREATE_SURVEY,
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 74,
            columnNumber: 7
        }
    }));
};
var CreateTeam = function CreateTeam() {
    return /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "Addon__CreateTeamBtn",
        color: "upgrade",
        size: "sm",
        href: createURL("/billing/p2gupgrade/", {
            ut_source: "header",
            ut_source3: "webplat"
        }),
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 81,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: Addon_COPY.CREATE_TEAM,
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 90,
            columnNumber: 7
        }
    }));
};
var AddUsers = function AddUsers() {
    return /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "Addon__AddUsersBtn",
        color: "upgrade",
        size: "sm",
        href: createURL("/team/add/", {
            ut_source: "header",
            ut_source3: "webplat"
        }),
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 97,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: Addon_COPY.ADD_USERS,
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 106,
            columnNumber: 7
        }
    }));
};
var showLICTA = function showLICTA(data) {
    var user = data.user || {};
    var team = user.team;
    var teamMembership = user.teamMembership || {};
    var _ref = user.package || {}, isAnnual = _ref.isAnnual;
    var canAddUsers = teamMembership.isAdmin && team && team.ssoState !== "REQUIRED";
    var showSeatUpgradeButton = (user === null || user === void 0 ? void 0 : user.features.powerCasualEnabled) && teamMembership.memberType === "CASUAL";
    if (showSeatUpgradeButton) {
        return /*#__PURE__*/ React.createElement(SeatUpgradeButton, {
            __self: Addon_this,
            __source: {
                fileName: Addon_jsxFileName,
                lineNumber: 122,
                columnNumber: 12
            }
        });
    }
    if (canAddUsers) {
        return /*#__PURE__*/ React.createElement(AddUsers, {
            __self: Addon_this,
            __source: {
                fileName: Addon_jsxFileName,
                lineNumber: 126,
                columnNumber: 12
            }
        });
    }
    if (!team && isAnnual) {
        return /*#__PURE__*/ React.createElement(CreateTeam, {
            __self: Addon_this,
            __source: {
                fileName: Addon_jsxFileName,
                lineNumber: 129,
                columnNumber: 12
            }
        });
    }
    if (!team) {
        return /*#__PURE__*/ React.createElement(UpgradeButton, {
            __self: Addon_this,
            __source: {
                fileName: Addon_jsxFileName,
                lineNumber: 132,
                columnNumber: 12
            }
        });
    }
    return null;
};
var Addon = function Addon(_ref2) {
    var isUserAuthenticated = _ref2.isUserAuthenticated, addonLogInColor = _ref2.addonLogInColor, addonSignUpColor = _ref2.addonSignUpColor, addonSignUpVariant = _ref2.addonSignUpVariant, variant = _ref2.variant, showLoginButton = _ref2.showLoginButton, showSignupButton = _ref2.showSignupButton;
    var auth = isUserAuthenticated ? "auth" : "anon";
    return /*#__PURE__*/ react.createElement(MediaComponents/* TabletScreen */.m6, {
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 148,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("div", {
        "data-testid": "Addon__Container",
        className: "sm-addon__".concat(auth, "--").concat(variant),
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 149,
            columnNumber: 7
        }
    }, showLoginButton ? /*#__PURE__*/ react.createElement(components_LogInCTA, {
        variant: "text",
        color: addonLogInColor,
        params: {
            ut_source: "megamenu"
        },
        className: "sm-addon__log-in sm-addon__log-in--".concat(addonLogInColor),
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 154,
            columnNumber: 11
        }
    }) : null, showSignupButton ? /*#__PURE__*/ react.createElement(components_SignUpCTA, {
        variant: addonSignUpVariant,
        color: addonSignUpColor,
        params: {
            ut_source: "megamenu"
        },
        className: "sm-addon__sign-up sm-addon__sign-up--".concat(addonSignUpColor),
        __self: Addon_this,
        __source: {
            fileName: Addon_jsxFileName,
            lineNumber: 162,
            columnNumber: 11
        }
    }) : null));
};
Addon.propTypes = {
    isUserAuthenticated: (prop_types_default()).bool,
    addonLogInColor: prop_types_default().oneOf([
        "secondary",
        "alt"
    ]),
    addonSignUpColor: prop_types_default().oneOf([
        "upgrade",
        "alt"
    ]),
    addonSignUpVariant: prop_types_default().oneOf([
        "default",
        "ghost"
    ]),
    variant: prop_types_default().oneOf([
        "default",
        "limited",
        "slim"
    ]),
    showLoginButton: (prop_types_default()).bool,
    showSignupButton: (prop_types_default()).bool
};
Addon.defaultProps = {
    isUserAuthenticated: false,
    addonLogInColor: "alt",
    addonSignUpColor: "alt",
    addonSignUpVariant: "default",
    variant: "default",
    showLoginButton: true,
    showSignupButton: true
}; //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Logos/index.js + 3 modules
var Logos = __webpack_require__(7120);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/HeaderLogo/header-logo.scss
var header_logo = __webpack_require__(2407);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/HeaderLogo/index.js
var HeaderLogo_jsxFileName = "/repo/packages/webassets/src/components/Header/components/HeaderLogo/index.js", HeaderLogo_this = undefined;





var HeaderLogo = function HeaderLogo(_ref) {
    var variant = _ref.variant, color = _ref.color, isUserAuthenticated = _ref.isUserAuthenticated;
    var auth = isUserAuthenticated ? "auth" : "anon";
    return /*#__PURE__*/ react.createElement("a", {
        href: "/",
        alt: "SurveyMonkey Logo",
        className: "sm-header-logo__".concat(auth, "--").concat(variant, " sm-header-logo__link"),
        __self: HeaderLogo_this,
        __source: {
            fileName: HeaderLogo_jsxFileName,
            lineNumber: 12,
            columnNumber: 5
        }
    }, !isUserAuthenticated ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MediaComponents/* TabletScreen */.m6, {
        __self: HeaderLogo_this,
        __source: {
            fileName: HeaderLogo_jsxFileName,
            lineNumber: 19,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(Logos/* LogoWithText */.u, {
        className: "sm-header-logo__text",
        color: color,
        __self: HeaderLogo_this,
        __source: {
            fileName: HeaderLogo_jsxFileName,
            lineNumber: 20,
            columnNumber: 13
        }
    })), /*#__PURE__*/ react.createElement(MediaComponents/* MobileScreen */.vp, {
        __self: HeaderLogo_this,
        __source: {
            fileName: HeaderLogo_jsxFileName,
            lineNumber: 22,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(Logos/* Logo */.T, {
        color: color,
        className: "sm-header-logo__anon-icon",
        __self: HeaderLogo_this,
        __source: {
            fileName: HeaderLogo_jsxFileName,
            lineNumber: 23,
            columnNumber: 13
        }
    }))) : /*#__PURE__*/ react.createElement(Logos/* Logo */.T, {
        className: "sm-header-logo__auth-icon",
        color: "alt",
        __self: HeaderLogo_this,
        __source: {
            fileName: HeaderLogo_jsxFileName,
            lineNumber: 27,
            columnNumber: 9
        }
    }));
};
HeaderLogo.propTypes = {
    isUserAuthenticated: (prop_types_default()).bool,
    color: prop_types_default().oneOf([
        "primary",
        "alt"
    ]),
    variant: prop_types_default().oneOf([
        "default",
        "limited",
        "slim"
    ])
};
HeaderLogo.defaultProps = {
    isUserAuthenticated: false,
    color: "primary",
    variant: "default"
};
/* harmony default export */ var components_HeaderLogo = (HeaderLogo); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/MomentiveHeaderLogo/MomentiveLogoType.js
var MomentiveLogoType_jsxFileName = "/repo/packages/webassets/src/components/Header/components/MomentiveHeaderLogo/MomentiveLogoType.tsx", MomentiveLogoType_this = undefined;

var MomentiveLogoType = function MomentiveLogoType(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "#FFFFFF" : _ref$fill;
    return /*#__PURE__*/ react.createElement("svg", {
        "data-testid": "MomentiveLogoType",
        viewBox: "0 0 123 18",
        width: 123,
        height: 18,
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "MomentiveLogoTypeGroup",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 15,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "MomentiveLogoTypeGroup2",
        transform: "translate(0.000000, 0.875000)",
        fill: fill,
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 22,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M122.02,6.988 L121.72,6.5745 C121.627,6.441 121.54,6.3145 121.467,6.1945 L121.453,6.201 C121.46,6.308 121.467,6.4945 121.467,6.6275 L121.467,7.4345 L121.047,7.4345 L121.047,5.501 L121.453,5.501 L122.02,6.288 L122.5865,5.501 L123,5.501 L123,7.4345 L122.573,7.4345 L122.573,6.6275 C122.573,6.4945 122.58,6.308 122.5865,6.201 L122.573,6.1945 C122.5,6.3145 122.4135,6.441 122.3205,6.5745 L122.02,6.988 Z M119.7665,5.8945 L119.2,5.8945 L119.2,5.501 L120.7665,5.501 L120.7665,5.8945 L120.2,5.8945 L120.2,7.4345 L119.7665,7.4345 L119.7665,5.8945 L119.7665,5.8945 Z",
        id: "MomentiveLogoTypeGroupFill1",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 27,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M16.966,6.457 C16.2725,5.7175 15.3395,5.2145 14.009,5.2145 C12.4625,5.2145 10.9165,5.7945 9.396,6.426 C8.684,5.5965 7.947,5.2075 6.448,5.2075 C4.6795,5.2075 2.5345,5.791 0,6.7025 L0,16.8705 L2.7965,16.8705 L2.7965,7.719 L5.639,7.719 C6.1935,7.719 6.725,7.8805 7.118,8.32 C7.465,8.7125 7.58,9.221 7.58,10.215 L7.58,16.8705 L10.3765,16.8705 L10.3765,8.397 C10.3765,8.149 10.3765,7.923 10.355,7.719 L13.1965,7.719 C13.797,7.719 14.282,7.904 14.652,8.32 C14.9985,8.7125 15.1605,9.244 15.1605,10.215 L15.1605,16.8705 L17.957,16.8705 L17.957,9.7525 C17.957,8.158 17.659,7.2195 16.966,6.457",
        id: "MomentiveLogoTypeGroupFill2",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 31,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M51.2535,6.457 C50.56,5.7175 49.627,5.2145 48.2965,5.2145 C46.75,5.2145 45.204,5.7945 43.6835,6.426 C42.9715,5.5965 42.2345,5.2075 40.7355,5.2075 C38.9675,5.2075 36.8225,5.791 34.2875,6.7025 L34.2875,16.8705 L37.084,16.8705 L37.084,7.719 L39.927,7.719 C40.4815,7.719 41.0125,7.8805 41.406,8.32 C41.7525,8.7125 41.8675,9.221 41.8675,10.215 L41.8675,16.8705 L44.664,16.8705 L44.664,8.397 C44.664,8.149 44.664,7.923 44.6425,7.719 L47.484,7.719 C48.0845,7.719 48.57,7.904 48.9395,8.32 C49.286,8.7125 49.448,9.244 49.448,10.215 L49.448,16.8705 L52.2445,16.8705 L52.2445,9.7525 C52.2445,8.158 51.947,7.2195 51.2535,6.457",
        id: "MomentiveLogoTypeGroupFill3",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 35,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M26.046,14.675 C27.9875,14.675 29.42,13.15 29.42,11.1855 C29.42,9.221 27.9875,7.696 26.046,7.696 C24.1045,7.696 22.672,9.221 22.672,11.1855 C22.672,13.15 24.1045,14.675 26.046,14.675 Z M26.046,5.246 C29.582,5.246 32.2165,7.8345 32.2165,11.1855 C32.2165,14.5365 29.582,17.125 26.046,17.125 C22.5105,17.125 19.8755,14.5365 19.8755,11.1855 C19.8755,7.8345 22.5105,5.246 26.046,5.246 L26.046,5.246 Z",
        id: "MomentiveLogoTypeGroupFill4",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 39,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M62.9025,10.007 C62.6945,8.2965 61.4465,7.511 60.1755,7.511 C58.881,7.511 57.587,8.2965 57.24,10.007 L62.9025,10.007 Z M57.24,11.948 C57.587,13.843 59.089,14.8135 61.0075,14.8135 C62.44,14.8135 63.4695,14.45 64.8895,13.934 L64.8895,16.0615 C63.8265,16.732 62.209,17.125 60.73,17.125 C57.0785,17.125 54.3975,14.7675 54.3975,11.2085 C54.3975,7.603 57.1015,5.246 60.198,5.246 C63.0175,5.246 65.5135,7.1645 65.5135,10.8155 C65.5135,11.1855 65.4905,11.6475 65.4445,11.948 L57.24,11.948 L57.24,11.948 Z",
        id: "MomentiveLogoTypeGroupFill5",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 43,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M116.0125,10.007 C115.8045,8.2965 114.5565,7.511 113.2855,7.511 C111.991,7.511 110.6975,8.2965 110.3505,10.007 L116.0125,10.007 Z M110.3505,11.948 C110.6975,13.843 112.199,14.8135 114.1175,14.8135 C115.5505,14.8135 116.58,14.45 118,13.934 L118,16.0615 C116.937,16.732 115.3195,17.125 113.8405,17.125 C110.1885,17.125 107.508,14.7675 107.508,11.2085 C107.508,7.603 110.212,5.246 113.3085,5.246 C116.128,5.246 118.624,7.1645 118.624,10.8155 C118.624,11.1855 118.601,11.6475 118.5545,11.948 L110.3505,11.948 L110.3505,11.948 Z",
        id: "MomentiveLogoTypeGroupFill6",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 47,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M77.497,6.4475 C76.781,5.662 75.745,5.219 74.52,5.219 C72.075,5.219 69.6985,6.092 67.9295,6.7435 L67.9295,16.8705 L70.726,16.8705 L70.726,7.719 L73.707,7.719 C74.354,7.719 74.863,7.927 75.2095,8.343 C75.5325,8.7125 75.6715,9.2675 75.6715,10.284 L75.6715,16.8705 L78.468,16.8705 L78.468,9.799 C78.468,8.112 78.1675,7.1645 77.497,6.4475",
        id: "MomentiveLogoTypeGroupFill7",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 51,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M90.5,16.8705 L93.2965,16.8705 L93.2965,5.5005 L90.5,5.5005 L90.5,16.8705 Z M91.9095,0 C92.8575,0 93.643,0.786 93.643,1.7335 C93.643,2.681 92.8575,3.4665 91.8865,3.4665 C90.939,3.4665 90.1535,2.681 90.1535,1.7335 C90.1535,0.786 90.939,0 91.9095,0 L91.9095,0 Z",
        id: "MomentiveLogoTypeGroupFill8",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 55,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M95.025,5.5005 L97.983,5.5005 L99.6005,9.66 C100.086,10.908 100.5715,12.179 101.0565,13.5195 L101.103,13.5195 C101.6115,12.179 102.0735,11.0005 102.605,9.6835 L104.292,5.5005 L107.135,5.5005 L102.4665,16.8705 L99.7165,16.8705 L95.025,5.5005",
        id: "MomentiveLogoTypeGroupFill9",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 59,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M88.009,7.8805 L88.009,5.5 L84.7965,5.5 L84.7965,1.9185 L82,2.774 L82,5.5 L80.0125,5.5 L80.0125,7.8805 L82,7.8805 L82,12.757 C82,14.444 82.3465,15.3915 82.9245,16.0155 C83.6405,16.8245 84.704,17.125 85.698,17.125 C86.5755,17.125 87.5005,16.894 88.009,16.5935 L88.009,14.338 C87.528,14.5295 86.8995,14.767 86.2985,14.767 C85.0275,14.767 84.7965,13.704 84.7965,12.433 L84.7965,7.8805 L88.009,7.8805",
        id: "MomentiveLogoTypeGroupFill10",
        __self: MomentiveLogoType_this,
        __source: {
            fileName: MomentiveLogoType_jsxFileName,
            lineNumber: 63,
            columnNumber: 11
        }
    }))));
};
/* harmony default export */ var MomentiveHeaderLogo_MomentiveLogoType = (MomentiveLogoType); //# sourceMappingURL=MomentiveLogoType.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/MomentiveHeaderLogo/MomentiveLogoMark.js
var MomentiveLogoMark_jsxFileName = "/repo/packages/webassets/src/components/Header/components/MomentiveHeaderLogo/MomentiveLogoMark.tsx", MomentiveLogoMark_this = undefined;

var MomentiveLogoMark = function MomentiveLogoMark() {
    return /*#__PURE__*/ react.createElement("svg", {
        viewBox: "0 0 36 24",
        "data-testid": "MomentiveLogoMark",
        width: 36,
        height: 24,
        __self: MomentiveLogoMark_this,
        __source: {
            fileName: MomentiveLogoMark_jsxFileName,
            lineNumber: 5,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "MomentiveLogoMarkGroup1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        __self: MomentiveLogoMark_this,
        __source: {
            fileName: MomentiveLogoMark_jsxFileName,
            lineNumber: 11,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "MomentiveLogoMarkGroup2",
        transform: "translate(-0.000000, 0.000000)",
        __self: MomentiveLogoMark_this,
        __source: {
            fileName: MomentiveLogoMark_jsxFileName,
            lineNumber: 18,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M19.137,11.242 C21.576,14.893 23,19.28 23,24 L36,24 L36,0 L19.137,11.242",
        id: "MomentiveLogoMarkFill11",
        fill: "#2CB2F1",
        __self: MomentiveLogoMark_this,
        __source: {
            fileName: MomentiveLogoMark_jsxFileName,
            lineNumber: 22,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M0,1 L0,24 L19.137,11.242 C15.0125,5.068 7.9825,1 0,1",
        id: "MomentiveLogoMarkFill12",
        fill: "#FFE11B",
        __self: MomentiveLogoMark_this,
        __source: {
            fileName: MomentiveLogoMark_jsxFileName,
            lineNumber: 27,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M0,24 L23,24 C23,19.28 21.576,14.893 19.137,11.242 L0,24",
        id: "MomentiveLogoMarkFill13",
        fill: "#008323",
        __self: MomentiveLogoMark_this,
        __source: {
            fileName: MomentiveLogoMark_jsxFileName,
            lineNumber: 32,
            columnNumber: 11
        }
    }))));
};
/* harmony default export */ var MomentiveHeaderLogo_MomentiveLogoMark = (MomentiveLogoMark); //# sourceMappingURL=MomentiveLogoMark.js.map

// EXTERNAL MODULE: ./node_modules/react-jss/dist/react-jss.esm.js + 25 modules
var react_jss_esm = __webpack_require__(389);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/MomentiveHeaderLogo/useStyles.js

function _defineProperty(obj, key, value) {
    key = useStyles_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useStyles_toPropertyKey(arg) {
    var key = useStyles_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function useStyles_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(_ref) {
    var breakpoints = _ref.breakpoints, spacing = _ref.spacing;
    return {
        headerBox: function headerBox(_ref2) {
            var isUserAuthenticated = _ref2.isUserAuthenticated;
            if (!isUserAuthenticated) {
                return {
                    margin: "auto"
                };
            }
            return _defineProperty({
                display: "flex",
                paddingLeft: spacing[3],
                paddingRight: spacing[3]
            }, "@media (max-width: ".concat(breakpoints.xl, "px)"), {
                flexGrow: 1,
                paddingLeft: 0,
                paddingRight: 0
            });
        },
        headerLink: function headerLink(_ref4) {
            var isUserAuthenticated = _ref4.isUserAuthenticated;
            if (!isUserAuthenticated) {
                return {};
            }
            return _defineProperty({
                display: "flex",
                flexGrow: 1,
                justifyContent: "center"
            }, "@media (max-width: ".concat(breakpoints.xl, "px)"), {
                paddingLeft: spacing[7],
                paddingRight: spacing[7],
                justifyContent: "flex-start"
            });
        },
        headerLogo: function headerLogo(_ref6) {
            var isUserAuthenticated = _ref6.isUserAuthenticated;
            if (!isUserAuthenticated) {
                return {};
            }
            return _defineProperty({
                paddingLeft: spacing[3],
                paddingRight: spacing[3]
            }, "@media (max-width: ".concat(breakpoints.xl, "px)"), {
                paddingLeft: 0,
                paddingRight: 0
            });
        }
    };
});
/* harmony default export */ var MomentiveHeaderLogo_useStyles = (useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/MomentiveHeaderLogo/MomentiveHeaderLogo.js
var MomentiveHeaderLogo_jsxFileName = "/repo/packages/webassets/src/components/Header/components/MomentiveHeaderLogo/MomentiveHeaderLogo.tsx", _this2 = undefined;







function withHeaderLink(Component) {
    var _this = this;
    return function(props) {
        var isUserAuthenticated = props.isUserAuthenticated;
        var theme = (0,theming_esm/* useTheme */.Fg)();
        var classes = MomentiveHeaderLogo_useStyles({
            isUserAuthenticated: isUserAuthenticated,
            theme: theme
        });
        return /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            className: classes.headerBox,
            display: "flex",
            flexAlign: "center",
            __self: _this,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 24,
                columnNumber: 7
            }
        }, /*#__PURE__*/ react.createElement("a", {
            href: "/",
            "aria-label": "Momentive Logo",
            className: classes.headerLink,
            __self: _this,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 25,
                columnNumber: 9
            }
        }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            className: classes.headerLogo,
            display: "flex",
            flexAlign: "center",
            __self: _this,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 26,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(Component, Object.assign({}, props, {
            __self: _this,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 27,
                columnNumber: 13
            }
        })))));
    };
}
var MomentiveIcons = function MomentiveIcons(_ref) {
    var isContrast = _ref.isContrast, _ref$showTypography = _ref.showTypography, showTypography = _ref$showTypography === void 0 ? false : _ref$showTypography;
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var typeColor = isContrast ? theme.palette.text.dark : theme.palette.text.light;
    return /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexDirection: "row",
        __self: _this2,
        __source: {
            fileName: MomentiveHeaderLogo_jsxFileName,
            lineNumber: 48,
            columnNumber: 5
        }
    }, showTypography && /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        pr: 1,
        flexAlign: "flex-end",
        __self: _this2,
        __source: {
            fileName: MomentiveHeaderLogo_jsxFileName,
            lineNumber: 50,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(MomentiveHeaderLogo_MomentiveLogoType, {
        fill: typeColor,
        __self: _this2,
        __source: {
            fileName: MomentiveHeaderLogo_jsxFileName,
            lineNumber: 51,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: "flex-end",
        __self: _this2,
        __source: {
            fileName: MomentiveHeaderLogo_jsxFileName,
            lineNumber: 54,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(MomentiveHeaderLogo_MomentiveLogoMark, {
        __self: _this2,
        __source: {
            fileName: MomentiveHeaderLogo_jsxFileName,
            lineNumber: 55,
            columnNumber: 9
        }
    })));
};
var MomentiveLogo = function MomentiveLogo(_ref2) {
    var isUserAuthenticated = _ref2.isUserAuthenticated, isContrast = _ref2.isContrast;
    if (!isUserAuthenticated) {
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MediaComponents/* TabletScreen */.m6, {
            __self: _this2,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 67,
                columnNumber: 9
            }
        }, /*#__PURE__*/ react.createElement(MomentiveIcons, {
            isContrast: isContrast,
            showTypography: true,
            __self: _this2,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 68,
                columnNumber: 11
            }
        })), /*#__PURE__*/ react.createElement(MediaComponents/* MobileScreen */.vp, {
            __self: _this2,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 70,
                columnNumber: 9
            }
        }, /*#__PURE__*/ react.createElement(MomentiveIcons, {
            isContrast: isContrast,
            __self: _this2,
            __source: {
                fileName: MomentiveHeaderLogo_jsxFileName,
                lineNumber: 71,
                columnNumber: 11
            }
        })));
    }
    return /*#__PURE__*/ react.createElement(MomentiveIcons, {
        isContrast: isContrast,
        showTypography: true,
        __self: _this2,
        __source: {
            fileName: MomentiveHeaderLogo_jsxFileName,
            lineNumber: 77,
            columnNumber: 10
        }
    });
};
/* harmony default export */ var MomentiveHeaderLogo = (withHeaderLink(MomentiveLogo)); //# sourceMappingURL=MomentiveHeaderLogo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/MomentiveHeaderLogo/index.js
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@wds/icons/dist/index.es.js
var icons_dist_index_es = __webpack_require__(9224);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/Drawer/Mobile/mobile-menu.scss
var mobile_menu = __webpack_require__(9547);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/Drawer/Mobile/index.js
var Mobile_jsxFileName = "/repo/packages/webassets/src/components/Header/components/Drawer/Mobile/index.js", Mobile_this = undefined;
function Mobile_slicedToArray(arr, i) {
    return Mobile_arrayWithHoles(arr) || Mobile_iterableToArrayLimit(arr, i) || Mobile_unsupportedIterableToArray(arr, i) || Mobile_nonIterableRest();
}
function Mobile_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Mobile_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Mobile_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Mobile_arrayLikeToArray(o, minLen);
}
function Mobile_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function Mobile_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function Mobile_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}






var MobileDrawer = function MobileDrawer(_ref) {
    var menuColor = _ref.menuColor, children = _ref.children;
    var _useState = (0,react.useState)(false), _useState2 = Mobile_slicedToArray(_useState, 2), drawerOpen = _useState2[0], setOpen = _useState2[1];
    var toggleDrawer = function toggleDrawer() {
        return setOpen(!drawerOpen);
    };
    var buttonClass = classnames_default()("sm-mobile-menu__trigger", "sm-mobile-menu__cta", "sm-mobile-menu--".concat(menuColor), "wds-float--left");
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(wds_react.Button, {
        variant: "text",
        size: "sm",
        className: buttonClass,
        onClick: toggleDrawer,
        __self: Mobile_this,
        __source: {
            fileName: Mobile_jsxFileName,
            lineNumber: 22,
            columnNumber: 7
        }
    }, drawerOpen ? /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconX */.kLi, {
        __self: Mobile_this,
        __source: {
            fileName: Mobile_jsxFileName,
            lineNumber: 28,
            columnNumber: 23
        }
    }) : /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconMenu */.dcc, {
        __self: Mobile_this,
        __source: {
            fileName: Mobile_jsxFileName,
            lineNumber: 28,
            columnNumber: 35
        }
    })), /*#__PURE__*/ react.createElement(wds_react.Sheet, {
        show: drawerOpen,
        onClose: toggleDrawer,
        placement: "left",
        offsetTop: 50,
        __self: Mobile_this,
        __source: {
            fileName: Mobile_jsxFileName,
            lineNumber: 30,
            columnNumber: 7
        }
    }, children));
};
MobileDrawer.propTypes = {
    menuColor: prop_types_default().oneOf([
        "alt",
        "secondary"
    ]),
    children: (prop_types_default()).node.isRequired
};
MobileDrawer.defaultProps = {
    menuColor: "alt"
};
/* harmony default export */ var Mobile = ((/* unused pure expression or super */ null && (MobileDrawer))); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/helpers/languageHelpers.js

var isEnglishLang = function isEnglishLang(lang) {
    return lang === "en";
};
var hasCX = function hasCX(lang) {
    return isEnglishLang(lang);
};
var hasEngage = function hasEngage(lang) {
    return isEnglishLang(lang);
};
var hasTechValidate = function hasTechValidate(lang) {
    return isEnglishLang(lang);
};
var hasWufoo = function hasWufoo(lang) {
    return [
        "en",
        "es"
    ].includes(lang);
};
var hasApply = function hasApply(lang) {
    return [
        "en",
        "fr"
    ].includes(lang);
};
var hasUsabilla = function hasUsabilla(lang) {
    return [
        "en",
        "fr",
        "sv",
        "de",
        "nl"
    ].includes(lang);
};
var hasGetFeedback = function hasGetFeedback(lang) {
    return isEnglishLang(lang);
};
var languageHelpers_getWufooURL = function getWufooURL(lang) {
    var url = "https://www.wufoo.";
    if (lang === "en-gb") return "".concat(url, "co.uk/");
    if (lang === "es") return "".concat(url, "mx/");
    return "".concat(url, "com/");
};
/**
 * Find the correct marketing link for Usabilla
 * @param lang
 * @return {String}
 */ var languageHelpers_usabillaLink = function usabillaLink(lang) {
    return ({
        de: "https://usabilla.com/de/",
        sv: "https://usabilla.com/sv/",
        fr: "https://usabilla.com/fr/"
    })[lang] || "https://usabilla.com/";
};
var showBoardOfDirectorsLink = function showBoardOfDirectorsLink(lang) {
    return [
        "en",
        "es",
        "pt-br",
        "de",
        "fr",
        "nl"
    ].includes(lang);
};
var showNewsRoom = function showNewsRoom(lang, country) {
    return lang === "en" && country === "US";
};
var showDachPaymentLinks = function showDachPaymentLinks(lang, country) {
    return lang === "de" && [
        "DE",
        "AT",
        "CH"
    ].includes(country);
};
var showImprintLink = function showImprintLink(lang, country) {
    return lang === "en" && country !== "US";
};
var showBlog = function showBlog(lang) {
    return [
        "de",
        "en",
        "en-gb",
        "es",
        "fr",
        "nl",
        "pt-br"
    ].includes(lang);
};
var getLanguageNameFromCode = function getLanguageNameFromCode(langCode) {
    var currentLangList = locale_dist/* LANGUAGES.filter */.a2.filter(function(language) {
        return language.code === langCode;
    });
    if (currentLangList.length === 0) return "unknown";
    // pick the first one gb / en issue TODO
    return currentLangList[0].displayName || "unknown";
}; //# sourceMappingURL=languageHelpers.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/NavBarAnonContext.js

var NavBarAnonContext_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/NavBarAnonContext.js", NavBarAnonContext_this = undefined;
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            NavBarAnonContext_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function NavBarAnonContext_defineProperty(obj, key, value) {
    key = NavBarAnonContext_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavBarAnonContext_toPropertyKey(arg) {
    var key = NavBarAnonContext_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function NavBarAnonContext_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


var NavBarAnonContext = /*#__PURE__*/ (0,react.createContext)({});
var Provider = NavBarAnonContext.Provider;
var NavBarContext = function NavBarContext(props) {
    return /*#__PURE__*/ react.createElement(Provider, {
        value: _objectSpread({}, props),
        __self: NavBarAnonContext_this,
        __source: {
            fileName: NavBarAnonContext_jsxFileName,
            lineNumber: 9,
            columnNumber: 3
        }
    }, props.children);
};
NavBarContext.propTypes = {
    children: (prop_types_default()).node.isRequired
};
 //# sourceMappingURL=NavBarAnonContext.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/copy/NavSubmenuCopy.js

/* harmony default export */ var NavSubmenuCopy = ((0,intl_dist/* defineMessages */.vU)({
    PRODUCTS_TITLE: {
        id: "NavSubmenuCopy.productsTitle",
        defaultMessage: "Power your curiosity with our data platforms",
        description: "[Type: Label][Vis.: low] - Products title of NavBar submenu"
    },
    SOLUTIONS_TITLE: {
        id: "NavSubmenuCopy.solutionsTitle",
        defaultMessage: "Drive business forward with People Powered Data",
        description: "[Type: Label][Vis.: low] - Solutions title of NavBar submenu"
    },
    RESOURCES_TITLE: {
        id: "NavSubmenuCopy.resourcesTitle",
        defaultMessage: "Seek the inspiration and expertise you need",
        description: "[Type: Label][Vis.: low] - Resources title of NavBar submenu"
    },
    SURVEYS: {
        id: "NavSubmenuCopy.surveys",
        defaultMessage: "Surveys",
        description: "[Type: Label][Vis.: low] - Surveys section of NavBar submenu"
    },
    SPECIALIZED_PRODUCTS: {
        id: "NavSubmenuCopy.specializedProducts",
        defaultMessage: "Specialized products",
        description: "[Type: Label][Vis.: low] - Specialized Products section of NavBar submenu"
    },
    FORMS_AND_WORKFLOWS: {
        id: "NavSubmenuCopy.formsWorkflows",
        defaultMessage: "Forms and workflows",
        description: "[Type: Label][Vis.: low] - Forms and Workflows section of NavBar submenu"
    },
    SURVEY_TYPES: {
        id: "NavSubmenuCopy.surveyTypes",
        defaultMessage: "Survey Types",
        description: "[Type: Label][Vis.: low] - SurveyTypes section in NavBar submenu"
    },
    PEOPLE_POWERED_DATA: {
        id: "NavSubmenuCopy.peoplePoweredData",
        defaultMessage: "People Powered Data for business",
        description: "[Type: Label][Vis.: low] - People Powered Data section in NavBar submenu"
    },
    SOLUTIONS_FOR_TEAMS: {
        id: "NavSubmenuCopy.solutionsForTeams",
        defaultMessage: "Solutions for teams",
        description: "[Type: Label][Vis.: low] - SolutionsForTeams section in NavBar submenu"
    },
    SURVEYMONKEY_SUBTITLE: {
        id: "NavSubmenuCopy.surveyMonkeySubtitle",
        defaultMessage: "Create & send surveys with the world’s #1 online survey software",
        description: "[Type: Label][Vis.: low] - SurveyMonkey subtitle of NavBar submenu"
    },
    ENTERPRISE_SUBTITLE: {
        id: "NavSubmenuCopy.enterpriseSubtitle",
        defaultMessage: "Empower your organization with our secure survey platform",
        description: "[Type: Label][Vis.: low] - Enterprise Subtitle in NavBar submenu"
    },
    INTEGRATIONS_PLUGINS: {
        id: "NavSubmenuCopy.integrationsPlugins",
        defaultMessage: "Integrations & plug-ins",
        description: "[Type: Label][Vis.: low] - Integrations and plugins section of NavBar submenu"
    },
    INTEGRATIONS_PLUGINS_SUBTITLE: {
        id: "NavSubmenuCopy.integrationsPluginsSubtitle",
        defaultMessage: "Bring survey insights into your business apps",
        description: "[Type: Label][Vis.: low] - Integrations and plugins subtitle in NavBar submenu"
    },
    AUDIENCE_SUBTITLE: {
        id: "NavSubmenuCopy.audienceSubtitle",
        defaultMessage: "Collect survey responses from our global consumer panel",
        description: "[Type: Label][Vis.: low] - Audience subtitle of NavBar submenu"
    },
    CX_SUBTITLE: {
        id: "NavSubmenuCopy.cxSubtitle",
        defaultMessage: "Understand & improve customer experience (NPS\xae)",
        description: "[Type: Label][Vis.: low] - CX subtitle in NavBar submenu"
    },
    ENGAGE_SUBTITLE: {
        id: "NavSubmenuCopy.engageSubtitle",
        defaultMessage: "Measure & increase employee engagement",
        description: "[Type: Label][Vis.: low] - Engage subtitle in NavBar submenu"
    },
    USABILLA_SUBTITLE: {
        id: "NavSubmenuCopy.usabillaSubtitle",
        defaultMessage: "Get in-the-moment feedback across all digital channels",
        description: "[Type: Label][Vis.: low] - Usabilla label of NavBar submenu"
    },
    TECH_VALIDATE_SUBTITLE: {
        id: "NavSubmenuCopy.techValidateSubtitle",
        defaultMessage: "Create marketing content from customer feedback",
        description: "[Type: Label][Vis.: low] - Tech Validate subtitle in NavBar submenu"
    },
    APPLY_SUBTITLE: {
        id: "NavSubmenuCopy.applySubtitle",
        defaultMessage: "Collect, review & manage applications online",
        description: "[Type: Label][Vis.: low] - Apply Subtitle of NavBar submenu"
    },
    WUFOO_SUBTITLE: {
        id: "NavSubmenuCopy.wufooSubtitle",
        defaultMessage: "Gather data & accept payments with online forms",
        description: "[Type: Label][Vis.: low] - Wufoo Subtitle of NavBar submenu"
    },
    GET_FEEDBACK_SUBTITLE: {
        id: "NavSubmenuCopy.getFeedbackSubtitle",
        defaultMessage: "Customer feedback for Salesforce",
        description: "[Type: Label][Vis.: low] - GetFeedback Subtitle of NavBar submenu"
    },
    CUSTOMER_SATISFACTION: {
        id: "NavSubmenuCopy.customerSatisfaction",
        defaultMessage: "Customer Satisfaction",
        description: "[Type: Label][Vis.: low] - Customer Satisfaction section in NavBar submenu"
    },
    CUSTOMER_LOYALTY: {
        id: "NavSubmenuCopy.customerLoyalty",
        defaultMessage: "Customer Loyalty",
        description: "[Type: Label][Vis.: low] - Customer Loyalty section in NavBar submenu"
    },
    EVENT_SURVEYS: {
        id: "NavSubmenuCopy.eventSurveys",
        defaultMessage: "Event Surveys",
        description: "[Type: Label][Vis.: low] - Event Surveys section in NavBar submenu"
    },
    EMPLOYEE_ENGAGEMENT: {
        id: "NavSubmenuCopy.employeeEngagement",
        defaultMessage: "Employee Engagement",
        description: "[Type: Label][Vis.: low] - Employee Engagement section in NavBar submenu"
    },
    JOB_SATISFACTION: {
        id: "NavSubmenuCopy.jobSatisfaction",
        defaultMessage: "Job Satisfaction",
        description: "[Type: Label][Vis.: low] - Job Satisfaction section in NavBar submenu"
    },
    HR_SURVEYS: {
        id: "NavSubmenuCopy.HRSurveys",
        defaultMessage: "HR Surveys",
        description: "[Type: Label][Vis.: low] - HR Surveys section in NavBar submenu"
    },
    MARKET_RESEARCH: {
        id: "NavSubmenuCopy.marketResearch",
        defaultMessage: "Market Research",
        description: "[Type: Label][Vis.: low] - Market Research section in NavBar submenu"
    },
    OPINION_POLLS: {
        id: "NavSubmenuCopy.opinionPolls",
        defaultMessage: "Opinion Polls",
        description: "[Type: Label][Vis.: low] - Opinion Polls section in NavBar submenu"
    },
    CONCEPT_TESTING: {
        id: "NavSubmenuCopy.conceptTesting",
        defaultMessage: "Concept Testing",
        description: "[Type: Label][Vis.: low] - Concept Testing section in NavBar submenu"
    },
    CUSTOMERS: {
        id: "NavSubmenuCopy.customers",
        defaultMessage: "Customers",
        description: "[Type: Label][Vis.: low] - Customers Section in NavBar submenu"
    },
    CUSTOMERS_SUBTITLE: {
        id: "NavSubmenuCopy.customersSubtitle",
        defaultMessage: "Win more business with Customer Powered Data",
        description: "[Type: Label][Vis.: low] - Customers subtitle in NavBar submenu"
    },
    EMPLOYEES: {
        id: "NavSubmenuCopy.employees",
        defaultMessage: "Employees",
        description: "[Type: Label][Vis.: low] - Employees Section in NavBar submenu"
    },
    EMPLOYEES_SUBTITLE: {
        id: "NavSubmenuCopy.employeesSubtitle",
        defaultMessage: "Build a stronger workforce with Employee Powered Data",
        description: "[Type: Label][Vis.: low] - Employees subtitle in NavBar submenu"
    },
    MARKETS: {
        id: "NavSubmenuCopy.markets",
        defaultMessage: "Markets",
        description: "[Type: Label][Vis.: low] - Markets Section in NavBar submenu"
    },
    MARKETS_SUBTITLE: {
        id: "NavSubmenuCopy.marketsSubtitle",
        defaultMessage: "Validate business strategy with Market Powered Data",
        description: "[Type: Label][Vis.: low] - Markets subtitle in NavBar submenu"
    },
    CUSTOMER_EXPERIENCE: {
        id: "NavSubmenuCopy.customerExperience",
        defaultMessage: "Customer Experience",
        description: "[Type: Label][Vis.: low] - Customer Experience Section in NavBar submenu"
    },
    CUSTOMER_EXPERIENCE_SUBTITLE: {
        id: "NavSubmenuCopy.customerExperienceSubtitle",
        defaultMessage: "Delight customers & increase loyalty through feedback",
        description: "[Type: Label][Vis.: low] - Customer Experience subtitle in NavBar submenu"
    },
    HUMAN_RESOURCES: {
        id: "NavSubmenuCopy.humanResources",
        defaultMessage: "Human Resources",
        description: "[Type: Label][Vis.: low] - Human Resources Section in NavBar submenu"
    },
    HUMAN_RESOURCES_SUBTITLE: {
        id: "NavSubmenuCopy.humanResourcesSubtitle",
        defaultMessage: "Improve your employee experience, engagement & retention",
        description: "[Type: Label][Vis.: low] - Human Resources subtitle in NavBar submenu"
    },
    MARKETING: {
        id: "NavSubmenuCopy.marketing",
        defaultMessage: "Marketing",
        description: "[Type: Label][Vis.: low] - Marketing Section in NavBar submenu"
    },
    MARKETING_SUBTITLE: {
        id: "NavSubmenuCopy.marketingSubtitle",
        defaultMessage: "Create winning campaigns, boost ROI & drive growth",
        description: "[Type: Label][Vis.: low] - Marketing subtitle in NavBar submenu"
    },
    RESOURCES: {
        id: "NavSubmenuCopy.resources",
        defaultMessage: "Resources",
        description: "[Type: Label][Vis.: low] - Resources Section in NavBar submenu"
    },
    RESOURCES_SUBTITLE: {
        id: "NavSubmenuCopy.resourcesSubtitle",
        defaultMessage: "Best practices for using surveys & survey data",
        description: "[Type: Label][Vis.: low] - Resources subtitle in NavBar submenu"
    },
    BLOG: {
        id: "NavSubmenuCopy.blog",
        defaultMessage: "Curiosity at Work",
        description: "[Type: Label][Vis.: low] - Blog section in NavBar submenu"
    },
    BLOG_SUBTITLE: {
        id: "NavSubmenuCopy.blogSubtitle",
        defaultMessage: "Our blog about surveys, tips for business, & more",
        description: "[Type: Label][Vis.: low] - Blog subtitle in NavBar submenu"
    },
    HELP_CENTER: {
        id: "NavSubmenuCopy.helpCenter",
        defaultMessage: "Help Center",
        description: "[Type: Label][Vis.: low] - Help Center section in NavBar submenu"
    },
    BY_NEED: {
        id: "NavSubmenuCopy.byNeed",
        defaultMessage: "By Need",
        description: "[Type: Label][Vis.: med] - By need label for Nav Submenu"
    },
    HELP_CENTER_SUBTITLE: {
        id: "NavSubmenuCopy.helpCenterSubtitle",
        defaultMessage: "Survey how-to guides & tutorials ",
        description: "[Type: Label][Vis.: low] - Help Center Subtitle in NavBar submenu"
    },
    // english products bottom link
    ALL_PRODUCTS_LINK: {
        id: "NavSubmenuCopy.allProductsLink",
        defaultMessage: "View all products",
        description: "[Type: Label][Vis.: low] - View all Products Link in NavBar submenu"
    },
    // non english products bottom link
    PRODUCTS_LINK: {
        id: "NavSubmenuCopy.productsLink",
        defaultMessage: "VIEW ALL PRODUCTS",
        description: "[Type: Label][Vis.: low] - Products Link in NavBar submenu"
    },
    INTEGRATIONS_PLUGINS_LINK: {
        id: "NavSubmenuCopy.integrationsPluginsLink",
        defaultMessage: "ADD INTEGRATIONS & PLUG-INS",
        description: "[Type: Label][Vis.: low] - Integrations and plugins Link in NavBar submenu"
    },
    // english solutions bottom link
    VIEW_MORE_SURVEY_TYPES_LINK: {
        id: "NavSubmenuCopy.viewMoreSurveyTypes",
        defaultMessage: "Explore more survey types",
        description: "[Type: Label][Vis.: low] - Explore more survey types link in NavBar submenu"
    },
    // non english solutions bottom link
    VIEW_MORE_LINK: {
        id: "NavSubmenuCopy.viewMoreLink",
        defaultMessage: "VIEW MORE",
        description: "[Type: Label][Vis.: low] - View More in NavBar submenu"
    },
    EXPLORE_SURVEY_TEMPLATES_LINK: {
        id: "NavSubmenuCopy.exploreSurveyTemplates",
        defaultMessage: "Explore our 180+ survey templates",
        description: "[Type: Label][Vis.: low] - Explore Survey Templates section in NavBar submenu"
    }
})); //# sourceMappingURL=NavSubmenuCopy.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/Menu.js
var Menu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/Menu.js", Menu_this = undefined;







var Menu = function Menu(_ref) {
    var path = _ref.path, title = _ref.title, menuKey = _ref.menuKey, children = _ref.children, name = _ref.name;
    var _useContext = (0,react.useContext)(NavBarAnonContext), color = _useContext.color, submenuOpened = _useContext.submenuOpened, toggleSubmenu = _useContext.toggleSubmenu;
    var _useContext2 = (0,react.useContext)(Header_SMHeaderContext), excludeMenuItems = _useContext2.excludeMenuItems;
    var linksClassname = classnames_default()("sm-header__nav-cta--".concat(color), "sm-header__text", {
        "sm-header--open": submenuOpened === menuKey
    });
    if (excludeMenuItems.includes(name)) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, path === "" ? /*#__PURE__*/ react.createElement("div", {
        className: "wds-display--inline-block",
        key: menuKey,
        __self: Menu_this,
        __source: {
            fileName: Menu_jsxFileName,
            lineNumber: 25,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Button, {
        variant: "text",
        className: linksClassname,
        color: color,
        onClick: function onClick() {
            return toggleSubmenu(menuKey);
        },
        __self: Menu_this,
        __source: {
            fileName: Menu_jsxFileName,
            lineNumber: 26,
            columnNumber: 11
        }
    }, title, /*#__PURE__*/ react.createElement(react.Fragment, null, submenuOpened === menuKey ? /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconChevronUp */.y_Q, {
        size: "xs",
        __self: Menu_this,
        __source: {
            fileName: Menu_jsxFileName,
            lineNumber: 35,
            columnNumber: 17
        }
    }) : /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconChevronDown */.C26, {
        size: "xs",
        __self: Menu_this,
        __source: {
            fileName: Menu_jsxFileName,
            lineNumber: 37,
            columnNumber: 17
        }
    }))), children) : /*#__PURE__*/ react.createElement(wds_react.Button, {
        key: menuKey,
        variant: "text",
        color: color,
        href: path,
        className: "sm-header__nav-cta--".concat(color, " sm-header__text"),
        __self: Menu_this,
        __source: {
            fileName: Menu_jsxFileName,
            lineNumber: 44,
            columnNumber: 9
        }
    }, title));
};
Menu.propTypes = {
    path: (prop_types_default()).string,
    title: (prop_types_default()).string.isRequired,
    menuKey: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired,
    name: (prop_types_default()).string.isRequired
};
Menu.defaultProps = {
    path: ""
};
/* harmony default export */ var components_Menu = (Menu); //# sourceMappingURL=Menu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/SubMenu.js
var SubMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SubMenu.js", SubMenu_this = undefined;






var SubMenu = function SubMenu(_ref) {
    var submenuKey = _ref.submenuKey, title = _ref.title, children = _ref.children;
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    var _useContext2 = (0,react.useContext)(NavBarAnonContext), submenuOpened = _useContext2.submenuOpened;
    var submenuClassname = classnames_default()("sm-nav-submenu__container", "sm-nav-submenu__".concat(submenuKey.toLowerCase()), "sm-utils--text-align-left", {
        "sm-nav-submenu--en": lang === "en"
    }, {
        "sm-nav-submenu--de": lang === "de"
    }, {
        "sm-nav-submenu--fr": lang === "fr"
    }, {
        "sm-nav-submenu--locale": lang !== "en"
    }, {
        "sm-nav-submenu--open": submenuOpened === submenuKey
    });
    return /*#__PURE__*/ react.createElement("div", {
        className: submenuClassname,
        __self: SubMenu_this,
        __source: {
            fileName: SubMenu_jsxFileName,
            lineNumber: 24,
            columnNumber: 5
        }
    }, lang !== "en" && /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "sectionTitle",
        className: "sm-nav-submenu__title sm-utils--text-align-center sm-utils--mw-90 sm-utils--mx-auto sm-utils--text-overflow-break",
        __self: SubMenu_this,
        __source: {
            fileName: SubMenu_jsxFileName,
            lineNumber: 26,
            columnNumber: 9
        }
    }, title), children);
};
/* harmony default export */ var components_SubMenu = (SubMenu);
SubMenu.propTypes = {
    title: (prop_types_default()).string.isRequired,
    submenuKey: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired
}; //# sourceMappingURL=SubMenu.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/Submenu/nav-submenu.scss
var nav_submenu = __webpack_require__(136);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/SubMenuBody.js
var SubMenuBody_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SubMenuBody.js", SubMenuBody_this = undefined;





var SubMenuBody = function SubMenuBody(_ref) {
    var children = _ref.children;
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    return /*#__PURE__*/ react.createElement(wds_react.Grid, {
        noBleeds: lang === "en",
        __self: SubMenuBody_this,
        __source: {
            fileName: SubMenuBody_jsxFileName,
            lineNumber: 11,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Row, {
        className: "sm-nav-submenu__row",
        __self: SubMenuBody_this,
        __source: {
            fileName: SubMenuBody_jsxFileName,
            lineNumber: 12,
            columnNumber: 7
        }
    }, children));
};
SubMenuBody.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var components_SubMenuBody = (SubMenuBody); //# sourceMappingURL=SubMenuBody.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/BottomLinkWrapper.js
var BottomLinkWrapper_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/BottomLinkWrapper.js", BottomLinkWrapper_this = undefined;



var BottomLinkWrapper = function BottomLinkWrapper(_ref) {
    var children = _ref.children;
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    return /*#__PURE__*/ react.createElement("div", {
        className: "sm-nav-submenu__bottom-container sm-nav-submenu--".concat(lang),
        __self: BottomLinkWrapper_this,
        __source: {
            fileName: BottomLinkWrapper_jsxFileName,
            lineNumber: 8,
            columnNumber: 5
        }
    }, children);
};
BottomLinkWrapper.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var components_BottomLinkWrapper = (BottomLinkWrapper); //# sourceMappingURL=BottomLinkWrapper.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/BottomLink.js
var BottomLink_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/BottomLink.js", BottomLink_this = undefined;




var BottomLink = function BottomLink(_ref) {
    var title = _ref.title, url = _ref.url, alignment = _ref.alignment;
    return /*#__PURE__*/ react.createElement(wds_react.Button, {
        size: "sm",
        color: "link",
        variant: "text",
        className: "sm-nav-submenu__button wds-float--".concat(alignment),
        href: url,
        __self: BottomLink_this,
        __source: {
            fileName: BottomLink_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, title, /*#__PURE__*/ react.createElement(wds_react.Icon, {
        __self: BottomLink_this,
        __source: {
            fileName: BottomLink_jsxFileName,
            lineNumber: 17,
            columnNumber: 7
        }
    }, "]"));
};
/* harmony default export */ var components_BottomLink = (BottomLink);
BottomLink.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    alignment: (prop_types_default()).string.isRequired
}; //# sourceMappingURL=BottomLink.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/ColumnTitle.js
var ColumnTitle_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/ColumnTitle.js", ColumnTitle_this = undefined;




var ColumnTitle = function ColumnTitle(_ref) {
    var title = _ref.title;
    return /*#__PURE__*/ react.createElement(wds_react.ListItem, {
        key: title,
        className: "sm-nav-submenu__list-item",
        __self: ColumnTitle_this,
        __source: {
            fileName: ColumnTitle_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "body",
        color: "dark",
        className: "sm-nav-submenu__column-title",
        __self: ColumnTitle_this,
        __source: {
            fileName: ColumnTitle_jsxFileName,
            lineNumber: 10,
            columnNumber: 7
        }
    }, title));
};
/* harmony default export */ var components_ColumnTitle = (ColumnTitle);
ColumnTitle.propTypes = {
    title: (prop_types_default()).string.isRequired
}; //# sourceMappingURL=ColumnTitle.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/SubMenuItem.js
var SubMenuItem_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SubMenuItem.js", SubMenuItem_this = undefined;





var SubMenuItem = function SubMenuItem(_ref) {
    var subTitle = _ref.subTitle, title = _ref.title, url = _ref.url, openInNewWindow = _ref.openInNewWindow, name = _ref.name;
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), excludeMenuItems = _useContext.excludeMenuItems;
    if (excludeMenuItems.includes(name)) return null;
    return /*#__PURE__*/ react.createElement(wds_react.ListItem, Object.assign({
        key: title,
        className: "sm-nav-submenu__list-item",
        isNavigable: true,
        navigationTarget: url
    }, openInNewWindow === true && {
        target: "_blank",
        rel: "noopener noreferrer"
    }, {
        __self: SubMenuItem_this,
        __source: {
            fileName: SubMenuItem_jsxFileName,
            lineNumber: 21,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "cardTitle",
        color: "link",
        className: "sm-nav-submenu__product-title",
        __self: SubMenuItem_this,
        __source: {
            fileName: SubMenuItem_jsxFileName,
            lineNumber: 31,
            columnNumber: 7
        }
    }, title), /*#__PURE__*/ react.createElement("p", {
        className: "sm-nav-submenu__product-subtitle",
        __self: SubMenuItem_this,
        __source: {
            fileName: SubMenuItem_jsxFileName,
            lineNumber: 38,
            columnNumber: 7
        }
    }, subTitle));
};
/* harmony default export */ var components_SubMenuItem = (SubMenuItem);
SubMenuItem.propTypes = {
    subTitle: (prop_types_default()).string.isRequired,
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    openInNewWindow: (prop_types_default()).bool,
    name: (prop_types_default()).string.isRequired
};
SubMenuItem.defaultProps = {
    openInNewWindow: false
}; //# sourceMappingURL=SubMenuItem.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/Column.js
var Column_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/Column.js", Column_this = undefined;




var Column = function Column(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ react.createElement(wds_react.Col, {
        className: "sm-nav-submenu__col",
        __self: Column_this,
        __source: {
            fileName: Column_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.List, {
        transparent: true,
        interactive: true,
        __self: Column_this,
        __source: {
            fileName: Column_jsxFileName,
            lineNumber: 10,
            columnNumber: 7
        }
    }, children));
};
/* harmony default export */ var components_Column = (Column);
Column.propTypes = {
    children: (prop_types_default()).node.isRequired
}; //# sourceMappingURL=Column.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/copy/NavBarCopy.js

/* harmony default export */ var NavBarCopy = ((0,intl_dist/* defineMessages */.vU)({
    PRODUCTS: {
        id: "NavBarCopy.products",
        defaultMessage: "Products",
        description: "[Type: Label][Vis.: low] - Products section of nav bar"
    },
    SOLUTIONS: {
        id: "NavBarCopy.solutions",
        defaultMessage: "Solutions",
        description: "[Type: Label][Vis.: low] - Solutions section of nav bar"
    },
    RESOURCES: {
        id: "NavBarCopy.resources",
        defaultMessage: "Resources",
        description: "[Type: Label][Vis.: low] - Resources section of nav bar"
    },
    HELP_CENTER: {
        id: "NavBarCopy.helpCenter",
        defaultMessage: "Help Center",
        description: "[Type: Label][Vis.: low] - Help Center section of nav bar"
    },
    PLANS_AND_PRICING: {
        id: "NavBarCopy.plansAndPricing",
        defaultMessage: "Plans & Pricing",
        description: "[Type: Label][Vis.: low] - Plans & Pricing section of nav bar"
    },
    DASHBOARD: {
        id: "NavBarCopy.dashboard",
        defaultMessage: "Dashboard",
        description: "[Type: Label][Vis.: low] - Dashboards section of nav bar"
    },
    MY_SURVEYS: {
        id: "NavBarCopy.mySurveys",
        defaultMessage: "My Surveys",
        description: "[Type: Label][Vis.: low] - My surveys section of nav bar"
    },
    MY_TEAM: {
        id: "NavBarCopy.myTeam",
        defaultMessage: "My Team",
        description: "[Type: Label][Vis.: low] - My team section of nav bar"
    }
})); //# sourceMappingURL=NavBarCopy.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/config/linkInfo.js






// Main Title Links
var productsMenu = function productsMenu() {
    return {
        name: "anon_products_menu",
        title: (0,intl_dist.t)(NavBarCopy.PRODUCTS)
    };
};
var solutionsMenu = function solutionsMenu() {
    return {
        name: "anon_solutions_menu",
        title: (0,intl_dist.t)(NavBarCopy.SOLUTIONS)
    };
};
var resourcesMenu = function resourcesMenu() {
    return {
        name: "anon_resources_menu",
        title: (0,intl_dist.t)(NavBarCopy.RESOURCES)
    };
};
var plansPricingMenu = function plansPricingMenu() {
    return {
        name: "anon_plans_pricing_menu",
        title: (0,intl_dist.t)(NavBarCopy.PLANS_AND_PRICING),
        url: (0,dist.createURL)("/pricing/", {
            ut_source: "megamenu"
        })
    };
};
var helpCenterMenu = function helpCenterMenu() {
    return {
        name: "anon_help_center_menu",
        title: (0,intl_dist.t)(NavBarCopy.HELP_CENTER),
        url: getHelpLink_getHelpCenterLink("en", {
            params: {
                ut_source: "megamenu"
            }
        })
    };
};
var mobileHelpCenterMenu = function mobileHelpCenterMenu(lang) {
    return {
        name: "anon_mobile_help_center_menu",
        title: (0,intl_dist.t)(NavBarCopy.HELP_CENTER),
        url: getHelpLink_getHelpCenterLink(lang, {
            params: {
                ut_source: "megamenu"
            }
        })
    };
};
// Column Title Links
var surveys = function surveys() {
    return {
        name: "anon_surveys",
        title: (0,intl_dist.t)(NavSubmenuCopy.SURVEYS)
    };
};
var none = function none() {
    return {
        name: "anon_no_column_title",
        title: ""
    };
};
var specializedProducts = function specializedProducts() {
    return {
        name: "anon_specialized_products",
        title: (0,intl_dist.t)(NavSubmenuCopy.SPECIALIZED_PRODUCTS)
    };
};
var formsWorkFlows = function formsWorkFlows() {
    return {
        name: "anon_forms_workflows",
        title: (0,intl_dist.t)(NavSubmenuCopy.FORMS_AND_WORKFLOWS)
    };
};
var peoplePoweredData = function peoplePoweredData() {
    return {
        name: "anon_people_powered_data",
        title: (0,intl_dist.t)(NavSubmenuCopy.PEOPLE_POWERED_DATA)
    };
};
var solutionsForTeams = function solutionsForTeams() {
    return {
        name: "anon_solutions_for_teams",
        title: (0,intl_dist.t)(NavSubmenuCopy.SOLUTIONS_FOR_TEAMS)
    };
};
// SubMenu Links
var surveymonkey = function surveymonkey() {
    return {
        name: "anon_surveymonkey",
        title: "SurveyMonkey",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.SURVEYMONKEY_SUBTITLE),
        url: (0,dist.createURL)("/mp/take-a-tour/", {
            ut_source: "megamenu"
        })
    };
};
var enterprise = function enterprise() {
    return {
        name: "anon_enterprise",
        title: "Enterprise",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.ENTERPRISE_SUBTITLE),
        url: (0,dist.createURL)("/mp/enterprise/", {
            ut_source: "megamenu"
        })
    };
};
var integrations = function integrations() {
    return {
        name: "anon_integrations_plugins",
        title: (0,intl_dist.t)(NavSubmenuCopy.INTEGRATIONS_PLUGINS),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.INTEGRATIONS_PLUGINS_SUBTITLE),
        url: (0,dist.createURL)("/apps/", {
            ut_source: "megamenu"
        })
    };
};
var audience = function audience() {
    return {
        name: "anon_audience",
        title: "Audience",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.AUDIENCE_SUBTITLE),
        url: (0,dist.createURL)("/market-research/solutions/audience-panel/", {
            ut_source: "megamenu"
        }),
        excludeForEUDC: true
    };
};
var cx = function cx() {
    return {
        name: "anon_cx",
        title: "CX",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.CX_SUBTITLE),
        url: (0,dist.createURL)("/cx/", {
            ut_source: "megamenu"
        })
    };
};
var engage = function engage() {
    return {
        name: "anon_engage",
        title: "Engage",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.ENGAGE_SUBTITLE),
        url: (0,dist.createURL)("https://www.surveymonkey.com/engage/", {
            ut_source: "megamenu"
        })
    };
};
var usabilla = function usabilla(lang) {
    return {
        name: "anon_usabilla",
        title: "Usabilla",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.USABILLA_SUBTITLE),
        url: (0,dist.createURL)(languageHelpers_usabillaLink(lang), {
            utm_source: "megamenu"
        })
    };
};
var techValidate = function techValidate() {
    return {
        name: "anon_techvalidate",
        title: "TechValidate",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.TECH_VALIDATE_SUBTITLE),
        url: (0,dist.createURL)("https://www.surveymonkey.com/techvalidate/", {
            ut_source: "megamenu"
        })
    };
};
var apply = function apply() {
    return {
        name: "anon_apply",
        title: "Apply",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.APPLY_SUBTITLE),
        url: (0,dist.createURL)("https://apply.surveymonkey.com/", {
            ut_source: "megamenu"
        })
    };
};
var wufoo = function wufoo() {
    return {
        name: "anon_wufoo",
        title: "Wufoo",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.WUFOO_SUBTITLE),
        url: (0,dist.createURL)("https://www.wufoo.com/", {
            ut_source: "megamenu"
        })
    };
};
var getFeedback = function getFeedback() {
    return {
        name: "anon_getfeedback",
        title: "GetFeedback",
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.GET_FEEDBACK_SUBTITLE),
        url: (0,dist.createURL)("https://www.getfeedback.com/", {
            utm_source: "surveymonkey"
        }),
        openInNewWindow: true
    };
};
var customerSatisfaction = function customerSatisfaction() {
    return {
        name: "anon_customer_satisfaction",
        title: (0,intl_dist.t)(NavSubmenuCopy.CUSTOMER_SATISFACTION),
        url: (0,dist.createURL)("/mp/customer-satisfaction-surveys/", {
            ut_source: "megamenu"
        })
    };
};
var customerLoyalty = function customerLoyalty() {
    return {
        name: "anon_customer_loyalty",
        title: (0,intl_dist.t)(NavSubmenuCopy.CUSTOMER_LOYALTY),
        url: (0,dist.createURL)("/mp/customer-loyalty-surveys/", {
            ut_source: "megamenu"
        })
    };
};
var eventSurveys = function eventSurveys() {
    return {
        name: "anon_event_surveys",
        title: (0,intl_dist.t)(NavSubmenuCopy.EVENT_SURVEYS),
        url: (0,dist.createURL)("/mp/event-planning-surveys/", {
            ut_source: "megamenu"
        })
    };
};
var employeeEngagement = function employeeEngagement() {
    return {
        name: "anon_employee_engagement",
        title: (0,intl_dist.t)(NavSubmenuCopy.EMPLOYEE_ENGAGEMENT),
        url: (0,dist.createURL)("/mp/employee-surveys/", {
            ut_source: "megamenu"
        })
    };
};
var jobSatisfaction = function jobSatisfaction() {
    return {
        name: "anon_job_satisfaction",
        title: (0,intl_dist.t)(NavSubmenuCopy.JOB_SATISFACTION),
        url: (0,dist.createURL)("/mp/job-satisfaction-survey/", {
            ut_source: "megamenu"
        })
    };
};
var hrSurveys = function hrSurveys() {
    return {
        name: "anon_hr_surveys",
        title: (0,intl_dist.t)(NavSubmenuCopy.HR_SURVEYS),
        url: (0,dist.createURL)("/mp/human-resource-surveys/", {
            ut_source: "megamenu"
        })
    };
};
var marketResearchSurveys = function marketResearchSurveys() {
    return {
        name: "anon_market_research_surveys",
        title: (0,intl_dist.t)(NavSubmenuCopy.MARKET_RESEARCH),
        url: (0,dist.createURL)("/mp/market-research-surveys/", {
            ut_source: "megamenu"
        })
    };
};
var opinionPolls = function opinionPolls() {
    return {
        name: "anon_opinion_polls",
        title: (0,intl_dist.t)(NavSubmenuCopy.OPINION_POLLS),
        url: (0,dist.createURL)("/mp/online-polls/", {
            ut_source: "megamenu"
        })
    };
};
var conceptTesting = function conceptTesting() {
    return {
        name: "anon_concept_testing",
        title: (0,intl_dist.t)(NavSubmenuCopy.CONCEPT_TESTING),
        url: (0,dist.createURL)("/mp/concept-testing/", {
            ut_source: "megamenu"
        })
    };
};
var customerFeedback = function customerFeedback() {
    return {
        name: "anon_customer_feedback",
        title: (0,intl_dist.t)(NavSubmenuCopy.CUSTOMERS),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.CUSTOMERS_SUBTITLE),
        url: (0,dist.createURL)("/mp/customer-feedback/", {
            ut_source: "megamenu"
        })
    };
};
var employeeFeedback = function employeeFeedback() {
    return {
        name: "anon_employee_feedback",
        title: (0,intl_dist.t)(NavSubmenuCopy.EMPLOYEES),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.EMPLOYEES_SUBTITLE),
        url: (0,dist.createURL)("/mp/employee-feedback/", {
            ut_source: "megamenu"
        })
    };
};
var marketResearch = function marketResearch() {
    return {
        name: "anon_market_research",
        title: (0,intl_dist.t)(NavSubmenuCopy.MARKETS),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.MARKETS_SUBTITLE),
        url: (0,dist.createURL)("/market-research/", {
            ut_source: "megamenu"
        })
    };
};
var customerExperience = function customerExperience() {
    return {
        name: "anon_customer_experience",
        title: (0,intl_dist.t)(NavSubmenuCopy.CUSTOMER_EXPERIENCE),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.CUSTOMER_EXPERIENCE_SUBTITLE),
        url: (0,dist.createURL)("/mp/customer-experience-solutions/", {
            ut_source: "megamenu"
        })
    };
};
var humanResources = function humanResources() {
    return {
        name: "anon_human_resources",
        title: (0,intl_dist.t)(NavSubmenuCopy.HUMAN_RESOURCES),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.HUMAN_RESOURCES_SUBTITLE),
        url: (0,dist.createURL)("/mp/hr-solutions/", {
            ut_source: "megamenu"
        })
    };
};
var marketing = function marketing() {
    return {
        name: "anon_marketing",
        title: (0,intl_dist.t)(NavSubmenuCopy.MARKETING),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.MARKETING_SUBTITLE),
        url: (0,dist.createURL)("/mp/marketing-solutions/", {
            ut_source: "megamenu"
        })
    };
};
var resources = function resources() {
    return {
        name: "anon_resources",
        title: (0,intl_dist.t)(NavSubmenuCopy.RESOURCES),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.RESOURCES_SUBTITLE),
        url: (0,dist.createURL)("/resources/", {
            ut_source: "megamenu"
        })
    };
};
var blog = function blog() {
    return {
        name: "anon_blog",
        title: (0,intl_dist.t)(NavSubmenuCopy.BLOG),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.BLOG_SUBTITLE),
        url: (0,dist.createURL)("/curiosity/", {
            ut_source: "megamenu"
        })
    };
};
var helpCenter = function helpCenter(lang) {
    return {
        name: "anon_help_center",
        title: (0,intl_dist.t)(NavSubmenuCopy.HELP_CENTER),
        subTitle: (0,intl_dist.t)(NavSubmenuCopy.HELP_CENTER_SUBTITLE),
        url: getHelpLink_getHelpCenterLink(lang, {
            params: {
                ut_source: "megamenu"
            }
        })
    };
};
// Bottom Links
var viewAllProducts = function viewAllProducts(lang) {
    return {
        name: "anon_view_all_products",
        title: lang === "en" ? (0,intl_dist.t)(NavSubmenuCopy.ALL_PRODUCTS_LINK) : (0,intl_dist.t)(NavSubmenuCopy.PRODUCTS_LINK),
        alignment: lang === "en" ? "left" : "right",
        url: (0,dist.createURL)(lang === "en" ? "/what-is-surveymonkey/" : "/business/", {
            ut_source: "megamenu"
        })
    };
};
var addIntegrations = function addIntegrations() {
    return {
        name: "anon_integrations_plugins",
        title: (0,intl_dist.t)(NavSubmenuCopy.INTEGRATIONS_PLUGINS_LINK),
        alignment: "left",
        url: (0,dist.createURL)("/apps/", {
            ut_source: "megamenu"
        })
    };
};
var exploreSurveyTypes = function exploreSurveyTypes(lang) {
    return {
        name: "anon_explore_survey_types",
        title: lang === "en" ? (0,intl_dist.t)(NavSubmenuCopy.VIEW_MORE_SURVEY_TYPES_LINK) : (0,intl_dist.t)(NavSubmenuCopy.VIEW_MORE_LINK),
        alignment: lang === "en" ? "left" : "right",
        url: (0,dist.createURL)("/mp/survey-types/", {
            ut_source: "megamenu"
        })
    };
};
var exploreSurveyTemplates = function exploreSurveyTemplates() {
    return {
        name: "anon_explore_survey_templates",
        title: (0,intl_dist.t)(NavSubmenuCopy.EXPLORE_SURVEY_TEMPLATES_LINK),
        alignment: "right",
        url: (0,dist.createURL)("/mp/sample-survey-questionnaire-templates/", {
            ut_source: "megamenu"
        })
    };
};
/**
 * @deprecated
 * To be used for js files of the legacy header
 * the new header can use VALID_MENU_NAME_LIST
 * in src/components/Header/wrench/types.ts
 */ var ValidMenuNameList = [
    "anon_products_menu",
    "anon_solutions_menu",
    "anon_resources_menu",
    "anon_plans_pricing_menu",
    "anon_help_center_menu",
    "anon_surveymonkey",
    "anon_enterprise",
    "anon_integrations_plugins",
    "anon_audience",
    "anon_cx",
    "anon_engage",
    "anon_usabilla",
    "anon_techvalidate",
    "anon_apply",
    "anon_wufoo",
    "anon_getfeedback",
    "anon_customer_satisfaction",
    "anon_customer_loyalty",
    "anon_event_surveys",
    "anon_employee_engagement",
    "anon_job_satisfaction",
    "anon_hr_surveys",
    "anon_market_research_surveys",
    "anon_opinion_polls",
    "anon_concept_testing",
    "anon_customer_feedback",
    "anon_employee_feedback",
    "anon_market_research",
    "anon_customer_experience",
    "anon_human_resources",
    "anon_marketing",
    "anon_resources",
    "anon_blog",
    "anon_help_center"
]; //# sourceMappingURL=linkInfo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/ProductsMenu.js
var ProductsMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/ProductsMenu.js", ProductsMenu_this = undefined;













var ProductMenu = function ProductMenu() {
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang, isEUDC = _useContext.isEUDC;
    var key = "Products";
    var subMenuTitle = (0,intl_dist.t)(NavSubmenuCopy.PRODUCTS_TITLE);
    return /*#__PURE__*/ react.createElement(components_Menu, Object.assign({
        menuKey: key
    }, productsMenu(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 43,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(components_SubMenu, {
        submenuKey: key,
        title: subMenuTitle,
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 44,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuBody, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 45,
            columnNumber: 9
        }
    }, lang === "en" ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_Column, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 49,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_ColumnTitle, Object.assign({}, surveys(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 50,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, surveymonkey(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 51,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, enterprise(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 52,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, integrations(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 53,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 55,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_ColumnTitle, Object.assign({}, specializedProducts(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 56,
            columnNumber: 17
        }
    })), !isEUDC ? /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, audience(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 57,
            columnNumber: 28
        }
    })) : null, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, cx(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 58,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, engage(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 59,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, usabilla(lang), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 60,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 62,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_ColumnTitle, Object.assign({}, none(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 63,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, techValidate(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 64,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, apply(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 65,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, wufoo(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 66,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, getFeedback(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 67,
            columnNumber: 17
        }
    })))) : lang === "fr" ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_Column, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 72,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_ColumnTitle, Object.assign({}, surveys(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 73,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, surveymonkey(lang), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 74,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, audience(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 75,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 77,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_ColumnTitle, Object.assign({}, formsWorkFlows(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 78,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, apply(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 79,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, usabilla(lang), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 80,
            columnNumber: 17
        }
    })))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_Column, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 85,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, surveymonkey(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 86,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 88,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, audience(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 89,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, usabilla(lang), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 90,
            columnNumber: 17
        }
    }))))), /*#__PURE__*/ react.createElement(components_BottomLinkWrapper, {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 96,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(components_BottomLink, Object.assign({}, viewAllProducts(lang), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 97,
            columnNumber: 11
        }
    })), lang !== "en" ? /*#__PURE__*/ react.createElement(components_BottomLink, Object.assign({}, addIntegrations(), {
        __self: ProductsMenu_this,
        __source: {
            fileName: ProductsMenu_jsxFileName,
            lineNumber: 98,
            columnNumber: 28
        }
    })) : null)));
};
/* harmony default export */ var ProductsMenu = ((/* unused pure expression or super */ null && (ProductMenu))); //# sourceMappingURL=ProductsMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/ByNeedSubMenu.js
var ByNeedSubMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/ByNeedSubMenu.js", ByNeedSubMenu_this = undefined;





var ByNeedSubMenu = function ByNeedSubMenu(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ react.createElement(wds_react.Grid, {
        __self: ByNeedSubMenu_this,
        __source: {
            fileName: ByNeedSubMenu_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "cardTitle",
        color: "dark",
        className: "sm-nav-submenu__by-need-title",
        __self: ByNeedSubMenu_this,
        __source: {
            fileName: ByNeedSubMenu_jsxFileName,
            lineNumber: 10,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: NavSubmenuCopy.BY_NEED,
        __self: ByNeedSubMenu_this,
        __source: {
            fileName: ByNeedSubMenu_jsxFileName,
            lineNumber: 15,
            columnNumber: 9
        }
    })), /*#__PURE__*/ react.createElement(wds_react.Row, {
        className: "submenu-lo--row",
        __self: ByNeedSubMenu_this,
        __source: {
            fileName: ByNeedSubMenu_jsxFileName,
            lineNumber: 17,
            columnNumber: 7
        }
    }, children));
};
/* harmony default export */ var components_ByNeedSubMenu = (ByNeedSubMenu);
ByNeedSubMenu.propTypes = {
    children: (prop_types_default()).node.isRequired
}; //# sourceMappingURL=ByNeedSubMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/SurveyTypesColumn.js
var SurveyTypesColumn_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SurveyTypesColumn.js", SurveyTypesColumn_this = undefined;




var SurveyTypesColumn = function SurveyTypesColumn(_ref) {
    var children = _ref.children, title = _ref.title;
    return /*#__PURE__*/ react.createElement(wds_react.Col, {
        className: "sm-nav-submenu__col",
        __self: SurveyTypesColumn_this,
        __source: {
            fileName: SurveyTypesColumn_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "cardTitle",
        color: "dark",
        className: "sm-nav-submenu__column-title",
        __self: SurveyTypesColumn_this,
        __source: {
            fileName: SurveyTypesColumn_jsxFileName,
            lineNumber: 10,
            columnNumber: 7
        }
    }, title), children);
};
/* harmony default export */ var components_SurveyTypesColumn = (SurveyTypesColumn);
SurveyTypesColumn.propTypes = {
    children: (prop_types_default()).node.isRequired,
    title: (prop_types_default()).string.isRequired
}; //# sourceMappingURL=SurveyTypesColumn.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/ByNeedColumn.js
var ByNeedColumn_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/ByNeedColumn.js", ByNeedColumn_this = undefined;




var ByNeedColumn = function ByNeedColumn(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ react.createElement(wds_react.Col, {
        className: "sm-nav-submenu__col",
        __self: ByNeedColumn_this,
        __source: {
            fileName: ByNeedColumn_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.List, {
        __self: ByNeedColumn_this,
        __source: {
            fileName: ByNeedColumn_jsxFileName,
            lineNumber: 10,
            columnNumber: 7
        }
    }, children));
};
/* harmony default export */ var components_ByNeedColumn = (ByNeedColumn);
ByNeedColumn.propTypes = {
    children: (prop_types_default()).node.isRequired
}; //# sourceMappingURL=ByNeedColumn.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/Block.js
var Block_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/Block.js", Block_this = undefined;




var Block = function Block(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ react.createElement(wds_react.Container, {
        mt: "5",
        mb: "5",
        ml: "4",
        mr: "4",
        key: "CustomerSatisfaction",
        className: "sm-nav-submenu__by-need-container",
        __self: Block_this,
        __source: {
            fileName: Block_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, children);
};
/* harmony default export */ var components_Block = (Block);
Block.propTypes = {
    children: (prop_types_default()).node.isRequired
}; //# sourceMappingURL=Block.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/SolutionByNeed.js
var SolutionByNeed_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SolutionByNeed.js", SolutionByNeed_this = undefined;





var SolutionByNeed = function SolutionByNeed(_ref) {
    var title = _ref.title, url = _ref.url, name = _ref.name;
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), excludeMenuItems = _useContext.excludeMenuItems;
    if (excludeMenuItems.includes(name)) return null;
    return /*#__PURE__*/ react.createElement(wds_react.ListItem, {
        key: title,
        className: "sm-nav-submenu__by-need-container",
        isNavigable: true,
        navigationTarget: url,
        __self: SolutionByNeed_this,
        __source: {
            fileName: SolutionByNeed_jsxFileName,
            lineNumber: 15,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "body",
        color: "link",
        className: "sm-nav-submenu__by-need",
        __self: SolutionByNeed_this,
        __source: {
            fileName: SolutionByNeed_jsxFileName,
            lineNumber: 21,
            columnNumber: 7
        }
    }, title));
};
/* harmony default export */ var components_SolutionByNeed = (SolutionByNeed);
SolutionByNeed.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    name: (prop_types_default()).string.isRequired
}; //# sourceMappingURL=SolutionByNeed.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/components/SurveySolution.js
var SurveySolution_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SurveySolution.js", SurveySolution_this = undefined;





var SurveySolution = function SurveySolution(_ref) {
    var title = _ref.title, url = _ref.url, name = _ref.name;
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), excludeMenuItems = _useContext.excludeMenuItems;
    if (excludeMenuItems.includes(name)) return null;
    return /*#__PURE__*/ react.createElement("a", {
        key: title,
        className: "sm-nav-submenu__link-item",
        href: url,
        __self: SurveySolution_this,
        __source: {
            fileName: SurveySolution_jsxFileName,
            lineNumber: 15,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Typography, {
        color: "link",
        __self: SurveySolution_this,
        __source: {
            fileName: SurveySolution_jsxFileName,
            lineNumber: 16,
            columnNumber: 7
        }
    }, title));
};
/* harmony default export */ var components_SurveySolution = (SurveySolution);
SurveySolution.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    name: (prop_types_default()).string.isRequired
}; //# sourceMappingURL=SurveySolution.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/SolutionsMenu.js
var SolutionsMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/SolutionsMenu.js", SolutionsMenu_this = undefined;



















var SolutionsMenu = function SolutionsMenu() {
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    var key = "Solutions";
    var subMenuTitle = (0,intl_dist.t)(NavSubmenuCopy.SOLUTIONS_TITLE);
    return /*#__PURE__*/ react.createElement(components_Menu, Object.assign({
        menuKey: key
    }, solutionsMenu(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 50,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(components_SubMenu, {
        submenuKey: key,
        title: subMenuTitle,
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 51,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuBody, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 52,
            columnNumber: 9
        }
    }, lang === "en" ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_SurveyTypesColumn, {
        title: "Survey Types",
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 55,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_Block, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 56,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, customerSatisfaction(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 57,
            columnNumber: 19
        }
    })), /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, customerLoyalty(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 58,
            columnNumber: 19
        }
    })), /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, eventSurveys(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 59,
            columnNumber: 19
        }
    }))), /*#__PURE__*/ react.createElement(components_Block, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 61,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, employeeEngagement(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 62,
            columnNumber: 19
        }
    })), /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, jobSatisfaction(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 63,
            columnNumber: 19
        }
    })), /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, hrSurveys(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 64,
            columnNumber: 19
        }
    }))), /*#__PURE__*/ react.createElement(components_Block, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 66,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, marketResearchSurveys(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 67,
            columnNumber: 19
        }
    })), /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, opinionPolls(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 68,
            columnNumber: 19
        }
    })), /*#__PURE__*/ react.createElement(components_SurveySolution, Object.assign({}, conceptTesting(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 69,
            columnNumber: 19
        }
    })))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 72,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_ColumnTitle, Object.assign({}, peoplePoweredData(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 73,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, customerFeedback(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 74,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, employeeFeedback(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 75,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, marketResearch(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 76,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 78,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_ColumnTitle, Object.assign({}, solutionsForTeams(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 79,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, customerExperience(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 80,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, humanResources(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 81,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, marketing(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 82,
            columnNumber: 17
        }
    })))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_Column, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 87,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, customerFeedback(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 88,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 90,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, employeeFeedback(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 91,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 93,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, marketResearch(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 94,
            columnNumber: 17
        }
    }))))), lang !== "en" ? /*#__PURE__*/ react.createElement(components_ByNeedSubMenu, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 100,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(components_ByNeedColumn, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 101,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, customerSatisfaction(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 102,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, customerLoyalty(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 103,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, eventSurveys(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 104,
            columnNumber: 15
        }
    }))), /*#__PURE__*/ react.createElement(components_ByNeedColumn, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 106,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, employeeEngagement(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 107,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, jobSatisfaction(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 108,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, hrSurveys(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 109,
            columnNumber: 15
        }
    }))), /*#__PURE__*/ react.createElement(components_ByNeedColumn, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 111,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, marketResearchSurveys(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 112,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, opinionPolls(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 113,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(components_SolutionByNeed, Object.assign({}, conceptTesting(), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 114,
            columnNumber: 15
        }
    })))) : null, /*#__PURE__*/ react.createElement(components_BottomLinkWrapper, {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 118,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(components_BottomLink, Object.assign({}, exploreSurveyTypes(lang), {
        __self: SolutionsMenu_this,
        __source: {
            fileName: SolutionsMenu_jsxFileName,
            lineNumber: 119,
            columnNumber: 11
        }
    })))));
};
/* harmony default export */ var Desktop_SolutionsMenu = ((/* unused pure expression or super */ null && (SolutionsMenu))); //# sourceMappingURL=SolutionsMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/ResourcesMenu.js
var ResourcesMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/ResourcesMenu.js", ResourcesMenu_this = undefined;












var ResourcesMenu = function ResourcesMenu() {
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    var key = "Resources";
    var subMenuTitle = (0,intl_dist.t)(NavSubmenuCopy.RESOURCES_TITLE);
    return /*#__PURE__*/ react.createElement(components_Menu, Object.assign({
        menuKey: key
    }, resourcesMenu(), {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 29,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(components_SubMenu, {
        submenuKey: key,
        title: subMenuTitle,
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 30,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuBody, {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 31,
            columnNumber: 9
        }
    }, lang === "en" ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_Column, {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 34,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, resources(), {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 35,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 37,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, blog(), {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 38,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 40,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, helpCenter(lang), {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 41,
            columnNumber: 17
        }
    })))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(components_Column, {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 46,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, blog(), {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 47,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(components_Column, {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 49,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(components_SubMenuItem, Object.assign({}, helpCenter(lang), {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 50,
            columnNumber: 17
        }
    }))))), lang === "en" ? /*#__PURE__*/ react.createElement(components_BottomLinkWrapper, {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 57,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(components_BottomLink, Object.assign({}, exploreSurveyTemplates(), {
        __self: ResourcesMenu_this,
        __source: {
            fileName: ResourcesMenu_jsxFileName,
            lineNumber: 58,
            columnNumber: 13
        }
    }))) : null));
};
/* harmony default export */ var Desktop_ResourcesMenu = ((/* unused pure expression or super */ null && (ResourcesMenu))); //# sourceMappingURL=ResourcesMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/PlansAndPricingMenu.js
var PlansAndPricingMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/PlansAndPricingMenu.js", PlansAndPricingMenu_this = undefined;




var PlansAndPricingMenu = function PlansAndPricingMenu() {
    var path = (0,dist.createURL)("/pricing/", {
        ut_source: "megamenu"
    });
    var key = "Plans & Pricing";
    return /*#__PURE__*/ react.createElement(components_Menu, Object.assign({}, plansPricingMenu(), {
        path: path,
        menuKey: key,
        __self: PlansAndPricingMenu_this,
        __source: {
            fileName: PlansAndPricingMenu_jsxFileName,
            lineNumber: 14,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("div", {
        __self: PlansAndPricingMenu_this,
        __source: {
            fileName: PlansAndPricingMenu_jsxFileName,
            lineNumber: 15,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var Desktop_PlansAndPricingMenu = ((/* unused pure expression or super */ null && (PlansAndPricingMenu))); //# sourceMappingURL=PlansAndPricingMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/HelpCenterMenu.js
var HelpCenterMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/HelpCenterMenu.js", HelpCenterMenu_this = undefined;




var HelpCenterMenu = function HelpCenterMenu() {
    var path = (0,dist.createURL)("https://help.surveymonkey.com/", {
        ut_source: "megamenu"
    });
    var key = "Help Center";
    return /*#__PURE__*/ react.createElement(components_Menu, Object.assign({}, helpCenterMenu(), {
        path: path,
        menuKey: key,
        __self: HelpCenterMenu_this,
        __source: {
            fileName: HelpCenterMenu_jsxFileName,
            lineNumber: 14,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("div", {
        __self: HelpCenterMenu_this,
        __source: {
            fileName: HelpCenterMenu_jsxFileName,
            lineNumber: 15,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var Desktop_HelpCenterMenu = ((/* unused pure expression or super */ null && (HelpCenterMenu))); //# sourceMappingURL=HelpCenterMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Desktop/index.js
var Desktop_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/index.js", Desktop_this = undefined;
function Desktop_slicedToArray(arr, i) {
    return Desktop_arrayWithHoles(arr) || Desktop_iterableToArrayLimit(arr, i) || Desktop_unsupportedIterableToArray(arr, i) || Desktop_nonIterableRest();
}
function Desktop_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Desktop_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Desktop_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Desktop_arrayLikeToArray(o, minLen);
}
function Desktop_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function Desktop_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function Desktop_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}











var NavBarAnon = function NavBarAnon(_ref) {
    var color = _ref.color;
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang, isMRX = _useContext.isMRX;
    var _useState = (0,react.useState)(""), _useState2 = Desktop_slicedToArray(_useState, 2), submenuOpened = _useState2[0], setOpen = _useState2[1];
    var toggleSubmenu = function toggleSubmenu(key) {
        if (submenuOpened === key) setOpen("");
        else setOpen(key);
    };
    return /*#__PURE__*/ react.createElement(NavBarContext, {
        color: color,
        submenuOpened: submenuOpened,
        toggleSubmenu: toggleSubmenu,
        __self: Desktop_this,
        __source: {
            fileName: Desktop_jsxFileName,
            lineNumber: 23,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "sm-header__nav--anon",
        __self: Desktop_this,
        __source: {
            fileName: Desktop_jsxFileName,
            lineNumber: 28,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(ProductMenu, {
        __self: Desktop_this,
        __source: {
            fileName: Desktop_jsxFileName,
            lineNumber: 29,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement(SolutionsMenu, {
        __self: Desktop_this,
        __source: {
            fileName: Desktop_jsxFileName,
            lineNumber: 30,
            columnNumber: 9
        }
    }), showBlog(lang) ? /*#__PURE__*/ react.createElement(ResourcesMenu, {
        __self: Desktop_this,
        __source: {
            fileName: Desktop_jsxFileName,
            lineNumber: 31,
            columnNumber: 27
        }
    }) : null, !showBlog(lang) ? /*#__PURE__*/ react.createElement(HelpCenterMenu, {
        __self: Desktop_this,
        __source: {
            fileName: Desktop_jsxFileName,
            lineNumber: 32,
            columnNumber: 28
        }
    }) : null, !isMRX ? /*#__PURE__*/ react.createElement(PlansAndPricingMenu, {
        __self: Desktop_this,
        __source: {
            fileName: Desktop_jsxFileName,
            lineNumber: 33,
            columnNumber: 19
        }
    }) : null));
};
NavBarAnon.propTypes = {
    color: prop_types_default().oneOf([
        "secondary",
        "alt"
    ])
};
NavBarAnon.defaultProps = {
    color: "secondary"
};
/* harmony default export */ var Desktop = (NavBarAnon); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/mobile-menu-anon.scss
var mobile_menu_anon = __webpack_require__(6378);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/components/Menu.js
var components_Menu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/components/Menu.js", components_Menu_this = undefined;




var Menu_Menu = function Menu(_ref) {
    var title = _ref.title, url = _ref.url;
    return /*#__PURE__*/ react.createElement(wds_react.ListItem, {
        key: "".concat(title, "-non-nested"),
        className: "sm-mobile-menu-anon__anchor",
        isNavigable: true,
        navigationTarget: url,
        __self: components_Menu_this,
        __source: {
            fileName: components_Menu_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, title);
};
Menu_Menu.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string
};
Menu_Menu.defaultProps = {
    url: null
};
/* harmony default export */ var Mobile_components_Menu = (Menu_Menu); //# sourceMappingURL=Menu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/PlansAndPricingMenu.js
var Mobile_PlansAndPricingMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/PlansAndPricingMenu.js", Mobile_PlansAndPricingMenu_this = undefined;



var PlansAndPricingMenu_PlansAndPricingMenu = function PlansAndPricingMenu() {
    return /*#__PURE__*/ react.createElement(Mobile_components_Menu, Object.assign({}, plansPricingMenu(), {
        __self: Mobile_PlansAndPricingMenu_this,
        __source: {
            fileName: Mobile_PlansAndPricingMenu_jsxFileName,
            lineNumber: 6,
            columnNumber: 10
        }
    }));
};
/* harmony default export */ var Mobile_PlansAndPricingMenu = ((/* unused pure expression or super */ null && (PlansAndPricingMenu_PlansAndPricingMenu))); //# sourceMappingURL=PlansAndPricingMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/HelpCenterMenu.js
var Mobile_HelpCenterMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/HelpCenterMenu.js", Mobile_HelpCenterMenu_this = undefined;



var HelpCenterMenu_HelpCenterMenu = function HelpCenterMenu() {
    return /*#__PURE__*/ react.createElement(Mobile_components_Menu, Object.assign({}, mobileHelpCenterMenu(), {
        __self: Mobile_HelpCenterMenu_this,
        __source: {
            fileName: Mobile_HelpCenterMenu_jsxFileName,
            lineNumber: 7,
            columnNumber: 10
        }
    }));
};
/* harmony default export */ var Mobile_HelpCenterMenu = ((/* unused pure expression or super */ null && (HelpCenterMenu_HelpCenterMenu))); //# sourceMappingURL=HelpCenterMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/components/SubMenuLink.js
var SubMenuLink_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/components/SubMenuLink.js", SubMenuLink_this = undefined;





var titleClassname = classnames_default()("sm-mobile-menu__type-title");
var SubMenuLink = function SubMenuLink(_ref) {
    var subTitle = _ref.subTitle, title = _ref.title, url = _ref.url, openInNewWindow = _ref.openInNewWindow;
    return /*#__PURE__*/ react.createElement(wds_react.ListItem, Object.assign({
        key: title,
        isNavigable: true,
        navigationTarget: url,
        className: "sm-mobile-menu__nested-item"
    }, openInNewWindow === true && {
        target: "_blank",
        rel: "noopener noreferrer"
    }, {
        __self: SubMenuLink_this,
        __source: {
            fileName: SubMenuLink_jsxFileName,
            lineNumber: 12,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "sectionTitle",
        color: "link",
        className: titleClassname,
        __self: SubMenuLink_this,
        __source: {
            fileName: SubMenuLink_jsxFileName,
            lineNumber: 22,
            columnNumber: 7
        }
    }, title), /*#__PURE__*/ react.createElement("p", {
        className: "sm-mobile-menu-anon__type-subtitle",
        __self: SubMenuLink_this,
        __source: {
            fileName: SubMenuLink_jsxFileName,
            lineNumber: 29,
            columnNumber: 7
        }
    }, subTitle));
};
/* harmony default export */ var components_SubMenuLink = ((/* unused pure expression or super */ null && (SubMenuLink)));
SubMenuLink.propTypes = {
    subTitle: (prop_types_default()).string,
    title: (prop_types_default()).string,
    url: (prop_types_default()).string,
    openInNewWindow: (prop_types_default()).bool
};
SubMenuLink.defaultProps = {
    subTitle: "",
    title: "",
    url: "",
    openInNewWindow: false
}; //# sourceMappingURL=SubMenuLink.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/components/SeeMoreLink.js
var SeeMoreLink_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/components/SeeMoreLink.js", SeeMoreLink_this = undefined;





var SeeMoreLink_titleClassname = classnames_default()("sm-mobile-menu__type-title", "sm-mobile-menu-anon--has-arrow-icon", "sm-mobile-menu-anon--no-subtitle");
var SeeMoreLink = function SeeMoreLink(_ref) {
    var title = _ref.title, url = _ref.url, openInNewWindow = _ref.openInNewWindow;
    return /*#__PURE__*/ react.createElement(wds_react.ListItem, Object.assign({
        key: title,
        isNavigable: true,
        navigationTarget: url,
        className: "sm-mobile-menu__nested-item"
    }, openInNewWindow === true && {
        target: "_blank",
        rel: "noopener noreferrer"
    }, {
        __self: SeeMoreLink_this,
        __source: {
            fileName: SeeMoreLink_jsxFileName,
            lineNumber: 16,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "sectionTitle",
        color: "link",
        className: SeeMoreLink_titleClassname,
        __self: SeeMoreLink_this,
        __source: {
            fileName: SeeMoreLink_jsxFileName,
            lineNumber: 26,
            columnNumber: 7
        }
    }, title, /*#__PURE__*/ react.createElement(wds_react.Icon, {
        className: "sm-mobile-menu__arrow-icon",
        __self: SeeMoreLink_this,
        __source: {
            fileName: SeeMoreLink_jsxFileName,
            lineNumber: 32,
            columnNumber: 9
        }
    }, "]")));
};
/* harmony default export */ var components_SeeMoreLink = ((/* unused pure expression or super */ null && (SeeMoreLink)));
SeeMoreLink.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    openInNewWindow: (prop_types_default()).bool
};
SeeMoreLink.defaultProps = {
    openInNewWindow: false
}; //# sourceMappingURL=SeeMoreLink.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/ProductsMenu.js
var Mobile_ProductsMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/ProductsMenu.js", Mobile_ProductsMenu_this = undefined;







var ProductsMenu_ProductsMenu = function ProductsMenu() {
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang, isEUDC = _useContext.isEUDC;
    return /*#__PURE__*/ react.createElement(wds_react.List, {
        interactive: true,
        transparent: true,
        noRules: true,
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 27,
            columnNumber: 5
        }
    }, lang === "en" ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, surveymonkey(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 31,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, enterprise(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 32,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, integrations(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 33,
            columnNumber: 11
        }
    })), !isEUDC ? /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, audience(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 34,
            columnNumber: 22
        }
    })) : null, /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, cx(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 35,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, engage(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 36,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, usabilla(lang), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 37,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, techValidate(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 38,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, apply(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 39,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, wufoo(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 40,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, getFeedback(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 41,
            columnNumber: 11
        }
    }))) : lang === "fr" ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, surveymonkey(lang), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 45,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, audience(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 46,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, apply(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 47,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, usabilla(lang), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 48,
            columnNumber: 11
        }
    }))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, surveymonkey(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 52,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, audience(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 53,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, usabilla(lang), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 54,
            columnNumber: 11
        }
    }))), /*#__PURE__*/ react.createElement(SeeMoreLink, Object.assign({}, viewAllProducts(lang), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 57,
            columnNumber: 7
        }
    })), lang !== "en" ? /*#__PURE__*/ react.createElement(SeeMoreLink, Object.assign({}, addIntegrations(), {
        __self: Mobile_ProductsMenu_this,
        __source: {
            fileName: Mobile_ProductsMenu_jsxFileName,
            lineNumber: 58,
            columnNumber: 24
        }
    })) : null);
};
/* harmony default export */ var Mobile_ProductsMenu = ((/* unused pure expression or super */ null && (ProductsMenu_ProductsMenu))); //# sourceMappingURL=ProductsMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/components/SolutionByNeed.js
var components_SolutionByNeed_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/components/SolutionByNeed.js", components_SolutionByNeed_this = undefined;





var SolutionByNeed_titleClassname = classnames_default()("sm-mobile-menu__type-title", "sm-mobile-menu-anon--no-subtitle");
var SolutionByNeed_SolutionByNeed = function SolutionByNeed(_ref) {
    var title = _ref.title, url = _ref.url, openInNewWindow = _ref.openInNewWindow;
    return /*#__PURE__*/ react.createElement(wds_react.ListItem, Object.assign({
        key: title,
        isNavigable: true,
        navigationTarget: url,
        className: "sm-mobile-menu__nested-item"
    }, openInNewWindow === true && {
        target: "_blank",
        rel: "noopener noreferrer"
    }, {
        __self: components_SolutionByNeed_this,
        __source: {
            fileName: components_SolutionByNeed_jsxFileName,
            lineNumber: 15,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(wds_react.Typography, {
        variant: "sectionTitle",
        color: "link",
        className: SolutionByNeed_titleClassname,
        __self: components_SolutionByNeed_this,
        __source: {
            fileName: components_SolutionByNeed_jsxFileName,
            lineNumber: 25,
            columnNumber: 7
        }
    }, title));
};
/* harmony default export */ var Mobile_components_SolutionByNeed = (SolutionByNeed_SolutionByNeed);
SolutionByNeed_SolutionByNeed.propTypes = {
    title: (prop_types_default()).string.isRequired,
    url: (prop_types_default()).string.isRequired,
    openInNewWindow: (prop_types_default()).bool
};
SolutionByNeed_SolutionByNeed.defaultProps = {
    openInNewWindow: false
}; //# sourceMappingURL=SolutionByNeed.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/SolutionsMenu.js
var Mobile_SolutionsMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/SolutionsMenu.js", Mobile_SolutionsMenu_this = undefined;








var SolutionsMenu_SolutionsMenu = function SolutionsMenu() {
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    return /*#__PURE__*/ react.createElement(wds_react.List, {
        interactive: true,
        transparent: true,
        noRules: true,
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 31,
            columnNumber: 5
        }
    }, lang === "en" ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, customerFeedback(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 34,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, employeeFeedback(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 35,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, marketResearch(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 36,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, customerExperience(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 37,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, humanResources(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 38,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, marketing(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 39,
            columnNumber: 11
        }
    }))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, customerFeedback(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 43,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, employeeFeedback(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 44,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, marketResearch(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 45,
            columnNumber: 11
        }
    }))), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, customerSatisfaction(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 48,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, customerLoyalty(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 49,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, eventSurveys(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 50,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, employeeEngagement(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 51,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, jobSatisfaction(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 52,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, hrSurveys(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 53,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, marketResearchSurveys(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 54,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, opinionPolls(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 55,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(Mobile_components_SolutionByNeed, Object.assign({}, conceptTesting(), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 56,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(SeeMoreLink, Object.assign({}, exploreSurveyTypes(lang), {
        __self: Mobile_SolutionsMenu_this,
        __source: {
            fileName: Mobile_SolutionsMenu_jsxFileName,
            lineNumber: 58,
            columnNumber: 7
        }
    })));
};
/* harmony default export */ var Mobile_SolutionsMenu = ((/* unused pure expression or super */ null && (SolutionsMenu_SolutionsMenu))); //# sourceMappingURL=SolutionsMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/ResourcesMenu.js
var Mobile_ResourcesMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/ResourcesMenu.js", Mobile_ResourcesMenu_this = undefined;







var ResourcesMenu_ResourcesMenu = function ResourcesMenu() {
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    var isEnglish = [
        "en",
        "en-gb"
    ].includes(lang);
    return /*#__PURE__*/ react.createElement(wds_react.List, {
        interactive: true,
        transparent: true,
        noRules: true,
        __self: Mobile_ResourcesMenu_this,
        __source: {
            fileName: Mobile_ResourcesMenu_jsxFileName,
            lineNumber: 21,
            columnNumber: 5
        }
    }, isEnglish ? /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, resources(), {
        __self: Mobile_ResourcesMenu_this,
        __source: {
            fileName: Mobile_ResourcesMenu_jsxFileName,
            lineNumber: 22,
            columnNumber: 20
        }
    })) : null, /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, blog(), {
        __self: Mobile_ResourcesMenu_this,
        __source: {
            fileName: Mobile_ResourcesMenu_jsxFileName,
            lineNumber: 23,
            columnNumber: 7
        }
    })), /*#__PURE__*/ react.createElement(SubMenuLink, Object.assign({}, helpCenter(lang), {
        __self: Mobile_ResourcesMenu_this,
        __source: {
            fileName: Mobile_ResourcesMenu_jsxFileName,
            lineNumber: 24,
            columnNumber: 7
        }
    })), isEnglish ? /*#__PURE__*/ react.createElement(SeeMoreLink, Object.assign({}, exploreSurveyTemplates(), {
        __self: Mobile_ResourcesMenu_this,
        __source: {
            fileName: Mobile_ResourcesMenu_jsxFileName,
            lineNumber: 25,
            columnNumber: 20
        }
    })) : null);
};
/* harmony default export */ var Mobile_ResourcesMenu = ((/* unused pure expression or super */ null && (ResourcesMenu_ResourcesMenu))); //# sourceMappingURL=ResourcesMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/components/MenusWithoutSubMenu.js
var MenusWithoutSubMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/components/MenusWithoutSubMenu.js", MenusWithoutSubMenu_this = undefined;




var MenusWithoutSubMenu = function MenusWithoutSubMenu(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ react.createElement(wds_react.List, {
        interactive: true,
        className: "sm-mobile-menu-anon",
        __self: MenusWithoutSubMenu_this,
        __source: {
            fileName: MenusWithoutSubMenu_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, children);
};
/* harmony default export */ var components_MenusWithoutSubMenu = ((/* unused pure expression or super */ null && (MenusWithoutSubMenu)));
MenusWithoutSubMenu.propTypes = {
    children: (prop_types_default()).node.isRequired
}; //# sourceMappingURL=MenusWithoutSubMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/anonymous/Mobile/index.js
var anonymous_Mobile_jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Mobile/index.js", anonymous_Mobile_this = undefined;















var MobileAnon = function MobileAnon() {
    var _useContext = (0,react.useContext)(Header_SMHeaderContext), lang = _useContext.lang;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(wds_react.Accordion, {
        noRules: true,
        interactive: true,
        className: "sm-mobile-menu-anon",
        "data-testid": "MobileMenuAnon",
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 31,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(wds_react.AccordionItem, {
        title: productsMenu().title,
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 37,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(ProductsMenu_ProductsMenu, {
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 38,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(wds_react.AccordionItem, {
        title: solutionsMenu().title,
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 41,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(SolutionsMenu_SolutionsMenu, {
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 42,
            columnNumber: 11
        }
    })), showBlog(lang) ? /*#__PURE__*/ react.createElement(wds_react.AccordionItem, {
        title: resourcesMenu().title,
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 45,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(ResourcesMenu_ResourcesMenu, {
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 46,
            columnNumber: 13
        }
    })) : null), /*#__PURE__*/ react.createElement(MenusWithoutSubMenu, {
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 51,
            columnNumber: 7
        }
    }, !showBlog(lang) ? /*#__PURE__*/ react.createElement(HelpCenterMenu_HelpCenterMenu, {
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 52,
            columnNumber: 28
        }
    }) : null, /*#__PURE__*/ react.createElement(PlansAndPricingMenu_PlansAndPricingMenu, {
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 53,
            columnNumber: 9
        }
    })), /*#__PURE__*/ react.createElement(MediaComponents/* MobileScreen */.vp, {
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 56,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "sm-mobile-menu-anon",
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 57,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(components_SignUpCTA, {
        size: "md",
        variant: "solid",
        color: "upgrade",
        stretched: true,
        className: "sm-mobile-menu-anon__cta",
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 58,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement(components_LogInCTA, {
        size: "md",
        variant: "solid",
        color: "primary",
        stretched: true,
        className: "sm-mobile-menu-anon__cta",
        __self: anonymous_Mobile_this,
        __source: {
            fileName: anonymous_Mobile_jsxFileName,
            lineNumber: 65,
            columnNumber: 11
        }
    }))));
};
/* harmony default export */ var anonymous_Mobile = (MobileAnon); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/enums.js
var enums = __webpack_require__(1478);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/header.scss
var header = __webpack_require__(8845);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Header/utils.scss
var utils = __webpack_require__(617);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/Header.js

var Header_jsxFileName = "/repo/packages/webassets/src/components/Header/Header.js", _Object$freeze, Header_this = undefined;
function Header_defineProperty(obj, key, value) {
    key = Header_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Header_toPropertyKey(arg) {
    var key = Header_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function Header_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
















var brandLogoMapper = Object.freeze((_Object$freeze = {}, Header_defineProperty(_Object$freeze, enums/* BRAND.MOMENTIVE */.cg.MOMENTIVE, MomentiveHeaderLogo), Header_defineProperty(_Object$freeze, enums/* BRAND.SURVEYMONKEY */.cg.SURVEYMONKEY, components_HeaderLogo), _Object$freeze));
function getDefaultLogoByBrand(brand) {
    return brandLogoMapper[brand] || components_HeaderLogo;
}
var SMHeader = function SMHeader(_ref) {
    var isUserAuthenticated = _ref.isUserAuthenticated, color = _ref.color, lang = _ref.lang, variant = _ref.variant, isEUDC = _ref.isEUDC, actionFlow = _ref.actionFlow, user = _ref.user, isAnonHeaderSticky = _ref.isAnonHeaderSticky, excludeMenuItems = _ref.excludeMenuItems, showLoginButton = _ref.showLoginButton, showSignupButton = _ref.showSignupButton, Logo = _ref.Logo, brand = _ref.brand;
    var LogoComponent = Logo || getDefaultLogoByBrand(brand);
    var auth = isUserAuthenticated ? "auth" : "anon";
    var headerColor = isUserAuthenticated ? "primary" : color;
    var headerVariant = isUserAuthenticated ? "default" : variant;
    return /*#__PURE__*/ react.createElement(Header_SMHeaderContext.Provider, {
        value: {
            isUserAuthenticated: isUserAuthenticated,
            lang: lang,
            isEUDC: isEUDC,
            actionFlow: actionFlow,
            user: user,
            excludeMenuItems: excludeMenuItems
        },
        __self: Header_this,
        __source: {
            fileName: Header_jsxFileName,
            lineNumber: 51,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(Header_OnScroll, {
        render: function render(x, y) {
            var headerColorAnon = y > 0 ? "light" : color;
            var smHeaderColor = isUserAuthenticated ? headerColor : headerColorAnon;
            var defaultColor = headerColorAnon === "transparent" || headerColorAnon === "primary";
            var logoColor = defaultColor ? "alt" : "primary";
            var mobileMenuColor = defaultColor ? "alt" : "secondary";
            var addonLogInColor = defaultColor ? "alt" : "secondary";
            var navBarColor = defaultColor ? "alt" : "secondary";
            var addonSignUpColor = defaultColor ? "alt" : "upgrade";
            var addonSignUpVariant = defaultColor ? "ghost" : "default";
            var classNames = classnames_default()("sm-header--".concat(auth), "sm-header--".concat(smHeaderColor), "sm-header--".concat(headerVariant), {
                "sm-header--en": lang === "en"
            }, {
                "sm-header--sticky": isAnonHeaderSticky && !isUserAuthenticated
            });
            var logoComponentProps = {
                isUserAuthenticated: isUserAuthenticated
            };
            if (brand === enums/* BRAND.MOMENTIVE */.cg.MOMENTIVE) {
                logoComponentProps.isContrast = smHeaderColor === enums/* HEADER_COLOR.LIGHT */.Nt.LIGHT;
            } else {
                logoComponentProps.variant = variant;
                logoComponentProps.color = logoColor;
            }
            return /*#__PURE__*/ react.createElement("div", {
                className: classNames,
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 98,
                    columnNumber: 13
                }
            }, /*#__PURE__*/ react.createElement(MediaComponents/* MobileTabletScreen */.fc, {
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 99,
                    columnNumber: 15
                }
            }, /*#__PURE__*/ react.createElement(MobileDrawer, {
                menuColor: mobileMenuColor,
                "data-testid": "Header__MobileDrawer--Anon",
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 100,
                    columnNumber: 17
                }
            }, /*#__PURE__*/ react.createElement(anonymous_Mobile, {
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 104,
                    columnNumber: 19
                }
            }))), /*#__PURE__*/ react.createElement(LogoComponent, Object.assign({}, logoComponentProps, {
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 107,
                    columnNumber: 15
                }
            })), /*#__PURE__*/ react.createElement(MediaComponents/* DesktopScreen */.g7, {
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 108,
                    columnNumber: 15
                }
            }, /*#__PURE__*/ react.createElement(Desktop, {
                color: navBarColor,
                lang: lang,
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 109,
                    columnNumber: 17
                }
            })), /*#__PURE__*/ react.createElement(Addon, {
                addonSignUpColor: addonSignUpColor,
                addonLogInColor: addonLogInColor,
                addonSignUpVariant: addonSignUpVariant,
                variant: variant,
                isUserAuthenticated: isUserAuthenticated,
                showLoginButton: showLoginButton,
                showSignupButton: showSignupButton,
                __self: Header_this,
                __source: {
                    fileName: Header_jsxFileName,
                    lineNumber: 111,
                    columnNumber: 15
                }
            }));
        },
        __self: Header_this,
        __source: {
            fileName: Header_jsxFileName,
            lineNumber: 61,
            columnNumber: 7
        }
    }));
};
SMHeader.propTypes = {
    isAnonHeaderSticky: (prop_types_default()).bool,
    color: prop_types_default().oneOf(Object.values(enums/* HEADER_COLOR */.Nt)),
    isUserAuthenticated: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).object
    ]),
    lang: (prop_types_default()).string.isRequired,
    variant: prop_types_default().oneOf(Object.values(enums/* HEADER_VARIANT */.Jf)),
    isEUDC: (prop_types_default()).bool.isRequired,
    actionFlow: (prop_types_default()).string,
    user: (prop_types_default()).object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    showDrawer: (prop_types_default()).bool,
    excludeMenuItems: prop_types_default().arrayOf(prop_types_default().oneOf(ValidMenuNameList)),
    showLoginButton: (prop_types_default()).bool,
    showSignupButton: (prop_types_default()).bool,
    alwaysUseAnonymousNav: (prop_types_default()).bool,
    Logo: (prop_types_default()).node,
    brand: prop_types_default().oneOf(Object.values(enums/* BRAND */.cg))
};
SMHeader.defaultProps = {
    isAnonHeaderSticky: true,
    color: "primary",
    isUserAuthenticated: false,
    showDrawer: true,
    variant: "default",
    actionFlow: "header",
    excludeMenuItems: [],
    showLoginButton: true,
    showSignupButton: true,
    alwaysUseAnonymousNav: false,
    Logo: undefined,
    brand: enums/* BRAND.SURVEYMONKEY */.cg.SURVEYMONKEY
};
/* harmony default export */ var Header_Header = (SMHeader); //# sourceMappingURL=Header.js.map

// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(7784);
// EXTERNAL MODULE: ./node_modules/lodash.isequal/index.js
var lodash_isequal = __webpack_require__(2307);
// EXTERNAL MODULE: ./node_modules/lodash.iselement/index.js
var lodash_iselement = __webpack_require__(4467);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
;// CONCATENATED MODULE: ./node_modules/@wds/responsive/node_modules/@wds/utils/dist/index.es.js









var clearfix = {
    '&:after': {
        content: '',
        display: 'block',
        clear: 'both',
    },
};

var createMemoStyles = function (styles, options) {
    var useStyles = createUseStyles(styles, options);
    var useMemoStyles = function (data) {
        var ref = useRef(data);
        if (!ref.current || !isEqual(data, ref.current)) {
            ref.current = data;
        }
        return useStyles(ref.current);
    };
    return useMemoStyles;
};

/**
 * @description
 * This factory function creates a hook that will return the wrenchSpacing class to be used in the component
 * Simply import it and call at the component level to create the hook, then use the hook inside your component
 * Code example: https://code.corp.surveymonkey.com/wrench/wrench/blob/master/packages/box/Box
 */
function createSpacingStyles() {
    return createMemoStyles(function (_a) {
        var spacing = _a.spacing;
        return {
            wrenchSpacing: function (_a) {
                var _b, _c, _d, _e, _f, _g, _h, _j;
                var m = _a.m, mx = _a.mx, my = _a.my, mt = _a.mt, mb = _a.mb, ml = _a.ml, mr = _a.mr, p = _a.p, px = _a.px, py = _a.py, pt = _a.pt, pb = _a.pb, pl = _a.pl, pr = _a.pr;
                var margin = {
                    t: (_b = m !== null && m !== void 0 ? m : my) !== null && _b !== void 0 ? _b : mt,
                    b: (_c = m !== null && m !== void 0 ? m : my) !== null && _c !== void 0 ? _c : mb,
                    l: (_d = m !== null && m !== void 0 ? m : mx) !== null && _d !== void 0 ? _d : ml,
                    r: (_e = m !== null && m !== void 0 ? m : mx) !== null && _e !== void 0 ? _e : mr,
                };
                var padding = {
                    t: (_f = p !== null && p !== void 0 ? p : py) !== null && _f !== void 0 ? _f : pt,
                    b: (_g = p !== null && p !== void 0 ? p : py) !== null && _g !== void 0 ? _g : pb,
                    l: (_h = p !== null && p !== void 0 ? p : px) !== null && _h !== void 0 ? _h : pl,
                    r: (_j = p !== null && p !== void 0 ? p : px) !== null && _j !== void 0 ? _j : pr,
                };
                return {
                    marginTop: margin.t && spacing[margin.t],
                    marginRight: margin.r && spacing[margin.r],
                    marginBottom: margin.b && spacing[margin.b],
                    marginLeft: margin.l && spacing[margin.l],
                    paddingTop: padding.t && spacing[padding.t],
                    paddingRight: padding.r && spacing[padding.r],
                    paddingBottom: padding.b && spacing[padding.b],
                    paddingLeft: padding.l && spacing[padding.l],
                };
            },
        };
    });
}

/* eslint-disable no-bitwise  */
/* Given a hex or rgb color value, checks if the contrasting color should be light or dark */
var getContrastColor = function (color) {
    var _a;
    var r = 0;
    var g = 0;
    var b = 0;
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {
        var colorValues = (_a = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)) !== null && _a !== void 0 ? _a : ['', '', ''];
        r = parseInt(colorValues[1], 10);
        g = parseInt(colorValues[2], 10);
        b = parseInt(colorValues[3], 10);
    }
    else {
        var colorReg = color.length < 5 ? /./g : '';
        var colorValues = +("0x".concat(color.slice(1).replace(colorReg, '$&$&')));
        r = colorValues >> 16;
        g = colorValues >> 8 & 255;
        b = colorValues & 255;
    }
    // HSP equation from http://alienryderflex.com/hsp.html
    var hsp = Math.sqrt(0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b));
    if (hsp > 160) {
        return 'dark';
    }
    return 'light';
};

// https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
var defaultBaseline = {
    boxSizing: 'border-box',
    padding: 0,
    margin: 0,
    listStyle: 'none',
};

var defaultFonts = function (_a) {
    var type = _a.type;
    return ({
        fontFamily: type.fontFamily.base,
        fontSize: type.fontSize.body,
        '-webkit-font-smoothing': 'antialiased',
    });
};

function deprecate(props, key, value, componentName) {
    if (props[key] === value) {
        // eslint-disable-next-line no-console
        console.warn(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        "[DEPRECATED]: The ".concat(componentName, " prop ").concat(String(key), " with value \"").concat(value, "\" is deprecated and will be removed in the future"));
    }
}

function extractType(node) {
    if (isValidElement(node))
        return node.type;
    return '';
}
function extractDisplayName(type) {
    var _a, _b;
    return (_b = (_a = type.displayName) !== null && _a !== void 0 ? _a : type.name) !== null && _b !== void 0 ? _b : 'Unknown';
}
var getDisplayName = function (child) {
    var type = extractType(child);
    if (typeof type === 'function' || typeof type === 'object') {
        return extractDisplayName(type);
    }
    return type;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var dist_index_es_assign = function() {
    dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return dist_index_es_assign.apply(this, arguments);
};

function dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var getState = function (state, newState) { return (dist_index_es_assign(dist_index_es_assign({}, state), newState)); };

var isControlled = function (value) {
    return !(value === undefined || value === null);
};

var isBrowser = typeof window !== 'undefined';

var guardElement = function (e) {
    return isElement(e);
};

function removeUndefinedProperties(obj) {
    var result = {};
    Object.entries(obj).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (value !== undefined) {
            result[key] = value;
        }
    });
    return result;
}

var safeRest = (function (_a) {
    _a.className; _a.style; var props = dist_index_es_rest(_a, ["className", "style"]);
    return props;
});

var conditionGuard = function (what, conditional) {
    return conditional;
};
var notEmpty = function (value) {
    return value !== null && value !== undefined;
};
var handlePortal = function (content, renderTo) {
    if (!renderTo)
        return content;
    if (conditionGuard(renderTo, isElement(renderTo)))
        return createPortal(content, renderTo);
    if (renderTo.current)
        return createPortal(content, renderTo.current);
    return content;
};

// Taken from lodash: https://github.com/lodash/lodash/blob/master/uniqueId.js
var idCounter = 0;
var uniqueId = function (prefix) {
    var id = ++idCounter; // eslint-disable-line no-plusplus
    if (prefix == null) {
        throw new Error('The value is missing in uniqueId() parameter');
    }
    return "".concat(prefix).concat(id);
};

// send in the state value as a parameter and get the previous value of that state
var usePreviousState = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};

// https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
var visuallyHidden = {
    border: '0px',
    clip: 'rect(1px, 1px, 1px, 1px)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    width: '1px',
    // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
    whiteSpace: 'nowrap',
    wordWrap: 'normal',
};

var withNested = function (component, args) {
    return Object.assign(component, args);
};

function withSpacing(Component) {
    /**
     * JSS injects css styles in the order of `createUseStyles` usage
     * Hence, useStyles needs to be instantiated every single time while
     * using this HOC because it should be the last `createUseStyles` usage
     * for a component. With this mechanism, `withSpacing` overwrites the component
     * spacing. Not ideal for a design system, but we are waiting on the
     * below ticket.
     *
     * Note: https://jira.surveymonkey.com/browse/WRENCH-1107
     *
     * If the decision is have `withStyles` NOT overwrite the component spacing,
     * just move this declaration outside of this component. `withSpacing` will then
     * add to the styles and not overwrite them.
     */
    var useStyles = createMemoStyles(function (_a) {
        var spacing = _a.spacing;
        return ({
            wrenchSpacing: function (_a) {
                var margin = _a.margin, padding = _a.padding;
                return ({
                    marginTop: margin.t && spacing[margin.t],
                    marginRight: margin.r && spacing[margin.r],
                    marginBottom: margin.b && spacing[margin.b],
                    marginLeft: margin.l && spacing[margin.l],
                    paddingTop: padding.t && spacing[padding.t],
                    paddingRight: padding.r && spacing[padding.r],
                    paddingBottom: padding.b && spacing[padding.b],
                    paddingLeft: padding.l && spacing[padding.l],
                });
            },
        });
    });
    var WithSpacing = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var m = _a.m, mx = _a.mx, my = _a.my, mt = _a.mt, mb = _a.mb, ml = _a.ml, mr = _a.mr, p = _a.p, px = _a.px, py = _a.py, pt = _a.pt, pb = _a.pb, pl = _a.pl, pr = _a.pr, className = _a.className, rest = dist_index_es_rest(_a, ["m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr", "className"]);
        var margin = {
            t: (_b = m !== null && m !== void 0 ? m : my) !== null && _b !== void 0 ? _b : mt,
            b: (_c = m !== null && m !== void 0 ? m : my) !== null && _c !== void 0 ? _c : mb,
            l: (_d = m !== null && m !== void 0 ? m : mx) !== null && _d !== void 0 ? _d : ml,
            r: (_e = m !== null && m !== void 0 ? m : mx) !== null && _e !== void 0 ? _e : mr,
        };
        var padding = {
            t: (_f = p !== null && p !== void 0 ? p : py) !== null && _f !== void 0 ? _f : pt,
            b: (_g = p !== null && p !== void 0 ? p : py) !== null && _g !== void 0 ? _g : pb,
            l: (_h = p !== null && p !== void 0 ? p : px) !== null && _h !== void 0 ? _h : pl,
            r: (_j = p !== null && p !== void 0 ? p : px) !== null && _j !== void 0 ? _j : pr,
        };
        var classes = useStyles({
            margin: margin,
            padding: padding,
        });
        var Element = Component;
        return (React.createElement(Element, dist_index_es_assign({ spacingClass: classes.wrenchSpacing, className: className }, safeRest(rest))));
    };
    WithSpacing.displayName = "WithSpacing(".concat(getDisplayName(Component), ")");
    WithSpacing.getOriginalComponent = function () { return Component; };
    WithSpacing.defaultProps = {
        m: undefined,
        mx: undefined,
        my: undefined,
        mt: undefined,
        mb: undefined,
        ml: undefined,
        mr: undefined,
        p: undefined,
        px: undefined,
        py: undefined,
        pt: undefined,
        pb: undefined,
        pl: undefined,
        pr: undefined,
        className: undefined,
    };
    return WithSpacing;
}

var KEYS = {
    DOWN: 'ArrowDown',
    END: 'End',
    ESC: 'Escape',
    HOME: 'Home',
    LEFT: 'ArrowLeft',
    PAGE_DOWN: 'PageDown',
    PAGE_UP: 'PageUp',
    RIGHT: 'ArrowRight',
    UP: 'ArrowUp',
    ENTER: 'Enter',
    SPACE: ' ',
    BACKSPACE: 'Backspace',
    TAB: 'Tab',
};



;// CONCATENATED MODULE: ./node_modules/@wds/responsive/dist/index.es.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var responsive_dist_index_es_assign = function() {
    responsive_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return responsive_dist_index_es_assign.apply(this, arguments);
};

function responsive_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var Responsive = function (_a) {
    var children = _a.children, minWidth = _a.minWidth, maxWidth = _a.maxWidth, rest = responsive_dist_index_es_rest(_a, ["children", "minWidth", "maxWidth"]);
    var breakpoints = (0,theming_esm/* useTheme */.Fg)().breakpoints;
    var query = "(min-width: ".concat(minWidth ? breakpoints[minWidth] : '', "px)");
    var max = "".concat(maxWidth ? breakpoints[maxWidth] - 1 : '', "px");
    if (minWidth && maxWidth) {
        query = "(min-width: ".concat(breakpoints[minWidth], "px) and (max-width: ").concat(max, ")");
    }
    else if (maxWidth) {
        query = "(max-width: ".concat(max, ")");
    }
    return (react.createElement(react_media/* default */.Z, responsive_dist_index_es_assign({ query: query }, safeRest(rest)), children));
};

var BREAKPOINTS = (/* unused pure expression or super */ null && (['sm', 'md', 'lg', 'xl']));



;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/HeaderContext.js

var defaultHeaderCtx = {
    isEUDC: false,
    lang: "en",
    session: undefined,
    user: undefined,
    pageURL: undefined,
    pageName: undefined
};
var HeaderContext = /*#__PURE__*/ (0,react.createContext)(defaultHeaderCtx);
/* harmony default export */ var wrench_HeaderContext = (HeaderContext); //# sourceMappingURL=HeaderContext.js.map

// EXTERNAL MODULE: ./node_modules/@wds/motion/dist/index.es.js + 8 modules
var motion_dist_index_es = __webpack_require__(4661);
// EXTERNAL MODULE: ./node_modules/@wds/internal-components/dist/index.es.js
var internal_components_dist_index_es = __webpack_require__(7153);
;// CONCATENATED MODULE: ./node_modules/@wds/sheet/dist/index.es.js





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var sheet_dist_index_es_assign = function() {
    sheet_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return sheet_dist_index_es_assign.apply(this, arguments);
};

function sheet_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles$3 = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette;
    var sheet = {
        width: {
            sm: '360px',
            md: '420px',
            lg: '640px',
        },
    };
    var width = {
        sm: sheet.width.sm,
        md: sheet.width.md,
        lg: sheet.width.lg,
    };
    var overlayShadow = {
        left: '6px 0 12px 0 rgba(0, 0, 0, 0.06)',
        right: '-6px 0 12px 0 rgba(0, 0, 0, 0.06)',
        bottom: '0 -6px 12px 0 rgba(0, 0, 0, 0.06)',
    };
    var sheetStyles = {
        wrenchSheetOverlayContainer: function (_a) {
            var elevation = _a.elevation;
            return ({
                position: 'relative',
                zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space,
            });
        },
        wrenchSheetOverlay: {
            '& > div': {
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                backgroundColor: palette.background.overlay,
            },
        },
        wrenchSheetContainer: function (_a) {
            var placement = _a.placement, elevation = _a.elevation;
            return ({
                position: 'fixed',
                top: placement !== 'bottom' ? 0 : null,
                bottom: placement === 'bottom' ? 0 : null,
                left: 0,
                right: 0,
                zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space,
            });
        },
        wrenchSheet: function (_a) {
            var placement = _a.placement;
            return ({
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                top: placement === 'bottom' ? 0 : null,
                bottom: placement !== 'bottom' ? 0 : null,
                pointerEvents: 'none',
            });
        },
        wrenchSheetPanel: function (_a) {
            var placement = _a.placement, size = _a.size, offsetTop = _a.offsetTop, elevation = _a.elevation;
            var offsetPx = offsetTop ? "".concat(offsetTop.toString(), "px") : '0px';
            var placementStyle = {
                position: 'fixed',
                bottom: 0,
                top: placement !== 'bottom' ? offsetPx : null,
                left: placement !== 'right' ? 0 : null,
                right: placement !== 'left' ? 0 : null,
                boxShadow: placement ? overlayShadow[placement] : null,
            };
            return sheet_dist_index_es_assign({ backgroundColor: palette.background.light, zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space + 1, display: 'flex', flexDirection: 'column', minWidth: width.sm, overflowY: 'auto', outline: 'none', pointerEvents: 'all', width: placement !== 'bottom' && size ? width[size] : null, height: placement === 'bottom' ? 'auto' : '100vh', minHeight: placement === 'bottom' ? '42px' : null }, (placement && placementStyle));
        },
    };
    return sheetStyles;
});

var useStyles$2 = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette, spacing = theme.spacing;
    return {
        wrenchSheetFooter: {
            display: 'flex',
            justifyContent: 'space-between',
            flexShrink: 0,
            padding: [spacing[4], spacing[6]],
            background: palette.background.light,
            borderTop: "1px solid ".concat(palette.background.accent),
            color: palette.text.dark,
        },
        wrenchSheetActions: function (_a) {
            var align = _a.align;
            return (sheet_dist_index_es_assign(sheet_dist_index_es_assign(sheet_dist_index_es_assign({ display: 'flex', flexGrow: 1, flexWrap: 'wrap' }, (align === 'right' && {
                justifyContent: 'flex-end',
            })), (align === 'left' && {
                justifyContent: 'flex-start',
            })), { '&:not([class^="wrenchButtonGroup"])': {
                    '& > button, & > a': {
                        marginLeft: spacing[2],
                    }
                } }));
        },
    };
});

var SheetFooter = function (_a) {
    var align = _a.align, children = _a.children;
    var _b = useStyles$2({
        align: align,
    }), wrenchSheetActions = _b.wrenchSheetActions, wrenchSheetFooter = _b.wrenchSheetFooter;
    return (react.createElement("footer", { className: wrenchSheetFooter },
        react.createElement("div", { className: wrenchSheetActions }, children)));
};
SheetFooter.defaultProps = {
    align: 'left',
};

var useStyles$1 = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var spacing = theme.spacing;
    return {
        wrenchSheetBody: function (_a) {
            var padding = _a.padding;
            return (sheet_dist_index_es_assign({ overflowY: 'auto', flexGrow: 1 }, (padding && {
                padding: [spacing[4], spacing[6], spacing[6], spacing[6]],
            })));
        },
    };
});

var SheetBody = (0,react.forwardRef)(function (_a, ref) {
    _a.className; var children = _a.children, handleClick = _a.handleClick, id = _a.id, padding = _a.padding, rest = sheet_dist_index_es_rest(_a, ["className", "children", "handleClick", "id", "padding"]);
    var wrenchSheetBody = useStyles$1({
        padding: padding,
    }).wrenchSheetBody;
    var handleKeyDown = function (e) {
        if (e.key === utils_dist_index_es/* KEYS.ESC */.tW.ESC) {
            handleClick === null || handleClick === void 0 ? void 0 : handleClick(e);
            e.preventDefault();
        }
    };
    return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    react.createElement("section", sheet_dist_index_es_assign({ 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0, ref: ref, id: id, className: wrenchSheetBody, onKeyDown: handleKeyDown }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)), children));
});
SheetBody.displayName = 'SheetBody';
SheetBody.defaultProps = {
    className: undefined,
    handleClick: undefined,
    id: undefined,
    padding: true,
};

var sheet_dist_index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette, spacing = theme.spacing, _a = theme.type, fontWeight = _a.fontWeight, fontSize = _a.fontSize;
    return {
        wrenchSheetHeader: function () { return ({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'baseline',
            padding: [spacing[6], spacing[6], spacing[4], spacing[6]],
            background: palette.background.light,
            flexShrink: 0,
            flexDirection: 'column',
        }); },
        wrenchSheetText: {
            fontSize: 24,
            fontWeight: fontWeight.medium,
            color: palette.text.dark,
            marginTop: 0,
            marginBottom: spacing[2],
        },
        wrenchSheetTitle: {
            flexGrow: 1,
            width: '100%',
        },
        wrenchSheetSubText: {
            fontSize: fontSize.bodySm,
            fontWeight: fontWeight.regular,
            color: palette.text.dark,
            margin: [spacing[1], 0, 0],
        },
        wrenchSheetAddOn: {
            flexGrow: 1,
            marginTop: spacing[3],
            width: '100%',
            minWidth: '33%',
            textAlign: 'right',
            // In the case that an addon is the first child (modal title was omitted)
            // we do not want a margin top
            '& :first-child': {
                marginTop: 0,
            },
        },
    };
});

var SheetHeader = function (_a) {
    var addOn = _a.addOn, header = _a.header, id = _a.id, subHeader = _a.subHeader;
    if (subHeader && addOn) {
        throw new Error('You cannot have both subHeader and addon');
    }
    else if (!header && subHeader) {
        throw new Error('You must provide a header if you provide a subHeader');
    }
    var _b = sheet_dist_index_es_useStyles(), wrenchSheetAddOn = _b.wrenchSheetAddOn, wrenchSheetHeader = _b.wrenchSheetHeader, wrenchSheetSubText = _b.wrenchSheetSubText, wrenchSheetText = _b.wrenchSheetText, wrenchSheetTitle = _b.wrenchSheetTitle;
    return (react.createElement("section", { className: wrenchSheetHeader },
        react.createElement("div", { className: wrenchSheetTitle },
            header && (react.createElement("h2", { className: wrenchSheetText, id: id }, header)),
            subHeader && react.createElement("p", { className: wrenchSheetSubText }, subHeader)),
        addOn && react.createElement("div", { className: wrenchSheetAddOn }, addOn)));
};
SheetHeader.defaultProps = {
    addOn: undefined,
    header: undefined,
    id: undefined,
    stretched: false,
    subHeader: undefined,
};

var Sheet = function (_a) {
    var children = _a.children, onClose = _a.onClose, _b = _a.show, show = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'sm' : _c, _d = _a.placement, placement = _d === void 0 ? 'right' : _d, _e = _a.showCloseButton, showCloseButton = _e === void 0 ? false : _e, _f = _a.closeButtonLabel, closeButtonLabel = _f === void 0 ? 'Close Sheet' : _f, _g = _a.blocking, blocking = _g === void 0 ? true : _g, _h = _a.offsetTop, offsetTop = _h === void 0 ? 0 : _h, _j = _a.elevation, elevation = _j === void 0 ? undefined : _j, rest = sheet_dist_index_es_rest(_a, ["children", "onClose", "show", "size", "placement", "showCloseButton", "closeButtonLabel", "blocking", "offsetTop", "elevation"]);
    var sheetPanelRef = (0,react.createRef)();
    var classes = useStyles$3({
        size: size,
        placement: placement,
        blocking: blocking,
        offsetTop: offsetTop,
        elevation: elevation,
    });
    (0,react.useEffect)(function () {
        if (sheetPanelRef.current) {
            sheetPanelRef.current.focus();
        }
    }, [sheetPanelRef, show]);
    var getSlideDirection = function () {
        var direction = 'left';
        if (!placement || placement === 'right') {
            return direction;
        }
        return placement === 'bottom' ? 'up' : 'right';
    };
    var handleClick = function () {
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var closeButton = function () {
        return (react.createElement(internal_components_dist_index_es/* CloseButton */.PZ, { onClick: handleClick, variant: "dark", label: closeButtonLabel }));
    };
    return (react.createElement(react.Fragment, null,
        blocking && (react.createElement("div", { className: classes.wrenchSheetOverlayContainer },
            react.createElement(motion_dist_index_es/* Fade */.pT, { in: show, speed: "fast" },
                react.createElement("div", null,
                    react.createElement("div", { className: classes.wrenchSheetOverlay },
                        react.createElement(internal_components_dist_index_es/* Overlay */.aV, { onClick: handleClick, className: "OverlayWDS" })))))),
        react.createElement("div", { className: classes.wrenchSheetContainer },
            react.createElement(motion_dist_index_es/* Slide */.Mi, { in: show, direction: getSlideDirection() },
                react.createElement("div", null,
                    react.createElement("div", sheet_dist_index_es_assign({ className: classes.wrenchSheet }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)),
                        react.createElement("div", { role: "dialog", className: classes.wrenchSheetPanel, ref: sheetPanelRef, tabIndex: -1 },
                            showCloseButton && closeButton(),
                            children)))))));
};
Sheet.Header = SheetHeader;
Sheet.Body = SheetBody;
Sheet.Footer = SheetFooter;

var SHEET_SIZES = (/* unused pure expression or super */ null && (['sm', 'md', 'lg']));
var SHEET_PLACEMENTS = (/* unused pure expression or super */ null && (['left', 'right', 'bottom']));



;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/types.js
var View;
(function(View) {
    View["StartingPoint"] = "StartingPoint";
    View["GuidedSetup"] = "GuidedSetup";
    View["None"] = "None";
})(View || (View = {}));
var isHrefMenuItem = function isHrefMenuItem(item) {
    return Boolean(item.href);
};
var isClickMenuItem = function isClickMenuItem(item) {
    return Boolean(item.onClick);
};
var ExperimentVariant;
(function(ExperimentVariant) {
    ExperimentVariant["DrillDownMenu"] = "create-18931-create-survey--drill-down";
    ExperimentVariant["SingleLevelMenu"] = "create-18931-create-survey--single-level";
})(ExperimentVariant || (ExperimentVariant = {}));
var ClickMetricEventName;
(function(ClickMetricEventName) {
    ClickMetricEventName["StartFromScratch"] = "Start with a blank survey";
    ClickMetricEventName["CopyAndPaste"] = "Copy and paste from doc";
    ClickMetricEventName["Solution"] = "Insights solutions";
    ClickMetricEventName["BuildItForMe"] = "In-product guidance";
    ClickMetricEventName["Template"] = "Popular template";
    ClickMetricEventName["Audience"] = "Buy targeted responses";
})(ClickMetricEventName || (ClickMetricEventName = {})); //# sourceMappingURL=types.js.map

// EXTERNAL MODULE: ./node_modules/@wds/typography/dist/index.es.js
var typography_dist_index_es = __webpack_require__(295);
;// CONCATENATED MODULE: ./node_modules/@wds/list/dist/index.es.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var list_dist_index_es_assign = function() {
    list_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return list_dist_index_es_assign.apply(this, arguments);
};

function list_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/** Resolves the correct color */
var getMarkedColor = function (color, palette) {
    if (!color || typeof color !== 'string') {
        return palette.primary.main;
    }
    if (color.startsWith('data-')) {
        return palette.data[color.replace('data-', '')];
    }
    return palette[color].main;
};
var index_es_useStyles$1 = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette, border = theme.border, spacing = theme.spacing, motion = theme.motion, type = theme.type;
    var list = {
        addonIconColor: palette.background.dark,
        affordanceIconColor: palette.secondary.main,
        itemHeight: 48,
        itemMinHeight: 48,
        itemDenseMinHeight: 40,
        labelFontSize: type.fontSize.bodySm,
        markWidth: 4,
    };
    var listStyles = {
        wrenchListRow: {
            borderBottom: border.main,
            '&:last-child': {
                borderBottom: 'none',
            },
            'a&': {
                color: palette.text.dark,
                '&:hover, &:focus': {
                    textDecoration: 'none',
                },
            },
        },
        wrenchListItem: function (_a) {
            var accordion = _a.accordion, color = _a.color, marked = _a.marked, menu = _a.menu, disabled = _a.disabled, upgrade = _a.upgrade, interactive = _a.interactive, isFocused = _a.isFocused, transparent = _a.transparent;
            return (list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign({}, utils_dist_index_es/* defaultBaseline */.yD), (0,utils_dist_index_es/* defaultFonts */.FZ)(theme)), { fontWeight: menu ? type.fontWeight.regular : type.fontWeight.medium, display: 'flex', background: palette.background.light, position: 'relative', justifyContent: 'space-between', alignItems: 'center', minHeight: list.itemMinHeight, 'a&': {
                    textDecoration: 'none',
                } }), (accordion && {
                '&:hover, &:focus, &:active': {
                    cursor: 'pointer',
                },
            })), (transparent
                ? {
                    background: 'none',
                }
                : undefined)), { 
                // same specificity as parent List rules
                '[class^="wrenchList-"] &': list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign({}, (interactive && list_dist_index_es_assign(list_dist_index_es_assign({ transition: 'background 180ms linear' }, (isFocused && {
                    transition: 'background 125ms linear',
                    background: palette.background.accent,
                    cursor: 'pointer',
                })), { '&:hover, &:focus': {
                        transition: 'background 125ms linear',
                        background: palette.background.accent,
                        cursor: 'pointer',
                    }, '&:active': {
                        transition: 'background 125ms linear',
                        background: (0,utils_dist_index_es/* darken */._j)(0.05, palette.background.accent),
                    } }))), (upgrade && {
                    background: (0,utils_dist_index_es/* lighten */.$n)(0.42, palette.upgrade.main), // same specificity as transparent List rule
                })), (upgrade &&
                    interactive && {
                    '&:hover, &:focus': {
                        background: (0,utils_dist_index_es/* lighten */.$n)(0.35, palette.upgrade.main), // same specificity as transparent List rule
                    },
                })), (disabled && {
                    opacity: 0.5,
                    pointerEvents: 'none',
                })), { '&:before': list_dist_index_es_assign({}, ((color || marked) && {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: list.markWidth,
                        background: getMarkedColor(color, palette),
                    })) }) }));
        },
        wrenchListAddon: function () { return ({
            padding: [0, spacing[4], 0, spacing[5]],
            color: list.addonIconColor,
            display: 'flex',
            alignItems: 'center',
            '> [class^="wrenchIcons-"]': {
                marginLeft: spacing[2],
            },
        }); },
        /** Additional styles when addon is on the right */
        wrenchListAddonOnRight: function () { return ({
            paddingLeft: 0,
            paddingRight: spacing[6],
            color: palette.text.lightMuted,
        }); },
        wrenchListAffordance: function (_a) {
            var addOnLeft = _a.addOnLeft;
            return (list_dist_index_es_assign({ padding: [0, spacing[6], 0, 0], color: list.affordanceIconColor, display: 'flex', alignItems: 'center', '& > *': {
                    transition: "transform 150ms ".concat(motion.curve.ease),
                } }, (addOnLeft && { paddingLeft: 0 })));
        },
        wrenchListLabel: function (_a) {
            var addOnLeft = _a.addOnLeft;
            return (list_dist_index_es_assign({ flexGrow: 1, padding: [0, spacing[5]], fontSize: list.labelFontSize, lineHeight: 1.25, minWidth: 0, 'a &': {
                    color: palette.text.dark,
                } }, (addOnLeft && { paddingLeft: 0 })));
        },
        wrenchPaneHide: function (_a) {
            var expanded = _a.expanded;
            return (expanded ? null : utils_dist_index_es/* visuallyHidden */.jy);
        },
    };
    return listStyles;
});

var ListItem = (0,react.forwardRef)(function (_a, ref) {
    var addOnLeft = _a.addOnLeft, addOnRight = _a.addOnRight, affordance = _a.affordance, children = _a.children, color = _a.color, component = _a.component, disabled = _a.disabled, id = _a.id, index = _a.index, isFocused = _a.isFocused, interactive = _a.interactive, marked = _a.marked, menu = _a.menu, navigationTarget = _a.navigationTarget, onClick = _a.onClick, upgrade = _a.upgrade, isNavigable = _a.isNavigable, transparent = _a.transparent, other = list_dist_index_es_rest(_a, ["addOnLeft", "addOnRight", "affordance", "children", "color", "component", "disabled", "id", "index", "isFocused", "interactive", "marked", "menu", "navigationTarget", "onClick", "upgrade", "isNavigable", "transparent"]);
    // no reason to expose these in props
    var accordion = other.accordion, expanded = other.expanded, paneComponent = other.paneComponent, rest = list_dist_index_es_rest(other, ["accordion", "expanded", "paneComponent"]);
    var _b = index_es_useStyles$1({
        accordion: accordion,
        color: color,
        marked: marked,
        menu: menu,
        disabled: disabled,
        upgrade: upgrade,
        isFocused: isFocused,
        interactive: interactive,
        addOnLeft: addOnLeft,
        expanded: expanded,
        transparent: transparent,
    }), wrenchListRow = _b.wrenchListRow, wrenchListItem = _b.wrenchListItem, wrenchListLabel = _b.wrenchListLabel, wrenchListAddon = _b.wrenchListAddon, wrenchListAddonOnRight = _b.wrenchListAddonOnRight, wrenchListAffordance = _b.wrenchListAffordance;
    var addOnClassNames = (0,utils_dist_index_es/* clsx */.Wy)(wrenchListAddon, wrenchListAddonOnRight);
    var href = isNavigable ? navigationTarget : undefined;
    var ListItemWrapper = (isNavigable
        ? component !== null && component !== void 0 ? component : 'a'
        : 'div');
    var interactiveProps = interactive
        ? { tabIndex: disabled ? '-1' : 0, role: 'button' }
        : {};
    var onHandleKeyDown = function (e) {
        if (onClick && (e.key === utils_dist_index_es/* KEYS.ENTER */.tW.ENTER || e.key === utils_dist_index_es/* KEYS.SPACE */.tW.SPACE)) {
            onClick(e);
        }
    };
    return (react.createElement("li", { className: wrenchListRow },
        react.createElement(ListItemWrapper, list_dist_index_es_assign({ disabled: disabled, className: wrenchListItem, onClick: function (e) { return onClick === null || onClick === void 0 ? void 0 : onClick(e); }, onKeyDown: onHandleKeyDown, href: href, id: id, "data-index": index, ref: ref }, interactiveProps, (0,utils_dist_index_es/* safeRest */.Q6)(rest)),
            addOnLeft && react.createElement("div", { className: wrenchListAddon }, addOnLeft),
            react.createElement("span", { className: wrenchListLabel }, children),
            addOnRight && react.createElement("div", { className: addOnClassNames }, addOnRight),
            affordance && (react.createElement("span", { className: wrenchListAffordance }, affordance))),
        typeof expanded !== 'undefined' && paneComponent));
});
ListItem.defaultProps = {
    accordion: false,
    addOnLeft: undefined,
    addOnRight: undefined,
    affordance: undefined,
    children: undefined,
    color: undefined,
    component: undefined,
    disabled: false,
    id: undefined,
    index: undefined,
    interactive: false,
    isFocused: false,
    isNavigable: false,
    marked: false,
    menu: false,
    // eslint-disable-next-line no-script-url
    navigationTarget: 'javascript:void(0)',
    onClick: undefined,
    upgrade: false,
};
// The displayName is needed for component's Accordion and perhaps other consumers in the future
// https://reactjs.org/docs/forwarding-refs.html#displaying-a-custom-name-in-devtools
ListItem.displayName = 'ListItem';

var list_dist_index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var spacing = theme.spacing, type = theme.type;
    var list = {
        itemDenseMinHeight: 40,
    };
    var listStyles = {
        wrenchList: function (_a) {
            var dense = _a.dense, noRules = _a.noRules;
            return (list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign(list_dist_index_es_assign({}, utils_dist_index_es/* defaultBaseline */.yD), { display: 'block' }), (dense && {
                '& [class^="wrenchListAddon-"]': {
                    paddingLeft: spacing[4],
                    '& [class^="wrenchIcons-"]': { paddingLeft: 0 },
                },
                // second className so it needs `*- not ^=` selector
                '& [class*="wrenchListAddonOnRight-"]': {
                    paddingRight: spacing[4],
                },
                '& [class^="wrenchListLabel-"]': {
                    fontWeight: type.fontWeight.regular,
                    margin: [spacing[3] + 1, 0],
                },
                '& [class^="wrenchListItem-"]': {
                    minHeight: list.itemDenseMinHeight,
                    borderBottom: 'none',
                },
            })), (noRules && {
                '& [class^="wrenchListRow-"]': {
                    borderBottom: 'none',
                },
            })));
        },
    };
    return listStyles;
});

var List = (0,react.forwardRef)(function (_a, ref) {
    var dense = _a.dense, interactive = _a.interactive, noRules = _a.noRules, transparent = _a.transparent, children = _a.children, role = _a.role, id = _a.id;
    var wrenchList = list_dist_index_es_useStyles({
        dense: dense,
        interactive: interactive,
        noRules: noRules,
        transparent: transparent,
    }).wrenchList;
    var newChildren = react.Children.map(children, function (child, index) {
        // Case wherte we have to allow transparent only for clone element?
        return react.isValidElement(child) &&
            react.cloneElement(child, { interactive: interactive, index: index, transparent: transparent });
    });
    return (react.createElement("ul", { ref: ref, className: wrenchList, role: role, id: id }, newChildren));
});
List.defaultProps = {
    dense: false,
    id: undefined,
    interactive: false,
    noRules: false,
    role: undefined,
    transparent: false,
};
List.displayName = 'List';
List.Item = ListItem;



// EXTERNAL MODULE: ./node_modules/@wds/grid/dist/index.es.js
var grid_dist_index_es = __webpack_require__(8597);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/images/audience.svg
/* harmony default export */ var images_audience = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/audience.27145ac6.svg","height":64,"width":64});
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/images/copy-paste.svg
/* harmony default export */ var copy_paste = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/copy-paste.8c8e962d.svg","height":64,"width":64});
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/images/create-scratch.svg
/* harmony default export */ var create_scratch = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/create-scratch.2aa727aa.svg","height":64,"width":64});
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/images/bifm.svg
/* harmony default export */ var bifm = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/bifm.d3a69219.svg","height":65,"width":64});
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/images/guided-setup.svg
/* harmony default export */ var guided_setup = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/guided-setup.9d60f40e.svg","height":64,"width":64});
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/images/solution.svg
/* harmony default export */ var solution = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/solution.1f0c748f.svg","height":65,"width":64});
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/images/template.svg
/* harmony default export */ var template = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/template.80837556.svg","height":53,"width":52});
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/ButtonCreateVariants.js

var ButtonCreateVariants_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonCreateVariant/ButtonCreateVariants.tsx", ButtonCreateVariants_this = undefined;
function ButtonCreateVariants_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function ButtonCreateVariants_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ButtonCreateVariants_ownKeys(Object(source), !0).forEach(function(key) {
            ButtonCreateVariants_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ButtonCreateVariants_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ButtonCreateVariants_defineProperty(obj, key, value) {
    key = ButtonCreateVariants_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonCreateVariants_toPropertyKey(arg) {
    var key = ButtonCreateVariants_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function ButtonCreateVariants_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



















var ButtonCreateVariants_COPY = {
    startingPoint: {
        id: "ButtonCreateVariant.startingPoint",
        defaultMessage: "Choose a starting point...",
        description: "[Type: Header][Vis.: high] - Heading for sidebar drawer menu for creating a survey"
    },
    guidedSetup: {
        id: "ButtonCreateVariant.guidedSetup",
        defaultMessage: "Guided setup",
        description: "[Type: Header][Vis.: high] - Heading for sidebar drawer menu for using our solutions products"
    },
    goBackToStartingPoint: {
        id: "ButtonCreateVariant.goBackToStartingPoint",
        defaultMessage: 'Go back to "Choose a starting point"',
        description: "[Type: Label][Vis.: high] - Label used exclusively for screen readers for going back in a menu"
    },
    startWithBlank: {
        id: "ButtonCreateVariant.startWithBlank",
        defaultMessage: "Start with a blank survey",
        description: "[Type: Label][Vis.: high] - Title for a link to survey creation, starting from scratch"
    },
    startWithBlankDesc: {
        id: "ButtonCreateVariant.startWithBlankDesc",
        defaultMessage: "Best for experienced survey authors",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to survey creation, starting from scratch"
    },
    startWithBlankVariantDesc: {
        id: "ButtonCreateVariant.startWithBlankVariantDesc",
        defaultMessage: "Good for those who want to start from scratch or copy and paste",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to survey creation, starting from scratch -- variant copy"
    },
    copyPaste: {
        id: "ButtonCreateVariant.copyPaste",
        defaultMessage: "Copy and paste from doc",
        description: "[Type: Label][Vis.: high] - Title for a link to survey creation, starting with copy/paste"
    },
    copyPasteDesc: {
        id: "ButtonCreateVariant.copyPasteDesc",
        defaultMessage: "Great for anyone who wants to import prewritten questions",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to survey creation, starting with copy/paste"
    },
    guidedSetupMenuItem: {
        id: "ButtonCreateVariant.guidedSetupMenuItem",
        defaultMessage: "Try guided setup",
        description: "[Type: Label][Vis.: high] - Title for a button that opens a sub-menu detailing our marketing solutions"
    },
    guidedSetupMenuItemDesc: {
        id: "ButtonCreateVariant.guidedSetupMenuItemDesc",
        defaultMessage: "Helpful for those who want guidance, templates or brand/marketing insights",
        description: "[Type: Paragraph][Vis.: high] - Description for a button that opens a sub-menu detailing our marketing solutions"
    },
    guidedSetupVariantDesc: {
        id: "ButtonCreateVariant.guidedSetupVariantDesc",
        defaultMessage: "Helpful for people who like step-by-step guidance",
        description: '[Type: Paragraph][Vis.: high] - Description for a button that opens create with "build it for me" auto-opened'
    },
    buyResponses: {
        id: "ButtonCreateVariant.buyResponses",
        defaultMessage: "Buy targeted responses",
        description: "[Type: Label][Vis.: high] - Title for a link to Audience preview"
    },
    buyResponsesDesc: {
        id: "ButtonCreateVariant.buyResponsesDesc",
        defaultMessage: "Excellent for people who want to start by choosing audience demographics",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    insightsSolutions: {
        id: "ButtonCreateVariant.insightsSolutions",
        defaultMessage: "Insights solutions",
        description: "[Type: Label][Vis.: high] - Title for a link to Audience preview"
    },
    insightsSolutionsVariant: {
        id: "ButtonCreateVariant.insightsSolutionsVariant",
        defaultMessage: "Do brand or market research",
        description: "[Type: Label][Vis.: high] - Title for a link to the solutions marketplace launchpad"
    },
    insightsSolutionsVariantDesc: {
        id: "ButtonCreateVariant.insightsSolutionsVariantDesc",
        defaultMessage: "Useful for those who want to test an idea or track a brand/market",
        description: "[Type: Paragraph][Vis.: high] - Description for a button that links to the solutions marketplace launchpad"
    },
    insightsSolutionsDesc: {
        id: "ButtonCreateVariant.insightsSolutionsDesc",
        defaultMessage: "Get an AI-backed solution like...",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    brandTracking: {
        id: "ButtonCreateVariant.brandTracking",
        defaultMessage: "Brand tracking",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    conceptTesting: {
        id: "ButtonCreateVariant.conceptTesting",
        defaultMessage: "Concept testing",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    ideaScreening: {
        id: "ButtonCreateVariant.ideaScreening",
        defaultMessage: "Idea screening",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    muchMore: {
        id: "ButtonCreateVariant.muchMore",
        defaultMessage: "Much more",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    productGuidance: {
        id: "ButtonCreateVariant.productGuidance",
        defaultMessage: "In-product guidance",
        description: "[Type: Label][Vis.: high] - Title for a link to Audience preview"
    },
    productGuidanceDesc: {
        id: "ButtonCreateVariant.productGuidanceDesc",
        defaultMessage: "Let SurveyMonkey help via...",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    stepByStep: {
        id: "ButtonCreateVariant.stepByStep",
        defaultMessage: "Step-by-step instructions",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    standardSurveys: {
        id: "ButtonCreateVariant.standardSurveys",
        defaultMessage: "Standard surveys",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    featureExplanations: {
        id: "ButtonCreateVariant.featureExplanations",
        defaultMessage: "Feature explanations",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    customizationTips: {
        id: "ButtonCreateVariant.customizationTips",
        defaultMessage: "Customization tips",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    popularTemplate: {
        id: "ButtonCreateVariant.popularTemplate",
        defaultMessage: "Popular template",
        description: "[Type: Label][Vis.: high] - Title for a link to Audience preview"
    },
    popularTemplateDesc: {
        id: "ButtonCreateVariant.popularTemplateDesc",
        defaultMessage: "Pick from templates like...",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    popularTemplateVariant: {
        id: "ButtonCreateVariant.popularTemplateVariant",
        defaultMessage: "Pick a popular template",
        description: "[Type: Label][Vis.: high] - Title for a link to survey creation with templates auto-opened"
    },
    popularTemplateVariantDesc: {
        id: "ButtonCreateVariant.popularTemplateVariantDesc",
        defaultMessage: "Good for anyone who wants to ask common questions",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to survey creation with templates auto-opened"
    },
    customerSatisfaction: {
        id: "ButtonCreateVariant.customerSatisfaction",
        defaultMessage: "Customer satisfaction",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    employeeEngagement: {
        id: "ButtonCreateVariant.employeeEngagement",
        defaultMessage: "Employee engagement",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    netPromoterScore: {
        id: "ButtonCreateVariant.netPromoterScore",
        defaultMessage: "Net promoter score",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    },
    manyOthers: {
        id: "ButtonCreateVariant.manyOthers",
        defaultMessage: "Many others",
        description: "[Type: Paragraph][Vis.: high] - Description for a link to Audience preview"
    }
};
var convertToMenuItem = function convertToMenuItem(viewListItem, clickHandler) {
    var _viewListItem$navigat;
    if (!viewListItem.navigationTarget && clickHandler) {
        return ButtonCreateVariants_objectSpread(ButtonCreateVariants_objectSpread({}, viewListItem), {}, {
            onClick: clickHandler
        });
    }
    return ButtonCreateVariants_objectSpread(ButtonCreateVariants_objectSpread({}, viewListItem), {}, {
        href: (_viewListItem$navigat = viewListItem.navigationTarget) !== null && _viewListItem$navigat !== void 0 ? _viewListItem$navigat : ""
    });
};
var startFromScratch = {
    eventName: ClickMetricEventName.StartFromScratch,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.startWithBlank),
    iconSrc: create_scratch,
    navigationTarget: (0,dist.createURL)("/create/", {
        ut_source: "header",
        create: "scratch"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 271,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.startWithBlankDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 272,
            columnNumber: 7
        }
    }))
};
var startFromScratchVariant = {
    eventName: ClickMetricEventName.StartFromScratch,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.startWithBlank),
    iconSrc: create_scratch,
    navigationTarget: (0,dist.createURL)("/create/", {
        ut_source: "header",
        create: "scratch"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 286,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.startWithBlankVariantDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 287,
            columnNumber: 7
        }
    }))
};
var copyAndPaste = {
    eventName: ClickMetricEventName.CopyAndPaste,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.copyPaste),
    iconSrc: copy_paste,
    navigationTarget: (0,dist.createURL)("/create/", {
        ut_source: "header",
        create: "importQuestions"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 301,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.copyPasteDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 302,
            columnNumber: 7
        }
    }))
};
var seeGuidedSetupOptions = {
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.guidedSetupMenuItem),
    iconSrc: guided_setup,
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 311,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.guidedSetupMenuItemDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 312,
            columnNumber: 7
        }
    }))
};
var buyResponses = {
    eventName: ClickMetricEventName.Audience,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.buyResponses),
    iconSrc: images_audience,
    navigationTarget: (0,dist.createURL)("/collect/audience/calculator/preview/", {
        ut_source: "header"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 325,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.buyResponsesDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 326,
            columnNumber: 7
        }
    }))
};
var solutions = {
    eventName: ClickMetricEventName.Solution,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.insightsSolutions),
    iconSrc: solution,
    navigationTarget: (0,dist.createURL)("/market-research/solutions/get-started/", {
        ut_source: "header"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 339,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.insightsSolutionsDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 340,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("ul", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 341,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 342,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.brandTracking,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 343,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 345,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.conceptTesting,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 346,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 348,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.ideaScreening,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 349,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 351,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.muchMore,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 352,
            columnNumber: 11
        }
    }))))
};
var solutionsVariant = {
    eventName: ClickMetricEventName.Solution,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.insightsSolutionsVariant),
    iconSrc: solution,
    navigationTarget: (0,dist.createURL)("/market-research/solutions/get-started/", {
        ut_source: "header"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 367,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.insightsSolutionsVariantDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 368,
            columnNumber: 7
        }
    }))
};
var buildItForMe = {
    eventName: ClickMetricEventName.BuildItForMe,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.productGuidance),
    iconSrc: bifm,
    navigationTarget: (0,dist.createURL)("/create/", {
        ut_source: "header",
        create: "bifm"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 382,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.productGuidanceDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 383,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("ul", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 384,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 385,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.stepByStep,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 386,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 388,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.standardSurveys,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 389,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 391,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.featureExplanations,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 392,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 394,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.customizationTips,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 395,
            columnNumber: 11
        }
    }))))
};
var buildItForMeVariant = {
    eventName: ClickMetricEventName.BuildItForMe,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.guidedSetupMenuItem),
    iconSrc: bifm,
    navigationTarget: (0,dist.createURL)("/create/", {
        ut_source: "header",
        create: "bifm"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 411,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.guidedSetupVariantDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 412,
            columnNumber: 7
        }
    }))
};
var templates = {
    eventName: ClickMetricEventName.Template,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.popularTemplate),
    iconSrc: template,
    navigationTarget: (0,dist.createURL)("/create/", {
        ut_source: "header",
        create: "template"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 426,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.popularTemplateDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 427,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("ul", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 428,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 429,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.customerSatisfaction,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 430,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 432,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.employeeEngagement,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 433,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 435,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.netPromoterScore,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 436,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement("li", {
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 438,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.manyOthers,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 439,
            columnNumber: 11
        }
    }))))
};
var templatesVariant = {
    eventName: ClickMetricEventName.Template,
    title: (0,intl_dist.t)(ButtonCreateVariants_COPY.popularTemplateVariant),
    iconSrc: template,
    navigationTarget: (0,dist.createURL)("/create/", {
        ut_source: "header",
        create: "template"
    }),
    bodyContent: /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 455,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.popularTemplateVariantDesc,
        __self: undefined,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 456,
            columnNumber: 7
        }
    }))
};
var ButtonCreateVariants_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        listItemContent: {
            whiteSpace: "break-spaces",
            marginTop: "".concat(theme.spacing[1], "px")
        },
        sheetTitle: {
            margin: "".concat(theme.spacing[5], "px 0 ").concat(theme.spacing[5], "px ").concat(theme.spacing[4], "px")
        },
        bolded: {
            fontWeight: 400,
            color: theme.palette.text.dark
        },
        listItem: {
            padding: "".concat(theme.spacing[4], "px 0 ").concat(theme.spacing[4], "px 0")
        },
        listLink: {
            display: "block",
            borderBottom: "solid thin ".concat(theme.palette.border.main),
            "&:last-child": {
                borderBottom: "none"
            },
            "&:hover,:focus": {
                textDecoration: "none"
            }
        },
        listItemTitle: {
            fontSize: "16px"
        },
        backButton: {
            textDecoration: "none",
            border: "none",
            background: "transparent",
            "&:hover": {
                cursor: "pointer",
                background: theme.palette.background.accent
            }
        },
        backButtonIcon: {
            display: "flex",
            alignItems: "center",
            marginRight: "".concat(theme.spacing[2], "px"),
            color: theme.palette.text.darkMuted,
            fontSize: "20px"
        },
        iconImageContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            height: "100%",
            "& img": {
                height: "48px",
                width: "48px"
            }
        }
    };
});
var ButtonCreateVariants_ListItem = function ListItem(_ref) {
    var listItem = _ref.listItem, pageName = _ref.pageName;
    var _useStyles = ButtonCreateVariants_useStyles(), listItemClass = _useStyles.listItem, listLinkClass = _useStyles.listLink, listItemContent = _useStyles.listItemContent, listItemTitle = _useStyles.listItemTitle, iconImageContainer = _useStyles.iconImageContainer;
    var isButton = isClickMenuItem(listItem);
    var inner = /*#__PURE__*/ react.createElement("div", {
        className: listItemClass,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 534,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        noBleeds: true,
        noGutters: true,
        fluid: true,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 535,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        xs: 2,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 536,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: iconImageContainer,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 537,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement("img", {
        src: listItem.iconSrc,
        alt: "",
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 538,
            columnNumber: 13
        }
    }))), /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        xs: 10,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 541,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 542,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement("strong", {
        className: listItemTitle,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 548,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement("strong", {
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 549,
            columnNumber: 15
        }
    }, listItem.title)), /*#__PURE__*/ react.createElement("div", {
        className: listItemContent,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 551,
            columnNumber: 13
        }
    }, listItem.bodyContent)))));
    if (isButton) {
        return /*#__PURE__*/ react.createElement(List.Item, {
            interactive: true,
            onClick: isClickMenuItem(listItem) ? listItem.onClick : undefined,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 560,
                columnNumber: 7
            }
        }, inner);
    }
    return /*#__PURE__*/ react.createElement("a", {
        className: listLinkClass,
        href: isHrefMenuItem(listItem) ? listItem.href : undefined,
        target: "_blank",
        rel: "noreferrer noopener",
        "data-sm-metrics": isHrefMenuItem(listItem) && listItem.eventName ? (0,metrics_dist.generateMetricsAttribute)({
            data: {
                pageName: pageName,
                amplitudeEvent: "create menu clicked option",
                ctaName: listItem.eventName
            }
        }) : undefined,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 570,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(List.Item, {
        interactive: true,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 587,
            columnNumber: 7
        }
    }, inner));
};
var DrillDownMenuVariant = function DrillDownMenuVariant(_ref2) {
    var view = _ref2.view, setView = _ref2.setView, pageName = _ref2.pageName;
    var _useStyles2 = ButtonCreateVariants_useStyles(), sheetTitle = _useStyles2.sheetTitle, backButton = _useStyles2.backButton, backButtonIcon = _useStyles2.backButtonIcon, bolded = _useStyles2.bolded;
    var startingPointMenuItems = [
        startFromScratch,
        copyAndPaste,
        seeGuidedSetupOptions,
        buyResponses
    ].map(function(viewListItem) {
        return convertToMenuItem(viewListItem, function() {
            return setView(View.GuidedSetup);
        });
    });
    var guidedSetupMenuItems = [
        solutions,
        buildItForMe,
        templates
    ].map(function(viewListItem) {
        return convertToMenuItem(viewListItem);
    });
    return view === View.StartingPoint ? [
        /*#__PURE__*/ react.createElement("div", {
            className: sheetTitle,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 620,
                columnNumber: 9
            },
            key: "0"
        }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            variant: "sectionTitle",
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 621,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement("span", {
            className: bolded,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 622,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(intl_dist.T, {
            desc: ButtonCreateVariants_COPY.startingPoint,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 623,
                columnNumber: 15
            }
        })))),
        /*#__PURE__*/ react.createElement(List, {
            interactive: true,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 627,
                columnNumber: 9
            },
            key: "1"
        }, startingPointMenuItems.map(function(viewListItem) {
            return /*#__PURE__*/ react.createElement(ButtonCreateVariants_ListItem, {
                listItem: viewListItem,
                pageName: pageName,
                key: "starting-point-list-item-".concat(viewListItem.title),
                __self: ButtonCreateVariants_this,
                __source: {
                    fileName: ButtonCreateVariants_jsxFileName,
                    lineNumber: 629,
                    columnNumber: 13
                }
            });
        }))
    ] : view === View.GuidedSetup ? [
        /*#__PURE__*/ react.createElement("button", {
            type: "button",
            className: backButton,
            onClick: function onClick() {
                return setView(View.StartingPoint);
            },
            "aria-label": (0,intl_dist.t)(ButtonCreateVariants_COPY.goBackToStartingPoint),
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 638,
                columnNumber: 9
            },
            key: "0"
        }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            variant: "sectionTitle",
            color: "dark",
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 644,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            display: "flex",
            alignItems: "center",
            className: classnames_default()(sheetTitle, bolded),
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 645,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement("span", {
            className: backButtonIcon,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 650,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconChevronLeft */.ed9, {
            title: "",
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 651,
                columnNumber: 17
            }
        })), /*#__PURE__*/ react.createElement(intl_dist.T, {
            desc: ButtonCreateVariants_COPY.guidedSetup,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 653,
                columnNumber: 15
            }
        })))),
        /*#__PURE__*/ react.createElement(List, {
            interactive: true,
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 657,
                columnNumber: 9
            },
            key: "1"
        }, guidedSetupMenuItems.map(function(viewListItem) {
            return /*#__PURE__*/ react.createElement(ButtonCreateVariants_ListItem, {
                listItem: viewListItem,
                pageName: pageName,
                key: "guided-setup-list-item-".concat(viewListItem.title),
                __self: ButtonCreateVariants_this,
                __source: {
                    fileName: ButtonCreateVariants_jsxFileName,
                    lineNumber: 659,
                    columnNumber: 13
                }
            });
        }))
    ] : null;
};
var SingleLevelVariant = function SingleLevelVariant(_ref3) {
    var view = _ref3.view, pageName = _ref3.pageName;
    var menuItems = [
        startFromScratchVariant,
        templatesVariant,
        buildItForMeVariant,
        solutionsVariant,
        buyResponses
    ].map(function(viewListItem) {
        return convertToMenuItem(viewListItem);
    });
    var _useStyles3 = ButtonCreateVariants_useStyles(), sheetTitle = _useStyles3.sheetTitle, bolded = _useStyles3.bolded;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: sheetTitle,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 689,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "sectionTitle",
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 690,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("span", {
        className: bolded,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 691,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariants_COPY.startingPoint,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 692,
            columnNumber: 13
        }
    })))), /*#__PURE__*/ react.createElement(List, {
        interactive: true,
        __self: ButtonCreateVariants_this,
        __source: {
            fileName: ButtonCreateVariants_jsxFileName,
            lineNumber: 696,
            columnNumber: 7
        }
    }, menuItems.map(function(viewListItem) {
        return /*#__PURE__*/ react.createElement(ButtonCreateVariants_ListItem, {
            listItem: viewListItem,
            pageName: pageName,
            key: "single-level-list-item-".concat(viewListItem.title),
            __self: ButtonCreateVariants_this,
            __source: {
                fileName: ButtonCreateVariants_jsxFileName,
                lineNumber: 698,
                columnNumber: 11
            }
        });
    })));
}; //# sourceMappingURL=ButtonCreateVariants.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/ButtonCreateVariant.js
var ButtonCreateVariant_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonCreateVariant/ButtonCreateVariant.tsx", ButtonCreateVariant_this = undefined;
function ButtonCreateVariant_slicedToArray(arr, i) {
    return ButtonCreateVariant_arrayWithHoles(arr) || ButtonCreateVariant_iterableToArrayLimit(arr, i) || ButtonCreateVariant_unsupportedIterableToArray(arr, i) || ButtonCreateVariant_nonIterableRest();
}
function ButtonCreateVariant_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ButtonCreateVariant_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ButtonCreateVariant_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ButtonCreateVariant_arrayLikeToArray(o, minLen);
}
function ButtonCreateVariant_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function ButtonCreateVariant_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function ButtonCreateVariant_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}









var ButtonCreateVariant_COPY = {
    createSurvey: {
        id: "ButtonCreateVariant.createSurvey",
        defaultMessage: "Create survey",
        description: "[Type: Button][Vis.: high] - This is the create survey addon button on the header."
    }
};
var ButtonCreateVariant_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    return {
        container: {
            color: theme.palette.text.dark
        }
    };
});
var ButtonCreate = function ButtonCreate(_ref) {
    var treatment = _ref.treatment;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var _useState = (0,react.useState)(View.None), _useState2 = ButtonCreateVariant_slicedToArray(_useState, 2), view = _useState2[0], setView = _useState2[1];
    var _useStyles = ButtonCreateVariant_useStyles(), container = _useStyles.container;
    return /*#__PURE__*/ react.createElement("div", {
        className: container,
        __self: ButtonCreateVariant_this,
        __source: {
            fileName: ButtonCreateVariant_jsxFileName,
            lineNumber: 39,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        size: "sm",
        color: "alt",
        onClick: function onClick() {
            return setView(View.StartingPoint);
        },
        "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked cta",
                ctaName: "create survey"
            }
        }),
        __self: ButtonCreateVariant_this,
        __source: {
            fileName: ButtonCreateVariant_jsxFileName,
            lineNumber: 40,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreateVariant_COPY.createSurvey,
        __self: ButtonCreateVariant_this,
        __source: {
            fileName: ButtonCreateVariant_jsxFileName,
            lineNumber: 53,
            columnNumber: 9
        }
    })), /*#__PURE__*/ react.createElement(Sheet, {
        show: view !== View.None,
        onClose: function onClose() {
            return setView(View.None);
        },
        size: "md",
        __self: ButtonCreateVariant_this,
        __source: {
            fileName: ButtonCreateVariant_jsxFileName,
            lineNumber: 55,
            columnNumber: 7
        }
    }, treatment === ExperimentVariant.DrillDownMenu ? /*#__PURE__*/ react.createElement(DrillDownMenuVariant, {
        view: view,
        setView: setView,
        pageName: pageName !== null && pageName !== void 0 ? pageName : "",
        __self: ButtonCreateVariant_this,
        __source: {
            fileName: ButtonCreateVariant_jsxFileName,
            lineNumber: 62,
            columnNumber: 13
        }
    }) : /*#__PURE__*/ react.createElement(SingleLevelVariant, {
        view: view,
        pageName: pageName !== null && pageName !== void 0 ? pageName : "",
        __self: ButtonCreateVariant_this,
        __source: {
            fileName: ButtonCreateVariant_jsxFileName,
            lineNumber: 69,
            columnNumber: 13
        }
    })));
};
/* harmony default export */ var ButtonCreateVariant = (ButtonCreate); //# sourceMappingURL=ButtonCreateVariant.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreateVariant/index.js

 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonCreate.js
var ButtonCreate_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonCreate.tsx", ButtonCreate_this = undefined;








var ButtonCreate_COPY = (0,intl_dist/* defineMessages */.vU)({
    CREATE_SURVEY: {
        id: "ButtonCreate.createSurvey",
        defaultMessage: "Create survey",
        description: "[Type: Label][Vis.: high] - This is the create survey addon button on the header."
    }
});
var ButtonCreate_ButtonCreate = function ButtonCreate() {
    var _HEADER_EXP$createSur;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var _useContext2 = (0,react.useContext)(components_StaticContext/* StaticContext */.vN), _useContext2$HEADER_E = _useContext2.HEADER_EXP, HEADER_EXP = _useContext2$HEADER_E === void 0 ? {} : _useContext2$HEADER_E;
    var experimentTreatment = HEADER_EXP === null || HEADER_EXP === void 0 ? void 0 : (_HEADER_EXP$createSur = HEADER_EXP.createSurveyButton) === null || _HEADER_EXP$createSur === void 0 ? void 0 : _HEADER_EXP$createSur.treatment;
    if (Object.values(ExperimentVariant).includes(experimentTreatment)) {
        return /*#__PURE__*/ react.createElement(ButtonCreateVariant, {
            treatment: experimentTreatment,
            __self: ButtonCreate_this,
            __source: {
                fileName: ButtonCreate_jsxFileName,
                lineNumber: 25,
                columnNumber: 12
            }
        });
    }
    return /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        size: "sm",
        color: "alt",
        href: (0,dist.createURL)("/create/", {
            ut_source: "header"
        }),
        "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked cta",
                ctaName: "create survey"
            }
        }),
        __self: ButtonCreate_this,
        __source: {
            fileName: ButtonCreate_jsxFileName,
            lineNumber: 29,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonCreate_COPY.CREATE_SURVEY,
        __self: ButtonCreate_this,
        __source: {
            fileName: ButtonCreate_jsxFileName,
            lineNumber: 42,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var actions_ButtonCreate = (ButtonCreate_ButtonCreate); //# sourceMappingURL=ButtonCreate.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonSeatUpgrade.js
var ButtonSeatUpgrade_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonSeatUpgrade.tsx", ButtonSeatUpgrade_this = undefined;
function ButtonSeatUpgrade_slicedToArray(arr, i) {
    return ButtonSeatUpgrade_arrayWithHoles(arr) || ButtonSeatUpgrade_iterableToArrayLimit(arr, i) || ButtonSeatUpgrade_unsupportedIterableToArray(arr, i) || ButtonSeatUpgrade_nonIterableRest();
}
function ButtonSeatUpgrade_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ButtonSeatUpgrade_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ButtonSeatUpgrade_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ButtonSeatUpgrade_arrayLikeToArray(o, minLen);
}
function ButtonSeatUpgrade_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function ButtonSeatUpgrade_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function ButtonSeatUpgrade_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}






var ButtonSeatUpgrade_COPY = (0,intl_dist/* defineMessages */.vU)({
    SEAT_REQUEST: {
        id: "ButtonSeatUpgrade.SeatRequest",
        defaultMessage: "Request power seat",
        description: "[Type: Label][Vis.: high] - This is a button for users to request a seat upgrade."
    }
});
var ButtonUpgradeSeat = function ButtonUpgradeSeat() {
    var _useState = (0,react.useState)(false), _useState2 = ButtonSeatUpgrade_slicedToArray(_useState, 2), showModal = _useState2[0], setShowModal = _useState2[1];
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        color: "alt",
        size: "sm",
        disabled: showModal,
        onClick: function onClick() {
            setShowModal(true);
        },
        "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked cta",
                ctaName: "upgrade"
            }
        }),
        __self: ButtonSeatUpgrade_this,
        __source: {
            fileName: ButtonSeatUpgrade_jsxFileName,
            lineNumber: 23,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonSeatUpgrade_COPY.SEAT_REQUEST,
        __self: ButtonSeatUpgrade_this,
        __source: {
            fileName: ButtonSeatUpgrade_jsxFileName,
            lineNumber: 39,
            columnNumber: 9
        }
    })), /*#__PURE__*/ react.createElement(components_SeatRequestModal, {
        show: showModal,
        onClose: function onClose() {
            return setShowModal(false);
        },
        sourceCategoryKey: "global_header",
        __self: ButtonSeatUpgrade_this,
        __source: {
            fileName: ButtonSeatUpgrade_jsxFileName,
            lineNumber: 41,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var ButtonSeatUpgrade = (ButtonUpgradeSeat); //# sourceMappingURL=ButtonSeatUpgrade.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonUpgrade.js
var ButtonUpgrade_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonUpgrade.tsx", ButtonUpgrade_this = undefined;






var ButtonUpgrade_COPY = (0,intl_dist/* defineMessages */.vU)({
    UPGRADE: {
        id: "ButtonUpgrade.upgradeButton",
        defaultMessage: "Upgrade",
        description: "[Type: Label][Vis.: high] - This is the upgrade addon button on the header."
    }
});
var ButtonUpgrade = function ButtonUpgrade() {
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    return /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        size: "sm",
        color: "upgrade",
        "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked cta",
                ctaName: "upgrade"
            }
        }),
        href: (0,dist.createURL)("/pricing/upgrade/", {
            ut_source: "header_upgrade",
            ut_source3: "webplat"
        }),
        __self: ButtonUpgrade_this,
        __source: {
            fileName: ButtonUpgrade_jsxFileName,
            lineNumber: 20,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonUpgrade_COPY.UPGRADE,
        __self: ButtonUpgrade_this,
        __source: {
            fileName: ButtonUpgrade_jsxFileName,
            lineNumber: 36,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var actions_ButtonUpgrade = (ButtonUpgrade); //# sourceMappingURL=ButtonUpgrade.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonTeam.js
var ButtonTeam_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonTeam.tsx", ButtonTeam_this = undefined;




var ButtonTeam_COPY = (0,intl_dist/* defineMessages */.vU)({
    CREATE_TEAM: {
        id: "ButtonTeam.createTeam",
        defaultMessage: "Create team",
        description: "[Type: Label][Vis.: high] - This is the create team addon button on the header."
    }
});
var ButtonTeam = function ButtonTeam() {
    return /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        size: "sm",
        color: "upgrade",
        href: (0,dist.createURL)("/billing/p2gupgrade/", {
            ut_source: "header",
            ut_source3: "webplat"
        }),
        __self: ButtonTeam_this,
        __source: {
            fileName: ButtonTeam_jsxFileName,
            lineNumber: 17,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonTeam_COPY.CREATE_TEAM,
        __self: ButtonTeam_this,
        __source: {
            fileName: ButtonTeam_jsxFileName,
            lineNumber: 25,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var actions_ButtonTeam = (ButtonTeam); //# sourceMappingURL=ButtonTeam.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonUsers.js
var ButtonUsers_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonUsers.tsx", ButtonUsers_this = undefined;






var ButtonUsers_COPY = (0,intl_dist/* defineMessages */.vU)({
    ADD_USERS: {
        id: "ButtonUsers.addUsers",
        defaultMessage: "Add users",
        description: "[Type: Label][Vis.: high] - This is the add users addon button on the header."
    }
});
var ButtonUsers = function ButtonUsers() {
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    return /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        size: "sm",
        color: "upgrade",
        href: (0,dist.createURL)("/team/add/", {
            ut_source: "header",
            ut_source3: "webplat"
        }),
        "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked cta",
                ctaName: "add users"
            }
        }),
        __self: ButtonUsers_this,
        __source: {
            fileName: ButtonUsers_jsxFileName,
            lineNumber: 20,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: ButtonUsers_COPY.ADD_USERS,
        __self: ButtonUsers_this,
        __source: {
            fileName: ButtonUsers_jsxFileName,
            lineNumber: 36,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var actions_ButtonUsers = (ButtonUsers); //# sourceMappingURL=ButtonUsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/types.js
/** All built-in and custom scalars, mapped to their actual values */ /** Supports Image and Text A/B question type answers */ /** The types of activities associated with an individual activity log */ var ActivityActionType;
(function(ActivityActionType) {
    ActivityActionType["AuthenticationFailed"] = "AUTHENTICATION_FAILED";
    ActivityActionType["AuthenticationSignout"] = "AUTHENTICATION_SIGNOUT";
    ActivityActionType["AuthenticationSucceeded"] = "AUTHENTICATION_SUCCEEDED";
    ActivityActionType["CollectorInfoCreated"] = "COLLECTOR_INFO_CREATED";
    ActivityActionType["CollectorInfoDeleted"] = "COLLECTOR_INFO_DELETED";
    ActivityActionType["CollectorInfoUpdated"] = "COLLECTOR_INFO_UPDATED";
    ActivityActionType["ExportDownloaded"] = "EXPORT_DOWNLOADED";
    ActivityActionType["ExportExportCreate"] = "EXPORT_EXPORT_CREATE";
    ActivityActionType["GrantInfoCreated"] = "GRANT_INFO_CREATED";
    ActivityActionType["GrantInfoDeleted"] = "GRANT_INFO_DELETED";
    ActivityActionType["GroupInfoUpdatedGroupName"] = "GROUP_INFO_UPDATED_GROUP_NAME";
    ActivityActionType["InviteCreated"] = "INVITE_CREATED";
    ActivityActionType["InviteResent"] = "INVITE_RESENT";
    ActivityActionType["MemberDeleted"] = "MEMBER_DELETED";
    ActivityActionType["MemberJoined"] = "MEMBER_JOINED";
    ActivityActionType["MemberUpdatedGroupMemberType"] = "MEMBER_UPDATED_GROUP_MEMBER_TYPE";
    ActivityActionType["PermissionCreated"] = "PERMISSION_CREATED";
    ActivityActionType["PermissionUpdated"] = "PERMISSION_UPDATED";
    ActivityActionType["RespondentDeleted"] = "RESPONDENT_DELETED";
    ActivityActionType["RespondentUpdated"] = "RESPONDENT_UPDATED";
    ActivityActionType["ScimTokenCreated"] = "SCIM_TOKEN_CREATED";
    ActivityActionType["ScimTokenRevoked"] = "SCIM_TOKEN_REVOKED";
    ActivityActionType["ScimTokenUpdated"] = "SCIM_TOKEN_UPDATED";
    ActivityActionType["ScimUserCreated"] = "SCIM_USER_CREATED";
    ActivityActionType["ScimUserDeleted"] = "SCIM_USER_DELETED";
    ActivityActionType["ScimUserLinkedToSso"] = "SCIM_USER_LINKED_TO_SSO";
    ActivityActionType["ScimUserUpdated"] = "SCIM_USER_UPDATED";
    ActivityActionType["SharedViewCreated"] = "SHARED_VIEW_CREATED";
    ActivityActionType["SharedViewUpdated"] = "SHARED_VIEW_UPDATED";
    ActivityActionType["SurveyInfoCopy"] = "SURVEY_INFO_COPY";
    ActivityActionType["SurveyInfoCreate"] = "SURVEY_INFO_CREATE";
    ActivityActionType["SurveyInfoDelete"] = "SURVEY_INFO_DELETE";
    ActivityActionType["SurveyInfoTransfer"] = "SURVEY_INFO_TRANSFER";
    ActivityActionType["SurveyInfoUpdate"] = "SURVEY_INFO_UPDATE";
})(ActivityActionType || (ActivityActionType = {}));
var ActivityCategories; /** The activity category related to app installs */ 
(function(ActivityCategories) {
    ActivityCategories["AppInstall"] = "APP_INSTALL";
    ActivityCategories["Collaboration"] = "COLLABORATION";
    ActivityCategories["Collect"] = "COLLECT";
    ActivityCategories["Logins"] = "LOGINS";
    ActivityCategories["Scim"] = "SCIM";
    ActivityCategories["Survey"] = "SURVEY";
})(ActivityCategories || (ActivityCategories = {})); /** The types of methods to collect survey results */ 
var ActivityCollectorType; /** The actions a user could take on a collector object */ 
(function(ActivityCollectorType) {
    ActivityCollectorType["Audience"] = "AUDIENCE";
    ActivityCollectorType["Email"] = "EMAIL";
    ActivityCollectorType["Facebook"] = "FACEBOOK";
    ActivityCollectorType["FacebookMessenger"] = "FACEBOOK_MESSENGER";
    ActivityCollectorType["MobileSdk"] = "MOBILE_SDK";
    ActivityCollectorType["OfflineKiosk"] = "OFFLINE_KIOSK";
    ActivityCollectorType["Popup"] = "POPUP";
    ActivityCollectorType["Sms"] = "SMS";
    ActivityCollectorType["Weblink"] = "WEBLINK";
})(ActivityCollectorType || (ActivityCollectorType = {}));
var ActivityCollectorUpdateAction; /** The format of exported jobs */ 
(function(ActivityCollectorUpdateAction) {
    ActivityCollectorUpdateAction["Close"] = "CLOSE";
    ActivityCollectorUpdateAction["Open"] = "OPEN";
    ActivityCollectorUpdateAction["Rename"] = "RENAME";
    ActivityCollectorUpdateAction["Update"] = "UPDATE";
})(ActivityCollectorUpdateAction || (ActivityCollectorUpdateAction = {}));
var ActivityExportJobFormat;
(function(ActivityExportJobFormat) {
    ActivityExportJobFormat["Csv"] = "CSV";
    ActivityExportJobFormat["Excel"] = "EXCEL";
    ActivityExportJobFormat["ExcelPlus"] = "EXCEL_PLUS";
    ActivityExportJobFormat["Gss"] = "GSS";
    ActivityExportJobFormat["Html"] = "HTML";
    ActivityExportJobFormat["Pdf"] = "PDF";
    ActivityExportJobFormat["Png"] = "PNG";
    ActivityExportJobFormat["Ppt"] = "PPT";
    ActivityExportJobFormat["Spss"] = "SPSS";
})(ActivityExportJobFormat || (ActivityExportJobFormat = {})); /** The types of members associated with an individual activity log */ 
var ActivityMemberType; /** The permission types on a survey */ 
(function(ActivityMemberType) {
    ActivityMemberType["AccountOwner"] = "ACCOUNT_OWNER";
    ActivityMemberType["Admin"] = "ADMIN";
    ActivityMemberType["Analyst"] = "ANALYST";
    ActivityMemberType["Casual"] = "CASUAL";
    ActivityMemberType["DivisionAdmin"] = "DIVISION_ADMIN";
    ActivityMemberType["NonEnterprise"] = "NON_ENTERPRISE";
    ActivityMemberType["Regular"] = "REGULAR";
})(ActivityMemberType || (ActivityMemberType = {}));
var ActivityPermissionType; /** The restrictions on shared surveys */ 
(function(ActivityPermissionType) {
    ActivityPermissionType["Analyze"] = "ANALYZE";
    ActivityPermissionType["Collect"] = "COLLECT";
    ActivityPermissionType["Design"] = "DESIGN";
})(ActivityPermissionType || (ActivityPermissionType = {}));
var ActivityShareType; /** The third party services a user could use as a log in method */ 
(function(ActivityShareType) {
    ActivityShareType["Private"] = "PRIVATE";
    ActivityShareType["Public"] = "PUBLIC";
    ActivityShareType["Restricted"] = "RESTRICTED";
})(ActivityShareType || (ActivityShareType = {}));
var ActivityThirdPartyLoginType;
(function(ActivityThirdPartyLoginType) {
    ActivityThirdPartyLoginType["Facebook"] = "FACEBOOK";
    ActivityThirdPartyLoginType["Google"] = "GOOGLE";
    ActivityThirdPartyLoginType["Microsoft"] = "MICROSOFT";
    ActivityThirdPartyLoginType["SamlEnterprise"] = "SAML_ENTERPRISE";
})(ActivityThirdPartyLoginType || (ActivityThirdPartyLoginType = {})); /** Indicates how new surveys created by team members should be automatically shared. */ 
var AdminShareSetting;
(function(AdminShareSetting) {
    AdminShareSetting["MaxPermissions"] = "MAX_PERMISSIONS";
    AdminShareSetting["MaxPermissionsAllowShareOff"] = "MAX_PERMISSIONS_ALLOW_SHARE_OFF";
    AdminShareSetting["MaxPermissionsCanDecrease"] = "MAX_PERMISSIONS_CAN_DECREASE";
    AdminShareSetting["ViewOnlyPermissionsCanIncrease"] = "VIEW_ONLY_PERMISSIONS_CAN_INCREASE";
})(AdminShareSetting || (AdminShareSetting = {}));
var AlertChannel;
(function(AlertChannel) {
    AlertChannel["Email"] = "EMAIL";
    AlertChannel["Mobile"] = "MOBILE";
})(AlertChannel || (AlertChannel = {})); /** Cell type for XLS format exports */ 
var AnalysisExportCellDisplay; /** Column type for XLS format exports */ 
(function(AnalysisExportCellDisplay) {
    AnalysisExportCellDisplay["ActualText"] = "ACTUAL_TEXT";
    AnalysisExportCellDisplay["NumericalValue"] = "NUMERICAL_VALUE";
})(AnalysisExportCellDisplay || (AnalysisExportCellDisplay = {}));
var AnalysisExportColumnCompression;
(function(AnalysisExportColumnCompression) {
    AnalysisExportColumnCompression["Condensed"] = "CONDENSED";
    AnalysisExportColumnCompression["CondensedMulti"] = "CONDENSED_MULTI";
    AnalysisExportColumnCompression["Expanded"] = "EXPANDED";
})(AnalysisExportColumnCompression || (AnalysisExportColumnCompression = {})); /** File format for exported data */ 
var AnalysisExportJobFormat; /** Required job info for all analysis export variations */ 
(function(AnalysisExportJobFormat) {
    AnalysisExportJobFormat["Csv"] = "CSV";
    AnalysisExportJobFormat["Pdf"] = "PDF";
    AnalysisExportJobFormat["Ppt"] = "PPT";
    AnalysisExportJobFormat["Spss"] = "SPSS";
    AnalysisExportJobFormat["Xls"] = "XLS";
})(AnalysisExportJobFormat || (AnalysisExportJobFormat = {})); /** Analyze Export Job Status */ 
var AnalysisExportJobStatus; /** Orientation type for PDF format exports */ 
(function(AnalysisExportJobStatus) {
    AnalysisExportJobStatus["Enqueued"] = "ENQUEUED";
    AnalysisExportJobStatus["ServerError"] = "SERVER_ERROR";
    AnalysisExportJobStatus["Started"] = "STARTED";
    AnalysisExportJobStatus["Success"] = "SUCCESS";
})(AnalysisExportJobStatus || (AnalysisExportJobStatus = {}));
var AnalysisExportOrientation; /** Paper size for PDF format exports */ 
(function(AnalysisExportOrientation) {
    AnalysisExportOrientation["Landscape"] = "LANDSCAPE";
    AnalysisExportOrientation["Portait"] = "PORTAIT";
})(AnalysisExportOrientation || (AnalysisExportOrientation = {}));
var AnalysisExportPaperSize; /** All inputs required for question level exports */ 
(function(AnalysisExportPaperSize) {
    AnalysisExportPaperSize["A4"] = "A4";
    AnalysisExportPaperSize["Legal"] = "LEGAL";
    AnalysisExportPaperSize["Letter"] = "LETTER";
})(AnalysisExportPaperSize || (AnalysisExportPaperSize = {})); /** Whether to display export data on one or multiple sheets */ 
var AnalysisExportQuestionSheetDisplay; /** Copy translations to display for analysis summary type exports */ 
(function(AnalysisExportQuestionSheetDisplay) {
    AnalysisExportQuestionSheetDisplay["MultipleSheets"] = "MULTIPLE_SHEETS";
    AnalysisExportQuestionSheetDisplay["OneSheet"] = "ONE_SHEET";
})(AnalysisExportQuestionSheetDisplay || (AnalysisExportQuestionSheetDisplay = {})); /** Type of export */ 
var AnalysisJobType; /** Fields for PDF format analysis exports */ 
(function(AnalysisJobType) {
    AnalysisJobType["Chart"] = "CHART";
    AnalysisJobType["Full"] = "FULL";
    AnalysisJobType["Summary"] = "SUMMARY";
    AnalysisJobType["WordCloud"] = "WORD_CLOUD";
})(AnalysisJobType || (AnalysisJobType = {}));
var AnalysisQuestionCommentSearchOperator; /** Individual question specific input */ 
(function(AnalysisQuestionCommentSearchOperator) {
    AnalysisQuestionCommentSearchOperator["Eq"] = "EQ";
    AnalysisQuestionCommentSearchOperator["Gt"] = "GT";
    AnalysisQuestionCommentSearchOperator["Lt"] = "LT";
})(AnalysisQuestionCommentSearchOperator || (AnalysisQuestionCommentSearchOperator = {}));
var AnalysisQuestionOptionSearchType;
(function(AnalysisQuestionOptionSearchType) {
    AnalysisQuestionOptionSearchType["All"] = "ALL";
    AnalysisQuestionOptionSearchType["Any"] = "ANY";
    AnalysisQuestionOptionSearchType["Exact"] = "EXACT";
})(AnalysisQuestionOptionSearchType || (AnalysisQuestionOptionSearchType = {}));
var AnalysisSharedViewBranding;
(function(AnalysisSharedViewBranding) {
    AnalysisSharedViewBranding["Custom"] = "CUSTOM";
    AnalysisSharedViewBranding["Default"] = "DEFAULT";
    AnalysisSharedViewBranding["None"] = "NONE";
})(AnalysisSharedViewBranding || (AnalysisSharedViewBranding = {}));
var AnalysisSharedViewMode;
(function(AnalysisSharedViewMode) {
    AnalysisSharedViewMode["Browse"] = "BROWSE";
    AnalysisSharedViewMode["DataTrends"] = "DATA_TRENDS";
    AnalysisSharedViewMode["Summary"] = "SUMMARY";
})(AnalysisSharedViewMode || (AnalysisSharedViewMode = {}));
var AnalysisSharedViewType; /**
 * A subset of response data defined by user filtering rules
 * for better data analysis
 */ 
(function(AnalysisSharedViewType) {
    AnalysisSharedViewType["Email"] = "EMAIL";
    AnalysisSharedViewType["Facebook"] = "FACEBOOK";
    AnalysisSharedViewType["InstantResults"] = "INSTANT_RESULTS";
    AnalysisSharedViewType["Public"] = "PUBLIC";
    AnalysisSharedViewType["Weblink"] = "WEBLINK";
})(AnalysisSharedViewType || (AnalysisSharedViewType = {})); /** Indicate the purpose of the AnalysisView */ 
var AnalysisViewType; /** Full XLS Specific export input */ 
(function(AnalysisViewType) {
    AnalysisViewType["Export"] = "EXPORT";
    AnalysisViewType["ReadOnly"] = "READ_ONLY";
    AnalysisViewType["Shared"] = "SHARED";
    AnalysisViewType["Standard"] = "STANDARD";
})(AnalysisViewType || (AnalysisViewType = {}));
var AnonymousResponseType;
(function(AnonymousResponseType) {
    AnonymousResponseType["FullyAnonymous"] = "FULLY_ANONYMOUS";
    AnonymousResponseType["NotAnonymous"] = "NOT_ANONYMOUS";
    AnonymousResponseType["PartiallyAnonymous"] = "PARTIALLY_ANONYMOUS";
})(AnonymousResponseType || (AnonymousResponseType = {}));
var AnswerOtherType;
(function(AnswerOtherType) {
    AnswerOtherType["Answer"] = "ANSWER";
    AnswerOtherType["Comment"] = "COMMENT";
    AnswerOtherType["CommentColumn"] = "COMMENT_COLUMN";
})(AnswerOtherType || (AnswerOtherType = {})); /** The types of configured criteria balancing options that may be associated with an Audience project */ 
var AudienceBalanceScheme; /** Describes a criteria balancing configuration */ 
(function(AudienceBalanceScheme) {
    AudienceBalanceScheme["BasicCensus"] = "BASIC_CENSUS";
    AudienceBalanceScheme["Crude"] = "CRUDE";
    AudienceBalanceScheme["CrudeAge"] = "CRUDE_AGE";
    AudienceBalanceScheme["CrudeGenderAge"] = "CRUDE_GENDER_AGE";
    AudienceBalanceScheme["Custom"] = "CUSTOM";
    AudienceBalanceScheme["Exact"] = "EXACT";
    AudienceBalanceScheme["FullAge"] = "FULL_AGE";
    AudienceBalanceScheme["FullCensus"] = "FULL_CENSUS";
    AudienceBalanceScheme["FullGenderAge"] = "FULL_GENDER_AGE";
    AudienceBalanceScheme["None"] = "NONE";
})(AudienceBalanceScheme || (AudienceBalanceScheme = {})); /** The selection type available to Audience clients for a particular criteria. */ 
var AudienceCriteriaAnswerType;
(function(AudienceCriteriaAnswerType) {
    AudienceCriteriaAnswerType["Multiselect"] = "MULTISELECT";
    AudienceCriteriaAnswerType["Range"] = "RANGE";
    AudienceCriteriaAnswerType["Select"] = "SELECT";
})(AudienceCriteriaAnswerType || (AudienceCriteriaAnswerType = {}));
var AudienceFeasibilityPredictedCompletionTime;
(function(AudienceFeasibilityPredictedCompletionTime) {
    AudienceFeasibilityPredictedCompletionTime["NineToSixteenHours"] = "NINE_TO_SIXTEEN_HOURS";
    AudienceFeasibilityPredictedCompletionTime["None"] = "NONE";
    AudienceFeasibilityPredictedCompletionTime["OneToEightHours"] = "ONE_TO_EIGHT_HOURS";
    AudienceFeasibilityPredictedCompletionTime["OverTwentyFourHours"] = "OVER_TWENTY_FOUR_HOURS";
    AudienceFeasibilityPredictedCompletionTime["SeventeenToTwentyFourHours"] = "SEVENTEEN_TO_TWENTY_FOUR_HOURS";
})(AudienceFeasibilityPredictedCompletionTime || (AudienceFeasibilityPredictedCompletionTime = {}));
var AudienceGeniusEvent;
(function(AudienceGeniusEvent) {
    AudienceGeniusEvent["Accepted"] = "ACCEPTED";
    AudienceGeniusEvent["Displayed"] = "DISPLAYED";
    AudienceGeniusEvent["Purchased"] = "PURCHASED";
    AudienceGeniusEvent["Rejected"] = "REJECTED";
})(AudienceGeniusEvent || (AudienceGeniusEvent = {}));
var AudienceInvoiceStatus; /** Survey configurations that are not allowed by Audience mobile apps produce these errors */ 
(function(AudienceInvoiceStatus) {
    AudienceInvoiceStatus["Authorized"] = "AUTHORIZED";
    AudienceInvoiceStatus["NotPaid"] = "NOT_PAID";
    AudienceInvoiceStatus["Paid"] = "PAID";
    AudienceInvoiceStatus["PaymentFailed"] = "PAYMENT_FAILED";
})(AudienceInvoiceStatus || (AudienceInvoiceStatus = {}));
var AudienceMobileGuardrailViolation;
(function(AudienceMobileGuardrailViolation) {
    AudienceMobileGuardrailViolation["HasChatbotEnabled"] = "HAS_CHATBOT_ENABLED";
    AudienceMobileGuardrailViolation["HasMenuMatrixQuestion"] = "HAS_MENU_MATRIX_QUESTION";
    AudienceMobileGuardrailViolation["HasTooManyOpenEndedQuestions"] = "HAS_TOO_MANY_OPEN_ENDED_QUESTIONS";
    AudienceMobileGuardrailViolation["HasTooManyQuestions"] = "HAS_TOO_MANY_QUESTIONS";
})(AudienceMobileGuardrailViolation || (AudienceMobileGuardrailViolation = {}));
var AudiencePriority;
(function(AudiencePriority) {
    AudiencePriority["HighPriority"] = "HIGH_PRIORITY";
    AudiencePriority["Normal"] = "NORMAL";
})(AudiencePriority || (AudiencePriority = {}));
var AudienceProjectCategory; /** Represents input needed to create an Audience project configuration */ 
(function(AudienceProjectCategory) {
    AudienceProjectCategory["Admin"] = "ADMIN";
    AudienceProjectCategory["AdminBt"] = "ADMIN_BT";
    AudienceProjectCategory["AdminCtm"] = "ADMIN_CTM";
    AudienceProjectCategory["AdminMms"] = "ADMIN_MMS";
    AudienceProjectCategory["BrandTracking"] = "BRAND_TRACKING";
    AudienceProjectCategory["ConceptTest"] = "CONCEPT_TEST";
    AudienceProjectCategory["Corp"] = "CORP";
    AudienceProjectCategory["Mms"] = "MMS";
    AudienceProjectCategory["SelfServe"] = "SELF_SERVE";
    AudienceProjectCategory["Solutions"] = "SOLUTIONS";
})(AudienceProjectCategory || (AudienceProjectCategory = {})); /** Audience project configuration errors */ 
var AudienceProjectGuardrailViolation; /** Input needed to create an Audience project */ 
(function(AudienceProjectGuardrailViolation) {
    AudienceProjectGuardrailViolation["HasDqQuestionWithoutQualificationRate"] = "HAS_DQ_QUESTION_WITHOUT_QUALIFICATION_RATE";
    AudienceProjectGuardrailViolation["HasQualificationRateWithoutDqQuestion"] = "HAS_QUALIFICATION_RATE_WITHOUT_DQ_QUESTION";
})(AudienceProjectGuardrailViolation || (AudienceProjectGuardrailViolation = {}));
var AudienceProjectStatuses;
(function(AudienceProjectStatuses) {
    AudienceProjectStatuses["Active"] = "ACTIVE";
    AudienceProjectStatuses["Completed"] = "COMPLETED";
    AudienceProjectStatuses["Deleted"] = "DELETED";
    AudienceProjectStatuses["Draft"] = "DRAFT";
    AudienceProjectStatuses["Ended"] = "ENDED";
    AudienceProjectStatuses["Failed"] = "FAILED";
    AudienceProjectStatuses["Paused"] = "PAUSED";
    AudienceProjectStatuses["Processing"] = "PROCESSING";
    AudienceProjectStatuses["Purchasing"] = "PURCHASING";
    AudienceProjectStatuses["Scheduled"] = "SCHEDULED";
    AudienceProjectStatuses["Scheduling"] = "SCHEDULING";
    AudienceProjectStatuses["Unscheduled"] = "UNSCHEDULED";
})(AudienceProjectStatuses || (AudienceProjectStatuses = {}));
var AudienceProvider;
(function(AudienceProvider) {
    AudienceProvider["Cint"] = "CINT";
    AudienceProvider["Contribute"] = "CONTRIBUTE";
    AudienceProvider["Lucid"] = "LUCID";
    AudienceProvider["Rewards"] = "REWARDS";
})(AudienceProvider || (AudienceProvider = {})); /** Survey configurations that are not allowed by SurveyMonkey Rewards */ 
var AudienceSmrGuardrailViolation; /** Survey configurations that are not allowed by Audience produce these errors */ 
(function(AudienceSmrGuardrailViolation) {
    AudienceSmrGuardrailViolation["HasBlockRandomization"] = "HAS_BLOCK_RANDOMIZATION";
    AudienceSmrGuardrailViolation["HasClickMapQuestion"] = "HAS_CLICK_MAP_QUESTION";
    AudienceSmrGuardrailViolation["HasIncidenceRateTesting"] = "HAS_INCIDENCE_RATE_TESTING";
    AudienceSmrGuardrailViolation["HasMatrixRankingScaleQuestion"] = "HAS_MATRIX_RANKING_SCALE_QUESTION";
})(AudienceSmrGuardrailViolation || (AudienceSmrGuardrailViolation = {}));
var AudienceSurveyGuardrailViolation;
(function(AudienceSurveyGuardrailViolation) {
    AudienceSurveyGuardrailViolation["HasCyclicPath"] = "HAS_CYCLIC_PATH";
    AudienceSurveyGuardrailViolation["HasFileUploadQuestion"] = "HAS_FILE_UPLOAD_QUESTION";
    AudienceSurveyGuardrailViolation["HasPaymentQuestion"] = "HAS_PAYMENT_QUESTION";
    AudienceSurveyGuardrailViolation["HasPii"] = "HAS_PII";
    AudienceSurveyGuardrailViolation["HasQuotas"] = "HAS_QUOTAS";
    AudienceSurveyGuardrailViolation["HasTooManyQuestions"] = "HAS_TOO_MANY_QUESTIONS";
    AudienceSurveyGuardrailViolation["HasWebLinks"] = "HAS_WEB_LINKS";
    AudienceSurveyGuardrailViolation["NoPageAfterDqQuestion"] = "NO_PAGE_AFTER_DQ_QUESTION";
    AudienceSurveyGuardrailViolation["NoRequiredQuestion"] = "NO_REQUIRED_QUESTION";
})(AudienceSurveyGuardrailViolation || (AudienceSurveyGuardrailViolation = {}));
var BifmUseCase;
(function(BifmUseCase) {
    BifmUseCase["AdTesting"] = "AD_TESTING";
    BifmUseCase["AppFeedback"] = "APP_FEEDBACK";
    BifmUseCase["BenefitsSatisfaction"] = "BENEFITS_SATISFACTION";
    BifmUseCase["BrandAwareness"] = "BRAND_AWARENESS";
    BifmUseCase["BrandTracking"] = "BRAND_TRACKING";
    BifmUseCase["CategoryAwareness"] = "CATEGORY_AWARENESS";
    BifmUseCase["CommunityFeedback"] = "COMMUNITY_FEEDBACK";
    BifmUseCase["CompetitorResearch"] = "COMPETITOR_RESEARCH";
    BifmUseCase["ConsumerBehavior"] = "CONSUMER_BEHAVIOR";
    BifmUseCase["CourseEvaluation"] = "COURSE_EVALUATION";
    BifmUseCase["CovidSymptomTracking"] = "COVID_SYMPTOM_TRACKING";
    BifmUseCase["CustomerLoyalty"] = "CUSTOMER_LOYALTY";
    BifmUseCase["CustomerSatisfaction"] = "CUSTOMER_SATISFACTION";
    BifmUseCase["CustomerSupportFeedback"] = "CUSTOMER_SUPPORT_FEEDBACK";
    BifmUseCase["DiversityInclusion"] = "DIVERSITY_INCLUSION";
    BifmUseCase["EmployeeEngagement"] = "EMPLOYEE_ENGAGEMENT";
    BifmUseCase["EmployeePerformance"] = "EMPLOYEE_PERFORMANCE";
    BifmUseCase["EmployeeSatisfaction"] = "EMPLOYEE_SATISFACTION";
    BifmUseCase["EventRegistration"] = "EVENT_REGISTRATION";
    BifmUseCase["Fundraising"] = "FUNDRAISING";
    BifmUseCase["GoalCheckin"] = "GOAL_CHECKIN";
    BifmUseCase["JobApplication"] = "JOB_APPLICATION";
    BifmUseCase["LogoTesting"] = "LOGO_TESTING";
    BifmUseCase["MarketSegmentation"] = "MARKET_SEGMENTATION";
    BifmUseCase["MeetingFeedback"] = "MEETING_FEEDBACK";
    BifmUseCase["MessageTesting"] = "MESSAGE_TESTING";
    BifmUseCase["NameTesting"] = "NAME_TESTING";
    BifmUseCase["NeighborhoodFeedback"] = "NEIGHBORHOOD_FEEDBACK";
    BifmUseCase["NewHireFeedback"] = "NEW_HIRE_FEEDBACK";
    BifmUseCase["NewProductConceptTesting"] = "NEW_PRODUCT_CONCEPT_TESTING";
    BifmUseCase["OnsiteWorkerEngagementBackToX"] = "ONSITE_WORKER_ENGAGEMENT_BACK_TO_X";
    BifmUseCase["OtherCustomers"] = "OTHER_CUSTOMERS";
    BifmUseCase["OtherEmployeeOrCoworkers"] = "OTHER_EMPLOYEE_OR_COWORKERS";
    BifmUseCase["OtherEventAttendees"] = "OTHER_EVENT_ATTENDEES";
    BifmUseCase["OtherStudentsOrParents"] = "OTHER_STUDENTS_OR_PARENTS";
    BifmUseCase["OtherTargetMarket"] = "OTHER_TARGET_MARKET";
    BifmUseCase["OtherVolunteersOrCommunity"] = "OTHER_VOLUNTEERS_OR_COMMUNITY";
    BifmUseCase["PackageTesting"] = "PACKAGE_TESTING";
    BifmUseCase["ParentFeedback"] = "PARENT_FEEDBACK";
    BifmUseCase["PatientSatisfaction"] = "PATIENT_SATISFACTION";
    BifmUseCase["PickATimeEducation"] = "PICK_A_TIME_EDUCATION";
    BifmUseCase["PickATimeEmployees"] = "PICK_A_TIME_EMPLOYEES";
    BifmUseCase["PostEventFeedback"] = "POST_EVENT_FEEDBACK";
    BifmUseCase["PricingTesting"] = "PRICING_TESTING";
    BifmUseCase["QuizEducation"] = "QUIZ_EDUCATION";
    BifmUseCase["QuizEmployees"] = "QUIZ_EMPLOYEES";
    BifmUseCase["RecruitingFeedback"] = "RECRUITING_FEEDBACK";
    BifmUseCase["RemoteWorkerEngagementBackToX"] = "REMOTE_WORKER_ENGAGEMENT_BACK_TO_X";
    BifmUseCase["ReturningToWorkplaceBackToX"] = "RETURNING_TO_WORKPLACE_BACK_TO_X";
    BifmUseCase["Review_360"] = "REVIEW_360";
    BifmUseCase["SchoolEvaluation"] = "SCHOOL_EVALUATION";
    BifmUseCase["SimpleRsvp"] = "SIMPLE_RSVP";
    BifmUseCase["TrainingFeedback"] = "TRAINING_FEEDBACK";
    BifmUseCase["VolunteerFeedback"] = "VOLUNTEER_FEEDBACK";
    BifmUseCase["VoteEducation"] = "VOTE_EDUCATION";
    BifmUseCase["VoteEmployees"] = "VOTE_EMPLOYEES";
    BifmUseCase["WebsiteFeedback"] = "WEBSITE_FEEDBACK";
})(BifmUseCase || (BifmUseCase = {}));
var BillingAccountType;
(function(BillingAccountType) {
    BillingAccountType["GroupMember"] = "GROUP_MEMBER";
    BillingAccountType["GroupOwner"] = "GROUP_OWNER";
    BillingAccountType["Individual"] = "INDIVIDUAL";
})(BillingAccountType || (BillingAccountType = {}));
var BillingContactType;
(function(BillingContactType) {
    BillingContactType["Primary"] = "PRIMARY";
    BillingContactType["Secondary"] = "SECONDARY";
})(BillingContactType || (BillingContactType = {}));
var BillingPartner;
(function(BillingPartner) {
    BillingPartner["Momentive"] = "MOMENTIVE";
    BillingPartner["Surveymonkey"] = "SURVEYMONKEY";
    BillingPartner["Wufoo"] = "WUFOO";
})(BillingPartner || (BillingPartner = {}));
var BillingPaymentMethod;
(function(BillingPaymentMethod) {
    BillingPaymentMethod["BankTransfer"] = "BANK_TRANSFER";
    BillingPaymentMethod["ChargeBack"] = "CHARGE_BACK";
    BillingPaymentMethod["CompUpgrade"] = "COMP_UPGRADE";
    BillingPaymentMethod["CreditCard"] = "CREDIT_CARD";
    BillingPaymentMethod["DirectDebit"] = "DIRECT_DEBIT";
    BillingPaymentMethod["Echeck"] = "ECHECK";
    BillingPaymentMethod["Invoice"] = "INVOICE";
    BillingPaymentMethod["ManualCreditCard"] = "MANUAL_CREDIT_CARD";
    BillingPaymentMethod["Mobile"] = "MOBILE";
    BillingPaymentMethod["Paypal"] = "PAYPAL";
    BillingPaymentMethod["TempUpgrade"] = "TEMP_UPGRADE";
    BillingPaymentMethod["Unassigned"] = "UNASSIGNED";
    BillingPaymentMethod["WalletCredits"] = "WALLET_CREDITS";
    BillingPaymentMethod["WireCheck"] = "WIRE_CHECK";
})(BillingPaymentMethod || (BillingPaymentMethod = {}));
var BillingPaymentMethodSubtype;
(function(BillingPaymentMethodSubtype) {
    BillingPaymentMethodSubtype["AmericanExpress"] = "AMERICAN_EXPRESS";
    BillingPaymentMethodSubtype["Australia"] = "AUSTRALIA";
    BillingPaymentMethodSubtype["Austria"] = "AUSTRIA";
    BillingPaymentMethodSubtype["Belgium"] = "BELGIUM";
    BillingPaymentMethodSubtype["Canada"] = "CANADA";
    BillingPaymentMethodSubtype["Cartasi"] = "CARTASI";
    BillingPaymentMethodSubtype["CarteBleue"] = "CARTE_BLEUE";
    BillingPaymentMethodSubtype["DankortVisa"] = "DANKORT_VISA";
    BillingPaymentMethodSubtype["DinersClub"] = "DINERS_CLUB";
    BillingPaymentMethodSubtype["Discover"] = "DISCOVER";
    BillingPaymentMethodSubtype["Elv"] = "ELV";
    BillingPaymentMethodSubtype["ElvSepa"] = "ELV_SEPA";
    BillingPaymentMethodSubtype["GocardlessBacsDd"] = "GOCARDLESS_BACS_DD";
    BillingPaymentMethodSubtype["GocardlessSepaDd"] = "GOCARDLESS_SEPA_DD";
    BillingPaymentMethodSubtype["Italy"] = "ITALY";
    BillingPaymentMethodSubtype["Jcb"] = "JCB";
    BillingPaymentMethodSubtype["Mastercard"] = "MASTERCARD";
    BillingPaymentMethodSubtype["Netherlands"] = "NETHERLANDS";
    BillingPaymentMethodSubtype["PaypalOneTime"] = "PAYPAL_ONE_TIME";
    BillingPaymentMethodSubtype["PaypalRecurring"] = "PAYPAL_RECURRING";
    BillingPaymentMethodSubtype["Spain"] = "SPAIN";
    BillingPaymentMethodSubtype["Switzerland"] = "SWITZERLAND";
    BillingPaymentMethodSubtype["Usa"] = "USA";
    BillingPaymentMethodSubtype["Visa"] = "VISA";
    BillingPaymentMethodSubtype["VisaDelta"] = "VISA_DELTA";
})(BillingPaymentMethodSubtype || (BillingPaymentMethodSubtype = {}));
var BillingTaxPartner;
(function(BillingTaxPartner) {
    BillingTaxPartner["Avalara"] = "AVALARA";
    BillingTaxPartner["Taxamo"] = "TAXAMO";
})(BillingTaxPartner || (BillingTaxPartner = {}));
var BillingUserRole;
(function(BillingUserRole) {
    BillingUserRole["GroupMember"] = "GROUP_MEMBER";
    BillingUserRole["GroupOwner"] = "GROUP_OWNER";
    BillingUserRole["Individual"] = "INDIVIDUAL";
})(BillingUserRole || (BillingUserRole = {}));
var BulkTransferSurveyStatus;
(function(BulkTransferSurveyStatus) {
    BulkTransferSurveyStatus["Complete"] = "COMPLETE";
    BulkTransferSurveyStatus["Failed"] = "FAILED";
    BulkTransferSurveyStatus["InProgress"] = "IN_PROGRESS";
    BulkTransferSurveyStatus["Queued"] = "QUEUED";
})(BulkTransferSurveyStatus || (BulkTransferSurveyStatus = {}));
var BulkTransferSurveyStatusEntityType;
(function(BulkTransferSurveyStatusEntityType) {
    BulkTransferSurveyStatusEntityType["Collector"] = "COLLECTOR";
    BulkTransferSurveyStatusEntityType["Survey"] = "SURVEY";
})(BulkTransferSurveyStatusEntityType || (BulkTransferSurveyStatusEntityType = {}));
var ChoiceScreeningQuestionFamilyType;
(function(ChoiceScreeningQuestionFamilyType) {
    ChoiceScreeningQuestionFamilyType["MultipleChoice"] = "MULTIPLE_CHOICE";
    ChoiceScreeningQuestionFamilyType["SingleChoice"] = "SINGLE_CHOICE";
})(ChoiceScreeningQuestionFamilyType || (ChoiceScreeningQuestionFamilyType = {}));
var ClientErrorFamily;
(function(ClientErrorFamily) {
    ClientErrorFamily["BadRequest"] = "BAD_REQUEST";
    ClientErrorFamily["Forbidden"] = "FORBIDDEN";
    ClientErrorFamily["NotFound"] = "NOT_FOUND";
    ClientErrorFamily["RequestFailed"] = "REQUEST_FAILED";
    ClientErrorFamily["Unauthorized"] = "UNAUTHORIZED";
})(ClientErrorFamily || (ClientErrorFamily = {}));
var CollaboratorAccess;
(function(CollaboratorAccess) {
    CollaboratorAccess["FullAccess"] = "FULL_ACCESS";
    CollaboratorAccess["NoAccess"] = "NO_ACCESS";
    CollaboratorAccess["ReadOnly"] = "READ_ONLY";
})(CollaboratorAccess || (CollaboratorAccess = {}));
var CollaboratorKind;
(function(CollaboratorKind) {
    CollaboratorKind["Invite"] = "INVITE";
    CollaboratorKind["Team"] = "TEAM";
    CollaboratorKind["User"] = "USER";
})(CollaboratorKind || (CollaboratorKind = {})); /** The anonymous setting type of the collector */ 
var CollectorAnonymousType;
(function(CollectorAnonymousType) {
    CollectorAnonymousType["FullyAnonymous"] = "FULLY_ANONYMOUS";
    CollectorAnonymousType["NotAnonymous"] = "NOT_ANONYMOUS";
    CollectorAnonymousType["PartialyAnonymous"] = "PARTIALY_ANONYMOUS";
})(CollectorAnonymousType || (CollectorAnonymousType = {}));
var CollectorDisqualificationType;
(function(CollectorDisqualificationType) {
    CollectorDisqualificationType["CustomMessage"] = "CUSTOM_MESSAGE";
    CollectorDisqualificationType["CustomUrl"] = "CUSTOM_URL";
    CollectorDisqualificationType["StandardMessage"] = "STANDARD_MESSAGE";
})(CollectorDisqualificationType || (CollectorDisqualificationType = {}));
var CollectorIpRestrictionType;
(function(CollectorIpRestrictionType) {
    CollectorIpRestrictionType["Allowlist"] = "ALLOWLIST";
    CollectorIpRestrictionType["Blocklist"] = "BLOCKLIST";
})(CollectorIpRestrictionType || (CollectorIpRestrictionType = {})); /** The status of the collector, computed based on its questions and collectors. */ 
var CollectorStatus; /** ThankYou page details for a Collector */ 
(function(CollectorStatus) {
    CollectorStatus["Archived"] = "ARCHIVED";
    CollectorStatus["Clearing"] = "CLEARING";
    CollectorStatus["Closed"] = "CLOSED";
    CollectorStatus["Open"] = "OPEN";
    CollectorStatus["Unconfigured"] = "UNCONFIGURED";
})(CollectorStatus || (CollectorStatus = {})); /** The type of the collector, specifies how the survey is deployed */ 
var CollectorType;
(function(CollectorType) {
    CollectorType["Audience"] = "AUDIENCE";
    CollectorType["Email"] = "EMAIL";
    CollectorType["FacebookMessenger"] = "FACEBOOK_MESSENGER";
    CollectorType["KioskSurvey"] = "KIOSK_SURVEY";
    CollectorType["ManualDataEntry"] = "MANUAL_DATA_ENTRY";
    CollectorType["MobileSdk"] = "MOBILE_SDK";
    CollectorType["Popup"] = "POPUP";
    CollectorType["Sms"] = "SMS";
    CollectorType["SocialMedia"] = "SOCIAL_MEDIA";
    CollectorType["WebCampaign"] = "WEB_CAMPAIGN";
    CollectorType["Weblink"] = "WEBLINK";
})(CollectorType || (CollectorType = {})); /**
 * !!!
 * this entire file is pending to be deleted once the frontend refactoring is done
 * !!!
 * Combining either the top two or the bottom two options of the likert-scale questions
 * for the performance score calculation
 */ 
var CombineOptions; /** Common group settings that will be shared at the team and division level */ 
(function(CombineOptions) {
    CombineOptions["BottomTwo"] = "BOTTOM_TWO";
    CombineOptions["TopTwo"] = "TOP_TWO";
})(CombineOptions || (CombineOptions = {}));
var CompletenessTypes;
(function(CompletenessTypes) {
    CompletenessTypes["Completely"] = "COMPLETELY";
    CompletenessTypes["Disqualified"] = "DISQUALIFIED";
    CompletenessTypes["Overquota"] = "OVERQUOTA";
    CompletenessTypes["Partially"] = "PARTIALLY";
})(CompletenessTypes || (CompletenessTypes = {})); /** All the possible values that can be used as a CrossTabOption */ 
var ConceptTestingOptionType;
(function(ConceptTestingOptionType) {
    ConceptTestingOptionType["AnswerOption"] = "ANSWER_OPTION";
    ConceptTestingOptionType["GroupByAnswerOptions"] = "GROUP_BY_ANSWER_OPTIONS";
})(ConceptTestingOptionType || (ConceptTestingOptionType = {}));
var ConceptTestingStimulusType;
(function(ConceptTestingStimulusType) {
    ConceptTestingStimulusType["Image"] = "IMAGE";
    ConceptTestingStimulusType["Text"] = "TEXT";
    ConceptTestingStimulusType["Video"] = "VIDEO";
})(ConceptTestingStimulusType || (ConceptTestingStimulusType = {}));
var ContactQuestionFieldType;
(function(ContactQuestionFieldType) {
    ContactQuestionFieldType["Address"] = "ADDRESS";
    ContactQuestionFieldType["Address2"] = "ADDRESS2";
    ContactQuestionFieldType["City"] = "CITY";
    ContactQuestionFieldType["Company"] = "COMPANY";
    ContactQuestionFieldType["Country"] = "COUNTRY";
    ContactQuestionFieldType["Email"] = "EMAIL";
    ContactQuestionFieldType["Name"] = "NAME";
    ContactQuestionFieldType["Phone"] = "PHONE";
    ContactQuestionFieldType["State"] = "STATE";
    ContactQuestionFieldType["Zip"] = "ZIP";
})(ContactQuestionFieldType || (ContactQuestionFieldType = {}));
var ContactQuestionStateType;
(function(ContactQuestionStateType) {
    ContactQuestionStateType["OpenEnded"] = "OPEN_ENDED";
    ContactQuestionStateType["UsStatesList"] = "US_STATES_LIST";
})(ContactQuestionStateType || (ContactQuestionStateType = {}));
var ContentModuleEvent;
(function(ContentModuleEvent) {
    ContentModuleEvent["CtaClicked"] = "CTA_CLICKED";
    ContentModuleEvent["Interaction"] = "INTERACTION";
    ContentModuleEvent["ModuleDismissed"] = "MODULE_DISMISSED";
})(ContentModuleEvent || (ContentModuleEvent = {})); /** The type of contributor */ 
var ContributorRoleType; /** Web collector cookie match symbol type */ 
(function(ContributorRoleType) {
    ContributorRoleType["Analyst"] = "ANALYST";
    ContributorRoleType["Casual"] = "CASUAL";
    ContributorRoleType["Unspecified"] = "UNSPECIFIED";
})(ContributorRoleType || (ContributorRoleType = {}));
var CookieMatch; /** Responses to ClickMap */ 
(function(CookieMatch) {
    CookieMatch["Contains"] = "CONTAINS";
    CookieMatch["Ends"] = "ENDS";
    CookieMatch["Exact"] = "EXACT";
    CookieMatch["Exists"] = "EXISTS";
    CookieMatch["Notexists"] = "NOTEXISTS";
    CookieMatch["Regexp"] = "REGEXP";
    CookieMatch["Starts"] = "STARTS";
})(CookieMatch || (CookieMatch = {}));
var CreateCollectorErrorType;
(function(CreateCollectorErrorType) {
    CreateCollectorErrorType["FreeUserReachedCollectorLimit"] = "FREE_USER_REACHED_COLLECTOR_LIMIT";
    CreateCollectorErrorType["SurveyWithPaidFeaturesCreatingNonAudienceCollector"] = "SURVEY_WITH_PAID_FEATURES_CREATING_NON_AUDIENCE_COLLECTOR";
})(CreateCollectorErrorType || (CreateCollectorErrorType = {}));
var CreateLookerQueryTaskErrorType;
(function(CreateLookerQueryTaskErrorType) {
    CreateLookerQueryTaskErrorType["InvalidInput"] = "INVALID_INPUT";
    CreateLookerQueryTaskErrorType["NotFound"] = "NOT_FOUND";
})(CreateLookerQueryTaskErrorType || (CreateLookerQueryTaskErrorType = {}));
var CreateProjectInvoiceErrorType; /**
 * Parameters responseCount and qualificationRate are optional,
 * include to generate an additional responses invoice.
 */ 
(function(CreateProjectInvoiceErrorType) {
    CreateProjectInvoiceErrorType["AssociatedModuleRetired"] = "ASSOCIATED_MODULE_RETIRED";
    CreateProjectInvoiceErrorType["EntityManuallyChanged"] = "ENTITY_MANUALLY_CHANGED";
    CreateProjectInvoiceErrorType["InvalidProject"] = "INVALID_PROJECT";
    CreateProjectInvoiceErrorType["MissingRequiredAnswerAudiencePanel"] = "MISSING_REQUIRED_ANSWER_AUDIENCE_PANEL";
    CreateProjectInvoiceErrorType["MissingRequiredAnswers"] = "MISSING_REQUIRED_ANSWERS";
    CreateProjectInvoiceErrorType["MissingRequiredStimuliScreener"] = "MISSING_REQUIRED_STIMULI_SCREENER";
    CreateProjectInvoiceErrorType["MissingRequiredSurveyEntity"] = "MISSING_REQUIRED_SURVEY_ENTITY";
    CreateProjectInvoiceErrorType["OverQuestionLimit"] = "OVER_QUESTION_LIMIT";
    CreateProjectInvoiceErrorType["SurveyCreationCallIncomplete"] = "SURVEY_CREATION_CALL_INCOMPLETE";
    CreateProjectInvoiceErrorType["SurveyFeaturesMissing"] = "SURVEY_FEATURES_MISSING";
    CreateProjectInvoiceErrorType["SurveyServiceUnavailable"] = "SURVEY_SERVICE_UNAVAILABLE";
    CreateProjectInvoiceErrorType["UnsupportedBillingCountry"] = "UNSUPPORTED_BILLING_COUNTRY";
})(CreateProjectInvoiceErrorType || (CreateProjectInvoiceErrorType = {}));
var CreateTrackingDashboardErrorType;
(function(CreateTrackingDashboardErrorType) {
    CreateTrackingDashboardErrorType["DuplicateTitle"] = "DUPLICATE_TITLE";
})(CreateTrackingDashboardErrorType || (CreateTrackingDashboardErrorType = {})); /** A single tracking shared dashboard session */ 
var CreateTrackingSharedDashboardAuthSessionErrorType;
(function(CreateTrackingSharedDashboardAuthSessionErrorType) {
    CreateTrackingSharedDashboardAuthSessionErrorType["IncorrectPassword"] = "INCORRECT_PASSWORD";
})(CreateTrackingSharedDashboardAuthSessionErrorType || (CreateTrackingSharedDashboardAuthSessionErrorType = {}));
var CreateWebsiteContainerErrorType;
(function(CreateWebsiteContainerErrorType) {
    CreateWebsiteContainerErrorType["EmptyName"] = "EMPTY_NAME";
})(CreateWebsiteContainerErrorType || (CreateWebsiteContainerErrorType = {}));
var CurrencyTypeId;
(function(CurrencyTypeId) {
    CurrencyTypeId["Aed"] = "AED";
    CurrencyTypeId["Ars"] = "ARS";
    CurrencyTypeId["Aud"] = "AUD";
    CurrencyTypeId["Brl"] = "BRL";
    CurrencyTypeId["Cad"] = "CAD";
    CurrencyTypeId["Chf"] = "CHF";
    CurrencyTypeId["Clp"] = "CLP";
    CurrencyTypeId["Cop"] = "COP";
    CurrencyTypeId["Crc"] = "CRC";
    CurrencyTypeId["Czk"] = "CZK";
    CurrencyTypeId["Dkk"] = "DKK";
    CurrencyTypeId["Egp"] = "EGP";
    CurrencyTypeId["Eur"] = "EUR";
    CurrencyTypeId["Gbp"] = "GBP";
    CurrencyTypeId["Hkd"] = "HKD";
    CurrencyTypeId["Huf"] = "HUF";
    CurrencyTypeId["Idr"] = "IDR";
    CurrencyTypeId["Ils"] = "ILS";
    CurrencyTypeId["Inr"] = "INR";
    CurrencyTypeId["Isk"] = "ISK";
    CurrencyTypeId["Jpy"] = "JPY";
    CurrencyTypeId["Krw"] = "KRW";
    CurrencyTypeId["Mxn"] = "MXN";
    CurrencyTypeId["Myr"] = "MYR";
    CurrencyTypeId["Nok"] = "NOK";
    CurrencyTypeId["Nzd"] = "NZD";
    CurrencyTypeId["Pen"] = "PEN";
    CurrencyTypeId["Php"] = "PHP";
    CurrencyTypeId["Pln"] = "PLN";
    CurrencyTypeId["Qar"] = "QAR";
    CurrencyTypeId["Rub"] = "RUB";
    CurrencyTypeId["Sar"] = "SAR";
    CurrencyTypeId["Sek"] = "SEK";
    CurrencyTypeId["Sgd"] = "SGD";
    CurrencyTypeId["Thb"] = "THB";
    CurrencyTypeId["Try"] = "TRY";
    CurrencyTypeId["Twd"] = "TWD";
    CurrencyTypeId["Usd"] = "USD";
    CurrencyTypeId["Zar"] = "ZAR";
})(CurrencyTypeId || (CurrencyTypeId = {}));
var CustomEmailDomainDnsVerificationStatus;
(function(CustomEmailDomainDnsVerificationStatus) {
    CustomEmailDomainDnsVerificationStatus["Invalid"] = "INVALID";
    CustomEmailDomainDnsVerificationStatus["Pending"] = "PENDING";
    CustomEmailDomainDnsVerificationStatus["Unverified"] = "UNVERIFIED";
    CustomEmailDomainDnsVerificationStatus["Valid"] = "VALID";
})(CustomEmailDomainDnsVerificationStatus || (CustomEmailDomainDnsVerificationStatus = {}));
var CustomQuestionDisplay;
(function(CustomQuestionDisplay) {
    CustomQuestionDisplay["AfterStimuli"] = "AFTER_STIMULI";
    CustomQuestionDisplay["All"] = "ALL";
    CustomQuestionDisplay["BeforeStimuli"] = "BEFORE_STIMULI";
})(CustomQuestionDisplay || (CustomQuestionDisplay = {})); /** Web collector custom variable comparator type */ 
var CustomVariableComparator; /**
 * Defines analyze dashboard that is used to present survey results.
 * Enables user to customize survey results, add charts and text and share Dashboard with anyone.
 */ 
(function(CustomVariableComparator) {
    CustomVariableComparator["Contains"] = "CONTAINS";
    CustomVariableComparator["Equal"] = "EQUAL";
    CustomVariableComparator["Gt"] = "GT";
    CustomVariableComparator["Gte"] = "GTE";
    CustomVariableComparator["Lt"] = "LT";
    CustomVariableComparator["Lte"] = "LTE";
    CustomVariableComparator["Notcontains"] = "NOTCONTAINS";
    CustomVariableComparator["Notequal"] = "NOTEQUAL";
    CustomVariableComparator["Oneof"] = "ONEOF";
})(CustomVariableComparator || (CustomVariableComparator = {}));
var DashboardElementType; /** Describes empty analyze dashboard element */ 
(function(DashboardElementType) {
    DashboardElementType["Content"] = "CONTENT";
    DashboardElementType["Empty"] = "EMPTY";
    DashboardElementType["Question"] = "QUESTION";
})(DashboardElementType || (DashboardElementType = {})); /** represents the state of the developer app (not to be confused with app listing state) */ 
var DeveloperAppState; /** represents the type of the developer app */ 
(function(DeveloperAppState) {
    DeveloperAppState["Deployed"] = "DEPLOYED";
    DeveloperAppState["Disabled"] = "DISABLED";
    DeveloperAppState["Draft"] = "DRAFT";
})(DeveloperAppState || (DeveloperAppState = {}));
var DeveloperAppType; /** represents the direction taken from the current page */ 
(function(DeveloperAppType) {
    DeveloperAppType["Disabled"] = "DISABLED";
    DeveloperAppType["Draft"] = "DRAFT";
    DeveloperAppType["Private"] = "PRIVATE";
    DeveloperAppType["Public"] = "PUBLIC";
    DeveloperAppType["PublicPlus"] = "PUBLIC_PLUS";
})(DeveloperAppType || (DeveloperAppType = {}));
var DirectionType;
(function(DirectionType) {
    DirectionType["Back"] = "BACK";
    DirectionType["Next"] = "NEXT";
    DirectionType["Same"] = "SAME";
})(DirectionType || (DirectionType = {}));
var DisabledCollectorReason;
(function(DisabledCollectorReason) {
    DisabledCollectorReason["DisabledByCasualSeat"] = "DISABLED_BY_CASUAL_SEAT";
    DisabledCollectorReason["DisabledByTeamAdmin"] = "DISABLED_BY_TEAM_ADMIN";
    DisabledCollectorReason["SurveyHasBestWorstQuestion"] = "SURVEY_HAS_BEST_WORST_QUESTION";
    DisabledCollectorReason["SurveyHasClickmapQuestion"] = "SURVEY_HAS_CLICKMAP_QUESTION";
    DisabledCollectorReason["SurveyHasPaymentPage"] = "SURVEY_HAS_PAYMENT_PAGE";
})(DisabledCollectorReason || (DisabledCollectorReason = {}));
var DiscoverabilityStatus;
(function(DiscoverabilityStatus) {
    DiscoverabilityStatus["Disabled"] = "DISABLED";
    DiscoverabilityStatus["Enabled"] = "ENABLED";
})(DiscoverabilityStatus || (DiscoverabilityStatus = {}));
var EmailDomainRolloutStatus;
(function(EmailDomainRolloutStatus) {
    EmailDomainRolloutStatus["Disabled"] = "DISABLED";
    EmailDomainRolloutStatus["Enabled"] = "ENABLED";
    EmailDomainRolloutStatus["Experiment"] = "EXPERIMENT";
})(EmailDomainRolloutStatus || (EmailDomainRolloutStatus = {}));
var EmailVerificationStatus;
(function(EmailVerificationStatus) {
    EmailVerificationStatus["Deleted"] = "DELETED";
    EmailVerificationStatus["Expired"] = "EXPIRED";
    EmailVerificationStatus["Pending"] = "PENDING";
    EmailVerificationStatus["Unsent"] = "UNSENT";
    EmailVerificationStatus["Verified"] = "VERIFIED";
})(EmailVerificationStatus || (EmailVerificationStatus = {}));
var ExperimentAssignmentType; /** Treatment assigned to user */ 
(function(ExperimentAssignmentType) {
    ExperimentAssignmentType["Existing"] = "EXISTING";
    ExperimentAssignmentType["New"] = "NEW";
    ExperimentAssignmentType["Winner"] = "WINNER";
})(ExperimentAssignmentType || (ExperimentAssignmentType = {}));
var FeedbackLevel;
(function(FeedbackLevel) {
    FeedbackLevel["Category"] = "CATEGORY";
    FeedbackLevel["Option"] = "OPTION";
})(FeedbackLevel || (FeedbackLevel = {})); /** Supported CSS font-style options */ 
var FontStyleType; /** Supported CSS font-weight options */ 
(function(FontStyleType) {
    FontStyleType["Inherit"] = "INHERIT";
    FontStyleType["Initial"] = "INITIAL";
    FontStyleType["Italic"] = "ITALIC";
    FontStyleType["Normal"] = "NORMAL";
    FontStyleType["Oblique"] = "OBLIQUE";
})(FontStyleType || (FontStyleType = {}));
var FontWeightType; /** Represents error states in query responses corresponding to 'forbidden' API responses. */ 
(function(FontWeightType) {
    FontWeightType["Bold"] = "BOLD";
    FontWeightType["Light"] = "LIGHT";
    FontWeightType["Medium"] = "MEDIUM";
    FontWeightType["Regular"] = "REGULAR";
    FontWeightType["Ultralight"] = "ULTRALIGHT";
})(FontWeightType || (FontWeightType = {})); /** Codes for errors corresponding to 'forbidden' error states. */ 
var ForbiddenErrorCode;
(function(ForbiddenErrorCode) {
    ForbiddenErrorCode["Forbidden"] = "FORBIDDEN";
})(ForbiddenErrorCode || (ForbiddenErrorCode = {})); /** Indicates whether the team was set up with the assistance of the sales team, granted complimentarily, or self-service. */ 
var GroupType;
(function(GroupType) {
    GroupType["Complimentary"] = "COMPLIMENTARY";
    GroupType["SalesAssisted"] = "SALES_ASSISTED";
    GroupType["SelfServe"] = "SELF_SERVE";
})(GroupType || (GroupType = {}));
var InsightFeedbackType; /**
 * Represents error states corresponding to invalid config value input that could
 * not be saved.
 */ 
(function(InsightFeedbackType) {
    InsightFeedbackType["Apply"] = "APPLY";
    InsightFeedbackType["BtViewAll"] = "BT_VIEW_ALL";
    InsightFeedbackType["BtViewQuestion"] = "BT_VIEW_QUESTION";
    InsightFeedbackType["Click"] = "CLICK";
    InsightFeedbackType["CtmViewAll"] = "CTM_VIEW_ALL";
    InsightFeedbackType["Export"] = "EXPORT";
    InsightFeedbackType["View"] = "VIEW";
})(InsightFeedbackType || (InsightFeedbackType = {})); /** Codes for errors corresponding to invalid config value update error states. */ 
var InvalidConfigValueErrorCode;
(function(InvalidConfigValueErrorCode) {
    InvalidConfigValueErrorCode["InvalidConfigValue"] = "INVALID_CONFIG_VALUE";
})(InvalidConfigValueErrorCode || (InvalidConfigValueErrorCode = {}));
var InvalidEmailReason; /**
 * Represents error states in query responses corresponding to 'invalid input' API responses.
 * Used to flag invalid user input.
 */ 
(function(InvalidEmailReason) {
    InvalidEmailReason["DomainLocked"] = "DOMAIN_LOCKED";
    InvalidEmailReason["EmailMalformed"] = "EMAIL_MALFORMED";
    InvalidEmailReason["EmailMisencoded"] = "EMAIL_MISENCODED";
    InvalidEmailReason["EmailRoleBased"] = "EMAIL_ROLE_BASED";
    InvalidEmailReason["EmailTooLong"] = "EMAIL_TOO_LONG";
    InvalidEmailReason["EmailTooShort"] = "EMAIL_TOO_SHORT";
})(InvalidEmailReason || (InvalidEmailReason = {})); /** Codes for errors corresponding to 'invalid input' error states. */ 
var InvalidInputErrorCode;
(function(InvalidInputErrorCode) {
    InvalidInputErrorCode["InvalidInput"] = "INVALID_INPUT";
})(InvalidInputErrorCode || (InvalidInputErrorCode = {})); /** Supported layout options */ 
var LayoutOptionType;
(function(LayoutOptionType) {
    LayoutOptionType["BackgroundFullTextCenter"] = "BACKGROUND_FULL_TEXT_CENTER";
    LayoutOptionType["BackgroundFullTextLeft"] = "BACKGROUND_FULL_TEXT_LEFT";
    LayoutOptionType["BackgroundFullTextRight"] = "BACKGROUND_FULL_TEXT_RIGHT";
    LayoutOptionType["BackgroundPartialLeftHalf"] = "BACKGROUND_PARTIAL_LEFT_HALF";
    LayoutOptionType["BackgroundPartialLeftThird"] = "BACKGROUND_PARTIAL_LEFT_THIRD";
    LayoutOptionType["BackgroundPartialRightHalf"] = "BACKGROUND_PARTIAL_RIGHT_HALF";
    LayoutOptionType["BackgroundPartialRightThird"] = "BACKGROUND_PARTIAL_RIGHT_THIRD";
    LayoutOptionType["BackgroundPartialTopBanner"] = "BACKGROUND_PARTIAL_TOP_BANNER";
})(LayoutOptionType || (LayoutOptionType = {}));
var LibraryAssetType;
(function(LibraryAssetType) {
    LibraryAssetType["Document"] = "DOCUMENT";
    LibraryAssetType["EndPage"] = "END_PAGE";
    LibraryAssetType["Image"] = "IMAGE";
    LibraryAssetType["IntroText"] = "INTRO_TEXT";
    LibraryAssetType["Presentation"] = "PRESENTATION";
    LibraryAssetType["Question"] = "QUESTION";
    LibraryAssetType["Template"] = "TEMPLATE";
    LibraryAssetType["Theme"] = "THEME";
})(LibraryAssetType || (LibraryAssetType = {}));
var LibraryImageAlignType; /** Determines the default logo used for surveys created by team and division members. */ 
(function(LibraryImageAlignType) {
    LibraryImageAlignType["Center"] = "CENTER";
    LibraryImageAlignType["Left"] = "LEFT";
    LibraryImageAlignType["Right"] = "RIGHT";
})(LibraryImageAlignType || (LibraryImageAlignType = {}));
var LibraryImageSizeType;
(function(LibraryImageSizeType) {
    LibraryImageSizeType["Large"] = "LARGE";
    LibraryImageSizeType["Medium"] = "MEDIUM";
    LibraryImageSizeType["Original"] = "ORIGINAL";
    LibraryImageSizeType["Small"] = "SMALL";
})(LibraryImageSizeType || (LibraryImageSizeType = {}));
var LibraryRestriction;
(function(LibraryRestriction) {
    LibraryRestriction["Enforce"] = "ENFORCE";
    LibraryRestriction["Library"] = "LIBRARY";
    LibraryRestriction["None"] = "NONE";
})(LibraryRestriction || (LibraryRestriction = {}));
var LibrarySortBy;
(function(LibrarySortBy) {
    LibrarySortBy["AssetType"] = "ASSET_TYPE";
    LibrarySortBy["CreatedAt"] = "CREATED_AT";
    LibrarySortBy["Division"] = "DIVISION";
    LibrarySortBy["Name"] = "NAME";
})(LibrarySortBy || (LibrarySortBy = {}));
var LinkCollectorToContainerErrorType;
(function(LinkCollectorToContainerErrorType) {
    LinkCollectorToContainerErrorType["CollectorIdNotExist"] = "COLLECTOR_ID_NOT_EXIST";
    LinkCollectorToContainerErrorType["ContainerIdNotExist"] = "CONTAINER_ID_NOT_EXIST";
})(LinkCollectorToContainerErrorType || (LinkCollectorToContainerErrorType = {})); /** Allows the list of returned identities to be filtered */ 
var LinkedIdentityTypeFilter;
(function(LinkedIdentityTypeFilter) {
    LinkedIdentityTypeFilter["All"] = "ALL";
    LinkedIdentityTypeFilter["Contribute"] = "CONTRIBUTE";
})(LinkedIdentityTypeFilter || (LinkedIdentityTypeFilter = {})); /**
 * All the possible values that can be used as a rank param on the
 * MarketMeasurementSolutionsPerformanceScoreInput input. The rank represents the scale of
 * the single-choice likert question driver attributes provided; all must be of the same rank.
 */ 
var MarketMeasurementSolutionsAttributeRank;
(function(MarketMeasurementSolutionsAttributeRank) {
    MarketMeasurementSolutionsAttributeRank["Five"] = "FIVE";
    MarketMeasurementSolutionsAttributeRank["Four"] = "FOUR";
    MarketMeasurementSolutionsAttributeRank["Seven"] = "SEVEN";
    MarketMeasurementSolutionsAttributeRank["Six"] = "SIX";
    MarketMeasurementSolutionsAttributeRank["Three"] = "THREE";
    MarketMeasurementSolutionsAttributeRank["Two"] = "TWO";
})(MarketMeasurementSolutionsAttributeRank || (MarketMeasurementSolutionsAttributeRank = {})); /** Web collector match trigger condition type */ 
var MatchAgainst;
(function(MatchAgainst) {
    MatchAgainst["Fullurl"] = "FULLURL";
    MatchAgainst["Pathname"] = "PATHNAME";
})(MatchAgainst || (MatchAgainst = {}));
var MembershipSeatType;
(function(MembershipSeatType) {
    MembershipSeatType["Casual"] = "CASUAL";
    MembershipSeatType["Contributor"] = "CONTRIBUTOR";
    MembershipSeatType["Full"] = "FULL";
})(MembershipSeatType || (MembershipSeatType = {}));
var MmsMetricType;
(function(MmsMetricType) {
    MmsMetricType["AttributeEvaluation"] = "ATTRIBUTE_EVALUATION";
    MmsMetricType["AttributeImportance"] = "ATTRIBUTE_IMPORTANCE";
    MmsMetricType["Behavioral"] = "BEHAVIORAL";
    MmsMetricType["CompetitorInfo"] = "COMPETITOR_INFO";
    MmsMetricType["Custom"] = "CUSTOM";
    MmsMetricType["Demographic"] = "DEMOGRAPHIC";
    MmsMetricType["Ecommerce"] = "ECOMMERCE";
    MmsMetricType["FrequencyOfUse"] = "FREQUENCY_OF_USE";
    MmsMetricType["FrequencyOfUseHypothetical"] = "FREQUENCY_OF_USE_HYPOTHETICAL";
    MmsMetricType["Geographic"] = "GEOGRAPHIC";
    MmsMetricType["ProductUse"] = "PRODUCT_USE";
    MmsMetricType["Psychographic"] = "PSYCHOGRAPHIC";
    MmsMetricType["PurchaseApproaches"] = "PURCHASE_APPROACHES";
    MmsMetricType["PurchaseBehaviors"] = "PURCHASE_BEHAVIORS";
    MmsMetricType["PurchaseBehaviorsInfluence"] = "PURCHASE_BEHAVIORS_INFLUENCE";
    MmsMetricType["PurchaseFrequency"] = "PURCHASE_FREQUENCY";
    MmsMetricType["PurchaseInfluencers"] = "PURCHASE_INFLUENCERS";
    MmsMetricType["PurchaseIntent"] = "PURCHASE_INTENT";
    MmsMetricType["Recognition"] = "RECOGNITION";
    MmsMetricType["UnknownMetric"] = "UNKNOWN_METRIC";
})(MmsMetricType || (MmsMetricType = {}));
var ModuleSubType;
(function(ModuleSubType) {
    ModuleSubType["Ad"] = "AD";
    ModuleSubType["ConsumerBehavior"] = "CONSUMER_BEHAVIOR";
    ModuleSubType["ConsumerSegmentation"] = "CONSUMER_SEGMENTATION";
    ModuleSubType["Logo"] = "LOGO";
    ModuleSubType["Message"] = "MESSAGE";
    ModuleSubType["Name"] = "NAME";
    ModuleSubType["Package"] = "PACKAGE";
    ModuleSubType["Product"] = "PRODUCT";
    ModuleSubType["Screener"] = "SCREENER";
    ModuleSubType["UsageAndAttitudes"] = "USAGE_AND_ATTITUDES";
    ModuleSubType["Video"] = "VIDEO";
})(ModuleSubType || (ModuleSubType = {}));
var ModuleType;
(function(ModuleType) {
    ModuleType["ConceptTesting"] = "CONCEPT_TESTING";
    ModuleType["Mms"] = "MMS";
})(ModuleType || (ModuleType = {}));
var MultipleChoiceAnswerLayout;
(function(MultipleChoiceAnswerLayout) {
    MultipleChoiceAnswerLayout["Horizontal"] = "HORIZONTAL";
    MultipleChoiceAnswerLayout["ThreeColumns"] = "THREE_COLUMNS";
    MultipleChoiceAnswerLayout["TwoColumns"] = "TWO_COLUMNS";
    MultipleChoiceAnswerLayout["Vertical"] = "VERTICAL";
})(MultipleChoiceAnswerLayout || (MultipleChoiceAnswerLayout = {})); /** Codes for errors corresponding to 'resource not found' error states. */ 
var NotFoundErrorCode;
(function(NotFoundErrorCode) {
    NotFoundErrorCode["NotFound"] = "NOT_FOUND";
})(NotFoundErrorCode || (NotFoundErrorCode = {}));
var NotificationAppType;
(function(NotificationAppType) {
    NotificationAppType["CommentSurveyPreviewTest"] = "COMMENT_SURVEY_PREVIEW_TEST";
    NotificationAppType["EmailCampaignTest"] = "EMAIL_CAMPAIGN_TEST";
    NotificationAppType["EmailCollector"] = "EMAIL_COLLECTOR";
    NotificationAppType["EmailService"] = "EMAIL_SERVICE";
    NotificationAppType["EmailVerification"] = "EMAIL_VERIFICATION";
    NotificationAppType["SharedResponse"] = "SHARED_RESPONSE";
    NotificationAppType["Test"] = "TEST";
    NotificationAppType["WeblinkCollector"] = "WEBLINK_COLLECTOR";
})(NotificationAppType || (NotificationAppType = {}));
var NotificationFrequency; /** A user preference on how and when they'd like to be notified */ 
(function(NotificationFrequency) {
    NotificationFrequency["Daily"] = "DAILY";
    NotificationFrequency["Hourly"] = "HOURLY";
    NotificationFrequency["Minute"] = "MINUTE";
    NotificationFrequency["Monthly"] = "MONTHLY";
    NotificationFrequency["Realtime"] = "REALTIME";
    NotificationFrequency["Second"] = "SECOND";
    NotificationFrequency["Weekly"] = "WEEKLY";
})(NotificationFrequency || (NotificationFrequency = {}));
var NotificationType; /** This validation configuration is used to enforce numerical inputs. */ 
(function(NotificationType) {
    NotificationType["AutorenewOff"] = "AUTORENEW_OFF";
    NotificationType["ChangeStatusComment"] = "CHANGE_STATUS_COMMENT";
    NotificationType["CollectorFlaggedToClose"] = "COLLECTOR_FLAGGED_TO_CLOSE";
    NotificationType["CreatedCommenter"] = "CREATED_COMMENTER";
    NotificationType["CreditCardFailed"] = "CREDIT_CARD_FAILED";
    NotificationType["DeletedComment"] = "DELETED_COMMENT";
    NotificationType["FirstResponse"] = "FIRST_RESPONSE";
    NotificationType["NewComment"] = "NEW_COMMENT";
    NotificationType["NewExternalSurveyAvailable"] = "NEW_EXTERNAL_SURVEY_AVAILABLE";
    NotificationType["NewResponses"] = "NEW_RESPONSES";
    NotificationType["NewSurveyAvailable"] = "NEW_SURVEY_AVAILABLE";
    NotificationType["Permission"] = "PERMISSION";
    NotificationType["PermissionV1"] = "PERMISSION_V1";
    NotificationType["QuizReceipt"] = "QUIZ_RECEIPT";
    NotificationType["ReplyComment"] = "REPLY_COMMENT";
    NotificationType["SraEmailSharePendingState"] = "SRA_EMAIL_SHARE_PENDING_STATE";
    NotificationType["SraFirstResponse"] = "SRA_FIRST_RESPONSE";
    NotificationType["SraNewSurveysAlert"] = "SRA_NEW_SURVEYS_ALERT";
    NotificationType["UpdatedComment"] = "UPDATED_COMMENT";
    NotificationType["UserDeletionHard"] = "USER_DELETION_HARD";
    NotificationType["UserDeletionSoft"] = "USER_DELETION_SOFT";
    NotificationType["UserEmailVerification"] = "USER_EMAIL_VERIFICATION";
    NotificationType["WeblinkcollectorRecurringSurvey"] = "WEBLINKCOLLECTOR_RECURRING_SURVEY";
    NotificationType["WorkgroupsMemberAdd"] = "WORKGROUPS_MEMBER_ADD";
    NotificationType["WorkgroupsMemberApplied"] = "WORKGROUPS_MEMBER_APPLIED";
    NotificationType["WorkgroupsMemberApproved"] = "WORKGROUPS_MEMBER_APPROVED";
    NotificationType["WorkgroupsMemberDenied"] = "WORKGROUPS_MEMBER_DENIED";
    NotificationType["WorkgroupsMemberRemove"] = "WORKGROUPS_MEMBER_REMOVE";
    NotificationType["WorkgroupsMemberRoleChanged"] = "WORKGROUPS_MEMBER_ROLE_CHANGED";
    NotificationType["WorkgroupsSurveyShared"] = "WORKGROUPS_SURVEY_SHARED";
    NotificationType["WorkgroupsSurveyUnshared"] = "WORKGROUPS_SURVEY_UNSHARED";
    NotificationType["WorkgroupsWorkgroupChanged"] = "WORKGROUPS_WORKGROUP_CHANGED";
    NotificationType["WorkgroupsWorkgroupDeleted"] = "WORKGROUPS_WORKGROUP_DELETED";
})(NotificationType || (NotificationType = {})); /** Status of the Open Ended Coding (OEC) job */ 
var OecJobState; /** A keyword tag can contain multiple keywords: e.g: expensive = [pricey, expensive, not cheap] */ 
(function(OecJobState) {
    OecJobState["Failed"] = "FAILED";
    OecJobState["InProgress"] = "IN_PROGRESS";
    OecJobState["Queued"] = "QUEUED";
    OecJobState["Success"] = "SUCCESS";
})(OecJobState || (OecJobState = {})); /** Response sort keys. */ 
var OecResponseSortBy; /** Open Ended Coding (OEC) Response Summary */ 
(function(OecResponseSortBy) {
    OecResponseSortBy["Content"] = "CONTENT";
    OecResponseSortBy["CreatedAt"] = "CREATED_AT";
    OecResponseSortBy["Id"] = "ID";
    OecResponseSortBy["Stimulus"] = "STIMULUS";
})(OecResponseSortBy || (OecResponseSortBy = {})); /** Tag Types present in the OEC question tag */ 
var OecTagType;
(function(OecTagType) {
    OecTagType["Oecmodel"] = "OECMODEL";
    OecTagType["Oecuser"] = "OECUSER";
    OecTagType["Sentiment"] = "SENTIMENT";
    OecTagType["User"] = "USER";
})(OecTagType || (OecTagType = {}));
var OverQuotaDestinationType;
(function(OverQuotaDestinationType) {
    OverQuotaDestinationType["CloseWindow"] = "CLOSE_WINDOW";
    OverQuotaDestinationType["CustomMessage"] = "CUSTOM_MESSAGE";
    OverQuotaDestinationType["EndSurvey"] = "END_SURVEY";
    OverQuotaDestinationType["RedirectUrl"] = "REDIRECT_URL";
})(OverQuotaDestinationType || (OverQuotaDestinationType = {}));
var PageSkipLogicType; /** Web collector page views trigger comparator type */ 
(function(PageSkipLogicType) {
    PageSkipLogicType["PageUnconditional"] = "PAGE_UNCONDITIONAL";
})(PageSkipLogicType || (PageSkipLogicType = {}));
var PageViewsComparator; /** The interface of any query that returns a list of objects should follow */ 
(function(PageViewsComparator) {
    PageViewsComparator["Gte"] = "GTE";
    PageViewsComparator["Lte"] = "LTE";
})(PageViewsComparator || (PageViewsComparator = {}));
var PaymentMethodCardType;
(function(PaymentMethodCardType) {
    PaymentMethodCardType["Amex"] = "AMEX";
    PaymentMethodCardType["Diners"] = "DINERS";
    PaymentMethodCardType["Discover"] = "DISCOVER";
    PaymentMethodCardType["Jcb"] = "JCB";
    PaymentMethodCardType["Mastercard"] = "MASTERCARD";
    PaymentMethodCardType["Unionpay"] = "UNIONPAY";
    PaymentMethodCardType["Unknown"] = "UNKNOWN";
    PaymentMethodCardType["Visa"] = "VISA";
})(PaymentMethodCardType || (PaymentMethodCardType = {}));
var PaymentStatus;
(function(PaymentStatus) {
    PaymentStatus["Approved"] = "APPROVED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["NotPaid"] = "NOT_PAID";
    PaymentStatus["Pending"] = "PENDING";
})(PaymentStatus || (PaymentStatus = {})); /**
 * Combining either the top two or the bottom two options of the likert-scale questions
 * for the performance score calculation
 */ 
var PerformanceScoreCombineOption; /** A section, as defined by the Fine Grained Permissions model of usersvc */ 
(function(PerformanceScoreCombineOption) {
    PerformanceScoreCombineOption["BottomTwo"] = "BOTTOM_TWO";
    PerformanceScoreCombineOption["TopTwo"] = "TOP_TWO";
})(PerformanceScoreCombineOption || (PerformanceScoreCombineOption = {}));
var PermissionPart;
(function(PermissionPart) {
    PermissionPart["Analyze"] = "ANALYZE";
    PermissionPart["Collect"] = "COLLECT";
    PermissionPart["Design"] = "DESIGN";
})(PermissionPart || (PermissionPart = {}));
var Placement; /** A Website collector is divided into these "Popup" types. */ 
(function(Placement) {
    Placement["BottomBar"] = "BOTTOM_BAR";
    Placement["Carousel"] = "CAROUSEL";
    Placement["Escalator"] = "ESCALATOR";
    Placement["LiHomeBottom"] = "LI_HOME_BOTTOM";
    Placement["SignInRight"] = "SIGN_IN_RIGHT";
    Placement["SurveySummarySideBar"] = "SURVEY_SUMMARY_SIDE_BAR";
    Placement["TopBar"] = "TOP_BAR";
})(Placement || (Placement = {}));
var PopupType;
(function(PopupType) {
    PopupType["Embedded"] = "EMBEDDED";
    PopupType["Invitation"] = "INVITATION";
    PopupType["Survey"] = "SURVEY";
    PopupType["WebCampaign"] = "WEB_CAMPAIGN";
})(PopupType || (PopupType = {}));
var PricingPackage; /**
 * For logged out users, pricing pages will forward around
 * arbitrary key/value pairs in an encrypted SM parameter. This
 * will allow the client to pass any additional parameters
 * to a pricing page call that need to be encrypted.
 */ 
(function(PricingPackage) {
    PricingPackage["AdvantageAnnual"] = "ADVANTAGE_ANNUAL";
    PricingPackage["AdvantageMonthly"] = "ADVANTAGE_MONTHLY";
    PricingPackage["AnalyzeMonthly"] = "ANALYZE_MONTHLY";
    PricingPackage["Basic"] = "BASIC";
    PricingPackage["EntPlatinum"] = "ENT_PLATINUM";
    PricingPackage["PremierAnnual"] = "PREMIER_ANNUAL";
    PricingPackage["PremierMonthly"] = "PREMIER_MONTHLY";
    PricingPackage["StandardAnnual"] = "STANDARD_ANNUAL";
    PricingPackage["StandardMonthly"] = "STANDARD_MONTHLY";
    PricingPackage["TeamAdvantageAnnual"] = "TEAM_ADVANTAGE_ANNUAL";
    PricingPackage["TeamPremierAnnual"] = "TEAM_PREMIER_ANNUAL";
})(PricingPackage || (PricingPackage = {}));
var PricingSkuId;
(function(PricingSkuId) {
    PricingSkuId["AdvantageAnnualPlanAdditionalSeat"] = "ADVANTAGE_ANNUAL_PLAN_ADDITIONAL_SEAT";
    PricingSkuId["AdvantageAnnualPlanCoreSeat"] = "ADVANTAGE_ANNUAL_PLAN_CORE_SEAT";
    PricingSkuId["AdvantageMonthlyPlanCoreSeat"] = "ADVANTAGE_MONTHLY_PLAN_CORE_SEAT";
    PricingSkuId["AnnualUpgradeCredit"] = "ANNUAL_UPGRADE_CREDIT";
    PricingSkuId["AudienceAdminTool"] = "AUDIENCE_ADMIN_TOOL";
    PricingSkuId["AudienceBundledCredits"] = "AUDIENCE_BUNDLED_CREDITS";
    PricingSkuId["AudienceDiscountedCredits"] = "AUDIENCE_DISCOUNTED_CREDITS";
    PricingSkuId["AudienceErrorFixingCredits"] = "AUDIENCE_ERROR_FIXING_CREDITS";
    PricingSkuId["AudienceInternalCredits"] = "AUDIENCE_INTERNAL_CREDITS";
    PricingSkuId["AudiencePaidCredits"] = "AUDIENCE_PAID_CREDITS";
    PricingSkuId["AudiencePromotionalCredits"] = "AUDIENCE_PROMOTIONAL_CREDITS";
    PricingSkuId["AudienceResponse"] = "AUDIENCE_RESPONSE";
    PricingSkuId["AudienceResponseAu"] = "AUDIENCE_RESPONSE_AU";
    PricingSkuId["AudienceResponseCa"] = "AUDIENCE_RESPONSE_CA";
    PricingSkuId["AudienceResponseGb"] = "AUDIENCE_RESPONSE_GB";
    PricingSkuId["AudienceResponseNz"] = "AUDIENCE_RESPONSE_NZ";
    PricingSkuId["AudienceResponseSg"] = "AUDIENCE_RESPONSE_SG";
    PricingSkuId["CreditItem"] = "CREDIT_ITEM";
    PricingSkuId["Enterprise"] = "ENTERPRISE";
    PricingSkuId["EnterprisePlanAdditionalSeat"] = "ENTERPRISE_PLAN_ADDITIONAL_SEAT";
    PricingSkuId["EnterprisePlanCoreSeat"] = "ENTERPRISE_PLAN_CORE_SEAT";
    PricingSkuId["EnterpriseResellerSoftbank"] = "ENTERPRISE_RESELLER_SOFTBANK";
    PricingSkuId["EnterpriseResellerSunbridge"] = "ENTERPRISE_RESELLER_SUNBRIDGE";
    PricingSkuId["FlexMonthlyPlanCoreSeat"] = "FLEX_MONTHLY_PLAN_CORE_SEAT";
    PricingSkuId["MiscOneTime"] = "MISC_ONE_TIME";
    PricingSkuId["PackageCredits"] = "PACKAGE_CREDITS";
    PricingSkuId["PremierAnnualPlanAdditionalSeat"] = "PREMIER_ANNUAL_PLAN_ADDITIONAL_SEAT";
    PricingSkuId["PremierAnnualPlanCoreSeat"] = "PREMIER_ANNUAL_PLAN_CORE_SEAT";
    PricingSkuId["PremierMonthlyPlanCoreSeat"] = "PREMIER_MONTHLY_PLAN_CORE_SEAT";
    PricingSkuId["ResponseOverage"] = "RESPONSE_OVERAGE";
    PricingSkuId["SalesforceProPackage"] = "SALESFORCE_PRO_PACKAGE";
    PricingSkuId["SalesforceProPlusPackage"] = "SALESFORCE_PRO_PLUS_PACKAGE";
    PricingSkuId["SalesforceStarterPackage"] = "SALESFORCE_STARTER_PACKAGE";
    PricingSkuId["StandardAnnualPlanAdditionalSeat"] = "STANDARD_ANNUAL_PLAN_ADDITIONAL_SEAT";
    PricingSkuId["StandardAnnualPlanCoreSeat"] = "STANDARD_ANNUAL_PLAN_CORE_SEAT";
    PricingSkuId["StandardMonthlyPlanCoreSeat"] = "STANDARD_MONTHLY_PLAN_CORE_SEAT";
    PricingSkuId["TeamAdvantageAnnualPlanAdditionalSeat"] = "TEAM_ADVANTAGE_ANNUAL_PLAN_ADDITIONAL_SEAT";
    PricingSkuId["TeamAdvantageAnnualPlanCoreSeat"] = "TEAM_ADVANTAGE_ANNUAL_PLAN_CORE_SEAT";
    PricingSkuId["TeamPremierAnnualPlanAdditionalSeat"] = "TEAM_PREMIER_ANNUAL_PLAN_ADDITIONAL_SEAT";
    PricingSkuId["TeamPremierAnnualPlanCoreSeat"] = "TEAM_PREMIER_ANNUAL_PLAN_CORE_SEAT";
})(PricingSkuId || (PricingSkuId = {}));
var PricingSkuTypeId;
(function(PricingSkuTypeId) {
    PricingSkuTypeId["AnnualUpgrade"] = "ANNUAL_UPGRADE";
    PricingSkuTypeId["AudienceWallet"] = "AUDIENCE_WALLET";
    PricingSkuTypeId["Benchmark"] = "BENCHMARK";
    PricingSkuTypeId["Discount"] = "DISCOUNT";
    PricingSkuTypeId["Incentives"] = "INCENTIVES";
    PricingSkuTypeId["Misc"] = "MISC";
    PricingSkuTypeId["OtherWallet"] = "OTHER_WALLET";
    PricingSkuTypeId["Panel"] = "PANEL";
    PricingSkuTypeId["Refund"] = "REFUND";
    PricingSkuTypeId["Responses"] = "RESPONSES";
    PricingSkuTypeId["Salesforce"] = "SALESFORCE";
    PricingSkuTypeId["Smi"] = "SMI";
    PricingSkuTypeId["Ssl"] = "SSL";
    PricingSkuTypeId["SubscriptionAdditionalSeat"] = "SUBSCRIPTION_ADDITIONAL_SEAT";
    PricingSkuTypeId["SubscriptionCoreSeat"] = "SUBSCRIPTION_CORE_SEAT";
})(PricingSkuTypeId || (PricingSkuTypeId = {}));
var PricingTaxBehavior;
(function(PricingTaxBehavior) {
    PricingTaxBehavior["Exclusive"] = "EXCLUSIVE";
    PricingTaxBehavior["Inclusive"] = "INCLUSIVE";
})(PricingTaxBehavior || (PricingTaxBehavior = {}));
var ProductClass;
(function(ProductClass) {
    ProductClass["Responses"] = "RESPONSES";
    ProductClass["Seat"] = "SEAT";
})(ProductClass || (ProductClass = {})); /** represents the set of distinct question types currently supported */ 
var ProfilerQuestionType; /** A universal input type for all question types for the profiler */ 
(function(ProfilerQuestionType) {
    ProfilerQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
    ProfilerQuestionType["SingleChoice"] = "SINGLE_CHOICE";
})(ProfilerQuestionType || (ProfilerQuestionType = {}));
var ProjectEntitySubtype;
(function(ProjectEntitySubtype) {
    ProjectEntitySubtype["Audience"] = "AUDIENCE";
})(ProjectEntitySubtype || (ProjectEntitySubtype = {}));
var ProjectEntityType;
(function(ProjectEntityType) {
    ProjectEntityType["Analyze"] = "ANALYZE";
    ProjectEntityType["Collector"] = "COLLECTOR";
    ProjectEntityType["MmsSurvey"] = "MMS_SURVEY";
    ProjectEntityType["Survey"] = "SURVEY";
})(ProjectEntityType || (ProjectEntityType = {}));
var ProjectStatus;
(function(ProjectStatus) {
    ProjectStatus["Cancelled"] = "CANCELLED";
    ProjectStatus["Collection"] = "COLLECTION";
    ProjectStatus["Completion"] = "COMPLETION";
    ProjectStatus["Creation"] = "CREATION";
    ProjectStatus["Locked"] = "LOCKED";
    ProjectStatus["PartialCompletion"] = "PARTIAL_COMPLETION";
})(ProjectStatus || (ProjectStatus = {}));
var ProjectTemplateFulfillmentType;
(function(ProjectTemplateFulfillmentType) {
    ProjectTemplateFulfillmentType["Change"] = "CHANGE";
    ProjectTemplateFulfillmentType["CheckoutPaid"] = "CHECKOUT_PAID";
})(ProjectTemplateFulfillmentType || (ProjectTemplateFulfillmentType = {}));
var ProjectTemplateSubType;
(function(ProjectTemplateSubType) {
    ProjectTemplateSubType["Audience"] = "AUDIENCE";
})(ProjectTemplateSubType || (ProjectTemplateSubType = {}));
var ProjectTemplateType;
(function(ProjectTemplateType) {
    ProjectTemplateType["Analyze"] = "ANALYZE";
    ProjectTemplateType["Collector"] = "COLLECTOR";
    ProjectTemplateType["Survey"] = "SURVEY";
})(ProjectTemplateType || (ProjectTemplateType = {}));
var ProjectVariableAnswerType;
(function(ProjectVariableAnswerType) {
    ProjectVariableAnswerType["Question"] = "QUESTION";
    ProjectVariableAnswerType["QuestionBank"] = "QUESTION_BANK";
    ProjectVariableAnswerType["Value"] = "VALUE";
})(ProjectVariableAnswerType || (ProjectVariableAnswerType = {}));
var ProjectVariableSubType;
(function(ProjectVariableSubType) {
    ProjectVariableSubType["Boolean"] = "BOOLEAN";
    ProjectVariableSubType["CommentBox"] = "COMMENT_BOX";
    ProjectVariableSubType["Dropdown"] = "DROPDOWN";
    ProjectVariableSubType["FileUpload"] = "FILE_UPLOAD";
    ProjectVariableSubType["MultipleChoice"] = "MULTIPLE_CHOICE";
    ProjectVariableSubType["Question"] = "QUESTION";
    ProjectVariableSubType["QuestionBank"] = "QUESTION_BANK";
    ProjectVariableSubType["QuestionList"] = "QUESTION_LIST";
    ProjectVariableSubType["SingleChoice"] = "SINGLE_CHOICE";
    ProjectVariableSubType["TextBox"] = "TEXT_BOX";
})(ProjectVariableSubType || (ProjectVariableSubType = {}));
var ProjectVariableType;
(function(ProjectVariableType) {
    ProjectVariableType["Component"] = "COMPONENT";
    ProjectVariableType["Question"] = "QUESTION";
})(ProjectVariableType || (ProjectVariableType = {}));
var PublishedApplicationListingFilter;
(function(PublishedApplicationListingFilter) {
    PublishedApplicationListingFilter["Featured"] = "FEATURED";
    PublishedApplicationListingFilter["MostPopular"] = "MOST_POPULAR";
    PublishedApplicationListingFilter["RecentlyAdded"] = "RECENTLY_ADDED";
})(PublishedApplicationListingFilter || (PublishedApplicationListingFilter = {}));
var PublishedApplicationListingLinkType;
(function(PublishedApplicationListingLinkType) {
    PublishedApplicationListingLinkType["Install"] = "INSTALL";
    PublishedApplicationListingLinkType["Launch"] = "LAUNCH";
    PublishedApplicationListingLinkType["Upgrade"] = "UPGRADE";
    PublishedApplicationListingLinkType["VisitSite"] = "VISIT_SITE";
})(PublishedApplicationListingLinkType || (PublishedApplicationListingLinkType = {}));
var PutSurveyPersonalizationEventType;
(function(PutSurveyPersonalizationEventType) {
    PutSurveyPersonalizationEventType["SurveyCompleted"] = "SURVEY_COMPLETED";
})(PutSurveyPersonalizationEventType || (PutSurveyPersonalizationEventType = {}));
var QuestionBankModifierType;
(function(QuestionBankModifierType) {
    QuestionBankModifierType["OpenEnded"] = "OPEN_ENDED";
    QuestionBankModifierType["Semantic"] = "SEMANTIC";
    QuestionBankModifierType["Superficial"] = "SUPERFICIAL";
})(QuestionBankModifierType || (QuestionBankModifierType = {}));
var QuestionBankPartner;
(function(QuestionBankPartner) {
    QuestionBankPartner["Audience"] = "AUDIENCE";
    QuestionBankPartner["Bavc"] = "BAVC";
    QuestionBankPartner["Eventbrite"] = "EVENTBRITE";
    QuestionBankPartner["Harvard"] = "HARVARD";
    QuestionBankPartner["Hubspot"] = "HUBSPOT";
    QuestionBankPartner["Leanin"] = "LEANIN";
    QuestionBankPartner["Shrm"] = "SHRM";
    QuestionBankPartner["Zendesk"] = "ZENDESK";
})(QuestionBankPartner || (QuestionBankPartner = {}));
var QuestionFieldValidationType;
(function(QuestionFieldValidationType) {
    QuestionFieldValidationType["DateIntl"] = "DATE_INTL";
    QuestionFieldValidationType["DateUs"] = "DATE_US";
    QuestionFieldValidationType["Decimal"] = "DECIMAL";
    QuestionFieldValidationType["Email"] = "EMAIL";
    QuestionFieldValidationType["FileFormat"] = "FILE_FORMAT";
    QuestionFieldValidationType["Integer"] = "INTEGER";
    QuestionFieldValidationType["Sum"] = "SUM";
    QuestionFieldValidationType["TextLength"] = "TEXT_LENGTH";
})(QuestionFieldValidationType || (QuestionFieldValidationType = {}));
var QuestionFunnelCondition;
(function(QuestionFunnelCondition) {
    QuestionFunnelCondition["Selected"] = "SELECTED";
    QuestionFunnelCondition["Unselected"] = "UNSELECTED";
})(QuestionFunnelCondition || (QuestionFunnelCondition = {}));
var QuestionFunnelPointerType;
(function(QuestionFunnelPointerType) {
    QuestionFunnelPointerType["Answer"] = "ANSWER";
    QuestionFunnelPointerType["Fieldset"] = "FIELDSET";
})(QuestionFunnelPointerType || (QuestionFunnelPointerType = {}));
var QuestionLayoutPlacement;
(function(QuestionLayoutPlacement) {
    QuestionLayoutPlacement["NewRow"] = "NEW_ROW";
    QuestionLayoutPlacement["RightAligned"] = "RIGHT_ALIGNED";
})(QuestionLayoutPlacement || (QuestionLayoutPlacement = {}));
var QuestionLayoutWidthFormat;
(function(QuestionLayoutWidthFormat) {
    QuestionLayoutWidthFormat["Fixed"] = "FIXED";
    QuestionLayoutWidthFormat["Percent"] = "PERCENT";
})(QuestionLayoutWidthFormat || (QuestionLayoutWidthFormat = {}));
var QuestionRequiredPredicateType;
(function(QuestionRequiredPredicateType) {
    QuestionRequiredPredicateType["All"] = "ALL";
    QuestionRequiredPredicateType["AtLeast"] = "AT_LEAST";
    QuestionRequiredPredicateType["AtMost"] = "AT_MOST";
    QuestionRequiredPredicateType["Exactly"] = "EXACTLY";
    QuestionRequiredPredicateType["Range"] = "RANGE";
})(QuestionRequiredPredicateType || (QuestionRequiredPredicateType = {}));
var QuestionSkipLogicType; /**
 * Configuration type for sorting. Depending on the question type, applies
 * to sorting of fieldsets or answers.
 */ 
(function(QuestionSkipLogicType) {
    QuestionSkipLogicType["QuestionConditionalCol"] = "QUESTION_CONDITIONAL_COL";
    QuestionSkipLogicType["QuestionConditionalRow"] = "QUESTION_CONDITIONAL_ROW";
})(QuestionSkipLogicType || (QuestionSkipLogicType = {}));
var QuestionSortingKind;
(function(QuestionSortingKind) {
    QuestionSortingKind["Flip"] = "FLIP";
    QuestionSortingKind["Random"] = "RANDOM";
    QuestionSortingKind["TextAsc"] = "TEXT_ASC";
    QuestionSortingKind["TextDesc"] = "TEXT_DESC";
})(QuestionSortingKind || (QuestionSortingKind = {}));
var RatingScaleAnswerSymbol;
(function(RatingScaleAnswerSymbol) {
    RatingScaleAnswerSymbol["Heart"] = "HEART";
    RatingScaleAnswerSymbol["Smiley"] = "SMILEY";
    RatingScaleAnswerSymbol["Star"] = "STAR";
    RatingScaleAnswerSymbol["Thumb"] = "THUMB";
})(RatingScaleAnswerSymbol || (RatingScaleAnswerSymbol = {})); /** Base roles represent current system default roles */ 
var RbacBaseRoleType; /** Role Feature Permission indicate base role default value and current value for a permission */ 
(function(RbacBaseRoleType) {
    RbacBaseRoleType["Admin"] = "ADMIN";
    RbacBaseRoleType["Analyst"] = "ANALYST";
    RbacBaseRoleType["CasualUser"] = "CASUAL_USER";
    RbacBaseRoleType["DivisionAdmin"] = "DIVISION_ADMIN";
    RbacBaseRoleType["PrimaryAdmin"] = "PRIMARY_ADMIN";
    RbacBaseRoleType["User"] = "USER";
})(RbacBaseRoleType || (RbacBaseRoleType = {})); /** Role Based Access Control Permission Type indicate permission types available in usersvc */ 
var RbacPermissionType; /** Role Config indicates role context and which actions are enabled */ 
(function(RbacPermissionType) {
    RbacPermissionType["ActivityExport"] = "ACTIVITY_EXPORT";
    RbacPermissionType["ActivityView"] = "ACTIVITY_VIEW";
    RbacPermissionType["AdminDashboardView"] = "ADMIN_DASHBOARD_VIEW";
    RbacPermissionType["AudienceCreditsManage"] = "AUDIENCE_CREDITS_MANAGE";
    RbacPermissionType["AudienceCreditsPurchase"] = "AUDIENCE_CREDITS_PURCHASE";
    RbacPermissionType["AudienceCreditsUse"] = "AUDIENCE_CREDITS_USE";
    RbacPermissionType["BillingManage"] = "BILLING_MANAGE";
    RbacPermissionType["DivisionManage"] = "DIVISION_MANAGE";
    RbacPermissionType["DivisionManageUsers"] = "DIVISION_MANAGE_USERS";
    RbacPermissionType["DivisionView"] = "DIVISION_VIEW";
    RbacPermissionType["DivisionsManage"] = "DIVISIONS_MANAGE";
    RbacPermissionType["DivisionsManageUsers"] = "DIVISIONS_MANAGE_USERS";
    RbacPermissionType["DivisionsView"] = "DIVISIONS_VIEW";
    RbacPermissionType["LibraryContribute"] = "LIBRARY_CONTRIBUTE";
    RbacPermissionType["LibraryManageAssets"] = "LIBRARY_MANAGE_ASSETS";
    RbacPermissionType["LibraryView"] = "LIBRARY_VIEW";
    RbacPermissionType["OfflineDevicesManage"] = "OFFLINE_DEVICES_MANAGE";
    RbacPermissionType["OfflineDevicesView"] = "OFFLINE_DEVICES_VIEW";
    RbacPermissionType["RbacManageRoles"] = "RBAC_MANAGE_ROLES";
    RbacPermissionType["RbacViewPermissions"] = "RBAC_VIEW_PERMISSIONS";
    RbacPermissionType["RbacViewRoles"] = "RBAC_VIEW_ROLES";
    RbacPermissionType["SettingsManageAudience"] = "SETTINGS_MANAGE_AUDIENCE";
    RbacPermissionType["SettingsManageCollectors"] = "SETTINGS_MANAGE_COLLECTORS";
    RbacPermissionType["SettingsManageHippa"] = "SETTINGS_MANAGE_HIPPA";
    RbacPermissionType["SettingsManagePii"] = "SETTINGS_MANAGE_PII";
    RbacPermissionType["SettingsManageResponses"] = "SETTINGS_MANAGE_RESPONSES";
    RbacPermissionType["SettingsManageSharing"] = "SETTINGS_MANAGE_SHARING";
    RbacPermissionType["SettingsManageTeam"] = "SETTINGS_MANAGE_TEAM";
    RbacPermissionType["TeamSummaryView"] = "TEAM_SUMMARY_VIEW";
    RbacPermissionType["UsersInvite"] = "USERS_INVITE";
    RbacPermissionType["UsersManageAccounts"] = "USERS_MANAGE_ACCOUNTS";
    RbacPermissionType["UsersManageSurveys"] = "USERS_MANAGE_SURVEYS";
    RbacPermissionType["UsersPromote"] = "USERS_PROMOTE";
    RbacPermissionType["UsersView"] = "USERS_VIEW";
    RbacPermissionType["WorkgroupsCreate"] = "WORKGROUPS_CREATE";
    RbacPermissionType["WorkgroupsManage"] = "WORKGROUPS_MANAGE";
    RbacPermissionType["WorkgroupsView"] = "WORKGROUPS_VIEW";
})(RbacPermissionType || (RbacPermissionType = {})); /** Role Feature Type indicates features manage by RBAC API */ 
var RbacRoleFeatureType; /** Group Role Paginated List */ 
(function(RbacRoleFeatureType) {
    RbacRoleFeatureType["Activity"] = "ACTIVITY";
    RbacRoleFeatureType["AudienceCredits"] = "AUDIENCE_CREDITS";
    RbacRoleFeatureType["Billing"] = "BILLING";
    RbacRoleFeatureType["Divisions"] = "DIVISIONS";
    RbacRoleFeatureType["Library"] = "LIBRARY";
    RbacRoleFeatureType["Rbac"] = "RBAC";
    RbacRoleFeatureType["Settings"] = "SETTINGS";
    RbacRoleFeatureType["TeamSummary"] = "TEAM_SUMMARY";
    RbacRoleFeatureType["Users"] = "USERS";
    RbacRoleFeatureType["Workgroups"] = "WORKGROUPS";
})(RbacRoleFeatureType || (RbacRoleFeatureType = {})); /**
 * Role Type indicate the two available categories of roles
 *   - BASE_ROLE: current system default roles
 *   - CUSTOM_ROLE: role customizable by user
 */ 
var RbacRoleType;
(function(RbacRoleType) {
    RbacRoleType["BaseRole"] = "BASE_ROLE";
    RbacRoleType["CustomRole"] = "CUSTOM_ROLE";
})(RbacRoleType || (RbacRoleType = {}));
var RelativeTimePeriodUnitTypes;
(function(RelativeTimePeriodUnitTypes) {
    RelativeTimePeriodUnitTypes["Days"] = "DAYS";
    RelativeTimePeriodUnitTypes["Hours"] = "HOURS";
})(RelativeTimePeriodUnitTypes || (RelativeTimePeriodUnitTypes = {}));
var RenewalType;
(function(RenewalType) {
    RenewalType["Month"] = "MONTH";
    RenewalType["Year"] = "YEAR";
})(RenewalType || (RenewalType = {}));
var ResendEmailReferrer;
(function(ResendEmailReferrer) {
    ResendEmailReferrer["CollectZeroState"] = "COLLECT_ZERO_STATE";
    ResendEmailReferrer["CreateZeroState"] = "CREATE_ZERO_STATE";
    ResendEmailReferrer["SolutionsCreate"] = "SOLUTIONS_CREATE";
})(ResendEmailReferrer || (ResendEmailReferrer = {}));
var RespondentCollectionMethod;
(function(RespondentCollectionMethod) {
    RespondentCollectionMethod["Edited"] = "EDITED";
    RespondentCollectionMethod["Manual"] = "MANUAL";
    RespondentCollectionMethod["Normal"] = "NORMAL";
    RespondentCollectionMethod["Preview"] = "PREVIEW";
    RespondentCollectionMethod["SurveyPreview"] = "SURVEY_PREVIEW";
})(RespondentCollectionMethod || (RespondentCollectionMethod = {}));
var RespondentStatus;
(function(RespondentStatus) {
    RespondentStatus["Completely"] = "COMPLETELY";
    RespondentStatus["Disqualified"] = "DISQUALIFIED";
    RespondentStatus["Overquota"] = "OVERQUOTA";
    RespondentStatus["Partially"] = "PARTIALLY";
})(RespondentStatus || (RespondentStatus = {}));
var ResponseDimension;
(function(ResponseDimension) {
    ResponseDimension["OneDimensional"] = "ONE_DIMENSIONAL";
    ResponseDimension["ThreeDimensional"] = "THREE_DIMENSIONAL";
    ResponseDimension["TwoDimensional"] = "TWO_DIMENSIONAL";
})(ResponseDimension || (ResponseDimension = {}));
var ResponseQualityTypes;
(function(ResponseQualityTypes) {
    ResponseQualityTypes["HighQuality"] = "HIGH_QUALITY";
    ResponseQualityTypes["LowQuality"] = "LOW_QUALITY";
})(ResponseQualityTypes || (ResponseQualityTypes = {}));
var RestrictedCollectorStatus;
(function(RestrictedCollectorStatus) {
    RestrictedCollectorStatus["Disabled"] = "DISABLED";
    RestrictedCollectorStatus["DisabledUnlessEnabledPerUser"] = "DISABLED_UNLESS_ENABLED_PER_USER";
    RestrictedCollectorStatus["Enabled"] = "ENABLED";
    RestrictedCollectorStatus["Hidden"] = "HIDDEN";
})(RestrictedCollectorStatus || (RestrictedCollectorStatus = {}));
var ScreeningQuestionRequiredMetadataType;
(function(ScreeningQuestionRequiredMetadataType) {
    ScreeningQuestionRequiredMetadataType["All"] = "ALL";
    ScreeningQuestionRequiredMetadataType["AtLeast"] = "AT_LEAST";
    ScreeningQuestionRequiredMetadataType["AtMost"] = "AT_MOST";
    ScreeningQuestionRequiredMetadataType["Exactly"] = "EXACTLY";
    ScreeningQuestionRequiredMetadataType["Range"] = "RANGE";
})(ScreeningQuestionRequiredMetadataType || (ScreeningQuestionRequiredMetadataType = {}));
var ScreeningQuestionSortingMetadataType;
(function(ScreeningQuestionSortingMetadataType) {
    ScreeningQuestionSortingMetadataType["Alphabetical"] = "ALPHABETICAL";
    ScreeningQuestionSortingMetadataType["Flip"] = "FLIP";
    ScreeningQuestionSortingMetadataType["Random"] = "RANDOM";
})(ScreeningQuestionSortingMetadataType || (ScreeningQuestionSortingMetadataType = {}));
var ScreeningQuestionValidationMetadataType; /** Input for searching a list of team members */ 
(function(ScreeningQuestionValidationMetadataType) {
    ScreeningQuestionValidationMetadataType["Any"] = "ANY";
    ScreeningQuestionValidationMetadataType["DateIntl"] = "DATE_INTL";
    ScreeningQuestionValidationMetadataType["DateUs"] = "DATE_US";
    ScreeningQuestionValidationMetadataType["Decimal"] = "DECIMAL";
    ScreeningQuestionValidationMetadataType["Email"] = "EMAIL";
    ScreeningQuestionValidationMetadataType["Integer"] = "INTEGER";
    ScreeningQuestionValidationMetadataType["TextLength"] = "TEXT_LENGTH";
})(ScreeningQuestionValidationMetadataType || (ScreeningQuestionValidationMetadataType = {})); /** Column that the search results should be sorted by */ 
var SearchTeamMembershipsSortBy; /** A request a user makes to change their seat type within a team. */ 
(function(SearchTeamMembershipsSortBy) {
    SearchTeamMembershipsSortBy["DivisionId"] = "DIVISION_ID";
    SearchTeamMembershipsSortBy["DivisionName"] = "DIVISION_NAME";
    SearchTeamMembershipsSortBy["Email"] = "EMAIL";
    SearchTeamMembershipsSortBy["FirstName"] = "FIRST_NAME";
    SearchTeamMembershipsSortBy["InviteExpiredAt"] = "INVITE_EXPIRED_AT";
    SearchTeamMembershipsSortBy["LastName"] = "LAST_NAME";
    SearchTeamMembershipsSortBy["Status"] = "STATUS";
    SearchTeamMembershipsSortBy["TeamMemberType"] = "TEAM_MEMBER_TYPE";
    SearchTeamMembershipsSortBy["TeamMemberTypeSortRank"] = "TEAM_MEMBER_TYPE_SORT_RANK";
    SearchTeamMembershipsSortBy["UserId"] = "USER_ID";
    SearchTeamMembershipsSortBy["Username"] = "USERNAME";
})(SearchTeamMembershipsSortBy || (SearchTeamMembershipsSortBy = {})); /** The resolution status of the seat request */ 
var SeatRequestResponseStatus; /** The SeatType for the SeatRequest */ 
(function(SeatRequestResponseStatus) {
    SeatRequestResponseStatus["Accepted"] = "ACCEPTED";
    SeatRequestResponseStatus["Declined"] = "DECLINED";
    SeatRequestResponseStatus["Pending"] = "PENDING";
    SeatRequestResponseStatus["Withdrawn"] = "WITHDRAWN";
})(SeatRequestResponseStatus || (SeatRequestResponseStatus = {}));
var SeatRequestSeatType; /** The status of a SeatRequest */ 
(function(SeatRequestSeatType) {
    SeatRequestSeatType["CasualUser"] = "CASUAL_USER";
    SeatRequestSeatType["PowerUser"] = "POWER_USER";
})(SeatRequestSeatType || (SeatRequestSeatType = {}));
var SeatRequestStatus; /** The user making the seat request */ 
(function(SeatRequestStatus) {
    SeatRequestStatus["Available"] = "AVAILABLE";
    SeatRequestStatus["NotAvailable"] = "NOT_AVAILABLE";
    SeatRequestStatus["Pending"] = "PENDING";
    SeatRequestStatus["Responded"] = "RESPONDED";
})(SeatRequestStatus || (SeatRequestStatus = {}));
var SentimentAnalysisTagLabel;
(function(SentimentAnalysisTagLabel) {
    SentimentAnalysisTagLabel["Negative"] = "NEGATIVE";
    SentimentAnalysisTagLabel["Neutral"] = "NEUTRAL";
    SentimentAnalysisTagLabel["Positive"] = "POSITIVE";
    SentimentAnalysisTagLabel["Unknown"] = "UNKNOWN";
    SentimentAnalysisTagLabel["Unprocessed"] = "UNPROCESSED";
    SentimentAnalysisTagLabel["Untagged"] = "UNTAGGED";
})(SentimentAnalysisTagLabel || (SentimentAnalysisTagLabel = {}));
var ShareSurveyAction;
(function(ShareSurveyAction) {
    ShareSurveyAction["Changed"] = "CHANGED";
    ShareSurveyAction["Created"] = "CREATED";
    ShareSurveyAction["Revoked"] = "REVOKED";
})(ShareSurveyAction || (ShareSurveyAction = {}));
var SkipLogicDestinationType;
(function(SkipLogicDestinationType) {
    SkipLogicDestinationType["DisqualifyRespondent"] = "DISQUALIFY_RESPONDENT";
    SkipLogicDestinationType["EndSurvey"] = "END_SURVEY";
    SkipLogicDestinationType["SkipToPage"] = "SKIP_TO_PAGE";
})(SkipLogicDestinationType || (SkipLogicDestinationType = {})); /** Error code to represent study checkout failure. */ 
var SolutionsCheckoutStudyErrorCode; /**
 * Response type for solutionsCheckoutStudy mutation.
 * Includes error state for when the specified solutionsStudyId is not found or not authorized.
 */ 
(function(SolutionsCheckoutStudyErrorCode) {
    SolutionsCheckoutStudyErrorCode["StudyHasErrors"] = "STUDY_HAS_ERRORS";
})(SolutionsCheckoutStudyErrorCode || (SolutionsCheckoutStudyErrorCode = {})); /** Codes for errors corresponding to invalid study input error states. */ 
var SolutionsInvalidStudyErrorCode; /**
 * Response type for solutionsLaunchStudy query
 * Includes error state for when the specified solutionsStudyId is not found or not authorized.
 */ 
(function(SolutionsInvalidStudyErrorCode) {
    SolutionsInvalidStudyErrorCode["InvalidStudy"] = "INVALID_STUDY";
})(SolutionsInvalidStudyErrorCode || (SolutionsInvalidStudyErrorCode = {})); /**
 * Enum for possible configuration field type values.
 *
 * Each member represents the name of a data type for a configuration field.
 */ 
var SolutionsMethodologyConfigFieldType; /** Configuration field definition for fields of unknown type. */ 
(function(SolutionsMethodologyConfigFieldType) {
    SolutionsMethodologyConfigFieldType["Boolean"] = "BOOLEAN";
    SolutionsMethodologyConfigFieldType["CurrencyRange"] = "CURRENCY_RANGE";
    SolutionsMethodologyConfigFieldType["RichText"] = "RICH_TEXT";
    SolutionsMethodologyConfigFieldType["SingleChoice"] = "SINGLE_CHOICE";
    SolutionsMethodologyConfigFieldType["Text"] = "TEXT";
    SolutionsMethodologyConfigFieldType["ToggleText"] = "TOGGLE_TEXT";
    SolutionsMethodologyConfigFieldType["Unknown"] = "UNKNOWN";
})(SolutionsMethodologyConfigFieldType || (SolutionsMethodologyConfigFieldType = {})); /** Enumeration of type values for possible configuration node contents objects. */ 
var SolutionsMethodologyConfigNodeContentItemType; /** Object representing an individual methodology configuration node group. */ 
(function(SolutionsMethodologyConfigNodeContentItemType) {
    SolutionsMethodologyConfigNodeContentItemType["ConfigField"] = "CONFIG_FIELD";
    SolutionsMethodologyConfigNodeContentItemType["QuestionPreview"] = "QUESTION_PREVIEW";
})(SolutionsMethodologyConfigNodeContentItemType || (SolutionsMethodologyConfigNodeContentItemType = {})); /** Enum for discriminating between series types for charts. */ 
var SolutionsStudyAnalysisChartSeriesType; /** Represents a union of all the possible study analysis node types. */ 
(function(SolutionsStudyAnalysisChartSeriesType) {
    SolutionsStudyAnalysisChartSeriesType["Line"] = "LINE";
})(SolutionsStudyAnalysisChartSeriesType || (SolutionsStudyAnalysisChartSeriesType = {})); /** Single-member enum for discriminating survey question analysis node type objects in unions. */ 
var SolutionsStudyAnalysisQuestionNodeType; /**
 * Analysis nodes for the "question statistics" node type (associated with the
 * simple_example demo methodology.
 */ 
(function(SolutionsStudyAnalysisQuestionNodeType) {
    SolutionsStudyAnalysisQuestionNodeType["SurveyQuestion"] = "SURVEY_QUESTION";
})(SolutionsStudyAnalysisQuestionNodeType || (SolutionsStudyAnalysisQuestionNodeType = {})); /**
 * Single-member enum for discriminating question statistics node type objects in
 * unions.
 */ 
var SolutionsStudyAnalysisQuestionStatisticsNodeType; /**
 * Analysis nodes for the "simple" node type (associated with the simple_example
 * demo methodology.
 *
 * This is a temporary node type for testing the Framework's aggregate analysis
 * capabilities.
 */ 
(function(SolutionsStudyAnalysisQuestionStatisticsNodeType) {
    SolutionsStudyAnalysisQuestionStatisticsNodeType["QuestionStatistics"] = "QUESTION_STATISTICS";
})(SolutionsStudyAnalysisQuestionStatisticsNodeType || (SolutionsStudyAnalysisQuestionStatisticsNodeType = {})); /** Single-member enum for discriminating simple_example node type objects in unions. */ 
var SolutionsStudyAnalysisSimpleNodeType; /** Metadata for a Van Westendorp Pricing Sensitivity chart */ 
(function(SolutionsStudyAnalysisSimpleNodeType) {
    SolutionsStudyAnalysisSimpleNodeType["Simple"] = "SIMPLE";
})(SolutionsStudyAnalysisSimpleNodeType || (SolutionsStudyAnalysisSimpleNodeType = {})); /** Single-member enum for discriminating Van Westendorp analysis node type objects in unions. */ 
var SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeType; /** Metadata for a point of interest on a Van Westendorp Pricing Sensitivity chart */ 
(function(SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeType) {
    SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeType["VanWestendorpPricingSensitivity"] = "VAN_WESTENDORP_PRICING_SENSITIVITY";
})(SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeType || (SolutionsStudyAnalysisVanWestendorpPricingSensitivityNodeType = {})); /**
 * Error codes to represent states within configuration value fetch operations
 * where the associated configuration field definition fetch has failed.
 */ 
var SolutionsStudyMethodologyConfigValuesConfigFieldsErrorCode; /**
 * A union of all possible market research study configuration field value types.
 *
 * Mirrors the input scalar type SolutionsStudyMethodologyConfigValue. Where
 * possible, this type should be used over the scalar, because it provides schema
 * documentation of the possible configuration field value data types.
 */ 
(function(SolutionsStudyMethodologyConfigValuesConfigFieldsErrorCode) {
    SolutionsStudyMethodologyConfigValuesConfigFieldsErrorCode["FieldDefinitionMissing"] = "FIELD_DEFINITION_MISSING";
})(SolutionsStudyMethodologyConfigValuesConfigFieldsErrorCode || (SolutionsStudyMethodologyConfigValuesConfigFieldsErrorCode = {}));
var SolutionsStudyMethodologyStateMethodologyErrorCode;
(function(SolutionsStudyMethodologyStateMethodologyErrorCode) {
    SolutionsStudyMethodologyStateMethodologyErrorCode["MethodologyFetchError"] = "METHODOLOGY_FETCH_ERROR";
    SolutionsStudyMethodologyStateMethodologyErrorCode["MethodologyNotFound"] = "METHODOLOGY_NOT_FOUND";
})(SolutionsStudyMethodologyStateMethodologyErrorCode || (SolutionsStudyMethodologyStateMethodologyErrorCode = {})); /** Error codes for SolutionsStudyAnalysisNodes corresponding to not enough responses error states. */ 
var SolutionsStudyNotEnoughResponsesErrorCode; /** The price information for a study. */ 
(function(SolutionsStudyNotEnoughResponsesErrorCode) {
    SolutionsStudyNotEnoughResponsesErrorCode["InsufficientNumberOfResponses"] = "INSUFFICIENT_NUMBER_OF_RESPONSES";
})(SolutionsStudyNotEnoughResponsesErrorCode || (SolutionsStudyNotEnoughResponsesErrorCode = {})); /** Types of question preview objects. */ 
var SolutionsStudyQuestionPreviewType;
(function(SolutionsStudyQuestionPreviewType) {
    SolutionsStudyQuestionPreviewType["SingleChoice"] = "SINGLE_CHOICE";
    SolutionsStudyQuestionPreviewType["SingleTextbox"] = "SINGLE_TEXTBOX";
    SolutionsStudyQuestionPreviewType["UnknownType"] = "UNKNOWN_TYPE";
})(SolutionsStudyQuestionPreviewType || (SolutionsStudyQuestionPreviewType = {})); /** Enums that indicates the state of the study's collector and the projects. */ 
var SolutionsStudyStatus;
(function(SolutionsStudyStatus) {
    SolutionsStudyStatus["Complete"] = "COMPLETE";
    SolutionsStudyStatus["Draft"] = "DRAFT";
    SolutionsStudyStatus["Fielding"] = "FIELDING";
    SolutionsStudyStatus["Paused"] = "PAUSED";
})(SolutionsStudyStatus || (SolutionsStudyStatus = {})); /**
 * Error codes for representing errors in config field fetching, after the value
 * update has been completed.
 *
 * Temporary until MRxAPI is able to return a properly-formed field value
 * object, instead of a 204.
 */ 
var SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode; /**
 * Response type union for solutionsUpdateStudyMethodologyConfigValue mutation.
 *
 * TODO: Extra error types for the value fetch will be removed in future
 * (MOD-5722). Some are reused from above (as those will also be removed).
 */ 
(function(SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode) {
    SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode["ConfigFieldDefinitionFetchError"] = "CONFIG_FIELD_DEFINITION_FETCH_ERROR";
    SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode["ConfigValueFetchError"] = "CONFIG_VALUE_FETCH_ERROR";
})(SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode || (SolutionsUpdateStudyMethodologyConfigValueDataFetchErrorCode = {})); /**
 * Error codes for solutionsUpdateStudy study fetch, representing not found
 * errors.
 */ 
var SolutionsUpdateStudyStudyFetchNotFoundErrorCode; /**
 * Error type to represent unauthorized fetch errors for the study object in
 * solutionsUpdateStudy, after the study has been updated.
 * Temporary until MRxAPI returns a proper study object rather than a 204
 */ 
(function(SolutionsUpdateStudyStudyFetchNotFoundErrorCode) {
    SolutionsUpdateStudyStudyFetchNotFoundErrorCode["StudyNotFound"] = "STUDY_NOT_FOUND";
})(SolutionsUpdateStudyStudyFetchNotFoundErrorCode || (SolutionsUpdateStudyStudyFetchNotFoundErrorCode = {})); /**
 * Error codes for solutionsUpdateStudy study fetch, representing unauthorized
 * errors.
 */ 
var SolutionsUpdateStudyStudyFetchUnauthorizedErrorCode; /** Sort direction key. */ 
(function(SolutionsUpdateStudyStudyFetchUnauthorizedErrorCode) {
    SolutionsUpdateStudyStudyFetchUnauthorizedErrorCode["StudyUnauthorized"] = "STUDY_UNAUTHORIZED";
})(SolutionsUpdateStudyStudyFetchUnauthorizedErrorCode || (SolutionsUpdateStudyStudyFetchUnauthorizedErrorCode = {}));
var SortDirection;
(function(SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));
var StripeInvoiceStatus;
(function(StripeInvoiceStatus) {
    StripeInvoiceStatus["Draft"] = "DRAFT";
    StripeInvoiceStatus["Open"] = "OPEN";
    StripeInvoiceStatus["Paid"] = "PAID";
    StripeInvoiceStatus["Uncollectible"] = "UNCOLLECTIBLE";
    StripeInvoiceStatus["Void"] = "VOID";
})(StripeInvoiceStatus || (StripeInvoiceStatus = {}));
var SurveyFileUploadContentType;
(function(SurveyFileUploadContentType) {
    SurveyFileUploadContentType["Doc"] = "DOC";
    SurveyFileUploadContentType["Docx"] = "DOCX";
    SurveyFileUploadContentType["Gif"] = "GIF";
    SurveyFileUploadContentType["Jpeg"] = "JPEG";
    SurveyFileUploadContentType["Pdf"] = "PDF";
    SurveyFileUploadContentType["Png"] = "PNG";
})(SurveyFileUploadContentType || (SurveyFileUploadContentType = {}));
var SurveyFileUploadStatus;
(function(SurveyFileUploadStatus) {
    SurveyFileUploadStatus["Corrupted"] = "CORRUPTED";
    SurveyFileUploadStatus["Verified"] = "VERIFIED";
    SurveyFileUploadStatus["Verifying"] = "VERIFYING";
})(SurveyFileUploadStatus || (SurveyFileUploadStatus = {}));
var SurveyFormat;
(function(SurveyFormat) {
    SurveyFormat["Classic"] = "CLASSIC";
    SurveyFormat["Conversational"] = "CONVERSATIONAL";
    SurveyFormat["OneQuestionAtATime"] = "ONE_QUESTION_AT_A_TIME";
    SurveyFormat["SymptomTracking"] = "SYMPTOM_TRACKING";
})(SurveyFormat || (SurveyFormat = {}));
var SurveyLinkDomainType; /** Computed relative paths to common SurveyMonkey pages associate with a survey */ 
(function(SurveyLinkDomainType) {
    SurveyLinkDomainType["Custom"] = "CUSTOM";
    SurveyLinkDomainType["Surveymonkey"] = "SURVEYMONKEY";
    SurveyLinkDomainType["WhiteLabel"] = "WHITE_LABEL";
    SurveyLinkDomainType["Zoomerang"] = "ZOOMERANG";
})(SurveyLinkDomainType || (SurveyLinkDomainType = {}));
var SurveyListInclude;
(function(SurveyListInclude) {
    SurveyListInclude["Owned"] = "OWNED";
    SurveyListInclude["SharedBy"] = "SHARED_BY";
    SurveyListInclude["SharedWith"] = "SHARED_WITH";
})(SurveyListInclude || (SurveyListInclude = {}));
var SurveyListSortColumn; /**
 * Logic associated with a survey, can include skip or disqualification logic.
 * Each instance represents a single configured logical path in the survey.
 */ 
(function(SurveyListSortColumn) {
    SurveyListSortColumn["DateModified"] = "DATE_MODIFIED";
    SurveyListSortColumn["NumResponses"] = "NUM_RESPONSES";
    SurveyListSortColumn["Title"] = "TITLE";
})(SurveyListSortColumn || (SurveyListSortColumn = {}));
var SurveyLogicDestinationType;
(function(SurveyLogicDestinationType) {
    SurveyLogicDestinationType["DisqualifyRespondent"] = "DISQUALIFY_RESPONDENT";
    SurveyLogicDestinationType["EndSurvey"] = "END_SURVEY";
    SurveyLogicDestinationType["SkipToPage"] = "SKIP_TO_PAGE";
})(SurveyLogicDestinationType || (SurveyLogicDestinationType = {}));
var SurveyLogicSkipType;
(function(SurveyLogicSkipType) {
    SurveyLogicSkipType["PageUnconditional"] = "PAGE_UNCONDITIONAL";
    SurveyLogicSkipType["QuestionConditionalCol"] = "QUESTION_CONDITIONAL_COL";
    SurveyLogicSkipType["QuestionConditionalRow"] = "QUESTION_CONDITIONAL_ROW";
})(SurveyLogicSkipType || (SurveyLogicSkipType = {}));
var SurveyLogoAlignment;
(function(SurveyLogoAlignment) {
    SurveyLogoAlignment["Baseline"] = "BASELINE";
    SurveyLogoAlignment["Bottom"] = "BOTTOM";
    SurveyLogoAlignment["Center"] = "CENTER";
    SurveyLogoAlignment["LeftMiddle"] = "LEFT_MIDDLE";
    SurveyLogoAlignment["LeftTop"] = "LEFT_TOP";
    SurveyLogoAlignment["RightMiddle"] = "RIGHT_MIDDLE";
    SurveyLogoAlignment["RightTop"] = "RIGHT_TOP";
    SurveyLogoAlignment["Top"] = "TOP";
})(SurveyLogoAlignment || (SurveyLogoAlignment = {}));
var SurveyLogoSize;
(function(SurveyLogoSize) {
    SurveyLogoSize["Actual"] = "ACTUAL";
    SurveyLogoSize["Large"] = "LARGE";
    SurveyLogoSize["Medium"] = "MEDIUM";
    SurveyLogoSize["Small"] = "SMALL";
})(SurveyLogoSize || (SurveyLogoSize = {}));
var SurveyProgressBarPosition; /** The interface of any query that returns a Survey Page Question */ 
(function(SurveyProgressBarPosition) {
    SurveyProgressBarPosition["Bottom"] = "BOTTOM";
    SurveyProgressBarPosition["Disabled"] = "DISABLED";
    SurveyProgressBarPosition["Top"] = "TOP";
})(SurveyProgressBarPosition || (SurveyProgressBarPosition = {}));
var SurveyQuestionDisplaySubType;
(function(SurveyQuestionDisplaySubType) {
    SurveyQuestionDisplaySubType["Heart"] = "HEART";
    SurveyQuestionDisplaySubType["Smiley"] = "SMILEY";
    SurveyQuestionDisplaySubType["Star"] = "STAR";
    SurveyQuestionDisplaySubType["Thumb"] = "THUMB";
})(SurveyQuestionDisplaySubType || (SurveyQuestionDisplaySubType = {}));
var SurveyQuestionDisplayType;
(function(SurveyQuestionDisplayType) {
    SurveyQuestionDisplayType["Emoji"] = "EMOJI";
    SurveyQuestionDisplayType["FileUpload"] = "FILE_UPLOAD";
    SurveyQuestionDisplayType["ImageChoice"] = "IMAGE_CHOICE";
    SurveyQuestionDisplayType["Slider"] = "SLIDER";
})(SurveyQuestionDisplayType || (SurveyQuestionDisplayType = {}));
var SurveyQuestionFamily;
(function(SurveyQuestionFamily) {
    SurveyQuestionFamily["ClickMap"] = "CLICK_MAP";
    SurveyQuestionFamily["ContactInfo"] = "CONTACT_INFO";
    SurveyQuestionFamily["Datetime"] = "DATETIME";
    SurveyQuestionFamily["FileUpload"] = "FILE_UPLOAD";
    SurveyQuestionFamily["Matrix"] = "MATRIX";
    SurveyQuestionFamily["MultipleChoice"] = "MULTIPLE_CHOICE";
    SurveyQuestionFamily["OpenEnded"] = "OPEN_ENDED";
    SurveyQuestionFamily["Presentation"] = "PRESENTATION";
    SurveyQuestionFamily["Ranking"] = "RANKING";
    SurveyQuestionFamily["RatingScale"] = "RATING_SCALE";
    SurveyQuestionFamily["Slider"] = "SLIDER";
})(SurveyQuestionFamily || (SurveyQuestionFamily = {}));
var SurveyQuestionFamilySet; /** Survey question header */ 
(function(SurveyQuestionFamilySet) {
    SurveyQuestionFamilySet["ClickMap"] = "CLICK_MAP";
    SurveyQuestionFamilySet["Datetime"] = "DATETIME";
    SurveyQuestionFamilySet["Demographic"] = "DEMOGRAPHIC";
    SurveyQuestionFamilySet["Matrix"] = "MATRIX";
    SurveyQuestionFamilySet["MultipleChoice"] = "MULTIPLE_CHOICE";
    SurveyQuestionFamilySet["OpenEnded"] = "OPEN_ENDED";
    SurveyQuestionFamilySet["Presentation"] = "PRESENTATION";
    SurveyQuestionFamilySet["SingleChoice"] = "SINGLE_CHOICE";
})(SurveyQuestionFamilySet || (SurveyQuestionFamilySet = {})); /** The format type of numbering associated with a question on a survey */ 
var SurveyQuestionNumberingType;
(function(SurveyQuestionNumberingType) {
    SurveyQuestionNumberingType["Disabled"] = "DISABLED";
    SurveyQuestionNumberingType["Page"] = "PAGE";
    SurveyQuestionNumberingType["Survey"] = "SURVEY";
})(SurveyQuestionNumberingType || (SurveyQuestionNumberingType = {}));
var SurveyQuestionOptionType;
(function(SurveyQuestionOptionType) {
    SurveyQuestionOptionType["Column"] = "COLUMN";
    SurveyQuestionOptionType["ColumnChoice"] = "COLUMN_CHOICE";
    SurveyQuestionOptionType["Other"] = "OTHER";
    SurveyQuestionOptionType["Row"] = "ROW";
})(SurveyQuestionOptionType || (SurveyQuestionOptionType = {}));
var SurveyQuestionRequiredType;
(function(SurveyQuestionRequiredType) {
    SurveyQuestionRequiredType["All"] = "ALL";
    SurveyQuestionRequiredType["AtLeast"] = "AT_LEAST";
    SurveyQuestionRequiredType["AtMost"] = "AT_MOST";
    SurveyQuestionRequiredType["Exactly"] = "EXACTLY";
    SurveyQuestionRequiredType["Range"] = "RANGE";
})(SurveyQuestionRequiredType || (SurveyQuestionRequiredType = {}));
var SurveyQuestionSubTypeSet;
(function(SurveyQuestionSubTypeSet) {
    SurveyQuestionSubTypeSet["Both"] = "BOTH";
    SurveyQuestionSubTypeSet["DateOnly"] = "DATE_ONLY";
    SurveyQuestionSubTypeSet["DescriptiveText"] = "DESCRIPTIVE_TEXT";
    SurveyQuestionSubTypeSet["Essay"] = "ESSAY";
    SurveyQuestionSubTypeSet["Horiz"] = "HORIZ";
    SurveyQuestionSubTypeSet["Image"] = "IMAGE";
    SurveyQuestionSubTypeSet["International"] = "INTERNATIONAL";
    SurveyQuestionSubTypeSet["Menu"] = "MENU";
    SurveyQuestionSubTypeSet["Multi"] = "MULTI";
    SurveyQuestionSubTypeSet["Numerical"] = "NUMERICAL";
    SurveyQuestionSubTypeSet["Ranking"] = "RANKING";
    SurveyQuestionSubTypeSet["Rating"] = "RATING";
    SurveyQuestionSubTypeSet["Single"] = "SINGLE";
    SurveyQuestionSubTypeSet["TimeOnly"] = "TIME_ONLY";
    SurveyQuestionSubTypeSet["Us"] = "US";
    SurveyQuestionSubTypeSet["Vertical"] = "VERTICAL";
    SurveyQuestionSubTypeSet["VerticalThreeCol"] = "VERTICAL_THREE_COL";
    SurveyQuestionSubTypeSet["VerticalTwoCol"] = "VERTICAL_TWO_COL";
    SurveyQuestionSubTypeSet["Video"] = "VIDEO";
})(SurveyQuestionSubTypeSet || (SurveyQuestionSubTypeSet = {}));
var SurveyQuestionTemplateModifierType;
(function(SurveyQuestionTemplateModifierType) {
    SurveyQuestionTemplateModifierType["OpenEnded"] = "OPEN_ENDED";
    SurveyQuestionTemplateModifierType["Semantic"] = "SEMANTIC";
    SurveyQuestionTemplateModifierType["Superficial"] = "SUPERFICIAL";
})(SurveyQuestionTemplateModifierType || (SurveyQuestionTemplateModifierType = {}));
var SurveyQuestionTypeFamily;
(function(SurveyQuestionTypeFamily) {
    SurveyQuestionTypeFamily["ClickMap"] = "CLICK_MAP";
    SurveyQuestionTypeFamily["Datetime"] = "DATETIME";
    SurveyQuestionTypeFamily["Demographic"] = "DEMOGRAPHIC";
    SurveyQuestionTypeFamily["Matrix"] = "MATRIX";
    SurveyQuestionTypeFamily["MultipleChoice"] = "MULTIPLE_CHOICE";
    SurveyQuestionTypeFamily["OpenEnded"] = "OPEN_ENDED";
    SurveyQuestionTypeFamily["Presentation"] = "PRESENTATION";
    SurveyQuestionTypeFamily["SingleChoice"] = "SINGLE_CHOICE";
})(SurveyQuestionTypeFamily || (SurveyQuestionTypeFamily = {}));
var SurveyQuestionVariant;
(function(SurveyQuestionVariant) {
    SurveyQuestionVariant["Date"] = "DATE";
    SurveyQuestionVariant["Datetime"] = "DATETIME";
    SurveyQuestionVariant["Essay"] = "ESSAY";
    SurveyQuestionVariant["FileUpload"] = "FILE_UPLOAD";
    SurveyQuestionVariant["Image"] = "IMAGE";
    SurveyQuestionVariant["ManyAnswersCheckbox"] = "MANY_ANSWERS_CHECKBOX";
    SurveyQuestionVariant["ManyAnswersImage"] = "MANY_ANSWERS_IMAGE";
    SurveyQuestionVariant["ManyFields"] = "MANY_FIELDS";
    SurveyQuestionVariant["Menu"] = "MENU";
    SurveyQuestionVariant["Nps"] = "NPS";
    SurveyQuestionVariant["SingleAnswerImage"] = "SINGLE_ANSWER_IMAGE";
    SurveyQuestionVariant["SingleAnswerMenu"] = "SINGLE_ANSWER_MENU";
    SurveyQuestionVariant["SingleAnswerRadio"] = "SINGLE_ANSWER_RADIO";
    SurveyQuestionVariant["SingleAnswerSymbol"] = "SINGLE_ANSWER_SYMBOL";
    SurveyQuestionVariant["SingleClick"] = "SINGLE_CLICK";
    SurveyQuestionVariant["SingleLine"] = "SINGLE_LINE";
    SurveyQuestionVariant["SingleSlider"] = "SINGLE_SLIDER";
    SurveyQuestionVariant["Text"] = "TEXT";
    SurveyQuestionVariant["Time"] = "TIME";
})(SurveyQuestionVariant || (SurveyQuestionVariant = {}));
var SurveyScoreRating;
(function(SurveyScoreRating) {
    SurveyScoreRating["Good"] = "GOOD";
    SurveyScoreRating["Great"] = "GREAT";
    SurveyScoreRating["Ok"] = "OK";
    SurveyScoreRating["Perfect"] = "PERFECT";
    SurveyScoreRating["Unknown"] = "UNKNOWN";
})(SurveyScoreRating || (SurveyScoreRating = {}));
var SurveyScoreRatingV2;
(function(SurveyScoreRatingV2) {
    SurveyScoreRatingV2["Critical"] = "CRITICAL";
    SurveyScoreRatingV2["Ok"] = "OK";
    SurveyScoreRatingV2["Perfect"] = "PERFECT";
})(SurveyScoreRatingV2 || (SurveyScoreRatingV2 = {}));
var SurveySortBy;
(function(SurveySortBy) {
    SurveySortBy["DateCreated"] = "DATE_CREATED";
    SurveySortBy["DateModified"] = "DATE_MODIFIED";
    SurveySortBy["Nickname"] = "NICKNAME";
    SurveySortBy["ResponseCount"] = "RESPONSE_COUNT";
    SurveySortBy["Title"] = "TITLE";
})(SurveySortBy || (SurveySortBy = {})); /** The status of the Survey, computed based on its questions and collectors. */ 
var SurveyStatus;
(function(SurveyStatus) {
    SurveyStatus["Closed"] = "CLOSED";
    SurveyStatus["Draft"] = "DRAFT";
    SurveyStatus["Open"] = "OPEN";
    SurveyStatus["Unconfigured"] = "UNCONFIGURED";
})(SurveyStatus || (SurveyStatus = {})); /**
 * Available versions of survey themes
 * Note: Only themes in ver.3 format gets full support.
 */ 
var SurveyThemeVersion;
(function(SurveyThemeVersion) {
    SurveyThemeVersion["Draft"] = "DRAFT";
    SurveyThemeVersion["Retired"] = "RETIRED";
    SurveyThemeVersion["V0"] = "V0";
    SurveyThemeVersion["V1"] = "V1";
    SurveyThemeVersion["V2"] = "V2";
    SurveyThemeVersion["V3"] = "V3";
    SurveyThemeVersion["Zoomerang"] = "ZOOMERANG";
})(SurveyThemeVersion || (SurveyThemeVersion = {}));
var SurveyTitleHorizontalAlignment;
(function(SurveyTitleHorizontalAlignment) {
    SurveyTitleHorizontalAlignment["Center"] = "CENTER";
    SurveyTitleHorizontalAlignment["Left"] = "LEFT";
})(SurveyTitleHorizontalAlignment || (SurveyTitleHorizontalAlignment = {}));
var TeamInviteRequestStatus;
(function(TeamInviteRequestStatus) {
    TeamInviteRequestStatus["Available"] = "AVAILABLE";
    TeamInviteRequestStatus["Invited"] = "INVITED";
    TeamInviteRequestStatus["Pending"] = "PENDING";
    TeamInviteRequestStatus["Unavailable"] = "UNAVAILABLE";
})(TeamInviteRequestStatus || (TeamInviteRequestStatus = {}));
var TeamInviteStatus; /** This enum represents the status of a team member. */ 
(function(TeamInviteStatus) {
    TeamInviteStatus["Accepted"] = "ACCEPTED";
    TeamInviteStatus["Expired"] = "EXPIRED";
    TeamInviteStatus["New"] = "NEW";
    TeamInviteStatus["Pending"] = "PENDING";
    TeamInviteStatus["ResassignmentPending"] = "RESASSIGNMENT_PENDING";
})(TeamInviteStatus || (TeamInviteStatus = {}));
var TeamMemberStatus; /** The type of user within your team */ 
(function(TeamMemberStatus) {
    TeamMemberStatus["Active"] = "ACTIVE";
    TeamMemberStatus["CompletedDeletion"] = "COMPLETED_DELETION";
    TeamMemberStatus["Deactivated"] = "DEACTIVATED";
    TeamMemberStatus["Expired"] = "EXPIRED";
    TeamMemberStatus["Pending"] = "PENDING";
    TeamMemberStatus["PendingDeletion"] = "PENDING_DELETION";
    TeamMemberStatus["ReassignmentPending"] = "REASSIGNMENT_PENDING";
})(TeamMemberStatus || (TeamMemberStatus = {}));
var TeamMemberType;
(function(TeamMemberType) {
    TeamMemberType["AccountOwner"] = "ACCOUNT_OWNER";
    TeamMemberType["Admin"] = "ADMIN";
    TeamMemberType["Analyst"] = "ANALYST";
    TeamMemberType["Casual"] = "CASUAL";
    TeamMemberType["DivisionAdmin"] = "DIVISION_ADMIN";
    TeamMemberType["Regular"] = "REGULAR";
    TeamMemberType["Unspecified"] = "UNSPECIFIED";
})(TeamMemberType || (TeamMemberType = {})); /** Indicates how new surveys created by the user should be automatically shared. */ 
var TeamShareSetting; /** The state of single sign-on within a team */ 
(function(TeamShareSetting) {
    TeamShareSetting["ShareFullAccess"] = "SHARE_FULL_ACCESS";
    TeamShareSetting["ShareOff"] = "SHARE_OFF";
    TeamShareSetting["ShareViewOnly"] = "SHARE_VIEW_ONLY";
})(TeamShareSetting || (TeamShareSetting = {}));
var TeamSsoState;
(function(TeamSsoState) {
    TeamSsoState["Disabled"] = "DISABLED";
    TeamSsoState["Optional"] = "OPTIONAL";
    TeamSsoState["Required"] = "REQUIRED";
})(TeamSsoState || (TeamSsoState = {}));
var TeamSurveySortBy; /**
 * Additional settings that are associated with a team that are not considered team settings.
 * Default assets, survey intro text, etc.
 */ 
(function(TeamSurveySortBy) {
    TeamSurveySortBy["DateCreated"] = "DATE_CREATED";
    TeamSurveySortBy["DateModified"] = "DATE_MODIFIED";
    TeamSurveySortBy["Name"] = "NAME";
})(TeamSurveySortBy || (TeamSurveySortBy = {})); /** The level of a queried team widget. Team widgets can either be associated with a team overall, or a specific division of a team. */ 
var TeamWidgetSettingLevel; /** The restriction status for a team widget (whether end users must be restricted to the set values). Can be any combination of LibraryRestriction values depending on the widget. */ 
(function(TeamWidgetSettingLevel) {
    TeamWidgetSettingLevel["Division"] = "DIVISION";
    TeamWidgetSettingLevel["Team"] = "TEAM";
})(TeamWidgetSettingLevel || (TeamWidgetSettingLevel = {})); /**
 * Additional settings that are associated with a team that are not considered team settings.
 * Default assets, survey intro text, etc.
 */ 
var TeamWidgetType; /** Supported CSS text-decoration options */ 
(function(TeamWidgetType) {
    TeamWidgetType["DefaultImage"] = "DEFAULT_IMAGE";
    TeamWidgetType["DefaultPresentation"] = "DEFAULT_PRESENTATION";
    TeamWidgetType["DefaultTemplate"] = "DEFAULT_TEMPLATE";
    TeamWidgetType["DefaultTheme"] = "DEFAULT_THEME";
    TeamWidgetType["EndPage"] = "END_PAGE";
    TeamWidgetType["IntroText"] = "INTRO_TEXT";
})(TeamWidgetType || (TeamWidgetType = {}));
var TextDecorationType; /** This validation configuration is used to enforce text inputs. */ 
(function(TextDecorationType) {
    TextDecorationType["None"] = "NONE";
    TextDecorationType["Underline"] = "UNDERLINE";
})(TextDecorationType || (TextDecorationType = {})); /** The available time comparison that a tracking insights can be produced against */ 
var TrackingInsightTimeComparison; /**
 * Defines a survey invoice that is used for a given wave launch
 * The id can be used to query at billing service
 */ 
(function(TrackingInsightTimeComparison) {
    TrackingInsightTimeComparison["Biannually"] = "BIANNUALLY";
    TrackingInsightTimeComparison["Monthly"] = "MONTHLY";
    TrackingInsightTimeComparison["Quarterly"] = "QUARTERLY";
    TrackingInsightTimeComparison["Yearly"] = "YEARLY";
})(TrackingInsightTimeComparison || (TrackingInsightTimeComparison = {}));
var TrackingLaunchState; /** Defines the information required for an advance market criteria */ 
(function(TrackingLaunchState) {
    TrackingLaunchState["Complete"] = "COMPLETE";
    TrackingLaunchState["Draft"] = "DRAFT";
    TrackingLaunchState["InProgress"] = "IN_PROGRESS";
})(TrackingLaunchState || (TrackingLaunchState = {}));
var TrackingMarketBalancingScheme;
(function(TrackingMarketBalancingScheme) {
    TrackingMarketBalancingScheme["BasicCensus"] = "BASIC_CENSUS";
    TrackingMarketBalancingScheme["Census"] = "CENSUS";
    TrackingMarketBalancingScheme["Crude"] = "CRUDE";
    TrackingMarketBalancingScheme["CrudeAge"] = "CRUDE_AGE";
    TrackingMarketBalancingScheme["CrudeGenderAge"] = "CRUDE_GENDER_AGE";
    TrackingMarketBalancingScheme["Custom"] = "CUSTOM";
    TrackingMarketBalancingScheme["Full"] = "FULL";
    TrackingMarketBalancingScheme["FullAge"] = "FULL_AGE";
    TrackingMarketBalancingScheme["FullCensus"] = "FULL_CENSUS";
    TrackingMarketBalancingScheme["FullCensusGenderAge"] = "FULL_CENSUS_GENDER_AGE";
    TrackingMarketBalancingScheme["Gender"] = "GENDER";
    TrackingMarketBalancingScheme["NoBalance"] = "NO_BALANCE";
    TrackingMarketBalancingScheme["None"] = "NONE";
})(TrackingMarketBalancingScheme || (TrackingMarketBalancingScheme = {}));
var TrackingMarketBalancingType; /** Defines the information required for a market demographic criteria */ 
(function(TrackingMarketBalancingType) {
    TrackingMarketBalancingType["Automatic"] = "AUTOMATIC";
    TrackingMarketBalancingType["Custom"] = "CUSTOM";
})(TrackingMarketBalancingType || (TrackingMarketBalancingType = {}));
var TrackingProjectState; /** Defines a question that can be used to filter tracking projects */ 
(function(TrackingProjectState) {
    TrackingProjectState["Draft"] = "DRAFT";
    TrackingProjectState["Published"] = "PUBLISHED";
    TrackingProjectState["Running"] = "RUNNING";
})(TrackingProjectState || (TrackingProjectState = {})); /** Defines the family from a question that can be used to filter tracking projects */ 
var TrackingQuestionFamily;
(function(TrackingQuestionFamily) {
    TrackingQuestionFamily["Matrix"] = "MATRIX";
    TrackingQuestionFamily["MultipleChoice"] = "MULTIPLE_CHOICE";
    TrackingQuestionFamily["OpenEnded"] = "OPEN_ENDED";
    TrackingQuestionFamily["Presentation"] = "PRESENTATION";
    TrackingQuestionFamily["SingleChoice"] = "SINGLE_CHOICE";
})(TrackingQuestionFamily || (TrackingQuestionFamily = {})); /** Defines the sub type from a question that can be used to filter tracking projects */ 
var TrackingQuestionSubType; /** Defines the type for a tracking question */ 
(function(TrackingQuestionSubType) {
    TrackingQuestionSubType["Essay"] = "ESSAY";
    TrackingQuestionSubType["Menu"] = "MENU";
    TrackingQuestionSubType["Multi"] = "MULTI";
    TrackingQuestionSubType["Numerical"] = "NUMERICAL";
    TrackingQuestionSubType["Ranking"] = "RANKING";
    TrackingQuestionSubType["Rating"] = "RATING";
    TrackingQuestionSubType["Single"] = "SINGLE";
    TrackingQuestionSubType["Vertical"] = "VERTICAL";
    TrackingQuestionSubType["VerticalThreeCol"] = "VERTICAL_THREE_COL";
    TrackingQuestionSubType["VerticalTwoCol"] = "VERTICAL_TWO_COL";
})(TrackingQuestionSubType || (TrackingQuestionSubType = {}));
var TrackingTrackerFrequency; /** An insight can be linked to either a column or a row from a question */ 
(function(TrackingTrackerFrequency) {
    TrackingTrackerFrequency["Biannually"] = "BIANNUALLY";
    TrackingTrackerFrequency["Custom"] = "CUSTOM";
    TrackingTrackerFrequency["Monthly"] = "MONTHLY";
    TrackingTrackerFrequency["Quarterly"] = "QUARTERLY";
    TrackingTrackerFrequency["Weekly"] = "WEEKLY";
    TrackingTrackerFrequency["Yearly"] = "YEARLY";
})(TrackingTrackerFrequency || (TrackingTrackerFrequency = {})); /** The possible trends when doing an in-time insight comparison. */ 
var TrackingTrackerInTimeInsightTrend;
(function(TrackingTrackerInTimeInsightTrend) {
    TrackingTrackerInTimeInsightTrend["Decrease"] = "DECREASE";
    TrackingTrackerInTimeInsightTrend["Increase"] = "INCREASE";
})(TrackingTrackerInTimeInsightTrend || (TrackingTrackerInTimeInsightTrend = {}));
var TrackingTrackerState; /**
 * Defines a static insight for a tracking project.
 * Ex:
 * [Answer option] is at 40 pts overall. [Gender: Women, Age: 18-29] were higher at 52 pts.
 */ 
(function(TrackingTrackerState) {
    TrackingTrackerState["Complete"] = "COMPLETE";
    TrackingTrackerState["Draft"] = "DRAFT";
    TrackingTrackerState["Fielding"] = "FIELDING";
    TrackingTrackerState["Halted"] = "HALTED";
    TrackingTrackerState["Published"] = "PUBLISHED";
})(TrackingTrackerState || (TrackingTrackerState = {}));
var TrackingWaveState;
(function(TrackingWaveState) {
    TrackingWaveState["Complete"] = "COMPLETE";
    TrackingWaveState["Draft"] = "DRAFT";
    TrackingWaveState["InProgress"] = "IN_PROGRESS";
})(TrackingWaveState || (TrackingWaveState = {}));
var TransactionProcessType;
(function(TransactionProcessType) {
    TransactionProcessType["AnnualUpgrade"] = "ANNUAL_UPGRADE";
    TransactionProcessType["BenchmarkOneTime"] = "BENCHMARK_ONE_TIME";
    TransactionProcessType["BenchmarkRenewable"] = "BENCHMARK_RENEWABLE";
    TransactionProcessType["BenchmarkSelfServeRenewable"] = "BENCHMARK_SELF_SERVE_RENEWABLE";
    TransactionProcessType["CompUpgrade"] = "COMP_UPGRADE";
    TransactionProcessType["ConceptTest"] = "CONCEPT_TEST";
    TransactionProcessType["Credit"] = "CREDIT";
    TransactionProcessType["CurrencyChange"] = "CURRENCY_CHANGE";
    TransactionProcessType["DirectDebitFailure"] = "DIRECT_DEBIT_FAILURE";
    TransactionProcessType["GroupOverage"] = "GROUP_OVERAGE";
    TransactionProcessType["Incentive"] = "INCENTIVE";
    TransactionProcessType["MarketoRenewable"] = "MARKETO_RENEWABLE";
    TransactionProcessType["OneTime"] = "ONE_TIME";
    TransactionProcessType["PanelSelfServe"] = "PANEL_SELF_SERVE";
    TransactionProcessType["Recurring"] = "RECURRING";
    TransactionProcessType["SalesforceOneTime"] = "SALESFORCE_ONE_TIME";
    TransactionProcessType["SalesforceRenewable"] = "SALESFORCE_RENEWABLE";
    TransactionProcessType["Smi"] = "SMI";
    TransactionProcessType["SmiCompUpgrade"] = "SMI_COMP_UPGRADE";
    TransactionProcessType["SmiP2PUpgrade"] = "SMI_P2P_UPGRADE";
    TransactionProcessType["SubscriptionHiddenCompUpgrade"] = "SUBSCRIPTION_HIDDEN_COMP_UPGRADE";
    TransactionProcessType["SubscriptionRestart"] = "SUBSCRIPTION_RESTART";
    TransactionProcessType["TaxamoRefund"] = "TAXAMO_REFUND";
    TransactionProcessType["TempUpgrade"] = "TEMP_UPGRADE";
    TransactionProcessType["Wallet"] = "WALLET";
    TransactionProcessType["ZoomerangHistoricInvoice"] = "ZOOMERANG_HISTORIC_INVOICE";
})(TransactionProcessType || (TransactionProcessType = {}));
var TransactionStatusType; /** The time periods in which you can filter response trends */ 
(function(TransactionStatusType) {
    TransactionStatusType["Authorized"] = "AUTHORIZED";
    TransactionStatusType["Failed"] = "FAILED";
    TransactionStatusType["New"] = "NEW";
    TransactionStatusType["Paid"] = "PAID";
    TransactionStatusType["Pending"] = "PENDING";
    TransactionStatusType["PendingAudienceCheckout"] = "PENDING_AUDIENCE_CHECKOUT";
    TransactionStatusType["PendingCheckout"] = "PENDING_CHECKOUT";
    TransactionStatusType["PendingRefund"] = "PENDING_REFUND";
    TransactionStatusType["Void"] = "VOID";
})(TransactionStatusType || (TransactionStatusType = {}));
var TrendTimePeriod; /** This contains all collectors triggering options */ 
(function(TrendTimePeriod) {
    TrendTimePeriod["Days"] = "DAYS";
    TrendTimePeriod["Default"] = "DEFAULT";
    TrendTimePeriod["Hours"] = "HOURS";
    TrendTimePeriod["Months"] = "MONTHS";
    TrendTimePeriod["Quarters"] = "QUARTERS";
    TrendTimePeriod["Weeks"] = "WEEKS";
    TrendTimePeriod["Years"] = "YEARS";
})(TrendTimePeriod || (TrendTimePeriod = {})); /** Codes for errors corresponding to 'unauthorized' error states. */ 
var UnauthorizedErrorCode;
(function(UnauthorizedErrorCode) {
    UnauthorizedErrorCode["Unauthorized"] = "UNAUTHORIZED";
})(UnauthorizedErrorCode || (UnauthorizedErrorCode = {}));
var UpdateTrackingDashboardSharingErrorType;
(function(UpdateTrackingDashboardSharingErrorType) {
    UpdateTrackingDashboardSharingErrorType["PasswordProhibited"] = "PASSWORD_PROHIBITED";
    UpdateTrackingDashboardSharingErrorType["PasswordTooShort"] = "PASSWORD_TOO_SHORT";
})(UpdateTrackingDashboardSharingErrorType || (UpdateTrackingDashboardSharingErrorType = {}));
var UpdateWebCampaignCollectorTriggeringOptionsErrorType;
(function(UpdateWebCampaignCollectorTriggeringOptionsErrorType) {
    UpdateWebCampaignCollectorTriggeringOptionsErrorType["CollectorIdNotExist"] = "COLLECTOR_ID_NOT_EXIST";
})(UpdateWebCampaignCollectorTriggeringOptionsErrorType || (UpdateWebCampaignCollectorTriggeringOptionsErrorType = {})); /** Web collector URL matcher type */ 
var UrlMatch;
(function(UrlMatch) {
    UrlMatch["Contains"] = "CONTAINS";
    UrlMatch["Ends"] = "ENDS";
    UrlMatch["Exact"] = "EXACT";
    UrlMatch["Regexp"] = "REGEXP";
    UrlMatch["Starts"] = "STARTS";
})(UrlMatch || (UrlMatch = {})); /** All the possible values that can be used as a performance calculation basis */ 
var UseCasePerformanceScoreType;
(function(UseCasePerformanceScoreType) {
    UseCasePerformanceScoreType["Benchmark"] = "BENCHMARK";
    UseCasePerformanceScoreType["Concept"] = "CONCEPT";
})(UseCasePerformanceScoreType || (UseCasePerformanceScoreType = {})); /** User Permission Type indicate types available in platformsyncsvc */ 
var UserPermissionType;
(function(UserPermissionType) {
    UserPermissionType["AudienceCreditsBuy"] = "AUDIENCE_CREDITS_BUY";
    UserPermissionType["AudienceCreditsManage"] = "AUDIENCE_CREDITS_MANAGE";
    UserPermissionType["AudienceCreditsUse"] = "AUDIENCE_CREDITS_USE";
})(UserPermissionType || (UserPermissionType = {})); /** General collector user segment type */ 
var UserSegment;
(function(UserSegment) {
    UserSegment["Any"] = "ANY";
    UserSegment["New"] = "NEW";
    UserSegment["Returning"] = "RETURNING";
})(UserSegment || (UserSegment = {}));
var UserSubscriptionPartner;
(function(UserSubscriptionPartner) {
    UserSubscriptionPartner["Surveymonkey"] = "SURVEYMONKEY";
    UserSubscriptionPartner["Wufoo"] = "WUFOO";
})(UserSubscriptionPartner || (UserSubscriptionPartner = {}));
var UserSubscriptionStatus; /** Indicates if alert is enabled for new and existing surveys */ 
(function(UserSubscriptionStatus) {
    UserSubscriptionStatus["Active"] = "ACTIVE";
    UserSubscriptionStatus["Canceled"] = "CANCELED";
    UserSubscriptionStatus["Incomplete"] = "INCOMPLETE";
    UserSubscriptionStatus["IncompleteExpired"] = "INCOMPLETE_EXPIRED";
    UserSubscriptionStatus["PastDue"] = "PAST_DUE";
    UserSubscriptionStatus["Trialing"] = "TRIALING";
    UserSubscriptionStatus["Unpaid"] = "UNPAID";
})(UserSubscriptionStatus || (UserSubscriptionStatus = {}));
var UserSurveyAlertStatus;
(function(UserSurveyAlertStatus) {
    UserSurveyAlertStatus["ExistingOffNewSurveyOff"] = "EXISTING_OFF_NEW_SURVEY_OFF";
    UserSurveyAlertStatus["ExistingOffNewSurveyOn"] = "EXISTING_OFF_NEW_SURVEY_ON";
    UserSurveyAlertStatus["ExistingOnNewSurveyOff"] = "EXISTING_ON_NEW_SURVEY_OFF";
    UserSurveyAlertStatus["ExistingOnNewSurveyOn"] = "EXISTING_ON_NEW_SURVEY_ON";
})(UserSurveyAlertStatus || (UserSurveyAlertStatus = {}));
var UserTeamSharingPolicyType;
(function(UserTeamSharingPolicyType) {
    UserTeamSharingPolicyType["Disabled"] = "DISABLED";
    UserTeamSharingPolicyType["Enabled"] = "ENABLED";
    UserTeamSharingPolicyType["Sso"] = "SSO";
})(UserTeamSharingPolicyType || (UserTeamSharingPolicyType = {})); /** This is the reason why a survey cannot be transfered */ 
var ValidateBulkTransferSurveyResultError;
(function(ValidateBulkTransferSurveyResultError) {
    ValidateBulkTransferSurveyResultError["Authorization"] = "AUTHORIZATION";
    ValidateBulkTransferSurveyResultError["Generic"] = "GENERIC";
    ValidateBulkTransferSurveyResultError["Offline"] = "OFFLINE";
    ValidateBulkTransferSurveyResultError["Payment"] = "PAYMENT";
})(ValidateBulkTransferSurveyResultError || (ValidateBulkTransferSurveyResultError = {})); /** The type of weblink collector, specifies the relationship it has with other weblinks */ 
var WeblinkVariant; /** Web collector page exit event */ 
(function(WeblinkVariant) {
    WeblinkVariant["Occurrence"] = "OCCURRENCE";
    WeblinkVariant["Standard"] = "STANDARD";
    WeblinkVariant["Template"] = "TEMPLATE";
})(WeblinkVariant || (WeblinkVariant = {}));
var WebTriggerConditionType; /** Web collector union of trigger conditions */ 
(function(WebTriggerConditionType) {
    WebTriggerConditionType["Cookie"] = "COOKIE";
    WebTriggerConditionType["CustomVariables"] = "CUSTOM_VARIABLES";
    WebTriggerConditionType["Device"] = "DEVICE";
    WebTriggerConditionType["PageVisits"] = "PAGE_VISITS";
    WebTriggerConditionType["SpecificUrl"] = "SPECIFIC_URL";
})(WebTriggerConditionType || (WebTriggerConditionType = {}));
var WebTriggerEventType; /** Union of web collector main events */ 
(function(WebTriggerEventType) {
    WebTriggerEventType["CustomEvent"] = "CUSTOM_EVENT";
    WebTriggerEventType["PageExit"] = "PAGE_EXIT";
    WebTriggerEventType["PageLoad"] = "PAGE_LOAD";
    WebTriggerEventType["ScrollDown"] = "SCROLL_DOWN";
    WebTriggerEventType["TimeOnPage"] = "TIME_ON_PAGE";
})(WebTriggerEventType || (WebTriggerEventType = {})); /** represents the set of distinct pages across all flows */ 
var WelcomeFlowPageType; /** common question fields */ 
(function(WelcomeFlowPageType) {
    WelcomeFlowPageType["Individual"] = "INDIVIDUAL";
    WelcomeFlowPageType["Organization"] = "ORGANIZATION";
    WelcomeFlowPageType["SurveyType"] = "SURVEY_TYPE";
    WelcomeFlowPageType["UserPurpose"] = "USER_PURPOSE";
})(WelcomeFlowPageType || (WelcomeFlowPageType = {})); /** represents the set of distinct question types currently supported */ 
var WelcomeFlowQuestionType; /** represents the type of redirection when the flow is being exited */ 
(function(WelcomeFlowQuestionType) {
    WelcomeFlowQuestionType["Flag"] = "FLAG";
    WelcomeFlowQuestionType["MultipleChoice"] = "MULTIPLE_CHOICE";
    WelcomeFlowQuestionType["Number"] = "NUMBER";
    WelcomeFlowQuestionType["SingleChoice"] = "SINGLE_CHOICE";
    WelcomeFlowQuestionType["Text"] = "TEXT";
})(WelcomeFlowQuestionType || (WelcomeFlowQuestionType = {}));
var WelcomeFlowRedirectType; /** a single choice question */ 
(function(WelcomeFlowRedirectType) {
    WelcomeFlowRedirectType["Redirect"] = "REDIRECT";
    WelcomeFlowRedirectType["Window"] = "WINDOW";
})(WelcomeFlowRedirectType || (WelcomeFlowRedirectType = {})); /** represents the type of destination when the flow is being exited */ 
var WelcomeFlowTargetType; /** a text question */ 
(function(WelcomeFlowTargetType) {
    WelcomeFlowTargetType["Analyst"] = "ANALYST";
    WelcomeFlowTargetType["Audience"] = "AUDIENCE";
    WelcomeFlowTargetType["Create"] = "CREATE";
    WelcomeFlowTargetType["Dashboard"] = "DASHBOARD";
    WelcomeFlowTargetType["EduPricingPage"] = "EDU_PRICING_PAGE";
})(WelcomeFlowTargetType || (WelcomeFlowTargetType = {})); /** Whether the member has been accepted into the workgroup or not. */ 
var WorkgroupMemberStatus; /** Info about the current user and if they are a member of a workgroup. */ 
(function(WorkgroupMemberStatus) {
    WorkgroupMemberStatus["Active"] = "ACTIVE";
    WorkgroupMemberStatus["Pending"] = "PENDING";
})(WorkgroupMemberStatus || (WorkgroupMemberStatus = {}));
var WorkgroupResourceType; /** An entity shared with a workgroup, for example a Survey */ 
(function(WorkgroupResourceType) {
    WorkgroupResourceType["Survey"] = "SURVEY";
})(WorkgroupResourceType || (WorkgroupResourceType = {})); //# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/graphql-tag/node_modules/tslib/tslib.es6.js
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var tslib_es6_assign = function() {
    tslib_es6_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return tslib_es6_assign.apply(this, arguments);
}

function tslib_es6_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(5821);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = __webpack_require__(5695);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineToJSON.mjs

/**
 * The `defineToJSON()` function defines toJSON() and inspect() prototype
 * methods, if no function provided they become aliases for toString().
 */

function defineToJSON(classObject) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
  classObject.prototype.toJSON = fn;
  classObject.prototype.inspect = fn;

  if (nodejsCustomInspectSymbol/* default */.Z) {
    classObject.prototype[nodejsCustomInspectSymbol/* default */.Z] = fn;
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var sublineIndex = Math.floor(columnNum / 80);
    var sublineColumnNum = columnNum % 80;
    var sublines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      sublines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), sublines[0]]].concat(sublines.slice(1, sublineIndex + 1).map(function (subline) {
      return ['', subline];
    }), [[' ', whitespace(sublineColumnNum - 1) + '^'], ['', sublines[sublineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return lpad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs



/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


  var _source = source;

  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;

  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }

      return list;
    }, []);
  }

  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations;

  if (positions && source) {
    _locations = positions.map(function (pos) {
      return getLocation(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(getLocation(node.loc.source, node.loc.start));
      }

      return list;
    }, []);
  }

  var _extensions = extensions;

  if (_extensions == null && originalError != null) {
    var originalExtensions = originalError.extensions;

    if (isObjectLike(originalExtensions)) {
      _extensions = originalExtensions;
    }
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_locations)
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(path)
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _extensions || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_extensions)
    }
  }); // Include (non-enumerable) stack trace.

  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}
GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: GraphQLError
  },
  name: {
    value: 'GraphQLError'
  },
  toString: {
    value: function toString() {
      return printError(this);
    }
  }
});
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */

function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
      var node = _error$nodes2[_i2];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
      var location = _error$locations2[_i4];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/kinds.mjs
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineToStringTag.mjs
/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */
function defineToStringTag(classObject) {
  if (typeof Symbol === 'function' && Symbol.toStringTag) {
    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
      get: function get() {
        return this.constructor.name;
      }
    });
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs



/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || {
    line: 1,
    column: 1
  };
  this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive');
  this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive');
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported

defineToStringTag(Source);

// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(7392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs




/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

function createLexer(source, options) {
  var startOfFileToken = new Tok(tokenKind_TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;

  if (token.kind !== tokenKind_TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === tokenKind_TokenKind.COMMENT);
  }

  return token;
}
/**
 * The return type of createLexer.
 */


// @internal
function isPunctuatorToken(token) {
  var kind = token.kind;
  return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
/**
 * Helper function for constructing the Token object.
 */

function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.


defineToJSON(Tok, function () {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
});

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? tokenKind_TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(tokenKind_TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = body.charCodeAt(pos); // SourceCharacter

  switch (code) {
    // !
    case 33:
      return new Tok(tokenKind_TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #

    case 35:
      return readComment(source, pos, line, col, prev);
    // $

    case 36:
      return new Tok(tokenKind_TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &

    case 38:
      return new Tok(tokenKind_TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (

    case 40:
      return new Tok(tokenKind_TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )

    case 41:
      return new Tok(tokenKind_TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .

    case 46:
      if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
        return new Tok(tokenKind_TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }

      break;
    // :

    case 58:
      return new Tok(tokenKind_TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =

    case 61:
      return new Tok(tokenKind_TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @

    case 64:
      return new Tok(tokenKind_TokenKind.AT, pos, pos + 1, line, col, prev);
    // [

    case 91:
      return new Tok(tokenKind_TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]

    case 93:
      return new Tok(tokenKind_TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {

    case 123:
      return new Tok(tokenKind_TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |

    case 124:
      return new Tok(tokenKind_TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }

    case 125:
      return new Tok(tokenKind_TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "

    case 34:
      if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev, lexer);
      }

      return readString(source, pos, line, col, prev);
  }

  throw syntaxError(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */


function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;

  while (position < bodyLength) {
    var code = body.charCodeAt(position); // tab | space | comma | BOM

    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }

  return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(tokenKind_TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or e


  if (code === 46 || code === 69 || code === 101) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new Tok(isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new Tok(tokenKind_TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new Tok(tokenKind_TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0,blockString/* dedentBlockStringValue */.W7)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Tok(tokenKind_TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs










/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}

var Parser =
/*#__PURE__*/
function () {
  function Parser(source, options) {
    var sourceObj = typeof source === 'string' ? new Source(source) : source;
    sourceObj instanceof Source || devAssert(0, "Must provide Source. Received: ".concat((0,inspect/* default */.Z)(sourceObj)));
    this._lexer = createLexer(sourceObj);
    this._options = options || {};
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(tokenKind_TokenKind.NAME);
    return {
      kind: Kind.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: Kind.DOCUMENT,
      definitions: this.many(tokenKind_TokenKind.SOF, this.parseDefinition, tokenKind_TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(tokenKind_TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return {
        kind: Kind.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: Kind.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseVariableDefinition, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return {
      kind: Kind.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: Kind.SELECTION_SET,
      selections: this.many(tokenKind_TokenKind.BRACE_L, this.parseSelection, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: Kind.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: Kind.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: Kind.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(tokenKind_TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.experimentalFragmentVariables) {
      return {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return {
          kind: Kind.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: Kind.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        if (token.value === 'true' || token.value === 'false') {
          this._lexer.advance();

          return {
            kind: Kind.BOOLEAN,
            value: token.value === 'true',
            loc: this.loc(token)
          };
        } else if (token.value === 'null') {
          this._lexer.advance();

          return {
            kind: Kind.NULL,
            loc: this.loc(token)
          };
        }

        this._lexer.advance();

        return {
          kind: Kind.ENUM,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: Kind.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: Kind.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: Kind.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = {
        kind: Kind.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return {
        kind: Kind.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);
    return {
      kind: Kind.SCHEMA_DEFINITION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var types = [];

    if (this.expectOptionalKeyword('implements')) {
      // Optional leading ampersand
      this.expectOptionalToken(tokenKind_TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.AMP) || // Legacy support for the SDL?
      this._options.allowLegacySDLImplementsInterfaces && this.peek(tokenKind_TokenKind.NAME));
    }

    return types;
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    // Legacy support for the SDL?
    if (this._options.allowLegacySDLEmptyFields && this.peek(tokenKind_TokenKind.BRACE_L) && this._lexer.lookahead().kind === tokenKind_TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseFieldDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseInputValueDef, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: Kind.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    var types = [];

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      // Optional leading pipe
      this.expectOptionalToken(tokenKind_TokenKind.PIPE);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.PIPE));
    }

    return types;
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseEnumValueDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseInputValueDef, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *   - extend interface Name Directives[Const]? FieldsDefinition
   *   - extend interface Name Directives[Const]
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: Kind.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    // Optional leading pipe
    this.expectOptionalToken(tokenKind_TokenKind.PIPE);
    var locations = [];

    do {
      locations.push(this.parseDirectiveLocation());
    } while (this.expectOptionalToken(tokenKind_TokenKind.PIPE));

    return locations;
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in
   * the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    if (!this._options.noLocation) {
      return new Loc(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat(getTokenDesc(token)));
  }
  /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token)));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing
   * the lexer. Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token
   * is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken || this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token)));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always
   * return non-empty list that begins with a lex token of openKind and ends
   * with a lex token of closeKind. Advances the parser to the next lex token
   * after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  };

  return Parser;
}();

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.


defineToJSON(Loc, function () {
  return {
    start: this.start,
    end: this.end
  };
});
/**
 * A helper function to describe a token as a string for debugging
 */

function getTokenDesc(token) {
  var value = token.value;
  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return tslib_es6_assign(tslib_es6_assign({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/Actions.generated.js

var _templateObject;
function Actions_generated_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function Actions_generated_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? Actions_generated_ownKeys(Object(source), !0).forEach(function(key) {
            Actions_generated_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Actions_generated_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Actions_generated_defineProperty(obj, key, value) {
    key = Actions_generated_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Actions_generated_toPropertyKey(arg) {
    var key = Actions_generated_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function Actions_generated_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
/* eslint-disable */ 

var defaultOptions = {};
var ActionsQueryDocument = lib(_templateObject || (_templateObject = _taggedTemplateLiteral([
    "\n  query actionsQuery {\n    user {\n      id\n      username\n      team {\n        id\n        name\n        ssoState\n      }\n      teamMembership {\n        id\n        isEnterprise\n        isAdmin\n        memberType\n      }\n      language {\n        id\n        code\n      }\n      package {\n        id\n        canonicalName\n        isAnnual\n      }\n      features {\n        powerCasualEnabled\n      }\n      permissions\n    }\n  }\n"
])));
/**
 * __useActionsQueryQuery__
 *
 * To run a query within a React component, call `useActionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionsQueryQuery({
 *   variables: {
 *   },
 * });
 */ function useActionsQueryQuery(baseOptions) {
    var options = Actions_generated_objectSpread(Actions_generated_objectSpread({}, defaultOptions), baseOptions);
    return ApolloReactHooks.useQuery(ActionsQueryDocument, options);
}
function useActionsQueryLazyQuery(baseOptions) {
    var options = Actions_generated_objectSpread(Actions_generated_objectSpread({}, defaultOptions), baseOptions);
    return react_hooks_esm/* useLazyQuery */.td(ActionsQueryDocument, options);
} //# sourceMappingURL=Actions.generated.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/ButtonUser.js
var ButtonUser_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/ButtonUser.tsx", ButtonUser_this = undefined;
function ButtonUser_slicedToArray(arr, i) {
    return ButtonUser_arrayWithHoles(arr) || ButtonUser_iterableToArrayLimit(arr, i) || ButtonUser_unsupportedIterableToArray(arr, i) || ButtonUser_nonIterableRest();
}
function ButtonUser_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ButtonUser_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ButtonUser_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ButtonUser_arrayLikeToArray(o, minLen);
}
function ButtonUser_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function ButtonUser_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function ButtonUser_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}







var ButtonUser = function ButtonUser() {
    var _user$teamMembership, _user$package, _user$permissions, _user$permissions2, _user$features;
    var _useActionsQueryLazyQ = useActionsQueryLazyQuery(), _useActionsQueryLazyQ2 = ButtonUser_slicedToArray(_useActionsQueryLazyQ, 2), fetch = _useActionsQueryLazyQ2[0], _useActionsQueryLazyQ3 = _useActionsQueryLazyQ2[1], loading = _useActionsQueryLazyQ3.loading, data = _useActionsQueryLazyQ3.data;
    (0,react.useEffect)(function() {
        fetch();
    }, []);
    if (loading) return null;
    if (!(data !== null && data !== void 0 && data.user)) return null;
    var user = data === null || data === void 0 ? void 0 : data.user;
    var team = user.team;
    var teamMembership = (_user$teamMembership = user.teamMembership) !== null && _user$teamMembership !== void 0 ? _user$teamMembership : {
        isAdmin: false,
        memberType: ""
    };
    var _ref = (_user$package = user.package) !== null && _user$package !== void 0 ? _user$package : {}, isAnnual = _ref.isAnnual;
    // Non-SSO users requires sm.features.users.invite to access /team/add
    // SSO users requires sm.features.users.view_users to see modal with invitation link under /team/users
    var canAddUsers = (team === null || team === void 0 ? void 0 : team.ssoState) === "REQUIRED" ? (_user$permissions = user.permissions) === null || _user$permissions === void 0 ? void 0 : _user$permissions.includes(RbacPermissionType.UsersView) : (_user$permissions2 = user.permissions) === null || _user$permissions2 === void 0 ? void 0 : _user$permissions2.includes(RbacPermissionType.UsersInvite);
    var showSeatUpgradeButton = (user === null || user === void 0 ? void 0 : (_user$features = user.features) === null || _user$features === void 0 ? void 0 : _user$features.powerCasualEnabled) && teamMembership.memberType === "CASUAL";
    if (showSeatUpgradeButton) {
        return /*#__PURE__*/ react.createElement(ButtonSeatUpgrade, {
            __self: ButtonUser_this,
            __source: {
                fileName: ButtonUser_jsxFileName,
                lineNumber: 36,
                columnNumber: 12
            }
        });
    }
    if (canAddUsers) {
        return /*#__PURE__*/ react.createElement(actions_ButtonUsers, {
            __self: ButtonUser_this,
            __source: {
                fileName: ButtonUser_jsxFileName,
                lineNumber: 39,
                columnNumber: 12
            }
        });
    }
    if (!team && isAnnual) {
        return /*#__PURE__*/ react.createElement(actions_ButtonTeam, {
            __self: ButtonUser_this,
            __source: {
                fileName: ButtonUser_jsxFileName,
                lineNumber: 42,
                columnNumber: 12
            }
        });
    }
    if (!team) {
        return /*#__PURE__*/ react.createElement(actions_ButtonUpgrade, {
            __self: ButtonUser_this,
            __source: {
                fileName: ButtonUser_jsxFileName,
                lineNumber: 45,
                columnNumber: 12
            }
        });
    }
    return null;
};
/* harmony default export */ var actions_ButtonUser = (ButtonUser); //# sourceMappingURL=ButtonUser.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/theme/themes/mntv.js

var ElevateHeaderTheme = {
    background: {
        main: styles_dist_index_es/* ElevateTheme.palette.background.dark */.RK.palette.background.dark
    },
    text: {
        main: styles_dist_index_es/* ElevateTheme.palette.text.light */.RK.palette.text.light
    },
    height: 48,
    breakpoints: styles_dist_index_es/* ElevateTheme.breakpoints */.RK.breakpoints,
    palette: styles_dist_index_es/* ElevateTheme.palette */.RK.palette,
    radius: styles_dist_index_es/* ElevateTheme.radius */.RK.radius,
    spacing: styles_dist_index_es/* ElevateTheme.spacing */.RK.spacing,
    type: styles_dist_index_es/* ElevateTheme.type */.RK.type,
    shadow: styles_dist_index_es/* ElevateTheme.shadow */.RK.shadow
};

/* harmony default export */ var mntv = ((/* unused pure expression or super */ null && (ElevateHeaderTheme))); //# sourceMappingURL=mntv.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/theme/themes/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/theme/index.js
var _excluded = [
    "theme"
];
var theme_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/theme/index.tsx", theme_this = undefined;
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = theme_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function theme_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var HeaderThemeMapper = {
    elevate: ElevateHeaderTheme
};
var ThemeMapper = {
    elevate: styles_dist_index_es/* ElevateTheme */.RK
};
var ThemeContext = /*#__PURE__*/ (0,react.createContext)(ElevateHeaderTheme);
var theming = (0,theming_esm/* createTheming */.d5)(ThemeContext);
var HeaderThemeProvider = theming.ThemeProvider, useHeaderTheme = theming.useTheme;
var withHeaderTheme = function withHeaderTheme(Component) {
    return function(_ref) {
        var theme = _ref.theme, rest = _objectWithoutProperties(_ref, _excluded);
        return /*#__PURE__*/ react.createElement(theming_esm/* ThemeProvider */.f6, {
            theme: ThemeMapper.elevate,
            __self: theme_this,
            __source: {
                fileName: theme_jsxFileName,
                lineNumber: 37,
                columnNumber: 7
            }
        }, /*#__PURE__*/ react.createElement(HeaderThemeProvider, {
            theme: HeaderThemeMapper.elevate,
            __self: theme_this,
            __source: {
                fileName: theme_jsxFileName,
                lineNumber: 38,
                columnNumber: 9
            }
        }, /*#__PURE__*/ react.createElement(Component, Object.assign({}, rest, {
            __self: theme_this,
            __source: {
                fileName: theme_jsxFileName,
                lineNumber: 39,
                columnNumber: 11
            }
        }))));
    };
};
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/nav-button/useStyles.js

var useNavButtonStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var palette = _ref.palette, spacing = _ref.spacing, type = _ref.type;
    return {
        navButton: function navButton(_ref2) {
            var active = _ref2.active;
            return {
                boxSizing: "border-box",
                fontWeight: type.fontWeight.medium,
                fontFamily: type.fontFamily.base,
                fontSize: type.fontSize.bodySm,
                "-webkit-font-smoothing": "antialiased",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                position: "relative",
                borderRadius: 0,
                border: "none",
                boxShadow: "none",
                background: "none",
                textDecoration: "none",
                color: palette.text.light,
                borderBottom: active ? "solid 4px #fff" : "solid 4px transparent",
                borderTop: "solid 4px transparent",
                margin: [
                    0,
                    spacing[4]
                ],
                padding: 0,
                height: 48,
                "&:hover, &:focus": {
                    borderBottom: "solid 4px #fff",
                    textDecoration: "none"
                }
            };
        }
    };
});
/* harmony default export */ var nav_button_useStyles = (useNavButtonStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/nav-button/NavButton.js
var NavButton_excluded = [
    "children",
    "active",
    "href",
    "label",
    "onClick"
];
var NavButton_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/nav-button/NavButton.tsx", NavButton_this = undefined;
function NavButton_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = NavButton_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function NavButton_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var NavButton = function NavButton(_ref) {
    var children = _ref.children, _ref$active = _ref.active, active = _ref$active === void 0 ? false : _ref$active, _ref$href = _ref.href, href = _ref$href === void 0 ? undefined : _ref$href, label = _ref.label, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function onClick() {} : _ref$onClick, rest = NavButton_objectWithoutProperties(_ref, NavButton_excluded);
    var theme = useHeaderTheme();
    var classes = nav_button_useStyles({
        active: active,
        theme: theme
    });
    var button = /*#__PURE__*/ react.createElement("button", Object.assign({
        type: "button",
        "aria-label": label,
        className: classes.navButton,
        onClick: onClick
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        __self: NavButton_this,
        __source: {
            fileName: NavButton_jsxFileName,
            lineNumber: 28,
            columnNumber: 5
        }
    }), children);
    var link = /*#__PURE__*/ react.createElement("a", Object.assign({
        href: href,
        className: classes.navButton,
        title: label
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        __self: NavButton_this,
        __source: {
            fileName: NavButton_jsxFileName,
            lineNumber: 40,
            columnNumber: 5
        }
    }), children);
    return href ? link : button;
};
/* harmony default export */ var nav_button_NavButton = ((/* unused pure expression or super */ null && (NavButton)));
 //# sourceMappingURL=NavButton.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/nav-button/MainNavButton.js
var MainNavButton_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/nav-button/MainNavButton.tsx", MainNavButton_this = undefined;







var MainNavButton = function MainNavButton(_ref) {
    var children = _ref.children, href = _ref.href, label = _ref.label, active = _ref.active, navItem = _ref.navItem;
    var url = href && (0,dist.createURL)(href, {
        ut_source: "header"
    });
    var _getClientEnvironment = (0,dist.getClientEnvironmentDetails)(), isNode = _getClientEnvironment.isNode;
    var currentPath = !isNode ? document.location.pathname : "";
    var pattern = new RegExp("^".concat(currentPath, "/?$"));
    var match = href ? pattern.test(href) : false;
    var isActive = active || match;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var metricsData = (0,metrics_dist.generateMetricsAttribute)({
        data: {
            url: pageURL,
            pageName: pageName,
            amplitudeEvent: "header clicked navigation",
            navItem: navItem
        }
    });
    return /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: MainNavButton_this,
        __source: {
            fileName: MainNavButton_jsxFileName,
            lineNumber: 42,
            columnNumber: 5
        }
    }, function(matches) {
        return matches ? /*#__PURE__*/ react.createElement("li", {
            __self: MainNavButton_this,
            __source: {
                fileName: MainNavButton_jsxFileName,
                lineNumber: 45,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(NavButton, {
            href: url,
            label: label,
            active: isActive,
            "data-sm-metrics": metricsData,
            __self: MainNavButton_this,
            __source: {
                fileName: MainNavButton_jsxFileName,
                lineNumber: 46,
                columnNumber: 13
            }
        }, children || label)) : /*#__PURE__*/ react.createElement(List.Item, {
            isNavigable: true,
            href: url,
            "data-sm-metrics": metricsData,
            __self: MainNavButton_this,
            __source: {
                fileName: MainNavButton_jsxFileName,
                lineNumber: 56,
                columnNumber: 11
            }
        }, children || label);
    });
};
/* harmony default export */ var nav_button_MainNavButton = ((/* unused pure expression or super */ null && (MainNavButton)));
 //# sourceMappingURL=MainNavButton.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/nav-button/index.js

 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Home.js
var Home_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Home.tsx", Home_this = undefined;



var Home_COPY = (0,intl_dist/* defineMessages */.vU)({
    HOME: {
        id: "Home.home",
        defaultMessage: "Home",
        description: "[Type: Label][Vis.: low] - Home button of nav bar"
    }
});
var Home = function Home() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/home/",
        label: (0,intl_dist.t)(Home_COPY.HOME),
        navItem: "home",
        __self: Home_this,
        __source: {
            fileName: Home_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Home = ((/* unused pure expression or super */ null && (Home)));
 //# sourceMappingURL=Home.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Dashboard.js
var Dashboard_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Dashboard.tsx", Dashboard_this = undefined;



var Dashboard_COPY = (0,intl_dist/* defineMessages */.vU)({
    DASHBOARD: {
        id: "Dashboard.dashboard",
        defaultMessage: "Dashboard",
        description: "[Type: Label][Vis.: low] - Dashboards section of nav bar"
    }
});
var Dashboard = function Dashboard() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/dashboard/",
        label: (0,intl_dist.t)(Dashboard_COPY.DASHBOARD),
        navItem: "dashboard",
        __self: Dashboard_this,
        __source: {
            fileName: Dashboard_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Dashboard = ((/* unused pure expression or super */ null && (Dashboard)));
 //# sourceMappingURL=Dashboard.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/MySurveys.js
var MySurveys_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/MySurveys.tsx", MySurveys_this = undefined;



var MySurveys_COPY = (0,intl_dist/* defineMessages */.vU)({
    MY_SURVEYS: {
        id: "MySurveys.mySurveys",
        defaultMessage: "My Surveys",
        description: "[Type: Label][Vis.: low] - My surveys section of nav bar"
    }
});
var MySurveys = function MySurveys() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/surveys/",
        label: (0,intl_dist.t)(MySurveys_COPY.MY_SURVEYS),
        navItem: "my surveys",
        __self: MySurveys_this,
        __source: {
            fileName: MySurveys_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_MySurveys = ((/* unused pure expression or super */ null && (MySurveys)));
 //# sourceMappingURL=MySurveys.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Pricing.js
var Pricing_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Pricing.tsx", Pricing_this = undefined;



var Pricing_COPY = (0,intl_dist/* defineMessages */.vU)({
    PLANS_AND_PRICING: {
        id: "Pricing.plansAndPricing",
        defaultMessage: "Plans & Pricing",
        description: "[Type: Label][Vis.: low] - Plans & Pricing section of nav bar"
    }
});
var Pricing = function Pricing() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/pricing/upgrade/quickview/",
        label: (0,intl_dist.t)(Pricing_COPY.PLANS_AND_PRICING),
        navItem: "plans and pricing",
        __self: Pricing_this,
        __source: {
            fileName: Pricing_jsxFileName,
            lineNumber: 15,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Pricing = ((/* unused pure expression or super */ null && (Pricing)));
 //# sourceMappingURL=Pricing.js.map

// EXTERNAL MODULE: ./node_modules/@wds/accordion/node_modules/@wds/utils/dist/index.es.js
var _wds_utils_dist_index_es = __webpack_require__(8530);
;// CONCATENATED MODULE: ./node_modules/@wds/accordion/node_modules/@wds/box/dist/index.es.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var box_dist_index_es_assign = function() {
    box_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return box_dist_index_es_assign.apply(this, arguments);
};

function box_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var box_dist_index_es_useStyles = (0,_wds_utils_dist_index_es/* createMemoStyles */.Im)(function (_a) {
    var spacing = _a.spacing, border = _a.border;
    return ({
        wrenchBox: function (_a) {
            var _b, _c;
            var display = _a.display, flexProperties = _a.flexProperties, gridProperties = _a.gridProperties, borderColor = _a.borderColor;
            var gap = gridProperties.gap, gridStyleProperties = box_dist_index_es_rest(gridProperties, ["gap"]);
            var _d = flexProperties.flexItemGrow, flexItemGrow = _d === void 0 ? undefined : _d, _e = flexProperties.flexWrap, flexWrap = _e === void 0 ? undefined : _e, flexStyleProperties = box_dist_index_es_rest(flexProperties, ["flexItemGrow", "flexWrap"]);
            return (0,_wds_utils_dist_index_es/* removeUndefinedProperties */.jB)(box_dist_index_es_assign(box_dist_index_es_assign(box_dist_index_es_assign({}, gridStyleProperties), flexStyleProperties), { justifyContent: (_b = gridStyleProperties.justifyContent) !== null && _b !== void 0 ? _b : flexStyleProperties.justifyContent, alignItems: (_c = gridStyleProperties.alignItems) !== null && _c !== void 0 ? _c : flexStyleProperties.alignItems, flexGrow: flexItemGrow && 1, flexWrap: flexWrap && 'wrap', display: display !== null && display !== void 0 ? display : null, gap: gap ? spacing[gap] : null, border: borderColor && border[borderColor] }));
        },
    });
});

/**
 * [IMPORTANT]
 * We have to call createSpacingStyles at the component level
 * Otherwise, the styles will be overridden by the global styles
 * This happens because JSS loads the styles in sequence
 */
var useSpacingStyles = (0,_wds_utils_dist_index_es/* createSpacingStyles */.js)();
var index_es_Box = function (props) {
    var containerRef = props.containerRef, borderColor = props.borderColor, className = props.className, children = props.children, _a = props.element, element = _a === void 0 ? 'div' : _a, display = props.display, alignItems = props.alignItems, justifyContent = props.justifyContent, flexDirection = props.flexDirection, flexItemGrow = props.flexItemGrow, flexJustify = props.flexJustify, flexAlign = props.flexAlign, flexWrap = props.flexWrap, gridTemplateColumns = props.gridTemplateColumns, gridTemplateRows = props.gridTemplateRows, gridAutoFlow = props.gridAutoFlow, placeItems = props.placeItems, gap = props.gap, m = props.m, mx = props.mx, my = props.my, mt = props.mt, mb = props.mb, ml = props.ml, mr = props.mr, p = props.p, px = props.px, py = props.py, pt = props.pt, pb = props.pb, pl = props.pl, pr = props.pr, rest = box_dist_index_es_rest(props, ["containerRef", "borderColor", "className", "children", "element", "display", "alignItems", "justifyContent", "flexDirection", "flexItemGrow", "flexJustify", "flexAlign", "flexWrap", "gridTemplateColumns", "gridTemplateRows", "gridAutoFlow", "placeItems", "gap", "m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr"]);
    var flexProperties = {
        alignItems: alignItems !== null && alignItems !== void 0 ? alignItems : flexAlign,
        justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : flexJustify,
        flexDirection: flexDirection,
        flexItemGrow: flexItemGrow,
        flexWrap: flexWrap,
    };
    var gridProperties = {
        justifyContent: justifyContent,
        alignItems: alignItems,
        gridTemplateColumns: gridTemplateColumns,
        gridTemplateRows: gridTemplateRows,
        gridAutoFlow: gridAutoFlow,
        placeItems: placeItems,
        gap: gap,
    };
    var wrenchSpacing = useSpacingStyles({
        m: m,
        mx: mx,
        my: my,
        mt: mt,
        mb: mb,
        ml: ml,
        mr: mr,
        p: p,
        px: px,
        py: py,
        pt: pt,
        pb: pb,
        pl: pl,
        pr: pr,
    }).wrenchSpacing;
    var wrenchBox = box_dist_index_es_useStyles({
        flexProperties: flexProperties,
        gridProperties: gridProperties,
        display: display,
        borderColor: borderColor,
    }).wrenchBox;
    // TODO: remove this type coercion when upgrading to React v18
    var Element = element;
    var classNames = (0,_wds_utils_dist_index_es/* clsx */.Wy)(className, wrenchBox, wrenchSpacing);
    return (react.createElement(Element, box_dist_index_es_assign({ className: classNames, ref: containerRef }, rest), children));
};
index_es_Box.defaultProps = {
    element: 'div',
    containerRef: undefined,
    display: undefined,
    children: null,
    className: undefined,
};



;// CONCATENATED MODULE: ./node_modules/@wds/accordion/node_modules/@wds/list/dist/index.es.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _wds_list_dist_index_es_assign = function() {
    _wds_list_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return _wds_list_dist_index_es_assign.apply(this, arguments);
};

function _wds_list_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/** Resolves the correct color */
var index_es_getMarkedColor = function (color, palette) {
    if (!color || typeof color !== 'string') {
        return palette.primary.main;
    }
    if (color.startsWith('data-')) {
        return palette.data[color.replace('data-', '')];
    }
    return palette[color].main;
};
var dist_index_es_useStyles$1 = (0,_wds_utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette, border = theme.border, spacing = theme.spacing, motion = theme.motion, type = theme.type;
    var list = {
        addonIconColor: palette.background.dark,
        affordanceIconColor: palette.secondary.main,
        itemHeight: 48,
        itemMinHeight: 48,
        itemDenseMinHeight: 40,
        labelFontSize: type.fontSize.bodySm,
        markWidth: 4,
    };
    var listStyles = {
        wrenchListRow: {
            borderBottom: border.main,
            '&:last-child': {
                borderBottom: 'none',
            },
            'a&': {
                color: palette.text.dark,
                '&:hover, &:focus': {
                    textDecoration: 'none',
                },
            },
        },
        wrenchListItem: function (_a) {
            var accordion = _a.accordion, color = _a.color, marked = _a.marked, menu = _a.menu, disabled = _a.disabled, upgrade = _a.upgrade, interactive = _a.interactive, isFocused = _a.isFocused, transparent = _a.transparent;
            return (_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign({}, _wds_utils_dist_index_es/* defaultBaseline */.yD), (0,_wds_utils_dist_index_es/* defaultFonts */.FZ)(theme)), { fontWeight: menu ? type.fontWeight.regular : type.fontWeight.medium, display: 'flex', background: palette.background.light, position: 'relative', justifyContent: 'space-between', alignItems: 'center', minHeight: list.itemMinHeight, 'a&': {
                    textDecoration: 'none',
                } }), (accordion && {
                '&:hover, &:focus, &:active': {
                    cursor: 'pointer',
                },
            })), (transparent
                ? {
                    background: 'none',
                }
                : undefined)), { 
                // same specificity as parent List rules
                '[class^="wrenchList-"] &': _wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign({}, (interactive && _wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign({ transition: 'background 180ms linear' }, (isFocused && {
                    transition: 'background 125ms linear',
                    background: palette.background.accent,
                    cursor: 'pointer',
                })), { '&:hover, &:focus': {
                        transition: 'background 125ms linear',
                        background: palette.background.accent,
                        cursor: 'pointer',
                    }, '&:active': {
                        transition: 'background 125ms linear',
                        background: (0,_wds_utils_dist_index_es/* darken */._j)(0.05, palette.background.accent),
                    } }))), (upgrade && {
                    background: (0,_wds_utils_dist_index_es/* lighten */.$n)(0.42, palette.upgrade.main), // same specificity as transparent List rule
                })), (upgrade &&
                    interactive && {
                    '&:hover, &:focus': {
                        background: (0,_wds_utils_dist_index_es/* lighten */.$n)(0.35, palette.upgrade.main), // same specificity as transparent List rule
                    },
                })), (disabled && {
                    opacity: 0.5,
                    pointerEvents: 'none',
                })), { '&:before': _wds_list_dist_index_es_assign({}, ((color || marked) && {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: list.markWidth,
                        background: index_es_getMarkedColor(color, palette),
                    })) }) }));
        },
        wrenchListAddon: function () { return ({
            padding: [0, spacing[4], 0, spacing[5]],
            color: list.addonIconColor,
            display: 'flex',
            alignItems: 'center',
            '> [class^="wrenchIcons-"]': {
                marginLeft: spacing[2],
            },
        }); },
        /** Additional styles when addon is on the right */
        wrenchListAddonOnRight: function () { return ({
            paddingLeft: 0,
            paddingRight: spacing[6],
            color: palette.text.lightMuted,
        }); },
        wrenchListAffordance: function (_a) {
            var addOnLeft = _a.addOnLeft;
            return (_wds_list_dist_index_es_assign({ padding: [0, spacing[6], 0, 0], color: list.affordanceIconColor, display: 'flex', alignItems: 'center', '& > *': {
                    transition: "transform 150ms ".concat(motion.curve.ease),
                } }, (addOnLeft && { paddingLeft: 0 })));
        },
        wrenchListLabel: function (_a) {
            var addOnLeft = _a.addOnLeft;
            return (_wds_list_dist_index_es_assign({ flexGrow: 1, padding: [0, spacing[5]], fontSize: list.labelFontSize, lineHeight: 1.25, minWidth: 0, 'a &': {
                    color: palette.text.dark,
                } }, (addOnLeft && { paddingLeft: 0 })));
        },
        wrenchPaneHide: function (_a) {
            var expanded = _a.expanded;
            return (expanded ? null : _wds_utils_dist_index_es/* visuallyHidden */.jy);
        },
    };
    return listStyles;
});

var index_es_ListItem = (0,react.forwardRef)(function (_a, ref) {
    var addOnLeft = _a.addOnLeft, addOnRight = _a.addOnRight, affordance = _a.affordance, children = _a.children, color = _a.color, component = _a.component, disabled = _a.disabled, id = _a.id, index = _a.index, isFocused = _a.isFocused, interactive = _a.interactive, marked = _a.marked, menu = _a.menu, navigationTarget = _a.navigationTarget, onClick = _a.onClick, upgrade = _a.upgrade, isNavigable = _a.isNavigable, transparent = _a.transparent, other = _wds_list_dist_index_es_rest(_a, ["addOnLeft", "addOnRight", "affordance", "children", "color", "component", "disabled", "id", "index", "isFocused", "interactive", "marked", "menu", "navigationTarget", "onClick", "upgrade", "isNavigable", "transparent"]);
    // no reason to expose these in props
    var accordion = other.accordion, expanded = other.expanded, paneComponent = other.paneComponent, rest = _wds_list_dist_index_es_rest(other, ["accordion", "expanded", "paneComponent"]);
    var _b = dist_index_es_useStyles$1({
        accordion: accordion,
        color: color,
        marked: marked,
        menu: menu,
        disabled: disabled,
        upgrade: upgrade,
        isFocused: isFocused,
        interactive: interactive,
        addOnLeft: addOnLeft,
        expanded: expanded,
        transparent: transparent,
    }), wrenchListRow = _b.wrenchListRow, wrenchListItem = _b.wrenchListItem, wrenchListLabel = _b.wrenchListLabel, wrenchListAddon = _b.wrenchListAddon, wrenchListAddonOnRight = _b.wrenchListAddonOnRight, wrenchListAffordance = _b.wrenchListAffordance;
    var addOnClassNames = (0,_wds_utils_dist_index_es/* clsx */.Wy)(wrenchListAddon, wrenchListAddonOnRight);
    var href = isNavigable ? navigationTarget : undefined;
    var ListItemWrapper = (isNavigable
        ? component !== null && component !== void 0 ? component : 'a'
        : 'div');
    var interactiveProps = interactive
        ? { tabIndex: disabled ? '-1' : 0, role: 'button' }
        : {};
    var onHandleKeyDown = function (e) {
        if (onClick && (e.key === _wds_utils_dist_index_es/* KEYS.ENTER */.tW.ENTER || e.key === _wds_utils_dist_index_es/* KEYS.SPACE */.tW.SPACE)) {
            onClick(e);
        }
    };
    return (react.createElement("li", { className: wrenchListRow },
        react.createElement(ListItemWrapper, _wds_list_dist_index_es_assign({ disabled: disabled, className: wrenchListItem, onClick: function (e) { return onClick === null || onClick === void 0 ? void 0 : onClick(e); }, onKeyDown: onHandleKeyDown, href: href, id: id, "data-index": index, ref: ref }, interactiveProps, (0,_wds_utils_dist_index_es/* safeRest */.Q6)(rest)),
            addOnLeft && react.createElement("div", { className: wrenchListAddon }, addOnLeft),
            react.createElement("span", { className: wrenchListLabel }, children),
            addOnRight && react.createElement("div", { className: addOnClassNames }, addOnRight),
            affordance && (react.createElement("span", { className: wrenchListAffordance }, affordance))),
        typeof expanded !== 'undefined' && paneComponent));
});
index_es_ListItem.defaultProps = {
    accordion: false,
    addOnLeft: undefined,
    addOnRight: undefined,
    affordance: undefined,
    children: undefined,
    color: undefined,
    component: undefined,
    disabled: false,
    id: undefined,
    index: undefined,
    interactive: false,
    isFocused: false,
    isNavigable: false,
    marked: false,
    menu: false,
    // eslint-disable-next-line no-script-url
    navigationTarget: 'javascript:void(0)',
    onClick: undefined,
    upgrade: false,
};
// The displayName is needed for component's Accordion and perhaps other consumers in the future
// https://reactjs.org/docs/forwarding-refs.html#displaying-a-custom-name-in-devtools
index_es_ListItem.displayName = 'ListItem';

var _wds_list_dist_index_es_useStyles = (0,_wds_utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var spacing = theme.spacing, type = theme.type;
    var list = {
        itemDenseMinHeight: 40,
    };
    var listStyles = {
        wrenchList: function (_a) {
            var dense = _a.dense, noRules = _a.noRules;
            return (_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign(_wds_list_dist_index_es_assign({}, _wds_utils_dist_index_es/* defaultBaseline */.yD), { display: 'block' }), (dense && {
                '& [class^="wrenchListAddon-"]': {
                    paddingLeft: spacing[4],
                    '& [class^="wrenchIcons-"]': { paddingLeft: 0 },
                },
                // second className so it needs `*- not ^=` selector
                '& [class*="wrenchListAddonOnRight-"]': {
                    paddingRight: spacing[4],
                },
                '& [class^="wrenchListLabel-"]': {
                    fontWeight: type.fontWeight.regular,
                    margin: [spacing[3] + 1, 0],
                },
                '& [class^="wrenchListItem-"]': {
                    minHeight: list.itemDenseMinHeight,
                    borderBottom: 'none',
                },
            })), (noRules && {
                '& [class^="wrenchListRow-"]': {
                    borderBottom: 'none',
                },
            })));
        },
    };
    return listStyles;
});

var index_es_List = (0,react.forwardRef)(function (_a, ref) {
    var dense = _a.dense, interactive = _a.interactive, noRules = _a.noRules, transparent = _a.transparent, children = _a.children, role = _a.role, id = _a.id;
    var wrenchList = _wds_list_dist_index_es_useStyles({
        dense: dense,
        interactive: interactive,
        noRules: noRules,
        transparent: transparent,
    }).wrenchList;
    var newChildren = react.Children.map(children, function (child, index) {
        // Case wherte we have to allow transparent only for clone element?
        return react.isValidElement(child) &&
            react.cloneElement(child, { interactive: interactive, index: index, transparent: transparent });
    });
    return (react.createElement("ul", { ref: ref, className: wrenchList, role: role, id: id }, newChildren));
});
index_es_List.defaultProps = {
    dense: false,
    id: undefined,
    interactive: false,
    noRules: false,
    role: undefined,
    transparent: false,
};
index_es_List.displayName = 'List';
index_es_List.Item = index_es_ListItem;



// EXTERNAL MODULE: ./node_modules/@wds/accordion/node_modules/@wds/icons/dist/index.es.js
var _wds_icons_dist_index_es = __webpack_require__(4275);
// EXTERNAL MODULE: ./node_modules/@wds/accordion/node_modules/@wds/styles/dist/index.es.js
var _wds_styles_dist_index_es = __webpack_require__(1833);
;// CONCATENATED MODULE: ./node_modules/@wds/accordion/node_modules/@wds/typography/dist/index.es.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var typography_dist_index_es_assign = function() {
    typography_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return typography_dist_index_es_assign.apply(this, arguments);
};

function typography_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function index_es_spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var isNotLink = function (t) {
    return t !== 'link';
};
var hasFontWeight = function (t) {
    return typeof t.fontWeight === 'string' || typeof t.fontWeight === 'number';
};
var typography_dist_index_es_useStyles = (0,_wds_utils_dist_index_es/* createMemoStyles */.Im)(function (_a) {
    var _b = _a.type, fontFamily = _b.fontFamily, fontSize = _b.fontSize, fontWeight = _b.fontWeight, palette = _a.palette;
    return {
        wrenchTypography: function (_a) {
            var align = _a.align, color = _a.color, variant = _a.variant, component = _a.component, weight = _a.weight;
            var chosenColor = (0,_wds_styles_dist_index_es/* getColor */.Lq)(palette, color, {
                fallback: palette.text.dark,
            });
            var variantStyle = {};
            if (variant) {
                if (isNotLink(variant)) {
                    variantStyle = {
                        fontSize: fontSize[variant],
                        fontWeight: {
                            hero1: fontWeight.light,
                            hero2: fontWeight.light,
                            title: fontWeight.light,
                            sectionTitle: fontWeight.light,
                            sectionTitleSm: fontWeight.light,
                            pageTitle: fontWeight.light,
                            cardTitle: fontWeight.regular,
                            body: fontWeight.regular,
                            bodySm: fontWeight.regular,
                            caption: fontWeight.regular,
                        }[variant],
                    };
                }
                else {
                    variantStyle = {
                        color: palette.link.main,
                        textDecoration: 'none',
                        border: 'none',
                        background: 'none',
                        outline: 'none',
                        cursor: 'pointer',
                        fontWeight: 'inherit',
                        fontSize: 'inherit',
                        '&:hover, &:focus': {
                            textDecoration: 'underline',
                        },
                    };
                }
            }
            var computedWeight = 'inherit';
            if (weight) {
                computedWeight = fontWeight[weight];
            }
            else if (component === 'strong') {
                computedWeight = fontWeight.medium;
            }
            else if (hasFontWeight(variantStyle)) {
                computedWeight = variantStyle.fontWeight;
            }
            return typography_dist_index_es_assign(typography_dist_index_es_assign(typography_dist_index_es_assign({ fontFamily: fontFamily.base, fontSize: fontSize.body, boxSizing: 'border-box', '-webkit-font-smoothing': 'antialiased', color: chosenColor, textAlign: align, lineHeight: 1.5, margin: 0, padding: 0 }, variantStyle), (variant &&
                (variant === 'hero1' || variant === 'hero2') && {
                fontFamily: fontFamily === null || fontFamily === void 0 ? void 0 : fontFamily.headings,
            })), { fontWeight: computedWeight, '& > strong': {
                    fontWeight: fontWeight.medium,
                } });
        },
    };
});

var index_es_Typography = (0,react.forwardRef)(function (_a, ref) {
    var _b = _a.align, align = _b === void 0 ? 'left' : _b, _c = _a.color, color = _c === void 0 ? 'dark' : _c, _d = _a.component, component = _d === void 0 ? 'div' : _d, _e = _a.variant, variant = _e === void 0 ? 'body' : _e, weight = _a.weight, children = _a.children, rest = typography_dist_index_es_rest(_a, ["align", "color", "component", "variant", "weight", "children"]);
    var wrenchTypography = typography_dist_index_es_useStyles({
        align: align,
        color: color,
        variant: variant,
        component: component,
        weight: weight,
    }).wrenchTypography;
    var Component = component;
    return (react.createElement(Component, typography_dist_index_es_assign({ className: wrenchTypography }, (0,_wds_utils_dist_index_es/* safeRest */.Q6)(rest), { ref: ref }), children));
});

var ALIGNMENTS = (/* unused pure expression or super */ null && (['center', 'left', 'right']));
var VARIANTS = index_es_spreadArray(index_es_spreadArray([], _wds_styles_dist_index_es/* FONT_SIZES */.um, true), ['link'], false);
var TYPOGRAPHY_COLORS = index_es_spreadArray(index_es_spreadArray(index_es_spreadArray([], _wds_styles_dist_index_es/* SEMANTIC_COLORS */.kg, true), _wds_styles_dist_index_es/* LINK_COLORS */.u5, true), _wds_styles_dist_index_es/* TYPE_COLORS */.nk, true);
var COMPONENTS = (/* unused pure expression or super */ null && ([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'a',
    'p',
    'span',
    'div',
    'article',
    'section',
    'em',
    'strong',
]));



;// CONCATENATED MODULE: ./node_modules/@wds/accordion/dist/index.es.js








/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var accordion_dist_index_es_assign = function() {
    accordion_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return accordion_dist_index_es_assign.apply(this, arguments);
};

function accordion_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var AccordionItem = (0,react.forwardRef)(function (_a, ref) {
    var addOnLeft = _a.addOnLeft, addOnRight = _a.addOnRight, affordance = _a.affordance, ariaControls = _a.ariaControls, onKeyDown = _a.onKeyDown, children = _a.children, color = _a.color, disabled = _a.disabled, expanded = _a.expanded, id = _a.id, interactive = _a.interactive, marked = _a.marked, onClick = _a.onClick, paneComponent = _a.paneComponent, upgrade = _a.upgrade;
    var tabIndex = disabled ? '-1' : 0;
    return (react.createElement(index_es_List.Item, { accordion: true, addOnLeft: addOnLeft, addOnRight: addOnRight, affordance: affordance, "aria-controls": ariaControls, onKeyDown: onKeyDown, color: color, disabled: disabled, expanded: expanded, id: id, interactive: interactive, marked: marked, onClick: onClick, paneComponent: paneComponent, role: "button", upgrade: upgrade, tabIndex: tabIndex, ref: ref }, children));
});
AccordionItem.defaultProps = {
    addOnLeft: undefined,
    addOnRight: undefined,
    affordance: undefined,
    ariaControls: undefined,
    onKeyDown: undefined,
    children: undefined,
    color: undefined,
    disabled: false,
    expanded: false,
    id: undefined,
    interactive: false,
    marked: false,
    onClick: undefined,
    paneComponent: undefined,
    upgrade: false,
    subtitle: undefined,
    titleSize: 'md',
};
AccordionItem.displayName = 'AccordionItem';

var Accordion = function (_a) {
    var multiple = _a.multiple, interactive = _a.interactive, noRules = _a.noRules, dense = _a.dense, transparent = _a.transparent, onChange = _a.onChange, id = _a.id, children = _a.children, rest = accordion_dist_index_es_rest(_a, ["multiple", "interactive", "noRules", "dense", "transparent", "onChange", "id", "children"]);
    var _b = (0,react.useState)(react.Children.map(children, function (child, index) {
        return (0,react.isValidElement)(child) && child.props.expanded ? index : null;
    }).filter(function (val) { return val !== null; })), activeItems = _b[0], setActiveItems = _b[1];
    var prevActiveItems = (0,_wds_utils_dist_index_es/* usePreviousState */.rc)(activeItems);
    var activeItemsHasChanged = prevActiveItems !== activeItems;
    var accListRef = (0,react.useRef)(null);
    var uniqueAccName = (0,react.useMemo)(function () { return (0,_wds_utils_dist_index_es/* uniqueId */.EL)('wrench-acc-'); }, []);
    var uniqueAccPaneName = (0,react.useMemo)(function () { return (0,_wds_utils_dist_index_es/* uniqueId */.EL)('wrench-accPane-'); }, []);
    /**
     * @param {number} ind
     * @return {void}
     */
    var handleOnChange = function (evt, index) {
        // Since dom node is a div, we can't check the disabled property
        if (evt.currentTarget !== null && evt.currentTarget.tabIndex > -1) {
            var newActiveItems = [];
            if (!multiple) {
                newActiveItems = activeItems[0] === index ? [] : [index];
            }
            else if (activeItems.includes(index)) {
                newActiveItems = activeItems.filter(function (item) { return item !== index; });
            }
            else {
                newActiveItems = activeItems.concat(index);
            }
            setActiveItems(newActiveItems);
            if (onChange) {
                var currentTargetIndex = newActiveItems[newActiveItems.length - 1];
                onChange(activeItems, currentTargetIndex);
            }
        }
    };
    /**
   * Accordion according to Accordion Design Pattern in WAI-ARIA Authoring Practices 1.1
   * see https://www.w3.org/TR/wai-aria-practices/examples/accordion/accordion.html
   *
   * Keyboard Support:
   *
  ```
  Space or Enter
    When focus is on the accordion header of a collapsed section, expands the section.
  Tab
    Moves focus to the next focusable element.
    All focusable elements in the accordion are included in the page Tab sequence.
  Shift + Tab
    Moves focus to the previous focusable element.
    All focusable elements in the accordion are included in the page Tab sequence.
  Down Arrow
    When focus is on an accordion header, moves focus to the next accordion header.
    When focus is on last accordion header, moves focus to first accordion header.
  Up Arrow
    When focus is on an accordion header, moves focus to the previous accordion header.
    When focus is on first accordion header, moves focus to last accordion header.
  Home
    When focus is on an accordion header, moves focus to the first accordion header.
  End
    When focus is on an accordion header, moves focus to the last accordion header.
  ```
   */
    var handleKeyDown = function (evt, ind) {
        if (evt.key === _wds_utils_dist_index_es/* KEYS.SPACE */.tW.SPACE || evt.key === _wds_utils_dist_index_es/* KEYS.ENTER */.tW.ENTER) {
            evt.preventDefault();
            handleOnChange(evt, ind);
            return;
        }
        var accList = accListRef.current
            ? Array.from(accListRef.current.children).map(function (acc) {
                return acc.firstChild;
            })
            : [];
        var accListLen = accList.length - 1;
        var newFocusTarget = null;
        switch (evt.key) {
            case _wds_utils_dist_index_es/* KEYS.DOWN */.tW.DOWN:
                evt.preventDefault();
                newFocusTarget = ind < accListLen ? accList[ind + 1] : accList[0];
                break;
            case _wds_utils_dist_index_es/* KEYS.UP */.tW.UP:
                evt.preventDefault();
                newFocusTarget = ind === 0 ? accList[accListLen] : accList[ind - 1];
                break;
            case _wds_utils_dist_index_es/* KEYS.HOME */.tW.HOME:
                evt.preventDefault();
                newFocusTarget = accList[0];
                break;
            case _wds_utils_dist_index_es/* KEYS.END */.tW.END:
                evt.preventDefault();
                newFocusTarget = accList[accListLen];
                break;
        }
        // Guard Null Case
        if (newFocusTarget !== null) {
            newFocusTarget.focus();
        }
    };
    /**
     * @param {node} paneChildren
     * @param {string} labelledBy
     * @param {string} paneId
     * @return {node}
     */
    var renderPane = function (paneChildren, labelledBy, paneId, expanded) {
        var padding = true;
        if ((0,_wds_utils_dist_index_es/* getDisplayName */.Gf)(paneChildren) === 'List') {
            padding = false;
        }
        var paneProps = {
            padding: padding,
            labelledBy: labelledBy,
            hide: !expanded,
            role: 'region',
            id: paneId,
        };
        return (react.createElement(internal_components_dist_index_es/* Pane */.X6, accordion_dist_index_es_assign({ transparent: true }, paneProps), paneChildren));
    };
    /**
     *
     * @param {node} child
     * @param {number} index
     * @param {boolean} expanded
     * @return {node}
     */
    var renderAccordionElement = function (child, index, expanded) {
        var _a, _b;
        var accordionName = (_a = child.props.id) !== null && _a !== void 0 ? _a : "".concat(uniqueAccName, "-").concat(index);
        var accordionPaneName = (_b = child.props.ariaControls) !== null && _b !== void 0 ? _b : "".concat(uniqueAccPaneName, "-").concat(index);
        var paneComponent = renderPane(child.props.children, accordionName, accordionPaneName, expanded);
        var titleVariant = child.props.titleSize === 'lg' ? 'cardTitle' : 'body';
        var childElements = (react.createElement(index_es_Box, { my: 4 },
            react.createElement(index_es_Box, { mb: 2 },
                react.createElement(index_es_Typography, { component: "strong", variant: titleVariant }, child.props.title)),
            child.props.subtitle && react.createElement(index_es_Typography, { variant: "bodySm", color: "secondary" }, child.props.subtitle)));
        return (0,react.cloneElement)(child, {
            children: childElements,
            expanded: expanded,
            key: accordionName,
            id: accordionName,
            // collapsed: !expanded,
            ariaControls: accordionPaneName,
            paneComponent: paneComponent,
            affordance: expanded ? (react.createElement(_wds_icons_dist_index_es/* IconChevronUp */.y_Q, { title: "Chevron Up" })) : (react.createElement(_wds_icons_dist_index_es/* IconChevronDown */.C26, { title: "Chevron Down" })),
            onClick: function (evt) { return handleOnChange(evt, index); },
            onKeyDown: function (evt) {
                return handleKeyDown(evt, index);
            },
            // multiple: multipleElement,
        });
    };
    var accordionList = react.Children.map(children, function (child, index) {
        var isExpandedItem = activeItems.includes(index);
        // check if a child prop changed and update state accordiongly
        var expandedProp = child ? child.props.expanded : null;
        var childExpandedChanged = isExpandedItem !== expandedProp;
        var onlyTheChildPropChanged = !activeItemsHasChanged && childExpandedChanged;
        if (onlyTheChildPropChanged) {
            setActiveItems(react.Children.map(children, function (c, i) {
                return (0,react.isValidElement)(c) && c.props.expanded ? i : null;
            }).filter(function (val) { return val !== null; }));
        }
        if (!(0,react.isValidElement)(child)) {
            return null;
        }
        return (0,_wds_utils_dist_index_es/* getDisplayName */.Gf)(child) === 'ListItem' ? child : renderAccordionElement(child, index, isExpandedItem);
    });
    return (react.createElement(index_es_List, accordion_dist_index_es_assign({ ref: accListRef, noRules: noRules, interactive: interactive, dense: dense, transparent: transparent, id: id }, (0,_wds_utils_dist_index_es/* safeRest */.Q6)(rest)), accordionList));
};
Accordion.defaultProps = {
    multiple: false,
    onChange: null,
    interactive: false,
    id: null,
    dense: false,
    transparent: false,
    noRules: false,
};
Accordion.Item = AccordionItem;



;// CONCATENATED MODULE: ./node_modules/@wds/menu/dist/index.es.js






/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var menu_dist_index_es_assign = function() {
    menu_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return menu_dist_index_es_assign.apply(this, arguments);
};

function menu_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var MenuItem = (0,react.forwardRef)(function (_a, ref) {
    var addOn = _a.addOn, _b = _a.addOnPlacement, addOnPlacement = _b === void 0 ? "left" : _b, color = _a.color, onClick = _a.onClick, children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.component, component = _d === void 0 ? undefined : _d, _e = _a.isNavigable, isNavigable = _e === void 0 ? false : _e; _a.isFocused; var _g = _a.marked, marked = _g === void 0 ? false : _g, _h = _a.upgrade, upgrade = _h === void 0 ? false : _h, groupindex = _a.groupindex, handleMenuClose = _a.handleMenuClose, index = _a.index, _j = _a.role, role = _j === void 0 ? 'menuitem' : _j, id = _a.id, rest = menu_dist_index_es_rest(_a, ["addOn", "addOnPlacement", "color", "onClick", "children", "disabled", "component", "isNavigable", "isFocused", "marked", "upgrade", "groupindex", "handleMenuClose", "index", "role", "id"]);
    var onHandleClick = function (e) {
        if (onClick)
            onClick(e);
        if (handleMenuClose)
            handleMenuClose(e);
        e.stopPropagation();
    };
    return (react.createElement(List.Item, menu_dist_index_es_assign({ addOnLeft: addOnPlacement === 'left' ? addOn : undefined, addOnRight: addOnPlacement === 'right' ? addOn : undefined, color: color, component: component, "data-group": groupindex, disabled: disabled, index: index, isNavigable: isNavigable, marked: marked, menu: true, interactive: true, onClick: onHandleClick, role: role, upgrade: upgrade, tabIndex: disabled ? -1 : 0, ref: ref, id: id }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)), children));
});
MenuItem.displayName = 'MenuItem';

var menu_dist_index_es_useStyles$1 = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var border = theme.border;
    return {
        wrenchMenuGroup: function () { return ({
            borderBottom: border.main,
        }); },
    };
});
var renderListItems = function (_a) {
    var children = _a.children, groupIndex = _a.groupIndex, onKeyDown = _a.onKeyDown, handleMenuClose = _a.handleMenuClose;
    var listItems = react.Children.map(children, function (child) {
        if (!react.isValidElement(child))
            return null;
        return (0,react.cloneElement)(child, {
            groupindex: groupIndex,
            handleMenuClose: handleMenuClose,
            onKeyDown: onKeyDown,
        });
    });
    return listItems;
};
var MenuGroup = function (_a) {
    var children = _a.children, title = _a.title, dense = _a.dense, groupIndex = _a.groupIndex, onKeyDown = _a.onKeyDown, handleMenuClose = _a.handleMenuClose, rest = menu_dist_index_es_rest(_a, ["children", "title", "dense", "groupIndex", "onKeyDown", "handleMenuClose"]);
    var classes = menu_dist_index_es_useStyles$1();
    return (react.createElement(List, menu_dist_index_es_assign({ interactive: true, noRules: true, dense: dense }, rest),
        title && react.createElement(List.Item, null, title),
        react.createElement("section", { className: classes.wrenchMenuGroup }, renderListItems({ children: children, groupIndex: groupIndex, onKeyDown: onKeyDown, handleMenuClose: handleMenuClose }))));
};
MenuGroup.displayName = 'MenuGroup';

var menu_dist_index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette, shadow = theme.shadow;
    var menu = {
        boxShadow: shadow.space,
        maxWidth: 300,
        minWidth: 175,
        maxHeight: 325,
    };
    return {
        wrenchMenuContainer: function (_a) {
            var stretched = _a.stretched;
            return (menu_dist_index_es_assign(menu_dist_index_es_assign({}, (0,utils_dist_index_es/* defaultFonts */.FZ)(theme)), { position: 'relative', display: stretched ? 'block' : 'inline-block', outline: 'none' }));
        },
        wrenchMenu: function (_a) {
            var menuStyle = _a.menuStyle, placement = _a.placement, stretched = _a.stretched, elevation = _a.elevation;
            return (menu_dist_index_es_assign(menu_dist_index_es_assign({ position: 'absolute', zIndex: elevation !== null && elevation !== void 0 ? elevation : theme.elevation.sky, display: 'block', outline: 'none', textAlign: 'left', color: palette.text.dark, minWidth: menu.minWidth, maxWidth: stretched ? 'none' : menu.maxWidth, boxShadow: menu.boxShadow, background: palette.background.light, whiteSpace: 'noWrap' }, (placement &&
                {
                    'bottom-left': {
                        left: 0,
                        top: '100%',
                    },
                    'bottom-right': {
                        left: 'auto',
                        right: 0,
                        top: '100%',
                    },
                    'top-left': {
                        left: 0,
                        top: 'auto',
                        bottom: '100%',
                    },
                    'top-right': {
                        left: 'auto',
                        right: 0,
                        top: 'auto',
                        bottom: '100%',
                    },
                }[placement])), menuStyle));
        },
        wrenchMenuBody: function (_a) {
            var noMaxHeight = _a.noMaxHeight;
            return ({
                maxHeight: noMaxHeight ? 'none' : menu.maxHeight,
                overflowY: 'auto',
            });
        },
    };
});

var FOCUS_STATES;
(function (FOCUS_STATES) {
    FOCUS_STATES["TOP"] = "top";
    FOCUS_STATES["BOTTOM"] = "bottom";
})(FOCUS_STATES || (FOCUS_STATES = {}));
var MENU_PLACEMENTS = (/* unused pure expression or super */ null && ([
    'bottom-right',
    'bottom-left',
    'top-right',
    'top-left',
]));

var index_es_Menu = function (_a) {
    var id = _a.id, autoClose = _a.autoClose, children = _a.children, dense = _a.dense, placement = _a.placement, menuTrigger = _a.menuTrigger, noMaxHeight = _a.noMaxHeight, onChange = _a.onChange, showProp = _a.show, stretched = _a.stretched, renderTo = _a.renderTo, role = _a.role, noRules = _a.noRules, elevation = _a.elevation, rest = menu_dist_index_es_rest(_a, ["id", "autoClose", "children", "dense", "placement", "menuTrigger", "noMaxHeight", "onChange", "show", "stretched", "renderTo", "role", "noRules", "elevation"]);
    // Refs
    var menuRef = (0,react.useRef)(null);
    var innerMenuRef = (0,react.useRef)(null);
    var itemsRef = (0,react.useRef)([]);
    // Menu State Items
    var _b = (0,react.useState)(showProp), showState = _b[0], setShowState = _b[1];
    var _c = (0,react.useState)({}), menuStyle = _c[0], setMenuStyle = _c[1];
    //
    var _d = (0,react.useState)(null), focusState = _d[0], setFocusState = _d[1];
    var _e = (0,react.useState)(-1), focusIndex = _e[0], setFocusIndex = _e[1];
    // aria-owns for a11y
    var menuID = (0,react.useMemo)(function () { return id !== null && id !== void 0 ? id : (0,utils_dist_index_es/* uniqueId */.EL)('wds-menu-'); }, [id]);
    // Styles
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var classes = menu_dist_index_es_useStyles({
        menuStyle: menuStyle,
        noMaxHeight: noMaxHeight,
        placement: placement,
        stretched: stretched,
        elevation: elevation,
    });
    /**
     * a way to help replicate componentWillReceiveProps
     * and componentDidUpdate
     */
    var prevPropsRef = (0,react.useRef)({});
    (0,react.useEffect)(function () {
        prevPropsRef.current = { showProp: showProp, showState: showState };
        /**
         * Each time the MenuItem List is generated through the menu button trigger
         * this code will create a list of accessible ListItems to traverse through.
         */
        if (showState && innerMenuRef.current) {
            itemsRef.current = ([].slice.call(innerMenuRef.current.getElementsByTagName('li'))).map(function (item) { return item.firstChild; }).filter(utils_dist_index_es/* notEmpty */.Dw);
        }
        /**
         * When showProp is still set to True, but showState is false,
         * we need sync showState up with showProp
         */
        if (showProp && showState !== showProp) {
            setShowState(showProp);
        }
    }, [showProp, showState, children]);
    var prevProps = prevPropsRef.current;
    // This will auto focus the first or last item
    (0,react.useEffect)(function () {
        var _a;
        if (focusState) {
            var focusInd = focusState === FOCUS_STATES.TOP ? 0 : itemsRef.current.length - 1;
            if (itemsRef.current[focusInd]) {
                (_a = itemsRef.current[focusInd]) === null || _a === void 0 ? void 0 : _a.focus();
            }
            setFocusIndex(focusInd);
        }
    }, [focusState]);
    /**
     * @todo needs Modal
     * Update the placement of the menu when renderTo is passed in.
     */
    var updatePosition = function () {
        var _a, _b;
        if (menuRef.current && showState && ((_b = (_a = innerMenuRef === null || innerMenuRef === void 0 ? void 0 : innerMenuRef.current) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length)) {
            var rect = menuRef.current.getBoundingClientRect();
            var innerRect = innerMenuRef.current.getBoundingClientRect();
            var plaementMap = {
                'top-left': {
                    top: rect.top - innerRect.height,
                    left: rect.left,
                },
                'top-right': {
                    top: rect.top - innerRect.height,
                    left: rect.right - innerRect.width,
                },
                'bottom-left': {
                    top: rect.bottom,
                    left: rect.left,
                },
                "bottom-right": {
                    top: rect.bottom,
                    left: rect.right - innerRect.width,
                }
            };
            var coordinates = plaementMap[placement !== null && placement !== void 0 ? placement : "bottom-right"];
            var top_1 = coordinates.top, left = coordinates.left;
            var z = (elevation !== null && elevation !== void 0 ? elevation : theme.elevation.space) + 1;
            setMenuStyle({
                top: top_1,
                left: left,
                zIndex: z,
                position: 'fixed',
                right: 'auto',
                bottom: 'auto', // fixes box-shadow not showing
            });
        }
    };
    var handleScroll = function () {
        if (showState && renderTo) {
            updatePosition();
        }
    };
    // componentDidMount
    (0,react.useEffect)(function () {
        if (showState && renderTo)
            updatePosition();
        // ssr doesn't have window object
        if (utils_dist_index_es/* isBrowser */.jU) {
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleScroll);
            window.addEventListener('orientationchange', handleScroll);
        }
        // componentWillUnmount
        return function () {
            if (utils_dist_index_es/* isBrowser */.jU) {
                window.removeEventListener('scroll', handleScroll);
                window.removeEventListener('resize', handleScroll);
                window.removeEventListener('orientationchange', handleScroll);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderTo, showState]);
    // componentDidUpdate
    (0,react.useEffect)(function () {
        if (prevProps) {
            if (!prevProps.showState && showProp && renderTo) {
                updatePosition();
            }
        }
    });
    // componentWillReceiveProps
    (0,react.useEffect)(function () {
        setShowState(showProp);
    }, [showProp]);
    var menuChange = function (showMenu) {
        if (!showMenu) {
            setFocusState(null);
            setFocusIndex(-1);
        }
        setShowState(showMenu);
        if (onChange) {
            onChange(showMenu);
        }
    };
    var handleOnClick = function (e) {
        menuChange(!showState);
        // e.stopPropagation();
    };
    var handleKeyScroll = function (index) {
        if (itemsRef.current) {
            if (index > -1 && itemsRef.current[index]) {
                var menuItemHeight = itemsRef.current[index].offsetTop +
                    itemsRef.current[index].offsetHeight;
                var menuContainerHeight = innerMenuRef.current.offsetHeight;
                innerMenuRef.current.scrollTop =
                    menuItemHeight <= menuContainerHeight
                        ? 0
                        : menuItemHeight - menuContainerHeight;
            }
        }
    };
    var handleOnKeyDown = function (e) {
        var key = e.key;
        if (showState) {
            var itemsLen = itemsRef.current.length - 1;
            var focusInd = focusIndex === -1 ? 0 : focusIndex;
            var newFocusIndex = 0;
            switch (key) {
                case utils_dist_index_es/* KEYS.TAB */.tW.TAB:
                case utils_dist_index_es/* KEYS.ESC */.tW.ESC:
                    menuChange(false);
                    if (menuRef.current.firstChild) {
                        menuRef.current.firstChild.focus();
                    }
                    e.preventDefault();
                    break;
                /**
                 * TODO: Needs to handle space in a better way
                 */
                case utils_dist_index_es/* KEYS.ENTER */.tW.ENTER:
                    itemsRef.current[focusInd].click();
                    break;
                case utils_dist_index_es/* KEYS.UP */.tW.UP:
                    newFocusIndex = focusInd > 0 ? focusInd - 1 : itemsLen;
                    break;
                case utils_dist_index_es/* KEYS.DOWN */.tW.DOWN:
                    newFocusIndex = focusInd === itemsLen ? 0 : focusInd + 1;
                    break;
            }
            if (key === utils_dist_index_es/* KEYS.UP */.tW.UP || key === utils_dist_index_es/* KEYS.DOWN */.tW.DOWN) {
                setFocusIndex(newFocusIndex);
                handleKeyScroll(newFocusIndex);
                if (newFocusIndex > -1 && itemsRef.current[newFocusIndex]) {
                    itemsRef.current[newFocusIndex].focus();
                    e.preventDefault();
                }
            }
        }
    };
    var handleOnTriggerKeyDown = function (e) {
        var key = e.key;
        if (react.isValidElement(menuTrigger) && (0,utils_dist_index_es/* conditionGuard */.U4)(menuTrigger.props, Object.prototype.hasOwnProperty.call(menuTrigger.props, "onKeyDown"))) {
            menuTrigger.props.onKeyDown(e);
        }
        var isNotInput = (0,utils_dist_index_es/* getDisplayName */.Gf)(menuTrigger) !== 'Input';
        if (isNotInput) {
            switch (key) {
                case utils_dist_index_es/* KEYS.ENTER */.tW.ENTER:
                case utils_dist_index_es/* KEYS.DOWN */.tW.DOWN:
                    // TODO: Find a better way to handle this type
                    handleOnClick();
                    setFocusState(FOCUS_STATES.TOP);
                    e.preventDefault();
                    break;
                case utils_dist_index_es/* KEYS.UP */.tW.UP:
                    // TODO: Find a better way to handle this type
                    handleOnClick();
                    setFocusState(FOCUS_STATES.BOTTOM);
                    e.preventDefault();
                    break;
            }
        }
    };
    var handleAutoCloseBlur = function () {
        setTimeout(function () {
            var _a;
            var renderToComp = null;
            if (renderTo) {
                if (renderTo && (0,utils_dist_index_es/* conditionGuard */.U4)(renderTo, (0,utils_dist_index_es/* isElement */.kK)(renderTo)))
                    renderToComp = renderTo;
                else if (renderTo.current)
                    renderToComp = renderTo.current;
            }
            var isFocusInRenderContainer = renderToComp === null || renderToComp === void 0 ? void 0 : renderToComp.contains(document.activeElement);
            var isFocusInMenuRef = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement);
            if (!isFocusInRenderContainer && !isFocusInMenuRef) {
                menuChange(false);
            }
        }, 0);
    };
    var handleMenuClose = function () {
        if (autoClose) {
            menuChange(false);
        }
    };
    var renderListItems = function (ch, groupindex, handleMenu) {
        var listItems = react.Children.map(ch, function (child) {
            if (!react.isValidElement(child))
                return null;
            return (0,react.cloneElement)(child, {
                groupindex: groupindex,
                // isFocused,
                onKeyDown: handleOnKeyDown,
                handleMenuClose: handleMenu,
            });
        });
        return listItems;
    };
    var renderMenuGroup = function (el, groupIndex, handleMenu) {
        return (0,react.cloneElement)(el, menu_dist_index_es_assign(menu_dist_index_es_assign({}, el.props), { groupIndex: groupIndex, dense: dense, onKeyDown: handleOnKeyDown, handleMenuClose: handleMenu }));
    };
    var renderList = function () {
        var _a;
        var items = (_a = react.Children.map(children, function (child, index) {
            if (!(0,react.isValidElement)(child))
                return undefined;
            if ((0,utils_dist_index_es/* getDisplayName */.Gf)(child) !== 'MenuGroup')
                return undefined;
            return renderMenuGroup(child, index, handleMenuClose);
        })) !== null && _a !== void 0 ? _a : [];
        if (items.length)
            return items;
        return (react.createElement(List, menu_dist_index_es_assign({ interactive: true, dense: dense, noRules: noRules }, rest), children && renderListItems(children, 0, handleMenuClose)));
    };
    var renderMenu = function () {
        var menuComponent = (react.createElement(motion_dist_index_es/* Fade */.pT, { in: showState, speed: "fast" },
            react.createElement("div", null,
                react.createElement("div", { className: classes.wrenchMenu, role: role, id: menuID },
                    react.createElement("div", { className: classes.wrenchMenuBody, ref: innerMenuRef }, renderList())))));
        return (0,utils_dist_index_es/* handlePortal */.FK)(menuComponent, renderTo);
    };
    var renderTrigger = function () {
        var componentName = (0,utils_dist_index_es/* getDisplayName */.Gf)(menuTrigger);
        var isButton = componentName === 'Button';
        var isInput = componentName === 'Input';
        return (0,react.cloneElement)(menuTrigger, menu_dist_index_es_assign(menu_dist_index_es_assign(menu_dist_index_es_assign({ 'aria-haspopup': role }, (showState && { 'aria-owns': menuID })), (isButton && { 'aria-pressed': (showState !== null && showState !== void 0 ? showState : false) || showProp })), { onFocus: isInput ? handleOnClick : undefined, onClick: !isInput ? handleOnClick : undefined, onKeyDown: handleOnTriggerKeyDown, tabIndex: 0 }));
    };
    return (react.createElement("span", menu_dist_index_es_assign({ className: classes.wrenchMenuContainer, onBlur: autoClose ? handleAutoCloseBlur : undefined, ref: menuRef, tabIndex: -1 }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)),
        renderTrigger(),
        renderMenu()));
};
index_es_Menu.defaultProps = {
    autoClose: true,
    dense: false,
    placement: undefined,
    noMaxHeight: false,
    onChange: undefined,
    stretched: false,
    show: false,
    renderTo: undefined,
    id: undefined,
    role: 'menu',
    noRules: false,
    elevation: undefined,
};
index_es_Menu.Item = MenuItem;
index_es_Menu.Group = MenuGroup;



;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/mobile-nav/SubMenuItem.js
var mobile_nav_SubMenuItem_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/mobile-nav/SubMenuItem.tsx", mobile_nav_SubMenuItem_this = undefined;
function SubMenuItem_slicedToArray(arr, i) {
    return SubMenuItem_arrayWithHoles(arr) || SubMenuItem_iterableToArrayLimit(arr, i) || SubMenuItem_unsupportedIterableToArray(arr, i) || SubMenuItem_nonIterableRest();
}
function SubMenuItem_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SubMenuItem_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SubMenuItem_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SubMenuItem_arrayLikeToArray(o, minLen);
}
function SubMenuItem_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function SubMenuItem_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function SubMenuItem_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}


var useDocument = function useDocument() {
    var _useState = (0,react.useState)(null), _useState2 = SubMenuItem_slicedToArray(_useState, 2), myDocument = _useState2[0], setMyDocument = _useState2[1];
    (0,react.useEffect)(function() {
        setMyDocument(document);
    }, []);
    return myDocument;
};
var SubMenuItem_SubMenuItem = function SubMenuItem(_ref) {
    var _doc$location$pathnam;
    var _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, _ref$name = _ref.name, name = _ref$name === void 0 ? "" : _ref$name, _ref$path = _ref.path, path = _ref$path === void 0 ? "" : _ref$path, _ref$url = _ref.url, url = _ref$url === void 0 ? "" : _ref$url, _ref$openInNewWindow = _ref.openInNewWindow, openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow, _ref$show = _ref.show, show = _ref$show === void 0 ? true : _ref$show, _ref$metrics = _ref.metrics, metrics = _ref$metrics === void 0 ? "" : _ref$metrics;
    var itemTitle = name || title;
    var itemURL = path || url;
    var doc = useDocument();
    if (!itemTitle || !itemURL || !show) return null;
    var currentPath = (_doc$location$pathnam = doc === null || doc === void 0 ? void 0 : doc.location.pathname) !== null && _doc$location$pathnam !== void 0 ? _doc$location$pathnam : "";
    var isActive = path.startsWith(currentPath);
    return /*#__PURE__*/ react.createElement(List.Item, Object.assign({
        key: itemTitle,
        isNavigable: true,
        navigationTarget: itemURL,
        "data-sm-metrics": metrics
    }, openInNewWindow === true && {
        target: "_blank",
        rel: "noopener noreferrer"
    }, {
        color: isActive ? "primary" : undefined,
        marked: isActive,
        __self: mobile_nav_SubMenuItem_this,
        __source: {
            fileName: mobile_nav_SubMenuItem_jsxFileName,
            lineNumber: 44,
            columnNumber: 5
        }
    }), itemTitle);
};
/* harmony default export */ var mobile_nav_SubMenuItem = ((/* unused pure expression or super */ null && (SubMenuItem_SubMenuItem))); //# sourceMappingURL=SubMenuItem.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/helpers/TeamMenuHelpers/TeamMenuCopy.js

var TEAM_MENU_COPY = (0,intl_dist/* defineMessages */.vU)({
    TEAM_SUMMARY: {
        id: "TeamMenuCopy.teamSummary",
        defaultMessage: "Team Summary",
        description: "[Type: Label][Vis.: low] - Team Summary section of nav bar"
    },
    MANAGE_USERS: {
        id: "TeamMenuCopy.manageUsers",
        defaultMessage: "Manage Users",
        description: "[Type: Label][Vis.: low] - Manage Users section of nav bar"
    },
    ADD_USERS: {
        id: "TeamMenuCopy.addUsers",
        defaultMessage: "Add Users",
        description: "[Type: Label][Vis.: low] - Add Users section of nav bar"
    },
    ADMIN_DASHBOARD: {
        id: "TeamMenuCopy.adminDashboard",
        defaultMessage: "Admin Dashboard",
        description: "[Type: Label][Vis.: low] - Admin Dashboard section of nav bar"
    },
    WORKGROUPS: {
        id: "TeamMenuCopy.workgroups",
        defaultMessage: "Workgroups",
        description: "[Type: Label][Vis.: low] - Workgroup section of nav bar"
    },
    LIBRARY: {
        id: "TeamMenuCopy.library",
        defaultMessage: "Library",
        description: "[Type: Label][Vis.: low] - Library section of nav bar"
    },
    ACTIVITY: {
        id: "TeamMenuCopy.activity",
        defaultMessage: "Activity",
        description: "[Type: Label][Vis.: low] - Activity section of nav bar"
    },
    OFFLINE_DEVICES: {
        id: "TeamMenuCopy.offlineDevices",
        defaultMessage: "Offline Devices",
        description: "[Type: Label][Vis.: low] - Offline Devices section of nav bar"
    },
    MANAGE_CREDITS: {
        id: "TeamMenuCopy.manageCredits",
        defaultMessage: "Manage Credits",
        description: "[Type: Label][Vis.: low] - Manage Credits section of nav bar"
    },
    SETTINGS: {
        id: "TeamMenuCopy.settings",
        defaultMessage: "Settings",
        description: "[Type: Label][Vis.: low] - Settings section of nav bar"
    },
    DIVISIONS: {
        id: "TeamMenuCopy.divisions",
        defaultMessage: "Divisions",
        description: "[Type: Label][Vis.: low] - Settings section of nav bar"
    }
});
/* harmony default export */ var TeamMenuCopy = (TEAM_MENU_COPY); //# sourceMappingURL=TeamMenuCopy.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/helpers/TeamMenuHelpers/teamMenuConstants.js

var teamMenuConstants_jsxFileName = "/repo/packages/webassets/src/helpers/TeamMenuHelpers/teamMenuConstants.js", teamMenuConstants_this = undefined;
function teamMenuConstants_defineProperty(obj, key, value) {
    key = teamMenuConstants_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function teamMenuConstants_toPropertyKey(arg) {
    var key = teamMenuConstants_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function teamMenuConstants_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}





var ACCOUNT_TYPES = {
    enterpriseAccount: "enterpriseAccount",
    teamAccount: "teamAccount"
};
var USER_ROLES = {
    accountOwner: "accountOwner",
    admin: "admin",
    divisionAdmin: "divisionAdmin",
    user: "user",
    casual: "casual"
};
var SSO_STATE = {
    REQUIRED: "REQUIRED"
};
var TEAM_MEMBERSHIP_TYPE = {
    ACCOUNT_OWNER: "ACCOUNT_OWNER",
    CASUAL: "CASUAL"
};
var TAB_IDS = {
    teamSummary: "teamSummary",
    manageUsers: "manageUsers",
    addUsers: "addUsers",
    adminDashboard: "adminDashboard",
    divisions: "divisions",
    workgroups: "workgroups",
    activity: "activity",
    offlineDevices: "offlineDevices",
    manageCredits: "manageCredits",
    settings: "settings",
    library: "library",
    contributor: "contributor",
    dei_reporting: "dei_reporting"
};
var getTeamMenuItemConfigs = function getTeamMenuItemConfigs(utSource) {
    var _ref;
    return _ref = {}, teamMenuConstants_defineProperty(_ref, TAB_IDS.teamSummary, {
        path: (0,dist.createURL)("/team/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.TEAM_SUMMARY),
        navItem: "team summary",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconUsers */.SrG, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 65,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.teamSummary
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.manageUsers, {
        path: (0,dist.createURL)("/team/users/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.MANAGE_USERS),
        navItem: "manage users",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconUser */.f7T, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 72,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.manageUsers
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.addUsers, {
        path: (0,dist.createURL)("/team/add/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.ADD_USERS),
        navItem: "add users",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconUserPlus */.$4n, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 79,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.addUsers
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.adminDashboard, {
        path: (0,dist.createURL)("/team/manage/users/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.ADMIN_DASHBOARD),
        navItem: "admin dashboard",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconChartDonut */.yDU, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 86,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.adminDashboard
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.divisions, {
        path: (0,dist.createURL)("/team/divisions/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.DIVISIONS),
        navItem: "divisions",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconBlocks */.u3G, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 93,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.divisions
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.workgroups, {
        path: (0,dist.createURL)("/team/workgroups/all/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.WORKGROUPS),
        navItem: "workgroups",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconWorkgroup */.a9W, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 100,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.workgroups
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.library, {
        path: (0,dist.createURL)("/team/libraries/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.LIBRARY),
        navItem: "library",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconBooks */.ihu, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 107,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.library
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.activity, {
        path: (0,dist.createURL)("/team/activity/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.ACTIVITY),
        navItem: "activity",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconPulse */.UBQ, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 114,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.activity
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.offlineDevices, {
        path: (0,dist.createURL)("/team/devices/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.OFFLINE_DEVICES),
        navItem: "offline devices",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconMobile */.yCG, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 121,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.offlineDevices
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.manageCredits, {
        path: (0,dist.createURL)("/team/manage_credits/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.MANAGE_CREDITS),
        navItem: "manage credits",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconCart */.k5K, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 128,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.manageCredits
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.settings, {
        path: (0,dist.createURL)("/team/settings/", {
            ut_source: utSource
        }),
        name: (0,intl_dist.t)(TeamMenuCopy.SETTINGS),
        navItem: "settings",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconGear */.GI0, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 135,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.settings
    }), teamMenuConstants_defineProperty(_ref, TAB_IDS.dei_reporting, {
        path: (0,dist.createURL)("/team/dei", {
            ut_source: utSource
        }),
        name: "Data upload",
        navItem: "dei",
        renderIcon: function renderIcon(props) {
            return /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconCloudArrow */.Pnl, Object.assign({}, props, {
                __self: teamMenuConstants_this,
                __source: {
                    fileName: teamMenuConstants_jsxFileName,
                    lineNumber: 142,
                    columnNumber: 26
                }
            }));
        },
        id: TAB_IDS.dei_reporting
    }), _ref;
}; //# sourceMappingURL=teamMenuConstants.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/helpers/TeamMenuHelpers/index.js

function TeamMenuHelpers_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function TeamMenuHelpers_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? TeamMenuHelpers_ownKeys(Object(source), !0).forEach(function(key) {
            TeamMenuHelpers_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TeamMenuHelpers_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function TeamMenuHelpers_defineProperty(obj, key, value) {
    key = TeamMenuHelpers_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TeamMenuHelpers_toPropertyKey(arg) {
    var key = TeamMenuHelpers_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function TeamMenuHelpers_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


// build the submenu items based on the current user package and role permissions
var _getSubMenuItems = function _getSubMenuItems(_ref) {
    var menuConfigs = _ref.menuConfigs, utSource = _ref.utSource;
    var menuItemConfigs = getTeamMenuItemConfigs(utSource);
    var menuItems = [
        menuConfigs.canAccess.teamSummaryTab && menuItemConfigs[TAB_IDS.teamSummary],
        menuConfigs.canAccess.manageUsersTab && menuItemConfigs[TAB_IDS.manageUsers],
        menuConfigs.canAccess.addUsersTab && menuItemConfigs[TAB_IDS.addUsers],
        menuConfigs.canAccess.adminDashboardTab && menuItemConfigs[TAB_IDS.adminDashboard],
        menuConfigs.canAccess.divisionsTab && menuItemConfigs[TAB_IDS.divisions],
        menuConfigs.canAccess.workgroupsTab && menuItemConfigs[TAB_IDS.workgroups],
        menuConfigs.canAccess.libraryTab && menuItemConfigs[TAB_IDS.library],
        menuConfigs.canAccess.activityTab && menuItemConfigs[TAB_IDS.activity],
        menuConfigs.canAccess.offlineDevicesTab && menuItemConfigs[TAB_IDS.offlineDevices],
        menuConfigs.canAccess.manageCreditsTab && menuItemConfigs[TAB_IDS.manageCredits],
        menuConfigs.canAccess.settingsTab && menuItemConfigs[TAB_IDS.settings],
        menuConfigs.canAccess.deiReportingTab && menuItemConfigs[TAB_IDS.dei_reporting]
    ];
    return menuItems.filter(Boolean);
};
// spell out all the combination of userPackage/role
// to better understand what the user can and cant see in the ui
var _buildMenuConfigs = function _buildMenuConfigs(_ref2) {
    var _enterpriseAccount, _teamAccount;
    var features = _ref2.features, _ref2$isSSOEnabled = _ref2.isSSOEnabled, isSSOEnabled = _ref2$isSSOEnabled === void 0 ? false : _ref2$isSSOEnabled, _ref2$isAdminImperson = _ref2.isAdminImpersonated, isAdminImpersonated = _ref2$isAdminImperson === void 0 ? false : _ref2$isAdminImperson, _ref2$divisionAdminsC = _ref2.divisionAdminsCanManageUsers, divisionAdminsCanManageUsers = _ref2$divisionAdminsC === void 0 ? false : _ref2$divisionAdminsC, _ref2$permissions = _ref2.permissions, audienceCreditsManagePermission = _ref2$permissions.audienceCreditsManage, teamSummaryPermission = _ref2$permissions.teamSummary, manageUsersPermission = _ref2$permissions.manageUsers, addUsersPermission = _ref2$permissions.addUsers, divisionPermission = _ref2$permissions.division, workgroupPermission = _ref2$permissions.workgroup, activityPermission = _ref2$permissions.activity, offlineDevicesPermission = _ref2$permissions.offlineDevices, adminDashboardPermission = _ref2$permissions.adminDashboard, libraryPermission = _ref2$permissions.library;
    var defaultTabs = {
        teamSummaryTab: teamSummaryPermission,
        manageUsersTab: manageUsersPermission,
        addUsersTab: addUsersPermission && !isSSOEnabled,
        // SSO can't see Add Users tab, only button on header
        adminDashboardTab: features.adminDashboardEnabled && adminDashboardPermission,
        divisionsTab: features.divisionsEnabled && divisionPermission,
        workgroupsTab: features.workgroupsEnabled && workgroupPermission,
        activityTab: features.auditLogsEnabled && activityPermission,
        offlineDevicesTab: features.offlineEnterpriseEnabled && offlineDevicesPermission,
        manageCreditsTab: features.teamAudienceCreditsEnabled && audienceCreditsManagePermission,
        libraryTab: libraryPermission,
        settings: false
    };
    return {
        enterpriseAccount: (_enterpriseAccount = {}, TeamMenuHelpers_defineProperty(_enterpriseAccount, "".concat(USER_ROLES.accountOwner), {
            canAccess: TeamMenuHelpers_objectSpread(TeamMenuHelpers_objectSpread({}, defaultTabs), {}, {
                activityTab: defaultTabs.activityTab || isAdminImpersonated,
                deiReportingTab: features.deiReporting,
                settingsTab: true
            })
        }), TeamMenuHelpers_defineProperty(_enterpriseAccount, "".concat(USER_ROLES.admin), {
            canAccess: TeamMenuHelpers_objectSpread(TeamMenuHelpers_objectSpread({}, defaultTabs), {}, {
                activityTab: defaultTabs.activityTab || isAdminImpersonated,
                deiReportingTab: features.deiReporting,
                settingsTab: true
            })
        }), TeamMenuHelpers_defineProperty(_enterpriseAccount, "".concat(USER_ROLES.divisionAdmin), {
            canAccess: TeamMenuHelpers_objectSpread(TeamMenuHelpers_objectSpread({}, defaultTabs), {}, {
                manageUsersTab: defaultTabs.manageUsersTab || divisionAdminsCanManageUsers,
                activityTab: defaultTabs.activityTab || isAdminImpersonated,
                deiReportingTab: features.deiReporting
            })
        }), TeamMenuHelpers_defineProperty(_enterpriseAccount, "".concat(USER_ROLES.user), {
            canAccess: TeamMenuHelpers_objectSpread(TeamMenuHelpers_objectSpread({}, defaultTabs), {}, {
                deiReportingTab: features.deiReporting
            })
        }), TeamMenuHelpers_defineProperty(_enterpriseAccount, "".concat(USER_ROLES.casual), {
            canAccess: defaultTabs
        }), _enterpriseAccount),
        teamAccount: (_teamAccount = {}, TeamMenuHelpers_defineProperty(_teamAccount, "".concat(USER_ROLES.accountOwner), {
            canAccess: TeamMenuHelpers_objectSpread(TeamMenuHelpers_objectSpread({}, defaultTabs), {}, {
                deiReportingTab: features.deiReporting
            })
        }), TeamMenuHelpers_defineProperty(_teamAccount, "".concat(USER_ROLES.admin), {
            canAccess: TeamMenuHelpers_objectSpread(TeamMenuHelpers_objectSpread({}, defaultTabs), {}, {
                deiReportingTab: features.deiReporting
            })
        }), TeamMenuHelpers_defineProperty(_teamAccount, "".concat(USER_ROLES.user), {
            canAccess: TeamMenuHelpers_objectSpread(TeamMenuHelpers_objectSpread({}, defaultTabs), {}, {
                deiReportingTab: features.deiReporting
            })
        }), _teamAccount)
    };
};
var _getMenuItems = function _getMenuItems(_ref3) {
    var _user$team$settings$d, _user$team, _user$team$settings;
    var user = _ref3.user, session = _ref3.session, utSource = _ref3.utSource, permissions = _ref3.permissions;
    var team = user.team || {};
    var teamMembership = user.teamMembership || {};
    // I will work on conforming the mobile and desktop calls because
    // session is passed in in 2 different ways currently
    var userSession = session || user.session;
    var isAdminImpersonated = userSession && userSession.isAdminImpersonation;
    var isAdmin = teamMembership.isAdmin, isDivisionAdmin = teamMembership.isDivisionAdmin;
    var isSSOEnabled = team.ssoState === SSO_STATE.REQUIRED;
    var isTeamOwner = teamMembership.memberType === TEAM_MEMBERSHIP_TYPE.ACCOUNT_OWNER;
    var isCasual = teamMembership.memberType === TEAM_MEMBERSHIP_TYPE.CASUAL;
    var features = user.features || {};
    var isEnterpriseAccount = teamMembership.isEnterprise;
    var isTeamAccount = !teamMembership.isEnterprise;
    var divisionAdminsCanManageUsers = (_user$team$settings$d = user === null || user === void 0 ? void 0 : (_user$team = user.team) === null || _user$team === void 0 ? void 0 : (_user$team$settings = _user$team.settings) === null || _user$team$settings === void 0 ? void 0 : _user$team$settings.divisionAdminsCanManageUsers) !== null && _user$team$settings$d !== void 0 ? _user$team$settings$d : false;
    var userAccountType = "";
    if (isEnterpriseAccount) {
        // enterprise package 26 accounts
        userAccountType = ACCOUNT_TYPES.enterpriseAccount;
    } else if (isTeamAccount) {
        // self serve teams
        userAccountType = ACCOUNT_TYPES.teamAccount;
    }
    var userRole = "";
    if (isTeamOwner) {
        userRole = USER_ROLES.accountOwner;
    } else if (isAdmin) {
        userRole = USER_ROLES.admin;
    } else if (isDivisionAdmin) {
        userRole = USER_ROLES.divisionAdmin;
    } else if (isCasual) {
        userRole = USER_ROLES.casual;
    } else {
        userRole = USER_ROLES.user;
    }
    var validUserAccountAndRole = !!userAccountType && !!userRole;
    if (validUserAccountAndRole) {
        try {
            var menuConfigs = _buildMenuConfigs({
                features: features,
                isSSOEnabled: isSSOEnabled,
                isAdminImpersonated: isAdminImpersonated,
                divisionAdminsCanManageUsers: divisionAdminsCanManageUsers,
                permissions: permissions
            })[userAccountType][userRole];
            // return only menu items the user have access to based on their
            // package/role
            return _getSubMenuItems({
                menuConfigs: menuConfigs,
                utSource: utSource
            });
        } catch (e) {
            // This should not occur, however it is a fallback in case we introduce
            // some new user account type
            errorHandler/* errorHandler.logError */.P.logError(e, "Unexpected error while building My Team menu items", {
                userAccountType: userAccountType,
                userRole: userRole,
                features: features,
                isSSOEnabled: isSSOEnabled,
                isAdminImpersonated: isAdminImpersonated
            });
            return [];
        }
    }
    return [];
};
var getMyTeamMenuItems = function getMyTeamMenuItems(_ref4) {
    var user = _ref4.user, _ref4$session = _ref4.session, session = _ref4$session === void 0 ? {} : _ref4$session, _ref4$utSource = _ref4.utSource, utSource = _ref4$utSource === void 0 ? "header" : _ref4$utSource, _ref4$permissions = _ref4.permissions, permissions = _ref4$permissions === void 0 ? {} : _ref4$permissions;
    if (!user) {
        return [];
    }
    return _getMenuItems({
        user: user,
        session: session,
        utSource: utSource,
        permissions: permissions
    });
};
/* harmony default export */ var TeamMenuHelpers = (getMyTeamMenuItems); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/TeamMenu/team-menu.generated.js

var team_menu_generated_templateObject;
function team_menu_generated_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function team_menu_generated_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? team_menu_generated_ownKeys(Object(source), !0).forEach(function(key) {
            team_menu_generated_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : team_menu_generated_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function team_menu_generated_defineProperty(obj, key, value) {
    key = team_menu_generated_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function team_menu_generated_toPropertyKey(arg) {
    var key = team_menu_generated_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function team_menu_generated_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function team_menu_generated_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
/* eslint-disable */ 

var team_menu_generated_defaultOptions = {};
var AuthQueryDocument = lib(team_menu_generated_templateObject || (team_menu_generated_templateObject = team_menu_generated_taggedTemplateLiteral([
    "\n  query authQuery($permissions: [RbacPermissionType!]!) {\n    user {\n      id\n      username\n      team {\n        id\n        name\n        ssoState\n        settings {\n          divisionAdminsCanManageUsers\n        }\n      }\n      teamMembership {\n        id\n        isEnterprise\n        isAdmin\n        isDivisionAdmin\n        memberType\n      }\n      language {\n        id\n        code\n      }\n      package {\n        id\n        canonicalName\n      }\n      features {\n        teamsEnabled\n        workgroupsEnabled\n        adminDashboardEnabled\n        offlineEnterpriseEnabled\n        teamAudienceCreditsEnabled\n        auditLogsEnabled\n        divisionsEnabled\n        deiReporting\n      }\n    }\n    rbacPermissions(permissions: $permissions) {\n      permission\n      isAuthorized\n    }\n  }\n"
])));
/**
 * __useAuthQueryQuery__
 *
 * To run a query within a React component, call `useAuthQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthQueryQuery({
 *   variables: {
 *      permissions: // value for 'permissions'
 *   },
 * });
 */ function useAuthQueryQuery(baseOptions) {
    var options = team_menu_generated_objectSpread(team_menu_generated_objectSpread({}, team_menu_generated_defaultOptions), baseOptions);
    return ApolloReactHooks.useQuery(AuthQueryDocument, options);
}
function useAuthQueryLazyQuery(baseOptions) {
    var options = team_menu_generated_objectSpread(team_menu_generated_objectSpread({}, team_menu_generated_defaultOptions), baseOptions);
    return react_hooks_esm/* useLazyQuery */.td(AuthQueryDocument, options);
} //# sourceMappingURL=team-menu.generated.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/TeamMenu/TeamMenu.js
var TeamMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/TeamMenu/TeamMenu.tsx", TeamMenu_this = undefined;
function TeamMenu_slicedToArray(arr, i) {
    return TeamMenu_arrayWithHoles(arr) || TeamMenu_iterableToArrayLimit(arr, i) || TeamMenu_unsupportedIterableToArray(arr, i) || TeamMenu_nonIterableRest();
}
function TeamMenu_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TeamMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TeamMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TeamMenu_arrayLikeToArray(o, minLen);
}
function TeamMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function TeamMenu_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function TeamMenu_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}















var TeamMenu_COPY = (0,intl_dist/* defineMessages */.vU)({
    MY_TEAM: {
        id: "TeamMenu.myTeam",
        defaultMessage: "My Team",
        description: "[Type: Label][Vis.: low] - My team section of nav bar"
    }
});
var TeamMenu = function TeamMenu() {
    var _permissionData$RbacP, _permissionData$RbacP2, _permissionData$RbacP3, _permissionData$RbacP4, _permissionData$RbacP5, _permissionData$RbacP6, _permissionData$RbacP7, _permissionData$RbacP8, _permissionData$RbacP9, _permissionData$RbacP10, _user$teamMembership;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), session = _useContext.session, pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var _useAuthQueryLazyQuer = useAuthQueryLazyQuery({
        variables: {
            permissions: [
                RbacPermissionType.TeamSummaryView,
                RbacPermissionType.UsersView,
                RbacPermissionType.UsersInvite,
                RbacPermissionType.DivisionsView,
                RbacPermissionType.WorkgroupsView,
                RbacPermissionType.ActivityView,
                RbacPermissionType.OfflineDevicesManage,
                RbacPermissionType.AudienceCreditsManage,
                RbacPermissionType.AdminDashboardView,
                RbacPermissionType.LibraryView
            ]
        }
    }), _useAuthQueryLazyQuer2 = TeamMenu_slicedToArray(_useAuthQueryLazyQuer, 2), fetch = _useAuthQueryLazyQuer2[0], _useAuthQueryLazyQuer3 = _useAuthQueryLazyQuer2[1], loading = _useAuthQueryLazyQuer3.loading, data = _useAuthQueryLazyQuer3.data;
    (0,react.useEffect)(function() {
        fetch();
    }, []);
    var permissionData = (0,react.useMemo)(function() {
        return (data === null || data === void 0 ? void 0 : data.rbacPermissions.reduce(function(acc, value) {
            acc[value.permission] = value.isAuthorized;
            return acc;
        }, {})) || {};
    }, [
        data
    ]);
    var permissions = {
        teamSummary: (_permissionData$RbacP = permissionData[RbacPermissionType.TeamSummaryView]) !== null && _permissionData$RbacP !== void 0 ? _permissionData$RbacP : false,
        manageUsers: (_permissionData$RbacP2 = permissionData[RbacPermissionType.UsersView]) !== null && _permissionData$RbacP2 !== void 0 ? _permissionData$RbacP2 : false,
        addUsers: (_permissionData$RbacP3 = permissionData[RbacPermissionType.UsersInvite]) !== null && _permissionData$RbacP3 !== void 0 ? _permissionData$RbacP3 : false,
        division: (_permissionData$RbacP4 = permissionData[RbacPermissionType.DivisionsView]) !== null && _permissionData$RbacP4 !== void 0 ? _permissionData$RbacP4 : false,
        workgroup: (_permissionData$RbacP5 = permissionData[RbacPermissionType.WorkgroupsView]) !== null && _permissionData$RbacP5 !== void 0 ? _permissionData$RbacP5 : false,
        activity: (_permissionData$RbacP6 = permissionData[RbacPermissionType.ActivityView]) !== null && _permissionData$RbacP6 !== void 0 ? _permissionData$RbacP6 : false,
        library: (_permissionData$RbacP7 = permissionData[RbacPermissionType.LibraryView]) !== null && _permissionData$RbacP7 !== void 0 ? _permissionData$RbacP7 : false,
        offlineDevices: (_permissionData$RbacP8 = permissionData[RbacPermissionType.OfflineDevicesManage]) !== null && _permissionData$RbacP8 !== void 0 ? _permissionData$RbacP8 : false,
        adminDashboard: (_permissionData$RbacP9 = permissionData[RbacPermissionType.AdminDashboardView]) !== null && _permissionData$RbacP9 !== void 0 ? _permissionData$RbacP9 : false,
        audienceCreditsManage: (_permissionData$RbacP10 = permissionData[RbacPermissionType.AudienceCreditsManage]) !== null && _permissionData$RbacP10 !== void 0 ? _permissionData$RbacP10 : false
    };
    if (loading) return null;
    if (!(data !== null && data !== void 0 && data.user)) return null;
    var user = data === null || data === void 0 ? void 0 : data.user;
    var TrackMenuEvents = function TrackMenuEvents(opened) {
        metrics_dist.MetricsTracker.track({
            name: metrics_dist.USER_EVENTS.ELEMENT_INTERACTION,
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked menu",
                menuName: "team",
                opened: opened
            }
        });
    };
    var GenerateMetricsNavigationEvent = function GenerateMetricsNavigationEvent(navItem) {
        return (0,metrics_dist.generateMetricsAttribute)({
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked navigation",
                navItem: navItem
            }
        });
    };
    var teamMembership = (_user$teamMembership = user.teamMembership) !== null && _user$teamMembership !== void 0 ? _user$teamMembership : {
        isAdmin: false,
        isEnterprise: false,
        memberType: ""
    };
    var canSeeTeamTab = teamMembership.isAdmin || teamMembership.isEnterprise;
    var title = (0,intl_dist.t)(TeamMenu_COPY.MY_TEAM);
    var menuItems = TeamMenuHelpers({
        user: user,
        session: session,
        permissions: permissions
    });
    return canSeeTeamTab ? /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: TeamMenu_this,
        __source: {
            fileName: TeamMenu_jsxFileName,
            lineNumber: 120,
            columnNumber: 5
        }
    }, function(matches) {
        return matches ? /*#__PURE__*/ react.createElement(index_es_Menu, {
            placement: "bottom-left",
            noRules: true,
            dense: true,
            menuTrigger: /*#__PURE__*/ react.createElement(NavButton, {
                label: "Open My Team menu",
                __self: TeamMenu_this,
                __source: {
                    fileName: TeamMenu_jsxFileName,
                    lineNumber: 128,
                    columnNumber: 15
                }
            }, /*#__PURE__*/ react.createElement(intl_dist.T, {
                desc: TeamMenu_COPY.MY_TEAM,
                __self: TeamMenu_this,
                __source: {
                    fileName: TeamMenu_jsxFileName,
                    lineNumber: 129,
                    columnNumber: 17
                }
            }), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
                ml: 2,
                __self: TeamMenu_this,
                __source: {
                    fileName: TeamMenu_jsxFileName,
                    lineNumber: 130,
                    columnNumber: 17
                }
            }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconCaretDown */.KCe, {
                title: "Dropdown arrow",
                __self: TeamMenu_this,
                __source: {
                    fileName: TeamMenu_jsxFileName,
                    lineNumber: 131,
                    columnNumber: 19
                }
            }))),
            key: title,
            elevation: 9999,
            onChange: function onChange(showMenu) {
                TrackMenuEvents(showMenu);
            },
            __self: TeamMenu_this,
            __source: {
                fileName: TeamMenu_jsxFileName,
                lineNumber: 123,
                columnNumber: 11
            }
        }, menuItems.map(function(item) {
            return /*#__PURE__*/ react.createElement(index_es_Menu.Item, {
                key: "".concat(item.name, "-teamMenu"),
                navigationTarget: item.path,
                isNavigable: true,
                "data-sm-metrics": GenerateMetricsNavigationEvent(item.navItem),
                __self: TeamMenu_this,
                __source: {
                    fileName: TeamMenu_jsxFileName,
                    lineNumber: 143,
                    columnNumber: 17
                }
            }, item.name);
        })) : /*#__PURE__*/ react.createElement(Accordion, {
            key: "accordion-MyTeam",
            onChange: function onChange(e) {
                return TrackMenuEvents(!e.length);
            },
            __self: TeamMenu_this,
            __source: {
                fileName: TeamMenu_jsxFileName,
                lineNumber: 155,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(Accordion.Item, {
            title: title,
            __self: TeamMenu_this,
            __source: {
                fileName: TeamMenu_jsxFileName,
                lineNumber: 159,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(List, {
            transparent: true,
            __self: TeamMenu_this,
            __source: {
                fileName: TeamMenu_jsxFileName,
                lineNumber: 160,
                columnNumber: 15
            }
        }, menuItems.map(function(item) {
            return /*#__PURE__*/ react.createElement(SubMenuItem_SubMenuItem, Object.assign({
                key: item.name,
                metrics: GenerateMetricsNavigationEvent(item.navItem)
            }, item, {
                __self: TeamMenu_this,
                __source: {
                    fileName: TeamMenu_jsxFileName,
                    lineNumber: 163,
                    columnNumber: 21
                }
            }));
        }))));
    }) : null;
};
/* harmony default export */ var TeamMenu_TeamMenu = ((/* unused pure expression or super */ null && (TeamMenu)));
 //# sourceMappingURL=TeamMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/TeamMenu/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/info-menu/useStyles.js

var info_menu_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var spacing = _ref.spacing, palette = _ref.palette;
    return {
        infoMenu: {
            display: "flex",
            "& > div > div > .wds-overlay": {
                top: spacing[7]
            }
        },
        descriptionBox: {
            whiteSpace: "normal"
        },
        footnote: {
            padding: [
                spacing[1],
                spacing[5],
                spacing[6],
                spacing[5]
            ],
            borderTop: [
                1,
                "solid",
                palette.text.darkMuted
            ],
            whiteSpace: "normal"
        }
    };
});
/* harmony default export */ var info_menu_useStyles = (info_menu_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/info-menu/MenuItems.js
var MenuItems_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/MenuItems.tsx", MenuItems_this = undefined;









var MenuItems = function MenuItems(_ref) {
    var title = _ref.title, url = _ref.url, subTitle = _ref.subTitle, navItem = _ref.navItem, _ref$openInNewWindow = _ref.openInNewWindow, openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow;
    var classes = info_menu_useStyles();
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var metrics = (0,metrics_dist.generateMetricsAttribute)({
        data: {
            url: pageURL,
            pageName: pageName,
            amplitudeEvent: "header clicked navigation",
            navItem: navItem
        }
    });
    return /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: MenuItems_this,
        __source: {
            fileName: MenuItems_jsxFileName,
            lineNumber: 38,
            columnNumber: 5
        }
    }, function(matches) {
        return matches ? /*#__PURE__*/ react.createElement(List.Item, Object.assign({
            interactive: true,
            isNavigable: true,
            href: url,
            "data-sm-metrics": metrics
        }, openInNewWindow === true && {
            target: "_blank",
            rel: "noopener noreferrer"
        }, {
            __self: MenuItems_this,
            __source: {
                fileName: MenuItems_jsxFileName,
                lineNumber: 41,
                columnNumber: 11
            }
        }), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            py: 4,
            __self: MenuItems_this,
            __source: {
                fileName: MenuItems_jsxFileName,
                lineNumber: 51,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            variant: "body",
            __self: MenuItems_this,
            __source: {
                fileName: MenuItems_jsxFileName,
                lineNumber: 52,
                columnNumber: 15
            }
        }, title), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            pt: 1,
            display: "flex",
            className: classes.descriptionBox,
            __self: MenuItems_this,
            __source: {
                fileName: MenuItems_jsxFileName,
                lineNumber: 53,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            variant: "bodySm",
            __self: MenuItems_this,
            __source: {
                fileName: MenuItems_jsxFileName,
                lineNumber: 54,
                columnNumber: 17
            }
        }, subTitle)))) : /*#__PURE__*/ react.createElement(SubMenuItem_SubMenuItem, {
            title: title,
            url: url,
            metrics: metrics,
            __self: MenuItems_this,
            __source: {
                fileName: MenuItems_jsxFileName,
                lineNumber: 59,
                columnNumber: 11
            }
        });
    });
};
/* harmony default export */ var info_menu_MenuItems = (MenuItems);
 //# sourceMappingURL=MenuItems.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/explore-menu/assets/Solutions.js
var Solutions_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/explore-menu/assets/Solutions.tsx", Solutions_this = undefined;

var SolutionsIcon = function SolutionsIcon() {
    return /*#__PURE__*/ react.createElement("svg", {
        width: "32",
        height: "32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 35 35",
        __self: Solutions_this,
        __source: {
            fileName: Solutions_jsxFileName,
            lineNumber: 5,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M16 2v6.257c.627.043 1.25.126 1.866.249a10.527 10.527 0 0 1 7.367 15.433l-3.725-2.528a6.072 6.072 0 1 1-6.75-8.503c.411-.061.827-.079 1.242-.053v2.812",
        stroke: "#6BC9F5",
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        __self: Solutions_this,
        __source: {
            fileName: Solutions_jsxFileName,
            lineNumber: 12,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M16 22.18a3.305 3.305 0 1 0 0-6.61 3.305 3.305 0 0 0 0 6.61Z",
        fill: "#9D9D9D",
        __self: Solutions_this,
        __source: {
            fileName: Solutions_jsxFileName,
            lineNumber: 19,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M18.257 6.286a12.792 12.792 0 1 1-4.514 0",
        stroke: "#404040",
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        __self: Solutions_this,
        __source: {
            fileName: Solutions_jsxFileName,
            lineNumber: 23,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M21.718 24.854A8.276 8.276 0 0 1 8.08 16.468M6.813 9.967l3.054 3.053.126-.133A8.285 8.285 0 0 1 24 18.873a8.426 8.426 0 0 1-.2 1.847M25.044 27.92l-3.182-3.184",
        stroke: "#404040",
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        __self: Solutions_this,
        __source: {
            fileName: Solutions_jsxFileName,
            lineNumber: 30,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "m21.613 13.26-2.96 2.96.003-.002c.524.512.88 1.17 1.024 1.889a3.759 3.759 0 1 1-6.298-1.93",
        stroke: "#404040",
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        __self: Solutions_this,
        __source: {
            fileName: Solutions_jsxFileName,
            lineNumber: 37,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M18.4 4.4 16 2l-2.4 2.4",
        stroke: "#6BC9F5",
        strokeWidth: "2",
        strokeLinecap: "round",
        __self: Solutions_this,
        __source: {
            fileName: Solutions_jsxFileName,
            lineNumber: 44,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var Solutions = (SolutionsIcon); //# sourceMappingURL=Solutions.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/explore-menu/assets/Audience.js
var Audience_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/explore-menu/assets/Audience.tsx", Audience_this = undefined;

var AudienceIcon = function AudienceIcon() {
    return /*#__PURE__*/ react.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 62 62",
        width: 32,
        height: 32,
        __self: Audience_this,
        __source: {
            fileName: Audience_jsxFileName,
            lineNumber: 5,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#B3DABD",
        d: "M28 50.667H4S2.667 33.333 20 33.333c8 0 10.667 5.778 10.667 5.778A23.602 23.602 0 0 0 28 50.667z",
        __self: Audience_this,
        __source: {
            fileName: Audience_jsxFileName,
            lineNumber: 12,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#9D9D9D",
        d: "M61.076 50.667H35.232a16.873 16.873 0 0 0-3.232-12s1.796-6.665 11.846-6.665c0 0 17.23-1.436 17.23 18.665z",
        __self: Audience_this,
        __source: {
            fileName: Audience_jsxFileName,
            lineNumber: 16,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: "#404040",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M44.61 27.588a7.794 7.794 0 1 0 0-15.588 7.794 7.794 0 0 0 0 15.588zM10.843 21.088a7.83 7.83 0 1 1 7.83 7.829 7.876 7.876 0 0 1-7.83-7.83v0z",
        __self: Audience_this,
        __source: {
            fileName: Audience_jsxFileName,
            lineNumber: 20,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        stroke: "#404040",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        d: "M3.744 50.556v-2.102a15.549 15.549 0 0 1 15.832-15.25v0a15.549 15.549 0 0 1 15.831 15.25v.13a3.33 3.33 0 0 1-3.389 3.265v0a3.329 3.329 0 0 1-3.389-3.264v-1.636a15.677 15.677 0 0 1 15.962-15.376v0A15.677 15.677 0 0 1 60.553 46.95v3.225",
        __self: Audience_this,
        __source: {
            fileName: Audience_jsxFileName,
            lineNumber: 26,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var Audience = (AudienceIcon); //# sourceMappingURL=Audience.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/explore-menu/useStyles.js

var explore_menu_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var palette = _ref.palette, shadow = _ref.shadow;
    return {
        panel: {
            position: "absolute",
            top: "100%",
            width: "516px",
            background: palette.background.light,
            boxShadow: shadow.space
        },
        leftBox: {
            maxWidth: "176px",
            whiteSpace: "normal"
        },
        rightBox: {
            maxWidth: "300px",
            whiteSpace: "normal",
            backgroundColor: palette.background.main
        },
        title: {
            borderBottom: "1px solid ".concat(palette.border.main)
        }
    };
});
/* harmony default export */ var explore_menu_useStyles = (explore_menu_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/explore-menu/ExplorePanel.js
var ExplorePanel_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/explore-menu/ExplorePanel.tsx", ExplorePanel_this = undefined;









var ExplorePanel = function ExplorePanel(_ref) {
    var show = _ref.show, onToggle = _ref.onToggle;
    var ref = (0,react.useRef)(null);
    var theme = useHeaderTheme();
    var _useStyles = explore_menu_useStyles({
        theme: theme
    }), panel = _useStyles.panel, title = _useStyles.title, leftBox = _useStyles.leftBox, rightBox = _useStyles.rightBox;
    (0,react.useEffect)(function() {
        if (show) {
            var _ref$current;
            (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus();
        }
    }, [
        show
    ]);
    if (!show) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("div", {
        role: "menu",
        tabIndex: -1,
        ref: ref,
        onBlur: function onBlur(e) {
            if (!e.currentTarget.contains(e.relatedTarget)) {
                onToggle();
            }
        },
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 32,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        justifyContent: "space-between",
        className: panel,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 42,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        pt: 6,
        pr: 2,
        pb: 4,
        pl: 6,
        className: leftBox,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 43,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        mb: 4,
        alignItems: "center",
        className: title,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 44,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "inline",
        mr: 2,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 45,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Audience, {
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 46,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        weight: "medium",
        variant: "body",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 48,
            columnNumber: 13
        }
    }, "Audience")), /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 52,
            columnNumber: 11
        }
    }, "Survey people who live, work, and do what matters to you. Reach audiences in 130+ countries and get responses quickly."), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mt: 3,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 56,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        color: "link",
        weight: "medium",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 57,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Link, {
        underline: false,
        href: "https://www.surveymonkey.com/collect/audience/calculator/preview?ut_source=header&ut_source3=buy_targeted_responses",
        target: "_blank",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 58,
            columnNumber: 15
        }
    }, "Buy targeted responses")))), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        flexItemGrow: true,
        pt: 6,
        pr: 5,
        pb: 4,
        pl: 6,
        className: rightBox,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 68,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        className: title,
        display: "flex",
        mb: 4,
        alignItems: "center",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 69,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mr: 2,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 70,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Solutions, {
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 71,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        weight: "medium",
        variant: "body",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 73,
            columnNumber: 13
        }
    }, "Brand and market research")), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mb: 4,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 77,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 78,
            columnNumber: 13
        }
    }, "Discover expert-designed solutions to gather feedback on your ideas, products, and business. Get valuable insights delivered in days.")), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mb: 2,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 84,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        color: "link",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 85,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Link, {
        underline: false,
        href: "https://www.surveymonkey.com/market-research/solutions/brand-tracker/?ut_source=header&ut_source3=trackers",
        target: "_blank",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 86,
            columnNumber: 15
        }
    }, "Brand tracking"))), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mb: 2,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 95,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        color: "link",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 96,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Link, {
        underline: false,
        href: "https://www.surveymonkey.com/market-research/solutions/ad-creative-analysis/?ut_source=header&ut_source3=ad_creative_analysis",
        target: "_blank",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 97,
            columnNumber: 15
        }
    }, "Ad testing"))), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mb: 2,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 106,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        color: "link",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 107,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Link, {
        underline: false,
        href: "https://www.surveymonkey.com/market-research/solutions/idea-screening/?ut_source=header&ut_source3=idea_screener",
        target: "_blank",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 108,
            columnNumber: 15
        }
    }, "Idea screening"))), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mb: 3,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 117,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        color: "link",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 118,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Link, {
        underline: false,
        href: "https://www.surveymonkey.com/market-research/solutions/price-optimization/?ut_source=header&ut_source3=van_west",
        target: "_blank",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 119,
            columnNumber: 15
        }
    }, "Price optimization"))), /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "bodySm",
        color: "link",
        weight: "medium",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 128,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(Link, {
        underline: false,
        href: "https://www.surveymonkey.com/market-research/solutions/get-started/?ut_source=header",
        target: "_blank",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 129,
            columnNumber: 13
        }
    }, "Explore more solutions", /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "inline",
        ml: 4,
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 135,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconArrowBox */.VBb, {
        title: "link icon",
        __self: ExplorePanel_this,
        __source: {
            fileName: ExplorePanel_jsxFileName,
            lineNumber: 136,
            columnNumber: 17
        }
    })))))));
};
/* harmony default export */ var explore_menu_ExplorePanel = (ExplorePanel); //# sourceMappingURL=ExplorePanel.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/explore-menu/ExploreMenu.js
var ExploreMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/explore-menu/ExploreMenu.tsx", ExploreMenu_this = undefined;
function ExploreMenu_slicedToArray(arr, i) {
    return ExploreMenu_arrayWithHoles(arr) || ExploreMenu_iterableToArrayLimit(arr, i) || ExploreMenu_unsupportedIterableToArray(arr, i) || ExploreMenu_nonIterableRest();
}
function ExploreMenu_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ExploreMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ExploreMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ExploreMenu_arrayLikeToArray(o, minLen);
}
function ExploreMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function ExploreMenu_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function ExploreMenu_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}











var ExploreMenu = function ExploreMenu() {
    var _useState = (0,react.useState)(false), _useState2 = ExploreMenu_slicedToArray(_useState, 2), show = _useState2[0], setShow = _useState2[1];
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var trackMenuEvents = function trackMenuEvents(opened) {
        metrics_dist.MetricsTracker.track({
            name: metrics_dist.USER_EVENTS.ELEMENT_INTERACTION,
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked menu",
                menuName: "explore",
                opened: opened
            }
        });
    };
    var onToggle = function onToggle() {
        trackMenuEvents(!show);
        setShow(!show);
    };
    return /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: ExploreMenu_this,
        __source: {
            fileName: ExploreMenu_jsxFileName,
            lineNumber: 37,
            columnNumber: 5
        }
    }, function(matches) {
        return matches ? /*#__PURE__*/ react.createElement("div", {
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 40,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(NavButton, {
            label: "Open explore menu",
            onClick: onToggle,
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 41,
                columnNumber: 13
            }
        }, "Explore", /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            ml: 2,
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 43,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconCaretDown */.KCe, {
            title: "Dropdown arrow icon",
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 44,
                columnNumber: 17
            }
        }))), /*#__PURE__*/ react.createElement(explore_menu_ExplorePanel, {
            show: show,
            onToggle: onToggle,
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 47,
                columnNumber: 13
            }
        })) : /*#__PURE__*/ react.createElement(Accordion, {
            key: "accordion-Explore",
            noRules: true,
            interactive: true,
            onChange: function onChange(e) {
                return trackMenuEvents(!e.length);
            },
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 50,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(Accordion.Item, {
            title: "Explore",
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 56,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(List, {
            noRules: true,
            interactive: true,
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 57,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(info_menu_MenuItems, {
            title: "Audience",
            url: "https://www.surveymonkey.com/collect/audience/calculator/preview?ut_source=header&ut_source3=buy_targeted_responses",
            navItem: "audience",
            subTitle: "",
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 58,
                columnNumber: 17
            }
        }), /*#__PURE__*/ react.createElement(info_menu_MenuItems, {
            title: " Brand and market research",
            url: "https://www.surveymonkey.com/market-research/solutions/get-started/?ut_source=header",
            navItem: " Brand and market research",
            subTitle: "",
            __self: ExploreMenu_this,
            __source: {
                fileName: ExploreMenu_jsxFileName,
                lineNumber: 64,
                columnNumber: 17
            }
        }))));
    });
};
// eslint-disable-next-line import/prefer-default-export
 //# sourceMappingURL=ExploreMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/explore-menu/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/BaseMenu.js
var BaseMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/BaseMenu.tsx", BaseMenu_this = undefined;








var BaseMenu = function BaseMenu(_ref) {
    var _experiment$lihpHeade, _headerContext$user, _experiment$exploreTa;
    var experiment = _ref.experiment;
    var headerContext = (0,react.useContext)(wrench_HeaderContext);
    // Global Header experiment
    // https://momentiveai.atlassian.net/browse/HOME-737
    var lihpTreatment = experiment === null || experiment === void 0 ? void 0 : (_experiment$lihpHeade = experiment.lihpHeader) === null || _experiment$lihpHeade === void 0 ? void 0 : _experiment$lihpHeade.treatment;
    var _ref2 = (_headerContext$user = headerContext === null || headerContext === void 0 ? void 0 : headerContext.user) !== null && _headerContext$user !== void 0 ? _headerContext$user : {}, homePageEnabled = _ref2.homePageEnabled, hasLIHPFeature = _ref2.hasLIHPFeature, hasSeenLIHPWelcomeModal = _ref2.hasSeenLIHPWelcomeModal;
    var hasLIHPTreatment = [
        "has_lihp",
        "lihp_paid_individuals_treatment",
        "lihp_teams_treatment",
        "lihp_sme_treatment"
    ].includes(lihpTreatment);
    // Global Header experiment
    // https://momentiveai.atlassian.net/browse/WEBEXP-762
    // https://admin.surveymonkey.com/experiments/surveymonkey/2356
    var exploreTabTreatment = experiment === null || experiment === void 0 ? void 0 : (_experiment$exploreTa = experiment.exploreTab) === null || _experiment$exploreTa === void 0 ? void 0 : _experiment$exploreTa.treatment;
    var hasExploreTab = exploreTabTreatment === "explore_experiment_enabled";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, homePageEnabled !== false && (hasLIHPFeature || hasSeenLIHPWelcomeModal || hasLIHPTreatment) ? /*#__PURE__*/ react.createElement(Home, {
        key: "menu-home",
        __self: BaseMenu_this,
        __source: {
            fileName: BaseMenu_jsxFileName,
            lineNumber: 38,
            columnNumber: 9
        }
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Dashboard, {
        key: "menu-dashboard",
        __self: BaseMenu_this,
        __source: {
            fileName: BaseMenu_jsxFileName,
            lineNumber: 41,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement(MySurveys, {
        key: "menu-surveys",
        __self: BaseMenu_this,
        __source: {
            fileName: BaseMenu_jsxFileName,
            lineNumber: 42,
            columnNumber: 11
        }
    })), /*#__PURE__*/ react.createElement(TeamMenu, {
        key: "menu-team",
        __self: BaseMenu_this,
        __source: {
            fileName: BaseMenu_jsxFileName,
            lineNumber: 45,
            columnNumber: 7
        }
    }), hasExploreTab && /*#__PURE__*/ react.createElement(ExploreMenu, {
        key: "menu-explore",
        __self: BaseMenu_this,
        __source: {
            fileName: BaseMenu_jsxFileName,
            lineNumber: 46,
            columnNumber: 25
        }
    }), /*#__PURE__*/ react.createElement(Pricing, {
        key: "menu-pricing",
        __self: BaseMenu_this,
        __source: {
            fileName: BaseMenu_jsxFileName,
            lineNumber: 47,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var navigation_BaseMenu = (BaseMenu); //# sourceMappingURL=BaseMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/user-menu/UserMenu.generated.js

var UserMenu_generated_templateObject;
function UserMenu_generated_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function UserMenu_generated_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? UserMenu_generated_ownKeys(Object(source), !0).forEach(function(key) {
            UserMenu_generated_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UserMenu_generated_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function UserMenu_generated_defineProperty(obj, key, value) {
    key = UserMenu_generated_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UserMenu_generated_toPropertyKey(arg) {
    var key = UserMenu_generated_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function UserMenu_generated_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function UserMenu_generated_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
/* eslint-disable */ 

var UserMenu_generated_defaultOptions = {};
var UserMenuQueryDocument = lib(UserMenu_generated_templateObject || (UserMenu_generated_templateObject = UserMenu_generated_taggedTemplateLiteral([
    "\n  query userMenuQuery {\n    user {\n      id\n      username\n      team {\n        id\n        name\n      }\n      teamMembership {\n        id\n        isEnterprise\n        isAdmin\n        memberType\n      }\n      language {\n        id\n        code\n      }\n      features {\n        liteLibraryEnabled\n        plansBenchmarksEnabled\n      }\n      preferences {\n        paidBenchmarksEnabled\n      }\n      linkedIdentities {\n        totalCount\n      }\n    }\n  }\n"
])));
/**
 * __useUserMenuQueryQuery__
 *
 * To run a query within a React component, call `useUserMenuQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMenuQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMenuQueryQuery({
 *   variables: {
 *   },
 * });
 */ function useUserMenuQueryQuery(baseOptions) {
    var options = UserMenu_generated_objectSpread(UserMenu_generated_objectSpread({}, UserMenu_generated_defaultOptions), baseOptions);
    return ApolloReactHooks.useQuery(UserMenuQueryDocument, options);
}
function useUserMenuQueryLazyQuery(baseOptions) {
    var options = UserMenu_generated_objectSpread(UserMenu_generated_objectSpread({}, UserMenu_generated_defaultOptions), baseOptions);
    return react_hooks_esm/* useLazyQuery */.td(UserMenuQueryDocument, options);
} //# sourceMappingURL=UserMenu.generated.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/user-menu/RenderUserMenu.js
var RenderUserMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/user-menu/RenderUserMenu.tsx", RenderUserMenu_this = undefined;












var RenderUserMenu_COPY = (0,intl_dist/* defineMessages */.vU)({
    OPEN_USER_MENU: {
        id: "RenderUserMenu.Open",
        defaultMessage: "Open user menu",
        description: "[Type: Label][Vis.: high] - Button that opens and closes the user menu."
    },
    EXPAND_ARROW_ICON: {
        id: "RenderUserMenu.Dropdown",
        defaultMessage: "Dropdown arrow icon",
        description: "[Type: Label][Vis.: high] - Expand arrow icon."
    }
});
var UserDropDownTrigger = function UserDropDownTrigger(username) {
    return /*#__PURE__*/ react.createElement(NavButton, {
        label: (0,intl_dist.t)(RenderUserMenu_COPY.OPEN_USER_MENU),
        __self: RenderUserMenu_this,
        __source: {
            fileName: RenderUserMenu_jsxFileName,
            lineNumber: 37,
            columnNumber: 5
        }
    }, username, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        ml: 2,
        __self: RenderUserMenu_this,
        __source: {
            fileName: RenderUserMenu_jsxFileName,
            lineNumber: 39,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconCaretDown */.KCe, {
        title: (0,intl_dist.t)(RenderUserMenu_COPY.EXPAND_ARROW_ICON),
        __self: RenderUserMenu_this,
        __source: {
            fileName: RenderUserMenu_jsxFileName,
            lineNumber: 40,
            columnNumber: 9
        }
    })));
};
var RenderUserMenu = function RenderUserMenu(_ref) {
    var username = _ref.username, _ref$menuItems = _ref.menuItems, menuItems = _ref$menuItems === void 0 ? [] : _ref$menuItems;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var TrackMenuEvents = function TrackMenuEvents(opened) {
        metrics_dist.MetricsTracker.track({
            name: metrics_dist.USER_EVENTS.ELEMENT_INTERACTION,
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked menu",
                menuName: "username",
                opened: opened
            }
        });
    };
    return /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "md",
        __self: RenderUserMenu_this,
        __source: {
            fileName: RenderUserMenu_jsxFileName,
            lineNumber: 70,
            columnNumber: 5
        }
    }, function(matches) {
        return matches ? /*#__PURE__*/ react.createElement(index_es_Menu, {
            placement: "bottom-right",
            menuTrigger: UserDropDownTrigger(username),
            noRules: true,
            elevation: 9999,
            onChange: function onChange(showMenu) {
                return TrackMenuEvents(showMenu);
            },
            __self: RenderUserMenu_this,
            __source: {
                fileName: RenderUserMenu_jsxFileName,
                lineNumber: 73,
                columnNumber: 11
            }
        }, menuItems.map(function(item) {
            return /*#__PURE__*/ react.createElement(index_es_Menu.Item, {
                key: item.name,
                navigationTarget: item.path,
                isNavigable: true,
                "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
                    data: {
                        url: pageURL,
                        pageName: pageName,
                        amplitudeEvent: "header clicked navigation",
                        navItem: item.navItem
                    }
                }),
                __self: RenderUserMenu_this,
                __source: {
                    fileName: RenderUserMenu_jsxFileName,
                    lineNumber: 81,
                    columnNumber: 15
                }
            }, item.name);
        })) : /*#__PURE__*/ react.createElement(Accordion, {
            interactive: true,
            onChange: function onChange(e) {
                return TrackMenuEvents(!e.length);
            },
            __self: RenderUserMenu_this,
            __source: {
                fileName: RenderUserMenu_jsxFileName,
                lineNumber: 99,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(Accordion.Item, {
            title: username,
            __self: RenderUserMenu_this,
            __source: {
                fileName: RenderUserMenu_jsxFileName,
                lineNumber: 100,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(List, {
            noRules: true,
            interactive: true,
            __self: RenderUserMenu_this,
            __source: {
                fileName: RenderUserMenu_jsxFileName,
                lineNumber: 101,
                columnNumber: 15
            }
        }, menuItems.filter(function(item) {
            return item.path.indexOf("sign-out") === -1;
        }).map(function(item) {
            return /*#__PURE__*/ react.createElement(SubMenuItem_SubMenuItem, Object.assign({
                key: item.name
            }, item, {
                "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
                    data: {
                        url: pageURL,
                        pageName: pageName,
                        amplitudeEvent: "header clicked navigation",
                        navItem: item.navItem
                    }
                }),
                __self: RenderUserMenu_this,
                __source: {
                    fileName: RenderUserMenu_jsxFileName,
                    lineNumber: 105,
                    columnNumber: 21
                }
            }));
        }))));
    });
};
/* harmony default export */ var user_menu_RenderUserMenu = (RenderUserMenu); //# sourceMappingURL=RenderUserMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/UserDropDown/getUserLinks.js
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || getUserLinks_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function getUserLinks_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return getUserLinks_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getUserLinks_arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return getUserLinks_arrayLikeToArray(arr);
}
function getUserLinks_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}


var getUserLinks_COPY = (0,intl_dist/* defineMessages */.vU)({
    MY_ACCOUNT: {
        id: "getUserLinks.myAccount",
        defaultMessage: "My Account",
        description: "[Type: Label][Vis.: high] - This is the My account dropdown on the header."
    },
    SWITCH_ACCOUNTS: {
        id: "getUserLinks.switchAccount",
        defaultMessage: "Switch accounts",
        description: "[Type: Label][Vis.: high] - This is the Switch accounts link in the user dropdown."
    },
    MY_TEAM: {
        id: "getUserLinks.myTeam",
        defaultMessage: "My Team",
        description: "[Type: Label][Vis.: high] - This is the My teams section of the userdrop down."
    },
    LIBRARY: {
        id: "getUserLinks.library",
        defaultMessage: "Library",
        description: "[Type: Label][Vis.: high] - This is the Library link in the userdrop down."
    },
    CONTACTS: {
        id: "getUserLinks.contacts",
        defaultMessage: "Contacts",
        description: "[Type: Label][Vis.: high] - This is the contacts link in the userdrop down."
    },
    BENCHMARKS: {
        id: "getUserLinks.benchmarks",
        defaultMessage: "Benchmarks",
        description: "[Type: Label][Vis.: high] - This is the benchmarks link in the userdrop down."
    },
    SIGN_OUT: {
        id: "getUserLinks.sign_out",
        defaultMessage: "Sign Out",
        description: "[Type: Label][Vis.: high] - This is the sign out link in the userdrop down."
    }
});
var getUserLinks = function getUserLinks(isNonEnterpriseGroupAdmin, paidBenchmarksEnabled, libraryEnabled, plansBenchmarksEnabled, isEnterpriseAccount, lang, isEUDC, hasMultipleLinkedIdentities) {
    var userLinks = [
        {
            path: (0,dist.createURL)("/user/account/", {
                ut_source: "header"
            }),
            name: (0,intl_dist.t)(getUserLinks_COPY.MY_ACCOUNT),
            navItem: "my account"
        }
    ].concat(_toConsumableArray(hasMultipleLinkedIdentities ? [
        {
            path: (0,dist.createURL)("/user/account/select/", {
                ut_source: "header",
                ep: window && "".concat(window.location.pathname).concat(window.location.search)
            }),
            name: (0,intl_dist.t)(getUserLinks_COPY.SWITCH_ACCOUNTS),
            navItem: "switch accounts"
        }
    ] : []), _toConsumableArray(isNonEnterpriseGroupAdmin ? [
        {
            path: (0,dist.createURL)("/team", {
                ut_source: "header"
            }),
            name: (0,intl_dist.t)(getUserLinks_COPY.MY_TEAM),
            navItem: "my team"
        }
    ] : []), _toConsumableArray(!isEnterpriseAccount && libraryEnabled ? [
        {
            path: (0,dist.createURL)("/team/libraries", {
                ut_source: "header"
            }),
            name: (0,intl_dist.t)(getUserLinks_COPY.LIBRARY),
            navItem: "library"
        }
    ] : []), [
        {
            path: (0,dist.createURL)("/addressbook/", {
                ut_source: "header"
            }),
            name: (0,intl_dist.t)(getUserLinks_COPY.CONTACTS),
            navItem: "contacts"
        }
    ], _toConsumableArray((lang === "en" && plansBenchmarksEnabled || paidBenchmarksEnabled) && !isEUDC ? [
        {
            path: (0,dist.createURL)("/benchmarks/home/", {
                ut_source: "header_username_menu",
                ut_source2: "wide_menu"
            }),
            name: (0,intl_dist.t)(getUserLinks_COPY.BENCHMARKS),
            navItem: "benchmarks"
        }
    ] : []), [
        {
            path: (0,dist.createURL)("/user/sign-out/", {
                ut_source: "header"
            }),
            name: (0,intl_dist.t)(getUserLinks_COPY.SIGN_OUT),
            navItem: "sign out"
        }
    ]);
    return userLinks;
};
/* harmony default export */ var UserDropDown_getUserLinks = (getUserLinks); //# sourceMappingURL=getUserLinks.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/user-menu/UserMenu.js
var UserMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/user-menu/UserMenu.tsx", UserMenu_this = undefined;
function UserMenu_slicedToArray(arr, i) {
    return UserMenu_arrayWithHoles(arr) || UserMenu_iterableToArrayLimit(arr, i) || UserMenu_unsupportedIterableToArray(arr, i) || UserMenu_nonIterableRest();
}
function UserMenu_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function UserMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return UserMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UserMenu_arrayLikeToArray(o, minLen);
}
function UserMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function UserMenu_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function UserMenu_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}




// TODO: Rewrite this in local scope after gettig translations

var parseUsername = function parseUsername(username) {
    return username.length > 15 ? "".concat(username.substring(0, 9), "...") : username;
};
var UserMenu = function UserMenu() {
    var _useContext = (0,react.useContext)(wrench_HeaderContext), lang = _useContext.lang, isEUDC = _useContext.isEUDC;
    var _useUserMenuQueryLazy = useUserMenuQueryLazyQuery(), _useUserMenuQueryLazy2 = UserMenu_slicedToArray(_useUserMenuQueryLazy, 2), fetch = _useUserMenuQueryLazy2[0], _useUserMenuQueryLazy3 = _useUserMenuQueryLazy2[1], loading = _useUserMenuQueryLazy3.loading, error = _useUserMenuQueryLazy3.error, data = _useUserMenuQueryLazy3.data;
    (0,react.useEffect)(function() {
        fetch();
    }, []);
    if (loading) {
        return null;
    }
    if (error || !(data !== null && data !== void 0 && data.user)) {
        var _userLinks = UserDropDown_getUserLinks();
        return /*#__PURE__*/ react.createElement(user_menu_RenderUserMenu, {
            username: "My Account",
            menuItems: _userLinks,
            __self: UserMenu_this,
            __source: {
                fileName: UserMenu_jsxFileName,
                lineNumber: 28,
                columnNumber: 12
            }
        });
    }
    var _data$user = data.user, username = _data$user.username, preferences = _data$user.preferences, features = _data$user.features, linkedIdentities = _data$user.linkedIdentities, teamMembership = _data$user.teamMembership;
    var isTeamOwner = (teamMembership === null || teamMembership === void 0 ? void 0 : teamMembership.memberType) === "ACCOUNT_OWNER";
    var isEnterpriseAccount = teamMembership === null || teamMembership === void 0 ? void 0 : teamMembership.isEnterprise;
    var isNonEnterpriseGroupAdmin = !isEnterpriseAccount && isTeamOwner;
    var paidBenchmarksEnabled = preferences === null || preferences === void 0 ? void 0 : preferences.paidBenchmarksEnabled;
    var plansBenchmarksEnabled = features === null || features === void 0 ? void 0 : features.plansBenchmarksEnabled;
    var liteLibraryEnabled = features === null || features === void 0 ? void 0 : features.liteLibraryEnabled;
    var libraryEnabled = !!(teamMembership || liteLibraryEnabled);
    var linked = linkedIdentities !== null && linkedIdentities !== void 0 ? linkedIdentities : {
        totalCount: 0
    };
    var hasMultipleLinkedIdentities = linked.totalCount > 1;
    var userLinks = UserDropDown_getUserLinks(isNonEnterpriseGroupAdmin, paidBenchmarksEnabled, libraryEnabled, plansBenchmarksEnabled, isEnterpriseAccount, lang, isEUDC, hasMultipleLinkedIdentities);
    return /*#__PURE__*/ react.createElement(user_menu_RenderUserMenu, {
        username: parseUsername(username),
        menuItems: userLinks,
        __self: UserMenu_this,
        __source: {
            fileName: UserMenu_jsxFileName,
            lineNumber: 63,
            columnNumber: 5
        }
    });
};
/* harmony default export */ var user_menu_UserMenu = (UserMenu); //# sourceMappingURL=UserMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/user-menu/index.js
/* eslint-disable import/prefer-default-export */  //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/components/Drawer/getDrawerData.js




var getDrawerData_COPY = (0,intl_dist/* defineMessages */.vU)({
    ENTERPRISE: {
        id: "getDrawerData.enterprise",
        defaultMessage: "Enterprise",
        description: "[Type: Label][Vis.: high] - This is the Enterprise section of the side menu."
    },
    ENTERPRISE_SUBTITLE: {
        id: "getDrawerData.enterprise_subtitle",
        defaultMessage: "Get more security & control over your survey data",
        description: "[Type: Label][Vis.: high] - This is the Enterprise subtitle section of the side menu."
    },
    AUDIENCE: {
        id: "getDrawerData.audience",
        defaultMessage: "Audience",
        description: "[Type: Label][Vis.: low] - Audience section of sidemenu"
    },
    AUDIENCE_SUBTITLE: {
        id: "getDrawerData.audienceSubtitle",
        defaultMessage: "Collect survey responses from our global consumer panel",
        description: "[Type: Label][Vis.: low] - Audience subtitle of sidemenu"
    },
    INTEGRATIONS_AND_PLUGINS: {
        id: "getDrawerData.integrationsAndPlugins",
        defaultMessage: "Integrations & Plug-ins",
        description: "[Type: Label][Vis.: low] - integrations label of submenu"
    },
    INTEGRATIONS_AND_PLUGINS_SUBTITLE: {
        id: "getDrawerData.integrationsAndPluginsSubtitle",
        defaultMessage: "Easily connect survey data to existing business systems",
        description: "[Type: Label][Vis.: low] - integrations subtitle section of submenu"
    },
    WUFOO_SUBTITLE: {
        id: "getDrawerData.wufooSubtitle",
        defaultMessage: "Gather data & payments with online forms",
        description: "[Type: Label][Vis.: low] - wufoo subtitle section of submenu"
    },
    APPLY_SUBTITLE: {
        id: "getDrawerData.applySubtitle",
        defaultMessage: "Collect, review & manage applications online",
        description: "[Type: Label][Vis.: low] - apply subtitle section of submenu"
    },
    USABILLA_SUBTITLE: {
        id: "getDrawerData.usabillaSubtitle",
        defaultMessage: "Get in-the-moment feedback across all digital channels",
        description: "[Type: Label][Vis.: low] - Usabilla subtitle section of submenu"
    },
    PRODUCTS_FOOTNOTE: {
        id: "getDrawerData.productsFootnote",
        defaultMessage: "Net Promoter Score and NPS are registered trademarks of Bain & Company, Inc., Fred Reichheld and Satmetrix Systems, Inc.",
        description: "[Type: Label][Vis.: low] - products footnote section of submenu"
    },
    HELP_CENTER: {
        id: "getDrawerData.helpCenter",
        defaultMessage: "Help Center",
        description: "[Type: Label][Vis.: low] - Help Center section of submenu"
    },
    HELP_CENTER_SUBTITLE: {
        id: "getDrawerData.helpCenterSubtitle",
        defaultMessage: "Find quick answers to your questions",
        description: "[Type: Label][Vis.: low] - Help Center subtitle section of submenu"
    },
    SURVEYMONKEY_BLOG: {
        id: "getDrawerData.SurveyMonkeyBlog",
        defaultMessage: "Curiosity at Work",
        description: "[Type: Label][Vis.: low] - SurveyMonkey section of submenu"
    },
    SURVEYMONKEY_BLOG_SUBTITLE: {
        id: "getDrawerData.SurveyMonkeyBlogSubtitle",
        defaultMessage: "Get inspiration on our blog",
        description: "[Type: Label][Vis.: low] - SurveyMonkey blog subtitle of submenu"
    }
});
var getDrawerData_createURLHelper = function createURLHelper(product, program, family, interest, code) {
    var date = new Date();
    var ISODate = date.toISOString().slice(0, 10);
    var utSourceIntegrations = "header_products_launchpad_integrations_apps";
    var url = {
        ut_source: "header_products_launchpad_".concat(product) || 0,
        utm_source: "surveymonkey",
        utm_system: "product",
        utm_medium: "product",
        utm_content: "".concat(product, "-site"),
        utm_term: product,
        utm_campaign: "header_products_launchpad_".concat(product),
        adid: "",
        family: family.charAt(0).toUpperCase() + family.substring(1),
        date: ISODate,
        program: "7013A000000mY".concat(program),
        interest: interest,
        code: code,
        source: "SurveyMonkey",
        recent: "SurveyMonkey"
    };
    return url;
};
var getProductsItems = function getProductsItems(lang, isEUDC) {
    var items = [
        {
            title: (0,intl_dist.t)(getDrawerData_COPY.ENTERPRISE),
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.ENTERPRISE_SUBTITLE),
            url: (0,dist.createURL)("/mp/enterprise/", getDrawerData_createURLHelper("enterprise", "7MQAU", "Enterprise", "SME", "SME")),
            navItem: "enterprise"
        },
        !isEUDC && {
            title: (0,intl_dist.t)(getDrawerData_COPY.AUDIENCE),
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.AUDIENCE_SUBTITLE),
            url: (0,dist.createURL)("/market-research/solutions/audience-panel/", {
                ut_source: "header_products_launchpad_audience"
            }),
            navItem: "audience"
        },
        {
            title: (0,intl_dist.t)(getDrawerData_COPY.INTEGRATIONS_AND_PLUGINS),
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.INTEGRATIONS_AND_PLUGINS_SUBTITLE),
            url: (0,dist.createURL)("/apps/", getDrawerData_createURLHelper("integrations", "7RQAU", "Enterprise", "Salesforce", "SME")),
            navItem: "integrations"
        },
        hasCX(lang) && {
            title: "CX",
            subTitle: "Understand & improve customer experience (NPS\xae)",
            url: (0,dist.createURL)("https://www.surveymonkey.com/cx/", getDrawerData_createURLHelper("cx", "7bQAE", "Solutions", "CX", "CX")),
            navItem: "cx"
        },
        hasEngage(lang) && {
            title: "Engage",
            subTitle: "Understand & increase employee engagement",
            url: (0,dist.createURL)("https://www.surveymonkey.com/engage/", getDrawerData_createURLHelper("engage", "7vQAE", "Solutions", "Engage", "Engage")),
            navItem: "engage"
        },
        hasTechValidate(lang) && {
            title: "TechValidate",
            subTitle: "Create marketing content from customer feedback",
            url: (0,dist.createURL)("https://www.surveymonkey.com/techvalidate/", getDrawerData_createURLHelper("techvalidate", "880QAE", "Solutions", "TV", "TV")),
            navItem: "tech validate"
        },
        hasWufoo(lang) && {
            title: "Wufoo",
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.WUFOO_SUBTITLE),
            url: (0,dist.createURL)(languageHelpers_getWufooURL(lang), {
                ut_source: "header_products_launchpad_wufoo"
            }),
            navItem: "wufoo"
        },
        hasApply(lang) && {
            title: "Apply",
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.APPLY_SUBTITLE),
            url: (0,dist.createURL)("https://apply.surveymonkey.com/", {
                ut_source: "header_products_launchpad_apply",
                program: "7013A000000mY8AQAU"
            }),
            navItem: "apply"
        },
        hasUsabilla(lang) && {
            title: "Usabilla",
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.USABILLA_SUBTITLE),
            url: (0,dist.createURL)(languageHelpers_usabillaLink(lang), {
                utm_source: "header_products_launchpad"
            }),
            navItem: "usabilla"
        },
        hasGetFeedback(lang) && {
            title: "GetFeeback",
            subTitle: "Customer feedback for Salesforce",
            url: (0,dist.createURL)("https://www.getfeedback.com/", {
                utm_source: "surveymonkey"
            }),
            openInNewWindow: true,
            navItem: "getfeedback"
        }
    ];
    return items.filter(Boolean);
};
var getProductsfootnote = function getProductsfootnote() {
    return (0,intl_dist.t)(getDrawerData_COPY.PRODUCTS_FOOTNOTE);
};
var getResourcesItems = function getResourcesItems(lang) {
    var items = [
        {
            title: (0,intl_dist.t)(getDrawerData_COPY.HELP_CENTER),
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.HELP_CENTER_SUBTITLE),
            url: getHelpLink_getHelpCenterLink(lang, {
                params: {
                    ut_source: "product",
                    ut_source3: "header"
                }
            }),
            navItem: "help center"
        },
        showBlog(lang) && {
            title: (0,intl_dist.t)(getDrawerData_COPY.SURVEYMONKEY_BLOG),
            subTitle: (0,intl_dist.t)(getDrawerData_COPY.SURVEYMONKEY_BLOG_SUBTITLE),
            url: (0,dist.createURL)("/curiosity/", {
                ut_source: "header"
            }),
            navItem: "resource center"
        }
    ];
    return items.filter(Boolean);
}; //# sourceMappingURL=getDrawerData.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/info-menu/ProductsMenu.js
var info_menu_ProductsMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/ProductsMenu.tsx", info_menu_ProductsMenu_this = undefined;













var COPYPROD = (0,intl_dist/* defineMessages */.vU)({
    PRODUCTS: {
        id: "ProductsMenu.products",
        defaultMessage: "Products",
        description: "[Type: Label][Vis.: high] - This is the Products title of the side menu."
    }
});
var info_menu_ProductsMenu_ProductsMenu = function ProductsMenu(_ref) {
    var showProducts = _ref.showProducts, toggleProducts = _ref.toggleProducts;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), lang = _useContext.lang, isEUDC = _useContext.isEUDC;
    var classes = info_menu_useStyles();
    var itemsData = getProductsItems(lang, isEUDC);
    return /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: info_menu_ProductsMenu_this,
        __source: {
            fileName: info_menu_ProductsMenu_jsxFileName,
            lineNumber: 44,
            columnNumber: 5
        }
    }, function(matches) {
        return matches ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(NavButton, {
            onClick: toggleProducts,
            label: "Open Products list",
            active: showProducts,
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 48,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 53,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconLaunchpad */.EoF, {
            title: "Products icon",
            size: "lg",
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 54,
                columnNumber: 17
            }
        }))), /*#__PURE__*/ react.createElement(Sheet, {
            show: showProducts,
            onClose: toggleProducts,
            offsetTop: 48,
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 57,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            pt: 5,
            pl: 5,
            pr: 5,
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 58,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            variant: "sectionTitle",
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 59,
                columnNumber: 17
            }
        }, (0,intl_dist.t)(COPYPROD.PRODUCTS))), /*#__PURE__*/ react.createElement(List, {
            interactive: true,
            noRules: true,
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 63,
                columnNumber: 15
            }
        }, itemsData.map(function(props) {
            return props && /*#__PURE__*/ react.createElement(MenuItems, Object.assign({}, props, {
                key: props.title,
                __self: info_menu_ProductsMenu_this,
                __source: {
                    fileName: info_menu_ProductsMenu_jsxFileName,
                    lineNumber: 65,
                    columnNumber: 37
                }
            }));
        })), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            flexWrap: true,
            pt: 1,
            px: 5,
            pb: 6,
            className: classes.footnote,
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 68,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            variant: "bodySm",
            color: "dark",
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 69,
                columnNumber: 17
            }
        }, /*#__PURE__*/ react.createElement("em", {
            __self: info_menu_ProductsMenu_this,
            __source: {
                fileName: info_menu_ProductsMenu_jsxFileName,
                lineNumber: 70,
                columnNumber: 19
            }
        }, getProductsfootnote()))))) : itemsData.map(function(props) {
            return props && /*#__PURE__*/ react.createElement(MenuItems, Object.assign({}, props, {
                key: props.title,
                __self: info_menu_ProductsMenu_this,
                __source: {
                    fileName: info_menu_ProductsMenu_jsxFileName,
                    lineNumber: 77,
                    columnNumber: 31
                }
            }));
        });
    });
};
/* harmony default export */ var info_menu_ProductsMenu = (info_menu_ProductsMenu_ProductsMenu);
 //# sourceMappingURL=ProductsMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/info-menu/HelpMenu.js
var HelpMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/HelpMenu.tsx", HelpMenu_this = undefined;














var COPYHELP = (0,intl_dist/* defineMessages */.vU)({
    HELP: {
        id: "HelpMenu.help",
        defaultMessage: "Help",
        description: "[Type: Label][Vis.: high] - This is the Help title of the side menu."
    }
});
var HelpMenu = function HelpMenu(_ref) {
    var _HEADER_EXP$helpPanel;
    var showHelp = _ref.showHelp, toggleHelp = _ref.toggleHelp;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), lang = _useContext.lang;
    var itemsData = getResourcesItems(lang) || [];
    var _useContext2 = (0,react.useContext)(components_StaticContext/* StaticContext */.vN), _useContext2$HEADER_E = _useContext2.HEADER_EXP, HEADER_EXP = _useContext2$HEADER_E === void 0 ? {} : _useContext2$HEADER_E;
    var hostname = window.location.hostname;
    var helpUrl = getHelpLink_getHelpCenterLink(lang);
    if (hostname.includes("localmonkey") || hostname.includes("monkeytest")) {
        helpUrl = helpUrl.replace("surveymonkey", "monkeytest3");
    }
    // Help center iframe experiment
    // https://momentiveai.atlassian.net/browse/ROADMAP-4595
    // https://admin.monkeytest3.com/experiments/surveymonkey/698746
    var helpPanelTreatment = HEADER_EXP === null || HEADER_EXP === void 0 ? void 0 : (_HEADER_EXP$helpPanel = HEADER_EXP.helpPanel) === null || _HEADER_EXP$helpPanel === void 0 ? void 0 : _HEADER_EXP$helpPanel.treatment;
    var showHelpCenterIframe = helpPanelTreatment === "header_help_center_iframe_variant";
    return /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: HelpMenu_this,
        __source: {
            fileName: HelpMenu_jsxFileName,
            lineNumber: 53,
            columnNumber: 5
        }
    }, function(matches) {
        return matches ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(NavButton, {
            onClick: toggleHelp,
            label: "Open Help menu",
            active: showHelp,
            __self: HelpMenu_this,
            __source: {
                fileName: HelpMenu_jsxFileName,
                lineNumber: 57,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconHelpFilled */.PTB, {
            title: "help icon",
            size: "lg",
            __self: HelpMenu_this,
            __source: {
                fileName: HelpMenu_jsxFileName,
                lineNumber: 62,
                columnNumber: 15
            }
        })), /*#__PURE__*/ react.createElement(Sheet, {
            show: showHelp,
            onClose: toggleHelp,
            offsetTop: 48,
            __self: HelpMenu_this,
            __source: {
                fileName: HelpMenu_jsxFileName,
                lineNumber: 64,
                columnNumber: 13
            }
        }, showHelpCenterIframe ? /*#__PURE__*/ react.createElement("iframe", {
            title: "Help center",
            width: "100%",
            height: "100%",
            src: helpUrl,
            __self: HelpMenu_this,
            __source: {
                fileName: HelpMenu_jsxFileName,
                lineNumber: 66,
                columnNumber: 17
            }
        }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            pt: 5,
            pl: 5,
            pr: 5,
            __self: HelpMenu_this,
            __source: {
                fileName: HelpMenu_jsxFileName,
                lineNumber: 74,
                columnNumber: 19
            }
        }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            variant: "sectionTitle",
            __self: HelpMenu_this,
            __source: {
                fileName: HelpMenu_jsxFileName,
                lineNumber: 75,
                columnNumber: 21
            }
        }, (0,intl_dist.t)(COPYHELP.HELP))), /*#__PURE__*/ react.createElement(List, {
            interactive: true,
            noRules: true,
            __self: HelpMenu_this,
            __source: {
                fileName: HelpMenu_jsxFileName,
                lineNumber: 79,
                columnNumber: 19
            }
        }, itemsData.map(function(props) {
            return props && /*#__PURE__*/ react.createElement(MenuItems, Object.assign({}, props, {
                key: props.title,
                __self: HelpMenu_this,
                __source: {
                    fileName: HelpMenu_jsxFileName,
                    lineNumber: 82,
                    columnNumber: 34
                }
            }));
        }))))) : itemsData.map(function(props) {
            return props && /*#__PURE__*/ react.createElement(MenuItems, Object.assign({}, props, {
                key: props.title,
                __self: HelpMenu_this,
                __source: {
                    fileName: HelpMenu_jsxFileName,
                    lineNumber: 91,
                    columnNumber: 31
                }
            }));
        });
    });
};
/* harmony default export */ var info_menu_HelpMenu = (HelpMenu);
 //# sourceMappingURL=HelpMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/info-menu/InfoMenu.js
var InfoMenu_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/info-menu/InfoMenu.tsx", InfoMenu_this = undefined;
function InfoMenu_slicedToArray(arr, i) {
    return InfoMenu_arrayWithHoles(arr) || InfoMenu_iterableToArrayLimit(arr, i) || InfoMenu_unsupportedIterableToArray(arr, i) || InfoMenu_nonIterableRest();
}
function InfoMenu_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function InfoMenu_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return InfoMenu_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return InfoMenu_arrayLikeToArray(o, minLen);
}
function InfoMenu_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function InfoMenu_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function InfoMenu_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function InfoMenu_extends() {
    InfoMenu_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return InfoMenu_extends.apply(this, arguments);
}












var InfoMenu_COPY = (0,intl_dist/* defineMessages */.vU)({
    HELP: {
        id: "InfoMenu.help",
        defaultMessage: "Help",
        description: "[Type: Label][Vis.: high] - This is the Help title of the side menu."
    },
    PRODUCTS: {
        id: "InfoMenu.products",
        defaultMessage: "Products",
        description: "[Type: Label][Vis.: high] - This is the Products title of the side menu."
    }
});
var InfoMenu = function InfoMenu(_ref) {
    var rest = InfoMenu_extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var classes = info_menu_useStyles();
    var _useState = (0,react.useState)(false), _useState2 = InfoMenu_slicedToArray(_useState, 2), showProducts = _useState2[0], setShowProducts = _useState2[1];
    var _useState3 = (0,react.useState)(false), _useState4 = InfoMenu_slicedToArray(_useState3, 2), showHelp = _useState4[0], setShowHelp = _useState4[1];
    var _getClientEnvironment = (0,dist.getClientEnvironmentDetails)(), isDesktop = _getClientEnvironment.isDesktop;
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    var TrackMenuEvents = function TrackMenuEvents(menuName, opened) {
        metrics_dist.MetricsTracker.track({
            name: metrics_dist.USER_EVENTS.ELEMENT_INTERACTION,
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked menu",
                menuName: menuName,
                opened: opened
            }
        });
    };
    var toggleProducts = function toggleProducts() {
        setShowHelp(false);
        setShowProducts(!showProducts);
        TrackMenuEvents("product", !showProducts);
    };
    var toggleHelp = function toggleHelp() {
        setShowProducts(false);
        setShowHelp(!showHelp);
        TrackMenuEvents("help center", !showHelp);
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Responsive, {
        defaultMatches: !isDesktop,
        minWidth: "xl",
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 64,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", Object.assign({
        className: classes.infoMenu
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 66,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement(info_menu_ProductsMenu, {
        showProducts: showProducts,
        toggleProducts: toggleProducts,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 67,
            columnNumber: 13
        }
    })), /*#__PURE__*/ react.createElement("div", Object.assign({
        className: classes.infoMenu
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 72,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement(info_menu_HelpMenu, {
        showHelp: showHelp,
        toggleHelp: toggleHelp,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 73,
            columnNumber: 13
        }
    })))), /*#__PURE__*/ react.createElement(Responsive, {
        defaultMatches: !isDesktop,
        maxWidth: "xl",
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 77,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Accordion, {
        noRules: true,
        interactive: true,
        onChange: toggleProducts,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 79,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(Accordion.Item, {
        title: (0,intl_dist.t)(InfoMenu_COPY.PRODUCTS),
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 80,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(List, {
        noRules: true,
        interactive: true,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 81,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(info_menu_ProductsMenu, {
        showProducts: showProducts,
        toggleProducts: toggleProducts,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 82,
            columnNumber: 17
        }
    })))), /*#__PURE__*/ react.createElement(Accordion, {
        noRules: true,
        interactive: true,
        onChange: toggleHelp,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 89,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(Accordion.Item, {
        title: (0,intl_dist.t)(InfoMenu_COPY.HELP),
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 90,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(List, {
        noRules: true,
        interactive: true,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 91,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(info_menu_HelpMenu, {
        showHelp: showHelp,
        toggleHelp: toggleHelp,
        __self: InfoMenu_this,
        __source: {
            fileName: InfoMenu_jsxFileName,
            lineNumber: 92,
            columnNumber: 17
        }
    })))))));
};
/* harmony default export */ var info_menu_InfoMenu = ((/* unused pure expression or super */ null && (InfoMenu)));
 //# sourceMappingURL=InfoMenu.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/info-menu/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/variants/default/index.js
var default_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/default/index.tsx", default_this = undefined;






var variant = {
    brand: "SurveyMonkey",
    getMenuItems: function getMenuItems(experiment) {
        return [
            /*#__PURE__*/ react.createElement(navigation_BaseMenu, {
                key: "base-menu",
                experiment: experiment,
                __self: default_this,
                __source: {
                    fileName: default_jsxFileName,
                    lineNumber: 12,
                    columnNumber: 13
                }
            })
        ];
    },
    actions: [
        /*#__PURE__*/ react.createElement(actions_ButtonUser, {
            key: "action-user",
            __self: undefined,
            __source: {
                fileName: default_jsxFileName,
                lineNumber: 15,
                columnNumber: 5
            }
        }),
        /*#__PURE__*/ react.createElement(actions_ButtonCreate, {
            key: "action-create",
            __self: undefined,
            __source: {
                fileName: default_jsxFileName,
                lineNumber: 16,
                columnNumber: 5
            }
        })
    ],
    info: [
        /*#__PURE__*/ react.createElement(InfoMenu, {
            key: "menu-info",
            __self: undefined,
            __source: {
                fileName: default_jsxFileName,
                lineNumber: 18,
                columnNumber: 10
            }
        })
    ],
    user: [
        /*#__PURE__*/ react.createElement(user_menu_UserMenu, {
            key: "menu-user",
            __self: undefined,
            __source: {
                fileName: default_jsxFileName,
                lineNumber: 19,
                columnNumber: 10
            }
        })
    ],
    homePage: "/"
};
/* harmony default export */ var variants_default = (variant); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Explore.js
var Explore_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Explore.tsx", Explore_this = undefined;



var Explore_COPY = (0,intl_dist/* defineMessages */.vU)({
    EXPLORE: {
        id: "Explore.explore",
        defaultMessage: "Explore",
        description: "[Type: Label][Vis.: low] - Explore link in main navigation"
    }
});
var Explore = function Explore() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/apps/",
        label: (0,intl_dist.t)(Explore_COPY.EXPLORE),
        navItem: "my apps",
        __self: Explore_this,
        __source: {
            fileName: Explore_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Explore = ((/* unused pure expression or super */ null && (Explore)));
 //# sourceMappingURL=Explore.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Manage.js
var Manage_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Manage.tsx", Manage_this = undefined;



var Manage_COPY = (0,intl_dist/* defineMessages */.vU)({
    MANAGE: {
        id: "Manage.manage",
        defaultMessage: "Manage",
        description: "[Type: Label][Vis.: low] - Manage link in main navigation"
    }
});
var Manage = function Manage() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/apps/my-apps",
        label: (0,intl_dist.t)(Manage_COPY.MANAGE),
        navItem: "my apps",
        __self: Manage_this,
        __source: {
            fileName: Manage_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Manage = ((/* unused pure expression or super */ null && (Manage)));
 //# sourceMappingURL=Manage.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/helpers/subDomainUri.js
var subdomainUri = function subdomainUri(_ref) {
    var altdomain = _ref.altdomain, domain = _ref.domain, subdomain = _ref.subdomain, tld = _ref.tld;
    if (subdomain !== "www") {
        return "https://".concat(altdomain, ".").concat(subdomain, ".").concat(domain, ".").concat(tld);
    }
    return "https://".concat(altdomain, ".").concat(domain, ".").concat(tld);
};
/* harmony default export */ var subDomainUri = (subdomainUri);
 //# sourceMappingURL=subDomainUri.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Develop.js
var Develop_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Develop.tsx", Develop_this = undefined;





var Develop_COPY = (0,intl_dist/* defineMessages */.vU)({
    DEVELOP: {
        id: "Develop.develop",
        defaultMessage: "Develop",
        description: "[Type: Label][Vis.: low] - Develop link in main navigation"
    }
});
var Develop = function Develop() {
    var _useContext = (0,react.useContext)(components_StaticContext/* StaticContext */.vN), _useContext$environme = _useContext.environment;
    _useContext$environme = _useContext$environme === void 0 ? {
        domain: "surveymonkey",
        subdomain: "www",
        tld: "com"
    } : _useContext$environme;
    var domain = _useContext$environme.domain, subdomain = _useContext$environme.subdomain, tld = _useContext$environme.tld;
    var appsPath = subDomainUri({
        altdomain: "developer",
        domain: domain,
        subdomain: subdomain,
        tld: tld
    });
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: appsPath,
        label: (0,intl_dist.t)(Develop_COPY.DEVELOP),
        navItem: "develop",
        __self: Develop_this,
        __source: {
            fileName: Develop_jsxFileName,
            lineNumber: 32,
            columnNumber: 5
        }
    });
};
/* harmony default export */ var navigation_Develop = ((/* unused pure expression or super */ null && (Develop)));
 //# sourceMappingURL=Develop.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Partner.js
var Partner_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Partner.tsx", Partner_this = undefined;



var Partner_COPY = (0,intl_dist/* defineMessages */.vU)({
    PARTNER: {
        id: "Partner.partner",
        defaultMessage: "Partner",
        description: "[Type: Label][Vis.: low] - Partner link in main navigation"
    }
});
var Partner = function Partner() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "https://www.surveymonkey.com/mp/partner-program/",
        label: (0,intl_dist.t)(Partner_COPY.PARTNER),
        navItem: "partner",
        __self: Partner_this,
        __source: {
            fileName: Partner_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Partner = ((/* unused pure expression or super */ null && (Partner)));
 //# sourceMappingURL=Partner.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/variants/apps/index.js
var apps_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/apps/index.tsx", apps_this = undefined;






var apps = {
    brand: "SurveyMonkey",
    title: "App Directory",
    getMenuItems: function getMenuItems() {
        return [
            /*#__PURE__*/ react.createElement(Explore, {
                key: "menu-explore",
                __self: apps_this,
                __source: {
                    fileName: apps_jsxFileName,
                    lineNumber: 14,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(Manage, {
                key: "menu-manage",
                __self: apps_this,
                __source: {
                    fileName: apps_jsxFileName,
                    lineNumber: 15,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(Develop, {
                key: "menu-developer",
                __self: apps_this,
                __source: {
                    fileName: apps_jsxFileName,
                    lineNumber: 16,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(Partner, {
                key: "menu-partner",
                __self: apps_this,
                __source: {
                    fileName: apps_jsxFileName,
                    lineNumber: 17,
                    columnNumber: 7
                }
            })
        ];
    },
    actions: [],
    info: [],
    user: [
        /*#__PURE__*/ react.createElement(user_menu_UserMenu, {
            key: "menu-user",
            __self: undefined,
            __source: {
                fileName: apps_jsxFileName,
                lineNumber: 22,
                columnNumber: 10
            }
        })
    ],
    homePage: "/apps/"
};
/* harmony default export */ var variants_apps = (apps); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/variants/analyze/index.js
var analyze_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/analyze/index.tsx", analyze_this = undefined;





var analyze = {
    brand: "SurveyMonkey",
    getMenuItems: function getMenuItems(experiment) {
        return [
            /*#__PURE__*/ react.createElement(navigation_BaseMenu, {
                key: "base-menu",
                experiment: experiment,
                __self: analyze_this,
                __source: {
                    fileName: analyze_jsxFileName,
                    lineNumber: 11,
                    columnNumber: 13
                }
            })
        ];
    },
    actions: [
        /*#__PURE__*/ react.createElement(actions_ButtonCreate, {
            key: "action-create",
            __self: undefined,
            __source: {
                fileName: analyze_jsxFileName,
                lineNumber: 13,
                columnNumber: 13
            }
        })
    ],
    info: [
        /*#__PURE__*/ react.createElement(InfoMenu, {
            key: "menu-info",
            __self: undefined,
            __source: {
                fileName: analyze_jsxFileName,
                lineNumber: 14,
                columnNumber: 10
            }
        })
    ],
    user: [
        /*#__PURE__*/ react.createElement(user_menu_UserMenu, {
            key: "menu-user",
            __self: undefined,
            __source: {
                fileName: analyze_jsxFileName,
                lineNumber: 15,
                columnNumber: 10
            }
        })
    ],
    homePage: "/"
};
/* harmony default export */ var variants_analyze = (analyze); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/variants/billing/index.js
var billing_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/billing/index.tsx", billing_this = undefined;






var billing = {
    brand: "SurveyMonkey",
    getMenuItems: function getMenuItems(experiment) {
        return [
            /*#__PURE__*/ react.createElement(navigation_BaseMenu, {
                key: "base-menu",
                experiment: experiment,
                __self: billing_this,
                __source: {
                    fileName: billing_jsxFileName,
                    lineNumber: 12,
                    columnNumber: 13
                }
            })
        ];
    },
    actions: [
        /*#__PURE__*/ react.createElement(actions_ButtonUser, {
            key: "action-user",
            __self: undefined,
            __source: {
                fileName: billing_jsxFileName,
                lineNumber: 15,
                columnNumber: 5
            }
        }),
        /*#__PURE__*/ react.createElement(actions_ButtonCreate, {
            key: "action-create",
            __self: undefined,
            __source: {
                fileName: billing_jsxFileName,
                lineNumber: 16,
                columnNumber: 5
            }
        })
    ],
    info: [
        /*#__PURE__*/ react.createElement(InfoMenu, {
            key: "menu-info",
            __self: undefined,
            __source: {
                fileName: billing_jsxFileName,
                lineNumber: 18,
                columnNumber: 10
            }
        })
    ],
    user: [
        /*#__PURE__*/ react.createElement(user_menu_UserMenu, {
            key: "menu-user",
            __self: undefined,
            __source: {
                fileName: billing_jsxFileName,
                lineNumber: 19,
                columnNumber: 10
            }
        })
    ],
    homePage: "/pricing/"
};
/* harmony default export */ var variants_billing = (billing); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/MyApps.js
var MyApps_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/MyApps.tsx", MyApps_this = undefined;



var MyApps_COPY = (0,intl_dist/* defineMessages */.vU)({
    MYAPPS: {
        id: "MyApps.myApps",
        defaultMessage: "My Apps",
        description: "[Type: Label][Vis.: low] - My Apps link in main navigation"
    }
});
var MyApps = function MyApps() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/apps/",
        label: (0,intl_dist.t)(MyApps_COPY.MYAPPS),
        navItem: "my apps",
        __self: MyApps_this,
        __source: {
            fileName: MyApps_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_MyApps = ((/* unused pure expression or super */ null && (MyApps)));
 //# sourceMappingURL=MyApps.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Docs.js
var Docs_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Docs.tsx", Docs_this = undefined;



var Docs_COPY = (0,intl_dist/* defineMessages */.vU)({
    DOCS: {
        id: "Docs.docs",
        defaultMessage: "Docs",
        description: "[Type: Label][Vis.: low] - Docs link in main navigation"
    }
});
var Docs = function Docs() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/api/v3/",
        label: (0,intl_dist.t)(Docs_COPY.DOCS),
        navItem: "docs",
        __self: Docs_this,
        __source: {
            fileName: Docs_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Docs = ((/* unused pure expression or super */ null && (Docs)));
 //# sourceMappingURL=Docs.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Status.js
var Status_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Status.tsx", Status_this = undefined;



var Status_COPY = (0,intl_dist/* defineMessages */.vU)({
    STATUS: {
        id: "Status.status",
        defaultMessage: "Status",
        description: "[Type: Label][Vis.: low] - Status link in main navigation"
    }
});
var Status = function Status() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/tools/api_status/",
        label: (0,intl_dist.t)(Status_COPY.STATUS),
        navItem: "status",
        __self: Status_this,
        __source: {
            fileName: Status_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_Status = ((/* unused pure expression or super */ null && (Status)));
 //# sourceMappingURL=Status.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/FAQ.js
var FAQ_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/FAQ.tsx", FAQ_this = undefined;



var FAQ_COPY = (0,intl_dist/* defineMessages */.vU)({
    FAQ: {
        id: "FAQ.faq",
        defaultMessage: "FAQ",
        description: "[Type: Label][Vis.: low] - FAQ link in main navigation"
    }
});
var FAQ = function FAQ() {
    return /*#__PURE__*/ react.createElement(MainNavButton, {
        href: "/faq/",
        label: (0,intl_dist.t)(FAQ_COPY.FAQ),
        navItem: "faq",
        __self: FAQ_this,
        __source: {
            fileName: FAQ_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var navigation_FAQ = ((/* unused pure expression or super */ null && (FAQ)));
 //# sourceMappingURL=FAQ.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/variants/developer/index.js
var developer_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/developer/index.tsx", developer_this = undefined;







var developer = {
    brand: "SurveyMonkey",
    title: "Developer",
    getMenuItems: function getMenuItems() {
        return [
            /*#__PURE__*/ react.createElement(Home, {
                key: "menu-home",
                __self: developer_this,
                __source: {
                    fileName: developer_jsxFileName,
                    lineNumber: 15,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(MyApps, {
                key: "menu-myapps",
                __self: developer_this,
                __source: {
                    fileName: developer_jsxFileName,
                    lineNumber: 16,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(Docs, {
                key: "menu-docs",
                __self: developer_this,
                __source: {
                    fileName: developer_jsxFileName,
                    lineNumber: 17,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(Status, {
                key: "menu-status",
                __self: developer_this,
                __source: {
                    fileName: developer_jsxFileName,
                    lineNumber: 18,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(FAQ, {
                key: "menu-faq",
                __self: developer_this,
                __source: {
                    fileName: developer_jsxFileName,
                    lineNumber: 19,
                    columnNumber: 7
                }
            })
        ];
    },
    actions: [],
    info: [],
    user: [
        /*#__PURE__*/ react.createElement(user_menu_UserMenu, {
            key: "menu-user",
            __self: undefined,
            __source: {
                fileName: developer_jsxFileName,
                lineNumber: 24,
                columnNumber: 10
            }
        })
    ],
    homePage: "/"
};
/* harmony default export */ var variants_developer = (developer); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/variants/mrx/index.js
var mrx_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/variants/mrx/index.tsx", mrx_this = undefined;





var mrx_variant = {
    brand: "Momentive",
    getMenuItems: function getMenuItems() {
        return [
            /*#__PURE__*/ react.createElement(Dashboard, {
                key: "menu-dashboard",
                __self: mrx_this,
                __source: {
                    fileName: mrx_jsxFileName,
                    lineNumber: 13,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(MySurveys, {
                key: "menu-surveys",
                __self: mrx_this,
                __source: {
                    fileName: mrx_jsxFileName,
                    lineNumber: 14,
                    columnNumber: 7
                }
            }),
            /*#__PURE__*/ react.createElement(TeamMenu, {
                key: "menu-team",
                __self: mrx_this,
                __source: {
                    fileName: mrx_jsxFileName,
                    lineNumber: 15,
                    columnNumber: 7
                }
            })
        ];
    },
    actions: [],
    info: [],
    user: [
        /*#__PURE__*/ react.createElement(user_menu_UserMenu, {
            key: "menu-user",
            __self: undefined,
            __source: {
                fileName: mrx_jsxFileName,
                lineNumber: 20,
                columnNumber: 10
            }
        })
    ],
    homePage: "/"
};
/* harmony default export */ var mrx = (mrx_variant); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/variants/index.js







var variants_VARIANTS = {
    analyze: variants_analyze,
    apps: variants_apps,
    billing: variants_billing,
    default: variants_default,
    developer: variants_developer,
    mrx: mrx
}; //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/useStyles.js

var actions_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var spacing = _ref.spacing;
    return {
        actions: {
            display: "flex",
            marginRight: spacing[4],
            "& > a, & > button": {
                border: "none",
                margin: "0 ".concat(spacing[1], "px"),
                textDecoration: "none"
            }
        }
    };
});
/* harmony default export */ var actions_useStyles = (actions_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/Actions.js
var Actions_excluded = [
    "items"
];
var Actions_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/actions/Actions.tsx", Actions_this = undefined;
function Actions_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Actions_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Actions_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Actions = function Actions(_ref) {
    var items = _ref.items, rest = Actions_objectWithoutProperties(_ref, Actions_excluded);
    var theme = useHeaderTheme();
    var classes = actions_useStyles({
        theme: theme
    });
    return /*#__PURE__*/ react.createElement("div", Object.assign({
        className: classes.actions
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        __self: Actions_this,
        __source: {
            fileName: Actions_jsxFileName,
            lineNumber: 17,
            columnNumber: 5
        }
    }), items);
};
/* harmony default export */ var actions_Actions = ((/* unused pure expression or super */ null && (Actions)));
 //# sourceMappingURL=Actions.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/actions/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/title/useStyles.js

var title_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var spacing = _ref.spacing;
    return {
        title: {
            padding: [
                0,
                spacing[4],
                0,
                spacing[3]
            ]
        }
    };
});
/* harmony default export */ var title_useStyles = (title_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/title/Title.js
var Title_excluded = [
    "children",
    "titleLabel"
];
var Title_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/title/Title.tsx", Title_this = undefined;
function Title_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Title_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Title_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var Title_COPY = (0,intl_dist/* defineMessages */.vU)({
    TITLE: {
        id: "Title.TitleLabel",
        defaultMessage: "Title of page",
        description: "[Type: Label][Vis.: high] - This is the page title on the header."
    }
});
var Title = function Title(_ref) {
    var children = _ref.children, _ref$titleLabel = _ref.titleLabel, titleLabel = _ref$titleLabel === void 0 ? (0,intl_dist.t)(Title_COPY.TITLE) : _ref$titleLabel, rest = Title_objectWithoutProperties(_ref, Title_excluded);
    var classes = title_useStyles();
    return /*#__PURE__*/ react.createElement("div", Object.assign({
        className: classes.title
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        "aria-label": titleLabel,
        __self: Title_this,
        __source: {
            fileName: Title_jsxFileName,
            lineNumber: 29,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "cardTitle",
        color: "light",
        __self: Title_this,
        __source: {
            fileName: Title_jsxFileName,
            lineNumber: 30,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("strong", {
        __self: Title_this,
        __source: {
            fileName: Title_jsxFileName,
            lineNumber: 31,
            columnNumber: 9
        }
    }, children)));
}; //# sourceMappingURL=Title.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/title/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/logo/useStyles.js

var logo_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var palette = _ref.palette;
    return {
        logo: {
            color: palette.background.light
        }
    };
});
/* harmony default export */ var logo_useStyles = (logo_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/logo/MomentiveLogo.js
var MomentiveLogo_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/logo/MomentiveLogo.tsx", MomentiveLogo_this = undefined;

var MomentiveLogo_MomentiveLogo = function MomentiveLogo(_ref) {
    var label = _ref.label;
    return /*#__PURE__*/ react.createElement("svg", {
        "aria-label": label,
        viewBox: "0 0 36 24",
        "data-testid": "MomentiveLogoMark",
        width: 36,
        height: 24,
        __self: MomentiveLogo_this,
        __source: {
            fileName: MomentiveLogo_jsxFileName,
            lineNumber: 9,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "MomentiveLogoMarkGroup1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        __self: MomentiveLogo_this,
        __source: {
            fileName: MomentiveLogo_jsxFileName,
            lineNumber: 16,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "MomentiveLogoMarkGroup2",
        transform: "translate(-0.000000, 0.000000)",
        __self: MomentiveLogo_this,
        __source: {
            fileName: MomentiveLogo_jsxFileName,
            lineNumber: 23,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M19.137,11.242 C21.576,14.893 23,19.28 23,24 L36,24 L36,0 L19.137,11.242",
        id: "MomentiveLogoMarkFill11",
        fill: "#2CB2F1",
        __self: MomentiveLogo_this,
        __source: {
            fileName: MomentiveLogo_jsxFileName,
            lineNumber: 27,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M0,1 L0,24 L19.137,11.242 C15.0125,5.068 7.9825,1 0,1",
        id: "MomentiveLogoMarkFill12",
        fill: "#FFE11B",
        __self: MomentiveLogo_this,
        __source: {
            fileName: MomentiveLogo_jsxFileName,
            lineNumber: 32,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M0,24 L23,24 C23,19.28 21.576,14.893 19.137,11.242 L0,24",
        id: "MomentiveLogoMarkFill13",
        fill: "#008323",
        __self: MomentiveLogo_this,
        __source: {
            fileName: MomentiveLogo_jsxFileName,
            lineNumber: 37,
            columnNumber: 11
        }
    }))));
}; //# sourceMappingURL=MomentiveLogo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/logo/Logo.js
var Logo_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/logo/Logo.tsx", Logo_this = undefined;








var Logo_COPY = (0,intl_dist/* defineMessages */.vU)({
    LOGO: {
        id: "Logo.logoLabel",
        defaultMessage: "Brand logo",
        description: "[Type: Label][Vis.: high] - This is the brand logo on the header."
    }
});
var Logo = function Logo(_ref) {
    var _ref$brand = _ref.brand, brand = _ref$brand === void 0 ? "SurveyMonkey" : _ref$brand, _ref$label = _ref.label, label = _ref$label === void 0 ? (0,intl_dist.t)(Logo_COPY.LOGO) : _ref$label, link = _ref.link;
    var theme = useHeaderTheme();
    var classes = logo_useStyles({
        theme: theme
    });
    var _useContext = (0,react.useContext)(wrench_HeaderContext), pageURL = _useContext.pageURL, pageName = _useContext.pageName;
    return /*#__PURE__*/ react.createElement("span", {
        className: classes.logo,
        "aria-label": "logo",
        "data-sm-metrics": (0,metrics_dist.generateMetricsAttribute)({
            data: {
                url: pageURL,
                pageName: pageName,
                amplitudeEvent: "header clicked navigation",
                navItem: "logo"
            }
        }),
        __self: Logo_this,
        __source: {
            fileName: Logo_jsxFileName,
            lineNumber: 39,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("a", {
        href: link,
        className: classes.logo,
        __self: Logo_this,
        __source: {
            fileName: Logo_jsxFileName,
            lineNumber: 51,
            columnNumber: 7
        }
    }, brand === "SurveyMonkey" && /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconLogoGoldie */.jNx, {
        title: label,
        size: "xl",
        __self: Logo_this,
        __source: {
            fileName: Logo_jsxFileName,
            lineNumber: 52,
            columnNumber: 38
        }
    }), brand === "Momentive" && /*#__PURE__*/ react.createElement(MomentiveLogo_MomentiveLogo, {
        label: label,
        __self: Logo_this,
        __source: {
            fileName: Logo_jsxFileName,
            lineNumber: 53,
            columnNumber: 35
        }
    })));
}; //# sourceMappingURL=Logo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/logo/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/mobile-nav/useStylesMenuButton.js

function useStylesMenuButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function useStylesMenuButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? useStylesMenuButton_ownKeys(Object(source), !0).forEach(function(key) {
            useStylesMenuButton_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useStylesMenuButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function useStylesMenuButton_defineProperty(obj, key, value) {
    key = useStylesMenuButton_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useStylesMenuButton_toPropertyKey(arg) {
    var key = useStylesMenuButton_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function useStylesMenuButton_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var menuButtonLineStyle = {
    position: "absolute",
    height: "3px",
    width: "24px",
    background: "#fff",
    borderRadius: "2px",
    marginBottom: "6px",
    transition: "all 0.4s"
};
var useMobileNavStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var spacing = _ref.spacing;
    return {
        menuButton: function menuButton(props) {
            return useStylesMenuButton_objectSpread(useStylesMenuButton_objectSpread({
                position: "absolute",
                top: "50%"
            }, props !== null && props !== void 0 && props.left ? {
                left: spacing[5]
            } : {
                right: spacing[5]
            }), {}, {
                transform: "translateY(-50%)",
                height: "25px",
                width: "26px",
                borderRadius: 0,
                border: "none",
                boxShadow: "none",
                background: "none",
                cursor: "pointer"
            });
        },
        menuButtonLineTop: function menuButtonLineTop(_ref2) {
            var showMobileNav = _ref2.showMobileNav;
            return useStylesMenuButton_objectSpread(useStylesMenuButton_objectSpread({}, menuButtonLineStyle), {}, {
                top: "0px",
                transition: "all 0.2s",
                opacity: showMobileNav ? 0 : 1
            });
        },
        menuButtonLineMiddleLeft: function menuButtonLineMiddleLeft(_ref3) {
            var showMobileNav = _ref3.showMobileNav;
            return useStylesMenuButton_objectSpread(useStylesMenuButton_objectSpread({}, menuButtonLineStyle), {}, {
                top: "10px",
                transform: showMobileNav ? "rotate(225deg)" : null,
                width: showMobileNav ? "26px" : "24px"
            });
        },
        menuButtonLineMiddleRight: function menuButtonLineMiddleRight(_ref4) {
            var showMobileNav = _ref4.showMobileNav;
            return useStylesMenuButton_objectSpread(useStylesMenuButton_objectSpread({}, menuButtonLineStyle), {}, {
                top: "10px",
                transform: showMobileNav ? "rotate(135deg)" : null,
                width: showMobileNav ? "26px" : "24px",
                opacity: showMobileNav ? 1 : 0
            });
        },
        menuButtonLineBottom: function menuButtonLineBottom(_ref5) {
            var showMobileNav = _ref5.showMobileNav;
            return useStylesMenuButton_objectSpread(useStylesMenuButton_objectSpread({}, menuButtonLineStyle), {}, {
                top: "20px",
                transition: "all 0.2s",
                opacity: showMobileNav ? 0 : 1
            });
        }
    };
});
/* harmony default export */ var useStylesMenuButton = (useMobileNavStyles); //# sourceMappingURL=useStylesMenuButton.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/mobile-nav/MobileMenuButton.js
var MobileMenuButton_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/mobile-nav/MobileMenuButton.tsx", MobileMenuButton_this = undefined;



var MobileMenuButton = function MobileMenuButton(_ref) {
    var showMobileNav = _ref.showMobileNav, toggleMobileNav = _ref.toggleMobileNav, _ref$testid = _ref.testid, testid = _ref$testid === void 0 ? "mobile-menu-button" : _ref$testid, left = _ref.left;
    var theme = useHeaderTheme();
    var classes = useStylesMenuButton({
        showMobileNav: showMobileNav,
        left: left,
        theme: theme
    });
    return /*#__PURE__*/ react.createElement("button", {
        className: classes.menuButton,
        onClick: toggleMobileNav,
        type: "button",
        "data-testid": testid,
        __self: MobileMenuButton_this,
        __source: {
            fileName: MobileMenuButton_jsxFileName,
            lineNumber: 22,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: classes.menuButtonLineTop,
        __self: MobileMenuButton_this,
        __source: {
            fileName: MobileMenuButton_jsxFileName,
            lineNumber: 28,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("div", {
        className: classes.menuButtonLineMiddleLeft,
        __self: MobileMenuButton_this,
        __source: {
            fileName: MobileMenuButton_jsxFileName,
            lineNumber: 29,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("div", {
        className: classes.menuButtonLineMiddleRight,
        __self: MobileMenuButton_this,
        __source: {
            fileName: MobileMenuButton_jsxFileName,
            lineNumber: 30,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("div", {
        className: classes.menuButtonLineBottom,
        __self: MobileMenuButton_this,
        __source: {
            fileName: MobileMenuButton_jsxFileName,
            lineNumber: 31,
            columnNumber: 7
        }
    }));
};
/* harmony default export */ var mobile_nav_MobileMenuButton = ((/* unused pure expression or super */ null && (MobileMenuButton))); //# sourceMappingURL=MobileMenuButton.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/copy/getDrawerData.js

/* harmony default export */ var getDrawerData = ((0,intl_dist/* defineMessages */.vU)({
    ENTERPRISE: {
        id: "getDrawerData.enterprise",
        defaultMessage: "Enterprise",
        description: "[Type: Label][Vis.: high] - This is the Enterprise section of the side menu."
    },
    ENTERPRISE_SUBTITLE: {
        id: "getDrawerData.enterprise_subtitle",
        defaultMessage: "Get more security & control over your survey data",
        description: "[Type: Label][Vis.: high] - This is the Enterprise subtitle section of the side menu."
    },
    AUDIENCE: {
        id: "getDrawerData.audience",
        defaultMessage: "Audience",
        description: "[Type: Label][Vis.: low] - Audience section of sidemenu"
    },
    AUDIENCE_SUBTITLE: {
        id: "getDrawerData.audienceSubtitle",
        defaultMessage: "Collect survey responses from our global consumer panel",
        description: "[Type: Label][Vis.: low] - Audience subtitle of sidemenu"
    },
    INTEGRATIONS_AND_PLUGINS: {
        id: "getDrawerData.integrationsAndPlugins",
        defaultMessage: "Integrations & Plug-ins",
        description: "[Type: Label][Vis.: low] - integrations label of submenu"
    },
    INTEGRATIONS_AND_PLUGINS_SUBTITLE: {
        id: "getDrawerData.integrationsAndPluginsSubtitle",
        defaultMessage: "Easily connect survey data to existing business systems",
        description: "[Type: Label][Vis.: low] - integrations subtitle section of submenu"
    },
    WUFOO_SUBTITLE: {
        id: "getDrawerData.wufooSubtitle",
        defaultMessage: "Gather data & payments with online forms",
        description: "[Type: Label][Vis.: low] - wufoo subtitle section of submenu"
    },
    APPLY_SUBTITLE: {
        id: "getDrawerData.applySubtitle",
        defaultMessage: "Collect, review & manage applications online",
        description: "[Type: Label][Vis.: low] - apply subtitle section of submenu"
    },
    USABILLA_SUBTITLE: {
        id: "getDrawerData.usabillaSubtitle",
        defaultMessage: "Get in-the-moment feedback across all digital channels",
        description: "[Type: Label][Vis.: low] - Usabilla subtitle section of submenu"
    },
    PRODUCTS_FOOTNOTE: {
        id: "getDrawerData.productsFootnote",
        defaultMessage: "Net Promoter Score and NPS are registered trademarks of Bain & Company, Inc., Fred Reichheld and Satmetrix Systems, Inc.",
        description: "[Type: Label][Vis.: low] - products footnote section of submenu"
    },
    HELP_CENTER: {
        id: "getDrawerData.helpCenter",
        defaultMessage: "Help Center",
        description: "[Type: Label][Vis.: low] - Help Center section of submenu"
    },
    HELP_CENTER_SUBTITLE: {
        id: "getDrawerData.helpCenterSubtitle",
        defaultMessage: "Find quick answers to your questions",
        description: "[Type: Label][Vis.: low] - Help Center subtitle section of submenu"
    },
    SURVEYMONKEY_BLOG: {
        id: "getDrawerData.SurveyMonkeyBlog",
        defaultMessage: "Curiosity at Work",
        description: "[Type: Label][Vis.: low] - SurveyMonkey section of submenu"
    },
    SURVEYMONKEY_BLOG_SUBTITLE: {
        id: "getDrawerData.SurveyMonkeyBlogSubtitle",
        defaultMessage: "Get inspiration on our blog",
        description: "[Type: Label][Vis.: low] - SurveyMonkey blog subtitle of submenu"
    }
})); //# sourceMappingURL=getDrawerData.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/copy/Mobile.js

/* harmony default export */ var copy_Mobile = ((0,intl_dist/* defineMessages */.vU)({
    PRODUCTS: {
        id: "Mobile.products",
        defaultMessage: "Products",
        description: "[Type: Label][Vis.: high] - This is the Products title of mobile menu."
    },
    HELP: {
        id: "Mobile.help",
        defaultMessage: "Help",
        description: "[Type: Label][Vis.: high] - This is the Help title of mobile menu"
    },
    SIGN_OUT: {
        id: "Mobile.sign_out",
        defaultMessage: "Sign Out",
        description: "[Type: Label][Vis.: high] - This is the sign out link in the mobile menu."
    }
})); //# sourceMappingURL=Mobile.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/copy/getUserLinks.js

/* harmony default export */ var copy_getUserLinks = ((0,intl_dist/* defineMessages */.vU)({
    MY_ACCOUNT: {
        id: "getUserLinks.myAccount",
        defaultMessage: "My Account",
        description: "[Type: Label][Vis.: high] - This is the My account dropdown on the header."
    },
    SWITCH_ACCOUNTS: {
        id: "getUserLinks.switchAccount",
        defaultMessage: "Switch accounts",
        description: "[Type: Label][Vis.: high] - This is the Switch accounts link in the user dropdown."
    },
    MY_TEAM: {
        id: "getUserLinks.myTeam",
        defaultMessage: "My Team",
        description: "[Type: Label][Vis.: high] - This is the My teams section of the userdrop down."
    },
    LIBRARY: {
        id: "getUserLinks.library",
        defaultMessage: "Library",
        description: "[Type: Label][Vis.: high] - This is the Library link in the userdrop down."
    },
    CONTACTS: {
        id: "getUserLinks.contacts",
        defaultMessage: "Contacts",
        description: "[Type: Label][Vis.: high] - This is the contacts link in the userdrop down."
    },
    BENCHMARKS: {
        id: "getUserLinks.benchmarks",
        defaultMessage: "Benchmarks",
        description: "[Type: Label][Vis.: high] - This is the benchmarks link in the userdrop down."
    },
    SIGN_OUT: {
        id: "getUserLinks.sign_out",
        defaultMessage: "Sign Out",
        description: "[Type: Label][Vis.: high] - This is the sign out link in the userdrop down."
    }
})); //# sourceMappingURL=getUserLinks.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/config/MobileLinkInfo.js








var MobileLinkInfo_enterprise = function enterprise() {
    return {
        title: t(DrawerCopy.ENTERPRISE),
        subTitle: t(DrawerCopy.ENTERPRISE_SUBTITLE),
        url: createURL("/mp/enterprise/", createURLHelper("enterprise", "7MQAU", "Enterprise", "SME", "SME"))
    };
};
var MobileLinkInfo_audience = function audience() {
    return {
        title: t(DrawerCopy.AUDIENCE),
        subTitle: t(DrawerCopy.AUDIENCE_SUBTITLE),
        url: createURL("/market-research/solutions/audience-panel/", {
            ut_source: "header_products_launchpad_audience"
        })
    };
};
var MobileLinkInfo_integrations = function integrations() {
    return {
        title: t(DrawerCopy.INTEGRATIONS_AND_PLUGINS),
        subTitle: t(DrawerCopy.INTEGRATIONS_AND_PLUGINS_SUBTITLE),
        url: createURL("/apps/", createURLHelper("integrations", "7RQAU", "Enterprise", "Salesforce", "SME"))
    };
};
var MobileLinkInfo_cx = function cx() {
    return {
        title: "CX",
        subTitle: "Understand & improve customer experience (NPS\xae)",
        url: createURL("https://www.surveymonkey.com/cx/", createURLHelper("cx", "7bQAE", "Solutions", "CX", "CX"))
    };
};
var MobileLinkInfo_engage = function engage() {
    return {
        title: "Engage",
        subTitle: "Understand & increase employee engagement",
        url: createURL("https://www.surveymonkey.com/engage/", createURLHelper("engage", "7vQAE", "Solutions", "Engage", "Engage"))
    };
};
var MobileLinkInfo_techValidate = function techValidate() {
    return {
        title: "TechValidate",
        subTitle: "Create marketing content from customer feedback",
        url: createURL("https://www.surveymonkey.com/techvalidate/", createURLHelper("techvalidate", "880QAE", "Solutions", "TV", "TV"))
    };
};
var MobileLinkInfo_wufoo = function wufoo(lang) {
    return {
        title: "Wufoo",
        subTitle: t(DrawerCopy.WUFOO_SUBTITLE),
        url: createURL(getWufooURL(lang), {
            ut_source: "header_products_launchpad_wufoo"
        })
    };
};
var MobileLinkInfo_apply = function apply() {
    return {
        title: "Apply",
        subTitle: t(DrawerCopy.APPLY_SUBTITLE),
        url: createURL("https://apply.surveymonkey.com/", {
            ut_source: "header_products_launchpad_apply",
            program: "7013A000000mY8AQAU"
        })
    };
};
var MobileLinkInfo_usabilla = function usabilla(lang) {
    return {
        title: "Usabilla",
        subTitle: t(DrawerCopy.USABILLA_SUBTITLE),
        url: createURL(usabillaLink(lang), {
            utm_source: "header_products_launchpad"
        })
    };
};
var MobileLinkInfo_getFeedback = function getFeedback() {
    return {
        title: "GetFeedback",
        subTitle: "Customer feedback for Salesforce",
        url: createURL("https://www.getfeedback.com/", {
            utm_source: "surveymonkey"
        }),
        openInNewWindow: true
    };
};
var MobileLinkInfo_helpCenter = function helpCenter(lang) {
    return {
        title: t(DrawerCopy.HELP_CENTER),
        subTitle: t(DrawerCopy.HELP_CENTER_SUBTITLE),
        url: getHelpCenterLink(lang, {
            params: {
                ut_source: "header"
            }
        })
    };
};
var MobileLinkInfo_blog = function blog() {
    return {
        title: t(DrawerCopy.SURVEYMONKEY_BLOG),
        subTitle: t(DrawerCopy.SURVEYMONKEY_BLOG_SUBTITLE),
        url: createURL("/curiosity/", {
            ut_source: "header"
        })
    };
};
var products = function products() {
    return {
        title: t(MobileCopy.PRODUCTS)
    };
};
var help = function help() {
    return {
        title: t(MobileCopy.HELP)
    };
};
var myAccount = function myAccount() {
    return {
        url: createURL("/user/account/", {
            ut_source: "header"
        }),
        title: t(UserLinkCopy.MY_ACCOUNT)
    };
};
var switchAccount = function switchAccount() {
    return {
        url: createURL("/user/account/select/", {
            ut_source: "header",
            ep: window && "".concat(window.location.pathname).concat(window.location.search)
        }),
        title: t(UserLinkCopy.SWITCH_ACCOUNTS)
    };
};
var team = function team() {
    return {
        url: createURL("/team", {
            ut_source: "header"
        }),
        title: t(UserLinkCopy.MY_TEAM)
    };
};
var library = function library() {
    return {
        url: createURL("/team/libraries", {
            ut_source: "header"
        }),
        title: t(UserLinkCopy.LIBRARY)
    };
};
var contacts = function contacts() {
    return {
        url: createURL("/addressbook/", {
            ut_source: "header"
        }),
        title: t(UserLinkCopy.CONTACTS)
    };
};
var benchmark = function benchmark() {
    return {
        url: createURL("/benchmarks/home/", {
            ut_source: "header_username_menu",
            ut_source2: "wide_menu"
        }),
        title: t(UserLinkCopy.BENCHMARKS)
    };
};
var signOut = function signOut() {
    return {
        url: (0,dist.createURL)("/user/sign-out/", {
            ut_source: "header"
        }),
        title: (0,intl_dist.t)(copy_getUserLinks.SIGN_OUT)
    };
}; //# sourceMappingURL=MobileLinkInfo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/mobile-nav/useStyles.js

function useStyles_defineProperty(obj, key, value) {
    key = mobile_nav_useStyles_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_nav_useStyles_toPropertyKey(arg) {
    var key = mobile_nav_useStyles_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function mobile_nav_useStyles_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var useStyles_useMobileNavStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var breakpoints = _ref.breakpoints, palette = _ref.palette, spacing = _ref.spacing, radius = _ref.radius, height = _ref.height;
    return {
        mobileNavContainer: function mobileNavContainer(props) {
            var _ref2;
            return _ref2 = {
                display: "flex",
                justifyContent: props !== null && props !== void 0 && props.title ? "left" : "center",
                alignItems: "center",
                width: "100%",
                height: spacing[7],
                color: palette.text.dark
            }, useStyles_defineProperty(_ref2, "@media (min-width: ".concat(breakpoints.md, "px)"), {
                justifyContent: "left",
                marginLeft: spacing[8]
            }), useStyles_defineProperty(_ref2, "& > div > div > .wds-overlay", {
                top: height
            }), _ref2;
        },
        mobileNavBoxFull: {
            width: "100%"
        },
        mobileNavLogo: function mobileNavLogo(props) {
            return {
                width: props !== null && props !== void 0 && props.title ? "initial" : "100%",
                textAlign: props !== null && props !== void 0 && props.title ? "left" : "center"
            };
        },
        createButton: {
            display: "inline-block",
            backgroundColor: palette.primary.main,
            color: palette.text.light,
            padding: spacing[4],
            position: "fixed",
            right: spacing[4],
            bottom: spacing[4],
            borderRadius: radius.large
        },
        mobileNavMenu: {
            "& > ul > li, & > ul > ul > li ": {
                '& > [role="button"], & > a': {
                    borderLeft: "8px solid transparent",
                    borderBottom: "solid 1px ".concat(palette.border.main),
                    "&:hover, &:active, &:focus": {
                        background: palette.background.light,
                        borderLeft: "8px solid ".concat(palette.primary.main)
                    }
                },
                '& > [role="region"] > ul li > a': {
                    borderLeft: "8px solid transparent",
                    background: palette.background.accent,
                    "&:hover, &:focus": {
                        borderLeft: "8px solid ".concat(palette.primary.main)
                    }
                }
            }
        }
    };
});
/* harmony default export */ var mobile_nav_useStyles = (useStyles_useMobileNavStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/mobile-nav/MobileNav.js
var MobileNav_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/mobile-nav/MobileNav.tsx", MobileNav_this = undefined;
function MobileNav_slicedToArray(arr, i) {
    return MobileNav_arrayWithHoles(arr) || MobileNav_iterableToArrayLimit(arr, i) || MobileNav_unsupportedIterableToArray(arr, i) || MobileNav_nonIterableRest();
}
function MobileNav_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileNav_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileNav_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileNav_arrayLikeToArray(o, minLen);
}
function MobileNav_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function MobileNav_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function MobileNav_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}















var MobileNav_COPY = (0,intl_dist/* defineMessages */.vU)({
    CREATE_SURVEY_LABEL: {
        id: "MobileNav.createSurvey",
        defaultMessage: "Create survey icon",
        description: "[Type: Label][Vis.: low] - Create Survey plus button on mobile"
    },
    MENU_ICON_LABEL: {
        id: "MobileNav.menuIcon",
        defaultMessage: "Menu icon",
        description: "[Type: Label][Vis.: low] - Mobile navigation menu button icon"
    },
    CLOSE_ICON_LABEL: {
        id: "MobileNav.closeIcon",
        defaultMessage: "Close menu icon",
        description: "[Type: Label][Vis.: low] - Mobile navigation close button icon"
    }
});
var MobileNav = function MobileNav(_ref) {
    var brand = _ref.brand, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, userMenu = _ref.userMenu, navItems = _ref.navItems, link = _ref.link, infoMenu = _ref.infoMenu, create = _ref.create;
    var theme = useHeaderTheme();
    var classes = mobile_nav_useStyles({
        title: title,
        theme: theme
    });
    var _useState = (0,react.useState)(false), _useState2 = MobileNav_slicedToArray(_useState, 2), showMobileNav = _useState2[0], setShowMobileNav = _useState2[1];
    var toggleMobileNav = function toggleMobileNav() {
        return setShowMobileNav(!showMobileNav);
    };
    var _getClientEnvironment = (0,dist.getClientEnvironmentDetails)(), isDesktop = _getClientEnvironment.isDesktop;
    return /*#__PURE__*/ react.createElement(Responsive, {
        maxWidth: "xl",
        defaultMatches: !isDesktop,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 69,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, create && /*#__PURE__*/ react.createElement(Responsive, {
        maxWidth: "md",
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 72,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement("a", {
        href: (0,dist.createURL)("/create/", {
            ut_source: "header"
        }),
        className: classes.createButton,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 73,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconPlus */.SC9, {
        size: "xl",
        title: (0,intl_dist.t)(MobileNav_COPY.CREATE_SURVEY_LABEL),
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 77,
            columnNumber: 15
        }
    }))), /*#__PURE__*/ react.createElement("div", {
        className: classes.mobileNavContainer,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 81,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        className: classes.mobileNavBoxFull,
        display: "flex",
        flexAlign: "center",
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 82,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "md",
        defaultMatches: !isDesktop,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 87,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MobileMenuButton, {
        showMobileNav: showMobileNav,
        toggleMobileNav: toggleMobileNav,
        testid: "tablet-menu-button",
        left: true,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 89,
            columnNumber: 17
        }
    }), /*#__PURE__*/ react.createElement(Logo, {
        brand: brand,
        link: link,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 95,
            columnNumber: 17
        }
    }))), /*#__PURE__*/ react.createElement(Responsive, {
        maxWidth: "md",
        defaultMatches: !isDesktop,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 98,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(MobileMenuButton, {
        showMobileNav: showMobileNav,
        toggleMobileNav: toggleMobileNav,
        left: !title,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 100,
            columnNumber: 17
        }
    }), /*#__PURE__*/ react.createElement("div", {
        className: classes.mobileNavLogo,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 105,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(Logo, {
        brand: brand,
        link: link,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 106,
            columnNumber: 19
        }
    })))), title && /*#__PURE__*/ react.createElement(Title, {
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 110,
            columnNumber: 23
        }
    }, title)), /*#__PURE__*/ react.createElement(Sheet, {
        showCloseButton: true,
        onClose: toggleMobileNav,
        show: showMobileNav,
        placement: "left",
        offsetTop: 48,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 112,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        className: classes.mobileNavMenu,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 119,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(List, {
        noRules: true,
        interactive: true,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 120,
            columnNumber: 15
        }
    }, navItems), infoMenu, !!userMenu && /*#__PURE__*/ react.createElement(Responsive, {
        maxWidth: "md",
        defaultMatches: !isDesktop,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 125,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(List, {
        interactive: true,
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 126,
            columnNumber: 19
        }
    }, userMenu, /*#__PURE__*/ react.createElement(SubMenuItem_SubMenuItem, Object.assign({}, signOut(), {
        __self: MobileNav_this,
        __source: {
            fileName: MobileNav_jsxFileName,
            lineNumber: 128,
            columnNumber: 21
        }
    })))))))));
};
/* harmony default export */ var mobile_nav_MobileNav = ((/* unused pure expression or super */ null && (MobileNav)));
 //# sourceMappingURL=MobileNav.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/mobile-nav/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/nav-bar/useStyles.js

function useStyles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function useStyles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? useStyles_ownKeys(Object(source), !0).forEach(function(key) {
            nav_bar_useStyles_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useStyles_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function nav_bar_useStyles_defineProperty(obj, key, value) {
    key = nav_bar_useStyles_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function nav_bar_useStyles_toPropertyKey(arg) {
    var key = nav_bar_useStyles_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function nav_bar_useStyles_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var nav_bar_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(theme) {
    var text = theme.text, background = theme.background, height = theme.height, spacing = theme.spacing;
    return {
        navBar: useStyles_objectSpread(useStyles_objectSpread({}, (0,utils_dist_index_es/* defaultFonts */.FZ)(theme)), {}, {
            position: "relative",
            backgroundColor: background.main,
            color: text.main,
            width: "100%",
            margin: 0,
            zIndex: 1000,
            height: height
        }),
        navBarBox: {
            whiteSpace: "nowrap",
            padding: "0 ".concat(spacing[5], "px")
        }
    };
});
/* harmony default export */ var nav_bar_useStyles = (nav_bar_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/nav-bar/NavBar.js
var NavBar_excluded = [
    "children"
];
var NavBar_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/nav-bar/NavBar.tsx", NavBar_this = undefined;
function NavBar_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = NavBar_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function NavBar_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var NavBar = function NavBar(_ref) {
    var children = _ref.children, rest = NavBar_objectWithoutProperties(_ref, NavBar_excluded);
    var theme = useHeaderTheme();
    var classes = nav_bar_useStyles({
        theme: theme
    });
    return /*#__PURE__*/ react.createElement("header", Object.assign({
        className: classes.navBar
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        __self: NavBar_this,
        __source: {
            fileName: NavBar_jsxFileName,
            lineNumber: 17,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexDirection: "row",
        flexAlign: "center",
        flexJustify: "space-between",
        className: classes.navBarBox,
        __self: NavBar_this,
        __source: {
            fileName: NavBar_jsxFileName,
            lineNumber: 18,
            columnNumber: 7
        }
    }, children));
};
/* harmony default export */ var nav_bar_NavBar = ((/* unused pure expression or super */ null && (NavBar)));
 //# sourceMappingURL=NavBar.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/nav-bar/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/useStyles.js

var navigation_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var palette = _ref.palette, spacing = _ref.spacing;
    return {
        navigation: {
            marginLeft: spacing[4],
            "& > ul": {
                listStyle: "none",
                margin: 0,
                padding: 0,
                display: "flex"
            }
        }
    };
});
/* harmony default export */ var navigation_useStyles = (navigation_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/Navigation.js
var Navigation_excluded = [
    "items"
];
var Navigation_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/navigation/Navigation.tsx", Navigation_this = undefined;
function Navigation_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Navigation_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Navigation_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Navigation = function Navigation(_ref) {
    var items = _ref.items, rest = Navigation_objectWithoutProperties(_ref, Navigation_excluded);
    var classes = navigation_useStyles();
    return /*#__PURE__*/ react.createElement("nav", Object.assign({
        className: classes.navigation
    }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), {
        __self: Navigation_this,
        __source: {
            fileName: Navigation_jsxFileName,
            lineNumber: 14,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("ul", {
        __self: Navigation_this,
        __source: {
            fileName: Navigation_jsxFileName,
            lineNumber: 15,
            columnNumber: 7
        }
    }, items));
};
/* harmony default export */ var navigation_Navigation = ((/* unused pure expression or super */ null && (Navigation)));
 //# sourceMappingURL=Navigation.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/components/navigation/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/useStyles.js

var wrench_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)({
    navSection: {
        display: "flex",
        alignItems: "center"
    }
});
/* harmony default export */ var wrench_useStyles = (wrench_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/UserContext.generated.js

var UserContext_generated_templateObject;
function UserContext_generated_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function UserContext_generated_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? UserContext_generated_ownKeys(Object(source), !0).forEach(function(key) {
            UserContext_generated_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UserContext_generated_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function UserContext_generated_defineProperty(obj, key, value) {
    key = UserContext_generated_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UserContext_generated_toPropertyKey(arg) {
    var key = UserContext_generated_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function UserContext_generated_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function UserContext_generated_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
/* eslint-disable */ 

var UserContext_generated_defaultOptions = {};
var UserContextQueryDocument = lib(UserContext_generated_templateObject || (UserContext_generated_templateObject = UserContext_generated_taggedTemplateLiteral([
    "\n  query userContextQuery {\n    user {\n      id\n      features {\n        loggedInHomePage\n      }\n      preferences {\n        hasSeenLIHPWelcomeModal\n        newHomePageEnabled\n      }\n      package {\n        id\n        canonicalName\n      }\n    }\n  }\n"
])));
/**
 * __useUserContextQueryQuery__
 *
 * To run a query within a React component, call `useUserContextQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserContextQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserContextQueryQuery({
 *   variables: {
 *   },
 * });
 */ function useUserContextQueryQuery(baseOptions) {
    var options = UserContext_generated_objectSpread(UserContext_generated_objectSpread({}, UserContext_generated_defaultOptions), baseOptions);
    return react_hooks_esm/* useQuery */.aM(UserContextQueryDocument, options);
}
function useUserContextQueryLazyQuery(baseOptions) {
    var options = UserContext_generated_objectSpread(UserContext_generated_objectSpread({}, UserContext_generated_defaultOptions), baseOptions);
    return ApolloReactHooks.useLazyQuery(UserContextQueryDocument, options);
} //# sourceMappingURL=UserContext.generated.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/Header.js
var wrench_Header_jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/Header.tsx", wrench_Header_this = undefined;















var getUserContext = function getUserContext(loading, data) {
    if (loading || !(data && data.user)) return undefined;
    return {
        userId: data.user.id,
        packageId: data.user.package.id,
        packageName: data.user.package.canonicalName,
        hasLIHPFeature: data.user.features.loggedInHomePage,
        hasSeenLIHPWelcomeModal: data.user.preferences.hasSeenLIHPWelcomeModal,
        homePageEnabled: data.user.preferences.newHomePageEnabled
    };
};
var HeaderContent = function HeaderContent(_ref) {
    var _headerVariant$brand, _document$location$pa;
    var isEUDC = _ref.isEUDC, lang = _ref.lang, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "default" : _ref$variant, _ref$title = _ref.title, title = _ref$title === void 0 ? "" : _ref$title, session = _ref.session;
    var classes = wrench_useStyles();
    var _useContext = (0,react.useContext)(components_StaticContext/* StaticContext */.vN), _useContext$HEADER_EX = _useContext.HEADER_EXP, HEADER_EXP = _useContext$HEADER_EX === void 0 ? {} : _useContext$HEADER_EX;
    var _HEADER_EXP$isThemeTr = HEADER_EXP.isThemeTreatment, isThemeTreatment = _HEADER_EXP$isThemeTr === void 0 ? false : _HEADER_EXP$isThemeTr;
    var themeTreatment = isThemeTreatment || variant === "mrx" ? "Momentive" : "SurveyMonkey";
    var headerVariant = variants_VARIANTS[variant];
    var headerBrand = (_headerVariant$brand = headerVariant.brand) !== null && _headerVariant$brand !== void 0 ? _headerVariant$brand : themeTreatment;
    var headerTitle = title || headerVariant.title;
    var _useUserContextQueryQ = useUserContextQueryQuery(), loading = _useUserContextQueryQ.loading, data = _useUserContextQueryQ.data;
    var _getClientEnvironment = (0,dist.getClientEnvironmentDetails)(), isNode = _getClientEnvironment.isNode, isDesktop = _getClientEnvironment.isDesktop;
    return /*#__PURE__*/ react.createElement(wrench_HeaderContext.Provider, {
        value: {
            isEUDC: isEUDC,
            lang: lang,
            session: session,
            user: getUserContext(loading, data),
            // first segment of the pathname
            pageName: !isNode ? ((_document$location$pa = document.location.pathname.split("/")) === null || _document$location$pa === void 0 ? void 0 : _document$location$pa[1]) || "" : "",
            pageURL: !isNode ? document.location.pathname : ""
        },
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 69,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(NavBar, {
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 82,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(MobileNav, {
        brand: headerBrand,
        title: headerVariant.title,
        navItems: headerVariant.getMenuItems(HEADER_EXP),
        userMenu: headerVariant.user,
        link: headerVariant.homePage,
        infoMenu: headerVariant.info,
        create: headerVariant.actions.length > 0,
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 83,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "md",
        defaultMatches: isDesktop,
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 92,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("span", {
        className: classes.navSection,
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 94,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 95,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(Logo, {
        brand: headerBrand,
        link: headerVariant.homePage,
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 96,
            columnNumber: 17
        }
    })), /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 98,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, headerTitle && /*#__PURE__*/ react.createElement(Title, {
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 100,
            columnNumber: 35
        }
    }, headerTitle), /*#__PURE__*/ react.createElement(Navigation, {
        items: headerVariant.getMenuItems(HEADER_EXP),
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 101,
            columnNumber: 19
        }
    })))), /*#__PURE__*/ react.createElement("span", {
        className: classes.navSection,
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 105,
            columnNumber: 13
        }
    }, headerVariant.actions && /*#__PURE__*/ react.createElement(Actions, {
        items: headerVariant.actions,
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 107,
            columnNumber: 17
        }
    }), /*#__PURE__*/ react.createElement(Responsive, {
        minWidth: "xl",
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 109,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(react.Fragment, null, headerVariant.info)), headerVariant.user)))));
};
var HeaderWithTheme = withHeaderTheme(HeaderContent);
var Header = function Header(props) {
    return /*#__PURE__*/ react.createElement(HeaderWithTheme, Object.assign({
        theme: "elevate"
    }, props, {
        __self: wrench_Header_this,
        __source: {
            fileName: wrench_Header_jsxFileName,
            lineNumber: 124,
            columnNumber: 10
        }
    }));
};
/* harmony default export */ var wrench_Header = (Header);
 //# sourceMappingURL=Header.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/wrench/index.js

/* harmony default export */ var wrench = (wrench_Header); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Header/index.js
var components_Header_jsxFileName = "/repo/packages/webassets/src/components/Header/index.js", components_Header_this = undefined;






var components_Header_Header = function Header(_ref) {
    var isAnonHeaderSticky = _ref.isAnonHeaderSticky, color = _ref.color, isUserAuthenticated = _ref.isUserAuthenticated, showCreateSurveyButton = _ref.showCreateSurveyButton, lang = _ref.lang, variant = _ref.variant, isEUDC = _ref.isEUDC, actionFlow = _ref.actionFlow, user = _ref.user, isMRX = _ref.isMRX, displayLICTA = _ref.displayLICTA, showDrawer = _ref.showDrawer, excludeMenuItems = _ref.excludeMenuItems, showLoginButton = _ref.showLoginButton, showSignupButton = _ref.showSignupButton, alwaysUseAnonymousNav = _ref.alwaysUseAnonymousNav, Logo = _ref.Logo, brand = _ref.brand, wrenchVariant = _ref.wrenchVariant, title = _ref.title;
    var session = user.session;
    return user.isAuthenticated && isUserAuthenticated ? /*#__PURE__*/ react.createElement(wrench, {
        variant: wrenchVariant,
        title: title,
        isEUDC: isEUDC,
        lang: lang,
        session: session,
        __self: components_Header_this,
        __source: {
            fileName: components_Header_jsxFileName,
            lineNumber: 36,
            columnNumber: 9
        }
    }) : /*#__PURE__*/ react.createElement(Header_Header, {
        isAnonHeaderSticky: isAnonHeaderSticky,
        color: color,
        isUserAuthenticated: isUserAuthenticated,
        showCreateSurveyButton: showCreateSurveyButton,
        lang: lang,
        variant: variant,
        isEUDC: isEUDC,
        actionFlow: actionFlow,
        user: user,
        isMRX: isMRX,
        displayLICTA: displayLICTA,
        showDrawer: showDrawer,
        excludeMenuItems: excludeMenuItems,
        showLoginButton: showLoginButton,
        showSignupButton: showSignupButton,
        alwaysUseAnonymousNav: alwaysUseAnonymousNav,
        Logo: Logo,
        brand: brand,
        __self: components_Header_this,
        __source: {
            fileName: components_Header_jsxFileName,
            lineNumber: 45,
            columnNumber: 9
        }
    });
};
components_Header_Header.propTypes = {
    isAnonHeaderSticky: (prop_types_default()).bool,
    color: prop_types_default().oneOf(Object.values(enums/* HEADER_COLOR */.Nt)),
    isUserAuthenticated: prop_types_default().oneOfType([
        (prop_types_default()).bool,
        (prop_types_default()).object
    ]),
    showCreateSurveyButton: (prop_types_default()).bool,
    lang: (prop_types_default()).string.isRequired,
    variant: prop_types_default().oneOf(Object.values(enums/* HEADER_VARIANT */.Jf)),
    isEUDC: (prop_types_default()).bool.isRequired,
    actionFlow: (prop_types_default()).string,
    user: (prop_types_default()).object.isRequired,
    // eslint-disable-line react/forbid-prop-types
    isMRX: (prop_types_default()).bool,
    displayLICTA: (prop_types_default()).bool,
    showDrawer: (prop_types_default()).bool,
    excludeMenuItems: prop_types_default().arrayOf(prop_types_default().oneOf(ValidMenuNameList)),
    showLoginButton: (prop_types_default()).bool,
    showSignupButton: (prop_types_default()).bool,
    alwaysUseAnonymousNav: (prop_types_default()).bool,
    Logo: prop_types_default().oneOfType([
        (prop_types_default()).node,
        (prop_types_default()).object
    ]),
    brand: prop_types_default().oneOf(Object.values(enums/* BRAND */.cg)),
    wrenchVariant: (prop_types_default()).string,
    title: (prop_types_default()).string
};
components_Header_Header.defaultProps = {
    isAnonHeaderSticky: true,
    color: "primary",
    isUserAuthenticated: false,
    showCreateSurveyButton: true,
    displayLICTA: true,
    showDrawer: true,
    variant: "default",
    actionFlow: "header",
    isMRX: false,
    excludeMenuItems: [],
    showLoginButton: true,
    showSignupButton: true,
    alwaysUseAnonymousNav: false,
    Logo: undefined,
    brand: enums/* BRAND.SURVEYMONKEY */.cg.SURVEYMONKEY,
    wrenchVariant: "default",
    title: undefined
};
/* harmony default export */ var components_Header = (components_Header_Header);
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/LanguageMenu/helpers/getFooterLanguageList.js

var getFooterLanguageList = function getFooterLanguageList(url, tld) {
    var languages = (0,locale_dist/* getSiteSupportedLanguages */.qA)();
    var languageInfo = (0,locale_dist/* getTldLanguageInfo */.UJ)(tld);
    if (!url) {
        return [];
    }
    return languages.map(function(language) {
        var dataCenterId = (0,locale_dist/* getDataCenterIdFromCurrentUrl */.Ep)(url);
        var dataCenter = (0,locale_dist/* getDataCenterById */.dC)(dataCenterId);
        var subdomain = (0,locale_dist/* getSubdomainFromLanguageCodeAndDataCenter */.gP)(language.code, dataCenterId);
        var langTld = "com";
        var primaryCCTldExistsForLanguage = language.tld !== "com";
        var notOnCCTldCurrenty = [
            "com",
            "net"
        ].includes(tld);
        var languageSupportedByCurrentCCTld = languageInfo === null || languageInfo === void 0 ? void 0 : languageInfo.supportedLanguages.includes(language.code);
        if (primaryCCTldExistsForLanguage && dataCenter.CCTldSupport && (notOnCCTldCurrenty || !languageSupportedByCurrentCCTld)) {
            var _language$tld;
            subdomain = (0,locale_dist/* getDefaultSubdomainForDataCenter */.Rt)(dataCenterId);
            langTld = (_language$tld = language.tld) !== null && _language$tld !== void 0 ? _language$tld : "";
        } else if (languageSupportedByCurrentCCTld && dataCenter.CCTldSupport) {
            langTld = tld;
        }
        return {
            name: language.name,
            subdomain: subdomain,
            tld: langTld,
            displayName: language.displayName
        };
    });
};
/* harmony default export */ var helpers_getFooterLanguageList = (getFooterLanguageList); //# sourceMappingURL=getFooterLanguageList.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/InlineList/useStyles.js

function InlineList_useStyles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function InlineList_useStyles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? InlineList_useStyles_ownKeys(Object(source), !0).forEach(function(key) {
            InlineList_useStyles_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InlineList_useStyles_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function InlineList_useStyles_defineProperty(obj, key, value) {
    key = InlineList_useStyles_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function InlineList_useStyles_toPropertyKey(arg) {
    var key = InlineList_useStyles_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function InlineList_useStyles_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var InlineList_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var palette = _ref.palette, spacing = _ref.spacing, type = _ref.type;
    return {
        inlineList: function inlineList(_ref2) {
            var noMargin = _ref2.noMargin;
            return {
                display: "table",
                margin: noMargin ? 0 : [
                    0,
                    0,
                    spacing[4]
                ],
                paddingLeft: 0,
                paddingRight: 0
            };
        },
        inlineListItem: function inlineListItem(_ref3) {
            var isTitle = _ref3.isTitle;
            return InlineList_useStyles_objectSpread(InlineList_useStyles_objectSpread({
                display: isTitle ? "table-cell" : "inline-block",
                listStyle: "disc none",
                margin: [
                    0,
                    spacing[4],
                    spacing[1],
                    0
                ],
                position: "relative",
                fontSize: type.fontSize.bodySm,
                color: palette.text.darkMuted
            }, isTitle && {
                fontWeight: type.fontWeight.medium,
                width: spacing[9],
                listStyleType: "none"
            }), {}, {
                "&:last-child": {
                    marginRight: 0
                }
            });
        },
        inlineListItemBullet: {
            position: "absolute",
            right: -spacing[3],
            top: 0
        },
        inlineListItemAnchor: {
            color: palette.text.darkMuted,
            textDecoration: "none",
            "&:visited": {
                color: palette.text.darkMuted
            },
            "&:hover, &:focus": {
                color: palette.text.dark,
                textDecoration: "underline"
            }
        }
    };
});
/* harmony default export */ var InlineList_useStyles = (InlineList_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/InlineList/InlineList.js
var InlineList_excluded = [
    "children",
    "noMargin"
];
var InlineList_jsxFileName = "/repo/packages/webassets/src/components/Footer/InlineList/InlineList.tsx", InlineList_this = undefined;
function InlineList_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = InlineList_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function InlineList_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var InlineList = function InlineList(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? "" : _ref$children, _ref$noMargin = _ref.noMargin, noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin, rest = InlineList_objectWithoutProperties(_ref, InlineList_excluded);
    var _useStyles = InlineList_useStyles({
        noMargin: noMargin
    }), inlineList = _useStyles.inlineList;
    return /*#__PURE__*/ react.createElement("ul", Object.assign({
        className: inlineList
    }, rest, {
        __self: InlineList_this,
        __source: {
            fileName: InlineList_jsxFileName,
            lineNumber: 17,
            columnNumber: 5
        }
    }), children);
};
/* harmony default export */ var InlineList_InlineList = (InlineList); //# sourceMappingURL=InlineList.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/InlineList/InlineListItem.js
var InlineListItem_excluded = [
    "children",
    "className",
    "isTitle",
    "href",
    "anchorAttributes",
    "lastItem"
];
var InlineListItem_jsxFileName = "/repo/packages/webassets/src/components/Footer/InlineList/InlineListItem.tsx", InlineListItem_this = undefined;
function InlineListItem_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = InlineListItem_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function InlineListItem_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var InlineListItem = function InlineListItem(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? "" : _ref$children, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, _ref$isTitle = _ref.isTitle, isTitle = _ref$isTitle === void 0 ? false : _ref$isTitle, _ref$href = _ref.href, href = _ref$href === void 0 ? "" : _ref$href, _ref$anchorAttributes = _ref.anchorAttributes, anchorAttributes = _ref$anchorAttributes === void 0 ? null : _ref$anchorAttributes, _ref$lastItem = _ref.lastItem, lastItem = _ref$lastItem === void 0 ? false : _ref$lastItem, rest = InlineListItem_objectWithoutProperties(_ref, InlineListItem_excluded);
    var _useStyles = InlineList_useStyles({
        isTitle: isTitle
    }), inlineListItem = _useStyles.inlineListItem, inlineListItemBullet = _useStyles.inlineListItemBullet, inlineListItemAnchor = _useStyles.inlineListItemAnchor;
    var showBullet = !isTitle && !lastItem;
    var inlineListItemAnchorMerged = classnames_default()(inlineListItemAnchor, className);
    return /*#__PURE__*/ react.createElement("li", Object.assign({
        className: inlineListItem
    }, rest, {
        __self: InlineListItem_this,
        __source: {
            fileName: InlineListItem_jsxFileName,
            lineNumber: 36,
            columnNumber: 5
        }
    }), !!href ? [
        /*#__PURE__*/ react.createElement("a", Object.assign({
            className: inlineListItemAnchorMerged,
            href: href
        }, anchorAttributes, {
            __self: InlineListItem_this,
            __source: {
                fileName: InlineListItem_jsxFileName,
                lineNumber: 39,
                columnNumber: 11
            },
            key: "0"
        }), children),
        showBullet ? /*#__PURE__*/ react.createElement("span", {
            className: inlineListItemBullet,
            __self: InlineListItem_this,
            __source: {
                fileName: InlineListItem_jsxFileName,
                lineNumber: 47,
                columnNumber: 13
            },
            key: "1"
        }, "•") : null
    ] : children);
};
/* harmony default export */ var InlineList_InlineListItem = (InlineListItem); //# sourceMappingURL=InlineListItem.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/InlineList/index.js

 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/SMFooterContext.js

var SMFooterContext_excluded = [
    "children"
];
var SMFooterContext_jsxFileName = "/repo/packages/webassets/src/components/Footer/SMFooterContext.tsx", SMFooterContext_this = undefined;
function SMFooterContext_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function SMFooterContext_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? SMFooterContext_ownKeys(Object(source), !0).forEach(function(key) {
            SMFooterContext_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SMFooterContext_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function SMFooterContext_defineProperty(obj, key, value) {
    key = SMFooterContext_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SMFooterContext_toPropertyKey(arg) {
    var key = SMFooterContext_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function SMFooterContext_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function SMFooterContext_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = SMFooterContext_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SMFooterContext_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var SMFooterContext = /*#__PURE__*/ (0,react.createContext)({});
var SMFooterContext_Provider = SMFooterContext.Provider;
var FooterContext = function FooterContext(_ref) {
    var children = _ref.children, props = SMFooterContext_objectWithoutProperties(_ref, SMFooterContext_excluded);
    return /*#__PURE__*/ react.createElement(SMFooterContext_Provider, {
        value: SMFooterContext_objectSpread({}, props),
        __self: SMFooterContext_this,
        __source: {
            fileName: SMFooterContext_jsxFileName,
            lineNumber: 28,
            columnNumber: 3
        }
    }, children);
};
FooterContext.propTypes = {
    children: (prop_types_default()).node.isRequired
};
 //# sourceMappingURL=SMFooterContext.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/LanguageMenu/LanguageListLO.js
var LanguageListLO_jsxFileName = "/repo/packages/webassets/src/components/Footer/LanguageMenu/LanguageListLO.tsx", LanguageListLO_this = undefined;






var LanguageListLO_COPY = (0,intl_dist/* defineMessages */.vU)({
    LANGUAGES: {
        id: "LanguageListLO.languageMenu",
        defaultMessage: "Language:",
        description: "[Type: Label][Vis.: med] - A label for logged out footer language list"
    }
});
var LanguageListLO = function LanguageListLO() {
    var _useContext = (0,react.useContext)(SMFooterContext), subdomain = _useContext.subdomain, domain = _useContext.domain, _useContext$tld = _useContext.tld, tld = _useContext$tld === void 0 ? "com" : _useContext$tld, url = _useContext.url;
    // if SSR, build the url from the request
    var SSRUrl = "https://".concat(subdomain, ".").concat(domain, ".").concat(tld).concat(url);
    var envDetails = (0,dist.getClientEnvironmentDetails)();
    var location = new URL(envDetails.isBrowser ? window.location.href : SSRUrl);
    var languages = helpers_getFooterLanguageList(location.href, tld);
    var languageItems = languages.map(function(lang) {
        return /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
            key: lang.name,
            href: "https://".concat(lang.subdomain, ".").concat(domain, ".").concat(lang.tld).concat(location.pathname, "?ut_source=footer"),
            __self: LanguageListLO_this,
            __source: {
                fileName: LanguageListLO_jsxFileName,
                lineNumber: 31,
                columnNumber: 7
            }
        }, lang.displayName);
    });
    return /*#__PURE__*/ react.createElement(InlineList_InlineList, {
        __self: LanguageListLO_this,
        __source: {
            fileName: LanguageListLO_jsxFileName,
            lineNumber: 40,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
        isTitle: true,
        __self: LanguageListLO_this,
        __source: {
            fileName: LanguageListLO_jsxFileName,
            lineNumber: 41,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: LanguageListLO_COPY.LANGUAGES,
        __self: LanguageListLO_this,
        __source: {
            fileName: LanguageListLO_jsxFileName,
            lineNumber: 42,
            columnNumber: 9
        }
    })), languageItems);
};
/* harmony default export */ var LanguageMenu_LanguageListLO = (LanguageListLO); //# sourceMappingURL=LanguageListLO.js.map

;// CONCATENATED MODULE: ./node_modules/@wds/button-group/dist/index.es.js




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var button_group_dist_index_es_assign = function() {
    button_group_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return button_group_dist_index_es_assign.apply(this, arguments);
};

function button_group_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var button_group_dist_index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var palette = theme.palette, radius = theme.radius, shadow = theme.shadow;
    var button = {
        borderRadius: radius.small,
        boxShadow: shadow.none,
    };
    return {
        wrenchButtonGroup: function (_a) {
            var radio = _a.radio;
            return ({
                display: 'inline-flex',
                boxShadow: button.boxShadow,
                borderRadius: button.borderRadius,
                // supports Buttons as well as Buttons that are nested in a Menu
                '& > button, & > a, & > span > button, & > span > a': {
                    borderRadius: 0,
                    boxShadow: 'none',
                    marginLeft: 0,
                    marginRight: 0,
                },
                '& > button:first-child, & > a:first-child, & > span:first-child > button, & > span:first-child > a': {
                    borderTopLeftRadius: button.borderRadius,
                    borderBottomLeftRadius: button.borderRadius,
                },
                '& > button:last-child, & > a:last-child, & > span:last-child > button, & > span:last-child > a': {
                    borderTopRightRadius: button.borderRadius,
                    borderBottomRightRadius: button.borderRadius,
                },
                '& > button:not(.wrenchButton--ghost):not(:first-child), & > a:not(.wrenchButton--ghost):not(:first-child), & > span:not(:first-child) > button:not(.wrenchButton--ghost), & > span:not(:first-child) > a:not(.wrenchButton--ghost)': {
                    borderLeft: [1, 'solid', palette.background.light],
                    borderLeftWidth: radio && '0',
                },
                '& > button.wrenchButton--ghost:not(:first-child), & > a.wrenchButton--ghost:not(:first-child), & > span:not(:first-child) > button.wrenchButton--ghost, & > span:not(:first-child) > a.wrenchButton--ghost': {
                    borderLeft: 'none',
                },
                '& > button.wrenchButton--alt:not(:first-child), & > a.wrenchButton--alt:not(:first-child), & > span:not(:first-child) > button.wrenchButton--alt, & > span:not(:first-child) > a.wrenchButton--alt': {
                    borderLeft: 'none',
                },
            });
        },
    };
});

var ButtonGroup = function (_a) {
    var radio = _a.radio, children = _a.children, props = button_group_dist_index_es_rest(_a, ["radio", "children"]);
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var wrenchButtonGroup = button_group_dist_index_es_useStyles({ radio: radio, theme: theme }).wrenchButtonGroup;
    return (react.createElement("div", button_group_dist_index_es_assign({ role: "group", className: wrenchButtonGroup }, (0,utils_dist_index_es/* safeRest */.Q6)(props)), children));
};
ButtonGroup.defaultProps = {
    radio: false,
};



;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/LanguageMenu/LanguageMenuLI.js
var LanguageMenuLI_jsxFileName = "/repo/packages/webassets/src/components/Footer/LanguageMenu/LanguageMenuLI.tsx", LanguageMenuLI_this = undefined;
function LanguageMenuLI_slicedToArray(arr, i) {
    return LanguageMenuLI_arrayWithHoles(arr) || LanguageMenuLI_iterableToArrayLimit(arr, i) || LanguageMenuLI_unsupportedIterableToArray(arr, i) || LanguageMenuLI_nonIterableRest();
}
function LanguageMenuLI_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function LanguageMenuLI_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return LanguageMenuLI_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LanguageMenuLI_arrayLikeToArray(o, minLen);
}
function LanguageMenuLI_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function LanguageMenuLI_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function LanguageMenuLI_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}







var LanguageMenuLI = function LanguageMenuLI(_ref) {
    var _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? "en" : _ref$lang;
    var _useState = (0,react.useState)(false), _useState2 = LanguageMenuLI_slicedToArray(_useState, 2), show = _useState2[0], setShow = _useState2[1];
    var orderedLILanguages = (0,locale_dist/* getSiteSupportedLanguages */.qA)().filter(function(language) {
        return language.code !== lang;
    }).sort(function(a, b) {
        var _a$displayOrder, _b$displayOrder;
        return ((_a$displayOrder = a.displayOrder) !== null && _a$displayOrder !== void 0 ? _a$displayOrder : 0) - ((_b$displayOrder = b.displayOrder) !== null && _b$displayOrder !== void 0 ? _b$displayOrder : 0);
    });
    var handleChange = function handleChange() {
        return setShow(function(s) {
            return !s;
        });
    };
    var currentLanguageName = getLanguageNameFromCode(lang);
    var menuTrigger = /*#__PURE__*/ react.createElement("div", {
        onChange: handleChange,
        __self: LanguageMenuLI_this,
        __source: {
            fileName: LanguageMenuLI_jsxFileName,
            lineNumber: 26,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(ButtonGroup, {
        __self: LanguageMenuLI_this,
        __source: {
            fileName: LanguageMenuLI_jsxFileName,
            lineNumber: 27,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        size: "sm",
        color: "secondary",
        __self: LanguageMenuLI_this,
        __source: {
            fileName: LanguageMenuLI_jsxFileName,
            lineNumber: 28,
            columnNumber: 9
        }
    }, currentLanguageName), /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        size: "sm",
        color: "secondary",
        label: "Language dropdown",
        __self: LanguageMenuLI_this,
        __source: {
            fileName: LanguageMenuLI_jsxFileName,
            lineNumber: 31,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconCaretDown */.KCe, {
        title: "Language dropdown",
        __self: LanguageMenuLI_this,
        __source: {
            fileName: LanguageMenuLI_jsxFileName,
            lineNumber: 32,
            columnNumber: 11
        }
    }))));
    return /*#__PURE__*/ react.createElement(index_es_Menu, {
        dense: true,
        placement: "top-left",
        show: show,
        menuTrigger: menuTrigger,
        __self: LanguageMenuLI_this,
        __source: {
            fileName: LanguageMenuLI_jsxFileName,
            lineNumber: 39,
            columnNumber: 5
        }
    }, orderedLILanguages.map(function(langItem) {
        return /*#__PURE__*/ react.createElement(index_es_Menu.Item, {
            key: langItem.code,
            isNavigable: true,
            navigationTarget: "/user/language?languageid=".concat(langItem.id, "&ut_source=footer"),
            __self: LanguageMenuLI_this,
            __source: {
                fileName: LanguageMenuLI_jsxFileName,
                lineNumber: 42,
                columnNumber: 11
            }
        }, langItem.displayName);
    }));
};
/* harmony default export */ var LanguageMenu_LanguageMenuLI = (LanguageMenuLI); //# sourceMappingURL=LanguageMenuLI.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/LanguageMenu/index.js

 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/FooterLinks/helpers/getFooterCopy.js

var getFooterCopy_COPY = (0,intl_dist/* defineMessages */.vU)({
    ABOUT_SURVEYMONKEY: {
        id: "getFooterCopy.aboutSurveymonkey",
        defaultMessage: "About SurveyMonkey",
        description: "[Type: Label][Vis.: med] - About Footer Link"
    },
    ABOUT_PRIVATE_LABEL: {
        id: "getFooterCopy.privateLabel",
        defaultMessage: "About {label}",
        description: "[Type: Label][Vis: med] - Private footer link"
    },
    CAREERS: {
        id: "getFooterCopy.careers",
        defaultMessage: "Careers",
        description: "[Type: Label][Vis.: med] - Careers Footer Link"
    },
    DEVELOPERS: {
        id: "getFooterCopy.developers",
        defaultMessage: "Developers",
        description: "[Type: Label][Vis.: med] - Developers Footer Link"
    },
    PRIVACY_NOTICE: {
        id: "getFooterCopy.privacyNotice",
        defaultMessage: "Privacy Notice",
        description: "[Type: Label][Vis.: med] - Privacy Notice Footer Link"
    },
    CALIFORNIA_PRIVACY_NOTICE: {
        id: "getFooterCopy.californiaPrivacyNotice",
        defaultMessage: "California Privacy Notice",
        description: "[Type: Label][Vis.: med] - California Privacy Notice Footer Link"
    },
    EMAIL_OPT_IN: {
        id: "getFooterCopy.emailOptIn",
        defaultMessage: "Email Opt-In",
        description: "[Type: Label][Vis.: med] - Email Opt-In Footer Link"
    },
    HELP: {
        id: "getFooterCopy.help",
        defaultMessage: "Help",
        description: "[Type: Label][Vis.: med] - Help Footer Link"
    },
    COOKIES_NOTICE: {
        id: "getFooterCopy.cookiesNotice",
        defaultMessage: "Cookies Notice",
        description: "[Type: Label][Vis.: med] - Cookies Notice Link"
    },
    OFFICE_LOCATIONS: {
        id: "getFooterCopy.officeLocations",
        defaultMessage: "Office Locations",
        description: "[Type: Label][Vis.: med] - Office Locations Link"
    },
    COMMUNITY: {
        id: "getFooterCopy.community",
        defaultMessage: "Community:",
        description: "[Type: Label][Vis.: med] - Community Link"
    },
    OUR_BLOG: {
        id: "getFooterCopy.ourBlog",
        defaultMessage: "Our Blog",
        description: "[Type: Label][Vis.: med] - Our Blog Link"
    },
    ABOUT_US: {
        id: "getFooterCopy.aboutUs",
        defaultMessage: "About Us:",
        description: "[Type: Label][Vis.: med] - About Us Link"
    },
    LEADERSHIP_TEAM: {
        id: "getFooterCopy.leadershipTeam",
        defaultMessage: "Leadership Team",
        description: "[Type: Label][Vis.: med] - Leadership Team Link"
    },
    BOARD_OF_DIRECTORS: {
        id: "getFooterCopy.boardOfDirectors",
        defaultMessage: "Board of Directors",
        description: "[Type: Label][Vis.: med] - Board of Directors Link"
    },
    INVESTOR_RELATIONS: {
        id: "getFooterCopy.investorRelations",
        defaultMessage: "Investor Relations",
        description: "[Type: Label][Vis.: med] - Investor Relations Link"
    },
    APP_DIRECTORY: {
        id: "getFooterCopy.appDirectory",
        defaultMessage: "App Directory",
        description: "[Type: Label][Vis.: med] - App directory Link"
    },
    NEWSROOM: {
        id: "getFooterCopy.newsroom",
        defaultMessage: "Newsroom",
        description: "[Type: Label][Vis.: med] - Newsroom Link"
    },
    PAYMENT_METHODS: {
        id: "getFooterCopy.paymentMethods",
        defaultMessage: "Payment Methods",
        description: "[Type: Label][Vis.: med] - Payment Methods Link"
    },
    IMPRINT: {
        id: "getFooterCopy.imprint",
        defaultMessage: "Imprint",
        description: "[Type: Label][Vis.: med] - Imprint Link"
    },
    SITEMAP: {
        id: "getFooterCopy.siteMap",
        defaultMessage: "Sitemap",
        description: "[Type: Label][Vis.: med] - Site Map Link"
    },
    POLICIES: {
        id: "getFooterCopy.policies",
        defaultMessage: "Policies:",
        description: "[Type: Label][Vis.: med] - Policies Link"
    },
    TERMS_OF_USE: {
        id: "getFooterCopy.termsOfUse",
        defaultMessage: "Terms of Use",
        description: "[Type: Label][Vis.: med] - Terms of Use Link"
    },
    ACCEPTABLE_USES_POLICY: {
        id: "getFooterCopy.acceptableUsesPolicy",
        defaultMessage: "Acceptable Uses Policy",
        description: "[Type: Label][Vis.: med] - Acceptable Uses Policy Link"
    },
    SECURITY_STATEMENT: {
        id: "getFooterCopy.securityStatement",
        defaultMessage: "Security Statement",
        description: "[Type: Label][Vis.: med] - Security Statement Link"
    },
    GDPR_COMPLIANCE: {
        id: "getFooterCopy.gdprCompliance",
        defaultMessage: "GDPR Compliance",
        description: "[Type: Label][Vis.: med] - GDPR Compliance Link"
    },
    ACCESSIBILITY: {
        id: "getFooterCopy.accessibility",
        defaultMessage: "Accessibility",
        description: "[Type: Label][Vis.: med] - Accessibility Link"
    }
});
/* harmony default export */ var getFooterCopy = (getFooterCopy_COPY); //# sourceMappingURL=getFooterCopy.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/FooterLinks/helpers/getAnonFooterLinks.js
function getAnonFooterLinks_toConsumableArray(arr) {
    return getAnonFooterLinks_arrayWithoutHoles(arr) || getAnonFooterLinks_iterableToArray(arr) || getAnonFooterLinks_unsupportedIterableToArray(arr) || getAnonFooterLinks_nonIterableSpread();
}
function getAnonFooterLinks_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function getAnonFooterLinks_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return getAnonFooterLinks_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getAnonFooterLinks_arrayLikeToArray(o, minLen);
}
function getAnonFooterLinks_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function getAnonFooterLinks_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return getAnonFooterLinks_arrayLikeToArray(arr);
}
function getAnonFooterLinks_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}





var getSlimLinks = function getSlimLinks(lang) {
    return [
        {
            title: (0,intl_dist.t)(getFooterCopy.ABOUT_SURVEYMONKEY),
            url: (0,dist.createURL)("/mp/aboutus/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.PRIVACY_NOTICE),
            url: (0,dist.createURL)("/mp/legal/privacy/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.CALIFORNIA_PRIVACY_NOTICE),
            url: (0,dist.createURL)("/mp/legal/region-specific-privacy-statement/", {
                ut_source: "footer"
            }),
            anchorAttributes: {
                rel: "nofollow"
            }
        }
    ].concat(getAnonFooterLinks_toConsumableArray(lang === "de" ? [
        {
            title: "Impressum",
            url: (0,dist.createURL)("/mp/impressum/", {
                ut_source: "footer"
            })
        }
    ] : []), [
        {
            title: (0,intl_dist.t)(getFooterCopy.EMAIL_OPT_IN),
            url: (0,dist.createURL)("/user/email-opt-in/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.OFFICE_LOCATIONS),
            url: (0,dist.createURL)("/mp/aboutus/office-locations/", {
                ut_source: "footer"
            }),
            lastItem: true
        }
    ]);
};
var getCommunityLinks = function getCommunityLinks(domain, lang) {
    return [
        {
            title: (0,intl_dist.t)(getFooterCopy.COMMUNITY),
            url: "https://www.facebook.com/surveymonkey/",
            isTitle: true
        }
    ].concat(getAnonFooterLinks_toConsumableArray(showBlog(lang) ? [
        {
            title: (0,intl_dist.t)(getFooterCopy.OUR_BLOG),
            url: (0,dist.createURL)("/curiosity/", {
                ut_source: "footer"
            })
        }
    ] : []), [
        {
            title: "Facebook",
            url: "https://www.facebook.com/surveymonkey/"
        },
        {
            title: "Twitter",
            url: "https://twitter.com/SurveyMonkey"
        },
        {
            title: "LinkedIn",
            url: "https://www.linkedin.com/company/surveymonkey/"
        },
        {
            title: "Instagram",
            url: "https://www.instagram.com/surveymonkey/"
        },
        {
            title: "YouTube",
            url: "https://www.youtube.com/surveymonkey"
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.DEVELOPERS),
            url: (0,dist.createURL)("https://developer.".concat(domain, ".com"), {
                ut_source: "footer"
            }),
            lastItem: true
        }
    ]);
};
var getAboutUsLinks = function getAboutUsLinks(domain, lang, country) {
    return [
        {
            title: (0,intl_dist.t)(getFooterCopy.ABOUT_US),
            url: (0,dist.createURL)("/mp/aboutus/", {
                ut_source: "footer"
            }),
            isTitle: true
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.LEADERSHIP_TEAM),
            url: (0,dist.createURL)("/mp/aboutus/leadership/", {
                ut_source: "footer"
            })
        }
    ].concat(getAnonFooterLinks_toConsumableArray(showBoardOfDirectorsLink(lang) ? [
        {
            title: (0,intl_dist.t)(getFooterCopy.BOARD_OF_DIRECTORS),
            url: (0,dist.createURL)("/mp/aboutus/directors/", {
                ut_source: "footer"
            })
        }
    ] : []), getAnonFooterLinks_toConsumableArray(showNewsRoom(lang, country) ? [
        {
            title: (0,intl_dist.t)(getFooterCopy.INVESTOR_RELATIONS),
            url: "https://investor.surveymonkey.com/"
        }
    ] : []), [
        {
            title: (0,intl_dist.t)(getFooterCopy.APP_DIRECTORY),
            url: (0,dist.createURL)("/apps/", {
                ut_source: "footer"
            })
        }
    ], getAnonFooterLinks_toConsumableArray(showNewsRoom(lang, country) ? [
        {
            title: (0,intl_dist.t)(getFooterCopy.NEWSROOM),
            url: (0,dist.createURL)("/newsroom/", {
                ut_source: "footer"
            })
        }
    ] : []), [
        {
            title: (0,intl_dist.t)(getFooterCopy.OFFICE_LOCATIONS),
            url: (0,dist.createURL)("/mp/aboutus/office-locations/", {
                ut_source: "footer"
            })
        }
    ], getAnonFooterLinks_toConsumableArray(showDachPaymentLinks(lang, country) ? [
        {
            title: "Impressum",
            url: (0,dist.createURL)("/mp/impressum/", {
                ut_source: "footer"
            })
        }
    ] : []), getAnonFooterLinks_toConsumableArray(showDachPaymentLinks(lang, country) ? [
        {
            title: (0,intl_dist.t)(getFooterCopy.PAYMENT_METHODS),
            url: getHelpLink_getHelpCenterLink(lang, {
                path: "billing/payment-methods",
                params: {
                    ut_source: "footer"
                }
            })
        }
    ] : []), getAnonFooterLinks_toConsumableArray(showImprintLink(lang, country) ? [
        {
            title: (0,intl_dist.t)(getFooterCopy.IMPRINT),
            url: (0,dist.createURL)("www.".concat(domain, "/mp/imprint"), {
                ut_source: "footer"
            })
        }
    ] : []), [
        {
            title: (0,intl_dist.t)(getFooterCopy.CAREERS),
            url: (0,dist.createURL)("/careers/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.SITEMAP),
            url: (0,dist.createURL)("/mp/sitemap/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.HELP),
            url: getHelpLink_getHelpCenterLink(lang, {
                params: {
                    ut_source: "footer"
                }
            }),
            lastItem: true
        }
    ]);
};
var getPolicesLink = function getPolicesLink(lang) {
    return [
        {
            title: (0,intl_dist.t)(getFooterCopy.POLICIES),
            url: (0,dist.createURL)("/mp/legal/", {
                ut_source: "footer"
            }),
            isTitle: true
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.TERMS_OF_USE),
            url: (0,dist.createURL)("/mp/legal/terms-of-use/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.PRIVACY_NOTICE),
            url: (0,dist.createURL)("/mp/legal/privacy/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.CALIFORNIA_PRIVACY_NOTICE),
            url: (0,dist.createURL)("/mp/legal/region-specific-privacy-statement/", {
                ut_source: "footer"
            }),
            anchorAttributes: {
                rel: "nofollow"
            }
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.ACCEPTABLE_USES_POLICY),
            url: (0,dist.createURL)("/mp/legal/acceptable-uses-policy/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.SECURITY_STATEMENT),
            url: (0,dist.createURL)("/mp/legal/security/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.GDPR_COMPLIANCE),
            url: (0,dist.createURL)("/mp/privacy/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.EMAIL_OPT_IN),
            url: (0,dist.createURL)("/user/email-opt-in/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.ACCESSIBILITY),
            url: getHelpLink_getHelpCenterLink(lang, {
                path: "create/accessibility",
                params: {
                    ut_source: "footer"
                }
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.COOKIES_NOTICE),
            url: (0,dist.createURL)("/mp/legal/cookies/", {
                ut_source: "footer"
            })
        }
    ];
};
var getAnonCategories = function getAnonCategories() {
    var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var country = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var variant = arguments.length > 3 ? arguments[3] : undefined;
    var defaultLinks = [
        getCommunityLinks(domain, lang),
        getAboutUsLinks(domain, lang, country),
        getPolicesLink(lang)
    ];
    var slimLinks = [
        getSlimLinks(lang)
    ];
    return variant === "default" ? defaultLinks : slimLinks;
}; //# sourceMappingURL=getAnonFooterLinks.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/FooterLinks/helpers/getAuthFooterLinks.js
function getAuthFooterLinks_toConsumableArray(arr) {
    return getAuthFooterLinks_arrayWithoutHoles(arr) || getAuthFooterLinks_iterableToArray(arr) || getAuthFooterLinks_unsupportedIterableToArray(arr) || getAuthFooterLinks_nonIterableSpread();
}
function getAuthFooterLinks_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function getAuthFooterLinks_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return getAuthFooterLinks_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getAuthFooterLinks_arrayLikeToArray(o, minLen);
}
function getAuthFooterLinks_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function getAuthFooterLinks_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return getAuthFooterLinks_arrayLikeToArray(arr);
}
function getAuthFooterLinks_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}




var getPrivateLabelAuthFooter = function getPrivateLabelAuthFooter(lang) {
    return [
        {
            title: (0,intl_dist.t)(getFooterCopy.ABOUT_PRIVATE_LABEL, {
                label: "Momentive"
            }),
            url: (0,dist.createURL)("https://www.momentive.ai/about/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.CAREERS),
            url: (0,dist.createURL)("https://www.surveymonkey.com/careers/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.DEVELOPERS),
            url: (0,dist.createURL)("https://developer.surveymonkey.com/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.PRIVACY_NOTICE),
            url: (0,dist.createURL)("https://www.surveymonkey.com/mp/legal/privacy/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.CALIFORNIA_PRIVACY_NOTICE),
            url: (0,dist.createURL)("https://www.surveymonkey.com/mp/legal/region-specific-privacy-statement/", {
                ut_source: "footer"
            })
        }
    ].concat(getAuthFooterLinks_toConsumableArray(lang === "de" ? [
        {
            title: "Impressum",
            url: (0,dist.createURL)("https://www.surveymonkey.com/mp/impressum/", {
                ut_source: "footer"
            })
        }
    ] : []), [
        {
            title: (0,intl_dist.t)(getFooterCopy.EMAIL_OPT_IN),
            url: (0,dist.createURL)("https://www.surveymonkey.com/user/email-opt-in/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.HELP),
            url: getHelpLink_getHelpCenterLink(lang, {
                params: {
                    ut_source: "footer"
                }
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.COOKIES_NOTICE),
            url: (0,dist.createURL)("https://www.surveymonkey.com/mp/legal/cookies/", {
                ut_source: "footer"
            })
        }
    ]);
};
var getAuthFooterLinks = function getAuthFooterLinks(domain, lang) {
    var isPrivateLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (isPrivateLabel) {
        return getPrivateLabelAuthFooter(lang);
    }
    return [
        isPrivateLabel ? {
            title: (0,intl_dist.t)(getFooterCopy.ABOUT_PRIVATE_LABEL, {
                label: "Momentive"
            }),
            url: (0,dist.createURL)("/about/", {
                ut_source: "footer"
            })
        } : {
            title: (0,intl_dist.t)(getFooterCopy.ABOUT_SURVEYMONKEY),
            url: (0,dist.createURL)("/mp/aboutus/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.CAREERS),
            url: (0,dist.createURL)("/careers/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.DEVELOPERS),
            url: (0,dist.createURL)("https://developer.".concat(domain, ".com/"), {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.PRIVACY_NOTICE),
            url: (0,dist.createURL)("/mp/legal/privacy/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.CALIFORNIA_PRIVACY_NOTICE),
            url: (0,dist.createURL)("/mp/legal/region-specific-privacy-statement/", {
                ut_source: "footer"
            })
        }
    ].concat(getAuthFooterLinks_toConsumableArray(lang === "de" ? [
        {
            title: "Impressum",
            url: (0,dist.createURL)("/mp/impressum/", {
                ut_source: "footer"
            })
        }
    ] : []), [
        {
            title: (0,intl_dist.t)(getFooterCopy.EMAIL_OPT_IN),
            url: (0,dist.createURL)("/user/email-opt-in/", {
                ut_source: "footer"
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.HELP),
            url: getHelpLink_getHelpCenterLink(lang, {
                params: {
                    ut_source: "footer"
                }
            })
        },
        {
            title: (0,intl_dist.t)(getFooterCopy.COOKIES_NOTICE),
            url: (0,dist.createURL)("/mp/legal/cookies/", {
                ut_source: "footer"
            })
        }
    ]);
};
/* harmony default export */ var helpers_getAuthFooterLinks = (getAuthFooterLinks); //# sourceMappingURL=getAuthFooterLinks.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/FooterLinks/helpers/index.js

 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/FooterLinks/AnonFooterLinks.js
var AnonFooterLinks_jsxFileName = "/repo/packages/webassets/src/components/Footer/FooterLinks/AnonFooterLinks.tsx", AnonFooterLinks_this = undefined;




var AnonFooterLinks = function AnonFooterLinks() {
    var _useContext = (0,react.useContext)(SMFooterContext), domain = _useContext.domain, lang = _useContext.lang, country = _useContext.country, variant = _useContext.variant, onetrustBannerEnabled = _useContext.onetrustBannerEnabled;
    var categories = getAnonCategories(domain, lang, country, variant);
    var margin = variant === "slim";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, categories.map(function(category, i) {
        return /*#__PURE__*/ react.createElement(InlineList_InlineList, {
            key: category[0].title,
            noMargin: margin,
            __self: AnonFooterLinks_this,
            __source: {
                fileName: AnonFooterLinks_jsxFileName,
                lineNumber: 26,
                columnNumber: 9
            }
        }, category.map(function(item) {
            return /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
                href: item.url,
                anchorAttributes: item.anchorAttributes,
                key: item.title,
                isTitle: item.isTitle,
                lastItem: item.lastItem,
                __self: AnonFooterLinks_this,
                __source: {
                    fileName: AnonFooterLinks_jsxFileName,
                    lineNumber: 28,
                    columnNumber: 13
                }
            }, item.title);
        }), i === 2 && !!onetrustBannerEnabled ? /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
            href: "#cookiePreferences",
            className: "ot-sdk-show-settings",
            "data-testid": "AnonFooterLinks__cookiePreferences",
            lastItem: true,
            __self: AnonFooterLinks_this,
            __source: {
                fileName: AnonFooterLinks_jsxFileName,
                lineNumber: 40,
                columnNumber: 13
            }
        }) : null);
    }));
};
/* harmony default export */ var FooterLinks_AnonFooterLinks = (AnonFooterLinks); //# sourceMappingURL=AnonFooterLinks.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/CopyRight/useStyles.js

var CopyRight_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var palette = _ref.palette, type = _ref.type;
    return {
        copyRight: {
            fontSize: type.fontSize.bodySm,
            color: palette.text.darkMuted
        }
    };
});
/* harmony default export */ var CopyRight_useStyles = (CopyRight_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/CopyRight/index.js
var CopyRight_jsxFileName = "/repo/packages/webassets/src/components/Footer/CopyRight/index.tsx", CopyRight_this = undefined;



var CopyRight = function CopyRight() {
    var _useContext = (0,react.useContext)(SMFooterContext), isPrivateLabel = _useContext.isPrivateLabel;
    var _useStyles = CopyRight_useStyles(), copyRight = _useStyles.copyRight;
    var year = new Date().getFullYear();
    return !!isPrivateLabel ? /*#__PURE__*/ react.createElement("span", {
        className: copyRight,
        __self: CopyRight_this,
        __source: {
            fileName: CopyRight_jsxFileName,
            lineNumber: 14,
            columnNumber: 9
        }
    }, "Copyright \xa9 ".concat(year, " Momentive")) : /*#__PURE__*/ react.createElement("span", {
        className: copyRight,
        __self: CopyRight_this,
        __source: {
            fileName: CopyRight_jsxFileName,
            lineNumber: 17,
            columnNumber: 9
        }
    }, "Copyright \xa9 1999-".concat(year, " Momentive"));
};
/* harmony default export */ var Footer_CopyRight = (CopyRight); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/FooterLinks/AuthedFooterLinks.js
var AuthedFooterLinks_jsxFileName = "/repo/packages/webassets/src/components/Footer/FooterLinks/AuthedFooterLinks.tsx", AuthedFooterLinks_this = undefined;





var AuthedFooterLinks = function AuthedFooterLinks(_ref) {
    var _ref$domain = _ref.domain, domain = _ref$domain === void 0 ? "surveymonkey" : _ref$domain, _ref$lang = _ref.lang, lang = _ref$lang === void 0 ? "en" : _ref$lang;
    var _useContext = (0,react.useContext)(SMFooterContext), onetrustBannerEnabled = _useContext.onetrustBannerEnabled, isPrivateLabel = _useContext.isPrivateLabel;
    var links = helpers_getAuthFooterLinks(domain, lang, isPrivateLabel);
    return /*#__PURE__*/ react.createElement(InlineList_InlineList, {
        noMargin: true,
        __self: AuthedFooterLinks_this,
        __source: {
            fileName: AuthedFooterLinks_jsxFileName,
            lineNumber: 19,
            columnNumber: 5
        }
    }, links.map(function(item) {
        return /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
            key: item.title,
            href: item.url,
            __self: AuthedFooterLinks_this,
            __source: {
                fileName: AuthedFooterLinks_jsxFileName,
                lineNumber: 21,
                columnNumber: 9
            }
        }, item.title);
    }), !!onetrustBannerEnabled ? /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
        href: "#cookiePreferences",
        className: "ot-sdk-show-settings",
        "data-testid": "AuthedFooterLinks__cookiePreferences",
        __self: AuthedFooterLinks_this,
        __source: {
            fileName: AuthedFooterLinks_jsxFileName,
            lineNumber: 27,
            columnNumber: 9
        }
    }) : null, /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
        __self: AuthedFooterLinks_this,
        __source: {
            fileName: AuthedFooterLinks_jsxFileName,
            lineNumber: 33,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(Footer_CopyRight, {
        __self: AuthedFooterLinks_this,
        __source: {
            fileName: AuthedFooterLinks_jsxFileName,
            lineNumber: 34,
            columnNumber: 9
        }
    })));
};
/* harmony default export */ var FooterLinks_AuthedFooterLinks = (AuthedFooterLinks); //# sourceMappingURL=AuthedFooterLinks.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/FooterLinks/index.js

 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/TrusteSeals/useStyles.js

var TrusteSeals_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)({
    trustedSeal: {
        border: 0,
        height: 50,
        width: 120
    }
});
/* harmony default export */ var TrusteSeals_useStyles = (TrusteSeals_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/TrusteSeals/TrusteSeals.generated.js

var TrusteSeals_generated_templateObject;
function TrusteSeals_generated_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function TrusteSeals_generated_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? TrusteSeals_generated_ownKeys(Object(source), !0).forEach(function(key) {
            TrusteSeals_generated_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TrusteSeals_generated_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function TrusteSeals_generated_defineProperty(obj, key, value) {
    key = TrusteSeals_generated_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TrusteSeals_generated_toPropertyKey(arg) {
    var key = TrusteSeals_generated_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function TrusteSeals_generated_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function TrusteSeals_generated_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
/* eslint-disable */ 

var TrusteSeals_generated_defaultOptions = {};
var TrusteSealsQueryDocument = lib(TrusteSeals_generated_templateObject || (TrusteSeals_generated_templateObject = TrusteSeals_generated_taggedTemplateLiteral([
    "\n  query trusteSealsQuery {\n    user {\n      id\n      team {\n        id\n        billing {\n          recentInvoice {\n            paymentMethod\n            paymentMethodSubtype\n          }\n        }\n      }\n    }\n  }\n"
])));
/**
 * __useTrusteSealsQueryQuery__
 *
 * To run a query within a React component, call `useTrusteSealsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrusteSealsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrusteSealsQueryQuery({
 *   variables: {
 *   },
 * });
 */ function useTrusteSealsQueryQuery(baseOptions) {
    var options = TrusteSeals_generated_objectSpread(TrusteSeals_generated_objectSpread({}, TrusteSeals_generated_defaultOptions), baseOptions);
    return react_hooks_esm/* useQuery */.aM(TrusteSealsQueryDocument, options);
}
function useTrusteSealsQueryLazyQuery(baseOptions) {
    var options = TrusteSeals_generated_objectSpread(TrusteSeals_generated_objectSpread({}, TrusteSeals_generated_defaultOptions), baseOptions);
    return ApolloReactHooks.useLazyQuery(TrusteSealsQueryDocument, options);
} //# sourceMappingURL=TrusteSeals.generated.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/TrusteSeals/DirectDebitLogo.js
var DirectDebitLogo_jsxFileName = "/repo/packages/webassets/src/components/Footer/TrusteSeals/DirectDebitLogo.tsx", DirectDebitLogo_this = undefined;

var DirectDebitLogo = function DirectDebitLogo() {
    return /*#__PURE__*/ react.createElement("svg", {
        className: "sm-truste-seals__svg",
        width: "100px",
        height: "34px",
        viewBox: "0 0 100 34",
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 5,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("title", {
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 11,
            columnNumber: 7
        }
    }, "DirectDebitLogo"), /*#__PURE__*/ react.createElement("desc", {
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 12,
            columnNumber: 7
        }
    }, "Created with Sketch."), /*#__PURE__*/ react.createElement("defs", {
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 13,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("g", {
        id: "Page-1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 14,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "DirectDebitLogo",
        fill: "#231F20",
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 21,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M47,7.6 L52.2,7.6 C52.2,7.6 57.3,7.5 57.3,12.2 C57.2,15.7 52.3,16.2 52.3,16.2 L47,16.2 L47,7.6 L47,7.6 Z M62.6,24.4 C62.7,25.1 63.2,25.8 64.9,25.9 C67.1,26 68.3,25.1 68.3,25.1 L68.3,26.7 C68.3,26.7 65.9,27.3 64.8,27.3 C63.6,27.3 60.1,27 60.1,23.8 C60.1,21.2 63,20.3 64.7,20.3 C67.6,20.4 69,21.4 69,24.4 C68.8,24.4 64,24.4 62.6,24.4 L62.6,24.4 Z M62.6,23.1 L66.6,23.1 C66.6,23.1 66.6,21.6 64.7,21.6 C63.2,21.6 62.7,22.3 62.6,23.1 L62.6,23.1 Z M75.2,21.4 C75.8,20.8 76.7,20.3 78.4,20.3 C81.6,20.3 82.1,23 82.1,23.7 C82,24.4 81.8,27.2 78.1,27.2 C76.7,27.2 75.8,26.7 75.3,26.1 L75.3,27 L72.8,27 L72.8,17.7 L75.3,17.7 L75.3,21.4 L75.2,21.4 Z M77.3,25.8 C78.8,25.7 79.5,24.5 79.5,23.8 C79.5,23.2 79.1,21.9 77.2,21.9 C75.7,21.9 75.3,23 75.1,23.6 L75.1,24.3 C75.3,24.8 75.7,25.8 77.3,25.8 L77.3,25.8 Z M99.3,25.5 L99.4,27 C99.4,27 98.2,27.3 97.4,27.3 C96.6,27.3 94.6,26.8 94.6,24.9 C94.6,24.1 94.6,23 94.6,21.9 L92.5,21.9 L92.5,20.6 L94.6,20.6 C94.6,19.7 94.6,19 94.6,19 L97.2,19 L97.2,20.6 L99.3,20.6 L99.3,21.9 L97.2,21.9 L97.2,24.5 C97.2,24.5 97.2,25.8 98.2,25.8 C99.2,25.7 99.3,25.5 99.3,25.5 L99.3,25.5 Z M91.4,9 L94.4,9 L94.4,16.2 L96.9,16.2 L96.9,9 L100,9 L100,7.5 L91.4,7.5 L91.4,9 L91.4,9 Z M90.4,9.4 L90.7,7.9 C90.7,7.9 89.4,7.3 87.1,7.3 C84.9,7.3 81.3,8.5 81.3,11.9 C81.3,15.2 85.1,16.4 87.4,16.4 C89.7,16.4 90.5,16 90.5,16 L90.2,14.3 C90.2,14.3 89.2,14.6 87.4,14.6 C85.7,14.5 83.9,13.2 83.9,11.7 C84,10.4 85.5,8.8 87.5,8.8 C89.2,8.9 90.4,9.4 90.4,9.4 L90.4,9.4 Z M67.4,7.6 C67.4,7.6 71.7,7.4 71.7,9.9 C71.7,12 69.3,12.2 69.3,12.2 C69.3,12.2 70,12.3 70.3,12.8 C70.6,13.2 72.3,16.3 72.3,16.3 L69.7,16.3 C69.7,16.3 69.3,15.8 69.1,15.4 C68.9,15 68.5,14.3 68.5,14.3 C68.5,14.3 68.1,13 66.9,13 C66.9,13 66.4,13 66,13 L66,16.4 L63.5,16.4 L63.5,7.7 L67.4,7.7 L67.4,7.6 Z M65.8,11.5 L67.1,11.5 C67.1,11.5 69,11.4 69.1,10.3 C69.2,9.2 67.3,9.1 67.3,9.1 L65.8,9.1 L65.8,11.5 L65.8,11.5 Z M76.2,12.8 L80.4,12.8 L80.4,11.2 L76.2,11.2 L76.2,9.2 L80.7,9.2 L80.7,7.5 L73.6,7.5 L73.6,16.2 L80.7,16.2 L80.7,14.6 L76.1,14.6 L76.1,12.8 L76.2,12.8 Z M86.4,19.4 L88.9,19.4 L88.9,17.6 L86.4,17.6 L86.4,19.4 L86.4,19.4 Z M86.4,27 L88.9,27 L88.9,20.4 L86.4,20.4 L86.4,27 L86.4,27 Z M58.7,16.2 L61.2,16.2 L61.2,7.5 L58.7,7.5 L58.7,16.2 L58.7,16.2 Z M47,18.4 L52.2,18.4 C52.2,18.4 57.3,18.3 57.3,23 C57.2,26.5 52.3,27 52.3,27 L47,27 L47,18.4 L47,18.4 Z M49.6,25.3 L51.3,25.3 C51.3,25.3 54.7,25.1 54.7,22.4 C54.7,19.8 51.1,19.5 51.1,19.5 L49.6,19.5 L49.6,25.3 L49.6,25.3 Z M49.6,14.6 L51.3,14.6 C51.3,14.6 54.7,14.3 54.7,11.7 C54.7,9 51.1,8.8 51.1,8.8 L49.6,8.8 L49.6,14.6 L49.6,14.6 Z",
        id: "Shape",
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 22,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M23.8,12.8 L23.8,30.2 C23.8,30.2 13.7,28.4 13.7,21.5 C13.7,15.9 21.1,13.5 23.8,12.8 L23.8,12.8 Z M23.8,12.4 C17.7,12 4,14.8 4,21 C4,25 11.3,31 23.1,31.1 C23.6,31.1 37,30.6 36.8,16.2 C36.6,4.1 27.5,2 24.6,1.6 L24.6,0.9 C36.2,1.6 45.2,8.6 45.2,17 C45.2,25.9 35,33.2 22.5,33.2 C10.1,33.2 0,25.9 0,17 C0,8.1 10.1,0.8 22.6,0.8 C23,0.8 23.4,0.8 23.7,0.8 L23.7,12.4 L23.8,12.4 Z",
        id: "Shape",
        __self: DirectDebitLogo_this,
        __source: {
            fileName: DirectDebitLogo_jsxFileName,
            lineNumber: 26,
            columnNumber: 11
        }
    }))));
};
/* harmony default export */ var TrusteSeals_DirectDebitLogo = (DirectDebitLogo); //# sourceMappingURL=DirectDebitLogo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/TrusteSeals/SepaLogo.js
var SepaLogo_jsxFileName = "/repo/packages/webassets/src/components/Footer/TrusteSeals/SepaLogo.tsx", SepaLogo_this = undefined;

var SepaLogo = function SepaLogo() {
    return /*#__PURE__*/ react.createElement("svg", {
        className: "sm-truste-seals__svg",
        width: "193px",
        height: "53px",
        viewBox: "0 0 193 53",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 5,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("title", {
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 11,
            columnNumber: 7
        }
    }, "SepaLogo"), /*#__PURE__*/ react.createElement("desc", {
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 12,
            columnNumber: 7
        }
    }, "Created with Sketch."), /*#__PURE__*/ react.createElement("defs", {
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 13,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("g", {
        id: "Page-1",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 14,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("g", {
        id: "SepaLogo",
        fillRule: "nonzero",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 21,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M42.6875,16.7485 L29.54125,16.7485 C29.54125,14.591 29.2875,13.1435 28.7825,12.406 C28,11.316 25.84125,10.76975 22.3075,10.76975 C18.875,10.76975 16.6,11.0835 15.49,11.71225 C14.38,12.3435 13.82375,13.71475 13.82375,15.826 C13.82375,17.73725 14.31625,18.99725 15.3025,19.59975 C16.00875,20.0285 16.9425,20.27975 18.105,20.35475 L20.75625,20.54225 C26.43875,20.9185 29.9875,21.18475 31.4025,21.336 C35.89625,21.7885 39.15375,22.9835 41.175,24.91975 C42.765,26.431 43.71375,28.406 44.01625,30.8435 C44.19375,32.30225 44.28125,33.9535 44.28125,35.78725 C44.28125,40.01475 43.8775,43.10975 43.07125,45.071 C41.6075,48.671 38.31875,50.94475 33.2025,51.89975 C31.05875,52.3035 27.78,52.50475 23.36875,52.50475 C16.00625,52.50475 10.87625,52.06725 7.97875,51.186 C4.42375,50.10725 2.07875,47.921 0.945,44.62975 C0.3125,42.79725 0,39.74475 0,35.47225 L13.14625,35.47225 C13.14625,35.9485 13.1475,36.3135 13.1475,36.56475 C13.1475,38.84475 13.8025,40.30975 15.11125,40.9635 C16.0175,41.4135 17.11125,41.64975 18.3975,41.6785 L23.23125,41.6785 C25.6975,41.6785 27.27125,41.55225 27.95,41.2985 C29.15875,40.8235 29.9525,40.0585 30.33125,38.99975 C30.5325,38.34725 30.6325,37.50475 30.6325,36.47225 C30.6325,34.161 29.78875,32.75475 28.10375,32.24975 C27.4725,32.051 24.5425,31.77225 19.31,31.421 C15.1075,31.121 12.18875,30.83225 10.555,30.55225 C6.25125,29.74725 3.3825,28.091 1.95125,25.57725 C0.6925,23.44225 0.06375,20.211 0.06375,15.88725 C0.06375,12.596 0.40375,9.956 1.08375,7.971 C1.76375,5.98475 2.86,4.47725 4.3725,3.446 C6.58875,1.86225 9.425,0.9335 12.87625,0.656 C15.74875,0.40475 18.935,0.27725 22.44,0.27725 C27.9575,0.27725 31.89,0.59475 34.23375,1.2235 C39.955,2.761 42.815,7.066 42.815,14.141 C42.815,14.721 42.7725,15.5885 42.6875,16.7485",
        id: "path5689",
        fill: "#10298E",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 22,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M100.49825,52.50525 L100.49825,0.00025 L121.0945,0.00025 L124.327,0.00025 L126.82575,0.00025 C130.437,0.00025 133.192,0.294 135.08575,0.884 C139.41575,2.24025 142.32075,5.019 143.8095,9.2165 C144.577,11.42025 144.962,14.73775 144.962,19.16775 C144.962,24.494 144.53575,28.32025 143.692,30.6515 C142.00325,35.259 138.52825,37.914 133.2795,38.6015 C132.662,38.70525 130.03575,38.7965 125.3995,38.8715 L123.0545,38.949 L114.6295,38.949 L114.6295,52.50525 L100.49825,52.50525 Z M114.6295,26.769 L123.43825,26.769 C126.232,26.669 127.93075,26.454 128.542,26.11775 C129.377,25.659 129.93825,24.739 130.217,23.36025 C130.39575,22.44275 130.4845,21.07775 130.4845,19.26525 C130.4845,17.044 130.307,15.39775 129.95075,14.32275 C129.44325,12.8165 128.22575,11.90025 126.29825,11.5665 C125.91575,11.5165 125.00325,11.489 123.557,11.489 L114.6295,11.489 L114.6295,26.769 Z",
        id: "path5693",
        fill: "#10298E",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 27,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M175.12587,43.43125 L156.23212,43.43125 L153.69337,52.505 L139.07337,52.505 L154.84962,0 L176.16587,0 L192.13462,52.505 L177.82212,52.505 L175.12587,43.43125 Z M172.31962,33.2025 L165.69837,10.4425 L159.27337,33.2025 L172.31962,33.2025 Z",
        id: "path5697",
        fill: "#10298E",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 32,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M80.99412,7.38675 C86.82162,7.38675 92.02412,10.07175 95.44287,14.27675 L98.48912,7.7455 C93.72537,3.243 87.24162,0.46675 80.09037,0.46675 C68.95537,0.46675 59.43037,7.19175 55.52162,16.71175 L49.58162,16.71175 L46.07412,24.2305 L53.71537,24.2305 C53.65787,24.928 53.62037,25.6255 53.62037,26.338 C53.62037,27.19925 53.66537,28.05175 53.75037,28.893 L49.91037,28.893 L46.40412,36.41425 L55.70412,36.41425 C59.72412,45.693 69.13037,52.20675 80.09037,52.20675 C85.61412,52.20675 90.73912,50.55175 94.98287,47.72425 L94.98287,38.50675 C91.56537,42.398 86.56662,44.85675 80.99412,44.85675 C74.48037,44.85675 68.75037,41.498 65.41412,36.41425 L84.88662,36.41425 L88.39412,28.893 L62.54912,28.893 C62.41537,27.988 62.34412,27.063 62.34412,26.1205 C62.34412,25.483 62.37662,24.853 62.43912,24.2305 L90.56787,24.2305 L94.07412,16.71175 L64.87037,16.71175 C68.10037,11.138 74.11037,7.38675 80.99412,7.38675",
        id: "path5701",
        fill: "#FFBE00",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 37,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M80.99412,7.612 C86.54787,7.612 91.75037,10.0945 95.26787,14.4195 L95.49537,14.6995 L95.64912,14.37325 L98.69412,7.842 L98.76162,7.69325 L98.64537,7.58075 C93.63787,2.84825 87.04787,0.242 80.09037,0.242 C74.65662,0.242 69.42912,1.8295 64.97037,4.83325 C60.61662,7.76575 57.27662,11.8445 55.31412,16.62575 L55.52162,16.48575 L49.58162,16.48575 L49.43662,16.48575 L49.37662,16.61575 L45.87037,24.13575 L45.72037,24.457 L46.07412,24.457 L53.71537,24.457 L53.49037,24.212 C53.42662,24.99325 53.39537,25.687 53.39537,26.33825 C53.39537,27.182 53.43912,28.05075 53.52537,28.91575 L53.75037,28.66825 L49.91037,28.66825 L49.76787,28.66825 L49.70787,28.79825 L46.19912,36.31825 L46.05037,36.6395 L46.40412,36.6395 L55.70412,36.6395 L55.49662,36.50325 C59.68912,46.1795 69.34287,52.432 80.09037,52.432 C85.47787,52.432 90.66912,50.87075 95.10787,47.91325 L95.20662,47.847 L95.20662,47.7245 L95.20662,38.507 L95.20662,37.90825 L94.81287,38.35825 C91.31162,42.3445 86.27537,44.6295 80.99412,44.6295 C74.78162,44.6295 69.02787,41.51075 65.60162,36.2895 L65.41412,36.6395 L84.88662,36.6395 L85.03162,36.6395 L85.09162,36.51075 L88.59912,28.98825 L88.74912,28.66825 L88.39412,28.66825 L62.54912,28.66825 L62.77287,28.86075 C62.63912,27.9495 62.57037,27.0295 62.57037,26.12075 C62.57037,25.502 62.60162,24.8745 62.66412,24.25325 L62.43912,24.457 L90.56787,24.457 L90.71287,24.457 L90.77287,24.327 L94.27912,16.807 L94.43037,16.48575 L94.07412,16.48575 L64.87037,16.48575 L65.06537,16.8245 C68.35787,11.142 74.46287,7.612 80.99412,7.612 L80.99412,7.612 Z M64.87037,16.937 L94.07412,16.937 L93.86912,16.61575 L90.36412,24.13575 L90.56787,24.00575 L62.43912,24.00575 L62.23537,24.00575 L62.21287,24.2095 C62.15037,24.8445 62.11912,25.48825 62.11912,26.12075 C62.11912,27.05075 62.18912,27.99575 62.32537,28.927 L62.35537,29.1195 L62.54912,29.1195 L88.39412,29.1195 L88.19037,28.79825 L84.68412,36.31825 L84.88662,36.18825 L65.41412,36.18825 L64.99537,36.18825 L65.22537,36.53575 C68.73412,41.88825 74.63037,45.0795 80.99412,45.0795 C86.40412,45.0795 91.56537,42.7395 95.15287,38.65575 L94.75662,38.507 L94.75662,47.7245 L94.85662,47.53825 C90.49287,50.4445 85.38787,51.98075 80.09037,51.98075 C69.52162,51.98075 60.03162,45.8345 55.91162,36.32325 L55.85162,36.18825 L55.70412,36.18825 L46.40412,36.18825 L46.61037,36.51075 L50.11537,28.98825 L49.91037,29.1195 L53.75037,29.1195 L53.99912,29.1195 L53.97537,28.87075 C53.89037,28.02075 53.84537,27.167 53.84537,26.33825 C53.84537,25.70075 53.87662,25.017 53.94037,24.2495 L53.96037,24.00575 L53.71537,24.00575 L46.07412,24.00575 L46.27787,24.327 L49.78537,16.807 L49.58162,16.937 L55.52162,16.937 L55.67287,16.937 L55.72912,16.797 C57.66037,12.09825 60.94287,8.09075 65.22287,5.207 C69.60537,2.25575 74.74787,0.6945 80.09037,0.6945 C86.93287,0.6945 93.41037,3.25575 98.33412,7.9095 L98.28412,7.6495 L95.24037,14.182 L95.61912,14.1345 C92.01287,9.70325 86.68412,7.16075 80.99412,7.16075 C74.30037,7.16075 68.04912,10.777 64.67412,16.59825 L64.47787,16.937 L64.87037,16.937 Z",
        id: "path5705",
        fill: "#10298E",
        __self: SepaLogo_this,
        __source: {
            fileName: SepaLogo_jsxFileName,
            lineNumber: 42,
            columnNumber: 11
        }
    }))));
};
/* harmony default export */ var TrusteSeals_SepaLogo = (SepaLogo); //# sourceMappingURL=SepaLogo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/TrusteSeals/BBBLogo.js
var BBBLogo_jsxFileName = "/repo/packages/webassets/src/components/Footer/TrusteSeals/BBBLogo.tsx", BBBLogo_this = undefined;

var BBBLogo = function BBBLogo() {
    return /*#__PURE__*/ react.createElement("svg", {
        className: "sm-truste-seals__svg",
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        width: "123px",
        height: "47px",
        viewBox: "0 0 439 170",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 4,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#0E7C98",
        stroke: "#0E7C98",
        strokeWidth: "3",
        strokeMiterlimit: "0",
        d: "M430.5,134.429c0,11.09-8.99,20.08-20.08,20.08H29.474c-11.09,0-20.08-8.99-20.08-20.08V29.572c0-11.09,8.99-20.08,20.08-20.08 H410.42c11.09,0,20.08,8.99,20.08,20.08V134.429z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 14,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M157,9.492H29.474c-11.09,0-20.08,8.99-20.08,20.08v104.857 c0,11.09,8.99,20.08,20.08,20.08H157V9.492z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 24,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#0E7C98",
        d: "M79.375,54.579l-6.272,8.636 c-3.144,4.33-2.171,12.002,2.123,15.102l11.628,8.395c1.995,1.44,2.152,2.868,1.206,4.391l1.688,1.255l5.886-8.154 c3.638-5.038,3.321-11.896-2.074-15.825l-11.724-8.54c-1.405-1.023-1.549-2.451-0.772-4.052L79.375,54.579L79.375,54.579z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 31,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#0E7C98",
        d: "M89.437,16.395l-9.764,13.503 c-4.579,6.333-2.914,17.148,3.342,21.739l16.052,11.781c3.254,2.388,3.678,8.47,1.31,11.589l1.361,1.021l11.071-15.578 c4.973-6.995,4.684-17.331-3.123-23l-17.17-12.467c-2.403-1.745-3.604-4.711-1.602-7.543L89.437,16.395L89.437,16.395z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 39,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#0E7C98",
        d: "M63.705,101.08h12.939l2.306,7.845c7.048,0,14.097,0,21.145,0 l2.307-7.845h12.938l-1.696-5.77c-16.08,0-32.162,0-48.243,0L63.705,101.08L63.705,101.08z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 47,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#006697",
        d: "M130.525,141.327c0-0.119-0.016-0.225-0.048-0.316 c-0.031-0.092-0.083-0.176-0.157-0.252s-0.172-0.147-0.295-0.211c-0.123-0.064-0.274-0.129-0.457-0.192 c-0.167-0.059-0.301-0.112-0.404-0.161c-0.102-0.049-0.182-0.099-0.238-0.148c-0.056-0.051-0.093-0.104-0.112-0.156 c-0.019-0.054-0.028-0.114-0.028-0.182c0-0.063,0.013-0.124,0.035-0.181c0.024-0.057,0.062-0.106,0.113-0.149 c0.052-0.042,0.118-0.077,0.2-0.103c0.082-0.026,0.18-0.039,0.293-0.039c0.166,0,0.311,0.024,0.432,0.075s0.241,0.124,0.36,0.223 l0.236-0.279c-0.139-0.107-0.285-0.191-0.441-0.253c-0.155-0.061-0.344-0.092-0.563-0.092c-0.154,0-0.294,0.019-0.422,0.055 c-0.128,0.037-0.235,0.092-0.326,0.163c-0.089,0.072-0.159,0.159-0.209,0.26s-0.075,0.215-0.075,0.344 c0,0.116,0.017,0.219,0.049,0.307c0.033,0.089,0.087,0.17,0.16,0.241c0.074,0.072,0.172,0.139,0.293,0.201 c0.121,0.063,0.271,0.125,0.45,0.187c0.15,0.052,0.276,0.104,0.377,0.153c0.101,0.051,0.182,0.103,0.243,0.154 c0.061,0.052,0.104,0.108,0.129,0.169c0.025,0.062,0.038,0.129,0.038,0.202c0,0.171-0.063,0.306-0.19,0.403 c-0.128,0.098-0.302,0.147-0.521,0.147c-0.169,0-0.327-0.036-0.471-0.106c-0.146-0.07-0.28-0.163-0.406-0.279l-0.245,0.266 c0.132,0.129,0.293,0.235,0.483,0.319c0.189,0.084,0.398,0.126,0.625,0.126c0.173,0,0.326-0.023,0.462-0.069 c0.135-0.045,0.25-0.108,0.344-0.188c0.095-0.08,0.166-0.175,0.215-0.284C130.501,141.57,130.525,141.453,130.525,141.327 L130.525,141.327z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 54,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#006697",
        d: "M133.948,142.171v-3.21h-0.4l-0.788,1.922 c-0.019,0.045-0.039,0.098-0.063,0.155c-0.023,0.059-0.046,0.116-0.068,0.175c-0.021,0.058-0.042,0.113-0.062,0.165 c-0.019,0.052-0.032,0.095-0.042,0.128c-0.01-0.033-0.024-0.075-0.042-0.126c-0.02-0.051-0.04-0.104-0.062-0.162 c-0.022-0.059-0.046-0.116-0.068-0.175c-0.024-0.059-0.045-0.111-0.063-0.16l-0.778-1.922h-0.41v3.21h0.354v-2.174v-0.344 c0.01,0.03,0.021,0.068,0.035,0.112c0.014,0.045,0.03,0.09,0.048,0.138c0.017,0.047,0.035,0.097,0.054,0.146 c0.019,0.051,0.038,0.096,0.057,0.136l0.867,2.068l0.882-2.068c0.019-0.043,0.038-0.089,0.057-0.138s0.038-0.098,0.057-0.145 c0.019-0.048,0.035-0.093,0.049-0.138c0.015-0.044,0.026-0.082,0.036-0.112v0.344v2.174H133.948L133.948,142.171z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 73,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#0E7C98",
        d: "M74.828,133.271c-0.551-3.73-2.054-4.624-5.061-5.949 c2.273-1.33,3.67-3.286,3.67-5.967c0-5.359-4.391-7.543-9.18-7.543H50.878v28.449h13.254 C69.793,142.261,75.792,139.786,74.828,133.271z M56.93,119.25h6.952c4.343,0,4.5,6.068,0.273,6.068H56.93V119.25z M64.683,136.885 H56.93v-6.49h7.753C70.384,130.395,70.037,136.885,64.683,136.885z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 85,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#0E7C98",
        d: "M101.393,133.271c-0.552-3.73-2.056-4.624-5.061-5.949 c2.272-1.33,3.669-3.286,3.669-5.967c0-5.359-4.39-7.543-9.18-7.543H77.442v28.449h13.254 C96.356,142.261,102.355,139.786,101.393,133.271z M83.494,119.25h6.952c4.344,0,4.5,6.068,0.273,6.068h-7.225V119.25z M91.246,136.885h-7.752v-6.49h7.752C96.947,130.395,96.601,136.885,91.246,136.885z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 94,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#0E7C98",
        d: "M127.956,133.271c-0.552-3.73-2.055-4.624-5.061-5.949 c2.273-1.33,3.669-3.286,3.669-5.967c0-5.359-4.39-7.543-9.179-7.543h-13.38v28.449h13.255 C122.92,142.261,128.92,139.786,127.956,133.271z M110.058,119.25h6.951c4.344,0,4.5,6.068,0.273,6.068h-7.225V119.25z M117.81,136.885h-7.752v-6.49h7.752C123.512,130.395,123.164,136.885,117.81,136.885z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 103,
            columnNumber: 5
        }
    }), /*#__PURE__*/ react.createElement("g", {
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 112,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M222.977,65.311c-1.617-1.861-4.162-3.57-6.563-4.225 c-1.044-0.285-2.206-0.427-3.485-0.427c-1.8,0-3.445,0.328-4.933,0.984c-1.487,0.657-2.767,1.573-3.837,2.75 c-1.069,1.176-1.906,2.588-2.505,4.235c-0.601,1.646-0.9,3.46-0.9,5.442c0,2.056,0.287,3.907,0.861,5.553 c0.574,1.647,1.389,3.053,2.447,4.218c1.058,1.163,2.316,2.062,3.778,2.693c1.461,0.631,3.092,0.947,4.893,0.947 c3.317,0,9.063-1.815,10.7-5.049l-3.897-3.455c-1.108,1.764-4.568,3.339-6.646,3.339c-1.018,0-1.932-0.209-2.74-0.631 c-0.809-0.421-1.494-1.003-2.055-1.746c-0.562-0.743-0.985-1.616-1.272-2.619c-0.287-1.002-0.431-2.086-0.431-3.25 c0-1.213,0.144-2.322,0.431-3.325c0.288-1.003,0.705-1.87,1.252-2.601c0.548-0.73,1.227-1.3,2.036-1.708 c0.809-0.409,1.722-0.613,2.74-0.613c2.058,0,4.966,1.364,6.326,3.153L222.977,65.311L222.977,65.311z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 113,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("polygon", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "298.014,87.073 298.014,81.982 283.882,81.982 283.882,75.704 295.255,75.704 295.255,70.653 283.882,70.653 283.882,66.157 297.428,66.157 297.428,61.068 278.4,61.068 278.4,87.073 298.014,87.073 	",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 126,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M323.266,68.033c-0.692-1.647-1.646-2.99-2.86-4.031 c-1.213-1.04-2.646-1.789-4.305-2.247c-1.657-0.458-3.467-0.687-5.424-0.687h-8.575v26.005h8.186c1.748,0,3.464-0.249,5.147-0.743 c1.684-0.496,3.183-1.271,4.502-2.323c1.317-1.052,2.376-2.402,3.17-4.049c0.796-1.646,1.194-3.609,1.194-5.888 C324.301,71.692,323.955,69.681,323.266,68.033z M318.154,77.32c-0.339,0.979-0.849,1.813-1.525,2.507 c-0.679,0.693-1.549,1.232-2.605,1.616c-1.056,0.384-2.303,0.576-3.736,0.576h-2.701V66.121h2.896c2.896,0,4.983,0.662,6.264,1.987 c1.277,1.325,1.918,3.313,1.918,5.962C318.664,75.259,318.495,76.342,318.154,77.32z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 134,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("polygon", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "335.086,87.073 335.086,61.068 329.604,61.068 329.604,87.073 335.086,87.073",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 145,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("polygon", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "360.629,66.195 360.629,61.068 339.408,61.068 339.408,66.195 347.278,66.195 347.278,87.073 352.759,87.073 352.759,66.195 360.629,66.195",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 152,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M409.032,68.033c-0.69-1.647-1.643-2.99-2.858-4.031 c-1.212-1.04-2.648-1.789-4.304-2.247c-1.658-0.458-3.467-0.687-5.424-0.687h-8.575v26.005h8.183c1.748,0,3.466-0.249,5.149-0.743 c1.685-0.496,3.184-1.271,4.503-2.323c1.316-1.052,2.373-2.402,3.17-4.049c0.796-1.646,1.194-3.609,1.194-5.888 C410.07,71.692,409.724,69.681,409.032,68.033z M403.923,77.32c-0.338,0.979-0.848,1.813-1.524,2.507 c-0.68,0.693-1.549,1.232-2.605,1.616s-2.303,0.576-3.739,0.576h-2.702V66.121h2.899c2.896,0,4.983,0.662,6.265,1.987 c1.277,1.325,1.918,3.313,1.918,5.962C404.434,75.259,404.264,76.342,403.923,77.32z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 159,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("polygon", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "383.765,87.073 383.765,81.982 369.631,81.982 369.631,75.704 381.003,75.704 381.003,70.653 369.631,70.653 369.631,66.157 383.177,66.157 383.177,61.068 364.149,61.068 364.149,87.073 383.765,87.073",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 170,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("polygon", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "337.904,120.65 337.904,115.561 323.772,115.561 323.772,109.282 335.146,109.282 335.146,104.229 323.772,104.229 323.772,99.735 337.318,99.735 337.318,94.646 318.289,94.646 318.289,120.65 337.904,120.65",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 178,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M248.283,65.311c-1.617-1.861-4.162-3.57-6.563-4.225 c-1.044-0.285-2.206-0.427-3.484-0.427c-1.8,0-3.445,0.328-4.933,0.984c-1.488,0.657-2.767,1.573-3.836,2.75 c-1.07,1.176-1.906,2.588-2.506,4.235c-0.601,1.646-0.9,3.46-0.9,5.442c0,2.056,0.287,3.907,0.861,5.553 c0.575,1.647,1.39,3.053,2.448,4.218c1.057,1.163,2.316,2.062,3.778,2.693c1.461,0.631,3.092,0.947,4.894,0.947 c3.317,0,9.063-1.815,10.699-5.049l-3.897-3.455c-1.108,1.764-4.569,3.339-6.645,3.339c-1.019,0-1.932-0.209-2.741-0.631 c-0.809-0.421-1.494-1.003-2.056-1.746c-0.561-0.743-0.985-1.616-1.272-2.619c-0.288-1.002-0.431-2.086-0.431-3.25 c0-1.213,0.143-2.322,0.431-3.325c0.287-1.003,0.705-1.87,1.252-2.601c0.548-0.73,1.227-1.3,2.036-1.708 c0.81-0.409,1.723-0.613,2.741-0.613c2.057,0,4.966,1.364,6.326,3.153L248.283,65.311L248.283,65.311z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 186,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M224.812,108.688c-0.711-0.94-1.602-1.646-2.67-2.117 c0.89-0.521,1.583-1.213,2.079-2.081c0.496-0.866,0.745-1.856,0.745-2.972c0-2.229-0.763-3.931-2.289-5.107 c-1.526-1.178-3.585-1.764-6.179-1.764h-12.244v26.004h12.129c1.424,0,2.721-0.179,3.89-0.538c1.17-0.36,2.168-0.893,2.995-1.598 c0.826-0.707,1.468-1.585,1.926-2.638c0.458-1.053,0.687-2.26,0.687-3.623C225.88,110.817,225.524,109.629,224.812,108.688z M209.478,99.437h6.79c1.169,0,2.008,0.211,2.517,0.633c0.509,0.42,0.763,1.04,0.763,1.857c0,0.718-0.222,1.306-0.667,1.765 c-0.445,0.459-1.227,0.688-2.346,0.688h-7.057V99.437z M219.453,114.799c-0.623,0.607-1.583,0.91-2.88,0.91h-7.094v-6.724h7.094 c2.543,0,3.814,1.114,3.814,3.343C220.387,113.369,220.076,114.191,219.453,114.799z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 199,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M251.07,109.172V94.646h-5.339v14.6 c0,2.104-0.49,3.751-1.468,4.94c-0.979,1.188-2.321,1.782-4.024,1.782s-3.039-0.605-4.005-1.82c-0.966-1.213-1.45-2.872-1.45-4.977 V94.646h-5.34v14.6c0,1.906,0.26,3.59,0.782,5.051c0.521,1.461,1.252,2.693,2.193,3.697c0.94,1.003,2.079,1.764,3.414,2.285 c1.335,0.52,2.803,0.78,4.406,0.78c3.407,0,6.064-1.034,7.972-3.103S251.07,112.961,251.07,109.172L251.07,109.172z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 211,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M275.613,112.774c0-1.411-0.267-2.576-0.801-3.492 s-1.227-1.671-2.079-2.266c-0.852-0.595-1.806-1.06-2.86-1.394c-1.056-0.334-2.117-0.626-3.186-0.873 c-1.067-0.247-1.945-0.471-2.632-0.669c-0.686-0.198-1.232-0.408-1.64-0.631c-0.406-0.223-0.693-0.478-0.858-0.763 c-0.165-0.283-0.248-0.636-0.248-1.058c0-0.299,0.064-0.582,0.19-0.854c0.127-0.272,0.344-0.52,0.648-0.744 c0.306-0.222,0.699-0.401,1.183-0.538c0.483-0.136,1.081-0.204,1.793-0.204c1.221,0,2.319,0.229,3.3,0.687 c0.979,0.458,1.9,1.122,2.765,1.988l3.853-3.641c-1.271-1.288-2.688-2.292-4.252-3.009c-1.565-0.719-3.389-1.078-5.475-1.078 c-1.322,0-2.562,0.174-3.719,0.52c-1.157,0.348-2.167,0.85-3.032,1.506c-0.864,0.656-1.545,1.455-2.041,2.396 c-0.495,0.94-0.743,2.006-0.743,3.194c0,1.288,0.203,2.365,0.61,3.232c0.406,0.866,0.979,1.584,1.716,2.154 c0.738,0.57,1.621,1.04,2.651,1.412c1.03,0.37,2.155,0.693,3.375,0.966c1.247,0.271,2.264,0.531,3.052,0.78 c0.789,0.247,1.393,0.508,1.812,0.779c0.42,0.273,0.706,0.563,0.858,0.873c0.153,0.31,0.229,0.675,0.229,1.096 c0,0.991-0.376,1.71-1.126,2.155c-0.749,0.446-1.926,0.668-3.528,0.668c-1.297,0-2.523-0.229-3.681-0.687 c-1.156-0.458-2.206-1.22-3.146-2.285l-3.853,3.345c1.017,1.461,2.441,2.612,4.272,3.454c1.83,0.843,3.865,1.264,6.103,1.264 c1.831,0,3.401-0.199,4.711-0.595c1.309-0.396,2.396-0.961,3.262-1.69c0.863-0.73,1.499-1.604,1.906-2.619 C275.41,115.14,275.613,114.014,275.613,112.774L275.613,112.774z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 220,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("polygon", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        points: "285.279,120.65 285.279,94.646 279.94,94.646 279.94,120.65 285.279,120.65",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 239,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M312.455,120.65V94.646h-5.266v10.994 c0,0.373,0.008,0.831,0.019,1.376c0.013,0.545,0.021,1.103,0.021,1.671c0,0.545,0.006,1.06,0.019,1.542 c0.013,0.484,0.021,0.849,0.021,1.096c-0.18-0.347-0.452-0.798-0.822-1.356c-0.367-0.557-0.718-1.082-1.049-1.578l-9.457-13.744 h-5.111v26.004h5.263v-11.442c0-0.372-0.006-0.83-0.019-1.374c-0.013-0.545-0.021-1.09-0.021-1.635 c0-0.569-0.006-1.097-0.019-1.579c-0.013-0.483-0.019-0.849-0.019-1.096c0.177,0.346,0.45,0.799,0.82,1.355 c0.369,0.557,0.718,1.084,1.049,1.579l9.803,14.191H312.455L312.455,120.65z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 246,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M359.71,112.774c0-1.411-0.268-2.576-0.802-3.492 c-0.533-0.916-1.229-1.671-2.079-2.266s-1.806-1.06-2.86-1.394c-1.057-0.334-2.118-0.626-3.186-0.873 c-1.066-0.247-1.943-0.471-2.631-0.669c-0.687-0.198-1.233-0.408-1.642-0.631c-0.406-0.223-0.692-0.478-0.856-0.763 c-0.167-0.283-0.25-0.636-0.25-1.058c0-0.299,0.065-0.582,0.192-0.854c0.128-0.272,0.344-0.52,0.648-0.744 c0.305-0.222,0.697-0.401,1.182-0.538c0.483-0.136,1.08-0.204,1.793-0.204c1.221,0,2.321,0.229,3.3,0.687s1.899,1.122,2.764,1.988 l3.854-3.641c-1.272-1.288-2.691-2.292-4.255-3.009c-1.562-0.719-3.386-1.078-5.474-1.078c-1.321,0-2.561,0.174-3.719,0.52 c-1.155,0.348-2.168,0.85-3.031,1.506c-0.864,0.656-1.546,1.455-2.041,2.396c-0.497,0.94-0.744,2.006-0.744,3.194 c0,1.288,0.203,2.365,0.611,3.232c0.406,0.866,0.979,1.584,1.716,2.154c0.738,0.57,1.621,1.04,2.651,1.412 c1.03,0.37,2.155,0.693,3.375,0.966c1.247,0.271,2.265,0.531,3.051,0.78c0.788,0.247,1.392,0.508,1.813,0.779 c0.419,0.273,0.705,0.563,0.856,0.873c0.153,0.31,0.229,0.675,0.229,1.096c0,0.991-0.374,1.71-1.124,2.155 c-0.749,0.446-1.926,0.668-3.528,0.668c-1.297,0-2.522-0.229-3.681-0.687c-1.157-0.458-2.206-1.22-3.146-2.285l-3.854,3.345 c1.018,1.461,2.44,2.612,4.273,3.454c1.829,0.843,3.864,1.264,6.103,1.264c1.829,0,3.401-0.199,4.71-0.595 c1.31-0.396,2.397-0.961,3.261-1.69c0.864-0.73,1.502-1.604,1.908-2.619C359.505,115.14,359.71,114.014,359.71,112.774 L359.71,112.774z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 257,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M382.65,112.774c0-1.411-0.268-2.576-0.801-3.492 c-0.534-0.916-1.229-1.671-2.08-2.266c-0.851-0.595-1.806-1.06-2.859-1.394c-1.057-0.334-2.119-0.626-3.186-0.873 c-1.067-0.247-1.944-0.471-2.632-0.669c-0.687-0.198-1.233-0.408-1.64-0.631c-0.408-0.223-0.694-0.478-0.858-0.763 c-0.166-0.283-0.25-0.636-0.25-1.058c0-0.299,0.065-0.582,0.192-0.854c0.128-0.272,0.344-0.52,0.648-0.744 c0.305-0.222,0.7-0.401,1.182-0.538c0.484-0.136,1.08-0.204,1.793-0.204c1.221,0,2.321,0.229,3.3,0.687s1.9,1.122,2.767,1.988 l3.852-3.641c-1.272-1.288-2.688-2.292-4.252-3.009c-1.564-0.719-3.389-1.078-5.476-1.078c-1.322,0-2.562,0.174-3.72,0.52 c-1.155,0.348-2.167,0.85-3.031,1.506s-1.544,1.455-2.041,2.396c-0.497,0.94-0.744,2.006-0.744,3.194 c0,1.288,0.203,2.365,0.612,3.232c0.405,0.866,0.979,1.584,1.715,2.154c0.739,0.57,1.621,1.04,2.651,1.412 c1.031,0.37,2.155,0.693,3.376,0.966c1.246,0.271,2.264,0.531,3.05,0.78c0.788,0.247,1.393,0.508,1.813,0.779 c0.419,0.273,0.706,0.563,0.859,0.873c0.15,0.31,0.227,0.675,0.227,1.096c0,0.991-0.375,1.71-1.125,2.155 c-0.749,0.446-1.926,0.668-3.528,0.668c-1.296,0-2.524-0.229-3.68-0.687c-1.158-0.458-2.207-1.22-3.146-2.285l-3.854,3.345 c1.018,1.461,2.441,2.612,4.273,3.454c1.832,0.843,3.864,1.264,6.103,1.264c1.832,0,3.401-0.199,4.711-0.595 c1.309-0.396,2.396-0.961,3.261-1.69c0.866-0.73,1.501-1.604,1.907-2.619C382.447,115.14,382.65,114.014,382.65,112.774 L382.65,112.774z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 276,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M189.421,61.068h-5.324l-10.493,26.005h5.873l2.153-5.796h10.023 l2.153,5.796h6.029L189.421,61.068z M183.51,76.336l1.761-4.718c0.288-0.768,0.555-1.511,0.803-2.229s0.437-1.325,0.568-1.82 c0.13,0.496,0.319,1.102,0.567,1.82s0.515,1.461,0.803,2.229l1.762,4.718H183.51z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 295,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "#FFFFFF",
        d: "M268.899,77.191c1.748-0.644,3.696-1.815,4.57-3.066 c0.875-1.25,1.313-2.855,1.313-4.811c0-1.387-0.249-2.595-0.744-3.623c-0.496-1.028-1.175-1.888-2.036-2.582 c-0.861-0.694-1.866-1.208-3.015-1.542s-2.362-0.501-3.641-0.501h-12.764v26.005h5.481V77.71l4.884,0.224l5.729,9.139h6.303 L268.899,77.191z M265.229,72.808h-7.164v-6.687h7.164c1.227,0,2.187,0.253,2.878,0.761c0.691,0.507,1.037,1.355,1.037,2.544 C269.144,71.679,267.839,72.808,265.229,72.808z",
        __self: BBBLogo_this,
        __source: {
            fileName: BBBLogo_jsxFileName,
            lineNumber: 303,
            columnNumber: 7
        }
    })));
};
/* harmony default export */ var TrusteSeals_BBBLogo = (BBBLogo); //# sourceMappingURL=BBBLogo.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/TrusteSeals/TrustedShop.js
var TrustedShop_jsxFileName = "/repo/packages/webassets/src/components/Footer/TrusteSeals/TrustedShop.tsx", TrustedShop_this = undefined;

var TrustedShop = function TrustedShop() {
    var trustedSpan = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var tsID = "X8F338485E616D91F6D5515EA0347B70B";
        var scriptSource = "//widgets.trustedshops.com/js/".concat(tsID, ".js");
        var script = document.createElement("script");
        var type = "text/javascript";
        var charset = "utf-8";
        script.type = type;
        script.charset = charset;
        script.src = scriptSource;
        var tsScript = document.getElementsByTagName("script")[0];
        if (!tsScript.parentNode) throw Error("Trusted Shop script does not exist!");
        tsScript.parentNode.insertBefore(script, tsScript);
        var tsConfigScript = document.createElement("script");
        tsConfigScript.type = type;
        tsConfigScript.innerHTML = "\n      (function () {\n        var _tsid = '".concat(tsID, "';\n        _tsConfig = {\n            'yOffset': '0', /* offset from page bottom */\n            'variant': 'custom', /* text, default, small, reviews, custom, custom_reviews */\n            'customElementId': 'TrustedShops', /* required for variants custom and custom_reviews */\n            'trustcardDirection': '', /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */\n            'customBadgeWidth': '40', /* for custom variants: 40 - 90 (in pixels) */\n            'customBadgeHeight': '40', /* for custom variants: 40 - 90 (in pixels) */\n            'disableResponsive': 'false', /* deactivate responsive behaviour */\n            'disableTrustbadge': 'false', /* deactivate trustbadge */\n            'trustCardTrigger': 'mouseenter' /* set to 'click' if you want the trustcard to be opened on click instead */\n        };\n      })();");
        if (!trustedSpan.current) throw Error("trustedSpan is not assigned");
        trustedSpan.current.appendChild(tsConfigScript);
    }, []);
    return /*#__PURE__*/ react.createElement("span", {
        id: "TrustedShops",
        "data-language": "en",
        ref: trustedSpan,
        __self: TrustedShop_this,
        __source: {
            fileName: TrustedShop_jsxFileName,
            lineNumber: 43,
            columnNumber: 10
        }
    });
};
/* harmony default export */ var TrusteSeals_TrustedShop = (TrustedShop); //# sourceMappingURL=TrustedShop.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/TrusteSeals/index.js
var TrusteSeals_jsxFileName = "/repo/packages/webassets/src/components/Footer/TrusteSeals/index.tsx", TrusteSeals_this = undefined;










var showTrustedShopSeal = function showTrustedShopSeal(lang, country) {
    if ([
        "DE",
        "AT",
        "CH"
    ].includes(country) && lang === "de") {
        return true;
    }
    return false;
};
var handleContextMenuClick = function handleContextMenuClick() {
    // eslint-disable-next-line no-alert
    alert("Copying Prohibited by Law - TrustedSite is a Trademark of TrustedSite, LLC");
    return false;
};
var FooterSeals = function FooterSeals() {
    var _useTrusteSealsQueryQ = useTrusteSealsQueryQuery(), loading = _useTrusteSealsQueryQ.loading, error = _useTrusteSealsQueryQ.error, data = _useTrusteSealsQueryQ.data;
    if (loading) return null;
    if (error) throw Error("An error occured with the graph query: ".concat(error));
    var recentInvoice = data && data.user && data.user.team && data.user.team.billing && data.user.team.billing.recentInvoice || {};
    var paymentMethod = recentInvoice.paymentMethod, paymentMethodSubtype = recentInvoice.paymentMethodSubtype;
    return paymentMethod === "DIRECT_DEBIT" ? /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        m: 2,
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 47,
            columnNumber: 5
        }
    }, paymentMethodSubtype === "GOCARDLESS_SEPA_DD" ? /*#__PURE__*/ react.createElement(TrusteSeals_SepaLogo, {
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 49,
            columnNumber: 9
        }
    }) : /*#__PURE__*/ react.createElement(TrusteSeals_DirectDebitLogo, {
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 51,
            columnNumber: 9
        }
    })) : null;
};
var TrusteSeals = function TrusteSeals() {
    var _useContext = (0,react.useContext)(SMFooterContext), _useContext$lang = _useContext.lang, lang = _useContext$lang === void 0 ? "" : _useContext$lang, _useContext$country = _useContext.country, country = _useContext$country === void 0 ? "" : _useContext$country, isUserAuthenticated = _useContext.isUserAuthenticated, isEUDC = _useContext.isEUDC;
    var _useStyles = TrusteSeals_useStyles(), trustedSeal = _useStyles.trustedSeal;
    var _getClientEnvironment = (0,dist.getClientEnvironmentDetails)(), isBrowser = _getClientEnvironment.isBrowser;
    return /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: "center",
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 68,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        mr: 2,
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 69,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("a", {
        title: "Click to verify BBB accreditation and to see a BBB report.",
        href: "https://www.bbb.org/us/ca/san-mateo/profile/market-survey/surveymonkey-1116-876628",
        rel: "noopener noreferrer",
        target: "_blank",
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 70,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(TrusteSeals_BBBLogo, {
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 76,
            columnNumber: 11
        }
    }))), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        m: 2,
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 79,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        title: "View TrustedSite Certification",
        href: "https://www.trustedsite.com/verify?host=".concat(isEUDC ? "eu" : "www", ".surveymonkey.com"),
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 80,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement("img", {
        className: trustedSeal,
        alt: "TrustedSite helps keep you safe from identity theft, credit card fraud, spyware, spam, viruses and online scams",
        src: "https://cdn.ywxi.net/meter/surveymonkey.com/202.svg",
        onContextMenu: handleContextMenuClick,
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 88,
            columnNumber: 11
        }
    }))), !!(isUserAuthenticated && isBrowser) && /*#__PURE__*/ react.createElement(FooterSeals, {
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 96,
            columnNumber: 48
        }
    }), showTrustedShopSeal(lang, country) && /*#__PURE__*/ react.createElement(TrusteSeals_TrustedShop, {
        __self: TrusteSeals_this,
        __source: {
            fileName: TrusteSeals_jsxFileName,
            lineNumber: 97,
            columnNumber: 46
        }
    }));
};
/* harmony default export */ var Footer_TrusteSeals = (TrusteSeals); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/useStyles.js

var Footer_useStyles_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(_ref) {
    var palette = _ref.palette, spacing = _ref.spacing, elevation = _ref.elevation, type = _ref.type, border = _ref.border;
    return {
        fullHeight: {
            height: "100%"
        },
        footerAnon: {
            position: "relative",
            zIndex: elevation.sky,
            backgroundColor: palette.background.light,
            padding: [
                spacing[7],
                0
            ],
            color: palette.text.dark,
            fontSize: type.fontSize.bodySm,
            borderTop: border.main
        },
        footerAuth: {
            position: "relative",
            zIndex: elevation.sky,
            backgroundColor: palette.background.light,
            padding: [
                spacing[7],
                0
            ],
            color: palette.text.dark,
            fontSize: type.fontSize.bodySm
        },
        footerBorder: {
            borderBottom: border.main
        }
    };
});
/* harmony default export */ var Footer_useStyles = (Footer_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/AnonFooter.js
var AnonFooter_jsxFileName = "/repo/packages/webassets/src/components/Footer/AnonFooter.tsx", AnonFooter_this = undefined;










var AnonFooter = function AnonFooter() {
    var _useContext = (0,react.useContext)(SMFooterContext), variant = _useContext.variant;
    var _useStyles = Footer_useStyles(), footerAnon = _useStyles.footerAnon, fullHeight = _useStyles.fullHeight, footerBorder = _useStyles.footerBorder;
    var TrusteFooterSeals = function TrusteFooterSeals() {
        return /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
            md: 5,
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 20,
                columnNumber: 7
            }
        }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            display: "flex",
            flexJustify: "flex-end",
            flexAlign: "center",
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 21,
                columnNumber: 9
            }
        }, /*#__PURE__*/ react.createElement(Footer_TrusteSeals, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 22,
                columnNumber: 11
            }
        })));
    };
    var footerClassNames = classnames_default()(footerAnon, "sm-footer");
    return /*#__PURE__*/ react.createElement("div", {
        className: footerClassNames,
        "data-testid": "AnonFooter",
        __self: AnonFooter_this,
        __source: {
            fileName: AnonFooter_jsxFileName,
            lineNumber: 31,
            columnNumber: 5
        }
    }, variant === "default" ? [
        /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 34,
                columnNumber: 11
            },
            key: "0"
        }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 35,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement("div", {
            className: footerBorder,
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 36,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(FooterLinks_AnonFooterLinks, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 37,
                columnNumber: 17
            }
        })))),
        /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 41,
                columnNumber: 11
            },
            key: "1"
        }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 42,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            className: footerBorder,
            py: 4,
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 43,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(LanguageMenu_LanguageListLO, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 44,
                columnNumber: 17
            }
        })))),
        /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 48,
                columnNumber: 11
            },
            key: "2"
        }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
            md: 7,
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 49,
                columnNumber: 13
            }
        }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
            display: "flex",
            flexAlign: "center",
            className: fullHeight,
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 50,
                columnNumber: 15
            }
        }, /*#__PURE__*/ react.createElement(Footer_CopyRight, {
            __self: AnonFooter_this,
            __source: {
                fileName: AnonFooter_jsxFileName,
                lineNumber: 51,
                columnNumber: 17
            }
        }))), TrusteFooterSeals())
    ] : /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        __self: AnonFooter_this,
        __source: {
            fileName: AnonFooter_jsxFileName,
            lineNumber: 58,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        md: 7,
        __self: AnonFooter_this,
        __source: {
            fileName: AnonFooter_jsxFileName,
            lineNumber: 59,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexDirection: variant === "default" ? "row" : "column",
        flexAlign: variant === "default" ? "center" : "flex-start",
        flexJustify: variant === "default" ? "flex-start" : "center",
        className: fullHeight,
        __self: AnonFooter_this,
        __source: {
            fileName: AnonFooter_jsxFileName,
            lineNumber: 60,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(FooterLinks_AnonFooterLinks, {
        __self: AnonFooter_this,
        __source: {
            fileName: AnonFooter_jsxFileName,
            lineNumber: 67,
            columnNumber: 17
        }
    }), /*#__PURE__*/ react.createElement(Footer_CopyRight, {
        __self: AnonFooter_this,
        __source: {
            fileName: AnonFooter_jsxFileName,
            lineNumber: 68,
            columnNumber: 17
        }
    }))), TrusteFooterSeals()));
};
/* harmony default export */ var Footer_AnonFooter = (AnonFooter); //# sourceMappingURL=AnonFooter.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/BillingAddress/BillingAddress.js
var BillingAddress_jsxFileName = "/repo/packages/webassets/src/components/Footer/BillingAddress/BillingAddress.tsx", BillingAddress_this = undefined;


var BillingAddress = function BillingAddress(_ref) {
    var _ref$country = _ref.country, country = _ref$country === void 0 ? "US" : _ref$country;
    return /*#__PURE__*/ react.createElement(InlineList_InlineList, {
        noMargin: true,
        "data-testid": "BillingAddress__Footer",
        __self: BillingAddress_this,
        __source: {
            fileName: BillingAddress_jsxFileName,
            lineNumber: 11,
            columnNumber: 3
        }
    }, country === "US" ? /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
        __self: BillingAddress_this,
        __source: {
            fileName: BillingAddress_jsxFileName,
            lineNumber: 14,
            columnNumber: 9
        }
    }, "SurveyMonkey 3050 South Delaware Street, San Mateo, CA, 94403, USA") : country === "BR" ? /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
        __self: BillingAddress_this,
        __source: {
            fileName: BillingAddress_jsxFileName,
            lineNumber: 19,
            columnNumber: 9
        }
    }, "SurveyMonkey Brasil Internet Ltda. Rua Joaquim Floriano, N\xba 243, Su\xedte 113, Itaim Bibi, S\xe3o Paulo, SP, CEP 04534-010, Brasil") : /*#__PURE__*/ react.createElement(InlineList_InlineListItem, {
        __self: BillingAddress_this,
        __source: {
            fileName: BillingAddress_jsxFileName,
            lineNumber: 25,
            columnNumber: 9
        }
    }, "SurveyMonkey Europe UC 2 Shelbourne Buildings, 2nd Floor, Shelbourne Road, Ballsbridge, Dublin 4, Ireland"));
};
/* harmony default export */ var BillingAddress_BillingAddress = (BillingAddress); //# sourceMappingURL=BillingAddress.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/BillingAddress/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/AuthedFooter.js
var AuthedFooter_jsxFileName = "/repo/packages/webassets/src/components/Footer/AuthedFooter.tsx", AuthedFooter_this = undefined;










var AuthedFooter = function AuthedFooter() {
    var _useContext = (0,react.useContext)(SMFooterContext), _useContext$domain = _useContext.domain, domain = _useContext$domain === void 0 ? "" : _useContext$domain, _useContext$lang = _useContext.lang, lang = _useContext$lang === void 0 ? "" : _useContext$lang, country = _useContext.country, variant = _useContext.variant, showBillingAddress = _useContext.showBillingAddress;
    var _useStyles = Footer_useStyles(), footerAuth = _useStyles.footerAuth;
    var footerClassNames = classnames_default()(footerAuth, "sm-footer");
    return /*#__PURE__*/ react.createElement("div", {
        className: footerClassNames,
        "data-testid": "AuthedFooter",
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 26,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 27,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 28,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: variant === "center" ? "center" : "flex-start",
        flexDirection: "column",
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 29,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(LanguageMenu_LanguageMenuLI, {
        lang: lang,
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 34,
            columnNumber: 13
        }
    })))), /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 38,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 39,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: variant === "center" ? "center" : "flex-start",
        flexDirection: "column",
        my: 5,
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 40,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(FooterLinks_AuthedFooterLinks, {
        domain: domain,
        lang: lang,
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 46,
            columnNumber: 13
        }
    }), showBillingAddress && /*#__PURE__*/ react.createElement(BillingAddress_BillingAddress, {
        country: country,
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 47,
            columnNumber: 36
        }
    })))), /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 51,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 52,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: variant === "center" ? "center" : "flex-start",
        flexDirection: "column",
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 53,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(Footer_TrusteSeals, {
        __self: AuthedFooter_this,
        __source: {
            fileName: AuthedFooter_jsxFileName,
            lineNumber: 58,
            columnNumber: 13
        }
    })))));
};
/* harmony default export */ var Footer_AuthedFooter = (AuthedFooter); //# sourceMappingURL=AuthedFooter.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Footer/index.js
var Footer_jsxFileName = "/repo/packages/webassets/src/components/Footer/index.tsx", Footer_this = undefined;




var SMFooter = function SMFooter(_ref) {
    var isUserAuthenticated = _ref.isUserAuthenticated, lang = _ref.lang, domain = _ref.domain, subdomain = _ref.subdomain, country = _ref.country, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? "default" : _ref$variant, _ref$showBillingAddre = _ref.showBillingAddress, showBillingAddress = _ref$showBillingAddre === void 0 ? false : _ref$showBillingAddre, isEUDC = _ref.isEUDC, _ref$isPrivateLabel = _ref.isPrivateLabel, isPrivateLabel = _ref$isPrivateLabel === void 0 ? false : _ref$isPrivateLabel, tld = _ref.tld, _ref$url = _ref.url, url = _ref$url === void 0 ? undefined : _ref$url, onetrustBannerEnabled = _ref.onetrustBannerEnabled;
    return /*#__PURE__*/ react.createElement(FooterContext, {
        isUserAuthenticated: isUserAuthenticated,
        lang: lang,
        subdomain: subdomain,
        domain: domain,
        country: country,
        variant: variant,
        showBillingAddress: showBillingAddress,
        isEUDC: isEUDC,
        isPrivateLabel: isPrivateLabel,
        tld: tld,
        url: url,
        onetrustBannerEnabled: onetrustBannerEnabled,
        __self: Footer_this,
        __source: {
            fileName: Footer_jsxFileName,
            lineNumber: 21,
            columnNumber: 5
        }
    }, !!isUserAuthenticated ? /*#__PURE__*/ react.createElement(Footer_AuthedFooter, {
        __self: Footer_this,
        __source: {
            fileName: Footer_jsxFileName,
            lineNumber: 37,
            columnNumber: 11
        }
    }) : /*#__PURE__*/ react.createElement(Footer_AnonFooter, {
        __self: Footer_this,
        __source: {
            fileName: Footer_jsxFileName,
            lineNumber: 40,
            columnNumber: 11
        }
    }));
};
/* harmony default export */ var components_Footer = (SMFooter); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Recaptcha/index.js + 1 modules
var Recaptcha = __webpack_require__(6537);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/node_modules/@wds/progress-circle/dist/index.es.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var progress_circle_dist_index_es_assign = function() {
    progress_circle_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return progress_circle_dist_index_es_assign.apply(this, arguments);
};

function progress_circle_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var progress_circle_dist_index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var spacing = theme.spacing, palette = theme.palette, type = theme.type;
    var width = function (s) {
        return {
            xs: spacing[4],
            sm: spacing[6],
            md: spacing[8],
            lg: spacing[10],
        }[s];
    };
    var font = function (s) {
        return {
            xs: type.fontSize.bodySm,
            sm: type.fontSize.bodySm,
            md: type.fontSize.body,
            lg: type.fontSize.pageTitle,
        }[s];
    };
    var fontWeight = function (s) {
        return {
            xs: type.fontWeight.regular,
            sm: type.fontWeight.regular,
            md: type.fontWeight.medium,
            lg: type.fontWeight.medium,
        }[s];
    };
    var height = width;
    var rotate = {
        '@keyframes rotate': {
            '100%': {
                transform: 'rotate(360deg)',
            },
        },
    };
    var stretch = {
        '@keyframes stretch': {
            '0%': {
                strokeDasharray: '339.292, 339.292',
                strokeDashoffset: '203.57519999999997',
                animationTimingFunction: 'cubic-bezier(0.3, 0, 1, 1)',
            },
            '40%': {
                strokeDasharray: '339.292, 339.292',
                strokeDashoffset: '253.57519999999997',
                animationTimingFunction: 'cubic-bezier(0, 0, 0.9, 1)',
            },
            '65%': {
                strokeDashoffset: '303.57519999999997',
            },
            '100%': {
                strokeDashoffset: '203.57519999999997',
            },
        },
    };
    return progress_circle_dist_index_es_assign(progress_circle_dist_index_es_assign(progress_circle_dist_index_es_assign({}, rotate), stretch), { wrenchProgressCircle: function (_a) {
            var size = _a.size, continuous = _a.continuous;
            return ({
                display: 'inline-block',
                position: 'relative',
                width: width(size),
                height: height(size),
                fill: 'none',
                '-webkit-transform': continuous && 'translate3d(0,0,0)',
            });
        }, wrenchCirclePath: function () { return ({
            transform: 'rotate(-90deg)',
        }); }, wrenchCirclePathGroup: function (_a) {
            var continuous = _a.continuous;
            return ({
                animation: continuous && '$rotate 1s linear infinite',
                transformOrigin: continuous && 'center center',
            });
        }, wrenchCirclePathBorder: function () { return ({
            stroke: palette.muted.main,
        }); }, wrenchCirclePathFill: function (_a) {
            var color = _a.color, continuous = _a.continuous;
            return ({
                stroke: palette[color].main,
                strokeLinecap: 'round',
                strokeDasharray: continuous && '339.292, 339.292',
                strokeDashoffset: continuous && '203.57519999999997',
                animation: continuous && '$stretch 1s infinite',
                transformOrigin: continuous && 'center center',
            });
        }, wrenchCircleDisplay: function (_a) {
            var size = _a.size;
            return ({
                position: 'absolute',
                top: '0',
                left: '0',
                width: width(size),
                height: height(size),
                fontSize: font(size),
                fontWeight: fontWeight(size),
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
            });
        } });
});

var CIRCLE_CIRCUMFERENCE = 339.292;
var index_es_ProgressCircle = function (_a) {
    var _b = _a.children, children = _b === void 0 ? undefined : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.percent, percent = _d === void 0 ? undefined : _d, _e = _a.color, color = _e === void 0 ? 'success' : _e, _f = _a.continuous, continuous = _f === void 0 ? false : _f, _g = _a.valueMax, valueMax = _g === void 0 ? undefined : _g, _h = _a.valueMin, valueMin = _h === void 0 ? undefined : _h, _j = _a.valueText, valueText = _j === void 0 ? undefined : _j, rest = progress_circle_dist_index_es_rest(_a, ["children", "size", "percent", "color", "continuous", "valueMax", "valueMin", "valueText"]);
    var classes = progress_circle_dist_index_es_useStyles({ color: color, size: size, continuous: continuous });
    var circleOptions = {
        lg: {
            strokeWidth: 8,
            radius: 56,
        },
        sm: {
            strokeWidth: 16,
            radius: 52,
        },
        md: {
            strokeWidth: 12,
            radius: 54,
        },
        xs: {
            strokeWidth: 20,
            radius: 50,
        },
    };
    var _k = circleOptions[size], strokeWidth = _k.strokeWidth, radius = _k.radius;
    var valueNow = percent ? percent * 100 : undefined;
    var strokeDasharray = !continuous
        ? "".concat(CIRCLE_CIRCUMFERENCE, " ").concat(CIRCLE_CIRCUMFERENCE)
        : undefined;
    var strokeDashoffset = !continuous && percent ? CIRCLE_CIRCUMFERENCE * (1 - percent) : undefined;
    return (react.createElement("div", progress_circle_dist_index_es_assign({ className: classes.wrenchProgressCircle, role: "progressbar", "aria-valuenow": valueNow, "aria-valuemax": valueMax, "aria-valuemin": valueMin, "aria-valuetext": valueText }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)),
        react.createElement("svg", { className: classes.wrenchCirclePath, role: "img", "aria-label": "Progress", viewBox: "0 0 120 120" },
            react.createElement("g", { className: classes.wrenchCirclePathGroup },
                react.createElement("circle", { className: classes.wrenchCirclePathBorder, cx: "60", cy: "60", r: radius, strokeWidth: strokeWidth }),
                react.createElement("circle", { className: classes.wrenchCirclePathFill, cx: "60", cy: "60", r: radius, strokeWidth: strokeWidth, strokeDasharray: strokeDasharray, strokeDashoffset: strokeDashoffset }))),
        children && (react.createElement("div", { className: classes.wrenchCircleDisplay }, children))));
};

var PROGRESS_CIRCLE_COLORS = (/* unused pure expression or super */ null && ([
    'primary',
    'secondary',
    'success',
    'warning',
    'error',
    'upgrade',
    'info',
]));
var PROGRESS_CIRCLE_SIZES = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg']));



;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/AccountCard/AccountName/AccountName.js

var AccountName_jsxFileName = "/repo/packages/webassets/src/components/AccountCard/AccountName/AccountName.tsx", AccountName_this = undefined;
function AccountName_defineProperty(obj, key, value) {
    key = AccountName_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AccountName_toPropertyKey(arg) {
    var key = AccountName_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function AccountName_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



var AccountName_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function(theme) {
    return {
        accountName: AccountName_defineProperty({
            maxWidth: "225px"
        }, "@media (min-width: ".concat(theme.breakpoints.sm, "px)"), {
            maxWidth: "300px"
        }),
        truncate: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    };
});
var AccountName_AccountName = function AccountName(_ref) {
    var username = _ref.username;
    var _useStyles = AccountName_useStyles(), accountName = _useStyles.accountName, truncate = _useStyles.truncate;
    return /*#__PURE__*/ React.createElement("div", {
        className: accountName,
        __self: AccountName_this,
        __source: {
            fileName: AccountName_jsxFileName,
            lineNumber: 23,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        component: "div",
        variant: "bodySm",
        __self: AccountName_this,
        __source: {
            fileName: AccountName_jsxFileName,
            lineNumber: 24,
            columnNumber: 7
        }
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": "AccountName__Username",
        className: truncate,
        __self: AccountName_this,
        __source: {
            fileName: AccountName_jsxFileName,
            lineNumber: 25,
            columnNumber: 9
        }
    }, /*#__PURE__*/ React.createElement("strong", {
        __self: AccountName_this,
        __source: {
            fileName: AccountName_jsxFileName,
            lineNumber: 26,
            columnNumber: 11
        }
    }, username))));
};
/* harmony default export */ var AccountCard_AccountName_AccountName = ((/* unused pure expression or super */ null && (AccountName_AccountName))); //# sourceMappingURL=AccountName.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/helpers/packageHelpers.js

function packageHelpers_defineProperty(obj, key, value) {
    key = packageHelpers_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function packageHelpers_toPropertyKey(arg) {
    var key = packageHelpers_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function packageHelpers_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// Helpers for localizing PackageTypes


var packageHelpers_COPY = (0,intl_dist/* defineMessages */.vU)({
    BASIC: {
        id: "packageHelpers.BasicPackage",
        defaultMessage: "Basic",
        description: "[Type: Label][Vis: med] - The name for the Basic account plan."
    },
    PRO: {
        id: "packageHelpers.ProPackage",
        defaultMessage: "Pro",
        description: "[Type: Label][Vis: med] - The name for the Pro account plan."
    },
    UNLIMITED: {
        id: "packageHelpers.UnlimitedPackage",
        defaultMessage: "Unlimited",
        description: "[Type: Label][Vis: med] - The name for the Unlimited account plan."
    },
    SELECT_MONTHLY: {
        id: "packageHelpers.Select MonthlyPackage",
        defaultMessage: "Select Monthly",
        description: "[Type: Label][Vis: med] - The name for the Select Monthly account plan."
    },
    SELECT_YEARLY: {
        id: "packageHelpers.Select AnnualPackage",
        defaultMessage: "Select Annual",
        description: "[Type: Label][Vis: med] - The name for the Select Annual account plan."
    },
    GOLD: {
        id: "packageHelpers.GoldPackage",
        defaultMessage: "Gold",
        description: "[Type: Label][Vis: med] - The name for the Gold account plan."
    },
    PLATINUM: {
        id: "packageHelpers.PlatinumPackage",
        defaultMessage: "Platinum",
        description: "[Type: Label][Vis: med] - The name for the Platinum account plan."
    },
    TEMP_PRO: {
        id: "packageHelpers.TempProPackage",
        defaultMessage: "Temporary Pro",
        description: "[Type: Label][Vis: med] - The name for the Temporary Pro account plan."
    },
    PRO_COMP: {
        id: "packageHelpers.CompProPackage",
        defaultMessage: "Complementary Pro",
        description: "[Type: Label][Vis: med] - The name for the Complementary Pro account plan."
    },
    ZOOM_PREMIUM: {
        id: "packageHelpers.ZoomPremiumPackage",
        defaultMessage: "Zoomerang Premium",
        description: "[Type: Label][Vis: med] - The name for the Zoomerang Premium account plan."
    },
    ZOOM_PRO: {
        id: "packageHelpers.ZoomProPackage",
        defaultMessage: "Zoomerang Pro",
        description: "[Type: Label][Vis: med] - The name for the Zoomerang Pro account plan."
    },
    ENTERPRISE_GOLD: {
        id: "packageHelpers.EnterpriseGoldPackage",
        defaultMessage: "Enterprise Gold",
        description: "[Type: Label][Vis: med] - The name for the Enterprise Gold account plan."
    },
    ENTERPRISE_PLATINUM: {
        id: "packageHelpers.EnterprisePackage",
        defaultMessage: "Enterprise",
        description: "[Type: Label][Vis: med] - The name for the Enterprise account plan."
    },
    ENTERPRISE: {
        id: "packageHelpers.EnterprisePackage",
        defaultMessage: "Enterprise",
        description: "[Type: Label][Vis: med] - The name for the Enterprise account plan."
    },
    STANDARD_MONTHLY: {
        id: "packageHelpers.StandardMonthlyPackage",
        defaultMessage: "Standard Monthly",
        description: "[Type: Label][Vis: med] - The name for the Standard Monthly account plan."
    },
    STANDARD_ANNUAL: {
        id: "packageHelpers.StandardAnnualPackage",
        defaultMessage: "Standard Annual",
        description: "[Type: Label][Vis: med] - The name for the Standard Annual account plan."
    },
    ADVANTAGE_MONTHLY: {
        id: "packageHelpers.AdvantageMonthlyPackage",
        defaultMessage: "Advantage Monthly",
        description: "[Type: Label][Vis: med] - The name for the Advantage Monthly account plan."
    },
    ADVANTAGE_ANNUAL: {
        id: "packageHelpers.AdvantageAnnualPackage",
        defaultMessage: "Advantage Annual",
        description: "[Type: Label][Vis: med] - The name for the Advantage Annual account plan."
    },
    PREMIER_MONTHLY: {
        id: "packageHelpers.PremierMonthlyPackage",
        defaultMessage: "Premier Monthly",
        description: "[Type: Label][Vis: med] - The name for the Premier Monthly account plan."
    },
    PREMIER_ANNUAL: {
        id: "packageHelpers.PremierAnnualPackage",
        defaultMessage: "Premier Annual",
        description: "[Type: Label][Vis: med] - The name for the Premier Annual account plan."
    },
    ANALYZE_PACKAGE: {
        id: "packageHelpers.FlexPackagePackage",
        defaultMessage: "Flex Package",
        description: "[Type: Label][Vis: med] - The name for the Flex Package account plan."
    },
    TEAM_ADVANTAGE_ANNUAL: {
        id: "packageHelpers.TeamAdvantageAnnualPackage",
        defaultMessage: "Team Advantage Annual",
        description: "[Type: Label][Vis: med] - The name for the Team Advantage Annual account plan."
    },
    TEAM_PREMIER_ANNUAL: {
        id: "packageHelpers.TeamPremierAnnualPackage",
        defaultMessage: "Team Premier Annual",
        description: "[Type: Label][Vis: med] - The name for the Team Premier Annual account plan."
    },
    ENTERPRISE_CONTRIBUTOR_SEAT: {
        id: "packageHelpers.EnterpriseContributorSeatPackage",
        defaultMessage: "Enterprise Contributor Seat",
        description: "[Type: Label][Vis: med] - The name for the Enterprise Contributor Seat account plan."
    },
    TEAM_ADVANTAGE_CONTRIBUTOR_SEAT: {
        id: "packageHelpers.TeamAdvantageContributorSeatPackage",
        defaultMessage: "Team Advantage Contributor Seat",
        description: "[Type: Label][Vis: med] - The name for the Team Advantage Contributor Seat account plan."
    },
    TEAM_PREMIER_CONTRIBUTOR_SEAT: {
        id: "packageHelpers.TeamPremierContributorSeatPackage",
        defaultMessage: "Team Premier Contributor Seat",
        description: "[Type: Label][Vis: med] - The name for the Team Premier Contributor Seat account plan."
    }
});
/**
 * Returns the translated display name of a package.
 *
 * @param packageID
 * @returns The localized name
 */ function getPackageName(packageID) {
    var _packageTypeToName;
    var packageTypeToName = (_packageTypeToName = {}, packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.BASIC, (0,intl_dist.t)(packageHelpers_COPY.BASIC)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.PRO, (0,intl_dist.t)(packageHelpers_COPY.PRO)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.UNLIMITED, (0,intl_dist.t)(packageHelpers_COPY.UNLIMITED)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.SELECT_MONTHLY, (0,intl_dist.t)(packageHelpers_COPY.SELECT_MONTHLY)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.SELECT_YEARLY, (0,intl_dist.t)(packageHelpers_COPY.SELECT_YEARLY)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.GOLD, (0,intl_dist.t)(packageHelpers_COPY.GOLD)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.PLATINUM, (0,intl_dist.t)(packageHelpers_COPY.PLATINUM)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.TEMP_PRO, (0,intl_dist.t)(packageHelpers_COPY.TEMP_PRO)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.PRO_COMP, (0,intl_dist.t)(packageHelpers_COPY.PRO_COMP)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ZOOM_PREMIUM, (0,intl_dist.t)(packageHelpers_COPY.ZOOM_PREMIUM)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ZOOM_PRO, (0,intl_dist.t)(packageHelpers_COPY.ZOOM_PRO)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ENT_GOLD, (0,intl_dist.t)(packageHelpers_COPY.ENTERPRISE_GOLD)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ENTERPRISE_PLATINUM, (0,intl_dist.t)(packageHelpers_COPY.ENTERPRISE)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ENTERPRISE, (0,intl_dist.t)(packageHelpers_COPY.ENTERPRISE)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ENTERPRISE_CASUAL_USER, (0,intl_dist.t)(packageHelpers_COPY.ENTERPRISE)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.STANDARD_MONTHLY, (0,intl_dist.t)(packageHelpers_COPY.STANDARD_MONTHLY)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.STANDARD_ANNUAL, (0,intl_dist.t)(packageHelpers_COPY.STANDARD_ANNUAL)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ADVANTAGE_MONTHLY, (0,intl_dist.t)(packageHelpers_COPY.ADVANTAGE_MONTHLY)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ADVANTAGE_ANNUAL, (0,intl_dist.t)(packageHelpers_COPY.ADVANTAGE_ANNUAL)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.PREMIER_MONTHLY, (0,intl_dist.t)(packageHelpers_COPY.PREMIER_MONTHLY)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.PREMIER_ANNUAL, (0,intl_dist.t)(packageHelpers_COPY.PREMIER_ANNUAL)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ANALYZE_PACKAGE, (0,intl_dist.t)(packageHelpers_COPY.ANALYZE_PACKAGE)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.TEAM_ADVANTAGE_ANNUAL, (0,intl_dist.t)(packageHelpers_COPY.TEAM_ADVANTAGE_ANNUAL)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.TEAM_PREMIER_ANNUAL, (0,intl_dist.t)(packageHelpers_COPY.TEAM_PREMIER_ANNUAL)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.ENTERPRISE_CONTRIBUTOR_SEAT, (0,intl_dist.t)(packageHelpers_COPY.ENTERPRISE_CONTRIBUTOR_SEAT)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.TEAM_ADVANTAGE_CONTRIBUTOR_SEAT, (0,intl_dist.t)(packageHelpers_COPY.TEAM_ADVANTAGE_CONTRIBUTOR_SEAT)), packageHelpers_defineProperty(_packageTypeToName, dist.PackageType.TEAM_PREMIER_CONTRIBUTOR_SEAT, (0,intl_dist.t)(packageHelpers_COPY.TEAM_PREMIER_CONTRIBUTOR_SEAT)), _packageTypeToName);
    return packageTypeToName[packageID];
}; //# sourceMappingURL=packageHelpers.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/AccountCard/AccountTypeBadge/useStyles.js

var useStyles_Object$freeze;
function AccountTypeBadge_useStyles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function AccountTypeBadge_useStyles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? AccountTypeBadge_useStyles_ownKeys(Object(source), !0).forEach(function(key) {
            AccountTypeBadge_useStyles_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AccountTypeBadge_useStyles_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function useStyles_slicedToArray(arr, i) {
    return useStyles_arrayWithHoles(arr) || useStyles_iterableToArrayLimit(arr, i) || useStyles_unsupportedIterableToArray(arr, i) || useStyles_nonIterableRest();
}
function useStyles_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useStyles_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useStyles_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useStyles_arrayLikeToArray(o, minLen);
}
function useStyles_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function useStyles_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function useStyles_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AccountTypeBadge_useStyles_defineProperty(obj, key, value) {
    key = AccountTypeBadge_useStyles_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AccountTypeBadge_useStyles_toPropertyKey(arg) {
    var key = AccountTypeBadge_useStyles_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function AccountTypeBadge_useStyles_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


// This file helps us map a packageId to its conventional color & background color
// as shown on the billing pages.
// https://code.corp.surveymonkey.com/devmonkeys/BillWeb/blob/develop/billweb/static/scss/_packages.scss
// https://code.corp.surveymonkey.com/webplatform/smweb/blob/master/apps/contentweb/src/app/pages/Pricing/lib/package-colors.scss
var toColorScheme = Object.freeze((useStyles_Object$freeze = {}, AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.ADVANTAGE_ANNUAL, "advantage"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.ADVANTAGE_MONTHLY, "advantage"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.ANALYZE_PACKAGE, "analyze"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.BASIC, "basic"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.ENTERPRISE_CASUAL_USER, "enterprise"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.ENTERPRISE_CONTRIBUTOR_SEAT, "enterprise"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.ENTERPRISE_PLATINUM, "enterprise"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.ENTERPRISE, "enterprise"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.PREMIER_ANNUAL, "premier"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.PREMIER_MONTHLY, "premier"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.STANDARD_ANNUAL, "standard"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.STANDARD_MONTHLY, "standard"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.TEAM_ADVANTAGE_ANNUAL, "team_advantage"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.TEAM_ADVANTAGE_CONTRIBUTOR_SEAT, "team_advantage"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.TEAM_PREMIER_ANNUAL, "team_premier"), AccountTypeBadge_useStyles_defineProperty(useStyles_Object$freeze, dist.PackageType.TEAM_PREMIER_CONTRIBUTOR_SEAT, "team_premier"), useStyles_Object$freeze));
var wrenchBadgeSizeSm = 22;
// These hardcoded colors can be removed when billing pages adopt Wrench theming. At present
// they're using the SM brand colors, which don't map 1:1 to the Wrench palette
var SM_RASPBERRY = "#AC145A";
var SM_MIDNIGHT = "#05467E";
var SM_ARCTIC = "#2DCCD3";
var SM_CONCORD = "#671E75";
var AccountTypeBadge_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var type = theme.type, spacing = theme.spacing, radius = theme.radius, palette = theme.palette;
    var data = palette.data, text = palette.text, link = palette.link;
    var badgeStyles = {
        display: "inline-block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: type.fontSize.bodySm,
        fontWeight: type.fontWeight.medium,
        padding: "0 ".concat(spacing[2], "px"),
        maxWidth: "100%",
        height: "".concat(wrenchBadgeSizeSm, "px"),
        lineHeight: "".concat(wrenchBadgeSizeSm, "px"),
        borderRadius: radius.small
    };
    var packageColors = {
        advantage: [
            text.light,
            data.two
        ],
        // sabaeus
        analyze: [
            text.light,
            SM_RASPBERRY
        ],
        // raspberry
        basic: [
            text.dark,
            text.lightMuted
        ],
        // flint
        enterprise: [
            text.light,
            SM_MIDNIGHT
        ],
        // midnight
        premier: [
            text.light,
            SM_MIDNIGHT
        ],
        // midnight
        standard: [
            text.dark,
            SM_ARCTIC
        ],
        // arctic
        team_advantage: [
            link.contrast,
            link.main
        ],
        // link
        team_premier: [
            text.light,
            SM_CONCORD
        ],
        // concord
        // fallback
        default: [
            text.dark,
            text.lightMuted
        ] // flint
    };
    var getPackageColors = function getPackageColors(packageId) {
        var key = toColorScheme[packageId] || "default";
        var _packageColors$key = useStyles_slicedToArray(packageColors[key], 2), color = _packageColors$key[0], backgroundColor = _packageColors$key[1];
        return {
            color: color,
            backgroundColor: backgroundColor
        };
    };
    return {
        badge: function badge(_ref) {
            var packageId = _ref.packageId;
            return AccountTypeBadge_useStyles_objectSpread(AccountTypeBadge_useStyles_objectSpread({}, badgeStyles), getPackageColors(packageId));
        }
    };
});
/* harmony default export */ var AccountTypeBadge_useStyles = (AccountTypeBadge_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/AccountCard/AccountTypeBadge/AccountTypeBadge.js
var AccountTypeBadge_jsxFileName = "/repo/packages/webassets/src/components/AccountCard/AccountTypeBadge/AccountTypeBadge.tsx", AccountTypeBadge_this = undefined;





var AccountTypeBadge_AccountTypeBadge = function AccountTypeBadge(_ref) {
    var packageId = _ref.packageId, teamName = _ref.teamName;
    var _useStyles = AccountTypeBadge_useStyles({
        packageId: packageId
    }), badge = _useStyles.badge;
    return /*#__PURE__*/ react.createElement("span", {
        "data-testid": "AccountTypeBadge",
        className: badge,
        __self: AccountTypeBadge_this,
        __source: {
            fileName: AccountTypeBadge_jsxFileName,
            lineNumber: 16,
            columnNumber: 5
        }
    }, !!teamName && (0,dist.isEnterprisePackage)(packageId) ? teamName : getPackageName(packageId));
};
/* harmony default export */ var AccountCard_AccountTypeBadge_AccountTypeBadge = ((0,theme/* withWebAssetsTheme */.I6)(AccountTypeBadge_AccountTypeBadge)); //# sourceMappingURL=AccountTypeBadge.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/AccountCard/useStyles.js

function AccountCard_useStyles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function AccountCard_useStyles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? AccountCard_useStyles_ownKeys(Object(source), !0).forEach(function(key) {
            AccountCard_useStyles_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AccountCard_useStyles_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function AccountCard_useStyles_defineProperty(obj, key, value) {
    key = AccountCard_useStyles_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AccountCard_useStyles_toPropertyKey(arg) {
    var key = AccountCard_useStyles_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function AccountCard_useStyles_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var DEFAULT_HEIGHT = 80;
var AccountCard_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(_ref) {
    var spacing = _ref.spacing, shadow = _ref.shadow, palette = _ref.palette, type = _ref.type;
    return {
        accountCard: {
            fontFamily: type.fontFamily.base,
            fontSize: type.fontSize.body,
            "-webkit-font-smoothing": "antialiased",
            backgroundColor: palette.background.light,
            border: "2px solid ".concat(palette.border.muted),
            borderRadius: "4px",
            boxShadow: shadow.none,
            position: "relative",
            // hover styles for interactive card
            "&:hover, &:focus": {
                borderColor: palette.border.hover,
                cursor: "pointer"
            }
        },
        // These styles get added conditionally based on component props
        accountCardDynamic: function accountCardDynamic(_ref2) {
            var selected = _ref2.selected;
            return AccountCard_useStyles_objectSpread({}, selected && {
                borderColor: palette.border.active,
                "&:hover, &focus": {
                    borderColor: palette.border.active
                }
            });
        },
        accountCardBody: function accountCardBody(_ref3) {
            var loading = _ref3.loading, _ref3$height = _ref3.height, height = _ref3$height === void 0 ? DEFAULT_HEIGHT : _ref3$height;
            return AccountCard_useStyles_objectSpread({
                padding: "0 ".concat(spacing[4], "px"),
                minHeight: "".concat(height, "px"),
                display: "flex",
                alignItems: "center"
            }, loading ? {
                justifyContent: "center"
            } : {});
        },
        accountType: {
            position: "absolute",
            top: 0
        },
        spinner: {
            minHeight: "100%"
        }
    };
});
/* harmony default export */ var AccountCard_useStyles = ((/* unused pure expression or super */ null && (AccountCard_useStyles_useStyles))); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/AccountCard/AccountCard.js

var AccountCard_excluded = (/* unused pure expression or super */ null && ([
    "account",
    "addOnLeft",
    "addOnRight",
    "height",
    "onClick",
    "onKeyDown",
    "selected",
    "loading",
    "loadingAltText"
]));
var AccountCard_jsxFileName = "/repo/packages/webassets/src/components/AccountCard/AccountCard.tsx", AccountCard_this = undefined;
function AccountCard_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function AccountCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? AccountCard_ownKeys(Object(source), !0).forEach(function(key) {
            AccountCard_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AccountCard_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function AccountCard_defineProperty(obj, key, value) {
    key = AccountCard_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AccountCard_toPropertyKey(arg) {
    var key = AccountCard_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : _type_of(key)) === "symbol" ? key : String(key);
}
function AccountCard_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function AccountCard_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = AccountCard_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function AccountCard_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var ACCOUNT_CARD_TEST_ID = "AccountPicker__AccountCard";
var AccountCard_COPY = (0,intl_dist/* defineMessages */.vU)({
    lastLogin: {
        id: "AccountCard.lastLoginDate",
        defaultMessage: "Last login {date}",
        description: "[Type: Label][Vis.: med] - Label for a field that shows the date when user last logged into an account"
    }
});
var CardSpinner = function CardSpinner(_ref) {
    var _ref$className = _ref.className, className = _ref$className === void 0 ? undefined : _ref$className, altText = _ref.altText;
    return /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        flexJustify: "center",
        flexAlign: "center",
        className: className,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 28,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(ProgressCircle, {
        size: "sm",
        continuous: true,
        valueText: altText,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 34,
            columnNumber: 7
        }
    }));
};
var AccountCard = function AccountCard(props) {
    return /*#__PURE__*/ React.createElement(WebAssetsThemeWrapper, {
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 41,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(AccountCardContent, Object.assign({}, props, {
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 42,
            columnNumber: 7
        }
    })));
};
/**
 * Interactive card for rendering a `LinkedIdentity`
 */ var AccountCardContent = function AccountCardContent(_ref2) {
    var account = _ref2.account, addOnLeft = _ref2.addOnLeft, addOnRight = _ref2.addOnRight, height = _ref2.height, onClick = _ref2.onClick, onKeyDown = _ref2.onKeyDown, _ref2$selected = _ref2.selected, selected = _ref2$selected === void 0 ? false : _ref2$selected, _ref2$loading = _ref2.loading, loading = _ref2$loading === void 0 ? false : _ref2$loading, _ref2$loadingAltText = _ref2.loadingAltText, loadingAltText = _ref2$loadingAltText === void 0 ? "" : _ref2$loadingAltText, props = AccountCard_objectWithoutProperties(_ref2, AccountCard_excluded);
    var _useStyles = useStyles({
        selected: selected,
        loading: loading,
        height: height
    }), accountCard = _useStyles.accountCard, accountCardDynamic = _useStyles.accountCardDynamic, accountCardBody = _useStyles.accountCardBody, accountType = _useStyles.accountType, spinner = _useStyles.spinner;
    var mainContent = /*#__PURE__*/ React.createElement("div", {
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 75,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: accountType,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 77,
            columnNumber: 7
        }
    }, /*#__PURE__*/ React.createElement(AccountTypeBadge, {
        packageId: parseInt(account.packageId, 10),
        teamName: account.teamName || undefined,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 78,
            columnNumber: 9
        }
    })), /*#__PURE__*/ React.createElement(Box, {
        mt: 4,
        display: "flex",
        flexDirection: "column",
        flexJustify: "flex-start",
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 84,
            columnNumber: 7
        }
    }, /*#__PURE__*/ React.createElement(AccountName, {
        username: account.username,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 90,
            columnNumber: 9
        }
    }), account.lastLoggedInAt ? /*#__PURE__*/ React.createElement(Typography, {
        variant: "bodySm",
        color: "darkMuted",
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 92,
            columnNumber: 11
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: AccountCard_COPY.lastLogin,
        values: {
            date: FormattedDateTime({
                value: new Date(account.lastLoggedInAt),
                month: "short",
                day: "numeric",
                year: "numeric"
            })
        },
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 93,
            columnNumber: 13
        }
    })) : /*#__PURE__*/ React.createElement(React.Fragment, null)));
    var leftContent = addOnLeft ? /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        flexAlign: "center",
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 113,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        mr: 4,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 114,
            columnNumber: 7
        }
    }, addOnLeft)) : /*#__PURE__*/ React.createElement(React.Fragment, null);
    var rightContent = addOnRight ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        style: {
            flexGrow: 1
        },
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 122,
            columnNumber: 7
        }
    }), /*#__PURE__*/ React.createElement(Box, {
        display: "flex",
        flexAlign: "center",
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 123,
            columnNumber: 7
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        ml: 2,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 124,
            columnNumber: 9
        }
    }, addOnRight))) : /*#__PURE__*/ React.createElement(React.Fragment, null);
    var cardProps = AccountCard_objectSpread({
        role: "button",
        onKeyDown: onKeyDown,
        onClick: onClick,
        tabIndex: 0
    }, props);
    return /*#__PURE__*/ React.createElement(Box, {
        mb: 4,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 140,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement("div", Object.assign({
        "data-testid": ACCOUNT_CARD_TEST_ID,
        className: "".concat(accountCard, " ").concat(accountCardDynamic)
    }, cardProps, {
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 141,
            columnNumber: 7
        }
    }), loading ? /*#__PURE__*/ React.createElement("div", {
        className: accountCardBody,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 147,
            columnNumber: 11
        }
    }, /*#__PURE__*/ React.createElement(CardSpinner, {
        className: spinner,
        altText: loadingAltText,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 148,
            columnNumber: 13
        }
    })) : /*#__PURE__*/ React.createElement("div", {
        className: accountCardBody,
        __self: AccountCard_this,
        __source: {
            fileName: AccountCard_jsxFileName,
            lineNumber: 151,
            columnNumber: 11
        }
    }, leftContent, mainContent, rightContent)));
};
/* harmony default export */ var AccountCard_AccountCard = ((/* unused pure expression or super */ null && (AccountCard))); //# sourceMappingURL=AccountCard.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/AccountCard/index.js
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@wds/input/dist/index.es.js + 1 modules
var input_dist_index_es = __webpack_require__(7634);
;// CONCATENATED MODULE: ./node_modules/@wds/input-group/dist/index.es.js





var COLOR_OPTIONS = (/* unused pure expression or super */ null && ([
    'default',
    'success',
    'warning',
    'error',
]));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var input_group_dist_index_es_assign = function() {
    input_group_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return input_group_dist_index_es_assign.apply(this, arguments);
};

function input_group_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStylesInput = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (theme) {
    var radius = theme.radius, palette = theme.palette, shadow = theme.shadow, spacing = theme.spacing, border = theme.border;
    var inputGroupStyles = {
        wrenchInputGroup: function (_a) {
            var color = _a.color, stretched = _a.stretched, disabled = _a.disabled;
            return ({
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: border.main,
                background: palette.background.light,
                borderRadius: radius.small,
                width: stretched ? '100%' : null,
                pointerEvents: disabled ? 'none' : null,
                opacity: disabled ? '0.4' : null,
                borderColor: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.border.main }),
                '&:hover': {
                    borderColor: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.border.hover }),
                    boxShadow: shadow.sky,
                    transition: ['border-color 100ms', 'box-shawdow 100ms'],
                },
                '&:focus': {
                    borderColor: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.border.active }),
                    transition: ['border-color', '100ms'],
                },
                '& > input': {
                    color: (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.text.dark }),
                    border: 'none',
                    flexGrow: 1,
                    width: stretched ? '100%' : null,
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
                '&:empty': {
                    border: 0,
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    margin: '-1px',
                    overflow: 'hidden',
                    padding: 0,
                    position: 'absolute',
                    width: '1px',
                },
            });
        },
        wrenchInputGroupAddon: function () { return (input_group_dist_index_es_assign(input_group_dist_index_es_assign({ whiteSpace: 'nowrap' }, (0,utils_dist_index_es/* defaultFonts */.FZ)(theme)), { '&:first-child': {
                paddingLeft: spacing[1],
                '& > svg': {
                    marginLeft: spacing[2],
                    fill: function (_a) {
                        var color = _a.color;
                        return (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.text.dark });
                    },
                    color: function (_a) {
                        var color = _a.color;
                        return (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.text.dark });
                    },
                },
            }, '&:last-child': {
                paddingRight: spacing[1],
                '& > svg': {
                    marginRight: spacing[2],
                    fill: function (_a) {
                        var color = _a.color;
                        return (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.text.dark });
                    },
                    color: function (_a) {
                        var color = _a.color;
                        return (0,styles_dist_index_es/* getColor */.Lq)(palette, color, { fallback: palette.text.dark });
                    },
                },
            } })); },
    };
    return inputGroupStyles;
});

var InputGroup = function (_a) {
    var children = _a.children, id = _a.id, label = _a.label, _b = _a.stretched, stretched = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.color, color = _d === void 0 ? 'default' : _d, rest = input_group_dist_index_es_rest(_a, ["children", "id", "label", "stretched", "disabled", "color"]);
    (0,utils_dist_index_es/* deprecate */.Rn)({ color: color }, 'color', 'warning', 'InputGroup');
    var inputID = (0,react.useMemo)(function () { return id !== null && id !== void 0 ? id : (0,utils_dist_index_es/* uniqueId */.EL)('input'); }, [id]);
    var wrenchInputGroup = useStylesInput({ color: color, stretched: stretched, disabled: disabled }).wrenchInputGroup;
    return (react.createElement(react.Fragment, null,
        label && react.createElement(label_dist_index_es/* Label */._, { htmlFor: inputID }, label),
        react.createElement("div", input_group_dist_index_es_assign({ className: wrenchInputGroup }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)), children)));
};

var InputGroupAddon = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'default' : _b, rest = input_group_dist_index_es_rest(_a, ["children", "color"]);
    var wrenchInputGroupAddon = useStylesInput({ color: color }).wrenchInputGroupAddon;
    return (react.createElement("div", input_group_dist_index_es_assign({ className: wrenchInputGroupAddon }, (0,utils_dist_index_es/* safeRest */.Q6)(rest)), children));
};



;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Autocomplete/Autocomplete.js
var Autocomplete_jsxFileName = "/repo/packages/webassets/src/components/Autocomplete/Autocomplete.tsx", Autocomplete_this = undefined;
function Autocomplete_slicedToArray(arr, i) {
    return Autocomplete_arrayWithHoles(arr) || Autocomplete_iterableToArrayLimit(arr, i) || Autocomplete_unsupportedIterableToArray(arr, i) || Autocomplete_nonIterableRest();
}
function Autocomplete_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Autocomplete_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Autocomplete_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Autocomplete_arrayLikeToArray(o, minLen);
}
function Autocomplete_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function Autocomplete_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function Autocomplete_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}







var UNSELECTED_ITEM_INDEX = -1;
var Autocomplete = function Autocomplete(props) {
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: Autocomplete_this,
        __source: {
            fileName: Autocomplete_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement(AutocompleteContent, Object.assign({}, props, {
        __self: Autocomplete_this,
        __source: {
            fileName: Autocomplete_jsxFileName,
            lineNumber: 15,
            columnNumber: 5
        }
    })));
};
var AutocompleteContent = function AutocompleteContent(_ref) {
    var data = _ref.data, onTextChanged = _ref.onTextChanged, _ref$onItemSelected = _ref.onItemSelected, onItemSelected = _ref$onItemSelected === void 0 ? function onItemSelected() {} : _ref$onItemSelected, text = _ref.text, placeholder = _ref.placeholder, _ref$renderItem = _ref.renderItem, renderItem = _ref$renderItem === void 0 ? function renderItem(item) {
        return item.text;
    } : _ref$renderItem, _ref$onSubmit = _ref.onSubmit, onSubmit = _ref$onSubmit === void 0 ? function onSubmit() {} : _ref$onSubmit, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$icon = _ref.icon, icon = _ref$icon === void 0 ? /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconSearch */.jVj, {
        title: "Search",
        __self: Autocomplete_this,
        __source: {
            fileName: Autocomplete_jsxFileName,
            lineNumber: 28,
            columnNumber: 10
        }
    }) : _ref$icon, _ref$hasError = _ref.hasError, hasError = _ref$hasError === void 0 ? false : _ref$hasError;
    var _useState = (0,react.useState)(UNSELECTED_ITEM_INDEX), _useState2 = Autocomplete_slicedToArray(_useState, 2), currentIndex = _useState2[0], setCurrentIndex = _useState2[1];
    var handleTextChange = function handleTextChange(e) {
        onTextChanged(e.target.value);
    };
    var handleItemSelected = function handleItemSelected(e) {
        var index = Number(e.currentTarget.getAttribute("data-index"));
        if (typeof index === "number") {
            var item = data[index];
            onItemSelected(item);
        }
    };
    var hasIcon = typeof icon !== "undefined";
    var handleKeyDown = function handleKeyDown(e) {
        var _ref2 = e.target, value = _ref2.value;
        if (e.key === "Enter" && currentIndex > -1) {
            onItemSelected(data[currentIndex]);
        } else if (e.key === "Enter" && value) {
            onSubmit(value);
        } else if (e.key === "Escape") {
            onTextChanged("");
        } else if (e.key === "ArrowDown" && currentIndex < data.length - 1) {
            setCurrentIndex(currentIndex + 1);
        } else if (e.key === "ArrowUp" && currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        } else if (e.key !== "ArrowDown" && e.key !== "ArrowUp") {
            setCurrentIndex(-1);
        }
    };
    var renderInput = function renderInput() {
        var color = hasError ? "warning" : undefined;
        return /*#__PURE__*/ react.createElement(InputGroup, {
            "data-testid": "Autocomplete",
            stretched: true,
            color: color,
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 67,
                columnNumber: 7
            }
        }, /*#__PURE__*/ react.createElement(input_dist_index_es/* Input */.I, {
            id: "Autocomplete",
            "data-testid": "Autocomplete__Input",
            value: text,
            onChange: handleTextChange,
            placeholder: placeholder,
            onKeyDown: handleKeyDown,
            stretched: true,
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 68,
                columnNumber: 9
            }
        }), isLoading ? /*#__PURE__*/ react.createElement(InputGroupAddon, {
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 79,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(index_es_ProgressCircle, {
            continuous: true,
            valueText: "Loading...",
            size: "xs",
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 80,
                columnNumber: 13
            }
        })) : // eslint-disable-next-line no-nested-ternary
        hasError ? /*#__PURE__*/ react.createElement(InputGroupAddon, {
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 84,
                columnNumber: 11
            }
        }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconWarning */.FCX, {
            title: "Warning",
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 85,
                columnNumber: 13
            }
        })) : hasIcon ? /*#__PURE__*/ react.createElement(InputGroupAddon, {
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 88,
                columnNumber: 11
            }
        }, icon) : null);
    };
    return /*#__PURE__*/ react.createElement(index_es_Menu, {
        "data-testid": "Autocomplete__Menu",
        dense: true,
        noRules: true,
        show: data.length > 0 && !!text,
        menuTrigger: renderInput(),
        stretched: true,
        __self: Autocomplete_this,
        __source: {
            fileName: Autocomplete_jsxFileName,
            lineNumber: 95,
            columnNumber: 5
        }
    }, data.map(function(item, idx) {
        return /*#__PURE__*/ react.createElement(index_es_Menu.Item, {
            "data-testid": "Autocomplete__MenuItem",
            key: item.id,
            onClick: handleItemSelected,
            isFocused: currentIndex === idx,
            __self: Autocomplete_this,
            __source: {
                fileName: Autocomplete_jsxFileName,
                lineNumber: 104,
                columnNumber: 9
            }
        }, renderItem(item));
    }));
};
Autocomplete.defaultProps = {};
/* harmony default export */ var Autocomplete_Autocomplete = ((/* unused pure expression or super */ null && (Autocomplete))); //# sourceMappingURL=Autocomplete.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/Autocomplete/index.js
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/BasePage/index.js + 5 modules
var BasePage = __webpack_require__(5159);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/captive-window.scss
var captive_window = __webpack_require__(8469);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/Footer/footer.scss
var footer = __webpack_require__(2284);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/Footer/footerCopy.js

/* harmony default export */ var footerCopy = ((0,intl_dist/* defineMessages */.vU)({
    help: {
        id: "footerCopy.Help",
        defaultMessage: "Help",
        description: "[Type: Link][Vis: low] - Link to the Help Center"
    },
    termsOfUse: {
        id: "footerCopy.TermsOfUse",
        defaultMessage: "Terms of Use",
        description: "[Type: Link][Vis: low] - Link to the Terms of Use"
    },
    privacyPolicy: {
        id: "footerCopy.PrivacyPolicy",
        defaultMessage: "Privacy Notice",
        description: "[Type: Link][Vis: low] - Link to the Privacy Notice"
    },
    regionalPrivacyPolicy: {
        id: "footerCopy.RegionalPrivacyPolicy",
        defaultMessage: "California Privacy Notice",
        description: "[Type: Link][Vis: low] - Link to the California Privacy Notice"
    },
    cookiePolicy: {
        id: "footerCopy.CookiesPolicy",
        defaultMessage: "Cookies Policy",
        description: "[Type: Link][Vis: low] - Link to the Cookies Policy"
    }
})); //# sourceMappingURL=footerCopy.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/Footer/getFooterLinks.js




function getFooterLinks_getFooterLinks(languageCode) {
    var linkParams = {
        ut_source: "captive_footer"
    };
    return [
        {
            text: t(COPY.help),
            href: getHelpCenterLink(languageCode, {
                params: linkParams
            })
        },
        {
            text: t(COPY.termsOfUse),
            href: createURL("/mp/legal/terms-of-use/", linkParams)
        },
        {
            text: t(COPY.privacyPolicy),
            href: createURL("/mp/legal/privacy/", linkParams)
        },
        {
            text: t(COPY.regionalPrivacyPolicy),
            href: createURL("/mp/legal/region-specific-privacy-statement/", linkParams)
        },
        {
            text: t(COPY.cookiePolicy),
            href: createURL("/mp/legal/cookies/", linkParams)
        }
    ];
}; //# sourceMappingURL=getFooterLinks.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/Footer/Footer.js
var Footer_Footer_jsxFileName = "/repo/packages/webassets/src/components/CaptiveWindow/Footer/Footer.tsx", Footer_Footer_this = undefined;




var Footer_Footer = function Footer() {
    var _useContext = useContext(StaticContext), languageCode = _useContext.environment.languageCode;
    return /*#__PURE__*/ React.createElement("footer", {
        className: "sm-captive-footer wds-container wds-flex",
        __self: Footer_Footer_this,
        __source: {
            fileName: Footer_Footer_jsxFileName,
            lineNumber: 11,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "wds-p-2 wds-m-3",
        __self: Footer_Footer_this,
        __source: {
            fileName: Footer_Footer_jsxFileName,
            lineNumber: 12,
            columnNumber: 7
        }
    }, getFooterLinks(languageCode).map(function(linkData) {
        return /*#__PURE__*/ React.createElement("a", {
            key: linkData.href,
            className: "sm-captive-footer__link",
            href: linkData.href,
            rel: "noopener noreferrer",
            __self: Footer_Footer_this,
            __source: {
                fileName: Footer_Footer_jsxFileName,
                lineNumber: 14,
                columnNumber: 11
            }
        }, linkData.text);
    }), /*#__PURE__*/ React.createElement("a", {
        href: "#cookiePreferences",
        className: "ot-sdk-show-settings",
        "data-testid": "CaptiveFooterLinks__cookiePreferences",
        __self: Footer_Footer_this,
        __source: {
            fileName: Footer_Footer_jsxFileName,
            lineNumber: 25,
            columnNumber: 9
        }
    })));
};
/* harmony default export */ var CaptiveWindow_Footer_Footer = ((/* unused pure expression or super */ null && (Footer_Footer))); //# sourceMappingURL=Footer.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/Footer/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/CaptiveWindow.js
var CaptiveWindow_jsxFileName = "/repo/packages/webassets/src/components/CaptiveWindow/CaptiveWindow.tsx", CaptiveWindow_this = undefined;





var CaptiveWindow = function CaptiveWindow(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "sm-captive-window__page wds-flex wds-flex--y wds-flex--x-center",
        __self: CaptiveWindow_this,
        __source: {
            fileName: CaptiveWindow_jsxFileName,
            lineNumber: 11,
            columnNumber: 3
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: "sm-captive-window__section",
        __self: CaptiveWindow_this,
        __source: {
            fileName: CaptiveWindow_jsxFileName,
            lineNumber: 12,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement("header", {
        className: "sm-logo__header",
        __self: CaptiveWindow_this,
        __source: {
            fileName: CaptiveWindow_jsxFileName,
            lineNumber: 13,
            columnNumber: 7
        }
    }, /*#__PURE__*/ React.createElement(LogoWithText, {
        className: "sm-logo__logo",
        __self: CaptiveWindow_this,
        __source: {
            fileName: CaptiveWindow_jsxFileName,
            lineNumber: 14,
            columnNumber: 9
        }
    })), /*#__PURE__*/ React.createElement(Card, Object.assign({}, props, {
        __self: CaptiveWindow_this,
        __source: {
            fileName: CaptiveWindow_jsxFileName,
            lineNumber: 17,
            columnNumber: 7
        }
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "sm-captive-window__section",
        __self: CaptiveWindow_this,
        __source: {
            fileName: CaptiveWindow_jsxFileName,
            lineNumber: 19,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement(Footer, {
        __self: CaptiveWindow_this,
        __source: {
            fileName: CaptiveWindow_jsxFileName,
            lineNumber: 20,
            columnNumber: 7
        }
    })));
};
/* harmony default export */ var CaptiveWindow_CaptiveWindow = ((/* unused pure expression or super */ null && (CaptiveWindow))); //# sourceMappingURL=CaptiveWindow.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CaptiveWindow/index.js
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(4578);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7462);
;// CONCATENATED MODULE: ./node_modules/resolve-pathname/esm/resolve-pathname.js
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ var resolve_pathname = (resolvePathname);

;// CONCATENATED MODULE: ./node_modules/history/esm/history.js






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function history_createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = (0,esm_extends/* default */.Z)({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolve_pathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function history_locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && valueEqual(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? 0 : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? 0 : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? 0 : invariant(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? 0 : void 0;
    if (basename) path = stripBasename(path, basename);
    return history_createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? 0 : void 0;
    var action = 'PUSH';
    var location = history_createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? 0 : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? 0 : void 0;
    var action = 'REPLACE';
    var location = history_createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? 0 : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? 0 : invariant(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? 0 : void 0;
    if (basename) path = stripBasename(path, basename);
    return history_createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? 0 : void 0;
    var action = 'PUSH';
    var location = history_createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? 0 : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? 0 : void 0;
    var action = 'REPLACE';
    var location = history_createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? 0 : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    (0,esm_extends/* default */.Z)(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? history_createLocation(entry, undefined, createKey()) : history_createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? 0 : void 0;
    var action = 'PUSH';
    var location = history_createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? 0 : void 0;
    var action = 'REPLACE';
    var location = history_createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}



;// CONCATENATED MODULE: ./node_modules/mini-create-react-context/dist/esm/index.js





var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    (0,inheritsLoose/* default */.Z)(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {}

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (prop_types_default()).object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    (0,inheritsLoose/* default */.Z)(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (prop_types_default()).object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = react.createContext || createReactContext;

/* harmony default export */ var esm = (index);

;// CONCATENATED MODULE: ./node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function tiny_invariant_esm_invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}



// EXTERNAL MODULE: ./node_modules/react-router/node_modules/path-to-regexp/index.js
var path_to_regexp = __webpack_require__(5582);
var path_to_regexp_default = /*#__PURE__*/__webpack_require__.n(path_to_regexp);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(9864);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(3366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
;// CONCATENATED MODULE: ./node_modules/react-router/esm/react-router.js













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = esm();
  context.displayName = name;
  return context;
};

var historyContext = /*#__PURE__*/createNamedContext("Router-History");

var context = /*#__PURE__*/createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        _this._pendingLocation = location;
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._isMounted = true;

    if (this.unlisten) {
      // Any pre-mount location changes have been captured at
      // this point, so unregister the listener.
      this.unlisten();
    }

    if (!this.props.staticContext) {
      this.unlisten = this.props.history.listen(function (location) {
        if (_this2._isMounted) {
          _this2.setState({
            location: location
          });
        }
      });
    }

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
      this._isMounted = false;
      this._pendingLocation = null;
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/react.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, /*#__PURE__*/react.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(react.Component);

if (false) {}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = createMemoryHistory(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/react.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(react.Component);

if (false) {}

var Lifecycle = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(react.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return /*#__PURE__*/React.createElement(context.Consumer, null, function (context) {
    !context ?  false ? 0 : invariant(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return /*#__PURE__*/React.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) { var messageType; }

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = pathToRegexp.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return /*#__PURE__*/React.createElement(context.Consumer, null, function (context) {
    !context ?  false ? 0 : invariant(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = createLocation(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : _extends({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return /*#__PURE__*/React.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = createLocation(prevProps.to);

        if (!locationsAreEqual(prevLocation, _extends({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = path_to_regexp_default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return react.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? 0 : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/react.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? 0 : tiny_invariant_esm_invariant(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = (0,esm_extends/* default */.Z)({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && isEmptyChildren(children)) {
        children = null;
      }

      return /*#__PURE__*/react.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? 0 : children(props) : children : component ? /*#__PURE__*/react.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? 0 : children(props) : null);
    });
  };

  return Route;
}(react.Component);

if (false) {}

function react_router_addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return (0,esm_extends/* default */.Z)({}, location, {
    pathname: react_router_addLeadingSlash(basename) + location.pathname
  });
}

function react_router_stripBasename(basename, location) {
  if (!basename) return location;
  var base = react_router_addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return (0,esm_extends/* default */.Z)({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function react_router_createURL(location) {
  return typeof location === "string" ? location : createPath(location);
}

function staticHandler(methodName) {
  return function () {
      false ? 0 : tiny_invariant_esm_invariant(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, history_createLocation(location));
    context.url = react_router_createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = (0,objectWithoutPropertiesLoose/* default */.Z)(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return react_router_addLeadingSlash(basename + react_router_createURL(path));
      },
      action: "POP",
      location: react_router_stripBasename(basename, history_createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return /*#__PURE__*/react.createElement(Router, (0,esm_extends/* default */.Z)({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(react.Component);

if (false) {}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = /*#__PURE__*/function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/react.createElement(context.Consumer, null, function (context) {
      !context ?  false ? 0 : tiny_invariant_esm_invariant(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      react.Children.forEach(_this.props.children, function (child) {
        if (match == null && /*#__PURE__*/react.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, (0,esm_extends/* default */.Z)({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? /*#__PURE__*/react.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(react.Component);

if (false) {}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutPropertiesLoose(props, ["wrappedComponentRef"]);

    return /*#__PURE__*/React.createElement(context.Consumer, null, function (context) {
      !context ?  false ? 0 : invariant(false) : void 0;
      return /*#__PURE__*/React.createElement(Component, _extends({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {}

  return hoistStatics(C, Component);
}

var react_router_useContext = react.useContext;
function useHistory() {
  if (false) {}

  return react_router_useContext(historyContext);
}
function useLocation() {
  if (false) {}

  return react_router_useContext(context).location;
}
function useParams() {
  if (false) {}

  var match = react_router_useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {}

  var location = useLocation();
  var match = react_router_useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) { var secondaryBuildName, initialBuildName, buildNames, key, global; }


//# sourceMappingURL=react-router.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SPAPageContent/index.js
var SPAPageContent_jsxFileName = "/repo/packages/webassets/src/components/SPAPageContent/index.js", SPAPageContent_this = undefined;





var SPAPageContent = function SPAPageContent(_ref) {
    var children = _ref.children, pageId = _ref.pageId, pageMetricsAttributes = _ref.pageMetricsAttributes, legacyWeb = _ref.legacyWeb;
    var _useLocation = useLocation(), pathname = _useLocation.pathname;
    var _useContext = (0,react.useContext)(components_StaticContext/* StaticContext */.vN), user = _useContext.user, environment = _useContext.environment, GDPR = _useContext.GDPR;
    var country = environment.countryCode;
    return /*#__PURE__*/ react.createElement(metrics_dist.SPARouteMetricsProvider, {
        pageId: pageId,
        legacyWeb: legacyWeb,
        pathname: pathname,
        attributes: pageMetricsAttributes,
        GDPR: GDPR,
        user: user,
        country: country,
        __self: SPAPageContent_this,
        __source: {
            fileName: SPAPageContent_jsxFileName,
            lineNumber: 20,
            columnNumber: 5
        }
    }, children);
};
SPAPageContent.propTypes = {
    legacyWeb: (prop_types_default()).string,
    pageId: (prop_types_default()).string.isRequired,
    pageMetricsAttributes: prop_types_default().shape({}),
    children: (prop_types_default()).node.isRequired
};
SPAPageContent.defaultProps = {
    legacyWeb: undefined,
    pageMetricsAttributes: null
};
/* harmony default export */ var components_SPAPageContent = ((/* unused pure expression or super */ null && (SPAPageContent))); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@apollo/react-components/lib/react-components.esm.js
var react_components_esm = __webpack_require__(5422);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ErrorController/index.js
var ErrorController_jsxFileName = "/repo/packages/webassets/src/components/ErrorController/index.tsx";


function ErrorController(_ref) {
    var children = _ref.children, query = _ref.query, context = _ref.context, variables = _ref.variables, apolloClient = _ref.apolloClient, handler = _ref.handler;
    return /*#__PURE__*/ react.createElement(react_components_esm/* Query */.AE, {
        query: query,
        context: context,
        variables: variables,
        client: apolloClient,
        __self: this,
        __source: {
            fileName: ErrorController_jsxFileName,
            lineNumber: 24,
            columnNumber: 5
        }
    }, function(_ref2) {
        var loading = _ref2.loading, error = _ref2.error, data = _ref2.data;
        return handler(loading, error, data) || children;
    });
}
/* harmony default export */ var components_ErrorController = (ErrorController); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/MobileBanner/useStyles.js

var MobileBanner_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    logoAlign: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
});
/* harmony default export */ var MobileBanner_useStyles = (MobileBanner_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/MobileBanner/MobileBanner.js
var MobileBanner_jsxFileName = "/repo/packages/webassets/src/components/MobileBanner/MobileBanner.tsx", MobileBanner_this = undefined;
function MobileBanner_slicedToArray(arr, i) {
    return MobileBanner_arrayWithHoles(arr) || MobileBanner_iterableToArrayLimit(arr, i) || MobileBanner_unsupportedIterableToArray(arr, i) || MobileBanner_nonIterableRest();
}
function MobileBanner_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MobileBanner_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return MobileBanner_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MobileBanner_arrayLikeToArray(o, minLen);
}
function MobileBanner_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function MobileBanner_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function MobileBanner_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}










var MobileBanner = function MobileBanner(props) {
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 14,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement(MobileBannerContent, Object.assign({}, props, {
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 15,
            columnNumber: 5
        }
    })));
};
var MobileBannerContent = function MobileBannerContent(_ref) {
    var _ref$iosRatingText = _ref.iosRatingText, iosRatingText = _ref$iosRatingText === void 0 ? "SurveyMonkey on iOS" : _ref$iosRatingText, _ref$iosRating = _ref.iosRating, iosRating = _ref$iosRating === void 0 ? 4 : _ref$iosRating, _ref$androidRatingTex = _ref.androidRatingText, androidRatingText = _ref$androidRatingTex === void 0 ? "SurveyMonkey on Android" : _ref$androidRatingTex, _ref$androidRating = _ref.androidRating, androidRating = _ref$androidRating === void 0 ? 4 : _ref$androidRating, _ref$deepLinkText = _ref.deepLinkText, deepLinkText = _ref$deepLinkText === void 0 ? "Open in App" : _ref$deepLinkText, _ref$installText = _ref.installText, installText = _ref$installText === void 0 ? "Install" : _ref$installText, _ref$deepLinkData = _ref.deepLinkData, deepLinkData = _ref$deepLinkData === void 0 ? {} : _ref$deepLinkData, downloadLink = _ref.downloadLink, _ref$isUserEligible = _ref.isUserEligible, isUserEligible = _ref$isUserEligible === void 0 ? false : _ref$isUserEligible;
    var _useStyles = MobileBanner_useStyles(), logoAlign = _useStyles.logoAlign;
    var environmentDetails = (0,dist.getClientEnvironmentDetails)();
    var getCookie = function getCookie(name) {
        var match = environmentDetails.isNode ? null : document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]+)")));
        if (match) {
            return match[2];
        }
        return null;
    };
    var _useState = (0,react.useState)(true), _useState2 = MobileBanner_slicedToArray(_useState, 2), showBanner = _useState2[0], setShowBanner = _useState2[1];
    var _useState3 = (0,react.useState)(new Date().getTime()), _useState4 = MobileBanner_slicedToArray(_useState3, 1), sessionTime = _useState4[0];
    var _useState5 = (0,react.useState)(function() {
        if (isUserEligible || environmentDetails.isMobile && !environmentDetails.isNode && getCookie("sb-closed") !== "true" && getCookie("sb-installed") !== "true") {
            return true;
        }
        return false;
    }), _useState6 = MobileBanner_slicedToArray(_useState5, 1), isUserEligibleState = _useState6[0];
    var setCookie = function setCookie(name) {
        // Set close cookie
        var dateRightNow = new Date();
        var expiryDate = new Date(dateRightNow.getTime() + 15 * 24 * 60 * 60 * 1000);
        var cookieValue = "".concat(encodeURI("true"), "; expires=").concat(expiryDate.toUTCString());
        document.cookie = "".concat(name, "=").concat(cookieValue, "; path=/;");
    };
    var getDownloadLink = function getDownloadLink() {
        if (!downloadLink) {
            // eslint-disable-next-line no-throw-literal
            throw "no download link";
        }
        var newDownloadLink = "".concat(downloadLink, "?path=").concat(encodeURIComponent(window.location.pathname));
        if (deepLinkData && Object.keys(deepLinkData).length !== 0) {
            newDownloadLink = "".concat(downloadLink, "&").concat(Object.keys(deepLinkData).map(function(k) {
                return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(deepLinkData[k]));
            }).join("&"));
        }
        newDownloadLink = "".concat(downloadLink, "&session=").concat(sessionTime);
        return newDownloadLink;
    };
    var handleOnClose = function handleOnClose() {
        setCookie("sb-closed");
        setShowBanner(false);
    };
    var handleInstallClick = function handleInstallClick() {
        setCookie("sb-installed");
        setShowBanner(false);
        window.location.href = getDownloadLink();
    };
    var handleOpenClick = function handleOpenClick() {
        setCookie("sb-closed");
        setShowBanner(false);
        window.location.href = getDownloadLink();
    };
    var getRatingStars = function getRatingStars() {
        var starRating = environmentDetails.isAndroid ? androidRating : iosRating;
        var starRatingNodes = [];
        for(var starCount = 0; starCount < starRating && starCount < 5; starCount += 1){
            starRatingNodes.push(/*#__PURE__*/ react.createElement(icons_dist_index_es/* IconStarFilled */.lk1, {
                title: "Star Filled",
                color: "upgrade",
                __self: MobileBanner_this,
                __source: {
                    fileName: MobileBanner_jsxFileName,
                    lineNumber: 114,
                    columnNumber: 9
                }
            }));
        }
        for(var _starCount = starRating; _starCount < 5; _starCount += 1){
            starRatingNodes.push(/*#__PURE__*/ react.createElement(icons_dist_index_es/* IconStar */.GK, {
                title: "Empty Star",
                __self: MobileBanner_this,
                __source: {
                    fileName: MobileBanner_jsxFileName,
                    lineNumber: 118,
                    columnNumber: 28
                }
            }));
        }
        return starRatingNodes;
    };
    var getRatingText = function getRatingText() {
        var starRatingText = environmentDetails.isAndroid ? androidRatingText : iosRatingText;
        return /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
            component: "div",
            variant: "cardTitle",
            __self: MobileBanner_this,
            __source: {
                fileName: MobileBanner_jsxFileName,
                lineNumber: 128,
                columnNumber: 7
            }
        }, starRatingText);
    };
    return isUserEligibleState ? /*#__PURE__*/ react.createElement(Sheet, {
        show: showBanner,
        blocking: false,
        placement: "bottom",
        onClose: handleOnClose,
        showCloseButton: true,
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 135,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        p: 1,
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 142,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 143,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        xs: 2,
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 144,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: logoAlign,
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 145,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconLogoGoldie */.jNx, {
        title: "SurveyMonkey Logo",
        size: "xl",
        color: "primary",
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 146,
            columnNumber: 15
        }
    }))), /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 153,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        noGutters: true,
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 154,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 155,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexJustify: "center",
        flexAlign: "flex-start",
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 156,
            columnNumber: 17
        }
    }, getRatingText(), "\xa0", /*#__PURE__*/ react.createElement("div", {
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 159,
            columnNumber: 19
        }
    }, getRatingStars()))), /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 162,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexJustify: "center",
        flexAlign: "center",
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 163,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        label: installText,
        onClick: handleInstallClick,
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 164,
            columnNumber: 19
        }
    }, installText), /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        label: deepLinkText,
        color: "alt",
        onClick: handleOpenClick,
        __self: MobileBanner_this,
        __source: {
            fileName: MobileBanner_jsxFileName,
            lineNumber: 167,
            columnNumber: 19
        }
    }, deepLinkText)))))))) : /*#__PURE__*/ react.createElement(react.Fragment, null);
};
/* harmony default export */ var MobileBanner_MobileBanner = (MobileBanner); //# sourceMappingURL=MobileBanner.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/MobileBanner/index.js
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ErrorBoundary/index.js


var ErrorBoundary_jsxFileName = "/repo/packages/webassets/src/components/ErrorBoundary/index.js";
function ErrorBoundary_classCallCheck(instance, Constructor) {
    if (!_instanceof(instance, Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function ErrorBoundary_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, ErrorBoundary_toPropertyKey(descriptor.key), descriptor);
    }
}
function ErrorBoundary_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) ErrorBoundary_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) ErrorBoundary_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function ErrorBoundary_toPropertyKey(arg) {
    var key = ErrorBoundary_toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(key)) === "symbol" ? key : String(key);
}
function ErrorBoundary_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function ErrorBoundary_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) ErrorBoundary_setPrototypeOf(subClass, superClass);
}
function ErrorBoundary_setPrototypeOf(o, p) {
    ErrorBoundary_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return ErrorBoundary_setPrototypeOf(o, p);
}
function ErrorBoundary_createSuper(Derived) {
    var hasNativeReflectConstruct = ErrorBoundary_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = ErrorBoundary_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = ErrorBoundary_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return ErrorBoundary_possibleConstructorReturn(this, result);
    };
}
function ErrorBoundary_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
    } else if (call !== void 0) {
        throw new TypeError("Derived constructors may only return object or undefined");
    }
    return ErrorBoundary_assertThisInitialized(self);
}
function ErrorBoundary_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function ErrorBoundary_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function ErrorBoundary_getPrototypeOf(o) {
    ErrorBoundary_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return ErrorBoundary_getPrototypeOf(o);
}



var ErrorBoundaryFallbackComponent = function ErrorBoundaryFallbackComponent() {
    return null;
};
var formatComponentStack = function formatComponentStack(str) {
    var lines = str.split(/\s*\n\s*/g);
    var ret = "";
    for(var line = 0, len = lines.length; line < len; line += 1){
        if (lines[line].length) ret += "".concat(ret.length ? "\n" : "").concat(lines[line]);
    }
    return ret;
};
var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    ErrorBoundary_inherits(ErrorBoundary, _React$Component);
    var _super = ErrorBoundary_createSuper(ErrorBoundary);
    function ErrorBoundary() {
        var _this;
        ErrorBoundary_classCallCheck(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            error: null,
            info: null
        };
        return _this;
    }
    ErrorBoundary_createClass(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, information) {
                var info = information;
                if (info && info.componentStack) {
                    info.componentStack = formatComponentStack(info.componentStack);
                }
                errorHandler/* errorHandler.logError */.P.logError(error, info, {
                    fallback: this.props.FallbackComponent && this.props.FallbackComponent.name
                });
                return this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, FallbackComponent = _this$props.FallbackComponent;
                var _this$state = this.state, error = _this$state.error, info = _this$state.info;
                if (error) {
                    return /*#__PURE__*/ react.createElement(FallbackComponent, {
                        error: error,
                        info: info,
                        __self: this,
                        __source: {
                            fileName: ErrorBoundary_jsxFileName,
                            lineNumber: 49,
                            columnNumber: 14
                        }
                    });
                }
                return children;
            }
        }
    ]);
    return ErrorBoundary;
}(react.Component);
ErrorBoundary.propTypes = {
    FallbackComponent: (prop_types_default()).any,
    // eslint-disable-line
    children: (prop_types_default()).node.isRequired
};
ErrorBoundary.defaultProps = {
    FallbackComponent: ErrorBoundaryFallbackComponent
};
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ClientError/index.js + 4 modules
var ClientError = __webpack_require__(7517);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FiveHundredError/index.js + 2 modules
var FiveHundredError = __webpack_require__(5849);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FourHundredError/index.js + 2 modules
var FourHundredError = __webpack_require__(2512);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FourOhFourError/index.js + 2 modules
var FourOhFourError = __webpack_require__(7970);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ForbiddenError/index.js + 2 modules
var ForbiddenError = __webpack_require__(6262);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/FourTenError/index.js + 2 modules
var FourTenError = __webpack_require__(7111);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Helmet/index.js + 1 modules
var Helmet = __webpack_require__(6685);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(3685);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SessionTimeoutModal/SessionCtrl.js

function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    var define = function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    };
    var wrap = function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && _instanceof(outerFn.prototype, Generator) ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    };
    var tryCatch = function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var defineIteratorMethods = function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    };
    var AsyncIterator = function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    };
    var makeInvokeMethod = function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    };
    var pushTryEntry = function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    };
    var resetTryEntry = function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    };
    var Context = function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    };
    var values = function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    };
    var doneResult = function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    };
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object){
            keys.push(key);
        }
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this){
                "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
            }
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            var handle = function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            };
            if (this.done) throw exception;
            var context = this;
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var _getClientEnvironment = (0,dist.getClientEnvironmentDetails)(), SessionCtrl_isBrowser = _getClientEnvironment.isBrowser;
// Small in-memory only localstorage
function inMemoryLocalStorage() {
    return {
        _data: {},
        setItem: function setItem(id, val) {
            var dataId = this._data[id];
            dataId = String(val);
            return dataId;
        },
        getItem: function getItem(id) {
            var dataID = Object.prototype.hasOwnProperty.call(this._data, id) ? this._data[id] : undefined;
            return dataID;
        },
        removeItem: function removeItem(id) {
            var deleteDataId = delete this._data[id];
            return deleteDataId;
        },
        clear: function clear() {
            var data = this._data;
            data = {};
            return data;
        }
    };
}
if (SessionCtrl_isBrowser && !("localStorage" in window)) {
    window.localStorage = inMemoryLocalStorage();
}
var Storage;
var LAST_BACKEND_ACTIVITY_KEY = "SessionCtrl.lba";
var LAST_FRONTEND_ACTIVITY_KEY = "SessionCtrl.lfa";
var RUN_EVERY = 1000 * 30; // Every 30 seconds
var state = {
    initialized: false,
    timeoutInterval: 0,
    // seconds
    intervalInstanceId: null,
    // setInterval instance ID
    reminderCb: null,
    // function passed during init
    // settings
    minimumDeltaForFlight: 5,
    // seconds
    minimumDeltaForBackendExtension: 5 * 60,
    // 5 minutes
    minimumDeltaToShowReminder: 5 * 60 // 5 minutes
};
function now() {
    return parseInt(new Date().getTime() / 1000, 10);
}
function getTimeToBackendTimeout() {
    var lastBackendActivity = Storage.getItem(LAST_BACKEND_ACTIVITY_KEY);
    var n = now();
    return state.timeoutInterval - (n - lastBackendActivity);
}
function getTimeToFrontendTimeout() {
    var lastFrontendActivity = Storage.getItem(LAST_FRONTEND_ACTIVITY_KEY);
    var n = now();
    return state.timeoutInterval - (n - lastFrontendActivity);
}
function logout() {
    if (state.timeoutInterval === 0) {
        window.location.assign("/user/sign-out/?timeout=true");
    } else {
        window.location.assign("/user/sign-out/?timeout=".concat(Math.ceil(state.timeoutInterval / 60)));
    }
}
function updateBackendActivity() {
    return Storage.setItem(LAST_BACKEND_ACTIVITY_KEY, now());
}
function extendBackend(_x) {
    return _extendBackend.apply(this, arguments);
}
function _extendBackend() {
    _extendBackend = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(callback) {
        var resp;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
            while(1){
                switch(_context.prev = _context.next){
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return fetch_npm_browserify_default()("/user/session/", {
                            method: "GET",
                            credentials: "include"
                        });
                    case 3:
                        resp = _context.sent;
                        if (!/sign-in/.test(resp.url)) {
                            _context.next = 8;
                            break;
                        }
                        logout();
                        _context.next = 10;
                        break;
                    case 8:
                        updateBackendActivity();
                        return _context.abrupt("return", callback && callback());
                    case 10:
                        _context.next = 15;
                        break;
                    case 12:
                        _context.prev = 12;
                        _context.t0 = _context["catch"](0);
                        errorHandler/* errorHandler.logError */.P.logError(_context.t0);
                    case 15:
                        return _context.abrupt("return", null);
                    case 16:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }));
    return _extendBackend.apply(this, arguments);
}
function updateFrontendActivity() {
    return Storage.setItem(LAST_FRONTEND_ACTIVITY_KEY, now());
}
function verifyLocalStorage() {
    var testKey = "value_that_is_not_expected_to_be_there";
    Storage = localStorage;
    try {
        Storage.setItem(testKey, "foo");
        if (Storage.getItem(testKey) !== "foo") {
            throw new Error("Unable to find match in localStorage");
        }
        Storage.removeItem(testKey);
    } catch (_unused) {
        Storage = inMemoryLocalStorage();
    }
}
function bindActivityEvents() {
    document.addEventListener("mousedown", updateFrontendActivity, false);
    document.addEventListener("touchstart", updateFrontendActivity, false);
    document.addEventListener("keydown", updateFrontendActivity, false);
}
function timer() {
    var timeToFrontendTimeout = getTimeToFrontendTimeout();
    var timeToBackendTimeout = getTimeToBackendTimeout();
    if (timeToFrontendTimeout < state.minimumDeltaForFlight) {
        return logout();
    }
    // If we have been active in the frontend only but not done any AJAX request
    // then we want to extend the backend
    if (timeToBackendTimeout < state.minimumDeltaForBackendExtension && timeToFrontendTimeout > state.minimumDeltaToShowReminder) {
        extendBackend();
    } else if (timeToFrontendTimeout < state.minimumDeltaToShowReminder) {
        state.reminderCb(timeToFrontendTimeout);
    }
    return null;
}
function startTimer() {
    state.intervalInstanceId = window.setInterval(timer, RUN_EVERY);
}
// Make it a singleton
var instance = {
    init: function init(_ref) {
        var timeout = _ref.timeout, reminderCb = _ref.reminderCb;
        if (!SessionCtrl_isBrowser) {
            // eslint-disable-next-line
            console.warn("SessionCtrl init() method was called without a window!");
            return;
        }
        state.timeoutInterval = timeout; // timeout in seconds
        state.reminderCb = reminderCb;
        if (timeout && !state.initialized) {
            verifyLocalStorage();
            bindActivityEvents();
            updateBackendActivity();
            updateFrontendActivity();
            startTimer();
            state.initialized = true;
        }
    },
    removeCallback: function removeCallback() {
        delete state.reminderCb;
    },
    continueSession: function continueSession(callback) {
        updateFrontendActivity();
        extendBackend(callback);
    }
};
Object.freeze(instance);
/* harmony default export */ var SessionCtrl = (instance); //# sourceMappingURL=SessionCtrl.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SessionTimeoutModal/useStyles.js

var SessionTimeoutModal_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)(function(theme) {
    var palette = theme.palette, radius = theme.radius;
    return {
        iconBackground: function iconBackground() {
            return {
                background: palette.warning.main,
                "border-radius": radius.large,
                height: "70px",
                width: "70px",
                display: "flex",
                "justify-content": "center",
                "align-items": "center"
            };
        }
    };
});
/* harmony default export */ var SessionTimeoutModal_useStyles = (SessionTimeoutModal_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SessionTimeoutModal/SessionTimeoutModal.js
var SessionTimeoutModal_jsxFileName = "/repo/packages/webassets/src/components/SessionTimeoutModal/SessionTimeoutModal.js", SessionTimeoutModal_this = undefined;
function SessionTimeoutModal_slicedToArray(arr, i) {
    return SessionTimeoutModal_arrayWithHoles(arr) || SessionTimeoutModal_iterableToArrayLimit(arr, i) || SessionTimeoutModal_unsupportedIterableToArray(arr, i) || SessionTimeoutModal_nonIterableRest();
}
function SessionTimeoutModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SessionTimeoutModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SessionTimeoutModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SessionTimeoutModal_arrayLikeToArray(o, minLen);
}
function SessionTimeoutModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function SessionTimeoutModal_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function SessionTimeoutModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}











var SessionTimeoutModal_COPY = (0,intl_dist/* defineMessages */.vU)({
    CONTINUE_SESSION: {
        id: "SessionTimeoutModal.ContinueSession",
        defaultMessage: "CONTINUE SESSION",
        description: "[Type: Button][Vis.: med] - CTA for the user to continue their browsing session and not be logged out automatically."
    },
    TIME_LEFT_MSG: {
        id: "SessionTimeoutModal.TimeLeftMessage",
        defaultMessage: "After {minutesLeft, plural, one { 1 minute } other {{ minutesLeft } minutes}} of inactivity, we sign you out to keep your data safe. Your session will expire soon, unless you click <i>Continue Session</i>",
        description: "[Type: Paragraph][Vis.: med] - Message given to the user informing them of the time left before automatic expiration."
    },
    SESSION_HEADER: {
        id: "SessionTimeoutModal.TimeLeftHeader",
        defaultMessage: "Do you want to continue your session?",
        description: "[Type: Header][Vis.: med] - Modal header for the prompt asking the user if they want to continue their browsing session."
    }
});
var SessionTimeoutModal = function SessionTimeoutModal(props) {
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 37,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement(SessionTimeoutModalContent, Object.assign({}, props, {
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 38,
            columnNumber: 5
        }
    })));
};
var SessionTimeoutModalContent = function SessionTimeoutModalContent(_ref) {
    var user = _ref.user;
    var _useState = (0,react.useState)(false), _useState2 = SessionTimeoutModal_slicedToArray(_useState, 2), show = _useState2[0], setShow = _useState2[1];
    var _useState3 = (0,react.useState)(null), _useState4 = SessionTimeoutModal_slicedToArray(_useState3, 2), timeLeft = _useState4[0], setTimeLeft = _useState4[1];
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var _useStyles = SessionTimeoutModal_useStyles({
        theme: theme
    }), iconBackground = _useStyles.iconBackground;
    var onReminder = function onReminder(timeRemaining) {
        setShow(true);
        setTimeLeft(timeRemaining);
    };
    var onClose = function onClose() {
        SessionCtrl.continueSession(function() {
            setShow(false);
            setTimeLeft(0);
        });
    };
    (0,react.useEffect)(function() {
        var timeout = user && (user.hipaa && user.hipaa.isHipaaEnabled && 30 * 60 || user.group && user.group.sessionTimeout && parseInt(user.group.sessionTimeout, 10) * 60);
        if (timeout !== undefined) {
            // it could be 0
            SessionCtrl.init({
                timeout: timeout,
                reminderCb: onReminder
            });
        }
        return function cleanup() {
            SessionCtrl.removeCallback();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ react.createElement(index_es/* Modal */.u, {
        show: show,
        onClose: onClose,
        className: "sm-session-timeout-modal-container",
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 77,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(index_es/* Modal.Header */.u.Header, {
        header: (0,intl_dist.t)(SessionTimeoutModal_COPY.SESSION_HEADER),
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 82,
            columnNumber: 7
        }
    }), /*#__PURE__*/ react.createElement(index_es/* Modal.Body */.u.Body, {
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 83,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid */.r, {
        noBleeds: true,
        noGutters: true,
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 84,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        xs: 3,
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 85,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: iconBackground,
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 86,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconLock */._V1, {
        title: "SessionTimeoutIcon",
        color: "light",
        size: "xl",
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 87,
            columnNumber: 15
        }
    }))), /*#__PURE__*/ react.createElement(grid_dist_index_es/* Grid.Item */.r.Item, {
        xs: 9,
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 90,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SessionTimeoutModal_COPY.TIME_LEFT_MSG,
        values: {
            minutesLeft: timeLeft
        },
        html: true,
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 91,
            columnNumber: 13
        }
    })))), /*#__PURE__*/ react.createElement(index_es/* Modal.Footer */.u.Footer, {
        align: "right",
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 99,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        color: "secondary",
        onClick: onClose,
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 100,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: SessionTimeoutModal_COPY.CONTINUE_SESSION,
        __self: SessionTimeoutModal_this,
        __source: {
            fileName: SessionTimeoutModal_jsxFileName,
            lineNumber: 101,
            columnNumber: 11
        }
    }))));
};
SessionTimeoutModalContent.propTypes = {
    user: prop_types_default().shape({
        hipaa: prop_types_default().shape({
            isHipaaEnabled: (prop_types_default()).bool
        }),
        group: prop_types_default().shape({
            sessionTimeout: prop_types_default().oneOfType([
                (prop_types_default()).string,
                (prop_types_default()).number
            ])
        })
    }).isRequired
};
/* harmony default export */ var SessionTimeoutModal_SessionTimeoutModal = (SessionTimeoutModal); //# sourceMappingURL=SessionTimeoutModal.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SessionTimeoutModal/index.js

/* harmony default export */ var components_SessionTimeoutModal = (SessionTimeoutModal_SessionTimeoutModal); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/ReleaseToggle/index.js
var ReleaseToggle = __webpack_require__(6851);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(6808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CookieBanner/static/images/cookies-plate.png
/* harmony default export */ var cookies_plate = ({"src":"//prod.smassets.net/assets/smweb/_next/static/media/cookies-plate.4481a8bf.png","height":500,"width":700,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAA0UlEQVR4nAHGADn/AWtfXQAaDTFMVmU3gePi4yu1scYDAvsD4dahA4v2AAKZAV5BfWgrN/eXYFs7AAoVIADv7/AAAgL5ALys3QDQewuFAX1lgPZfazUJAPbn/QIHEgP4+foA//z1/gwRGALMt/z/AXhMiPhXdRoHExIN/djOyAPY0tUAAQH9/B4uMwTd0xHwAWgAmGQgauebQ1MZAN7c4ADXz8oA/P4BAL6bBgAoB0BZAUgAbwApOyBQ/Bjbf9na4iX39P7+EhESzSIaLX7AtN/DoJlWm8lBUc8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/CookieBanner/cookie-banner.scss
var cookie_banner = __webpack_require__(6172);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/CookieBanner/index.js
var CookieBanner_jsxFileName = "/repo/packages/webassets/src/components/CookieBanner/index.js", CookieBanner_this = undefined;
function CookieBanner_slicedToArray(arr, i) {
    return CookieBanner_arrayWithHoles(arr) || CookieBanner_iterableToArrayLimit(arr, i) || CookieBanner_unsupportedIterableToArray(arr, i) || CookieBanner_nonIterableRest();
}
function CookieBanner_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CookieBanner_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CookieBanner_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CookieBanner_arrayLikeToArray(o, minLen);
}
function CookieBanner_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function CookieBanner_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function CookieBanner_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * TODO:
 * Is CookieBanner still being used anywhere? If not, remove it?
 */ 








var CONSENT_KEY = "gdpr_consent";
var CONSENT_DENIED_KEY = "gdpr_consent_denied";
var CookieBanner_COPY = (0,intl_dist/* defineMessages */.vU)({
    COOKIE_BANNER: {
        id: "CookieBanner.cookiePolicy",
        defaultMessage: // eslint-disable-next-line no-multi-str
        'In order to give you the best experience, SurveyMonkey and our third party partners may use cookies    and similar technologies, for example, to analyze usage and optimize our sites and services, personalize content,    tailor and measure our marketing and to keep the site secure. Please visit our    <a href="/mp/legal/privacy-policy/">privacy policy</a> for more information and our    <a href="/mp/legal/cookies/">cookies policy</a> for a list of all cookies used.',
        description: "[Type: Label][Vis.: med] - Cookie Banner Message"
    },
    COOKIE_PREFERENCES: {
        id: "CookieBanner.preferences",
        defaultMessage: '<a href="/mp/legal/cookies/">Clear or manage cookie preferences</a>.',
        description: "[Type: Label][Vis.: med] - Cookie Banner Preferences"
    },
    IMAGE_ALT: {
        id: "CookieBanner.imageAlt",
        defaultMessage: "Plate of Cookies",
        description: "[Type: Label][Vis.: med] - Cookie Banner Image Alt Tag"
    },
    NO: {
        id: "CookieBanner.decline",
        defaultMessage: "DISAGREE",
        description: "[Type: Label][Vis.: med] - Cookie Banner Decline button"
    },
    AGREE: {
        id: "CookieBanner.agree",
        defaultMessage: "AGREE",
        description: "[Type: Label][Vis.: med] - Cookie Banner Agree button"
    }
});
var CookieBanner = function CookieBanner(_ref) {
    var GDPR = _ref.GDPR;
    var hasGDPRConsent = GDPR.hasGDPRConsent, hasExplictlyDenied = GDPR.hasExplictlyDenied;
    var _useState = (0,react.useState)(true), _useState2 = CookieBanner_slicedToArray(_useState, 2), show = _useState2[0], setShow = _useState2[1];
    var _useState3 = (0,react.useState)("gdpr_consent_denied"), _useState4 = CookieBanner_slicedToArray(_useState3, 2), consent = _useState4[0], setConsent = _useState4[1];
    (0,react.useEffect)(function() {
        if (!show) {
            metrics_dist.MetricsTracker.track({
                name: metrics_dist.USER_EVENTS.GDPR_ACTION,
                data: {
                    actionType: metrics_dist.USER_EVENTS.GDPR_ACTION,
                    actionFlow: consent !== CONSENT_KEY ? "denyConsent" : "giveConsent"
                }
            });
        }
    }, [
        show,
        consent
    ]);
    if (hasGDPRConsent || hasExplictlyDenied || !show) {
        return null;
    }
    /**
   * Agree to tracking cookie
   * @param {Object} e
   */ var onAgree = function onAgree(e) {
        e.stopPropagation();
        js_cookie_default().set(CONSENT_KEY, "true", {
            expires: 365,
            secure: true
        });
        setConsent(CONSENT_KEY);
        setShow(!show);
    };
    /**
   * Deny tracking cookie
   */ var onDeny = function onDeny() {
        js_cookie_default().set(CONSENT_DENIED_KEY, "true", {
            expires: 7,
            secure: true
        });
        setConsent(CONSENT_DENIED_KEY);
        setShow(!show);
    };
    return /*#__PURE__*/ react.createElement("div", {
        className: "sm-cookie-banner",
        "data-testid": "CookieBanner",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 109,
            columnNumber: 5
        }
    }, /*#__PURE__*/ react.createElement(MediaComponents/* TabletScreen */.m6, {
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 110,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Modal, {
        closeButtonClass: "gdpr-cta-no",
        size: "md",
        show: show,
        onClose: onDeny,
        ariaLabel: (0,intl_dist.t)(CookieBanner_COPY.NO),
        "data-testid": "CookieBanner__Modal",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 111,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Grid, {
        className: "sm-cookie-banner__grid",
        noBleeds: true,
        noGutters: true,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 119,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Row, {
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 120,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Col, {
        className: "sm-cookie-banner__col",
        md: 3,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 121,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Container, {
        className: "sm-cookie-banner__img-wrapper",
        flex: true,
        flexDirection: "column",
        flexJustify: "center",
        flexAlign: "center",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 122,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement("img", {
        src: cookies_plate,
        className: "sm-cookie-banner__img",
        alt: (0,intl_dist.t)(CookieBanner_COPY.IMAGE_ALT),
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 129,
            columnNumber: 19
        }
    }))), /*#__PURE__*/ react.createElement(wds_react.Col, {
        md: 9,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 136,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Container, {
        p: "5",
        className: "sm-cookie-banner__modal-body",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 137,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Typography, {
        className: "sm-cookie-banner__text-container",
        component: "div",
        variant: "body",
        color: "dark-muted",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 138,
            columnNumber: 19
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: CookieBanner_COPY.COOKIE_BANNER,
        html: true,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 144,
            columnNumber: 21
        }
    })), /*#__PURE__*/ react.createElement(wds_react.Typography, {
        className: "sm-cookie-banner__link",
        color: "dark-muted",
        component: "div",
        variant: "body",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 146,
            columnNumber: 19
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: CookieBanner_COPY.COOKIE_PREFERENCES,
        html: true,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 152,
            columnNumber: 21
        }
    }))), /*#__PURE__*/ react.createElement(wds_react.Container, {
        className: "sm-cookie-banner__cta-container",
        pr: "4",
        pb: "4",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 155,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Align, {
        placement: "right",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 160,
            columnNumber: 19
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Button, {
        className: "sm-cookie-banner__cta-btn gdpr-cta-agree",
        onClick: onAgree,
        "data-testid": "CookieBanner__Agree",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 161,
            columnNumber: 21
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: CookieBanner_COPY.AGREE,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 166,
            columnNumber: 23
        }
    }))))))))), /*#__PURE__*/ react.createElement(MediaComponents/* MobileScreen */.vp, {
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 175,
            columnNumber: 7
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Sheet, {
        placement: "bottom",
        closeButtonClass: "gdpr-cta-no",
        onClose: onDeny,
        show: show,
        ariaLabel: (0,intl_dist.t)(CookieBanner_COPY.NO),
        closeButton: true,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 176,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Container, {
        pt: "6",
        pb: "5",
        px: "7",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 184,
            columnNumber: 11
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Typography, {
        className: "sm-cookie-banner__text-container",
        component: "div",
        variant: "body",
        color: "dark-muted",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 185,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: CookieBanner_COPY.COOKIE_BANNER,
        html: true,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 191,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(wds_react.Typography, {
        className: "sm-cookie-banner__link",
        color: "dark-muted",
        component: "div",
        variant: "body",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 193,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: CookieBanner_COPY.COOKIE_PREFERENCES,
        html: true,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 199,
            columnNumber: 15
        }
    })), /*#__PURE__*/ react.createElement(wds_react.Container, {
        pb: "3",
        pt: "3",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 201,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Align, {
        placement: "left",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 202,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(wds_react.Button, {
        className: "sm-cookie-banner__cta-btn gdpr-cta-agree",
        onClick: onAgree,
        "data-testid": "CookieBanner__Agree",
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 203,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: CookieBanner_COPY.AGREE,
        __self: CookieBanner_this,
        __source: {
            fileName: CookieBanner_jsxFileName,
            lineNumber: 208,
            columnNumber: 19
        }
    }))))))));
};
CookieBanner.propTypes = {
    GDPR: prop_types_default().shape({
        hasGDPRConsent: (prop_types_default()).bool,
        hasExplictlyDenied: (prop_types_default()).bool
    }).isRequired
};
/* harmony default export */ var components_CookieBanner = (CookieBanner); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@wds/card/dist/index.es.js



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var card_dist_index_es_assign = function() {
    card_dist_index_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return card_dist_index_es_assign.apply(this, arguments);
};

function card_dist_index_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var card_dist_index_es_useStyles = (0,utils_dist_index_es/* createMemoStyles */.Im)(function (_a) {
    var spacing = _a.spacing, border = _a.border; _a.radius; var shadow = _a.shadow, palette = _a.palette, type = _a.type;
    var card = {
        borderRadius: spacing[2],
        boxShadow: shadow.none,
        border: border.muted,
        padding: spacing[5],
        bgColor: palette.background.light,
    };
    return {
        wrenchCard: function (_a) {
            var selected = _a.selected, interactive = _a.interactive;
            return (card_dist_index_es_assign(card_dist_index_es_assign({ fontFamily: type.fontFamily.base, fontSize: type.fontSize.body, '-webkit-font-smoothing': 'antialiased', backgroundColor: card.bgColor, border: card.border, borderRadius: card.borderRadius, boxShadow: card.boxShadow }, (interactive && {
                '&:hover, &:focus': {
                    borderColor: palette.border.hover,
                    cursor: 'pointer',
                },
            })), (selected && {
                borderColor: palette.border.active,
                '&:hover, &focus': {
                    borderColor: palette.border.active,
                },
                '& focus': {
                    borderColor: palette.border.active,
                },
            })));
        },
        wrenchCardHeader: function (_a) {
            var noRule = _a.noRule;
            return card_dist_index_es_assign(card_dist_index_es_assign({}, (noRule
                ? { borderBottom: 'none' }
                : { borderBottom: border.muted })), { boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '0', padding: [spacing[5]], minHeight: '72px', fontSize: type.fontSize.cardTitle, fontWeight: type.fontWeight.regular });
        },
        wrenchCardBody: function () { return ({
            padding: card.padding,
        }); },
        wrenchCardAddon: function () { return ({
            display: 'inline-flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            minHeight: '40px',
            margin: [0, 0, 'auto', spacing[4]],
            float: 'right',
        }); },
    };
});

var index_es_Card = function (_a) {
    var children = _a.children, _b = _a.selected, selected = _b === void 0 ? false : _b, _c = _a.title, title = _c === void 0 ? undefined : _c, _d = _a.padding, padding = _d === void 0 ? true : _d, _e = _a.addOn, addOn = _e === void 0 ? undefined : _e, _f = _a.interactive, interactive = _f === void 0 ? false : _f, _g = _a.noRule, noRule = _g === void 0 ? false : _g, _h = _a.spacingClass, spacingClass = _h === void 0 ? undefined : _h, _j = _a.onClick, onClick = _j === void 0 ? undefined : _j, rest = card_dist_index_es_rest(_a, ["children", "selected", "title", "padding", "addOn", "interactive", "noRule", "spacingClass", "onClick"]);
    var _k = card_dist_index_es_useStyles({ selected: selected, noRule: noRule, interactive: interactive }), wrenchCard = _k.wrenchCard, wrenchCardBody = _k.wrenchCardBody, wrenchCardHeader = _k.wrenchCardHeader, wrenchCardAddon = _k.wrenchCardAddon;
    var cardAddon = react.createElement("div", { className: wrenchCardAddon }, addOn);
    var hadAddOn = !title && addOn && cardAddon;
    var wrenchCardWrapper = (0,utils_dist_index_es/* clsx */.Wy)(wrenchCard, spacingClass);
    return (react.createElement("div", card_dist_index_es_assign({ className: wrenchCardWrapper }, (0,utils_dist_index_es/* safeRest */.Q6)(rest), { onClick: onClick, role: "button", tabIndex: 0, onKeyDown: onClick }),
        title && (react.createElement("header", { className: wrenchCardHeader },
            title,
            addOn && cardAddon)),
        padding ? (react.createElement("div", { className: wrenchCardBody },
            hadAddOn,
            children)) : (react.createElement(react.Fragment, null,
            hadAddOn,
            children))));
};
var CardWithSpacing = (0,utils_dist_index_es/* withSpacing */.ii)(index_es_Card);



;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ErrorCard/Copy.js

var Copy_COPY = (0,intl_dist/* defineMessages */.vU)({
    weSlippedError: {
        id: "Copy.ErrorCardWeSlippedError",
        defaultMessage: "It looks like we slipped!",
        description: "[Type: Label][Vis.: med] - It looks like we slipped!"
    },
    refresh: {
        id: "Copy.ErrorCardRefresh",
        defaultMessage: "Refresh",
        description: "[Type: Button][Vis.: high] - Refresh"
    },
    troubleLoading: {
        id: "Copy.ErrorCardTroubleLoading",
        defaultMessage: "We had trouble loading your data.",
        description: "[Type: Label][Vis.: high] - We had trouble loading your data."
    }
});
/* harmony default export */ var Copy = (Copy_COPY); //# sourceMappingURL=Copy.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ErrorCard/useStyles.js

var ErrorCard_useStyles_useStyles = (0,react_jss_esm/* createUseStyles */.QM)({
    refreshText: {
        pointerEvents: "none",
        fontWeight: "normal"
    }
});
/* harmony default export */ var ErrorCard_useStyles = (ErrorCard_useStyles_useStyles); //# sourceMappingURL=useStyles.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/ErrorCard/index.js
var ErrorCard_excluded = [
    "iconOnly",
    "iconOptions",
    "copyOptions",
    "errorCopy",
    "refreshCopy",
    "refetch"
];
var ErrorCard_jsxFileName = "/repo/packages/webassets/src/components/ErrorCard/index.js", ErrorCard_this = undefined;
function ErrorCard_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ErrorCard_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ErrorCard_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var ErrorCard = function ErrorCard(props) {
    return /*#__PURE__*/ React.createElement(WebAssetsThemeWrapper, {
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 15,
            columnNumber: 3
        }
    }, /*#__PURE__*/ React.createElement(ErrorCardContent, Object.assign({}, props, {
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 16,
            columnNumber: 5
        }
    })));
};
var ErrorCardContent = function ErrorCardContent(_ref) {
    var iconOnly = _ref.iconOnly, iconOptions = _ref.iconOptions, copyOptions = _ref.copyOptions, errorCopy = _ref.errorCopy, refreshCopy = _ref.refreshCopy, refetch = _ref.refetch, otherProps = ErrorCard_objectWithoutProperties(_ref, ErrorCard_excluded);
    var classes = ErrorCard_useStyles();
    var Icon = /*#__PURE__*/ react.createElement(icons_dist_index_es/* IconWarning */.FCX, Object.assign({
        title: "An error has occurred"
    }, iconOptions, {
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 30,
            columnNumber: 16
        }
    }));
    var getErrorMessage = function getErrorMessage() {
        if (!errorCopy) {
            return /*#__PURE__*/ react.createElement(react.Fragment, null, refetch ? /*#__PURE__*/ react.createElement(intl_dist.T, {
                desc: Copy.troubleLoading,
                __self: ErrorCard_this,
                __source: {
                    fileName: ErrorCard_jsxFileName,
                    lineNumber: 36,
                    columnNumber: 13
                }
            }) : /*#__PURE__*/ react.createElement(intl_dist.T, {
                desc: Copy.weSlippedError,
                __self: ErrorCard_this,
                __source: {
                    fileName: ErrorCard_jsxFileName,
                    lineNumber: 38,
                    columnNumber: 13
                }
            }));
        }
        return errorCopy;
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, iconOnly ? /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, Object.assign({
        display: "flex",
        flexJustify: "center",
        flexAlign: "center"
    }, otherProps, {
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 49,
            columnNumber: 9
        }
    }), /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        "data-testid": "ErrorCard",
        component: "h2",
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 55,
            columnNumber: 11
        }
    }, Icon)) : /*#__PURE__*/ react.createElement(CardWithSpacing, {
        "data-testid": "ErrorCard",
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 60,
            columnNumber: 9
        }
    }, /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, Object.assign({
        display: "flex",
        flexJustify: "center"
    }, otherProps, {
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 61,
            columnNumber: 11
        }
    }), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: "center",
        mr: 3,
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 62,
            columnNumber: 13
        }
    }, Icon), /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: "center",
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 65,
            columnNumber: 13
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, Object.assign({}, copyOptions, {
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 66,
            columnNumber: 15
        }
    }), getErrorMessage())), refetch ? /*#__PURE__*/ react.createElement(box_dist_index_es/* Box */.x, {
        display: "flex",
        flexAlign: "center",
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 69,
            columnNumber: 15
        }
    }, /*#__PURE__*/ react.createElement(button_dist_index_es/* Button */.zx, {
        px: 1,
        variant: "text",
        size: "sm",
        onClick: function onClick() {
            return refetch();
        },
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 70,
            columnNumber: 17
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: classes.refreshText,
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 76,
            columnNumber: 19
        }
    }, /*#__PURE__*/ react.createElement(typography_dist_index_es/* Typography */.ZT, {
        variant: "link",
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 77,
            columnNumber: 21
        }
    }, refreshCopy ? /*#__PURE__*/ react.createElement(react.Fragment, null, refreshCopy) : /*#__PURE__*/ react.createElement(intl_dist.T, {
        desc: Copy.refresh,
        __self: ErrorCard_this,
        __source: {
            fileName: ErrorCard_jsxFileName,
            lineNumber: 81,
            columnNumber: 25
        }
    }))))) : null)));
};
ErrorCardContent.propTypes = {
    /**
   * Show only the Error Icon without any text.
   */ iconOnly: (prop_types_default()).bool,
    /**
   * This is a prop overrides object for the IconWarning component.
   */ iconOptions: prop_types_default().shape({
        color: (prop_types_default()).string,
        size: prop_types_default().oneOf([
            "lg",
            "md",
            "sm",
            "xl"
        ])
    }),
    /**
   * Refetch function; Shows a button to refetch data.
   */ refetch: (prop_types_default()).func,
    /**
   * This is a prop overrides object for the Typography component.
   */ copyOptions: prop_types_default().shape({
        variant: (prop_types_default()).string
    }),
    /**
   * Error Message.
   */ errorCopy: (prop_types_default()).string,
    /**
   * Refetch Button Message.
   */ refreshCopy: (prop_types_default()).string
};
ErrorCardContent.defaultProps = {
    iconOnly: false,
    iconOptions: {
        color: null,
        size: "lg"
    },
    refetch: undefined,
    copyOptions: {
        variant: "sectionTitle"
    },
    errorCopy: undefined,
    refreshCopy: undefined
};
/* harmony default export */ var components_ErrorCard = ((/* unused pure expression or super */ null && (ErrorCard))); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/react-content-loader/dist/react-content-loader.es.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var react_content_loader_es_assign = function() {
    react_content_loader_es_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return react_content_loader_es_assign.apply(this, arguments);
};

function react_content_loader_es_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var uid = (function () {
    return Math.random()
        .toString(36)
        .substring(6);
});

var SVG = function (_a) {
    var animate = _a.animate, backgroundColor = _a.backgroundColor, backgroundOpacity = _a.backgroundOpacity, baseUrl = _a.baseUrl, children = _a.children, foregroundColor = _a.foregroundColor, foregroundOpacity = _a.foregroundOpacity, gradientRatio = _a.gradientRatio, uniqueKey = _a.uniqueKey, interval = _a.interval, rtl = _a.rtl, speed = _a.speed, style = _a.style, title = _a.title, props = react_content_loader_es_rest(_a, ["animate", "backgroundColor", "backgroundOpacity", "baseUrl", "children", "foregroundColor", "foregroundOpacity", "gradientRatio", "uniqueKey", "interval", "rtl", "speed", "style", "title"]);
    var fixedId = uniqueKey || uid();
    var idClip = fixedId + "-diff";
    var idGradient = fixedId + "-animated-diff";
    var idAria = fixedId + "-aria";
    var rtlStyle = rtl ? { transform: 'scaleX(-1)' } : null;
    var keyTimes = "0; " + interval + "; 1";
    var dur = speed + "s";
    return ((0,react.createElement)("svg", react_content_loader_es_assign({ "aria-labelledby": idAria, role: "img", style: react_content_loader_es_assign(react_content_loader_es_assign({}, style), rtlStyle) }, props),
        title ? (0,react.createElement)("title", { id: idAria }, title) : null,
        (0,react.createElement)("rect", { role: "presentation", x: "0", y: "0", width: "100%", height: "100%", clipPath: "url(" + baseUrl + "#" + idClip + ")", style: { fill: "url(" + baseUrl + "#" + idGradient + ")" } }),
        (0,react.createElement)("defs", { role: "presentation" },
            (0,react.createElement)("clipPath", { id: idClip }, children),
            (0,react.createElement)("linearGradient", { id: idGradient },
                (0,react.createElement)("stop", { offset: "0%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }, animate && ((0,react.createElement)("animate", { attributeName: "offset", values: -gradientRatio + "; " + -gradientRatio + "; 1", keyTimes: keyTimes, dur: dur, repeatCount: "indefinite" }))),
                (0,react.createElement)("stop", { offset: "50%", stopColor: foregroundColor, stopOpacity: foregroundOpacity }, animate && ((0,react.createElement)("animate", { attributeName: "offset", values: -gradientRatio / 2 + "; " + -gradientRatio / 2 + "; " + (1 +
                        gradientRatio / 2), keyTimes: keyTimes, dur: dur, repeatCount: "indefinite" }))),
                (0,react.createElement)("stop", { offset: "100%", stopColor: backgroundColor, stopOpacity: backgroundOpacity }, animate && ((0,react.createElement)("animate", { attributeName: "offset", values: "0; 0; " + (1 + gradientRatio), keyTimes: keyTimes, dur: dur, repeatCount: "indefinite" })))))));
};
SVG.defaultProps = {
    animate: true,
    backgroundColor: '#f5f6f7',
    backgroundOpacity: 1,
    baseUrl: '',
    foregroundColor: '#eee',
    foregroundOpacity: 1,
    gradientRatio: 2,
    id: null,
    interval: 0.25,
    rtl: false,
    speed: 1.2,
    style: {},
    title: 'Loading...',
};

var ContentLoader = function (props) {
    return props.children ? (0,react.createElement)(SVG, react_content_loader_es_assign({}, props)) : (0,react.createElement)(ReactContentLoaderFacebook, react_content_loader_es_assign({}, props));
};

var ReactContentLoaderFacebook = function (props) { return ((0,react.createElement)(ContentLoader, react_content_loader_es_assign({ viewBox: "0 0 476 124" }, props),
    (0,react.createElement)("rect", { x: "48", y: "8", width: "88", height: "6", rx: "3" }),
    (0,react.createElement)("rect", { x: "48", y: "26", width: "52", height: "6", rx: "3" }),
    (0,react.createElement)("rect", { x: "0", y: "56", width: "410", height: "6", rx: "3" }),
    (0,react.createElement)("rect", { x: "0", y: "72", width: "380", height: "6", rx: "3" }),
    (0,react.createElement)("rect", { x: "0", y: "88", width: "178", height: "6", rx: "3" }),
    (0,react.createElement)("circle", { cx: "20", cy: "20", r: "20" }))); };

var ReactContentLoaderInstagram = function (props) { return (createElement(ContentLoader, react_content_loader_es_assign({ viewBox: "0 0 400 460" }, props),
    createElement("circle", { cx: "31", cy: "31", r: "15" }),
    createElement("rect", { x: "58", y: "18", rx: "2", ry: "2", width: "140", height: "10" }),
    createElement("rect", { x: "58", y: "34", rx: "2", ry: "2", width: "140", height: "10" }),
    createElement("rect", { x: "0", y: "60", rx: "2", ry: "2", width: "400", height: "400" }))); };

var ReactContentLoaderCode = function (props) { return (createElement(ContentLoader, react_content_loader_es_assign({ viewBox: "0 0 340 84" }, props),
    createElement("rect", { x: "0", y: "0", width: "67", height: "11", rx: "3" }),
    createElement("rect", { x: "76", y: "0", width: "140", height: "11", rx: "3" }),
    createElement("rect", { x: "127", y: "48", width: "53", height: "11", rx: "3" }),
    createElement("rect", { x: "187", y: "48", width: "72", height: "11", rx: "3" }),
    createElement("rect", { x: "18", y: "48", width: "100", height: "11", rx: "3" }),
    createElement("rect", { x: "0", y: "71", width: "37", height: "11", rx: "3" }),
    createElement("rect", { x: "18", y: "23", width: "140", height: "11", rx: "3" }),
    createElement("rect", { x: "166", y: "23", width: "173", height: "11", rx: "3" }))); };

var ReactContentLoaderListStyle = function (props) { return (createElement(ContentLoader, react_content_loader_es_assign({ viewBox: "0 0 400 110" }, props),
    createElement("rect", { x: "0", y: "0", rx: "3", ry: "3", width: "250", height: "10" }),
    createElement("rect", { x: "20", y: "20", rx: "3", ry: "3", width: "220", height: "10" }),
    createElement("rect", { x: "20", y: "40", rx: "3", ry: "3", width: "170", height: "10" }),
    createElement("rect", { x: "0", y: "60", rx: "3", ry: "3", width: "250", height: "10" }),
    createElement("rect", { x: "20", y: "80", rx: "3", ry: "3", width: "200", height: "10" }),
    createElement("rect", { x: "20", y: "100", rx: "3", ry: "3", width: "80", height: "10" }))); };

var ReactContentLoaderBulletList = function (props) { return (createElement(ContentLoader, react_content_loader_es_assign({ viewBox: "0 0 245 125" }, props),
    createElement("circle", { cx: "10", cy: "20", r: "8" }),
    createElement("rect", { x: "25", y: "15", rx: "5", ry: "5", width: "220", height: "10" }),
    createElement("circle", { cx: "10", cy: "50", r: "8" }),
    createElement("rect", { x: "25", y: "45", rx: "5", ry: "5", width: "220", height: "10" }),
    createElement("circle", { cx: "10", cy: "80", r: "8" }),
    createElement("rect", { x: "25", y: "75", rx: "5", ry: "5", width: "220", height: "10" }),
    createElement("circle", { cx: "10", cy: "110", r: "8" }),
    createElement("rect", { x: "25", y: "105", rx: "5", ry: "5", width: "220", height: "10" }))); };

/* harmony default export */ var react_content_loader_es = (ContentLoader);

//# sourceMappingURL=react-content-loader.es.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SkeletonLoader/InitialComponent.js
var InitialComponent_jsxFileName = "/repo/packages/webassets/src/components/SkeletonLoader/InitialComponent.tsx", InitialComponent_this = undefined;

var InitialComponent = function InitialComponent(_ref) {
    var _ref$width = _ref.width, width = _ref$width === void 0 ? 400 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 130 : _ref$height;
    return /*#__PURE__*/ react.createElement("rect", {
        "data-testid": "SkeletonLoader__InitialComponent",
        x: "0",
        y: "0",
        rx: "5",
        ry: "5",
        width: width,
        height: height,
        __self: InitialComponent_this,
        __source: {
            fileName: InitialComponent_jsxFileName,
            lineNumber: 12,
            columnNumber: 3
        }
    });
};
/* harmony default export */ var SkeletonLoader_InitialComponent = (InitialComponent); //# sourceMappingURL=InitialComponent.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/SkeletonLoader/index.js
var SkeletonLoader_excluded = [
    "backgroundColor",
    "foregroundColor",
    "children"
];
var SkeletonLoader_jsxFileName = "/repo/packages/webassets/src/components/SkeletonLoader/index.tsx", SkeletonLoader_this = undefined;
function SkeletonLoader_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = SkeletonLoader_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SkeletonLoader_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * HOW TO USE
 *
 * use create-content-loader to generate the desired skeleton svg:
 * https://danilowoz.com/create-content-loader/
 *
 * How it works:
 * 1) get dimensions of component to skeleton and put into create-content-loader
 * 2) use best guess estimates to mock out placements for all elements you
 *  want to show in the skeleton
 * 3) transfer this to code
 * 4) load page and check the position/size for each element
 * Adjust position in code as necessary
 * 5) rinse and repeat until you hit your desired level of pixel perfection
 */ 



// https://github.com/danilowoz/react-content-loader/issues/194

var DEFAULT_COLOR = "#6B787A";
var SkeletonLoaderContent = function SkeletonLoaderContent(props) {
    var _theme$palette, _theme$palette$second, _theme$palette2, _theme$palette2$secon;
    var theme = (0,theming_esm/* useTheme */.Fg)();
    var backgroundColor = props.backgroundColor, foregroundColor = props.foregroundColor, children = props.children, other = SkeletonLoader_objectWithoutProperties(props, SkeletonLoader_excluded);
    var bgColor = backgroundColor || (theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$second = _theme$palette.secondary) === null || _theme$palette$second === void 0 ? void 0 : _theme$palette$second.main) || DEFAULT_COLOR;
    var fgColor = foregroundColor || (theme === null || theme === void 0 ? void 0 : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$secon = _theme$palette2.secondary) === null || _theme$palette2$secon === void 0 ? void 0 : _theme$palette2$secon.main) || DEFAULT_COLOR;
    return /*#__PURE__*/ react.createElement(react_content_loader_es, Object.assign({
        backgroundColor: bgColor,
        foregroundColor: fgColor
    }, other, {
        __self: SkeletonLoader_this,
        __source: {
            fileName: SkeletonLoader_jsxFileName,
            lineNumber: 50,
            columnNumber: 5
        }
    }), children || /*#__PURE__*/ react.createElement(SkeletonLoader_InitialComponent, Object.assign({}, props, {
        __self: SkeletonLoader_this,
        __source: {
            fileName: SkeletonLoader_jsxFileName,
            lineNumber: 55,
            columnNumber: 20
        }
    })));
};
var SkeletonLoader = function SkeletonLoader(props) {
    return /*#__PURE__*/ react.createElement(theme/* WebAssetsThemeWrapper */.at, {
        __self: SkeletonLoader_this,
        __source: {
            fileName: SkeletonLoader_jsxFileName,
            lineNumber: 61,
            columnNumber: 3
        }
    }, /*#__PURE__*/ react.createElement(SkeletonLoaderContent, Object.assign({}, props, {
        __self: SkeletonLoader_this,
        __source: {
            fileName: SkeletonLoader_jsxFileName,
            lineNumber: 62,
            columnNumber: 5
        }
    })));
};
SkeletonLoader.defaultProps = {
    children: null,
    // background
    backgroundColor: "",
    backgroundOpacity: 0.08,
    // animation
    foregroundColor: "",
    foregroundOpacity: 0.18,
    // speed
    speed: 2
};
/* harmony default export */ var components_SkeletonLoader = ((/* unused pure expression or super */ null && (SkeletonLoader))); //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Experiments/Treatment/index.js + 1 modules
var Treatment = __webpack_require__(5263);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/Experiments/index.js
var Experiments = __webpack_require__(4165);
// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/helpers/errorHandler.js
var errorHandler = __webpack_require__(6589);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BrowserGuard/BrowserGuard.js
var BrowserGuard_jsxFileName = "/repo/packages/webassets/src/components/BrowserGuard/BrowserGuard.tsx", BrowserGuard_this = undefined;
function BrowserGuard_slicedToArray(arr, i) {
    return BrowserGuard_arrayWithHoles(arr) || BrowserGuard_iterableToArrayLimit(arr, i) || BrowserGuard_unsupportedIterableToArray(arr, i) || BrowserGuard_nonIterableRest();
}
function BrowserGuard_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function BrowserGuard_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return BrowserGuard_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return BrowserGuard_arrayLikeToArray(o, minLen);
}
function BrowserGuard_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++){
        arr2[i] = arr[i];
    }
    return arr2;
}
function BrowserGuard_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0){
                ;
            }
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function BrowserGuard_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}





var BrowserGuard_COPY = (0,intl_dist/* defineMessages */.vU)({
    DIALOG_HEADER: {
        id: "BrowserGuard.DialogHeader",
        defaultMessage: "Your browser isn't supported",
        description: "Header of a dialog displaying a message to the users that their browser is not supported."
    },
    DIALOG_BODY: {
        id: "BrowserGuard.DialogBody",
        defaultMessage: "For more information please visit:",
        description: "Text describing that more information on the issue will be available on the following link"
    },
    LINK_TEXT: {
        id: "BrowserGuard.LinkText",
        defaultMessage: "Supported Browsers",
        description: "Text for a link directing the user to the Supported Browsers help page"
    }
});
var BrowserGuardDialog = function BrowserGuardDialog() {
    return /*#__PURE__*/ React.createElement(WebAssetsThemeWrapper, {
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 35,
            columnNumber: 5
        }
    }, /*#__PURE__*/ React.createElement("div", {
        "data-testid": "BrowserGuardDialog",
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 36,
            columnNumber: 7
        }
    }, /*#__PURE__*/ React.createElement(Modal, {
        show: true,
        dismissible: true,
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 37,
            columnNumber: 9
        }
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        header: t(BrowserGuard_COPY.DIALOG_HEADER),
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 38,
            columnNumber: 11
        }
    }), /*#__PURE__*/ React.createElement(Modal.Body, {
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 39,
            columnNumber: 11
        }
    }, /*#__PURE__*/ React.createElement("p", {
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 40,
            columnNumber: 13
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: BrowserGuard_COPY.DIALOG_BODY,
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 41,
            columnNumber: 15
        }
    })), /*#__PURE__*/ React.createElement("p", {
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 43,
            columnNumber: 13
        }
    }, /*#__PURE__*/ React.createElement("a", {
        href: "https://help.surveymonkey.com/articles/en_US/kb/What-browser-versions-do-you-support",
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 44,
            columnNumber: 15
        }
    }, /*#__PURE__*/ React.createElement(T, {
        desc: BrowserGuard_COPY.LINK_TEXT,
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 45,
            columnNumber: 17
        }
    })))))));
};
/**
 * Component for checking if the user browser is supported
 *
 * Basic usage example:
 * `<BrowserGuard />`
 *
 * The basic usage will check against the default supported browsers
 * as documented here: https://help.surveymonkey.com/articles/en_US/kb/What-browser-versions-do-you-support
 *
 * If the user's browser is not supported a modal window will be displayed to the user.
 *
 * Optionally one can provide a list of supported browsers via the supportedBrowsers prop.
 * Also, a different UI may be rendered if a children is passed to the component.
 */ var BrowserGuard = function BrowserGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? /*#__PURE__*/ React.createElement(BrowserGuardDialog, {
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 71,
            columnNumber: 14
        }
    }) : _ref$children, supportedBrowsers = _ref.supportedBrowsers;
    var _useState = useState(false), _useState2 = BrowserGuard_slicedToArray(_useState, 2), hasVerified = _useState2[0], setHasVerified = _useState2[1];
    var _useState3 = useState(false), _useState4 = BrowserGuard_slicedToArray(_useState3, 2), isSupported = _useState4[0], setIsSupported = _useState4[1];
    useEffect(function() {
        if (window && !hasVerified) {
            setIsSupported(isBrowserSupported(window.navigator.userAgent, supportedBrowsers));
            setHasVerified(true);
        }
    }, [
        hasVerified,
        supportedBrowsers
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, hasVerified && !isSupported ? /*#__PURE__*/ React.createElement("div", {
        "data-testid": "BrowserGuard",
        __self: BrowserGuard_this,
        __source: {
            fileName: BrowserGuard_jsxFileName,
            lineNumber: 89,
            columnNumber: 9
        }
    }, children) : null);
};
/* harmony default export */ var BrowserGuard_BrowserGuard = ((/* unused pure expression or super */ null && (BrowserGuard))); //# sourceMappingURL=BrowserGuard.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/BrowserGuard/index.js
 //# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sm/webassets/dist/components/SurveyTheme/index.js + 1 modules
var SurveyTheme = __webpack_require__(4693);
;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/GlobalThemeProvider/GlobalThemeProvider.js
var GlobalThemeProvider_jsxFileName = "/repo/packages/webassets/src/components/GlobalThemeProvider/GlobalThemeProvider.tsx", GlobalThemeProvider_this = undefined;



var GlobalThemeProvider_GlobalThemeProvider = function GlobalThemeProvider(_ref) {
    var theme = _ref.theme, children = _ref.children;
    var _getClientEnvironment = getClientEnvironmentDetails(), isBrowser = _getClientEnvironment.isBrowser;
    useEffect(function() {
        /**
     *  remove the JSS styles from the DOM after the client has loaded
     *  https://cssinjs.org/react-jss?v=v10.4.0#server-side-rendering
     */ if (isBrowser) {
            var jss = document.getElementById("jss");
            if (jss) {
                jss.remove();
            }
        }
    }, [
        isBrowser
    ]);
    return /*#__PURE__*/ React.createElement(ReactJSSThemeProvider, {
        theme: theme,
        __self: GlobalThemeProvider_this,
        __source: {
            fileName: GlobalThemeProvider_jsxFileName,
            lineNumber: 29,
            columnNumber: 5
        }
    }, children);
};
/* harmony default export */ var components_GlobalThemeProvider_GlobalThemeProvider = ((/* unused pure expression or super */ null && (GlobalThemeProvider_GlobalThemeProvider))); //# sourceMappingURL=GlobalThemeProvider.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/components/GlobalThemeProvider/index.js

/* harmony default export */ var components_GlobalThemeProvider = ((/* unused pure expression or super */ null && (GlobalThemeProvider))); //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sm/webassets/dist/index.js




































 //# sourceMappingURL=index.js.map


/***/ }),

/***/ 9267:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "saveExperimentTreatment"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "saveExperimentTreatmentInput"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "saveExperimentTreatment"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "success"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "assignments"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "maxAge"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 171
    }
};
doc.loc.source = {
    "body": "mutation saveExperimentTreatment($input: saveExperimentTreatmentInput!) {\n  saveExperimentTreatment(input: $input) {\n    success\n    assignments\n    maxAge\n    name\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.saveExperimentTreatment = oneQuery(doc, "saveExperimentTreatment");


/***/ }),

/***/ 307:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "cancelSeatRequest"
            },
            "variableDefinitions": [],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "cancelSeatRequest"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "success"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 69
    }
};
doc.loc.source = {
    "body": "mutation cancelSeatRequest {\n  cancelSeatRequest {\n    success\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.cancelSeatRequest = oneQuery(doc, "cancelSeatRequest");


/***/ }),

/***/ 4202:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "createSeatRequest"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "CreateSeatRequestInput"
                            }
                        }
                    },
                    "directives": []
                }
            ],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "createSeatRequest"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "success"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "seatRequest"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 150
    }
};
doc.loc.source = {
    "body": "mutation createSeatRequest($input: CreateSeatRequestInput!) {\n  createSeatRequest(input: $input) {\n    success\n    seatRequest {\n      id\n    }\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.createSeatRequest = oneQuery(doc, "createSeatRequest");


/***/ }),

/***/ 8571:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "remindSeatRequest"
            },
            "variableDefinitions": [],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remindSeatRequest"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "success"
                                    },
                                    "arguments": [],
                                    "directives": []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 69
    }
};
doc.loc.source = {
    "body": "mutation remindSeatRequest {\n  remindSeatRequest {\n    success\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.remindSeatRequest = oneQuery(doc, "remindSeatRequest");


/***/ }),

/***/ 8212:
/***/ (function(module) {

"use strict";

var doc = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "seatRequest"
            },
            "variableDefinitions": [],
            "directives": [],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "user"
                        },
                        "arguments": [],
                        "directives": [],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "featureSetId"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "seatRequest"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "status"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "request"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "seatType"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "date"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "reminder"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "mostRecentDate"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "count"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "contributorRoleType"
                                    },
                                    "arguments": [],
                                    "directives": []
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "team"
                                    },
                                    "arguments": [],
                                    "directives": [],
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                },
                                                "arguments": [],
                                                "directives": []
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "accountOwner"
                                                },
                                                "arguments": [],
                                                "directives": [],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "email"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "firstName"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "lastName"
                                                            },
                                                            "arguments": [],
                                                            "directives": []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    "loc": {
        "start": 0,
        "end": 371
    }
};
doc.loc.source = {
    "body": "query seatRequest {\n  user {\n    id\n    featureSetId\n    seatRequest {\n      id\n      status\n      request {\n        id\n        seatType\n        date\n      }\n      reminder {\n        mostRecentDate\n        count\n      }\n    }\n    contributorRoleType\n    team {\n      id\n      accountOwner {\n        id\n        email\n        firstName\n        lastName\n      }\n    }\n  }\n}\n",
    "name": "GraphQL request",
    "locationOffset": {
        "line": 1,
        "column": 1
    }
};
var names = {};
function unique(defs) {
    return defs.filter(function(def) {
        if (def.kind !== "FragmentDefinition") return true;
        var name = def.name.value;
        if (names[name]) {
            return false;
        } else {
            names[name] = true;
            return true;
        }
    });
}
// Collect any fragment/type references from a node, adding them to the refs Set
function collectFragmentReferences(node, refs) {
    if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
    } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
            refs.add(type.name.value);
        }
    }
    if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
            collectFragmentReferences(selection, refs);
        });
    }
    if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
    if (node.definitions) {
        node.definitions.forEach(function(def) {
            collectFragmentReferences(def, refs);
        });
    }
}
var definitionRefs = {};
(function extractReferences() {
    doc.definitions.forEach(function(def) {
        if (def.name) {
            var refs = new Set();
            collectFragmentReferences(def, refs);
            definitionRefs[def.name.value] = refs;
        }
    });
})();
function findOperation(doc, name) {
    for(var i = 0; i < doc.definitions.length; i++){
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
            return element;
        }
    }
}
function oneQuery(doc, operationName) {
    // Copy the DocumentNode, but clear out the definitions
    var newDoc = {
        kind: doc.kind,
        definitions: [
            findOperation(doc, operationName)
        ]
    };
    if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
    }
    // Now, for the operation we're running, find any fragments referenced by
    // it or the fragments it references
    var opRefs = definitionRefs[operationName] || new Set();
    var allRefs = new Set();
    var newRefs = new Set();
    // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
    opRefs.forEach(function(refName) {
        newRefs.add(refName);
    });
    while(newRefs.size > 0){
        var prevRefs = newRefs;
        newRefs = new Set();
        prevRefs.forEach(function(refName) {
            if (!allRefs.has(refName)) {
                allRefs.add(refName);
                var childRefs = definitionRefs[refName] || new Set();
                childRefs.forEach(function(childRef) {
                    newRefs.add(childRef);
                });
            }
        });
    }
    allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
            newDoc.definitions.push(op);
        }
    });
    return newDoc;
}
module.exports = doc;
module.exports.seatRequest = oneQuery(doc, "seatRequest");


/***/ }),

/***/ 2284:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8469:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6172:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 136:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6378:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2165:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9547:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 2407:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8845:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 617:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7479:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fromUrl = exports.NO_HOSTNAME = void 0;
const urlPattern = /^[a-z][*+.a-z-]+:\/\//i;
exports.NO_HOSTNAME = Symbol("NO_HOSTNAME");
const fromUrl = (urlLike) => {
    /* istanbul ignore next */
    if (typeof URL !== "function") {
        throw new Error("Looks like the new URL() constructor is not globally available in your environment. Please make sure to use a polyfill.");
    }
    // Extra check for non-TypeScript users
    if (typeof urlLike !== "string") {
        return exports.NO_HOSTNAME;
    }
    // URLs that start with // are protocol relative
    const url = urlLike.startsWith("//")
        ? `http:${urlLike}`
        : // URLs that start with / do not have a hostname section
            urlLike.startsWith("/")
                ? urlLike
                : urlPattern.test(urlLike)
                    ? urlLike
                    : `http://${urlLike}`;
    try {
        return new URL(url).hostname;
    }
    catch (_a) {
        return exports.NO_HOSTNAME;
    }
};
exports.fromUrl = fromUrl;
//# sourceMappingURL=from-url.js.map

/***/ }),

/***/ 3327:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValidationErrorType = exports.NO_HOSTNAME = exports.fromUrl = exports.ParseResultType = exports.parseDomain = void 0;
/* istanbul ignore file */
// Jest will report function coverage errors here otherwise
var parse_domain_1 = __webpack_require__(3434);
Object.defineProperty(exports, "parseDomain", ({ enumerable: true, get: function () { return parse_domain_1.parseDomain; } }));
Object.defineProperty(exports, "ParseResultType", ({ enumerable: true, get: function () { return parse_domain_1.ParseResultType; } }));
var from_url_1 = __webpack_require__(7479);
Object.defineProperty(exports, "fromUrl", ({ enumerable: true, get: function () { return from_url_1.fromUrl; } }));
Object.defineProperty(exports, "NO_HOSTNAME", ({ enumerable: true, get: function () { return from_url_1.NO_HOSTNAME; } }));
var sanitize_1 = __webpack_require__(4896);
Object.defineProperty(exports, "ValidationErrorType", ({ enumerable: true, get: function () { return sanitize_1.ValidationErrorType; } }));
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 3434:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseDomain = exports.ParseResultType = exports.RESERVED_TOP_LEVEL_DOMAINS = void 0;
const serialized_tries_1 = __webpack_require__(4673);
const look_up_1 = __webpack_require__(7985);
const sanitize_1 = __webpack_require__(4896);
const parse_trie_1 = __webpack_require__(8273);
exports.RESERVED_TOP_LEVEL_DOMAINS = [
    "localhost",
    "local",
    "example",
    "invalid",
    "test",
];
var ParseResultType;
(function (ParseResultType) {
    /**
     * This parse result is returned in case the given hostname does not adhere to [RFC 1034](https://tools.ietf.org/html/rfc1034).
     */
    ParseResultType["Invalid"] = "INVALID";
    /**
     * This parse result is returned if the given hostname was an IPv4 or IPv6.
     */
    ParseResultType["Ip"] = "IP";
    /**
     * This parse result is returned when the given hostname
     * - is the root domain (the empty string `""`)
     * - belongs to the top-level domain `localhost`, `local`, `example`, `invalid` or `test`
     */
    ParseResultType["Reserved"] = "RESERVED";
    /**
     * This parse result is returned when the given hostname is valid and does not belong to a reserved top-level domain, but is not listed in the public suffix list.
     */
    ParseResultType["NotListed"] = "NOT_LISTED";
    /**
     * This parse result is returned when the given hostname belongs to a top-level domain that is listed in the public suffix list.
     */
    ParseResultType["Listed"] = "LISTED";
})(ParseResultType = exports.ParseResultType || (exports.ParseResultType = {}));
const getAtIndex = (array, index) => {
    return index >= 0 && index < array.length ? array[index] : undefined;
};
const splitLabelsIntoDomains = (labels, index) => {
    return {
        subDomains: labels.slice(0, Math.max(0, index)),
        domain: getAtIndex(labels, index),
        topLevelDomains: labels.slice(index + 1),
    };
};
let parsedIcannTrie;
let parsedPrivateTrie;
/**
 * Splits the given hostname in topLevelDomains, a domain and subDomains.
 */
const parseDomain = (hostname) => {
    const sanitizationResult = (0, sanitize_1.sanitize)(hostname);
    if (sanitizationResult.type === sanitize_1.SanitizationResultType.Error) {
        return {
            type: ParseResultType.Invalid,
            hostname,
            errors: sanitizationResult.errors,
        };
    }
    if (sanitizationResult.type === sanitize_1.SanitizationResultType.ValidIp) {
        return {
            type: ParseResultType.Ip,
            hostname: sanitizationResult.ip,
            ipVersion: sanitizationResult.ipVersion,
        };
    }
    const { labels, domain } = sanitizationResult;
    if (hostname === "" ||
        exports.RESERVED_TOP_LEVEL_DOMAINS.includes(labels[labels.length - 1])) {
        return {
            type: ParseResultType.Reserved,
            hostname: domain,
            labels,
        };
    }
    // Parse the serialized trie lazily
    parsedIcannTrie = parsedIcannTrie !== null && parsedIcannTrie !== void 0 ? parsedIcannTrie : (0, parse_trie_1.parseTrie)(serialized_tries_1.icannTrie);
    parsedPrivateTrie = parsedPrivateTrie !== null && parsedPrivateTrie !== void 0 ? parsedPrivateTrie : (0, parse_trie_1.parseTrie)(serialized_tries_1.privateTrie);
    const icannTlds = (0, look_up_1.lookUpTldsInTrie)(labels, parsedIcannTrie);
    const privateTlds = (0, look_up_1.lookUpTldsInTrie)(labels, parsedPrivateTrie);
    if (icannTlds.length === 0 && privateTlds.length === 0) {
        return {
            type: ParseResultType.NotListed,
            hostname: domain,
            labels,
        };
    }
    const indexOfPublicSuffixDomain = labels.length - Math.max(privateTlds.length, icannTlds.length) - 1;
    const indexOfIcannDomain = labels.length - icannTlds.length - 1;
    return Object.assign({ type: ParseResultType.Listed, hostname: domain, labels, icann: splitLabelsIntoDomains(labels, indexOfIcannDomain) }, splitLabelsIntoDomains(labels, indexOfPublicSuffixDomain));
};
exports.parseDomain = parseDomain;
//# sourceMappingURL=parse-domain.js.map

/***/ }),

/***/ 4896:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sanitize = exports.SanitizationResultType = exports.ValidationErrorType = void 0;
const is_ip_1 = __importDefault(__webpack_require__(5003));
// See https://en.wikipedia.org/wiki/Domain_name
// See https://tools.ietf.org/html/rfc1034
const LABEL_SEPARATOR = ".";
const LABEL_ROOT = "";
const LABEL_LENGTH_MIN = 1;
const LABEL_LENGTH_MAX = 63;
const DOMAIN_LENGTH_MAX = 253;
var ValidationErrorType;
(function (ValidationErrorType) {
    ValidationErrorType["NoHostname"] = "NO_HOSTNAME";
    ValidationErrorType["DomainMaxLength"] = "DOMAIN_MAX_LENGTH";
    ValidationErrorType["LabelMinLength"] = "LABEL_MIN_LENGTH";
    ValidationErrorType["LabelMaxLength"] = "LABEL_MAX_LENGTH";
    ValidationErrorType["LabelInvalidCharacter"] = "LABEL_INVALID_CHARACTER";
})(ValidationErrorType = exports.ValidationErrorType || (exports.ValidationErrorType = {}));
var SanitizationResultType;
(function (SanitizationResultType) {
    SanitizationResultType["ValidIp"] = "VALID_IP";
    SanitizationResultType["ValidDomain"] = "VALID_DOMAIN";
    SanitizationResultType["Error"] = "ERROR";
})(SanitizationResultType = exports.SanitizationResultType || (exports.SanitizationResultType = {}));
const createNoHostnameError = (input) => {
    return {
        type: ValidationErrorType.NoHostname,
        message: `The given input ${String(input)} does not look like a hostname.`,
        column: 1,
    };
};
const createDomainMaxLengthError = (domain) => {
    const length = domain.length;
    return {
        type: ValidationErrorType.DomainMaxLength,
        message: `Domain "${domain}" is too long. Domain is ${length} octets long but should not be longer than ${DOMAIN_LENGTH_MAX}.`,
        column: length,
    };
};
const createLabelMinLengthError = (label, column) => {
    const length = label.length;
    return {
        type: ValidationErrorType.LabelMinLength,
        message: `Label "${label}" is too short. Label is ${length} octets long but should be at least ${LABEL_LENGTH_MIN}.`,
        column,
    };
};
const createLabelMaxLengthError = (label, column) => {
    const length = label.length;
    return {
        type: ValidationErrorType.LabelMaxLength,
        message: `Label "${label}" is too long. Label is ${length} octets long but should not be longer than ${LABEL_LENGTH_MAX}.`,
        column,
    };
};
const createLabelInvalidCharacterError = (label, invalidCharacter, column) => {
    return {
        type: ValidationErrorType.LabelInvalidCharacter,
        message: `Label "${label}" contains invalid character "${invalidCharacter}" at column ${column}.`,
        column,
    };
};
const sanitize = (input) => {
    // Extra check for non-TypeScript users
    if (typeof input !== "string") {
        return {
            type: SanitizationResultType.Error,
            errors: [createNoHostnameError(input)],
        };
    }
    const inputTrimmed = input.trim();
    // IPv6 addresses are surrounded by square brackets in URLs
    // See https://tools.ietf.org/html/rfc3986#section-3.2.2
    const inputTrimmedAsIp = inputTrimmed.replace(/^\[|]$/g, "");
    const ipVersion = is_ip_1.default.version(inputTrimmedAsIp);
    if (ipVersion !== undefined) {
        return {
            type: SanitizationResultType.ValidIp,
            ip: inputTrimmedAsIp,
            ipVersion,
        };
    }
    if (inputTrimmed.length > DOMAIN_LENGTH_MAX) {
        return {
            type: SanitizationResultType.Error,
            errors: [createDomainMaxLengthError(inputTrimmed)],
        };
    }
    const labels = inputTrimmed.split(LABEL_SEPARATOR);
    const lastLabel = labels[labels.length - 1];
    // If the last label is the special root label, ignore it
    if (lastLabel === LABEL_ROOT) {
        labels.pop();
    }
    const labelValidationErrors = [];
    let column = 1;
    for (const label of labels) {
        // According to https://tools.ietf.org/html/rfc6761 labels should
        // only contain ASCII letters, digits and hyphens (LDH).
        const invalidCharacter = /[^\da-z-]/iu.exec(label);
        if (invalidCharacter) {
            labelValidationErrors.push(createLabelInvalidCharacterError(label, invalidCharacter[0], invalidCharacter.index + 1));
        }
        else if (
        // We can use .length here to check for the octet size because
        // label can only contain ASCII LDH characters at this point.
        label.length < LABEL_LENGTH_MIN) {
            labelValidationErrors.push(createLabelMinLengthError(label, column));
        }
        else if (label.length > LABEL_LENGTH_MAX) {
            labelValidationErrors.push(createLabelMaxLengthError(label, column));
        }
        column += label.length + LABEL_SEPARATOR.length;
    }
    if (labelValidationErrors.length > 0) {
        return {
            type: SanitizationResultType.Error,
            errors: labelValidationErrors,
        };
    }
    return {
        type: SanitizationResultType.ValidDomain,
        domain: inputTrimmed,
        labels,
    };
};
exports.sanitize = sanitize;
//# sourceMappingURL=sanitize.js.map

/***/ }),

/***/ 4673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.privateTrie = exports.icannTrie = void 0;
const icann_json_1 = __importDefault(__webpack_require__(2942));
exports.icannTrie = icann_json_1.default;
const private_json_1 = __importDefault(__webpack_require__(6943));
exports.privateTrie = private_json_1.default;
//# sourceMappingURL=serialized-tries.js.map

/***/ }),

/***/ 9932:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EXCEPTION = exports.WILDCARD = exports.RESET = exports.DOWN = exports.SAME = exports.UP = void 0;
// UP, SAME, DOWN, RESET should not be special regex characters in a character class.
exports.UP = "<"; // one level up
exports.SAME = ","; // same level
exports.DOWN = ">"; // one level down
exports.RESET = "|"; // reset level index and start new
exports.WILDCARD = "*"; // as defined by publicsuffix.org
exports.EXCEPTION = "!"; // as defined by publicsuffix.org
//# sourceMappingURL=characters.js.map

/***/ }),

/***/ 7985:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.lookUpTldsInTrie = void 0;
const characters = __importStar(__webpack_require__(9932));
const lookUpTldsInTrie = (labels, trie) => {
    const labelsToCheck = labels.slice();
    const tlds = [];
    let node = trie;
    while (labelsToCheck.length !== 0) {
        const label = labelsToCheck.pop();
        const labelLowerCase = label.toLowerCase();
        if (node.children.has(characters.WILDCARD)) {
            if (node.children.has(characters.EXCEPTION + labelLowerCase)) {
                break;
            }
            node = node.children.get(characters.WILDCARD);
        }
        else {
            if (node.children.has(labelLowerCase) === false) {
                break;
            }
            node = node.children.get(labelLowerCase);
        }
        tlds.unshift(label);
    }
    return tlds;
};
exports.lookUpTldsInTrie = lookUpTldsInTrie;
//# sourceMappingURL=look-up.js.map

/***/ }),

/***/ 8351:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createOrGetChild = exports.createRootNode = exports.NODE_TYPE_CHILD = exports.NODE_TYPE_ROOT = void 0;
exports.NODE_TYPE_ROOT = Symbol("ROOT");
exports.NODE_TYPE_CHILD = Symbol("CHILD");
const createRootNode = () => {
    return {
        type: exports.NODE_TYPE_ROOT,
        children: new Map(),
    };
};
exports.createRootNode = createRootNode;
const createOrGetChild = (parent, label) => {
    let child = parent.children.get(label);
    if (child === undefined) {
        child = {
            type: exports.NODE_TYPE_CHILD,
            label,
            children: new Map(),
            parent,
        };
        parent.children.set(label, child);
    }
    return child;
};
exports.createOrGetChild = createOrGetChild;
//# sourceMappingURL=nodes.js.map

/***/ }),

/***/ 8273:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseTrie = void 0;
const characters = __importStar(__webpack_require__(9932));
const nodes_1 = __webpack_require__(8351);
const parseTrie = (serializedTrie) => {
    const rootNode = (0, nodes_1.createRootNode)();
    let domain = "";
    let parentNode = rootNode;
    // Type assertion necessary here due to a TypeScript unsoundness
    // https://github.com/microsoft/TypeScript/issues/9998#issuecomment-235963457
    let node = rootNode;
    const addDomain = () => {
        node = (0, nodes_1.createOrGetChild)(parentNode, domain);
        domain = "";
    };
    for (let i = 0; i < serializedTrie.length; i++) {
        const char = serializedTrie.charAt(i);
        switch (char) {
            case characters.SAME: {
                addDomain();
                continue;
            }
            case characters.DOWN: {
                addDomain();
                parentNode = node;
                continue;
            }
            case characters.RESET: {
                addDomain();
                parentNode = rootNode;
                continue;
            }
            case characters.UP: {
                if (parentNode.type === nodes_1.NODE_TYPE_ROOT) {
                    throw new Error(`Error in serialized trie at position ${i}: Cannot go up, current parent node is already root`);
                }
                addDomain();
                parentNode = parentNode.parent;
                continue;
            }
        }
        domain += char;
    }
    if (domain !== "") {
        addDomain();
    }
    return rootNode;
};
exports.parseTrie = parseTrie;
//# sourceMappingURL=parse-trie.js.map

/***/ }),

/***/ 7784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7462);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4578);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7326);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1143);
/* harmony import */ var invariant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(invariant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var json2mq__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(973);
/* harmony import */ var json2mq__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json2mq__WEBPACK_IMPORTED_MODULE_2__);









var MediaQueryListener =
/*#__PURE__*/
function () {
  function MediaQueryListener(targetWindow, query, listener) {
    var _this = this;

    this.nativeMediaQueryList = targetWindow.matchMedia(query);
    this.active = true; // Safari doesn't clear up listener with removeListener
    // when the listener is already waiting in the event queue.
    // Having an active flag to make sure the listener is not called
    // after we removeListener.

    this.cancellableListener = function () {
      _this.matches = _this.nativeMediaQueryList.matches;

      if (_this.active) {
        listener.apply(void 0, arguments);
      }
    };

    this.nativeMediaQueryList.addListener(this.cancellableListener);
    this.matches = this.nativeMediaQueryList.matches;
  }

  var _proto = MediaQueryListener.prototype;

  _proto.cancel = function cancel() {
    this.active = false;
    this.nativeMediaQueryList.removeListener(this.cancellableListener);
  };

  return MediaQueryListener;
}();

var queryType = prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object), prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().object.isRequired))]);
/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media =
/*#__PURE__*/
function (_React$Component) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Media, _React$Component);

  function Media(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this)), "queries", []);

    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this)), "getMatches", function () {
      var result = _this.queries.reduce(function (acc, _ref) {
        var _extends2;

        var name = _ref.name,
            mqListener = _ref.mqListener;
        return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, acc, (_extends2 = {}, _extends2[name] = mqListener.matches, _extends2));
      }, {}); // return result;


      return unwrapSingleQuery(result);
    });

    (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this)), "updateMatches", function () {
      var newMatches = _this.getMatches();

      _this.setState(function () {
        return {
          matches: newMatches
        };
      }, _this.onChange);
    });

    !(!(!props.query && !props.queries) || props.query && props.queries) ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
    !(props.defaultMatches === undefined || !props.query || typeof props.defaultMatches === "boolean") ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
    !(props.defaultMatches === undefined || !props.queries || typeof props.defaultMatches === "object") ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;

    if (typeof window !== "object") {
      // In case we're rendering on the server, apply the default matches
      var matches;

      if (props.defaultMatches !== undefined) {
        matches = props.defaultMatches;
      } else if (props.query) {
        matches = true;
      }
      /* if (props.queries) */
      else {
          matches = Object.keys(_this.props.queries).reduce(function (acc, key) {
            var _extends3;

            return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, acc, (_extends3 = {}, _extends3[key] = true, _extends3));
          }, {});
        }

      _this.state = {
        matches: matches
      };
      return (0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_this);
    }

    _this.initialize(); // Instead of calling this.updateMatches, we manually set the initial state to prevent
    // calling setState, which could trigger an unnecessary second render


    _this.state = {
      matches: _this.props.defaultMatches !== undefined ? _this.props.defaultMatches : _this.getMatches()
    };

    _this.onChange();

    return _this;
  }

  var _proto = Media.prototype;

  _proto.initialize = function initialize() {
    var _this2 = this;

    var targetWindow = this.props.targetWindow || window;
    !(typeof targetWindow.matchMedia === "function") ?  false ? 0 : invariant__WEBPACK_IMPORTED_MODULE_1___default()(false) : void 0;
    var queries = this.props.queries || wrapInQueryObject(this.props.query);
    this.queries = Object.keys(queries).map(function (name) {
      var query = queries[name];
      var qs = typeof query !== "string" ? json2mq__WEBPACK_IMPORTED_MODULE_2___default()(query) : query;
      var mqListener = new MediaQueryListener(targetWindow, qs, _this2.updateMatches);
      return {
        name: name,
        mqListener: mqListener
      };
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initialize(); // If props.defaultMatches has been set, ensure we trigger a two-pass render.
    // This is useful for SSR with mismatching defaultMatches vs actual matches from window.matchMedia
    // Details: https://github.com/ReactTraining/react-media/issues/81

    if (this.props.defaultMatches !== undefined) {
      this.updateMatches();
    }
  };

  _proto.onChange = function onChange() {
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.state.matches);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.queries.forEach(function (_ref2) {
      var mqListener = _ref2.mqListener;
      return mqListener.cancel();
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        render = _this$props.render;
    var matches = this.state.matches;
    var isAnyMatches = typeof matches === "object" ? Object.keys(matches).some(function (key) {
      return matches[key];
    }) : matches;
    return render ? isAnyMatches ? render(matches) : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? isAnyMatches ? // We have to check whether child is a composite component or not to decide should we
    // provide `matches` as a prop or not
    react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children) && typeof react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children).type === "string" ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children) : react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(react__WEBPACK_IMPORTED_MODULE_0__.Children.only(children), {
      matches: matches
    }) : null : null : null;
  };

  return Media;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/**
 * Wraps a single query in an object. This is used to provide backward compatibility with
 * the old `query` prop (as opposed to `queries`). If only a single query is passed, the object
 * will be unpacked down the line, but this allows our internals to assume an object of queries
 * at all times.
 */


(0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Media, "propTypes", {
  defaultMatches: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool), prop_types__WEBPACK_IMPORTED_MODULE_3___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool))]),
  query: queryType,
  queries: prop_types__WEBPACK_IMPORTED_MODULE_3___default().objectOf(queryType),
  render: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
  children: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().node), (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)]),
  targetWindow: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
});

function wrapInQueryObject(query) {
  return {
    __DEFAULT__: query
  };
}
/**
 * Unwraps an object of queries, if it was originally passed as a single query.
 */


function unwrapSingleQuery(queryObject) {
  var queryNames = Object.keys(queryObject);

  if (queryNames.length === 1 && queryNames[0] === "__DEFAULT__") {
    return queryObject.__DEFAULT__;
  }

  return queryObject;
}

/* harmony default export */ __webpack_exports__["Z"] = (Media);


/***/ }),

/***/ 6585:
/***/ (function(module) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 5582:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isarray = __webpack_require__(6585)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),

/***/ 1169:
/***/ (function(module) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 4363:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"dataCenters":{"0":{"id":"0","regionCode":"US","regionName":"The United States of America","surveyCollectionDefaultTld":"com","surveyCollectionWhiteLabelTld":"net","defaultSubdomain":"www","CCTldSupport":true},"1":{"id":"1","regionCode":"CA","regionName":"Canada","surveyCollectionDefaultTld":"ca","surveyCollectionWhiteLabelTld":"net","defaultSubdomain":"www","CCTldSupport":true},"2":{"id":"2","regionCode":"EU","regionName":"Europe","surveyCollectionDefaultTld":"com","surveyCollectionWhiteLabelTld":"net","defaultSubdomain":"eu","CCTldSupport":false}},"dataCenterSpecificSubdomains":{"eu":"2"}}');

/***/ }),

/***/ 4316:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"id":"1","name":"English","displayName":"English","code":"en","primary":"en","region":null,"script":null,"variant":null},{"id":"2","name":"Chinese (Simplified)","displayName":"中文 (简体)","code":"zh_Hans","primary":"zh","region":null,"script":"Hans","variant":null},{"id":"3","name":"Chinese (Traditional)","displayName":"中文","code":"zh","primary":"zh","region":null,"script":null,"variant":null},{"id":"4","name":"Danish","displayName":"Dansk","code":"da","primary":"da","region":null,"script":null,"variant":null},{"id":"5","name":"Dutch","displayName":"Nederlands","code":"nl","primary":"nl","region":null,"script":null,"variant":null},{"id":"6","name":"Finnish","displayName":"Suomi","code":"fi","primary":"fi","region":null,"script":null,"variant":null},{"id":"7","name":"French","displayName":"Français","code":"fr","primary":"fr","region":null,"script":null,"variant":null},{"id":"8","name":"German","displayName":"Deutsch","code":"de","primary":"de","region":null,"script":null,"variant":null},{"id":"9","name":"Greek","displayName":"Ελληνικά","code":"el","primary":"el","region":null,"script":null,"variant":null},{"id":"10","name":"Italian","displayName":"Italiano","code":"it","primary":"it","region":null,"script":null,"variant":null},{"id":"11","name":"Japanese","displayName":"日本語","code":"ja","primary":"ja","region":null,"script":null,"variant":null},{"id":"12","name":"Korean","displayName":"한국어","code":"ko","primary":"ko","region":null,"script":null,"variant":null},{"id":"13","name":"Malay","displayName":"Bahasa Melayu","code":"ms","primary":"ms","region":null,"script":null,"variant":null},{"id":"14","name":"Norwegian","displayName":"Norsk","code":"no","primary":"no","region":null,"script":null,"variant":null},{"id":"15","name":"Polish","displayName":"Polski","code":"pl","primary":"pl","region":null,"script":null,"variant":null},{"id":"16","name":"Portuguese (Iberian)","displayName":"Português","code":"pt","primary":"pt","region":null,"script":null,"variant":null},{"id":"17","name":"Portuguese (Brazilian)","displayName":"Português (Brasil)","code":"pt_BR","primary":"pt","region":"BR","script":null,"variant":null},{"id":"18","name":"Russian","displayName":"Русский","code":"ru","primary":"ru","region":null,"script":null,"variant":null},{"id":"19","name":"Spanish","displayName":"Español","code":"es","primary":"es","region":null,"script":null,"variant":null},{"id":"20","name":"Swedish","displayName":"Svenska","code":"sv","primary":"sv","region":null,"script":null,"variant":null},{"id":"21","name":"Turkish","displayName":"Türkçe","code":"tr","primary":"tr","region":null,"script":null,"variant":null},{"id":"22","name":"Ukrainian","displayName":"Українська","code":"uk","primary":"uk","region":null,"script":null,"variant":null},{"id":"23","name":"Reverse","displayName":"Rv","code":"rv","primary":"rv","region":null,"script":null,"variant":null},{"id":"24","name":"Albanian","displayName":"Shqip","code":"sq","primary":"sq","region":null,"script":null,"variant":null},{"id":"25","name":"Arabic","displayName":"العربية","code":"ar","primary":"ar","region":null,"script":null,"variant":null},{"id":"26","name":"Armenian","displayName":"Հայերեն","code":"hy","primary":"hy","region":null,"script":null,"variant":null},{"id":"27","name":"Basque","displayName":"Euskara","code":"eu","primary":"eu","region":null,"script":null,"variant":null},{"id":"28","name":"Bengali","displayName":"বাংলা","code":"bn","primary":"bn","region":null,"script":null,"variant":null},{"id":"29","name":"Bosnian","displayName":"Bosanski","code":"bs","primary":"bs","region":null,"script":null,"variant":null},{"id":"30","name":"Bulgarian","displayName":"Български","code":"bg","primary":"bg","region":null,"script":null,"variant":null},{"id":"31","name":"Catalan","displayName":"Català","code":"ca","primary":"ca","region":null,"script":null,"variant":null},{"id":"32","name":"Croatian","displayName":"Hrvatski","code":"hr","primary":"hr","region":null,"script":null,"variant":null},{"id":"33","name":"Czech","displayName":"Čeština","code":"cs","primary":"cs","region":null,"script":null,"variant":null},{"id":"34","name":"Estonian","displayName":"Eesti","code":"et","primary":"et","region":null,"script":null,"variant":null},{"id":"35","name":"Filipino","displayName":"Filipino","code":"tl","primary":"tl","region":null,"script":null,"variant":null},{"id":"36","name":"Georgian","displayName":"Ქართული","code":"ka","primary":"ka","region":null,"script":null,"variant":null},{"id":"37","name":"Hebrew","displayName":"עברית","code":"he","primary":"he","region":null,"script":null,"variant":null},{"id":"38","name":"Hindi","displayName":"हिन्दी","code":"hi","primary":"hi","region":null,"script":null,"variant":null},{"id":"39","name":"Hungarian","displayName":"Magyar","code":"hu","primary":"hu","region":null,"script":null,"variant":null},{"id":"40","name":"Icelandic","displayName":"Íslenska","code":"is","primary":"is","region":null,"script":null,"variant":null},{"id":"41","name":"Indonesian","displayName":"Indonesia","code":"id","primary":"id","region":null,"script":null,"variant":null},{"id":"42","name":"Irish","displayName":"Gaeilge","code":"ga","primary":"ga","region":null,"script":null,"variant":null},{"id":"43","name":"Kurdish","displayName":"Kurdish","code":"ku","primary":"ku","region":null,"script":null,"variant":null},{"id":"44","name":"Latvian","displayName":"Latviešu","code":"lv","primary":"lv","region":null,"script":null,"variant":null},{"id":"45","name":"Lithuanian","displayName":"Lietuvių","code":"lt","primary":"lt","region":null,"script":null,"variant":null},{"id":"46","name":"Macedonian","displayName":"Македонски","code":"mk","primary":"mk","region":null,"script":null,"variant":null},{"id":"47","name":"Malayalam","displayName":"മലയാളം","code":"ml","primary":"ml","region":null,"script":null,"variant":null},{"id":"48","name":"Persian","displayName":"فارسی","code":"fa","primary":"fa","region":null,"script":null,"variant":null},{"id":"49","name":"Punjabi","displayName":"ਪੰਜਾਬੀ","code":"pa","primary":"pa","region":null,"script":null,"variant":null},{"id":"50","name":"Romanian","displayName":"Română","code":"ro","primary":"ro","region":null,"script":null,"variant":null},{"id":"51","name":"Serbian","displayName":"Српски","code":"sr","primary":"sr","region":null,"script":null,"variant":null},{"id":"52","name":"Slovak","displayName":"Slovenčina","code":"sk","primary":"sk","region":null,"script":null,"variant":null},{"id":"53","name":"Slovenian","displayName":"Slovenščina","code":"sl","primary":"sl","region":null,"script":null,"variant":null},{"id":"54","name":"Swahili","displayName":"Kiswahili","code":"sw","primary":"sw","region":null,"script":null,"variant":null},{"id":"55","name":"Tamil","displayName":"தமிழ்","code":"ta","primary":"ta","region":null,"script":null,"variant":null},{"id":"56","name":"Telugu","displayName":"తెలుగు","code":"te","primary":"te","region":null,"script":null,"variant":null},{"id":"57","name":"Thai","displayName":"ไทย","code":"th","primary":"th","region":null,"script":null,"variant":null},{"id":"58","name":"Vietnamese","displayName":"Tiếng Việt","code":"vi","primary":"vi","region":null,"script":null,"variant":null},{"id":"59","name":"Welsh","displayName":"Cymraeg","code":"cy","primary":"cy","region":null,"script":null,"variant":null},{"id":"60","name":"English (Great Britain)","displayName":"English (Great Britain)","code":"gb","primary":"gb","region":null,"script":null,"variant":null},{"id":"61","name":"Afrikaans (Namibia)","displayName":"Afrikaans (Namibië)","code":"af_NA","primary":"af","region":"NA","script":null,"variant":null},{"id":"62","name":"Afrikaans (South Africa)","displayName":"Afrikaans (Suid-Afrika)","code":"af_ZA","primary":"af","region":"ZA","script":null,"variant":null},{"id":"63","name":"Aghem","displayName":"Aghem","code":"agq","primary":"agq","region":null,"script":null,"variant":null},{"id":"64","name":"Aghem (Cameroon)","displayName":"Aghem (Kàmàlûŋ)","code":"agq_CM","primary":"agq","region":"CM","script":null,"variant":null},{"id":"65","name":"Akan","displayName":"Akan","code":"ak","primary":"ak","region":null,"script":null,"variant":null},{"id":"66","name":"Akan (Ghana)","displayName":"Akan (Gaana)","code":"ak_GH","primary":"ak","region":"GH","script":null,"variant":null},{"id":"67","name":"Amharic","displayName":"አማርኛ","code":"am","primary":"am","region":null,"script":null,"variant":null},{"id":"68","name":"Amharic (Ethiopia)","displayName":"አማርኛ (ኢትዮጵያ)","code":"am_ET","primary":"am","region":"ET","script":null,"variant":null},{"id":"69","name":"Arabic (World)","displayName":"العربية (العالم)","code":"ar_001","primary":"ar","region":"001","script":null,"variant":null},{"id":"70","name":"Arabic (United Arab Emirates)","displayName":"العربية (الإمارات العربية المتحدة)","code":"ar_AE","primary":"ar","region":"AE","script":null,"variant":null},{"id":"71","name":"Arabic (Bahrain)","displayName":"العربية (البحرين)","code":"ar_BH","primary":"ar","region":"BH","script":null,"variant":null},{"id":"72","name":"Arabic (Djibouti)","displayName":"العربية (جيبوتي)","code":"ar_DJ","primary":"ar","region":"DJ","script":null,"variant":null},{"id":"73","name":"Arabic (Algeria)","displayName":"العربية (الجزائر)","code":"ar_DZ","primary":"ar","region":"DZ","script":null,"variant":null},{"id":"74","name":"Arabic (Egypt)","displayName":"ADD العربية (مصر)","code":"ar_EG","primary":"ar","region":"EG","script":null,"variant":null},{"id":"75","name":"Arabic (Western Sahara)","displayName":"العربية (الصحراء الغربية)","code":"ar_EH","primary":"ar","region":"EH","script":null,"variant":null},{"id":"76","name":"Arabic (Eritrea)","displayName":"العربية (إريتريا)","code":"ar_ER","primary":"ar","region":"ER","script":null,"variant":null},{"id":"77","name":"Arabic (Israel)","displayName":"العربية (إسرائيل)","code":"ar_IL","primary":"ar","region":"IL","script":null,"variant":null},{"id":"78","name":"Arabic (Iraq)","displayName":"العربية (العراق)","code":"ar_IQ","primary":"ar","region":"IQ","script":null,"variant":null},{"id":"79","name":"Arabic (Jordan)","displayName":"العربية (الأردن)","code":"ar_JO","primary":"ar","region":"JO","script":null,"variant":null},{"id":"80","name":"Arabic (Comoros)","displayName":"العربية (جزر القمر)","code":"ar_KM","primary":"ar","region":"KM","script":null,"variant":null},{"id":"81","name":"Arabic (Kuwait)","displayName":"العربية (الكويت)","code":"ar_KW","primary":"ar","region":"KW","script":null,"variant":null},{"id":"82","name":"Arabic (Lebanon)","displayName":"العربية (لبنان)","code":"ar_LB","primary":"ar","region":"LB","script":null,"variant":null},{"id":"83","name":"Arabic (Libya)","displayName":"العربية (ليبيا)","code":"ar_LY","primary":"ar","region":"LY","script":null,"variant":null},{"id":"84","name":"Arabic (Morocco)","displayName":"العربية (المغرب)","code":"ar_MA","primary":"ar","region":"MA","script":null,"variant":null},{"id":"85","name":"Arabic (Mauritania)","displayName":"العربية (موريتانيا)","code":"ar_MR","primary":"ar","region":"MR","script":null,"variant":null},{"id":"86","name":"Arabic (Oman)","displayName":"العربية (عُمان)","code":"ar_OM","primary":"ar","region":"OM","script":null,"variant":null},{"id":"87","name":"Arabic (Palestinian Territories)","displayName":"العربية (الأراضي الفلسطينية)","code":"ar_PS","primary":"ar","region":"PS","script":null,"variant":null},{"id":"88","name":"Arabic (Qatar)","displayName":"العربية (قطر)","code":"ar_QA","primary":"ar","region":"QA","script":null,"variant":null},{"id":"89","name":"Arabic (Saudi Arabia)","displayName":"العربية (المملكة العربية السعودية)","code":"ar_SA","primary":"ar","region":"SA","script":null,"variant":null},{"id":"90","name":"Arabic (Sudan)","displayName":"العربية (السودان)","code":"ar_SD","primary":"ar","region":"SD","script":null,"variant":null},{"id":"91","name":"Arabic (Somalia)","displayName":"العربية (الصومال)","code":"ar_SO","primary":"ar","region":"SO","script":null,"variant":null},{"id":"92","name":"Arabic (South Sudan)","displayName":"العربية (جنوب السودان)","code":"ar_SS","primary":"ar","region":"SS","script":null,"variant":null},{"id":"93","name":"Arabic (Syria)","displayName":"العربية (سوريا)","code":"ar_SY","primary":"ar","region":"SY","script":null,"variant":null},{"id":"94","name":"Arabic (Chad)","displayName":"العربية (تشاد)","code":"ar_TD","primary":"ar","region":"TD","script":null,"variant":null},{"id":"95","name":"Arabic (Tunisia)","displayName":"العربية (تونس)","code":"ar_TN","primary":"ar","region":"TN","script":null,"variant":null},{"id":"96","name":"Arabic (Yemen)","displayName":"العربية (اليمن)","code":"ar_YE","primary":"ar","region":"YE","script":null,"variant":null},{"id":"97","name":"Assamese","displayName":"অসমীয়া","code":"as","primary":"as","region":null,"script":null,"variant":null},{"id":"98","name":"Assamese (India)","displayName":"অসমীয়া (ভাৰত)","code":"as_IN","primary":"as","region":"IN","script":null,"variant":null},{"id":"99","name":"Asu","displayName":"Kipare","code":"asa","primary":"asa","region":null,"script":null,"variant":null},{"id":"100","name":"Asu (Tanzania)","displayName":"Kipare (Tadhania)","code":"asa_TZ","primary":"asa","region":"TZ","script":null,"variant":null},{"id":"101","name":"Azerbaijani","displayName":"Azərbaycan","code":"az","primary":"az","region":null,"script":null,"variant":null},{"id":"102","name":"Azerbaijani (Cyrillic)","displayName":"Азәрбајҹан (Кирил)","code":"az_Cyrl","primary":"az","region":null,"script":"Cyrl","variant":null},{"id":"103","name":"Azerbaijani (Cyrillic, Azerbaijan)","displayName":"Azərbaycan (kiril, Azərbaycan)","code":"az_Cyrl_AZ","primary":"az","region":"AZ","script":"Cyrl","variant":null},{"id":"104","name":"Azerbaijani (Latin)","displayName":"Azərbaycan (latın)","code":"az_Latn","primary":"az","region":null,"script":"Latn","variant":null},{"id":"105","name":"Azerbaijani (Latin, Azerbaijan)","displayName":"Azərbaycan (latın, Azərbaycan)","code":"az_Latn_AZ","primary":"az","region":"AZ","script":"Latn","variant":null},{"id":"106","name":"Basaa","displayName":"Ɓàsàa","code":"bas","primary":"bas","region":null,"script":null,"variant":null},{"id":"107","name":"Basaa (Cameroon)","displayName":"Ɓàsàa (Kàmɛ̀Rûn)","code":"bas_CM","primary":"bas","region":"CM","script":null,"variant":null},{"id":"108","name":"Belarusian","displayName":"Беларуская","code":"be","primary":"be","region":null,"script":null,"variant":null},{"id":"109","name":"Belarusian (Belarus)","displayName":"Беларуская (Беларусь)","code":"be_BY","primary":"be","region":"BY","script":null,"variant":null},{"id":"110","name":"Bemba","displayName":"Ichibemba","code":"bem","primary":"bem","region":null,"script":null,"variant":null},{"id":"111","name":"Bemba (Zambia)","displayName":"Ichibemba (Zambia)","code":"bem_ZM","primary":"bem","region":"ZM","script":null,"variant":null},{"id":"112","name":"Bena","displayName":"Hibena","code":"bez","primary":"bez","region":null,"script":null,"variant":null},{"id":"113","name":"Bena (Tanzania)","displayName":"Hibena (Hutanzania)","code":"bez_TZ","primary":"bez","region":"TZ","script":null,"variant":null},{"id":"114","name":"Bulgarian (Bulgaria)","displayName":"Български (България)","code":"bg_BG","primary":"bg","region":"BG","script":null,"variant":null},{"id":"115","name":"Bambara","displayName":"Bamanakan","code":"bm","primary":"bm","region":null,"script":null,"variant":null},{"id":"116","name":"Bambara (Mali)","displayName":"Bamanakan (Mali)","code":"bm_ML","primary":"bm","region":"ML","script":null,"variant":null},{"id":"117","name":"Bengali (Bangladesh)","displayName":"বাংলা (বাংলাদেশ)","code":"bn_BD","primary":"bn","region":"BD","script":null,"variant":null},{"id":"118","name":"Bengali (India)","displayName":"বাংলা (ভারত)","code":"bn_IN","primary":"bn","region":"IN","script":null,"variant":null},{"id":"119","name":"Tibetan","displayName":"བོད་སྐད་","code":"bo","primary":"bo","region":null,"script":null,"variant":null},{"id":"120","name":"Tibetan (China)","displayName":"བོད་སྐད་ (རྒྱ་ནག)","code":"bo_CN","primary":"bo","region":"CN","script":null,"variant":null},{"id":"121","name":"Tibetan (India)","displayName":"བོད་སྐད་ (རྒྱ་གར་)","code":"bo_IN","primary":"bo","region":"IN","script":null,"variant":null},{"id":"122","name":"Breton","displayName":"Brezhoneg","code":"br","primary":"br","region":null,"script":null,"variant":null},{"id":"123","name":"Breton (France)","displayName":"Brezhoneg (Frañs)","code":"br_FR","primary":"br","region":"FR","script":null,"variant":null},{"id":"124","name":"Bodo","displayName":"बड़ो","code":"brx","primary":"brx","region":null,"script":null,"variant":null},{"id":"125","name":"Bodo (India)","displayName":"बड़ो (भारत)","code":"brx_IN","primary":"brx","region":"IN","script":null,"variant":null},{"id":"126","name":"Bosnian (Cyrillic)","displayName":"Босански (Ћирилица)","code":"bs_Cyrl","primary":"bs","region":null,"script":"Cyrl","variant":null},{"id":"127","name":"Bosnian (Cyrillic, Bosnia and Herzegovina)","displayName":"Bosanski (ćirilica, Bosna i Hercegovina)","code":"bs_Cyrl_BA","primary":"bs","region":"BA","script":"Cyrl","variant":null},{"id":"128","name":"Bosnian (Latin)","displayName":"Bosanski (latinica)","code":"bs_Latn","primary":"bs","region":null,"script":"Latn","variant":null},{"id":"129","name":"Bosnian (Latin, Bosnia and Herzegovina)","displayName":"Bosanski (latinica, Bosna i Hercegovina)","code":"bs_Latn_BA","primary":"bs","region":"BA","script":"Latn","variant":null},{"id":"130","name":"Catalan (Andorra)","displayName":"Català (Andorra)","code":"ca_AD","primary":"ca","region":"AD","script":null,"variant":null},{"id":"131","name":"Catalan (Spain)","displayName":"Català (Espanya)","code":"ca_ES","primary":"ca","region":"ES","script":null,"variant":null},{"id":"132","name":"Catalan (France)","displayName":"Català (França)","code":"ca_FR","primary":"ca","region":"FR","script":null,"variant":null},{"id":"133","name":"Catalan (Italy)","displayName":"Català (Itàlia)","code":"ca_IT","primary":"ca","region":"IT","script":null,"variant":null},{"id":"134","name":"Chiga","displayName":"Rukiga","code":"cgg","primary":"cgg","region":null,"script":null,"variant":null},{"id":"135","name":"Chiga (Uganda)","displayName":"Rukiga (Uganda)","code":"cgg_UG","primary":"cgg","region":"UG","script":null,"variant":null},{"id":"136","name":"Cherokee","displayName":"Ꮳꮃꭹ","code":"chr","primary":"chr","region":null,"script":null,"variant":null},{"id":"137","name":"Cherokee (United States)","displayName":"Ꮳꮃꭹ (Ꮜꮚ Ꭲᏻꮎꮅꮝꮤꮕ Ꮝꭶꮪꭹ)","code":"chr_US","primary":"chr","region":"US","script":null,"variant":null},{"id":"138","name":"Czech (Czech Republic)","displayName":"Čeština (Česko)","code":"cs_CZ","primary":"cs","region":"CZ","script":null,"variant":null},{"id":"139","name":"Welsh (United Kingdom)","displayName":"Cymraeg (Y Deyrnas Unedig)","code":"cy_GB","primary":"cy","region":"GB","script":null,"variant":null},{"id":"140","name":"Danish (Denmark)","displayName":"Dansk (Danmark)","code":"da_DK","primary":"da","region":"DK","script":null,"variant":null},{"id":"141","name":"Danish (Greenland)","displayName":"Dansk (Grønland)","code":"da_GL","primary":"da","region":"GL","script":null,"variant":null},{"id":"142","name":"Taita","displayName":"Kitaita","code":"dav","primary":"dav","region":null,"script":null,"variant":null},{"id":"143","name":"Taita (Kenya)","displayName":"Kitaita (Kenya)","code":"dav_KE","primary":"dav","region":"KE","script":null,"variant":null},{"id":"144","name":"German (Austria)","displayName":"Deutsch (Österreich)","code":"de_AT","primary":"de","region":"AT","script":null,"variant":null},{"id":"145","name":"German (Belgium)","displayName":"Deutsch (Belgien)","code":"de_BE","primary":"de","region":"BE","script":null,"variant":null},{"id":"146","name":"German (Switzerland)","displayName":"Deutsch (Schweiz)","code":"de_CH","primary":"de","region":"CH","script":null,"variant":null},{"id":"147","name":"German (Germany)","displayName":"Deutsch (Deutschland)","code":"de_DE","primary":"de","region":"DE","script":null,"variant":null},{"id":"148","name":"German (Liechtenstein)","displayName":"Deutsch (Liechtenstein)","code":"de_LI","primary":"de","region":"LI","script":null,"variant":null},{"id":"149","name":"German (Luxembourg)","displayName":"Deutsch (Luxemburg)","code":"de_LU","primary":"de","region":"LU","script":null,"variant":null},{"id":"150","name":"Zarma","displayName":"Zarmaciine","code":"dje","primary":"dje","region":null,"script":null,"variant":null},{"id":"151","name":"Zarma (Niger)","displayName":"Zarmaciine (Nižer)","code":"dje_NE","primary":"dje","region":"NE","script":null,"variant":null},{"id":"152","name":"Duala","displayName":"Duálá","code":"dua","primary":"dua","region":null,"script":null,"variant":null},{"id":"153","name":"Duala (Cameroon)","displayName":"Duálá (Cameroun)","code":"dua_CM","primary":"dua","region":"CM","script":null,"variant":null},{"id":"154","name":"Jola-Fonyi","displayName":"Joola","code":"dyo","primary":"dyo","region":null,"script":null,"variant":null},{"id":"155","name":"Jola-Fonyi (Senegal)","displayName":"Joola (Senegal)","code":"dyo_SN","primary":"dyo","region":"SN","script":null,"variant":null},{"id":"156","name":"Dzongkha","displayName":"རྫོང་ཁ","code":"dz","primary":"dz","region":null,"script":null,"variant":null},{"id":"157","name":"Dzongkha (Bhutan)","displayName":"རྫོང་ཁ (འབྲུག)","code":"dz_BT","primary":"dz","region":"BT","script":null,"variant":null},{"id":"158","name":"Embu","displayName":"Kĩembu","code":"ebu","primary":"ebu","region":null,"script":null,"variant":null},{"id":"159","name":"Embu (Kenya)","displayName":"Kĩembu (Kenya)","code":"ebu_KE","primary":"ebu","region":"KE","script":null,"variant":null},{"id":"160","name":"Ewe","displayName":"Eʋegbe","code":"ee","primary":"ee","region":null,"script":null,"variant":null},{"id":"161","name":"Ewe (Ghana)","displayName":"Eʋegbe (Ghana nutome)","code":"ee_GH","primary":"ee","region":"GH","script":null,"variant":null},{"id":"162","name":"Ewe (Togo)","displayName":"Eʋegbe (Togo nutome)","code":"ee_TG","primary":"ee","region":"TG","script":null,"variant":null},{"id":"163","name":"Greek (Cyprus)","displayName":"Ελληνικά (Κύπρος)","code":"el_CY","primary":"el","region":"CY","script":null,"variant":null},{"id":"164","name":"Greek (Greece)","displayName":"Ελληνικά (Ελλάδα)","code":"el_GR","primary":"el","region":"GR","script":null,"variant":null},{"id":"165","name":"English (World)","displayName":"English (World)","code":"en_001","primary":"en","region":"001","script":null,"variant":null},{"id":"166","name":"English (Europe)","displayName":"English (Europe)","code":"en_150","primary":"en","region":"150","script":null,"variant":null},{"id":"167","name":"English (Antigua and Barbuda)","displayName":"English (Antigua & Barbuda)","code":"en_AG","primary":"en","region":"AG","script":null,"variant":null},{"id":"168","name":"English (Anguilla)","displayName":"English (Anguilla)","code":"en_AI","primary":"en","region":"AI","script":null,"variant":null},{"id":"169","name":"English (American Samoa)","displayName":"English (American Samoa)","code":"en_AS","primary":"en","region":"AS","script":null,"variant":null},{"id":"170","name":"English (Australia)","displayName":"English (Australia)","code":"en_AU","primary":"en","region":"AU","script":null,"variant":null},{"id":"171","name":"English (Barbados)","displayName":"English (Barbados)","code":"en_BB","primary":"en","region":"BB","script":null,"variant":null},{"id":"172","name":"English (Belgium)","displayName":"English (Belgium)","code":"en_BE","primary":"en","region":"BE","script":null,"variant":null},{"id":"173","name":"English (Bermuda)","displayName":"English (Bermuda)","code":"en_BM","primary":"en","region":"BM","script":null,"variant":null},{"id":"174","name":"English (Bahamas)","displayName":"English (Bahamas)","code":"en_BS","primary":"en","region":"BS","script":null,"variant":null},{"id":"175","name":"English (Botswana)","displayName":"English (Botswana)","code":"en_BW","primary":"en","region":"BW","script":null,"variant":null},{"id":"176","name":"English (Belize)","displayName":"English (Belize)","code":"en_BZ","primary":"en","region":"BZ","script":null,"variant":null},{"id":"177","name":"English (Canada)","displayName":"English (Canada)","code":"en_CA","primary":"en","region":"CA","script":null,"variant":null},{"id":"178","name":"English (Cocos [Keeling] Islands)","displayName":"English (Cocos (Keeling) Islands)","code":"en_CC","primary":"en","region":"CC","script":null,"variant":null},{"id":"179","name":"English (Cook Islands)","displayName":"English (Cook Islands)","code":"en_CK","primary":"en","region":"CK","script":null,"variant":null},{"id":"180","name":"English (Cameroon)","displayName":"English (Cameroon)","code":"en_CM","primary":"en","region":"CM","script":null,"variant":null},{"id":"181","name":"English (Christmas Island)","displayName":"English (Christmas Island)","code":"en_CX","primary":"en","region":"CX","script":null,"variant":null},{"id":"182","name":"English (Diego Garcia)","displayName":"English (Diego Garcia)","code":"en_DG","primary":"en","region":"DG","script":null,"variant":null},{"id":"183","name":"English (Dominica)","displayName":"English (Dominica)","code":"en_DM","primary":"en","region":"DM","script":null,"variant":null},{"id":"184","name":"English (Eritrea)","displayName":"English (Eritrea)","code":"en_ER","primary":"en","region":"ER","script":null,"variant":null},{"id":"185","name":"English (Fiji)","displayName":"English (Fiji)","code":"en_FJ","primary":"en","region":"FJ","script":null,"variant":null},{"id":"186","name":"English (Falkland Islands)","displayName":"English (Falkland Islands)","code":"en_FK","primary":"en","region":"FK","script":null,"variant":null},{"id":"187","name":"English (Micronesia)","displayName":"English (Micronesia)","code":"en_FM","primary":"en","region":"FM","script":null,"variant":null},{"id":"188","name":"English (United Kingdom)","displayName":"English (United Kingdom)","code":"en_GB","primary":"en","region":"GB","script":null,"variant":null},{"id":"189","name":"English (Grenada)","displayName":"English (Grenada)","code":"en_GD","primary":"en","region":"GD","script":null,"variant":null},{"id":"190","name":"English (Guernsey)","displayName":"English (Guernsey)","code":"en_GG","primary":"en","region":"GG","script":null,"variant":null},{"id":"191","name":"English (Ghana)","displayName":"English (Ghana)","code":"en_GH","primary":"en","region":"GH","script":null,"variant":null},{"id":"192","name":"English (Gibraltar)","displayName":"English (Gibraltar)","code":"en_GI","primary":"en","region":"GI","script":null,"variant":null},{"id":"193","name":"English (Gambia)","displayName":"English (Gambia)","code":"en_GM","primary":"en","region":"GM","script":null,"variant":null},{"id":"194","name":"English (Guam)","displayName":"English (Guam)","code":"en_GU","primary":"en","region":"GU","script":null,"variant":null},{"id":"195","name":"English (Guyana)","displayName":"English (Guyana)","code":"en_GY","primary":"en","region":"GY","script":null,"variant":null},{"id":"196","name":"English (Hong Kong SAR China)","displayName":"English (Hong Kong SAR China)","code":"en_HK","primary":"en","region":"HK","script":null,"variant":null},{"id":"197","name":"English (Ireland)","displayName":"English (Ireland)","code":"en_IE","primary":"en","region":"IE","script":null,"variant":null},{"id":"198","name":"English (Isle of Man)","displayName":"English (Isle of Man)","code":"en_IM","primary":"en","region":"IM","script":null,"variant":null},{"id":"199","name":"English (India)","displayName":"English (India)","code":"en_IN","primary":"en","region":"IN","script":null,"variant":null},{"id":"200","name":"English (British Indian Ocean Territory)","displayName":"English (British Indian Ocean Territory)","code":"en_IO","primary":"en","region":"IO","script":null,"variant":null},{"id":"201","name":"English (Jersey)","displayName":"English (Jersey)","code":"en_JE","primary":"en","region":"JE","script":null,"variant":null},{"id":"202","name":"English (Jamaica)","displayName":"English (Jamaica)","code":"en_JM","primary":"en","region":"JM","script":null,"variant":null},{"id":"203","name":"English (Kenya)","displayName":"English (Kenya)","code":"en_KE","primary":"en","region":"KE","script":null,"variant":null},{"id":"204","name":"English (Kiribati)","displayName":"English (Kiribati)","code":"en_KI","primary":"en","region":"KI","script":null,"variant":null},{"id":"205","name":"English (Saint Kitts and Nevis)","displayName":"English (St. Kitts & Nevis)","code":"en_KN","primary":"en","region":"KN","script":null,"variant":null},{"id":"206","name":"English (Cayman Islands)","displayName":"English (Cayman Islands)","code":"en_KY","primary":"en","region":"KY","script":null,"variant":null},{"id":"207","name":"English (Saint Lucia)","displayName":"English (St. Lucia)","code":"en_LC","primary":"en","region":"LC","script":null,"variant":null},{"id":"208","name":"English (Liberia)","displayName":"English (Liberia)","code":"en_LR","primary":"en","region":"LR","script":null,"variant":null},{"id":"209","name":"English (Lesotho)","displayName":"English (Lesotho)","code":"en_LS","primary":"en","region":"LS","script":null,"variant":null},{"id":"210","name":"English (Madagascar)","displayName":"English (Madagascar)","code":"en_MG","primary":"en","region":"MG","script":null,"variant":null},{"id":"211","name":"English (Marshall Islands)","displayName":"English (Marshall Islands)","code":"en_MH","primary":"en","region":"MH","script":null,"variant":null},{"id":"212","name":"English (Macau SAR China)","displayName":"English (Macau SAR China)","code":"en_MO","primary":"en","region":"MO","script":null,"variant":null},{"id":"213","name":"English (Northern Mariana Islands)","displayName":"English (Northern Mariana Islands)","code":"en_MP","primary":"en","region":"MP","script":null,"variant":null},{"id":"214","name":"English (Montserrat)","displayName":"English (Montserrat)","code":"en_MS","primary":"en","region":"MS","script":null,"variant":null},{"id":"215","name":"English (Malta)","displayName":"English (Malta)","code":"en_MT","primary":"en","region":"MT","script":null,"variant":null},{"id":"216","name":"English (Mauritius)","displayName":"English (Mauritius)","code":"en_MU","primary":"en","region":"MU","script":null,"variant":null},{"id":"217","name":"English (Malawi)","displayName":"English (Malawi)","code":"en_MW","primary":"en","region":"MW","script":null,"variant":null},{"id":"218","name":"English (Namibia)","displayName":"English (Namibia)","code":"en_NA","primary":"en","region":"NA","script":null,"variant":null},{"id":"219","name":"English (Norfolk Island)","displayName":"English (Norfolk Island)","code":"en_NF","primary":"en","region":"NF","script":null,"variant":null},{"id":"220","name":"English (Nigeria)","displayName":"English (Nigeria)","code":"en_NG","primary":"en","region":"NG","script":null,"variant":null},{"id":"221","name":"English (Nauru)","displayName":"English (Nauru)","code":"en_NR","primary":"en","region":"NR","script":null,"variant":null},{"id":"222","name":"English (Niue)","displayName":"English (Niue)","code":"en_NU","primary":"en","region":"NU","script":null,"variant":null},{"id":"223","name":"English (New Zealand)","displayName":"English (New Zealand)","code":"en_NZ","primary":"en","region":"NZ","script":null,"variant":null},{"id":"224","name":"English (Papua New Guinea)","displayName":"English (Papua New Guinea)","code":"en_PG","primary":"en","region":"PG","script":null,"variant":null},{"id":"225","name":"English (Philippines)","displayName":"English (Philippines)","code":"en_PH","primary":"en","region":"PH","script":null,"variant":null},{"id":"226","name":"English (Pakistan)","displayName":"English (Pakistan)","code":"en_PK","primary":"en","region":"PK","script":null,"variant":null},{"id":"227","name":"English (Pitcairn Islands)","displayName":"English (Pitcairn Islands)","code":"en_PN","primary":"en","region":"PN","script":null,"variant":null},{"id":"228","name":"English (Puerto Rico)","displayName":"English (Puerto Rico)","code":"en_PR","primary":"en","region":"PR","script":null,"variant":null},{"id":"229","name":"English (Palau)","displayName":"English (Palau)","code":"en_PW","primary":"en","region":"PW","script":null,"variant":null},{"id":"230","name":"English (Rwanda)","displayName":"English (Rwanda)","code":"en_RW","primary":"en","region":"RW","script":null,"variant":null},{"id":"231","name":"English (Solomon Islands)","displayName":"English (Solomon Islands)","code":"en_SB","primary":"en","region":"SB","script":null,"variant":null},{"id":"232","name":"English (Seychelles)","displayName":"English (Seychelles)","code":"en_SC","primary":"en","region":"SC","script":null,"variant":null},{"id":"233","name":"English (Sudan)","displayName":"English (Sudan)","code":"en_SD","primary":"en","region":"SD","script":null,"variant":null},{"id":"234","name":"English (Singapore)","displayName":"English (Singapore)","code":"en_SG","primary":"en","region":"SG","script":null,"variant":null},{"id":"235","name":"English (Saint Helena)","displayName":"English (St. Helena)","code":"en_SH","primary":"en","region":"SH","script":null,"variant":null},{"id":"236","name":"English (Sierra Leone)","displayName":"English (Sierra Leone)","code":"en_SL","primary":"en","region":"SL","script":null,"variant":null},{"id":"237","name":"English (South Sudan)","displayName":"English (South Sudan)","code":"en_SS","primary":"en","region":"SS","script":null,"variant":null},{"id":"238","name":"English (Sint Maarten)","displayName":"English (Sint Maarten)","code":"en_SX","primary":"en","region":"SX","script":null,"variant":null},{"id":"239","name":"English (Swaziland)","displayName":"English (Swaziland)","code":"en_SZ","primary":"en","region":"SZ","script":null,"variant":null},{"id":"240","name":"English (Turks and Caicos Islands)","displayName":"English (Turks & Caicos Islands)","code":"en_TC","primary":"en","region":"TC","script":null,"variant":null},{"id":"241","name":"English (Tokelau)","displayName":"English (Tokelau)","code":"en_TK","primary":"en","region":"TK","script":null,"variant":null},{"id":"242","name":"English (Tonga)","displayName":"English (Tonga)","code":"en_TO","primary":"en","region":"TO","script":null,"variant":null},{"id":"243","name":"English (Trinidad and Tobago)","displayName":"English (Trinidad & Tobago)","code":"en_TT","primary":"en","region":"TT","script":null,"variant":null},{"id":"244","name":"English (Tuvalu)","displayName":"English (Tuvalu)","code":"en_TV","primary":"en","region":"TV","script":null,"variant":null},{"id":"245","name":"English (Tanzania)","displayName":"English (Tanzania)","code":"en_TZ","primary":"en","region":"TZ","script":null,"variant":null},{"id":"246","name":"English (Uganda)","displayName":"English (Uganda)","code":"en_UG","primary":"en","region":"UG","script":null,"variant":null},{"id":"247","name":"English (U.S. Outlying Islands)","displayName":"English (U.S. Outlying Islands)","code":"en_UM","primary":"en","region":"UM","script":null,"variant":null},{"id":"248","name":"English (United States)","displayName":"English (United States)","code":"en_US","primary":"en","region":"US","script":null,"variant":null},{"id":"249","name":"English (United States, Computer)","displayName":"English (United States, Computer)","code":"en_US_POSIX","primary":"en","region":"US","script":null,"variant":"POSIX"},{"id":"250","name":"English (St. Vincent & Grenadines)","displayName":"English (St. Vincent & Grenadines)","code":"en_VC","primary":"en","region":"VC","script":null,"variant":null},{"id":"251","name":"English (British Virgin Islands)","displayName":"English (British Virgin Islands)","code":"en_VG","primary":"en","region":"VG","script":null,"variant":null},{"id":"252","name":"English (U.S. Virgin Islands)","displayName":"English (U.S. Virgin Islands)","code":"en_VI","primary":"en","region":"VI","script":null,"variant":null},{"id":"253","name":"English (Vanuatu)","displayName":"English (Vanuatu)","code":"en_VU","primary":"en","region":"VU","script":null,"variant":null},{"id":"254","name":"English (Samoa)","displayName":"English (Samoa)","code":"en_WS","primary":"en","region":"WS","script":null,"variant":null},{"id":"255","name":"English (South Africa)","displayName":"English (South Africa)","code":"en_ZA","primary":"en","region":"ZA","script":null,"variant":null},{"id":"256","name":"English (Zambia)","displayName":"English (Zambia)","code":"en_ZM","primary":"en","region":"ZM","script":null,"variant":null},{"id":"257","name":"English (Zimbabwe)","displayName":"English (Zimbabwe)","code":"en_ZW","primary":"en","region":"ZW","script":null,"variant":null},{"id":"258","name":"Esperanto","displayName":"Esperanto","code":"eo","primary":"eo","region":null,"script":null,"variant":null},{"id":"259","name":"Spanish (Latin America)","displayName":"Español (Latinoamérica)","code":"es_419","primary":"es","region":"419","script":null,"variant":null},{"id":"260","name":"Spanish (Argentina)","displayName":"Español (Argentina)","code":"es_AR","primary":"es","region":"AR","script":null,"variant":null},{"id":"261","name":"Spanish (Bolivia)","displayName":"Español (Bolivia)","code":"es_BO","primary":"es","region":"BO","script":null,"variant":null},{"id":"262","name":"Spanish (Chile)","displayName":"Español (Chile)","code":"es_CL","primary":"es","region":"CL","script":null,"variant":null},{"id":"263","name":"Spanish (Colombia)","displayName":"Español (Colombia)","code":"es_CO","primary":"es","region":"CO","script":null,"variant":null},{"id":"264","name":"Spanish (Costa Rica)","displayName":"Español (Costa Rica)","code":"es_CR","primary":"es","region":"CR","script":null,"variant":null},{"id":"265","name":"Spanish (Cuba)","displayName":"Español (Cuba)","code":"es_CU","primary":"es","region":"CU","script":null,"variant":null},{"id":"266","name":"Spanish (Dominican Republic)","displayName":"Español (República Dominicana)","code":"es_DO","primary":"es","region":"DO","script":null,"variant":null},{"id":"267","name":"Spanish (Ceuta and Melilla)","displayName":"Español (Ceuta y Melilla)","code":"es_EA","primary":"es","region":"EA","script":null,"variant":null},{"id":"268","name":"Spanish (Ecuador)","displayName":"Español (Ecuador)","code":"es_EC","primary":"es","region":"EC","script":null,"variant":null},{"id":"269","name":"Spanish (Spain)","displayName":"Español (España)","code":"es_ES","primary":"es","region":"ES","script":null,"variant":null},{"id":"270","name":"Spanish (Equatorial Guinea)","displayName":"Español (Guinea Ecuatorial)","code":"es_GQ","primary":"es","region":"GQ","script":null,"variant":null},{"id":"271","name":"Spanish (Guatemala)","displayName":"Español (Guatemala)","code":"es_GT","primary":"es","region":"GT","script":null,"variant":null},{"id":"272","name":"Spanish (Honduras)","displayName":"Español (Honduras)","code":"es_HN","primary":"es","region":"HN","script":null,"variant":null},{"id":"273","name":"Spanish (Canary Islands)","displayName":"Español (Canarias)","code":"es_IC","primary":"es","region":"IC","script":null,"variant":null},{"id":"274","name":"Spanish (Mexico)","displayName":"Español (México)","code":"es_MX","primary":"es","region":"MX","script":null,"variant":null},{"id":"275","name":"Spanish (Nicaragua)","displayName":"Español (Nicaragua)","code":"es_NI","primary":"es","region":"NI","script":null,"variant":null},{"id":"276","name":"Spanish (Panama)","displayName":"Español (Panamá)","code":"es_PA","primary":"es","region":"PA","script":null,"variant":null},{"id":"277","name":"Spanish (Peru)","displayName":"Español (Perú)","code":"es_PE","primary":"es","region":"PE","script":null,"variant":null},{"id":"278","name":"Spanish (Philippines)","displayName":"Español (Filipinas)","code":"es_PH","primary":"es","region":"PH","script":null,"variant":null},{"id":"279","name":"Spanish (Puerto Rico)","displayName":"Español (Puerto Rico)","code":"es_PR","primary":"es","region":"PR","script":null,"variant":null},{"id":"280","name":"Spanish (Paraguay)","displayName":"Español (Paraguay)","code":"es_PY","primary":"es","region":"PY","script":null,"variant":null},{"id":"281","name":"Spanish (El Salvador)","displayName":"Español (El Salvador)","code":"es_SV","primary":"es","region":"SV","script":null,"variant":null},{"id":"282","name":"Spanish (United States)","displayName":"Español (Estados Unidos)","code":"es_US","primary":"es","region":"US","script":null,"variant":null},{"id":"283","name":"Spanish (Uruguay)","displayName":"Español (Uruguay)","code":"es_UY","primary":"es","region":"UY","script":null,"variant":null},{"id":"284","name":"Spanish (Venezuela)","displayName":"Español (Venezuela)","code":"es_VE","primary":"es","region":"VE","script":null,"variant":null},{"id":"285","name":"Estonian (Estonia)","displayName":"Eesti (Eesti)","code":"et_EE","primary":"et","region":"EE","script":null,"variant":null},{"id":"286","name":"Basque (Spain)","displayName":"Euskara (Espainia)","code":"eu_ES","primary":"eu","region":"ES","script":null,"variant":null},{"id":"287","name":"Ewondo","displayName":"Ewondo","code":"ewo","primary":"ewo","region":null,"script":null,"variant":null},{"id":"288","name":"Ewondo (Cameroon)","displayName":"Ewondo (Kamərún)","code":"ewo_CM","primary":"ewo","region":"CM","script":null,"variant":null},{"id":"289","name":"Persian (Afghanistan)","displayName":"فارسی (افغانستان)","code":"fa_AF","primary":"fa","region":"AF","script":null,"variant":null},{"id":"290","name":"Persian (Iran)","displayName":"فارسی (ایران)","code":"fa_IR","primary":"fa","region":"IR","script":null,"variant":null},{"id":"291","name":"Fulah","displayName":"Pulaar","code":"ff","primary":"ff","region":null,"script":null,"variant":null},{"id":"292","name":"Fulah (Senegal)","displayName":"Pulaar (Senegaal)","code":"ff_SN","primary":"ff","region":"SN","script":null,"variant":null},{"id":"293","name":"Finnish (Finland)","displayName":"Suomi (Suomi)","code":"fi_FI","primary":"fi","region":"FI","script":null,"variant":null},{"id":"294","name":"Filipino","displayName":"Filipino","code":"fil","primary":"fil","region":null,"script":null,"variant":null},{"id":"295","name":"Filipino (Philippines)","displayName":"Filipino (Pilipinas)","code":"fil_PH","primary":"fil","region":"PH","script":null,"variant":null},{"id":"296","name":"Faroese","displayName":"Føroyskt","code":"fo","primary":"fo","region":null,"script":null,"variant":null},{"id":"297","name":"Faroese (Faroe Islands)","displayName":"Føroyskt (Føroyar)","code":"fo_FO","primary":"fo","region":"FO","script":null,"variant":null},{"id":"298","name":"French (Belgium)","displayName":"Français (Belgique)","code":"fr_BE","primary":"fr","region":"BE","script":null,"variant":null},{"id":"299","name":"French (Burkina Faso)","displayName":"Français (Burkina Faso)","code":"fr_BF","primary":"fr","region":"BF","script":null,"variant":null},{"id":"300","name":"French (Burundi)","displayName":"Français (Burundi)","code":"fr_BI","primary":"fr","region":"BI","script":null,"variant":null},{"id":"301","name":"French (Benin)","displayName":"Français (Bénin)","code":"fr_BJ","primary":"fr","region":"BJ","script":null,"variant":null},{"id":"302","name":"French (Saint Barthelemy)","displayName":"Français (Saint-Barthélemy)","code":"fr_BL","primary":"fr","region":"BL","script":null,"variant":null},{"id":"303","name":"French (Canada)","displayName":"Français (Canada)","code":"fr_CA","primary":"fr","region":"CA","script":null,"variant":null},{"id":"304","name":"French (Congo - Kinshasa)","displayName":"Français (Congo-Kinshasa)","code":"fr_CD","primary":"fr","region":"CD","script":null,"variant":null},{"id":"305","name":"French (Central African Republic)","displayName":"Français (République centrafricaine)","code":"fr_CF","primary":"fr","region":"CF","script":null,"variant":null},{"id":"306","name":"French (Congo - Brazzaville)","displayName":"Français (Congo-Brazzaville)","code":"fr_CG","primary":"fr","region":"CG","script":null,"variant":null},{"id":"307","name":"French (Switzerland)","displayName":"Français (Suisse)","code":"fr_CH","primary":"fr","region":"CH","script":null,"variant":null},{"id":"308","name":"French (Cote d Ivoire)","displayName":"Français (Côte d’Ivoire)","code":"fr_CI","primary":"fr","region":"CI","script":null,"variant":null},{"id":"309","name":"French (Cameroon)","displayName":"Français (Cameroun)","code":"fr_CM","primary":"fr","region":"CM","script":null,"variant":null},{"id":"310","name":"French (Djibouti)","displayName":"Français (Djibouti)","code":"fr_DJ","primary":"fr","region":"DJ","script":null,"variant":null},{"id":"311","name":"French (Algeria)","displayName":"Français (Algérie)","code":"fr_DZ","primary":"fr","region":"DZ","script":null,"variant":null},{"id":"312","name":"French (France)","displayName":"Français (France)","code":"fr_FR","primary":"fr","region":"FR","script":null,"variant":null},{"id":"313","name":"French (Gabon)","displayName":"Français (Gabon)","code":"fr_GA","primary":"fr","region":"GA","script":null,"variant":null},{"id":"314","name":"French (French Guiana)","displayName":"Français (Guyane française)","code":"fr_GF","primary":"fr","region":"GF","script":null,"variant":null},{"id":"315","name":"French (Guinea)","displayName":"Français (Guinée)","code":"fr_GN","primary":"fr","region":"GN","script":null,"variant":null},{"id":"316","name":"French (Guadeloupe)","displayName":"Français (Guadeloupe)","code":"fr_GP","primary":"fr","region":"GP","script":null,"variant":null},{"id":"317","name":"French (Equatorial Guinea)","displayName":"Français (Guinée équatoriale)","code":"fr_GQ","primary":"fr","region":"GQ","script":null,"variant":null},{"id":"318","name":"French (Haiti)","displayName":"Français (Haïti)","code":"fr_HT","primary":"fr","region":"HT","script":null,"variant":null},{"id":"319","name":"French (Comoros)","displayName":"Français (Comores)","code":"fr_KM","primary":"fr","region":"KM","script":null,"variant":null},{"id":"320","name":"French (Luxembourg)","displayName":"Français (Luxembourg)","code":"fr_LU","primary":"fr","region":"LU","script":null,"variant":null},{"id":"321","name":"French (Morocco)","displayName":"Français (Maroc)","code":"fr_MA","primary":"fr","region":"MA","script":null,"variant":null},{"id":"322","name":"French (Monaco)","displayName":"Français (Monaco)","code":"fr_MC","primary":"fr","region":"MC","script":null,"variant":null},{"id":"323","name":"French (Saint Martin)","displayName":"Français (Saint-Martin)","code":"fr_MF","primary":"fr","region":"MF","script":null,"variant":null},{"id":"324","name":"French (Madagascar)","displayName":"Français (Madagascar)","code":"fr_MG","primary":"fr","region":"MG","script":null,"variant":null},{"id":"325","name":"French (Mali)","displayName":"Français (Mali)","code":"fr_ML","primary":"fr","region":"ML","script":null,"variant":null},{"id":"326","name":"French (Martinique)","displayName":"Français (Martinique)","code":"fr_MQ","primary":"fr","region":"MQ","script":null,"variant":null},{"id":"327","name":"French (Mauritania)","displayName":"Français (Mauritanie)","code":"fr_MR","primary":"fr","region":"MR","script":null,"variant":null},{"id":"328","name":"French (Mauritius)","displayName":"Français (Maurice)","code":"fr_MU","primary":"fr","region":"MU","script":null,"variant":null},{"id":"329","name":"French (New Caledonia)","displayName":"Français (Nouvelle-Calédonie)","code":"fr_NC","primary":"fr","region":"NC","script":null,"variant":null},{"id":"330","name":"French (Niger)","displayName":"Français (Niger)","code":"fr_NE","primary":"fr","region":"NE","script":null,"variant":null},{"id":"331","name":"French (French Polynesia)","displayName":"Français (Polynésie française)","code":"fr_PF","primary":"fr","region":"PF","script":null,"variant":null},{"id":"332","name":"French (Saint Pierre and Miquelon)","displayName":"Français (Saint-Pierre-et-Miquelon)","code":"fr_PM","primary":"fr","region":"PM","script":null,"variant":null},{"id":"333","name":"French (Réunion)","displayName":"Français (La Réunion)","code":"fr_RE","primary":"fr","region":"RE","script":null,"variant":null},{"id":"334","name":"French (Rwanda)","displayName":"Français (Rwanda)","code":"fr_RW","primary":"fr","region":"RW","script":null,"variant":null},{"id":"335","name":"French (Seychelles)","displayName":"Français (Seychelles)","code":"fr_SC","primary":"fr","region":"SC","script":null,"variant":null},{"id":"336","name":"French (Senegal)","displayName":"Français (Sénégal)","code":"fr_SN","primary":"fr","region":"SN","script":null,"variant":null},{"id":"337","name":"French (Syria)","displayName":"Français (Syrie)","code":"fr_SY","primary":"fr","region":"SY","script":null,"variant":null},{"id":"338","name":"French (Chad)","displayName":"Français (Tchad)","code":"fr_TD","primary":"fr","region":"TD","script":null,"variant":null},{"id":"339","name":"French (Togo)","displayName":"Français (Togo)","code":"fr_TG","primary":"fr","region":"TG","script":null,"variant":null},{"id":"340","name":"French (Tunisia)","displayName":"Français (Tunisie)","code":"fr_TN","primary":"fr","region":"TN","script":null,"variant":null},{"id":"341","name":"French (Vanuatu)","displayName":"Français (Vanuatu)","code":"fr_VU","primary":"fr","region":"VU","script":null,"variant":null},{"id":"342","name":"French (Wallis and Futuna)","displayName":"Français (Wallis-et-Futuna)","code":"fr_WF","primary":"fr","region":"WF","script":null,"variant":null},{"id":"343","name":"French (Mayotte)","displayName":"Français (Mayotte)","code":"fr_YT","primary":"fr","region":"YT","script":null,"variant":null},{"id":"344","name":"Irish (Ireland)","displayName":"Gaeilge (Éire)","code":"ga_IE","primary":"ga","region":"IE","script":null,"variant":null},{"id":"345","name":"Galician","displayName":"Galego","code":"gl","primary":"gl","region":null,"script":null,"variant":null},{"id":"346","name":"Galician (Spain)","displayName":"Galego (España)","code":"gl_ES","primary":"gl","region":"ES","script":null,"variant":null},{"id":"347","name":"Swiss German","displayName":"Schwiizertüütsch","code":"gsw","primary":"gsw","region":null,"script":null,"variant":null},{"id":"348","name":"Swiss German (Switzerland)","displayName":"Schwiizertüütsch (Schwiiz)","code":"gsw_CH","primary":"gsw","region":"CH","script":null,"variant":null},{"id":"349","name":"Swiss German (Liechtenstein)","displayName":"Schwiizertüütsch (Liächteschtäi)","code":"gsw_LI","primary":"gsw","region":"LI","script":null,"variant":null},{"id":"350","name":"Gujarati","displayName":"ગુજરાતી","code":"gu","primary":"gu","region":null,"script":null,"variant":null},{"id":"351","name":"Gujarati (India)","displayName":"ગુજરાતી (ભારત)","code":"gu_IN","primary":"gu","region":"IN","script":null,"variant":null},{"id":"352","name":"Gusii","displayName":"Ekegusii","code":"guz","primary":"guz","region":null,"script":null,"variant":null},{"id":"353","name":"Gusii (Kenya)","displayName":"Ekegusii (Kenya)","code":"guz_KE","primary":"guz","region":"KE","script":null,"variant":null},{"id":"354","name":"Manx","displayName":"Gaelg","code":"gv","primary":"gv","region":null,"script":null,"variant":null},{"id":"355","name":"Manx (Isle of Man)","displayName":"Gaelg (Ellan Vannin)","code":"gv_IM","primary":"gv","region":"IM","script":null,"variant":null},{"id":"356","name":"Hausa","displayName":"Hausa","code":"ha","primary":"ha","region":null,"script":null,"variant":null},{"id":"357","name":"Hawaiian","displayName":"ʻŌlelo HawaiʻI","code":"haw","primary":"haw","region":null,"script":null,"variant":null},{"id":"358","name":"Hawaiian (United States)","displayName":"ʻŌlelo HawaiʻI (ʻAmelika Hui Pū ʻIa)","code":"haw_US","primary":"haw","region":"US","script":null,"variant":null},{"id":"359","name":"Hebrew (Israel)","displayName":"עברית (ישראל)","code":"he_IL","primary":"he","region":"IL","script":null,"variant":null},{"id":"360","name":"Hindi (India)","displayName":"हिन्दी (भारत)","code":"hi_IN","primary":"hi","region":"IN","script":null,"variant":null},{"id":"361","name":"Croatian (Bosnia and Herzegovina)","displayName":"Hrvatski (Bosna i Hercegovina)","code":"hr_BA","primary":"hr","region":"BA","script":null,"variant":null},{"id":"362","name":"Croatian (Croatia)","displayName":"Hrvatski (Hrvatska)","code":"hr_HR","primary":"hr","region":"HR","script":null,"variant":null},{"id":"363","name":"Hungarian (Hungary)","displayName":"Magyar (Magyarország)","code":"hu_HU","primary":"hu","region":"HU","script":null,"variant":null},{"id":"364","name":"Armenian (Armenia)","displayName":"Հայերեն (Հայաստան)","code":"hy_AM","primary":"hy","region":"AM","script":null,"variant":null},{"id":"365","name":"Indonesian (Indonesia)","displayName":"Indonesia (Indonesia)","code":"id_ID","primary":"id","region":"ID","script":null,"variant":null},{"id":"366","name":"Igbo","displayName":"Igbo","code":"ig","primary":"ig","region":null,"script":null,"variant":null},{"id":"367","name":"Igbo (Nigeria)","displayName":"Igbo (Nigeria)","code":"ig_NG","primary":"ig","region":"NG","script":null,"variant":null},{"id":"368","name":"Sichuan Yi","displayName":"ꆈꌠꉙ","code":"ii","primary":"ii","region":null,"script":null,"variant":null},{"id":"369","name":"Sichuan Yi (China)","displayName":"ꆈꌠꉙ (ꍏꇩ)","code":"ii_CN","primary":"ii","region":"CN","script":null,"variant":null},{"id":"370","name":"Icelandic (Iceland)","displayName":"Íslenska (Ísland)","code":"is_IS","primary":"is","region":"IS","script":null,"variant":null},{"id":"371","name":"Italian (Switzerland)","displayName":"Italiano (Svizzera)","code":"it_CH","primary":"it","region":"CH","script":null,"variant":null},{"id":"372","name":"Italian (Italy)","displayName":"Italiano (Italia)","code":"it_IT","primary":"it","region":"IT","script":null,"variant":null},{"id":"373","name":"Italian (San Marino)","displayName":"Italiano (San Marino)","code":"it_SM","primary":"it","region":"SM","script":null,"variant":null},{"id":"374","name":"Japanese (Japan)","displayName":"日本語 (日本)","code":"ja_JP","primary":"ja","region":"JP","script":null,"variant":null},{"id":"375","name":"Ngomba","displayName":"Ndaꞌa","code":"jgo","primary":"jgo","region":null,"script":null,"variant":null},{"id":"376","name":"Ngomba (Cameroon)","displayName":"Ndaꞌa (Kamɛlûn)","code":"jgo_CM","primary":"jgo","region":"CM","script":null,"variant":null},{"id":"377","name":"Machame","displayName":"Kimachame","code":"jmc","primary":"jmc","region":null,"script":null,"variant":null},{"id":"378","name":"Machame (Tanzania)","displayName":"Kimachame (Tanzania)","code":"jmc_TZ","primary":"jmc","region":"TZ","script":null,"variant":null},{"id":"379","name":"Georgian (Georgia)","displayName":"Ქართული (საქართველო)","code":"ka_GE","primary":"ka","region":"GE","script":null,"variant":null},{"id":"380","name":"Kabyle","displayName":"Taqbaylit","code":"kab","primary":"kab","region":null,"script":null,"variant":null},{"id":"381","name":"Kabyle (Algeria)","displayName":"Taqbaylit (Lezzayer)","code":"kab_DZ","primary":"kab","region":"DZ","script":null,"variant":null},{"id":"382","name":"Kamba","displayName":"Kikamba","code":"kam","primary":"kam","region":null,"script":null,"variant":null},{"id":"383","name":"Kamba (Kenya)","displayName":"Kikamba (Kenya)","code":"kam_KE","primary":"kam","region":"KE","script":null,"variant":null},{"id":"384","name":"Makonde","displayName":"Chimakonde","code":"kde","primary":"kde","region":null,"script":null,"variant":null},{"id":"385","name":"Makonde (Tanzania)","displayName":"Chimakonde (Tanzania)","code":"kde_TZ","primary":"kde","region":"TZ","script":null,"variant":null},{"id":"386","name":"Kabuverdianu","displayName":"Kabuverdianu","code":"kea","primary":"kea","region":null,"script":null,"variant":null},{"id":"387","name":"Kabuverdianu (Cape Verde)","displayName":"Kabuverdianu (Kabu Verdi)","code":"kea_CV","primary":"kea","region":"CV","script":null,"variant":null},{"id":"388","name":"Koyra Chiini","displayName":"Koyra Ciini","code":"khq","primary":"khq","region":null,"script":null,"variant":null},{"id":"389","name":"Koyra Chiini (Mali)","displayName":"Koyra Ciini (Maali)","code":"khq_ML","primary":"khq","region":"ML","script":null,"variant":null},{"id":"390","name":"Kikuyu","displayName":"Gikuyu","code":"ki","primary":"ki","region":null,"script":null,"variant":null},{"id":"391","name":"Kikuyu (Kenya)","displayName":"Gikuyu (Kenya)","code":"ki_KE","primary":"ki","region":"KE","script":null,"variant":null},{"id":"392","name":"Kazakh","displayName":"Қазақ тілі","code":"kk","primary":"kk","region":null,"script":null,"variant":null},{"id":"393","name":"Kako","displayName":"Kakɔ","code":"kkj","primary":"kkj","region":null,"script":null,"variant":null},{"id":"394","name":"Kako (Cameroon)","displayName":"Kakɔ (Kamɛrun)","code":"kkj_CM","primary":"kkj","region":"CM","script":null,"variant":null},{"id":"395","name":"Kalaallisut","displayName":"Kalaallisut","code":"kl","primary":"kl","region":null,"script":null,"variant":null},{"id":"396","name":"Kalaallisut (Greenland)","displayName":"Kalaallisut (Kalaallit Nunaat)","code":"kl_GL","primary":"kl","region":"GL","script":null,"variant":null},{"id":"397","name":"Kalenjin","displayName":"Kalenjin","code":"kln","primary":"kln","region":null,"script":null,"variant":null},{"id":"398","name":"Kalenjin (Kenya)","displayName":"Kalenjin (Emetab Kenya)","code":"kln_KE","primary":"kln","region":"KE","script":null,"variant":null},{"id":"399","name":"Khmer","displayName":"ខ្មែរ","code":"km","primary":"km","region":null,"script":null,"variant":null},{"id":"400","name":"Khmer (Cambodia)","displayName":"ខ្មែរ (កម្ពុជា)","code":"km_KH","primary":"km","region":"KH","script":null,"variant":null},{"id":"401","name":"Kannada","displayName":"ಕನ್ನಡ","code":"kn","primary":"kn","region":null,"script":null,"variant":null},{"id":"402","name":"Kannada (India)","displayName":"ಕನ್ನಡ (ಭಾರತ)","code":"kn_IN","primary":"kn","region":"IN","script":null,"variant":null},{"id":"403","name":"Korean (North Korea)","displayName":"한국어 (조선민주주의인민공화국)","code":"ko_KP","primary":"ko","region":"KP","script":null,"variant":null},{"id":"404","name":"Korean (South Korea)","displayName":"한국어 (대한민국)","code":"ko_KR","primary":"ko","region":"KR","script":null,"variant":null},{"id":"405","name":"Konkani","displayName":"कोंकणी","code":"kok","primary":"kok","region":null,"script":null,"variant":null},{"id":"406","name":"Konkani (India)","displayName":"कोंकणी (भारत)","code":"kok_IN","primary":"kok","region":"IN","script":null,"variant":null},{"id":"407","name":"Kashmiri","displayName":"کٲشُر","code":"ks","primary":"ks","region":null,"script":null,"variant":null},{"id":"408","name":"Shambala","displayName":"Kishambaa","code":"ksb","primary":"ksb","region":null,"script":null,"variant":null},{"id":"409","name":"Shambala (Tanzania)","displayName":"Kishambaa (Tanzania)","code":"ksb_TZ","primary":"ksb","region":"TZ","script":null,"variant":null},{"id":"410","name":"Bafia","displayName":"Rikpa","code":"ksf","primary":"ksf","region":null,"script":null,"variant":null},{"id":"411","name":"Bafia (Cameroon)","displayName":"Rikpa (Kamɛrún)","code":"ksf_CM","primary":"ksf","region":"CM","script":null,"variant":null},{"id":"412","name":"Cornish","displayName":"Kernewek","code":"kw","primary":"kw","region":null,"script":null,"variant":null},{"id":"413","name":"Cornish (United Kingdom)","displayName":"Kernewek (Rywvaneth Unys)","code":"kw_GB","primary":"kw","region":"GB","script":null,"variant":null},{"id":"414","name":"Kyrgyz","displayName":"Кыргызча","code":"ky","primary":"ky","region":null,"script":null,"variant":null},{"id":"415","name":"Langi","displayName":"Kɨlaangi","code":"lag","primary":"lag","region":null,"script":null,"variant":null},{"id":"416","name":"Langi (Tanzania)","displayName":"Kɨlaangi (Taansanía)","code":"lag_TZ","primary":"lag","region":"TZ","script":null,"variant":null},{"id":"417","name":"Ganda","displayName":"Luganda","code":"lg","primary":"lg","region":null,"script":null,"variant":null},{"id":"418","name":"Ganda (Uganda)","displayName":"Luganda (Yuganda)","code":"lg_UG","primary":"lg","region":"UG","script":null,"variant":null},{"id":"419","name":"Lakota","displayName":"LakȟólʼIyapi","code":"lkt","primary":"lkt","region":null,"script":null,"variant":null},{"id":"420","name":"Lakota (United States)","displayName":"LakȟólʼIyapi (Mílahaŋska Tȟamákȟočhe)","code":"lkt_US","primary":"lkt","region":"US","script":null,"variant":null},{"id":"421","name":"Lingala","displayName":"Lingála","code":"ln","primary":"ln","region":null,"script":null,"variant":null},{"id":"422","name":"Lingala (Angola)","displayName":"Lingála (Angóla)","code":"ln_AO","primary":"ln","region":"AO","script":null,"variant":null},{"id":"423","name":"Lingala (Congo - Kinshasa)","displayName":"Lingála (Republíki ya Kongó Demokratíki)","code":"ln_CD","primary":"ln","region":"CD","script":null,"variant":null},{"id":"424","name":"Lingala (Central African Republic)","displayName":"Lingála (Repibiki ya Afríka ya Káti)","code":"ln_CF","primary":"ln","region":"CF","script":null,"variant":null},{"id":"425","name":"Lingala (Congo - Brazzaville)","displayName":"Lingála (Kongo)","code":"ln_CG","primary":"ln","region":"CG","script":null,"variant":null},{"id":"426","name":"Lao","displayName":"ລາວ","code":"lo","primary":"lo","region":null,"script":null,"variant":null},{"id":"427","name":"Lao (Laos)","displayName":"ລາວ (ລາວ)","code":"lo_LA","primary":"lo","region":"LA","script":null,"variant":null},{"id":"428","name":"Lithuanian (Lithuania)","displayName":"Lietuvių (Lietuva)","code":"lt_LT","primary":"lt","region":"LT","script":null,"variant":null},{"id":"429","name":"Luba-Katanga","displayName":"Tshiluba","code":"lu","primary":"lu","region":null,"script":null,"variant":null},{"id":"430","name":"Luba-Katanga (Congo - Kinshasa)","displayName":"Tshiluba (Ditunga wa Kongu)","code":"lu_CD","primary":"lu","region":"CD","script":null,"variant":null},{"id":"431","name":"Luo","displayName":"Dholuo","code":"luo","primary":"luo","region":null,"script":null,"variant":null},{"id":"432","name":"Luo (Kenya)","displayName":"Dholuo (Kenya)","code":"luo_KE","primary":"luo","region":"KE","script":null,"variant":null},{"id":"433","name":"Luyia","displayName":"Luluhia","code":"luy","primary":"luy","region":null,"script":null,"variant":null},{"id":"434","name":"Luyia (Kenya)","displayName":"Luluhia (Kenya)","code":"luy_KE","primary":"luy","region":"KE","script":null,"variant":null},{"id":"435","name":"Latvian (Latvia)","displayName":"Latviešu (Latvija)","code":"lv_LV","primary":"lv","region":"LV","script":null,"variant":null},{"id":"436","name":"Masai","displayName":"Maa","code":"mas","primary":"mas","region":null,"script":null,"variant":null},{"id":"437","name":"Masai (Kenya)","displayName":"Maa (Kenya)","code":"mas_KE","primary":"mas","region":"KE","script":null,"variant":null},{"id":"438","name":"Masai (Tanzania)","displayName":"Maa (Tansania)","code":"mas_TZ","primary":"mas","region":"TZ","script":null,"variant":null},{"id":"439","name":"Meru","displayName":"Kĩmĩrũ","code":"mer","primary":"mer","region":null,"script":null,"variant":null},{"id":"440","name":"Meru (Kenya)","displayName":"Kĩmĩrũ (Kenya)","code":"mer_KE","primary":"mer","region":"KE","script":null,"variant":null},{"id":"441","name":"Morisyen","displayName":"Kreol Morisien","code":"mfe","primary":"mfe","region":null,"script":null,"variant":null},{"id":"442","name":"Morisyen (Mauritius)","displayName":"Kreol Morisien (Moris)","code":"mfe_MU","primary":"mfe","region":"MU","script":null,"variant":null},{"id":"443","name":"Malagasy","displayName":"Malagasy","code":"mg","primary":"mg","region":null,"script":null,"variant":null},{"id":"444","name":"Malagasy (Madagascar)","displayName":"Malagasy (Madagasikara)","code":"mg_MG","primary":"mg","region":"MG","script":null,"variant":null},{"id":"445","name":"Makhuwa-Meetto","displayName":"Makua","code":"mgh","primary":"mgh","region":null,"script":null,"variant":null},{"id":"446","name":"Makhuwa-Meetto (Mozambique)","displayName":"Makua (Umozambiki)","code":"mgh_MZ","primary":"mgh","region":"MZ","script":null,"variant":null},{"id":"447","name":"Meta","displayName":"Metaʼ","code":"mgo","primary":"mgo","region":null,"script":null,"variant":null},{"id":"448","name":"Meta (Cameroon)","displayName":"Metaʼ (Kamalun)","code":"mgo_CM","primary":"mgo","region":"CM","script":null,"variant":null},{"id":"449","name":"Macedonian (Macedonia)","displayName":"Македонски (Македонија)","code":"mk_MK","primary":"mk","region":"MK","script":null,"variant":null},{"id":"450","name":"Malayalam (India)","displayName":"മലയാളം (ഇന്ത്യ)","code":"ml_IN","primary":"ml","region":"IN","script":null,"variant":null},{"id":"451","name":"Mongolian","displayName":"Монгол","code":"mn","primary":"mn","region":null,"script":null,"variant":null},{"id":"452","name":"Marathi","displayName":"मराठी","code":"mr","primary":"mr","region":null,"script":null,"variant":null},{"id":"453","name":"Marathi (India)","displayName":"मराठी (भारत)","code":"mr_IN","primary":"mr","region":"IN","script":null,"variant":null},{"id":"454","name":"Maltese","displayName":"Malti","code":"mt","primary":"mt","region":null,"script":null,"variant":null},{"id":"455","name":"Maltese (Malta)","displayName":"Malti (Malta)","code":"mt_MT","primary":"mt","region":"MT","script":null,"variant":null},{"id":"456","name":"Mundang","displayName":"Mundaŋ","code":"mua","primary":"mua","region":null,"script":null,"variant":null},{"id":"457","name":"Mundang (Cameroon)","displayName":"Mundaŋ (Kameruŋ)","code":"mua_CM","primary":"mua","region":"CM","script":null,"variant":null},{"id":"458","name":"Burmese","displayName":"မြန်မာ","code":"my","primary":"my","region":null,"script":null,"variant":null},{"id":"459","name":"Burmese (Myanmar [Burma])","displayName":"မြန်မာ (မြန်မာ)","code":"my_MM","primary":"my","region":"MM","script":null,"variant":null},{"id":"460","name":"Nama","displayName":"Khoekhoegowab","code":"naq","primary":"naq","region":null,"script":null,"variant":null},{"id":"461","name":"Nama (Namibia)","displayName":"Khoekhoegowab (Namibiab)","code":"naq_NA","primary":"naq","region":"NA","script":null,"variant":null},{"id":"462","name":"Norwegian Bokmål","displayName":"Norsk bokmål","code":"nb","primary":"nb","region":null,"script":null,"variant":null},{"id":"463","name":"Norwegian Bokmål (Norway)","displayName":"Norsk bokmål (Norge)","code":"nb_NO","primary":"nb","region":"NO","script":null,"variant":null},{"id":"464","name":"Norwegian Bokmål (Svalbard and Jan Mayen)","displayName":"Norsk bokmål (Svalbard og Jan Mayen)","code":"nb_SJ","primary":"nb","region":"SJ","script":null,"variant":null},{"id":"465","name":"North Ndebele","displayName":"IsiNdebele","code":"nd","primary":"nd","region":null,"script":null,"variant":null},{"id":"466","name":"North Ndebele (Zimbabwe)","displayName":"IsiNdebele (Zimbabwe)","code":"nd_ZW","primary":"nd","region":"ZW","script":null,"variant":null},{"id":"467","name":"Nepali","displayName":"नेपाली","code":"ne","primary":"ne","region":null,"script":null,"variant":null},{"id":"468","name":"Nepali (India)","displayName":"नेपाली (भारत)","code":"ne_IN","primary":"ne","region":"IN","script":null,"variant":null},{"id":"469","name":"Nepali (Nepal)","displayName":"नेपाली (नेपाल)","code":"ne_NP","primary":"ne","region":"NP","script":null,"variant":null},{"id":"470","name":"Dutch (Aruba)","displayName":"Nederlands (Aruba)","code":"nl_AW","primary":"nl","region":"AW","script":null,"variant":null},{"id":"471","name":"Dutch (Belgium)","displayName":"Nederlands (België)","code":"nl_BE","primary":"nl","region":"BE","script":null,"variant":null},{"id":"472","name":"Dutch (Caribbean Netherlands)","displayName":"Nederlands (Caribisch Nederland)","code":"nl_BQ","primary":"nl","region":"BQ","script":null,"variant":null},{"id":"473","name":"Dutch (Curaçao)","displayName":"Nederlands (Curaçao)","code":"nl_CW","primary":"nl","region":"CW","script":null,"variant":null},{"id":"474","name":"Dutch (Netherlands)","displayName":"Nederlands (Nederland)","code":"nl_NL","primary":"nl","region":"NL","script":null,"variant":null},{"id":"475","name":"Dutch (Suriname)","displayName":"Nederlands (Suriname)","code":"nl_SR","primary":"nl","region":"SR","script":null,"variant":null},{"id":"476","name":"Dutch (Sint Maarten)","displayName":"Nederlands (Sint-Maarten)","code":"nl_SX","primary":"nl","region":"SX","script":null,"variant":null},{"id":"477","name":"Kwasio","displayName":"Kwasio","code":"nmg","primary":"nmg","region":null,"script":null,"variant":null},{"id":"478","name":"Kwasio (Cameroon)","displayName":"Nmg (Kamerun)","code":"nmg_CM","primary":"nmg","region":"CM","script":null,"variant":null},{"id":"479","name":"Norwegian Nynorsk","displayName":"Nynorsk","code":"nn","primary":"nn","region":null,"script":null,"variant":null},{"id":"480","name":"Norwegian Nynorsk (Norway)","displayName":"Nynorsk (Norge)","code":"nn_NO","primary":"nn","region":"NO","script":null,"variant":null},{"id":"481","name":"Ngiemboon","displayName":"Shwóŋò Ngiembɔɔn","code":"nnh","primary":"nnh","region":null,"script":null,"variant":null},{"id":"482","name":"Ngiemboon (Cameroon)","displayName":"Shwóŋò Ngiembɔɔn (Kàmalûm)","code":"nnh_CM","primary":"nnh","region":"CM","script":null,"variant":null},{"id":"483","name":"Nuer","displayName":"Thok Nath","code":"nus","primary":"nus","region":null,"script":null,"variant":null},{"id":"484","name":"Nyankole","displayName":"Runyankore","code":"nyn","primary":"nyn","region":null,"script":null,"variant":null},{"id":"485","name":"Nyankole (Uganda)","displayName":"Runyankore (Uganda)","code":"nyn_UG","primary":"nyn","region":"UG","script":null,"variant":null},{"id":"486","name":"Oromo","displayName":"Oromoo","code":"om","primary":"om","region":null,"script":null,"variant":null},{"id":"487","name":"Oromo (Ethiopia)","displayName":"Oromoo (Itoophiyaa)","code":"om_ET","primary":"om","region":"ET","script":null,"variant":null},{"id":"488","name":"Oromo (Kenya)","displayName":"Oromoo (Keeniyaa)","code":"om_KE","primary":"om","region":"KE","script":null,"variant":null},{"id":"489","name":"Oriya","displayName":"ଓଡ଼ିଆ","code":"or","primary":"or","region":null,"script":null,"variant":null},{"id":"490","name":"Oriya (India)","displayName":"ଓଡ଼ିଆ (ଭାରତ)","code":"or_IN","primary":"or","region":"IN","script":null,"variant":null},{"id":"491","name":"Punjabi (Arabic)","displayName":"پنجابی (عربی)","code":"pa_Arab","primary":"pa","region":null,"script":"Arab","variant":null},{"id":"492","name":"Punjabi (Arabic, Pakistan)","displayName":"ਪੰਜਾਬੀ (ਅਰਬੀ, ਪਾਕਿਸਤਾਨ)","code":"pa_Arab_PK","primary":"pa","region":"PK","script":"Arab","variant":null},{"id":"493","name":"Punjabi (Gurmukhi)","displayName":"ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ)","code":"pa_Guru","primary":"pa","region":null,"script":"Guru","variant":null},{"id":"494","name":"Punjabi (Gurmukhi, India)","displayName":"ਪੰਜਾਬੀ (ਗੁਰਮੁਖੀ, ਭਾਰਤ)","code":"pa_Guru_IN","primary":"pa","region":"IN","script":"Guru","variant":null},{"id":"495","name":"Polish (Poland)","displayName":"Polski (Polska)","code":"pl_PL","primary":"pl","region":"PL","script":null,"variant":null},{"id":"496","name":"Pashto","displayName":"پښتو","code":"ps","primary":"ps","region":null,"script":null,"variant":null},{"id":"497","name":"Pashto (Afghanistan)","displayName":"پښتو (افغانستان)","code":"ps_AF","primary":"ps","region":"AF","script":null,"variant":null},{"id":"498","name":"Portuguese (Angola)","displayName":"Português (Angola)","code":"pt_AO","primary":"pt","region":"AO","script":null,"variant":null},{"id":"499","name":"Portuguese (Cape Verde)","displayName":"Português (Cabo Verde)","code":"pt_CV","primary":"pt","region":"CV","script":null,"variant":null},{"id":"500","name":"Portuguese (Guinea-Bissau)","displayName":"Português (Guiné-Bissau)","code":"pt_GW","primary":"pt","region":"GW","script":null,"variant":null},{"id":"501","name":"Portuguese (Macau SAR China)","displayName":"Português (Macau, RAE da China)","code":"pt_MO","primary":"pt","region":"MO","script":null,"variant":null},{"id":"502","name":"Portuguese (Mozambique)","displayName":"Português (Moçambique)","code":"pt_MZ","primary":"pt","region":"MZ","script":null,"variant":null},{"id":"503","name":"Portuguese (Portugal)","displayName":"Português (Portugal)","code":"pt_PT","primary":"pt","region":"PT","script":null,"variant":null},{"id":"504","name":"Portuguese (São Tomé & Príncipe)","displayName":"Português (São Tomé e Príncipe)","code":"pt_ST","primary":"pt","region":"ST","script":null,"variant":null},{"id":"505","name":"Portuguese (Timor-Leste)","displayName":"Português (Timor-Leste)","code":"pt_TL","primary":"pt","region":"TL","script":null,"variant":null},{"id":"506","name":"Romansh","displayName":"Rumantsch","code":"rm","primary":"rm","region":null,"script":null,"variant":null},{"id":"507","name":"Romansh (Switzerland)","displayName":"Rumantsch (Svizra)","code":"rm_CH","primary":"rm","region":"CH","script":null,"variant":null},{"id":"508","name":"Rundi","displayName":"Ikirundi","code":"rn","primary":"rn","region":null,"script":null,"variant":null},{"id":"509","name":"Rundi (Burundi)","displayName":"Ikirundi (Uburundi)","code":"rn_BI","primary":"rn","region":"BI","script":null,"variant":null},{"id":"510","name":"Romanian (Moldova)","displayName":"Română (Republica Moldova)","code":"ro_MD","primary":"ro","region":"MD","script":null,"variant":null},{"id":"511","name":"Romanian (Romania)","displayName":"Română (România)","code":"ro_RO","primary":"ro","region":"RO","script":null,"variant":null},{"id":"512","name":"Rombo","displayName":"Kihorombo","code":"rof","primary":"rof","region":null,"script":null,"variant":null},{"id":"513","name":"Rombo (Tanzania)","displayName":"Kihorombo (Tanzania)","code":"rof_TZ","primary":"rof","region":"TZ","script":null,"variant":null},{"id":"514","name":"Russian (Belarus)","displayName":"Русский (Беларусь)","code":"ru_BY","primary":"ru","region":"BY","script":null,"variant":null},{"id":"515","name":"Russian (Kyrgyzstan)","displayName":"Русский (Киргизия)","code":"ru_KG","primary":"ru","region":"KG","script":null,"variant":null},{"id":"516","name":"Russian (Kazakhstan)","displayName":"Русский (Казахстан)","code":"ru_KZ","primary":"ru","region":"KZ","script":null,"variant":null},{"id":"517","name":"Russian (Moldova)","displayName":"Русский (Молдова)","code":"ru_MD","primary":"ru","region":"MD","script":null,"variant":null},{"id":"518","name":"Russian (Russia)","displayName":"Русский (Россия)","code":"ru_RU","primary":"ru","region":"RU","script":null,"variant":null},{"id":"519","name":"Russian (Ukraine)","displayName":"Русский (Украина)","code":"ru_UA","primary":"ru","region":"UA","script":null,"variant":null},{"id":"520","name":"Kinyarwanda","displayName":"Kinyarwanda","code":"rw","primary":"rw","region":null,"script":null,"variant":null},{"id":"521","name":"Kinyarwanda (Rwanda)","displayName":"Kinyarwanda (Rwanda)","code":"rw_RW","primary":"rw","region":"RW","script":null,"variant":null},{"id":"522","name":"Rwa","displayName":"Kiruwa","code":"rwk","primary":"rwk","region":null,"script":null,"variant":null},{"id":"523","name":"Rwa (Tanzania)","displayName":"Kiruwa (Tanzania)","code":"rwk_TZ","primary":"rwk","region":"TZ","script":null,"variant":null},{"id":"524","name":"Samburu","displayName":"Kisampur","code":"saq","primary":"saq","region":null,"script":null,"variant":null},{"id":"525","name":"Samburu (Kenya)","displayName":"Kisampur (Kenya)","code":"saq_KE","primary":"saq","region":"KE","script":null,"variant":null},{"id":"526","name":"Sangu","displayName":"Ishisangu","code":"sbp","primary":"sbp","region":null,"script":null,"variant":null},{"id":"527","name":"Sangu (Tanzania)","displayName":"Ishisangu (Tansaniya)","code":"sbp_TZ","primary":"sbp","region":"TZ","script":null,"variant":null},{"id":"528","name":"Sena","displayName":"Sena","code":"seh","primary":"seh","region":null,"script":null,"variant":null},{"id":"529","name":"Sena (Mozambique)","displayName":"Sena (Moçambique)","code":"seh_MZ","primary":"seh","region":"MZ","script":null,"variant":null},{"id":"530","name":"Koyraboro Senni","displayName":"Koyraboro Senni","code":"ses","primary":"ses","region":null,"script":null,"variant":null},{"id":"531","name":"Koyraboro Senni (Mali)","displayName":"Koyraboro Senni (Maali)","code":"ses_ML","primary":"ses","region":"ML","script":null,"variant":null},{"id":"532","name":"Sango","displayName":"Sängö","code":"sg","primary":"sg","region":null,"script":null,"variant":null},{"id":"533","name":"Sango (Central African Republic)","displayName":"Sängö (Ködörösêse tî Bêafrîka)","code":"sg_CF","primary":"sg","region":"CF","script":null,"variant":null},{"id":"534","name":"Tachelhit","displayName":"ⵜⴰⵛⵍⵃⵉⵜ","code":"shi","primary":"shi","region":null,"script":null,"variant":null},{"id":"535","name":"Tachelhit (Latin)","displayName":"Tashelḥiyt (Latn)","code":"shi_Latn","primary":"shi","region":null,"script":"Latn","variant":null},{"id":"536","name":"Tachelhit (Latin, Morocco)","displayName":"Tashelḥiyt (Latn, Lmɣrib)","code":"shi_Latn_MA","primary":"shi","region":"MA","script":"Latn","variant":null},{"id":"537","name":"Tachelhit (Tifinagh)","displayName":"ⵜⴰⵛⵍⵃⵉⵜ (Tfng)","code":"shi_Tfng","primary":"shi","region":null,"script":"Tfng","variant":null},{"id":"538","name":"Tachelhit (Tifinagh, Morocco)","displayName":"ⵜⴰⵛⵍⵃⵉⵜ (Tfng, ⵍⵎⵖⵔⵉⴱ)","code":"shi_Tfng_MA","primary":"shi","region":"MA","script":"Tfng","variant":null},{"id":"539","name":"Sinhala","displayName":"සිංහල","code":"si","primary":"si","region":null,"script":null,"variant":null},{"id":"540","name":"Sinhala (Sri Lanka)","displayName":"සිංහල (ශ්‍රී ලංකාව)","code":"si_LK","primary":"si","region":"LK","script":null,"variant":null},{"id":"541","name":"Slovak (Slovakia)","displayName":"Slovenčina (Slovensko)","code":"sk_SK","primary":"sk","region":"SK","script":null,"variant":null},{"id":"542","name":"Slovenian (Slovenia)","displayName":"Slovenščina (Slovenija)","code":"sl_SI","primary":"sl","region":"SI","script":null,"variant":null},{"id":"543","name":"Shona","displayName":"ChiShona","code":"sn","primary":"sn","region":null,"script":null,"variant":null},{"id":"544","name":"Shona (Zimbabwe)","displayName":"ChiShona (Zimbabwe)","code":"sn_ZW","primary":"sn","region":"ZW","script":null,"variant":null},{"id":"545","name":"Somali","displayName":"Soomaali","code":"so","primary":"so","region":null,"script":null,"variant":null},{"id":"546","name":"Somali (Djibouti)","displayName":"Soomaali (Jabuuti)","code":"so_DJ","primary":"so","region":"DJ","script":null,"variant":null},{"id":"547","name":"Somali (Ethiopia)","displayName":"Soomaali (Itoobiya)","code":"so_ET","primary":"so","region":"ET","script":null,"variant":null},{"id":"548","name":"Somali (Kenya)","displayName":"Soomaali (Kiiniya)","code":"so_KE","primary":"so","region":"KE","script":null,"variant":null},{"id":"549","name":"Somali (Somalia)","displayName":"Soomaali (Soomaaliya)","code":"so_SO","primary":"so","region":"SO","script":null,"variant":null},{"id":"550","name":"Albanian (Albania)","displayName":"Shqip (Shqipëri)","code":"sq_AL","primary":"sq","region":"AL","script":null,"variant":null},{"id":"551","name":"Albanian (Macedonia)","displayName":"Shqip (Maqedoni)","code":"sq_MK","primary":"sq","region":"MK","script":null,"variant":null},{"id":"552","name":"Albanian (Kosovo)","displayName":"Shqip (Kosovë)","code":"sq_XK","primary":"sq","region":"XK","script":null,"variant":null},{"id":"553","name":"Serbian (Cyrillic)","displayName":"Српски (ћирилица)","code":"sr_Cyrl","primary":"sr","region":null,"script":"Cyrl","variant":null},{"id":"554","name":"Serbian (Cyrillic, Bosnia and Herzegovina)","displayName":"Српски (ћирилица, Босна и Херцеговина)","code":"sr_Cyrl_BA","primary":"sr","region":"BA","script":"Cyrl","variant":null},{"id":"555","name":"Serbian (Cyrillic, Montenegro)","displayName":"Српски (ћирилица, Црна Гора)","code":"sr_Cyrl_ME","primary":"sr","region":"ME","script":"Cyrl","variant":null},{"id":"556","name":"Serbian (Cyrillic, Serbia)","displayName":"Српски (ћирилица, Србија)","code":"sr_Cyrl_RS","primary":"sr","region":"RS","script":"Cyrl","variant":null},{"id":"557","name":"Serbian (Cyrillic, Kosovo)","displayName":"Српски (ћирилица, Косово)","code":"sr_Cyrl_XK","primary":"sr","region":"XK","script":"Cyrl","variant":null},{"id":"558","name":"Serbian (Latin)","displayName":"Srpski (latinica)","code":"sr_Latn","primary":"sr","region":null,"script":"Latn","variant":null},{"id":"559","name":"Serbian (Latin, Bosnia and Herzegovina)","displayName":"Српски (латиница, Босна и Херцеговина)","code":"sr_Latn_BA","primary":"sr","region":"BA","script":"Latn","variant":null},{"id":"560","name":"Serbian (Latin, Montenegro)","displayName":"Српски (латиница, Црна Гора)","code":"sr_Latn_ME","primary":"sr","region":"ME","script":"Latn","variant":null},{"id":"561","name":"Serbian (Latin, Serbia)","displayName":"Српски (латиница, Србија)","code":"sr_Latn_RS","primary":"sr","region":"RS","script":"Latn","variant":null},{"id":"562","name":"Serbian (Latin, Kosovo)","displayName":"Српски (латиница, Косово)","code":"sr_Latn_XK","primary":"sr","region":"XK","script":"Latn","variant":null},{"id":"563","name":"Swedish (Åland Islands)","displayName":"Svenska (Åland)","code":"sv_AX","primary":"sv","region":"AX","script":null,"variant":null},{"id":"564","name":"Swedish (Finland)","displayName":"Svenska (Finland)","code":"sv_FI","primary":"sv","region":"FI","script":null,"variant":null},{"id":"565","name":"Swedish (Sweden)","displayName":"Svenska (Sverige)","code":"sv_SE","primary":"sv","region":"SE","script":null,"variant":null},{"id":"566","name":"Swahili (Kenya)","displayName":"Kiswahili (Kenya)","code":"sw_KE","primary":"sw","region":"KE","script":null,"variant":null},{"id":"567","name":"Swahili (Tanzania)","displayName":"Kiswahili (Tanzania)","code":"sw_TZ","primary":"sw","region":"TZ","script":null,"variant":null},{"id":"568","name":"Swahili (Uganda)","displayName":"Kiswahili (Uganda)","code":"sw_UG","primary":"sw","region":"UG","script":null,"variant":null},{"id":"569","name":"Tamil (India)","displayName":"தமிழ் (இந்தியா)","code":"ta_IN","primary":"ta","region":"IN","script":null,"variant":null},{"id":"570","name":"Tamil (Sri Lanka)","displayName":"தமிழ் (இலங்கை)","code":"ta_LK","primary":"ta","region":"LK","script":null,"variant":null},{"id":"571","name":"Tamil (Malaysia)","displayName":"தமிழ் (மலேசியா)","code":"ta_MY","primary":"ta","region":"MY","script":null,"variant":null},{"id":"572","name":"Tamil (Singapore)","displayName":"தமிழ் (சிங்கப்பூர்)","code":"ta_SG","primary":"ta","region":"SG","script":null,"variant":null},{"id":"573","name":"Telugu (India)","displayName":"తెలుగు (భారత దేశం)","code":"te_IN","primary":"te","region":"IN","script":null,"variant":null},{"id":"574","name":"Teso","displayName":"Kiteso","code":"teo","primary":"teo","region":null,"script":null,"variant":null},{"id":"575","name":"Teso (Kenya)","displayName":"Kiteso (Kenia)","code":"teo_KE","primary":"teo","region":"KE","script":null,"variant":null},{"id":"576","name":"Teso (Uganda)","displayName":"Kiteso (Uganda)","code":"teo_UG","primary":"teo","region":"UG","script":null,"variant":null},{"id":"577","name":"Thai (Thailand)","displayName":"ไทย (ไทย)","code":"th_TH","primary":"th","region":"TH","script":null,"variant":null},{"id":"578","name":"Tigrinya","displayName":"ትግርኛ","code":"ti","primary":"ti","region":null,"script":null,"variant":null},{"id":"579","name":"Tigrinya (Eritrea)","displayName":"ትግርኛ (ኢትዮጵያ)","code":"ti_ER","primary":"ti","region":"ER","script":null,"variant":null},{"id":"580","name":"Tigrinya (Ethiopia)","displayName":"ትግርኛ (ኤርትራ)","code":"ti_ET","primary":"ti","region":"ET","script":null,"variant":null},{"id":"581","name":"Tongan","displayName":"Lea fakatonga","code":"to","primary":"to","region":null,"script":null,"variant":null},{"id":"582","name":"Tongan (Tonga)","displayName":"Lea fakatonga (Tonga)","code":"to_TO","primary":"to","region":"TO","script":null,"variant":null},{"id":"583","name":"Turkish (Cyprus)","displayName":"Türkçe (Kıbrıs)","code":"tr_CY","primary":"tr","region":"CY","script":null,"variant":null},{"id":"584","name":"Turkish (Turkey)","displayName":"Türkçe (Türkiye)","code":"tr_TR","primary":"tr","region":"TR","script":null,"variant":null},{"id":"585","name":"Tasawaq","displayName":"Tasawaq Senni","code":"twq","primary":"twq","region":null,"script":null,"variant":null},{"id":"586","name":"Tasawaq (Niger)","displayName":"Tasawaq Senni (Nižer)","code":"twq_NE","primary":"twq","region":"NE","script":null,"variant":null},{"id":"587","name":"Central Atlas Tamazight","displayName":"Tamaziɣt N Laṭlaṣ","code":"tzm","primary":"tzm","region":null,"script":null,"variant":null},{"id":"588","name":"Ukrainian (Ukraine)","displayName":"Українська (Україна)","code":"uk_UA","primary":"uk","region":"UA","script":null,"variant":null},{"id":"589","name":"Urdu","displayName":"اردو","code":"ur","primary":"ur","region":null,"script":null,"variant":null},{"id":"590","name":"Urdu (India)","displayName":"اردو (بھارت)","code":"ur_IN","primary":"ur","region":"IN","script":null,"variant":null},{"id":"591","name":"Urdu (Pakistan)","displayName":"اردو (پاکستان)","code":"ur_PK","primary":"ur","region":"PK","script":null,"variant":null},{"id":"592","name":"Uzbek","displayName":"O‘zbek","code":"uz","primary":"uz","region":null,"script":null,"variant":null},{"id":"593","name":"Uzbek (Arabic)","displayName":"اوزبیک (عربی)","code":"uz_Arab","primary":"uz","region":null,"script":"Arab","variant":null},{"id":"594","name":"Uzbek (Arabic, Afghanistan)","displayName":"O‘zbek (arab, Afgʻoniston)","code":"uz_Arab_AF","primary":"uz","region":"AF","script":"Arab","variant":null},{"id":"595","name":"Uzbek (Cyrillic)","displayName":"Ўзбекча (Кирил)","code":"uz_Cyrl","primary":"uz","region":null,"script":"Cyrl","variant":null},{"id":"596","name":"Uzbek (Cyrillic, Uzbekistan)","displayName":"O‘zbek (kirill, Oʻzbekiston)","code":"uz_Cyrl_UZ","primary":"uz","region":"UZ","script":"Cyrl","variant":null},{"id":"597","name":"Uzbek (Latin)","displayName":"O‘zbek (lotin)","code":"uz_Latn","primary":"uz","region":null,"script":"Latn","variant":null},{"id":"598","name":"Uzbek (Latin, Uzbekistan)","displayName":"O‘zbek (lotin, Oʻzbekiston)","code":"uz_Latn_UZ","primary":"uz","region":"UZ","script":"Latn","variant":null},{"id":"599","name":"Vai","displayName":"ꕙꔤ","code":"vai","primary":"vai","region":null,"script":null,"variant":null},{"id":"600","name":"Vai (Latin)","displayName":"Vai (Latn)","code":"vai_Latn","primary":"vai","region":null,"script":"Latn","variant":null},{"id":"601","name":"Vai (Latin, Liberia)","displayName":"Vai (Latn, Laibhiya)","code":"vai_Latn_LR","primary":"vai","region":"LR","script":"Latn","variant":null},{"id":"602","name":"Vai (Vai)","displayName":"ꕙꔤ (Vaii)","code":"vai_Vaii","primary":"vai","region":null,"script":"Vaii","variant":null},{"id":"603","name":"Vai (Vai, Liberia)","displayName":"ꕙꔤ (Vaii, ꕞꔤꔫꕩ)","code":"vai_Vaii_LR","primary":"vai","region":"LR","script":"Vaii","variant":null},{"id":"604","name":"Vietnamese (Vietnam)","displayName":"Tiếng Việt (Việt Nam)","code":"vi_VN","primary":"vi","region":"VN","script":null,"variant":null},{"id":"605","name":"Vunjo","displayName":"Kyivunjo","code":"vun","primary":"vun","region":null,"script":null,"variant":null},{"id":"606","name":"Vunjo (Tanzania)","displayName":"Kyivunjo (Tanzania)","code":"vun_TZ","primary":"vun","region":"TZ","script":null,"variant":null},{"id":"607","name":"Soga","displayName":"Olusoga","code":"xog","primary":"xog","region":null,"script":null,"variant":null},{"id":"608","name":"Soga (Uganda)","displayName":"Olusoga (Yuganda)","code":"xog_UG","primary":"xog","region":"UG","script":null,"variant":null},{"id":"609","name":"Yangben","displayName":"Nuasue","code":"yav","primary":"yav","region":null,"script":null,"variant":null},{"id":"610","name":"Yangben (Cameroon)","displayName":"Nuasue (Kemelún)","code":"yav_CM","primary":"yav","region":"CM","script":null,"variant":null},{"id":"611","name":"Yiddish","displayName":"ייִדיש","code":"yi","primary":"yi","region":null,"script":null,"variant":null},{"id":"612","name":"Yoruba","displayName":"Èdè Yorùbá","code":"yo","primary":"yo","region":null,"script":null,"variant":null},{"id":"613","name":"Yoruba (Benin)","displayName":"Èdè Yorùbá (Orílɛ́ède Bɛ̀nɛ̀)","code":"yo_BJ","primary":"yo","region":"BJ","script":null,"variant":null},{"id":"614","name":"Yoruba (Nigeria)","displayName":"Èdè Yorùbá (Orílẹ́ède Nàìjíríà)","code":"yo_NG","primary":"yo","region":"NG","script":null,"variant":null},{"id":"615","name":"Standard Moroccan Tamazight","displayName":"ⵜⴰⵎⴰⵣⵉⵖⵜ","code":"zgh","primary":"zgh","region":null,"script":null,"variant":null},{"id":"616","name":"Standard Moroccan Tamazight (Morocco)","displayName":"ⵜⴰⵎⴰⵣⵉⵖⵜ (ⵍⵎⵖⵔⵉⴱ)","code":"zgh_MA","primary":"zgh","region":"MA","script":null,"variant":null},{"id":"617","name":"Chinese (Simplified, China)","displayName":"中文 (简体, 中国)","code":"zh_Hans_CN","primary":"zh","region":"CN","script":"Hans","variant":null},{"id":"618","name":"Chinese (Simplified, Hong Kong SAR China)","displayName":"中文 (简体, 中国香港特别行政区)","code":"zh_Hans_HK","primary":"zh","region":"HK","script":"Hans","variant":null},{"id":"619","name":"Chinese (Simplified, Macau SAR China)","displayName":"中文 (简体, 中国澳门特别行政区)","code":"zh_Hans_MO","primary":"zh","region":"MO","script":"Hans","variant":null},{"id":"620","name":"Chinese (Simplified, Singapore)","displayName":"中文 (简体, 新加坡)","code":"zh_Hans_SG","primary":"zh","region":"SG","script":"Hans","variant":null},{"id":"621","name":"Chinese (Traditional)","displayName":"中文 (繁體)","code":"zh_Hant","primary":"zh","region":null,"script":"Hant","variant":null},{"id":"622","name":"Chinese (Traditional, Hong Kong SAR China)","displayName":"中文 (繁體字, 中國香港特別行政區)","code":"zh_Hant_HK","primary":"zh","region":"HK","script":"Hant","variant":null},{"id":"623","name":"Chinese (Traditional, Macau SAR China)","displayName":"中文 (繁体, 中国澳门特别行政区)","code":"zh_Hant_MO","primary":"zh","region":"MO","script":"Hant","variant":null},{"id":"624","name":"Chinese (Traditional, Taiwan)","displayName":"中文 (繁体, 台湾)","code":"zh_Hant_TW","primary":"zh","region":"TW","script":"Hant","variant":null},{"id":"625","name":"Zulu","displayName":"IsiZulu","code":"zu","primary":"zu","region":null,"script":null,"variant":null},{"id":"626","name":"Zulu (South Africa)","displayName":"IsiZulu (i-South Africa)","code":"zu_ZA","primary":"zu","region":"ZA","script":null,"variant":null},{"id":"627","name":"Afrikaans","displayName":"Afrikaans","code":"af","primary":"af","region":null,"script":null,"variant":null},{"id":"628","name":"Nyanja","displayName":"Nyanja","code":"ny","primary":"ny","region":null,"script":null,"variant":null}]');

/***/ }),

/***/ 7012:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"tld":"com","defaultLanguage":"en","supportedLanguages":["en","es","pt-br","de","nl","fr","ru","it","da","sv","ja","ko","zh-tw","tr","no","fi"],"enabled":true},{"tld":"net","defaultLanguage":"en","supportedLanguages":["en","es","pt-br","de","nl","fr","ru","it","da","sv","ja","ko","zh-tw","tr","no","fi"],"enabled":true},{"tld":"at","defaultLanguage":"de","supportedLanguages":["de"],"enabled":false},{"tld":"be","defaultLanguage":"nl","supportedLanguages":["nl","fr"],"enabled":false},{"tld":"ca","defaultLanguage":"en","supportedLanguages":["en","fr"],"enabled":false},{"tld":"ch","defaultLanguage":"de","supportedLanguages":["de","fr","it"],"enabled":true},{"tld":"cl","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"co.cr","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"co.id","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"co.in","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"co.jp","defaultLanguage":"ja","supportedLanguages":["ja"],"enabled":false},{"tld":"co.ke","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"co.kr","defaultLanguage":"ko","supportedLanguages":["ko"],"enabled":false},{"tld":"co.nz","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"co.uk","defaultLanguage":"en","supportedLanguages":["en"],"enabled":true},{"tld":"co.ve","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"co.za","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"com.ar","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.au","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"com.bo","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.br","defaultLanguage":"pt-br","supportedLanguages":["pt-br"],"enabled":false},{"tld":"com.co","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.cy","defaultLanguage":"en","supportedLanguages":["en","tr"],"enabled":false},{"tld":"com.do","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.ec","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.gt","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.hk","defaultLanguage":"zh-tw","supportedLanguages":["zh-tw"],"enabled":false},{"tld":"com.jm","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"com.mx","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.my","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"com.ng","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"com.pa","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.pe","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.ph","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"com.py","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.sg","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"com.sv","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"com.tr","defaultLanguage":"tr","supportedLanguages":["tr"],"enabled":false},{"tld":"com.tw","defaultLanguage":"zh-tw","supportedLanguages":["zh-tw"],"enabled":false},{"tld":"com.uy","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"cz","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"de","defaultLanguage":"de","supportedLanguages":["de"],"enabled":true},{"tld":"dk","defaultLanguage":"da","supportedLanguages":["da","de"],"enabled":false},{"tld":"ee","defaultLanguage":"ru","supportedLanguages":["ru"],"enabled":false},{"tld":"es","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"fi","defaultLanguage":"fi","supportedLanguages":["fi"],"enabled":false},{"tld":"fr","defaultLanguage":"fr","supportedLanguages":["fr"],"enabled":false},{"tld":"gr","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"hn","defaultLanguage":"es","supportedLanguages":["es"],"enabled":false},{"tld":"hu","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"ie","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"is","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"it","defaultLanguage":"it","supportedLanguages":["it"],"enabled":false},{"tld":"kz","defaultLanguage":"ru","supportedLanguages":["ru"],"enabled":false},{"tld":"nl","defaultLanguage":"nl","supportedLanguages":["nl"],"enabled":false},{"tld":"no","defaultLanguage":"no","supportedLanguages":["no"],"enabled":false},{"tld":"pl","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"pt","defaultLanguage":"pt-br","supportedLanguages":["pt-br"],"enabled":false},{"tld":"ro","defaultLanguage":"en","supportedLanguages":["en"],"enabled":false},{"tld":"ru","defaultLanguage":"ru","supportedLanguages":["ru"],"enabled":true},{"tld":"se","defaultLanguage":"sv","supportedLanguages":["sv"],"enabled":false}]');

/***/ }),

/***/ 2942:
/***/ (function(module) {

"use strict";
module.exports = "ac>com,edu,gov,net,mil,org<ad>nom<ae>co,net,org,sch,ac,gov,mil<aero>accident-investigation,accident-prevention,aerobatic,aeroclub,aerodrome,agents,aircraft,airline,airport,air-surveillance,airtraffic,air-traffic-control,ambulance,amusement,association,author,ballooning,broker,caa,cargo,catering,certification,championship,charter,civilaviation,club,conference,consultant,consulting,control,council,crew,design,dgca,educator,emergency,engine,engineer,entertainment,equipment,exchange,express,federation,flight,fuel,gliding,government,groundhandling,group,hanggliding,homebuilt,insurance,journal,journalist,leasing,logistics,magazine,maintenance,media,microlight,modelling,navigation,parachuting,paragliding,passenger-association,pilot,press,production,recreation,repbody,res,research,rotorcraft,safety,scientist,services,show,skydiving,software,student,trader,trading,trainer,union,workinggroup,works<af>gov,com,org,net,edu<ag>com,org,net,co,nom<ai>off,com,net,org<al>com,edu,gov,mil,net,org<am>co,com,commune,net,org<ao>ed,gv,og,co,pb,it<aq,ar>com,edu,gob,gov,int,mil,musica,net,org,tur<arpa>e164,in-addr,ip6,iris,uri,urn<as>gov<asia,at>ac>sth<co,gv,or<au>com,net,org,edu>act,catholic,nsw>schools<nt,qld,sa,tas,vic,wa<gov>qld,sa,tas,vic,wa<asn,id,info,conf,oz,act,nsw,nt,qld,sa,tas,vic,wa<aw>com<ax,az>com,net,int,gov,org,edu,info,pp,mil,name,pro,biz<ba>com,edu,gov,mil,net,org<bb>biz,co,com,edu,gov,info,net,org,store,tv<bd>*<be>ac<bf>gov<bg>a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,0,1,2,3,4,5,6,7,8,9<bh>com,edu,net,org,gov<bi>co,com,edu,or,org<biz,bj>asso,barreau,gouv<bm>com,edu,gov,net,org<bn>com,edu,gov,net,org<bo>com,edu,gob,int,org,net,mil,tv,web,academia,agro,arte,blog,bolivia,ciencia,cooperativa,democracia,deporte,ecologia,economia,empresa,indigena,industria,info,medicina,movimiento,musica,natural,nombre,noticias,patria,politica,profesional,plurinacional,pueblo,revista,salud,tecnologia,tksat,transporte,wiki<br>9guacu,abc,adm,adv,agr,aju,am,anani,aparecida,app,arq,art,ato,b,barueri,belem,bhz,bib,bio,blog,bmd,boavista,bsb,campinagrande,campinas,caxias,cim,cng,cnt,com,contagem,coop,coz,cri,cuiaba,curitiba,def,des,det,dev,ecn,eco,edu,emp,enf,eng,esp,etc,eti,far,feira,flog,floripa,fm,fnd,fortal,fot,foz,fst,g12,geo,ggf,goiania,gov>ac,al,am,ap,ba,ce,df,es,go,ma,mg,ms,mt,pa,pb,pe,pi,pr,rj,rn,ro,rr,rs,sc,se,sp,to<gru,imb,ind,inf,jab,jampa,jdf,joinville,jor,jus,leg,lel,log,londrina,macapa,maceio,manaus,maringa,mat,med,mil,morena,mp,mus,natal,net,niteroi,nom>*<not,ntr,odo,ong,org,osasco,palmas,poa,ppg,pro,psc,psi,pvh,qsl,radio,rec,recife,rep,ribeirao,rio,riobranco,riopreto,salvador,sampa,santamaria,santoandre,saobernardo,saogonca,seg,sjc,slg,slz,sorocaba,srv,taxi,tc,tec,teo,the,tmp,trd,tur,tv,udi,vet,vix,vlog,wiki,zlg<bs>com,net,org,edu,gov<bt>com,edu,gov,net,org<bv,bw>co,org<by>gov,mil,com,of<bz>com,net,org,edu,gov<ca>ab,bc,mb,nb,nf,nl,ns,nt,nu,on,pe,qc,sk,yk,gc<cat,cc,cd>gov<cf,cg,ch,ci>org,or,com,co,edu,ed,ac,net,go,asso,xn--aroport-bya,int,presse,md,gouv<ck>*,!www<cl>co,gob,gov,mil<cm>co,com,gov,net<cn>ac,com,edu,gov,net,org,mil,xn--55qx5d,xn--io0a7i,xn--od0alg,ah,bj,cq,fj,gd,gs,gz,gx,ha,hb,he,hi,hl,hn,jl,js,jx,ln,nm,nx,qh,sc,sd,sh,sn,sx,tj,xj,xz,yn,zj,hk,mo,tw<co>arts,com,edu,firm,gov,info,int,mil,net,nom,org,rec,web<com,coop,cr>ac,co,ed,fi,go,or,sa<cu>com,edu,org,net,gov,inf<cv,cw>com,edu,net,org<cx>gov<cy>ac,biz,com,ekloges,gov,ltd,name,net,org,parliament,press,pro,tm<cz,de,dj,dk,dm>com,net,org,edu,gov<do>art,com,edu,gob,gov,mil,net,org,sld,web<dz>art,asso,com,edu,gov,org,net,pol,soc,tm<ec>com,info,net,fin,k12,med,pro,org,edu,gov,gob,mil<edu,ee>edu,gov,riik,lib,med,com,pri,aip,org,fie<eg>com,edu,eun,gov,mil,name,net,org,sci<er>*<es>com,nom,org,gob,edu<et>com,gov,org,edu,biz,name,info,net<eu,fi>aland<fj>ac,biz,com,gov,info,mil,name,net,org,pro<fk>*<fm>com,edu,net,org<fo,fr>asso,com,gouv,nom,prd,tm,aeroport,avocat,avoues,cci,chambagri,chirurgiens-dentistes,experts-comptables,geometre-expert,greta,huissier-justice,medecin,notaires,pharmacien,port,veterinaire<ga,gb,gd>edu,gov<ge>com,edu,gov,org,mil,net,pvt<gf,gg>co,net,org<gh>com,edu,gov,org,mil<gi>com,ltd,gov,mod,edu,org<gl>co,com,edu,net,org<gm,gn>ac,com,edu,gov,org,net<gov,gp>com,net,mobi,edu,org,asso<gq,gr>com,edu,net,org,gov<gs,gt>com,edu,gob,ind,mil,net,org<gu>com,edu,gov,guam,info,net,org,web<gw,gy>co,com,edu,gov,net,org<hk>com,edu,gov,idv,net,org,xn--55qx5d,xn--wcvs22d,xn--lcvr32d,xn--mxtq1m,xn--gmqw5a,xn--ciqpn,xn--gmq050i,xn--zf0avx,xn--io0a7i,xn--mk0axi,xn--od0alg,xn--od0aq3b,xn--tn0ag,xn--uc0atv,xn--uc0ay4a<hm,hn>com,edu,org,net,mil,gob<hr>iz,from,name,com<ht>com,shop,firm,info,adult,net,pro,org,med,art,coop,pol,asso,edu,rel,gouv,perso<hu>co,info,org,priv,sport,tm,2000,agrar,bolt,casino,city,erotica,erotika,film,forum,games,hotel,ingatlan,jogasz,konyvelo,lakas,media,news,reklam,sex,shop,suli,szex,tozsde,utazas,video<id>ac,biz,co,desa,go,mil,my,net,or,ponpes,sch,web<ie>gov<il>ac,co,gov,idf,k12,muni,net,org<im>ac,co>ltd,plc<com,net,org,tt,tv<in>co,firm,net,org,gen,ind,nic,ac,edu,res,gov,mil<info,int>eu<io>com<iq>gov,edu,mil,com,org,net<ir>ac,co,gov,id,net,org,sch,xn--mgba3a4f16a,xn--mgba3a4fra<is>net,com,edu,gov,org,int<it>gov,edu,abr,abruzzo,aosta-valley,aostavalley,bas,basilicata,cal,calabria,cam,campania,emilia-romagna,emiliaromagna,emr,friuli-v-giulia,friuli-ve-giulia,friuli-vegiulia,friuli-venezia-giulia,friuli-veneziagiulia,friuli-vgiulia,friuliv-giulia,friulive-giulia,friulivegiulia,friulivenezia-giulia,friuliveneziagiulia,friulivgiulia,fvg,laz,lazio,lig,liguria,lom,lombardia,lombardy,lucania,mar,marche,mol,molise,piedmont,piemonte,pmn,pug,puglia,sar,sardegna,sardinia,sic,sicilia,sicily,taa,tos,toscana,trentin-sud-tirol,xn--trentin-sd-tirol-rzb,trentin-sudtirol,xn--trentin-sdtirol-7vb,trentin-sued-tirol,trentin-suedtirol,trentino-a-adige,trentino-aadige,trentino-alto-adige,trentino-altoadige,trentino-s-tirol,trentino-stirol,trentino-sud-tirol,xn--trentino-sd-tirol-c3b,trentino-sudtirol,xn--trentino-sdtirol-szb,trentino-sued-tirol,trentino-suedtirol,trentino,trentinoa-adige,trentinoaadige,trentinoalto-adige,trentinoaltoadige,trentinos-tirol,trentinostirol,trentinosud-tirol,xn--trentinosd-tirol-rzb,trentinosudtirol,xn--trentinosdtirol-7vb,trentinosued-tirol,trentinosuedtirol,trentinsud-tirol,xn--trentinsd-tirol-6vb,trentinsudtirol,xn--trentinsdtirol-nsb,trentinsued-tirol,trentinsuedtirol,tuscany,umb,umbria,val-d-aosta,val-daosta,vald-aosta,valdaosta,valle-aosta,valle-d-aosta,valle-daosta,valleaosta,valled-aosta,valledaosta,vallee-aoste,xn--valle-aoste-ebb,vallee-d-aoste,xn--valle-d-aoste-ehb,valleeaoste,xn--valleaoste-e7a,valleedaoste,xn--valledaoste-ebb,vao,vda,ven,veneto,ag,agrigento,al,alessandria,alto-adige,altoadige,an,ancona,andria-barletta-trani,andria-trani-barletta,andriabarlettatrani,andriatranibarletta,ao,aosta,aoste,ap,aq,aquila,ar,arezzo,ascoli-piceno,ascolipiceno,asti,at,av,avellino,ba,balsan-sudtirol,xn--balsan-sdtirol-nsb,balsan-suedtirol,balsan,bari,barletta-trani-andria,barlettatraniandria,belluno,benevento,bergamo,bg,bi,biella,bl,bn,bo,bologna,bolzano-altoadige,bolzano,bozen-sudtirol,xn--bozen-sdtirol-2ob,bozen-suedtirol,bozen,br,brescia,brindisi,bs,bt,bulsan-sudtirol,xn--bulsan-sdtirol-nsb,bulsan-suedtirol,bulsan,bz,ca,cagliari,caltanissetta,campidano-medio,campidanomedio,campobasso,carbonia-iglesias,carboniaiglesias,carrara-massa,carraramassa,caserta,catania,catanzaro,cb,ce,cesena-forli,xn--cesena-forl-mcb,cesenaforli,xn--cesenaforl-i8a,ch,chieti,ci,cl,cn,co,como,cosenza,cr,cremona,crotone,cs,ct,cuneo,cz,dell-ogliastra,dellogliastra,en,enna,fc,fe,fermo,ferrara,fg,fi,firenze,florence,fm,foggia,forli-cesena,xn--forl-cesena-fcb,forlicesena,xn--forlcesena-c8a,fr,frosinone,ge,genoa,genova,go,gorizia,gr,grosseto,iglesias-carbonia,iglesiascarbonia,im,imperia,is,isernia,kr,la-spezia,laquila,laspezia,latina,lc,le,lecce,lecco,li,livorno,lo,lodi,lt,lu,lucca,macerata,mantova,massa-carrara,massacarrara,matera,mb,mc,me,medio-campidano,mediocampidano,messina,mi,milan,milano,mn,mo,modena,monza-brianza,monza-e-della-brianza,monza,monzabrianza,monzaebrianza,monzaedellabrianza,ms,mt,na,naples,napoli,no,novara,nu,nuoro,og,ogliastra,olbia-tempio,olbiatempio,or,oristano,ot,pa,padova,padua,palermo,parma,pavia,pc,pd,pe,perugia,pesaro-urbino,pesarourbino,pescara,pg,pi,piacenza,pisa,pistoia,pn,po,pordenone,potenza,pr,prato,pt,pu,pv,pz,ra,ragusa,ravenna,rc,re,reggio-calabria,reggio-emilia,reggiocalabria,reggioemilia,rg,ri,rieti,rimini,rm,rn,ro,roma,rome,rovigo,sa,salerno,sassari,savona,si,siena,siracusa,so,sondrio,sp,sr,ss,suedtirol,xn--sdtirol-n2a,sv,ta,taranto,te,tempio-olbia,tempioolbia,teramo,terni,tn,to,torino,tp,tr,trani-andria-barletta,trani-barletta-andria,traniandriabarletta,tranibarlettaandria,trapani,trento,treviso,trieste,ts,turin,tv,ud,udine,urbino-pesaro,urbinopesaro,va,varese,vb,vc,ve,venezia,venice,verbania,vercelli,verona,vi,vibo-valentia,vibovalentia,vicenza,viterbo,vr,vs,vt,vv<je>co,net,org<jm>*<jo>com,org,net,edu,sch,gov,mil,name<jobs,jp>ac,ad,co,ed,go,gr,lg,ne,or,aichi>aisai,ama,anjo,asuke,chiryu,chita,fuso,gamagori,handa,hazu,hekinan,higashiura,ichinomiya,inazawa,inuyama,isshiki,iwakura,kanie,kariya,kasugai,kira,kiyosu,komaki,konan,kota,mihama,miyoshi,nishio,nisshin,obu,oguchi,oharu,okazaki,owariasahi,seto,shikatsu,shinshiro,shitara,tahara,takahama,tobishima,toei,togo,tokai,tokoname,toyoake,toyohashi,toyokawa,toyone,toyota,tsushima,yatomi<akita>akita,daisen,fujisato,gojome,hachirogata,happou,higashinaruse,honjo,honjyo,ikawa,kamikoani,kamioka,katagami,kazuno,kitaakita,kosaka,kyowa,misato,mitane,moriyoshi,nikaho,noshiro,odate,oga,ogata,semboku,yokote,yurihonjo<aomori>aomori,gonohe,hachinohe,hashikami,hiranai,hirosaki,itayanagi,kuroishi,misawa,mutsu,nakadomari,noheji,oirase,owani,rokunohe,sannohe,shichinohe,shingo,takko,towada,tsugaru,tsuruta<chiba>abiko,asahi,chonan,chosei,choshi,chuo,funabashi,futtsu,hanamigawa,ichihara,ichikawa,ichinomiya,inzai,isumi,kamagaya,kamogawa,kashiwa,katori,katsuura,kimitsu,kisarazu,kozaki,kujukuri,kyonan,matsudo,midori,mihama,minamiboso,mobara,mutsuzawa,nagara,nagareyama,narashino,narita,noda,oamishirasato,omigawa,onjuku,otaki,sakae,sakura,shimofusa,shirako,shiroi,shisui,sodegaura,sosa,tako,tateyama,togane,tohnosho,tomisato,urayasu,yachimata,yachiyo,yokaichiba,yokoshibahikari,yotsukaido<ehime>ainan,honai,ikata,imabari,iyo,kamijima,kihoku,kumakogen,masaki,matsuno,matsuyama,namikata,niihama,ozu,saijo,seiyo,shikokuchuo,tobe,toon,uchiko,uwajima,yawatahama<fukui>echizen,eiheiji,fukui,ikeda,katsuyama,mihama,minamiechizen,obama,ohi,ono,sabae,sakai,takahama,tsuruga,wakasa<fukuoka>ashiya,buzen,chikugo,chikuho,chikujo,chikushino,chikuzen,chuo,dazaifu,fukuchi,hakata,higashi,hirokawa,hisayama,iizuka,inatsuki,kaho,kasuga,kasuya,kawara,keisen,koga,kurate,kurogi,kurume,minami,miyako,miyama,miyawaka,mizumaki,munakata,nakagawa,nakama,nishi,nogata,ogori,okagaki,okawa,oki,omuta,onga,onojo,oto,saigawa,sasaguri,shingu,shinyoshitomi,shonai,soeda,sue,tachiarai,tagawa,takata,toho,toyotsu,tsuiki,ukiha,umi,usui,yamada,yame,yanagawa,yukuhashi<fukushima>aizubange,aizumisato,aizuwakamatsu,asakawa,bandai,date,fukushima,furudono,futaba,hanawa,higashi,hirata,hirono,iitate,inawashiro,ishikawa,iwaki,izumizaki,kagamiishi,kaneyama,kawamata,kitakata,kitashiobara,koori,koriyama,kunimi,miharu,mishima,namie,nango,nishiaizu,nishigo,okuma,omotego,ono,otama,samegawa,shimogo,shirakawa,showa,soma,sukagawa,taishin,tamakawa,tanagura,tenei,yabuki,yamato,yamatsuri,yanaizu,yugawa<gifu>anpachi,ena,gifu,ginan,godo,gujo,hashima,hichiso,hida,higashishirakawa,ibigawa,ikeda,kakamigahara,kani,kasahara,kasamatsu,kawaue,kitagata,mino,minokamo,mitake,mizunami,motosu,nakatsugawa,ogaki,sakahogi,seki,sekigahara,shirakawa,tajimi,takayama,tarui,toki,tomika,wanouchi,yamagata,yaotsu,yoro<gunma>annaka,chiyoda,fujioka,higashiagatsuma,isesaki,itakura,kanna,kanra,katashina,kawaba,kiryu,kusatsu,maebashi,meiwa,midori,minakami,naganohara,nakanojo,nanmoku,numata,oizumi,ora,ota,shibukawa,shimonita,shinto,showa,takasaki,takayama,tamamura,tatebayashi,tomioka,tsukiyono,tsumagoi,ueno,yoshioka<hiroshima>asaminami,daiwa,etajima,fuchu,fukuyama,hatsukaichi,higashihiroshima,hongo,jinsekikogen,kaita,kui,kumano,kure,mihara,miyoshi,naka,onomichi,osakikamijima,otake,saka,sera,seranishi,shinichi,shobara,takehara<hokkaido>abashiri,abira,aibetsu,akabira,akkeshi,asahikawa,ashibetsu,ashoro,assabu,atsuma,bibai,biei,bifuka,bihoro,biratori,chippubetsu,chitose,date,ebetsu,embetsu,eniwa,erimo,esan,esashi,fukagawa,fukushima,furano,furubira,haboro,hakodate,hamatonbetsu,hidaka,higashikagura,higashikawa,hiroo,hokuryu,hokuto,honbetsu,horokanai,horonobe,ikeda,imakane,ishikari,iwamizawa,iwanai,kamifurano,kamikawa,kamishihoro,kamisunagawa,kamoenai,kayabe,kembuchi,kikonai,kimobetsu,kitahiroshima,kitami,kiyosato,koshimizu,kunneppu,kuriyama,kuromatsunai,kushiro,kutchan,kyowa,mashike,matsumae,mikasa,minamifurano,mombetsu,moseushi,mukawa,muroran,naie,nakagawa,nakasatsunai,nakatombetsu,nanae,nanporo,nayoro,nemuro,niikappu,niki,nishiokoppe,noboribetsu,numata,obihiro,obira,oketo,okoppe,otaru,otobe,otofuke,otoineppu,oumu,ozora,pippu,rankoshi,rebun,rikubetsu,rishiri,rishirifuji,saroma,sarufutsu,shakotan,shari,shibecha,shibetsu,shikabe,shikaoi,shimamaki,shimizu,shimokawa,shinshinotsu,shintoku,shiranuka,shiraoi,shiriuchi,sobetsu,sunagawa,taiki,takasu,takikawa,takinoue,teshikaga,tobetsu,tohma,tomakomai,tomari,toya,toyako,toyotomi,toyoura,tsubetsu,tsukigata,urakawa,urausu,uryu,utashinai,wakkanai,wassamu,yakumo,yoichi<hyogo>aioi,akashi,ako,amagasaki,aogaki,asago,ashiya,awaji,fukusaki,goshiki,harima,himeji,ichikawa,inagawa,itami,kakogawa,kamigori,kamikawa,kasai,kasuga,kawanishi,miki,minamiawaji,nishinomiya,nishiwaki,ono,sanda,sannan,sasayama,sayo,shingu,shinonsen,shiso,sumoto,taishi,taka,takarazuka,takasago,takino,tamba,tatsuno,toyooka,yabu,yashiro,yoka,yokawa<ibaraki>ami,asahi,bando,chikusei,daigo,fujishiro,hitachi,hitachinaka,hitachiomiya,hitachiota,ibaraki,ina,inashiki,itako,iwama,joso,kamisu,kasama,kashima,kasumigaura,koga,miho,mito,moriya,naka,namegata,oarai,ogawa,omitama,ryugasaki,sakai,sakuragawa,shimodate,shimotsuma,shirosato,sowa,suifu,takahagi,tamatsukuri,tokai,tomobe,tone,toride,tsuchiura,tsukuba,uchihara,ushiku,yachiyo,yamagata,yawara,yuki<ishikawa>anamizu,hakui,hakusan,kaga,kahoku,kanazawa,kawakita,komatsu,nakanoto,nanao,nomi,nonoichi,noto,shika,suzu,tsubata,tsurugi,uchinada,wajima<iwate>fudai,fujisawa,hanamaki,hiraizumi,hirono,ichinohe,ichinoseki,iwaizumi,iwate,joboji,kamaishi,kanegasaki,karumai,kawai,kitakami,kuji,kunohe,kuzumaki,miyako,mizusawa,morioka,ninohe,noda,ofunato,oshu,otsuchi,rikuzentakata,shiwa,shizukuishi,sumita,tanohata,tono,yahaba,yamada<kagawa>ayagawa,higashikagawa,kanonji,kotohira,manno,marugame,mitoyo,naoshima,sanuki,tadotsu,takamatsu,tonosho,uchinomi,utazu,zentsuji<kagoshima>akune,amami,hioki,isa,isen,izumi,kagoshima,kanoya,kawanabe,kinko,kouyama,makurazaki,matsumoto,minamitane,nakatane,nishinoomote,satsumasendai,soo,tarumizu,yusui<kanagawa>aikawa,atsugi,ayase,chigasaki,ebina,fujisawa,hadano,hakone,hiratsuka,isehara,kaisei,kamakura,kiyokawa,matsuda,minamiashigara,miura,nakai,ninomiya,odawara,oi,oiso,sagamihara,samukawa,tsukui,yamakita,yamato,yokosuka,yugawara,zama,zushi<kochi>aki,geisei,hidaka,higashitsuno,ino,kagami,kami,kitagawa,kochi,mihara,motoyama,muroto,nahari,nakamura,nankoku,nishitosa,niyodogawa,ochi,okawa,otoyo,otsuki,sakawa,sukumo,susaki,tosa,tosashimizu,toyo,tsuno,umaji,yasuda,yusuhara<kumamoto>amakusa,arao,aso,choyo,gyokuto,kamiamakusa,kikuchi,kumamoto,mashiki,mifune,minamata,minamioguni,nagasu,nishihara,oguni,ozu,sumoto,takamori,uki,uto,yamaga,yamato,yatsushiro<kyoto>ayabe,fukuchiyama,higashiyama,ide,ine,joyo,kameoka,kamo,kita,kizu,kumiyama,kyotamba,kyotanabe,kyotango,maizuru,minami,minamiyamashiro,miyazu,muko,nagaokakyo,nakagyo,nantan,oyamazaki,sakyo,seika,tanabe,uji,ujitawara,wazuka,yamashina,yawata<mie>asahi,inabe,ise,kameyama,kawagoe,kiho,kisosaki,kiwa,komono,kumano,kuwana,matsusaka,meiwa,mihama,minamiise,misugi,miyama,nabari,shima,suzuka,tado,taiki,taki,tamaki,toba,tsu,udono,ureshino,watarai,yokkaichi<miyagi>furukawa,higashimatsushima,ishinomaki,iwanuma,kakuda,kami,kawasaki,marumori,matsushima,minamisanriku,misato,murata,natori,ogawara,ohira,onagawa,osaki,rifu,semine,shibata,shichikashuku,shikama,shiogama,shiroishi,tagajo,taiwa,tome,tomiya,wakuya,watari,yamamoto,zao<miyazaki>aya,ebino,gokase,hyuga,kadogawa,kawaminami,kijo,kitagawa,kitakata,kitaura,kobayashi,kunitomi,kushima,mimata,miyakonojo,miyazaki,morotsuka,nichinan,nishimera,nobeoka,saito,shiiba,shintomi,takaharu,takanabe,takazaki,tsuno<nagano>achi,agematsu,anan,aoki,asahi,azumino,chikuhoku,chikuma,chino,fujimi,hakuba,hara,hiraya,iida,iijima,iiyama,iizuna,ikeda,ikusaka,ina,karuizawa,kawakami,kiso,kisofukushima,kitaaiki,komagane,komoro,matsukawa,matsumoto,miasa,minamiaiki,minamimaki,minamiminowa,minowa,miyada,miyota,mochizuki,nagano,nagawa,nagiso,nakagawa,nakano,nozawaonsen,obuse,ogawa,okaya,omachi,omi,ookuwa,ooshika,otaki,otari,sakae,sakaki,saku,sakuho,shimosuwa,shinanomachi,shiojiri,suwa,suzaka,takagi,takamori,takayama,tateshina,tatsuno,togakushi,togura,tomi,ueda,wada,yamagata,yamanouchi,yasaka,yasuoka<nagasaki>chijiwa,futsu,goto,hasami,hirado,iki,isahaya,kawatana,kuchinotsu,matsuura,nagasaki,obama,omura,oseto,saikai,sasebo,seihi,shimabara,shinkamigoto,togitsu,tsushima,unzen<nara>ando,gose,heguri,higashiyoshino,ikaruga,ikoma,kamikitayama,kanmaki,kashiba,kashihara,katsuragi,kawai,kawakami,kawanishi,koryo,kurotaki,mitsue,miyake,nara,nosegawa,oji,ouda,oyodo,sakurai,sango,shimoichi,shimokitayama,shinjo,soni,takatori,tawaramoto,tenkawa,tenri,uda,yamatokoriyama,yamatotakada,yamazoe,yoshino<niigata>aga,agano,gosen,itoigawa,izumozaki,joetsu,kamo,kariwa,kashiwazaki,minamiuonuma,mitsuke,muika,murakami,myoko,nagaoka,niigata,ojiya,omi,sado,sanjo,seiro,seirou,sekikawa,shibata,tagami,tainai,tochio,tokamachi,tsubame,tsunan,uonuma,yahiko,yoita,yuzawa<oita>beppu,bungoono,bungotakada,hasama,hiji,himeshima,hita,kamitsue,kokonoe,kuju,kunisaki,kusu,oita,saiki,taketa,tsukumi,usa,usuki,yufu<okayama>akaiwa,asakuchi,bizen,hayashima,ibara,kagamino,kasaoka,kibichuo,kumenan,kurashiki,maniwa,misaki,nagi,niimi,nishiawakura,okayama,satosho,setouchi,shinjo,shoo,soja,takahashi,tamano,tsuyama,wake,yakage<okinawa>aguni,ginowan,ginoza,gushikami,haebaru,higashi,hirara,iheya,ishigaki,ishikawa,itoman,izena,kadena,kin,kitadaito,kitanakagusuku,kumejima,kunigami,minamidaito,motobu,nago,naha,nakagusuku,nakijin,nanjo,nishihara,ogimi,okinawa,onna,shimoji,taketomi,tarama,tokashiki,tomigusuku,tonaki,urasoe,uruma,yaese,yomitan,yonabaru,yonaguni,zamami<osaka>abeno,chihayaakasaka,chuo,daito,fujiidera,habikino,hannan,higashiosaka,higashisumiyoshi,higashiyodogawa,hirakata,ibaraki,ikeda,izumi,izumiotsu,izumisano,kadoma,kaizuka,kanan,kashiwara,katano,kawachinagano,kishiwada,kita,kumatori,matsubara,minato,minoh,misaki,moriguchi,neyagawa,nishi,nose,osakasayama,sakai,sayama,sennan,settsu,shijonawate,shimamoto,suita,tadaoka,taishi,tajiri,takaishi,takatsuki,tondabayashi,toyonaka,toyono,yao<saga>ariake,arita,fukudomi,genkai,hamatama,hizen,imari,kamimine,kanzaki,karatsu,kashima,kitagata,kitahata,kiyama,kouhoku,kyuragi,nishiarita,ogi,omachi,ouchi,saga,shiroishi,taku,tara,tosu,yoshinogari<saitama>arakawa,asaka,chichibu,fujimi,fujimino,fukaya,hanno,hanyu,hasuda,hatogaya,hatoyama,hidaka,higashichichibu,higashimatsuyama,honjo,ina,iruma,iwatsuki,kamiizumi,kamikawa,kamisato,kasukabe,kawagoe,kawaguchi,kawajima,kazo,kitamoto,koshigaya,kounosu,kuki,kumagaya,matsubushi,minano,misato,miyashiro,miyoshi,moroyama,nagatoro,namegawa,niiza,ogano,ogawa,ogose,okegawa,omiya,otaki,ranzan,ryokami,saitama,sakado,satte,sayama,shiki,shiraoka,soka,sugito,toda,tokigawa,tokorozawa,tsurugashima,urawa,warabi,yashio,yokoze,yono,yorii,yoshida,yoshikawa,yoshimi<shiga>aisho,gamo,higashiomi,hikone,koka,konan,kosei,koto,kusatsu,maibara,moriyama,nagahama,nishiazai,notogawa,omihachiman,otsu,ritto,ryuoh,takashima,takatsuki,torahime,toyosato,yasu<shimane>akagi,ama,gotsu,hamada,higashiizumo,hikawa,hikimi,izumo,kakinoki,masuda,matsue,misato,nishinoshima,ohda,okinoshima,okuizumo,shimane,tamayu,tsuwano,unnan,yakumo,yasugi,yatsuka<shizuoka>arai,atami,fuji,fujieda,fujikawa,fujinomiya,fukuroi,gotemba,haibara,hamamatsu,higashiizu,ito,iwata,izu,izunokuni,kakegawa,kannami,kawanehon,kawazu,kikugawa,kosai,makinohara,matsuzaki,minamiizu,mishima,morimachi,nishiizu,numazu,omaezaki,shimada,shimizu,shimoda,shizuoka,susono,yaizu,yoshida<tochigi>ashikaga,bato,haga,ichikai,iwafune,kaminokawa,kanuma,karasuyama,kuroiso,mashiko,mibu,moka,motegi,nasu,nasushiobara,nikko,nishikata,nogi,ohira,ohtawara,oyama,sakura,sano,shimotsuke,shioya,takanezawa,tochigi,tsuga,ujiie,utsunomiya,yaita<tokushima>aizumi,anan,ichiba,itano,kainan,komatsushima,matsushige,mima,minami,miyoshi,mugi,nakagawa,naruto,sanagochi,shishikui,tokushima,wajiki<tokyo>adachi,akiruno,akishima,aogashima,arakawa,bunkyo,chiyoda,chofu,chuo,edogawa,fuchu,fussa,hachijo,hachioji,hamura,higashikurume,higashimurayama,higashiyamato,hino,hinode,hinohara,inagi,itabashi,katsushika,kita,kiyose,kodaira,koganei,kokubunji,komae,koto,kouzushima,kunitachi,machida,meguro,minato,mitaka,mizuho,musashimurayama,musashino,nakano,nerima,ogasawara,okutama,ome,oshima,ota,setagaya,shibuya,shinagawa,shinjuku,suginami,sumida,tachikawa,taito,tama,toshima<tottori>chizu,hino,kawahara,koge,kotoura,misasa,nanbu,nichinan,sakaiminato,tottori,wakasa,yazu,yonago<toyama>asahi,fuchu,fukumitsu,funahashi,himi,imizu,inami,johana,kamiichi,kurobe,nakaniikawa,namerikawa,nanto,nyuzen,oyabe,taira,takaoka,tateyama,toga,tonami,toyama,unazuki,uozu,yamada<wakayama>arida,aridagawa,gobo,hashimoto,hidaka,hirogawa,inami,iwade,kainan,kamitonda,katsuragi,kimino,kinokawa,kitayama,koya,koza,kozagawa,kudoyama,kushimoto,mihama,misato,nachikatsuura,shingu,shirahama,taiji,tanabe,wakayama,yuasa,yura<yamagata>asahi,funagata,higashine,iide,kahoku,kaminoyama,kaneyama,kawanishi,mamurogawa,mikawa,murayama,nagai,nakayama,nanyo,nishikawa,obanazawa,oe,oguni,ohkura,oishida,sagae,sakata,sakegawa,shinjo,shirataka,shonai,takahata,tendo,tozawa,tsuruoka,yamagata,yamanobe,yonezawa,yuza<yamaguchi>abu,hagi,hikari,hofu,iwakuni,kudamatsu,mitou,nagato,oshima,shimonoseki,shunan,tabuse,tokuyama,toyota,ube,yuu<yamanashi>chuo,doshi,fuefuki,fujikawa,fujikawaguchiko,fujiyoshida,hayakawa,hokuto,ichikawamisato,kai,kofu,koshu,kosuge,minami-alps,minobu,nakamichi,nanbu,narusawa,nirasaki,nishikatsura,oshino,otsuki,showa,tabayama,tsuru,uenohara,yamanakako,yamanashi<xn--4pvxs,xn--vgu402c,xn--c3s14m,xn--f6qx53a,xn--8pvr4u,xn--uist22h,xn--djrs72d6uy,xn--mkru45i,xn--0trq7p7nn,xn--8ltr62k,xn--2m4a15e,xn--efvn9s,xn--32vp30h,xn--4it797k,xn--1lqs71d,xn--5rtp49c,xn--5js045d,xn--ehqz56n,xn--1lqs03n,xn--qqqt11m,xn--kbrq7o,xn--pssu33l,xn--ntsq17g,xn--uisz3g,xn--6btw5a,xn--1ctwo,xn--6orx2r,xn--rht61e,xn--rht27z,xn--djty4k,xn--nit225k,xn--rht3d,xn--klty5x,xn--kltx9a,xn--kltp7d,xn--uuwu58a,xn--zbx025d,xn--ntso0iqx3a,xn--elqq16h,xn--4it168d,xn--klt787d,xn--rny31h,xn--7t0a264c,xn--5rtq34k,xn--k7yn95e,xn--tor131o,xn--d5qv7z876c,kawasaki>*,!city<kitakyushu>*,!city<kobe>*,!city<nagoya>*,!city<sapporo>*,!city<sendai>*,!city<yokohama>*,!city<<ke>ac,co,go,info,me,mobi,ne,or,sc<kg>org,net,com,edu,gov,mil<kh>*<ki>edu,biz,net,org,gov,info,com<km>org,nom,gov,prd,tm,edu,mil,ass,com,coop,asso,presse,medecin,notaires,pharmaciens,veterinaire,gouv<kn>net,org,edu,gov<kp>com,edu,gov,org,rep,tra<kr>ac,co,es,go,hs,kg,mil,ms,ne,or,pe,re,sc,busan,chungbuk,chungnam,daegu,daejeon,gangwon,gwangju,gyeongbuk,gyeonggi,gyeongnam,incheon,jeju,jeonbuk,jeonnam,seoul,ulsan<kw>com,edu,emb,gov,ind,net,org<ky>edu,gov,com,org,net<kz>org,edu,net,gov,mil,com<la>int,net,info,edu,gov,per,com,org<lb>com,edu,gov,net,org<lc>com,net,co,org,edu,gov<li,lk>gov,sch,net,int,com,org,edu,ngo,soc,web,ltd,assn,grp,hotel,ac<lr>com,edu,gov,org,net<ls>ac,biz,co,edu,gov,info,net,org,sc<lt>gov<lu,lv>com,edu,gov,org,mil,id,net,asn,conf<ly>com,net,gov,plc,edu,sch,med,org,id<ma>co,net,gov,org,ac,press<mc>tm,asso<md,me>co,net,org,edu,ac,gov,its,priv<mg>org,nom,gov,prd,tm,edu,mil,com,co<mh,mil,mk>com,org,net,edu,gov,inf,name<ml>com,edu,gouv,gov,net,org,presse<mm>*<mn>gov,edu,org<mo>com,net,org,edu,gov<mobi,mp,mq,mr>gov<ms>com,edu,gov,net,org<mt>com,edu,net,org<mu>com,net,org,gov,ac,co,or<museum>academy,agriculture,air,airguard,alabama,alaska,amber,ambulance,american,americana,americanantiques,americanart,amsterdam,and,annefrank,anthro,anthropology,antiques,aquarium,arboretum,archaeological,archaeology,architecture,art,artanddesign,artcenter,artdeco,arteducation,artgallery,arts,artsandcrafts,asmatart,assassination,assisi,association,astronomy,atlanta,austin,australia,automotive,aviation,axis,badajoz,baghdad,bahn,bale,baltimore,barcelona,baseball,basel,baths,bauern,beauxarts,beeldengeluid,bellevue,bergbau,berkeley,berlin,bern,bible,bilbao,bill,birdart,birthplace,bonn,boston,botanical,botanicalgarden,botanicgarden,botany,brandywinevalley,brasil,bristol,british,britishcolumbia,broadcast,brunel,brussel,brussels,bruxelles,building,burghof,bus,bushey,cadaques,california,cambridge,can,canada,capebreton,carrier,cartoonart,casadelamoneda,castle,castres,celtic,center,chattanooga,cheltenham,chesapeakebay,chicago,children,childrens,childrensgarden,chiropractic,chocolate,christiansburg,cincinnati,cinema,circus,civilisation,civilization,civilwar,clinton,clock,coal,coastaldefence,cody,coldwar,collection,colonialwilliamsburg,coloradoplateau,columbia,columbus,communication,communications,community,computer,computerhistory,xn--comunicaes-v6a2o,contemporary,contemporaryart,convent,copenhagen,corporation,xn--correios-e-telecomunicaes-ghc29a,corvette,costume,countryestate,county,crafts,cranbrook,creation,cultural,culturalcenter,culture,cyber,cymru,dali,dallas,database,ddr,decorativearts,delaware,delmenhorst,denmark,depot,design,detroit,dinosaur,discovery,dolls,donostia,durham,eastafrica,eastcoast,education,educational,egyptian,eisenbahn,elburg,elvendrell,embroidery,encyclopedic,england,entomology,environment,environmentalconservation,epilepsy,essex,estate,ethnology,exeter,exhibition,family,farm,farmequipment,farmers,farmstead,field,figueres,filatelia,film,fineart,finearts,finland,flanders,florida,force,fortmissoula,fortworth,foundation,francaise,frankfurt,franziskaner,freemasonry,freiburg,fribourg,frog,fundacio,furniture,gallery,garden,gateway,geelvinck,gemological,geology,georgia,giessen,glas,glass,gorge,grandrapids,graz,guernsey,halloffame,hamburg,handson,harvestcelebration,hawaii,health,heimatunduhren,hellas,helsinki,hembygdsforbund,heritage,histoire,historical,historicalsociety,historichouses,historisch,historisches,history,historyofscience,horology,house,humanities,illustration,imageandsound,indian,indiana,indianapolis,indianmarket,intelligence,interactive,iraq,iron,isleofman,jamison,jefferson,jerusalem,jewelry,jewish,jewishart,jfk,journalism,judaica,judygarland,juedisches,juif,karate,karikatur,kids,koebenhavn,koeln,kunst,kunstsammlung,kunstunddesign,labor,labour,lajolla,lancashire,landes,lans,xn--lns-qla,larsson,lewismiller,lincoln,linz,living,livinghistory,localhistory,london,losangeles,louvre,loyalist,lucerne,luxembourg,luzern,mad,madrid,mallorca,manchester,mansion,mansions,manx,marburg,maritime,maritimo,maryland,marylhurst,media,medical,medizinhistorisches,meeres,memorial,mesaverde,michigan,midatlantic,military,mill,miners,mining,minnesota,missile,missoula,modern,moma,money,monmouth,monticello,montreal,moscow,motorcycle,muenchen,muenster,mulhouse,muncie,museet,museumcenter,museumvereniging,music,national,nationalfirearms,nationalheritage,nativeamerican,naturalhistory,naturalhistorymuseum,naturalsciences,nature,naturhistorisches,natuurwetenschappen,naumburg,naval,nebraska,neues,newhampshire,newjersey,newmexico,newport,newspaper,newyork,niepce,norfolk,north,nrw,nyc,nyny,oceanographic,oceanographique,omaha,online,ontario,openair,oregon,oregontrail,otago,oxford,pacific,paderborn,palace,paleo,palmsprings,panama,paris,pasadena,pharmacy,philadelphia,philadelphiaarea,philately,phoenix,photography,pilots,pittsburgh,planetarium,plantation,plants,plaza,portal,portland,portlligat,posts-and-telecommunications,preservation,presidio,press,project,public,pubol,quebec,railroad,railway,research,resistance,riodejaneiro,rochester,rockart,roma,russia,saintlouis,salem,salvadordali,salzburg,sandiego,sanfrancisco,santabarbara,santacruz,santafe,saskatchewan,satx,savannahga,schlesisches,schoenbrunn,schokoladen,school,schweiz,science,scienceandhistory,scienceandindustry,sciencecenter,sciencecenters,science-fiction,sciencehistory,sciences,sciencesnaturelles,scotland,seaport,settlement,settlers,shell,sherbrooke,sibenik,silk,ski,skole,society,sologne,soundandvision,southcarolina,southwest,space,spy,square,stadt,stalbans,starnberg,state,stateofdelaware,station,steam,steiermark,stjohn,stockholm,stpetersburg,stuttgart,suisse,surgeonshall,surrey,svizzera,sweden,sydney,tank,tcm,technology,telekommunikation,television,texas,textile,theater,time,timekeeping,topology,torino,touch,town,transport,tree,trolley,trust,trustee,uhren,ulm,undersea,university,usa,usantiques,usarts,uscountryestate,usculture,usdecorativearts,usgarden,ushistory,ushuaia,uslivinghistory,utah,uvic,valley,vantaa,versailles,viking,village,virginia,virtual,virtuel,vlaanderen,volkenkunde,wales,wallonie,war,washingtondc,watchandclock,watch-and-clock,western,westfalen,whaling,wildlife,williamsburg,windmill,workshop,york,yorkshire,yosemite,youth,zoological,zoology,xn--9dbhblg6di,xn--h1aegh<mv>aero,biz,com,coop,edu,gov,info,int,mil,museum,name,net,org,pro<mw>ac,biz,co,com,coop,edu,gov,int,museum,net,org<mx>com,org,gob,edu,net<my>biz,com,edu,gov,mil,name,net,org<mz>ac,adv,co,edu,gov,mil,net,org<na>info,pro,name,school,or,dr,us,mx,ca,in,cc,tv,ws,mobi,co,com,org<name,nc>asso,nom<ne,net,nf>com,net,per,rec,web,arts,firm,info,other,store<ng>com,edu,gov,i,mil,mobi,name,net,org,sch<ni>ac,biz,co,com,edu,gob,in,info,int,mil,net,nom,org,web<nl,no>fhs,vgs,fylkesbibl,folkebibl,museum,idrett,priv,mil,stat,dep,kommune,herad,aa>gs<ah>gs<bu>gs<fm>gs<hl>gs<hm>gs<jan-mayen>gs<mr>gs<nl>gs<nt>gs<of>gs<ol>gs<oslo>gs<rl>gs<sf>gs<st>gs<svalbard>gs<tm>gs<tr>gs<va>gs<vf>gs<akrehamn,xn--krehamn-dxa,algard,xn--lgrd-poac,arna,brumunddal,bryne,bronnoysund,xn--brnnysund-m8ac,drobak,xn--drbak-wua,egersund,fetsund,floro,xn--flor-jra,fredrikstad,hokksund,honefoss,xn--hnefoss-q1a,jessheim,jorpeland,xn--jrpeland-54a,kirkenes,kopervik,krokstadelva,langevag,xn--langevg-jxa,leirvik,mjondalen,xn--mjndalen-64a,mo-i-rana,mosjoen,xn--mosjen-eya,nesoddtangen,orkanger,osoyro,xn--osyro-wua,raholt,xn--rholt-mra,sandnessjoen,xn--sandnessjen-ogb,skedsmokorset,slattum,spjelkavik,stathelle,stavern,stjordalshalsen,xn--stjrdalshalsen-sqb,tananger,tranby,vossevangen,afjord,xn--fjord-lra,agdenes,al,xn--l-1fa,alesund,xn--lesund-hua,alstahaug,alta,xn--lt-liac,alaheadju,xn--laheadju-7ya,alvdal,amli,xn--mli-tla,amot,xn--mot-tla,andebu,andoy,xn--andy-ira,andasuolo,ardal,xn--rdal-poa,aremark,arendal,xn--s-1fa,aseral,xn--seral-lra,asker,askim,askvoll,askoy,xn--asky-ira,asnes,xn--snes-poa,audnedaln,aukra,aure,aurland,aurskog-holand,xn--aurskog-hland-jnb,austevoll,austrheim,averoy,xn--avery-yua,balestrand,ballangen,balat,xn--blt-elab,balsfjord,bahccavuotna,xn--bhccavuotna-k7a,bamble,bardu,beardu,beiarn,bajddar,xn--bjddar-pta,baidar,xn--bidr-5nac,berg,bergen,berlevag,xn--berlevg-jxa,bearalvahki,xn--bearalvhki-y4a,bindal,birkenes,bjarkoy,xn--bjarky-fya,bjerkreim,bjugn,bodo,xn--bod-2na,badaddja,xn--bdddj-mrabd,budejju,bokn,bremanger,bronnoy,xn--brnny-wuac,bygland,bykle,barum,xn--brum-voa,telemark>bo,xn--b-5ga<nordland>bo,xn--b-5ga,heroy,xn--hery-ira<bievat,xn--bievt-0qa,bomlo,xn--bmlo-gra,batsfjord,xn--btsfjord-9za,bahcavuotna,xn--bhcavuotna-s4a,dovre,drammen,drangedal,dyroy,xn--dyry-ira,donna,xn--dnna-gra,eid,eidfjord,eidsberg,eidskog,eidsvoll,eigersund,elverum,enebakk,engerdal,etne,etnedal,evenes,evenassi,xn--eveni-0qa01ga,evje-og-hornnes,farsund,fauske,fuossko,fuoisku,fedje,fet,finnoy,xn--finny-yua,fitjar,fjaler,fjell,flakstad,flatanger,flekkefjord,flesberg,flora,fla,xn--fl-zia,folldal,forsand,fosnes,frei,frogn,froland,frosta,frana,xn--frna-woa,froya,xn--frya-hra,fusa,fyresdal,forde,xn--frde-gra,gamvik,gangaviika,xn--ggaviika-8ya47h,gaular,gausdal,gildeskal,xn--gildeskl-g0a,giske,gjemnes,gjerdrum,gjerstad,gjesdal,gjovik,xn--gjvik-wua,gloppen,gol,gran,grane,granvin,gratangen,grimstad,grong,kraanghke,xn--kranghke-b0a,grue,gulen,hadsel,halden,halsa,hamar,hamaroy,habmer,xn--hbmer-xqa,hapmir,xn--hpmir-xqa,hammerfest,hammarfeasta,xn--hmmrfeasta-s4ac,haram,hareid,harstad,hasvik,aknoluokta,xn--koluokta-7ya57h,hattfjelldal,aarborte,haugesund,hemne,hemnes,hemsedal,more-og-romsdal>heroy,sande<xn--mre-og-romsdal-qqb>xn--hery-ira,sande<hitra,hjartdal,hjelmeland,hobol,xn--hobl-ira,hof,hol,hole,holmestrand,holtalen,xn--holtlen-hxa,hornindal,horten,hurdal,hurum,hvaler,hyllestad,hagebostad,xn--hgebostad-g3a,hoyanger,xn--hyanger-q1a,hoylandet,xn--hylandet-54a,ha,xn--h-2fa,ibestad,inderoy,xn--indery-fya,iveland,jevnaker,jondal,jolster,xn--jlster-bya,karasjok,karasjohka,xn--krjohka-hwab49j,karlsoy,galsa,xn--gls-elac,karmoy,xn--karmy-yua,kautokeino,guovdageaidnu,klepp,klabu,xn--klbu-woa,kongsberg,kongsvinger,kragero,xn--krager-gya,kristiansand,kristiansund,krodsherad,xn--krdsherad-m8a,kvalsund,rahkkeravju,xn--rhkkervju-01af,kvam,kvinesdal,kvinnherad,kviteseid,kvitsoy,xn--kvitsy-fya,kvafjord,xn--kvfjord-nxa,giehtavuoatna,kvanangen,xn--kvnangen-k0a,navuotna,xn--nvuotna-hwa,kafjord,xn--kfjord-iua,gaivuotna,xn--givuotna-8ya,larvik,lavangen,lavagis,loabat,xn--loabt-0qa,lebesby,davvesiida,leikanger,leirfjord,leka,leksvik,lenvik,leangaviika,xn--leagaviika-52b,lesja,levanger,lier,lierne,lillehammer,lillesand,lindesnes,lindas,xn--linds-pra,lom,loppa,lahppi,xn--lhppi-xqa,lund,lunner,luroy,xn--lury-ira,luster,lyngdal,lyngen,ivgu,lardal,lerdal,xn--lrdal-sra,lodingen,xn--ldingen-q1a,lorenskog,xn--lrenskog-54a,loten,xn--lten-gra,malvik,masoy,xn--msy-ula0h,muosat,xn--muost-0qa,mandal,marker,marnardal,masfjorden,meland,meldal,melhus,meloy,xn--mely-ira,meraker,xn--merker-kua,moareke,xn--moreke-jua,midsund,midtre-gauldal,modalen,modum,molde,moskenes,moss,mosvik,malselv,xn--mlselv-iua,malatvuopmi,xn--mlatvuopmi-s4a,namdalseid,aejrie,namsos,namsskogan,naamesjevuemie,xn--nmesjevuemie-tcba,laakesvuemie,nannestad,narvik,narviika,naustdal,nedre-eiker,akershus>nes<buskerud>nes<nesna,nesodden,nesseby,unjarga,xn--unjrga-rta,nesset,nissedal,nittedal,nord-aurdal,nord-fron,nord-odal,norddal,nordkapp,davvenjarga,xn--davvenjrga-y4a,nordre-land,nordreisa,raisa,xn--risa-5na,nore-og-uvdal,notodden,naroy,xn--nry-yla5g,notteroy,xn--nttery-byae,odda,oksnes,xn--ksnes-uua,oppdal,oppegard,xn--oppegrd-ixa,orkdal,orland,xn--rland-uua,orskog,xn--rskog-uua,orsta,xn--rsta-fra,hedmark>os,valer,xn--vler-qoa<hordaland>os<osen,osteroy,xn--ostery-fya,ostre-toten,xn--stre-toten-zcb,overhalla,ovre-eiker,xn--vre-eiker-k8a,oyer,xn--yer-zna,oygarden,xn--ygarden-p1a,oystre-slidre,xn--ystre-slidre-ujb,porsanger,porsangu,xn--porsgu-sta26f,porsgrunn,radoy,xn--rady-ira,rakkestad,rana,ruovat,randaberg,rauma,rendalen,rennebu,rennesoy,xn--rennesy-v1a,rindal,ringebu,ringerike,ringsaker,rissa,risor,xn--risr-ira,roan,rollag,rygge,ralingen,xn--rlingen-mxa,rodoy,xn--rdy-0nab,romskog,xn--rmskog-bya,roros,xn--rros-gra,rost,xn--rst-0na,royken,xn--ryken-vua,royrvik,xn--ryrvik-bya,rade,xn--rde-ula,salangen,siellak,saltdal,salat,xn--slt-elab,xn--slat-5na,samnanger,vestfold>sande<sandefjord,sandnes,sandoy,xn--sandy-yua,sarpsborg,sauda,sauherad,sel,selbu,selje,seljord,sigdal,siljan,sirdal,skaun,skedsmo,ski,skien,skiptvet,skjervoy,xn--skjervy-v1a,skierva,xn--skierv-uta,skjak,xn--skjk-soa,skodje,skanland,xn--sknland-fxa,skanit,xn--sknit-yqa,smola,xn--smla-hra,snillfjord,snasa,xn--snsa-roa,snoasa,snaase,xn--snase-nra,sogndal,sokndal,sola,solund,songdalen,sortland,spydeberg,stange,stavanger,steigen,steinkjer,stjordal,xn--stjrdal-s1a,stokke,stor-elvdal,stord,stordal,storfjord,omasvuotna,strand,stranda,stryn,sula,suldal,sund,sunndal,surnadal,sveio,svelvik,sykkylven,sogne,xn--sgne-gra,somna,xn--smna-gra,sondre-land,xn--sndre-land-0cb,sor-aurdal,xn--sr-aurdal-l8a,sor-fron,xn--sr-fron-q1a,sor-odal,xn--sr-odal-q1a,sor-varanger,xn--sr-varanger-ggb,matta-varjjat,xn--mtta-vrjjat-k7af,sorfold,xn--srfold-bya,sorreisa,xn--srreisa-q1a,sorum,xn--srum-gra,tana,deatnu,time,tingvoll,tinn,tjeldsund,dielddanuorri,tjome,xn--tjme-hra,tokke,tolga,torsken,tranoy,xn--trany-yua,tromso,xn--troms-zua,tromsa,romsa,trondheim,troandin,trysil,trana,xn--trna-woa,trogstad,xn--trgstad-r1a,tvedestrand,tydal,tynset,tysfjord,divtasvuodna,divttasvuotna,tysnes,tysvar,xn--tysvr-vra,tonsberg,xn--tnsberg-q1a,ullensaker,ullensvang,ulvik,utsira,vadso,xn--vads-jra,cahcesuolo,xn--hcesuolo-7ya35b,vaksdal,valle,vang,vanylven,vardo,xn--vard-jra,varggat,xn--vrggt-xqad,vefsn,vaapste,vega,vegarshei,xn--vegrshei-c0a,vennesla,verdal,verran,vestby,vestnes,vestre-slidre,vestre-toten,vestvagoy,xn--vestvgy-ixa6o,vevelstad,vik,vikna,vindafjord,volda,voss,varoy,xn--vry-yla5g,vagan,xn--vgan-qoa,voagat,vagsoy,xn--vgsy-qoa0j,vaga,xn--vg-yiab,ostfold>valer<xn--stfold-9xa>xn--vler-qoa<<np>*<nr>biz,info,gov,edu,org,net,com<nu,nz>ac,co,cri,geek,gen,govt,health,iwi,kiwi,maori,mil,xn--mori-qsa,net,org,parliament,school<om>co,com,edu,gov,med,museum,net,org,pro<onion,org,pa>ac,gob,com,org,sld,edu,net,ing,abo,med,nom<pe>edu,gob,nom,mil,org,com,net<pf>com,org,edu<pg>*<ph>com,net,org,gov,edu,ngo,mil,i<pk>com,net,edu,org,fam,biz,web,gov,gob,gok,gon,gop,gos,info<pl>com,net,org,aid,agro,atm,auto,biz,edu,gmina,gsm,info,mail,miasta,media,mil,nieruchomosci,nom,pc,powiat,priv,realestate,rel,sex,shop,sklep,sos,szkola,targi,tm,tourism,travel,turystyka,gov>ap,ic,is,us,kmpsp,kppsp,kwpsp,psp,wskr,kwp,mw,ug,um,umig,ugim,upow,uw,starostwo,pa,po,psse,pup,rzgw,sa,so,sr,wsa,sko,uzs,wiih,winb,pinb,wios,witd,wzmiuw,piw,wiw,griw,wif,oum,sdn,zp,uppo,mup,wuoz,konsulat,oirm<augustow,babia-gora,bedzin,beskidy,bialowieza,bialystok,bielawa,bieszczady,boleslawiec,bydgoszcz,bytom,cieszyn,czeladz,czest,dlugoleka,elblag,elk,glogow,gniezno,gorlice,grajewo,ilawa,jaworzno,jelenia-gora,jgora,kalisz,kazimierz-dolny,karpacz,kartuzy,kaszuby,katowice,kepno,ketrzyn,klodzko,kobierzyce,kolobrzeg,konin,konskowola,kutno,lapy,lebork,legnica,lezajsk,limanowa,lomza,lowicz,lubin,lukow,malbork,malopolska,mazowsze,mazury,mielec,mielno,mragowo,naklo,nowaruda,nysa,olawa,olecko,olkusz,olsztyn,opoczno,opole,ostroda,ostroleka,ostrowiec,ostrowwlkp,pila,pisz,podhale,podlasie,polkowice,pomorze,pomorskie,prochowice,pruszkow,przeworsk,pulawy,radom,rawa-maz,rybnik,rzeszow,sanok,sejny,slask,slupsk,sosnowiec,stalowa-wola,skoczow,starachowice,stargard,suwalki,swidnica,swiebodzin,swinoujscie,szczecin,szczytno,tarnobrzeg,tgory,turek,tychy,ustka,walbrzych,warmia,warszawa,waw,wegrow,wielun,wlocl,wloclawek,wodzislaw,wolomin,wroclaw,zachpomor,zagan,zarow,zgora,zgorzelec<pm,pn>gov,co,org,edu,net<post,pr>com,net,org,gov,edu,isla,pro,biz,info,name,est,prof,ac<pro>aaa,aca,acct,avocat,bar,cpa,eng,jur,law,med,recht<ps>edu,gov,sec,plo,com,org,net<pt>net,gov,org,edu,int,publ,com,nome<pw>co,ne,or,ed,go,belau<py>com,coop,edu,gov,mil,net,org<qa>com,edu,gov,mil,name,net,org,sch<re>asso,com,nom<ro>arts,com,firm,info,nom,nt,org,rec,store,tm,www<rs>ac,co,edu,gov,in,org<ru,rw>ac,co,coop,gov,mil,net,org<sa>com,net,org,gov,med,pub,edu,sch<sb>com,edu,gov,net,org<sc>com,gov,net,org,edu<sd>com,net,org,edu,med,tv,gov,info<se>a,ac,b,bd,brand,c,d,e,f,fh,fhsk,fhv,g,h,i,k,komforb,kommunalforbund,komvux,l,lanbib,m,n,naturbruksgymn,o,org,p,parti,pp,press,r,s,t,tm,u,w,x,y,z<sg>com,net,org,gov,edu,per<sh>com,net,gov,org,mil<si,sj,sk,sl>com,net,edu,gov,org<sm,sn>art,com,edu,gouv,org,perso,univ<so>com,edu,gov,me,net,org<sr,ss>biz,com,edu,gov,me,net,org,sch<st>co,com,consulado,edu,embaixada,mil,net,org,principe,saotome,store<su,sv>com,edu,gob,org,red<sx>gov<sy>edu,gov,net,mil,com,org<sz>co,ac,org<tc,td,tel,tf,tg,th>ac,co,go,in,mi,net,or<tj>ac,biz,co,com,edu,go,gov,int,mil,name,net,nic,org,test,web<tk,tl>gov<tm>com,co,org,net,nom,gov,mil,edu<tn>com,ens,fin,gov,ind,intl,nat,net,org,info,perso,tourism,edunet,rnrt,rns,rnu,mincom,agrinet,defense,turen<to>com,gov,net,org,edu,mil<tr>av,bbs,bel,biz,com,dr,edu,gen,gov,info,mil,k12,kep,name,net,org,pol,tel,tsk,tv,web,nc>gov<<tt>co,com,org,net,biz,info,pro,int,coop,jobs,mobi,travel,museum,aero,name,gov,edu<tv,tw>edu,gov,mil,com,net,org,idv,game,ebiz,club,xn--zf0ao64a,xn--uc0atv,xn--czrw28b<tz>ac,co,go,hotel,info,me,mil,mobi,ne,or,sc,tv<ua>com,edu,gov,in,net,org,cherkassy,cherkasy,chernigov,chernihiv,chernivtsi,chernovtsy,ck,cn,cr,crimea,cv,dn,dnepropetrovsk,dnipropetrovsk,donetsk,dp,if,ivano-frankivsk,kh,kharkiv,kharkov,kherson,khmelnitskiy,khmelnytskyi,kiev,kirovograd,km,kr,krym,ks,kv,kyiv,lg,lt,lugansk,lutsk,lv,lviv,mk,mykolaiv,nikolaev,od,odesa,odessa,pl,poltava,rivne,rovno,rv,sb,sebastopol,sevastopol,sm,sumy,te,ternopil,uz,uzhgorod,vinnica,vinnytsia,vn,volyn,yalta,zaporizhzhe,zaporizhzhia,zhitomir,zhytomyr,zp,zt<ug>co,or,ac,sc,go,ne,com,org<uk>ac,co,gov,ltd,me,net,nhs,org,plc,police,sch>*<<us>dni,fed,isa,kids,nsn,ak>k12,cc,lib<al>k12,cc,lib<ar>k12,cc,lib<as>k12,cc,lib<az>k12,cc,lib<ca>k12,cc,lib<co>k12,cc,lib<ct>k12,cc,lib<dc>k12,cc,lib<de>k12,cc<fl>k12,cc,lib<ga>k12,cc,lib<gu>k12,cc,lib<hi>cc,lib<ia>k12,cc,lib<id>k12,cc,lib<il>k12,cc,lib<in>k12,cc,lib<ks>k12,cc,lib<ky>k12,cc,lib<la>k12,cc,lib<ma>k12>pvt,chtr,paroch<cc,lib<md>k12,cc,lib<me>k12,cc,lib<mi>k12,cc,lib,ann-arbor,cog,dst,eaton,gen,mus,tec,washtenaw<mn>k12,cc,lib<mo>k12,cc,lib<ms>k12,cc,lib<mt>k12,cc,lib<nc>k12,cc,lib<nd>cc,lib<ne>k12,cc,lib<nh>k12,cc,lib<nj>k12,cc,lib<nm>k12,cc,lib<nv>k12,cc,lib<ny>k12,cc,lib<oh>k12,cc,lib<ok>k12,cc,lib<or>k12,cc,lib<pa>k12,cc,lib<pr>k12,cc,lib<ri>cc,lib<sc>k12,cc,lib<sd>cc,lib<tn>k12,cc,lib<tx>k12,cc,lib<ut>k12,cc,lib<vi>k12,cc,lib<vt>k12,cc,lib<va>k12,cc,lib<wa>k12,cc,lib<wi>k12,cc,lib<wv>cc<wy>k12,cc,lib<<uy>com,edu,gub,mil,net,org<uz>co,com,net,org<va,vc>com,net,org,gov,mil,edu<ve>arts,bib,co,com,e12,edu,firm,gob,gov,info,int,mil,net,nom,org,rar,rec,store,tec,web<vg,vi>co,com,k12,net,org<vn>com,net,org,edu,gov,int,ac,biz,info,name,pro,health<vu>com,edu,net,org<wf,ws>com,net,org,gov,edu<yt,xn--mgbaam7a8h,xn--y9a3aq,xn--54b7fta0cc,xn--90ae,xn--mgbcpq6gpa1a,xn--90ais,xn--fiqs8s,xn--fiqz9s,xn--lgbbat1ad8j,xn--wgbh1c,xn--e1a4c,xn--qxa6a,xn--mgbah1a3hjkrd,xn--node,xn--qxam,xn--j6w193g>xn--55qx5d,xn--wcvs22d,xn--mxtq1m,xn--gmqw5a,xn--od0alg,xn--uc0atv<xn--2scrj9c,xn--3hcrj9c,xn--45br5cyl,xn--h2breg3eve,xn--h2brj9c8c,xn--mgbgu82a,xn--rvc1e0am3e,xn--h2brj9c,xn--mgbbh1a,xn--mgbbh1a71e,xn--fpcrj9c3d,xn--gecrj9c,xn--s9brj9c,xn--45brj9c,xn--xkc2dl3a5ee0h,xn--mgba3a4f16a,xn--mgba3a4fra,xn--mgbtx2b,xn--mgbayh7gpa,xn--3e0b707e,xn--80ao21a,xn--q7ce6a,xn--fzc2c9e2c,xn--xkc2al3hye2a,xn--mgbc0a9azcg,xn--d1alf,xn--l1acc,xn--mix891f,xn--mix082f,xn--mgbx4cd0ab,xn--mgb9awbf,xn--mgbai9azgqp6j,xn--mgbai9a5eva00b,xn--ygbi2ammx,xn--90a3ac>xn--o1ac,xn--c1avg,xn--90azh,xn--d1at,xn--o1ach,xn--80au<xn--p1ai,xn--wgbl6a,xn--mgberp4a5d4ar,xn--mgberp4a5d4a87g,xn--mgbqly7c0a67fbc,xn--mgbqly7cvafr,xn--mgbpl2fh,xn--yfro4i67o,xn--clchc0ea0b2g2a9gcd,xn--ogbpf8fl,xn--mgbtf8fl,xn--o3cw4h>xn--12c1fe0br,xn--12co0c3b4eva,xn--h3cuzk1di,xn--o3cyx2a,xn--m3ch0j3a,xn--12cfi8ixb8l<xn--pgbs0dh,xn--kpry57d,xn--kprw13d,xn--nnx388a,xn--j1amh,xn--mgb2ddes,xxx,ye>com,edu,gov,net,mil,org<za>ac,agric,alt,co,edu,gov,grondar,law,mil,net,ngo,nic,nis,nom,org,school,tm,web<zm>ac,biz,co,com,edu,gov,info,mil,net,org,sch<zw>ac,co,gov,mil,org<aaa,aarp,abarth,abb,abbott,abbvie,abc,able,abogado,abudhabi,academy,accenture,accountant,accountants,aco,actor,adac,ads,adult,aeg,aetna,afamilycompany,afl,africa,agakhan,agency,aig,airbus,airforce,airtel,akdn,alfaromeo,alibaba,alipay,allfinanz,allstate,ally,alsace,alstom,amazon,americanexpress,americanfamily,amex,amfam,amica,amsterdam,analytics,android,anquan,anz,aol,apartments,app,apple,aquarelle,arab,aramco,archi,army,art,arte,asda,associates,athleta,attorney,auction,audi,audible,audio,auspost,author,auto,autos,avianca,aws,axa,azure,baby,baidu,banamex,bananarepublic,band,bank,bar,barcelona,barclaycard,barclays,barefoot,bargains,baseball,basketball,bauhaus,bayern,bbc,bbt,bbva,bcg,bcn,beats,beauty,beer,bentley,berlin,best,bestbuy,bet,bharti,bible,bid,bike,bing,bingo,bio,black,blackfriday,blockbuster,blog,bloomberg,blue,bms,bmw,bnpparibas,boats,boehringer,bofa,bom,bond,boo,book,booking,bosch,bostik,boston,bot,boutique,box,bradesco,bridgestone,broadway,broker,brother,brussels,budapest,bugatti,build,builders,business,buy,buzz,bzh,cab,cafe,cal,call,calvinklein,cam,camera,camp,cancerresearch,canon,capetown,capital,capitalone,car,caravan,cards,care,career,careers,cars,casa,case,cash,casino,catering,catholic,cba,cbn,cbre,cbs,center,ceo,cern,cfa,cfd,chanel,channel,charity,chase,chat,cheap,chintai,christmas,chrome,church,cipriani,circle,cisco,citadel,citi,citic,city,cityeats,claims,cleaning,click,clinic,clinique,clothing,cloud,club,clubmed,coach,codes,coffee,college,cologne,comcast,commbank,community,company,compare,computer,comsec,condos,construction,consulting,contact,contractors,cooking,cookingchannel,cool,corsica,country,coupon,coupons,courses,cpa,credit,creditcard,creditunion,cricket,crown,crs,cruise,cruises,csc,cuisinella,cymru,cyou,dabur,dad,dance,data,date,dating,datsun,day,dclk,dds,deal,dealer,deals,degree,delivery,dell,deloitte,delta,democrat,dental,dentist,desi,design,dev,dhl,diamonds,diet,digital,direct,directory,discount,discover,dish,diy,dnp,docs,doctor,dog,domains,dot,download,drive,dtv,dubai,duck,dunlop,dupont,durban,dvag,dvr,earth,eat,eco,edeka,education,email,emerck,energy,engineer,engineering,enterprises,epson,equipment,ericsson,erni,esq,estate,etisalat,eurovision,eus,events,exchange,expert,exposed,express,extraspace,fage,fail,fairwinds,faith,family,fan,fans,farm,farmers,fashion,fast,fedex,feedback,ferrari,ferrero,fiat,fidelity,fido,film,final,finance,financial,fire,firestone,firmdale,fish,fishing,fit,fitness,flickr,flights,flir,florist,flowers,fly,foo,food,foodnetwork,football,ford,forex,forsale,forum,foundation,fox,free,fresenius,frl,frogans,frontdoor,frontier,ftr,fujitsu,fun,fund,furniture,futbol,fyi,gal,gallery,gallo,gallup,game,games,gap,garden,gay,gbiz,gdn,gea,gent,genting,george,ggee,gift,gifts,gives,giving,glade,glass,gle,global,globo,gmail,gmbh,gmo,gmx,godaddy,gold,goldpoint,golf,goo,goodyear,goog,google,gop,got,grainger,graphics,gratis,green,gripe,grocery,group,guardian,gucci,guge,guide,guitars,guru,hair,hamburg,hangout,haus,hbo,hdfc,hdfcbank,health,healthcare,help,helsinki,here,hermes,hgtv,hiphop,hisamitsu,hitachi,hiv,hkt,hockey,holdings,holiday,homedepot,homegoods,homes,homesense,honda,horse,hospital,host,hosting,hot,hoteles,hotels,hotmail,house,how,hsbc,hughes,hyatt,hyundai,ibm,icbc,ice,icu,ieee,ifm,ikano,imamat,imdb,immo,immobilien,inc,industries,infiniti,ing,ink,institute,insurance,insure,international,intuit,investments,ipiranga,irish,ismaili,ist,istanbul,itau,itv,jaguar,java,jcb,jeep,jetzt,jewelry,jio,jll,jmp,jnj,joburg,jot,joy,jpmorgan,jprs,juegos,juniper,kaufen,kddi,kerryhotels,kerrylogistics,kerryproperties,kfh,kia,kids,kim,kinder,kindle,kitchen,kiwi,koeln,komatsu,kosher,kpmg,kpn,krd,kred,kuokgroup,kyoto,lacaixa,lamborghini,lamer,lancaster,lancia,land,landrover,lanxess,lasalle,lat,latino,latrobe,law,lawyer,lds,lease,leclerc,lefrak,legal,lego,lexus,lgbt,lidl,life,lifeinsurance,lifestyle,lighting,like,lilly,limited,limo,lincoln,linde,link,lipsy,live,living,lixil,llc,llp,loan,loans,locker,locus,loft,lol,london,lotte,lotto,love,lpl,lplfinancial,ltd,ltda,lundbeck,luxe,luxury,macys,madrid,maif,maison,makeup,man,management,mango,map,market,marketing,markets,marriott,marshalls,maserati,mattel,mba,mckinsey,med,media,meet,melbourne,meme,memorial,men,menu,merckmsd,miami,microsoft,mini,mint,mit,mitsubishi,mlb,mls,mma,mobile,moda,moe,moi,mom,monash,money,monster,mormon,mortgage,moscow,moto,motorcycles,mov,movie,msd,mtn,mtr,music,mutual,nab,nagoya,natura,navy,nba,nec,netbank,netflix,network,neustar,new,news,next,nextdirect,nexus,nfl,ngo,nhk,nico,nike,nikon,ninja,nissan,nissay,nokia,northwesternmutual,norton,now,nowruz,nowtv,nra,nrw,ntt,nyc,obi,observer,off,office,okinawa,olayan,olayangroup,oldnavy,ollo,omega,one,ong,onl,online,ooo,open,oracle,orange,organic,origins,osaka,otsuka,ott,ovh,page,panasonic,paris,pars,partners,parts,party,passagens,pay,pccw,pet,pfizer,pharmacy,phd,philips,phone,photo,photography,photos,physio,pics,pictet,pictures,pid,pin,ping,pink,pioneer,pizza,place,play,playstation,plumbing,plus,pnc,pohl,poker,politie,porn,pramerica,praxi,press,prime,prod,productions,prof,progressive,promo,properties,property,protection,pru,prudential,pub,pwc,qpon,quebec,quest,qvc,racing,radio,raid,read,realestate,realtor,realty,recipes,red,redstone,redumbrella,rehab,reise,reisen,reit,reliance,ren,rent,rentals,repair,report,republican,rest,restaurant,review,reviews,rexroth,rich,richardli,ricoh,ril,rio,rip,rmit,rocher,rocks,rodeo,rogers,room,rsvp,rugby,ruhr,run,rwe,ryukyu,saarland,safe,safety,sakura,sale,salon,samsclub,samsung,sandvik,sandvikcoromant,sanofi,sap,sarl,sas,save,saxo,sbi,sbs,sca,scb,schaeffler,schmidt,scholarships,school,schule,schwarz,science,scjohnson,scot,search,seat,secure,security,seek,select,sener,services,ses,seven,sew,sex,sexy,sfr,shangrila,sharp,shaw,shell,shia,shiksha,shoes,shop,shopping,shouji,show,showtime,silk,sina,singles,site,ski,skin,sky,skype,sling,smart,smile,sncf,soccer,social,softbank,software,sohu,solar,solutions,song,sony,soy,spa,space,sport,spot,srl,stada,staples,star,statebank,statefarm,stc,stcgroup,stockholm,storage,store,stream,studio,study,style,sucks,supplies,supply,support,surf,surgery,suzuki,swatch,swiftcover,swiss,sydney,systems,tab,taipei,talk,taobao,target,tatamotors,tatar,tattoo,tax,taxi,tci,tdk,team,tech,technology,temasek,tennis,teva,thd,theater,theatre,tiaa,tickets,tienda,tiffany,tips,tires,tirol,tjmaxx,tjx,tkmaxx,tmall,today,tokyo,tools,top,toray,toshiba,total,tours,town,toyota,toys,trade,trading,training,travel,travelchannel,travelers,travelersinsurance,trust,trv,tube,tui,tunes,tushu,tvs,ubank,ubs,unicom,university,uno,uol,ups,vacations,vana,vanguard,vegas,ventures,verisign,versicherung,vet,viajes,video,vig,viking,villas,vin,vip,virgin,visa,vision,viva,vivo,vlaanderen,vodka,volkswagen,volvo,vote,voting,voto,voyage,vuelos,wales,walmart,walter,wang,wanggou,watch,watches,weather,weatherchannel,webcam,weber,website,wedding,weibo,weir,whoswho,wien,wiki,williamhill,win,windows,wine,winners,wme,wolterskluwer,woodside,work,works,world,wow,wtc,wtf,xbox,xerox,xfinity,xihuan,xin,xn--11b4c3d,xn--1ck2e1b,xn--1qqw23a,xn--30rr7y,xn--3bst00m,xn--3ds443g,xn--3oq18vl8pn36a,xn--3pxu8k,xn--42c2d9a,xn--45q11c,xn--4gbrim,xn--55qw42g,xn--55qx5d,xn--5su34j936bgsg,xn--5tzm5g,xn--6frz82g,xn--6qq986b3xl,xn--80adxhks,xn--80aqecdr1a,xn--80asehdb,xn--80aswg,xn--8y0a063a,xn--9dbq2a,xn--9et52u,xn--9krt00a,xn--b4w605ferd,xn--bck1b9a5dre4c,xn--c1avg,xn--c2br7g,xn--cck2b3b,xn--cckwcxetd,xn--cg4bki,xn--czr694b,xn--czrs0t,xn--czru2d,xn--d1acj3b,xn--eckvdtc9d,xn--efvy88h,xn--fct429k,xn--fhbei,xn--fiq228c5hs,xn--fiq64b,xn--fjq720a,xn--flw351e,xn--fzys8d69uvgm,xn--g2xx48c,xn--gckr3f0f,xn--gk3at1e,xn--hxt814e,xn--i1b6b1a6a2e,xn--imr513n,xn--io0a7i,xn--j1aef,xn--jlq480n2rg,xn--jlq61u9w7b,xn--jvr189m,xn--kcrx77d1x4a,xn--kput3i,xn--mgba3a3ejt,xn--mgba7c0bbn0a,xn--mgbaakc7dvf,xn--mgbab2bd,xn--mgbca7dzdo,xn--mgbi4ecexp,xn--mgbt3dhd,xn--mk1bu44c,xn--mxtq1m,xn--ngbc5azd,xn--ngbe9e0a,xn--ngbrx,xn--nqv7f,xn--nqv7fs00ema,xn--nyqy26a,xn--otu796d,xn--p1acf,xn--pssy2u,xn--q9jyb4c,xn--qcka1pmc,xn--rhqv96g,xn--rovu88b,xn--ses554g,xn--t60b56a,xn--tckwe,xn--tiq49xqyj,xn--unup4y,xn--vermgensberater-ctb,xn--vermgensberatung-pwb,xn--vhquv,xn--vuq861b,xn--w4r85el8fhu5dnra,xn--w4rs40l,xn--xhq521b,xn--zfr164b,xyz,yachts,yahoo,yamaxun,yandex,yodobashi,yoga,yokohama,you,youtube,yun,zappos,zara,zero,zip,zone,zuerich";

/***/ }),

/***/ 6943:
/***/ (function(module) {

"use strict";
module.exports = "ua>cc,inf,ltd,cx,biz,co,pp,v<to>611,oya,rdv,vpnplus,quickconnect>direct<nyan<us>graphox,cloudns,drud,is-by,land-4-sale,stuff-4-sale,enscaled>phx<mircloud,freeddns,golffan,noip,pointto,platterp,de>lib<<com>devcdnaccesso>*<adobeaemcloud>dev>*<<kasserver,amazonaws>compute>*<compute-1>*<us-east-1>dualstack>s3<<elb>*<s3,s3-ap-northeast-1,s3-ap-northeast-2,s3-ap-south-1,s3-ap-southeast-1,s3-ap-southeast-2,s3-ca-central-1,s3-eu-central-1,s3-eu-west-1,s3-eu-west-2,s3-eu-west-3,s3-external-1,s3-fips-us-gov-west-1,s3-sa-east-1,s3-us-gov-west-1,s3-us-east-2,s3-us-west-1,s3-us-west-2,ap-northeast-2>s3,dualstack>s3<s3-website<ap-south-1>s3,dualstack>s3<s3-website<ca-central-1>s3,dualstack>s3<s3-website<eu-central-1>s3,dualstack>s3<s3-website<eu-west-2>s3,dualstack>s3<s3-website<eu-west-3>s3,dualstack>s3<s3-website<us-east-2>s3,dualstack>s3<s3-website<ap-northeast-1>dualstack>s3<<ap-southeast-1>dualstack>s3<<ap-southeast-2>dualstack>s3<<eu-west-1>dualstack>s3<<sa-east-1>dualstack>s3<<s3-website-us-east-1,s3-website-us-west-1,s3-website-us-west-2,s3-website-ap-northeast-1,s3-website-ap-southeast-1,s3-website-ap-southeast-2,s3-website-eu-west-1,s3-website-sa-east-1<elasticbeanstalk>ap-northeast-1,ap-northeast-2,ap-northeast-3,ap-south-1,ap-southeast-1,ap-southeast-2,ca-central-1,eu-central-1,eu-west-1,eu-west-2,eu-west-3,sa-east-1,us-east-1,us-east-2,us-gov-west-1,us-west-1,us-west-2<awsglobalaccelerator,appspacehosted,appspaceusercontent,on-aptible,myasustor,balena-devices,betainabox,boutir,bplaced,cafjs,br,cn,de,eu,jpn,mex,ru,sa,uk,us,za,ar,gb,hu,kr,no,qc,uy,africa,gr,co,jdevcloud,wpdevcloud,cloudcontrolled,cloudcontrolapp,trycloudflare,customer-oci>*,oci>*<ocp>*<ocs>*<<dattolocal,dattorelay,dattoweb,mydatto,builtwithdark,datadetect>demo,instance<ddns5,drayddns,dreamhosters,mydrobo,dyndns-at-home,dyndns-at-work,dyndns-blog,dyndns-free,dyndns-home,dyndns-ip,dyndns-mail,dyndns-office,dyndns-pics,dyndns-remote,dyndns-server,dyndns-web,dyndns-wiki,dyndns-work,blogdns,cechire,dnsalias,dnsdojo,doesntexist,dontexist,doomdns,dyn-o-saur,dynalias,est-a-la-maison,est-a-la-masion,est-le-patron,est-mon-blogueur,from-ak,from-al,from-ar,from-ca,from-ct,from-dc,from-de,from-fl,from-ga,from-hi,from-ia,from-id,from-il,from-in,from-ks,from-ky,from-ma,from-md,from-mi,from-mn,from-mo,from-ms,from-mt,from-nc,from-nd,from-ne,from-nh,from-nj,from-nm,from-nv,from-oh,from-ok,from-or,from-pa,from-pr,from-ri,from-sc,from-sd,from-tn,from-tx,from-ut,from-va,from-vt,from-wa,from-wi,from-wv,from-wy,getmyip,gotdns,hobby-site,homelinux,homeunix,iamallama,is-a-anarchist,is-a-blogger,is-a-bookkeeper,is-a-bulls-fan,is-a-caterer,is-a-chef,is-a-conservative,is-a-cpa,is-a-cubicle-slave,is-a-democrat,is-a-designer,is-a-doctor,is-a-financialadvisor,is-a-geek,is-a-green,is-a-guru,is-a-hard-worker,is-a-hunter,is-a-landscaper,is-a-lawyer,is-a-liberal,is-a-libertarian,is-a-llama,is-a-musician,is-a-nascarfan,is-a-nurse,is-a-painter,is-a-personaltrainer,is-a-photographer,is-a-player,is-a-republican,is-a-rockstar,is-a-socialist,is-a-student,is-a-teacher,is-a-techie,is-a-therapist,is-an-accountant,is-an-actor,is-an-actress,is-an-anarchist,is-an-artist,is-an-engineer,is-an-entertainer,is-certified,is-gone,is-into-anime,is-into-cars,is-into-cartoons,is-into-games,is-leet,is-not-certified,is-slick,is-uberleet,is-with-theband,isa-geek,isa-hockeynut,issmarterthanyou,likes-pie,likescandy,neat-url,saves-the-whales,selfip,sells-for-less,sells-for-u,servebbs,simple-url,space-to-rent,teaches-yoga,writesthisblog,ddnsfree,ddnsgeek,giize,gleeze,kozow,loseyourip,ooguy,theworkpc,elluciancrmadvance,elluciancrmadvise,elluciancrmrecruit,mytuleap,tuleap-partners,evennode>eu-1,eu-2,eu-3,eu-4,us-1,us-2,us-3,us-4<onfabrica,fbsbx>apps<fastly-terrarium,fastvps-server,mydobiss,firebaseapp,forgeblocks,framercanvas,freebox-os,freeboxos,freemyip,gentapps,gentlentapis,githubusercontent,0emm>*<appspot>r>*<<codespot,googleapis,googlecode,pagespeedmobilizer,publishproxy,withgoogle,withyoutube,blogspot,awsmppl,herokuapp,herokussl,myravendb,impertrixcdn,impertrix,smushcdn,wphostedmail,wpmucdn,pixolino,amscompute,clicketcloud,dopaas,hidora,hosted-by-previder>paas<hosteur>rag-cloud,rag-cloud-ch<ik-server>jcloud,jcloud-ver-jpc<jelastic>demo<kilatiron,massivegrid>paas<wafaicloud>jed,lon,ryd<joyent>cns>*<<lpusercontent,lmpm>app<linode>members,nodebalancer>*<<linodeobjects>*<barsycenter,barsyonline,mazeplay,miniserver,meteorapp>eu<hostedpi,mythic-beasts>customer,caracal,fentiger,lynx,ocelot,oncilla,onza,sphinx,vs,x,yali<4u,nfshost,001www,ddnslive,myiphost,blogsyte,ciscofreak,damnserver,ditchyourip,dnsiskinky,dynns,geekgalaxy,health-carereform,homesecuritymac,homesecuritypc,myactivedirectory,mysecuritycamera,net-freaks,onthewifi,point2this,quicksytes,securitytactics,serveexchange,servehumour,servep2p,servesarcasm,stufftoread,unusualperson,workisboring,3utilities,ddnsking,myvnc,servebeer,servecounterstrike,serveftp,servegame,servehalflife,servehttp,serveirc,servemp3,servepics,servequake,observableusercontent>static<orsites,operaunite,authgear-staging,authgearapps,skygearapp,outsystemscloud,ownprovider,pgfog,pagefrontapp,pagexl,paywhirl>*<gotpantheon,platter-app,pleskns,postman-echo,prgmr>xen<pythonanywhere>eu<qualifioapp,qbuser,qa2,dev-myqnapcloud,alpha-myqnapcloud,myqnapcloud,quipelements>*<rackmaze,rhcloud,render>app<onrender,logoip,scrysec,firewall-gateway,myshopblocks,myshopify,shopitsite,1kapp,appchizi,applinzi,sinaapp,vipsinaapp,bounty-full>alpha,beta<try-snowplow,stackhero-network,playstation-cloud,myspreadshop,stdlib>api<temp-dns,dsmynas,familyds,reservd,thingdustdata,bloxcms,townnews-staging,hk,wafflecell,idnblogger,indowapblog,reserve-online,hotelwithflight,remotewd,wiardweb>pages<woltlab-demo,wpenginepowered>js<wixsite,xnbay>u2,u2-local<yolasite<live>hlx<net>adobeaemcloud,alwaysdata,cloudfront,t3l3p0rt,appudo,atlassian-dev>prod>cdn<<myfritz,onavstack,blackbaudcdn,boomla,bplaced,square7,gb,hu,jp,se,uk,in,clic2000,clickrising,cloudaccess,cdn77-ssl,cdn77>r<feste-ip,knx-server,static-access,cryptonomic>*<dattolocal,mydatto,debian,bitbridge,at-band-camp,blogdns,broke-it,buyshouses,dnsalias,dnsdojo,does-it,dontexist,dynalias,dynathome,endofinternet,from-az,from-co,from-la,from-ny,gets-it,ham-radio-op,homeftp,homeip,homelinux,homeunix,in-the-band,is-a-chef,is-a-geek,isa-geek,kicks-ass,office-on-the,podzone,scrapper-site,selfip,sells-it,servebbs,serveftp,thruhere,webhop,definima,casacam,dynu,dynv6,twmail,ru,channelsdvr>u<fastlylb>map<fastly>freetls,map,prod>a,global<ssl>a,b,global<<edgeapp,flynnhosting,cdn-edges,cloudfunctions,moonscale,in-dsl,in-vpn,ipifony,iobb,cloudjiffy>fra1-de,west1-us<elastx>jls-sto1,jls-sto2,jls-sto3<faststacks,massivegrid>paas>fr-1,lon-1,lon-2,ny-1,ny-2,sg-1<<saveincloud>jelastic,nordeste-idc<scaleforce>j<tsukaeru>jelastic<kinghost,uni5,krellian,barsy,memset,azurewebsites,azure-mobile,cloudapp,azurestaticapps>centralus,eastasia,eastus2,westeurope,westus2<dnsup,hicam,now-dns,ownip,vpndns,eating-organic,mydissent,myeffect,mymediapc,mypsx,mysecuritycamera,nhlfan,no-ip,pgafan,privatizehealthinsurance,bounceme,ddns,redirectme,serveblog,serveminecraft,sytes,cloudycluster,ovh>webpaas>*<hosting>*<<bar0,bar1,bar2,rackmaze,schokokeks,firewall-gateway,seidat,senseering,siteleaf,vps-host>jelastic>atl,njs,ric<<myspreadshop,srcf>soc,user<supabase,dsmynas,familyds,torproject>pages<fastblog,reserve-online,community-pro,meinforum,yandexcloud>storage,website<za<page>hlx,hlx3,pdns,plesk,prvcy,magnet<pl>beep,ecommerce-shop,shoparena,homesklep,sdscloud,unicloud,krasnik,leczna,lubartow,lublin,poniatowa,swidnik,co,art,gliwice,krakow,poznan,wroc,zakopane,myspreadshop,gda,gdansk,gdynia,med,sopot<ca>barsy,awdev>*<co,blogspot,no-ip,myspreadshop<estate>compute>*<<network>alces>*<co,arvo,azimuth,tlon<org>altervista,amune>tele<pimienta,poivron,potager,sweetpepper,ae,us,certmgr,cdn77>c,rsc<cdn77-secure>origin>ssl<<cloudns,duckdns,tunk,dyndns>go,home<blogdns,blogsite,boldlygoingnowhere,dnsalias,dnsdojo,doesntexist,dontexist,doomdns,dvrdns,dynalias,endofinternet,endoftheinternet,from-me,game-host,gotdns,hobby-site,homedns,homeftp,homelinux,homeunix,is-a-bruinsfan,is-a-candidate,is-a-celticsfan,is-a-chef,is-a-geek,is-a-knight,is-a-linux-user,is-a-patsfan,is-a-soxfan,is-found,is-lost,is-saved,is-very-bad,is-very-evil,is-very-good,is-very-nice,is-very-sweet,isa-geek,kicks-ass,misconfused,podzone,readmyblog,selfip,sellsyourhome,servebbs,serveftp,servegame,stuff-4-sale,webhop,ddnss,accesscam,camdvr,freeddns,mywire,webredirect,eu>al,asso,at,au,be,bg,ca,cd,ch,cn,cy,cz,de,dk,edu,ee,es,fi,fr,gr,hr,hu,ie,il,in,int,is,it,jp,kr,lt,lu,lv,mc,me,mk,mt,my,net,ng,nl,no,nz,paris,pl,pt,q-a,ro,ru,se,si,sk,tr,uk,us<twmail,fedorainfracloud,fedorapeople,fedoraproject>cloud,os>app<stg>os>app<<<freedesktop,hepforge,in-dsl,in-vpn,js,barsy,mayfirst,mozilla-iot,bmoattachments,dynserv,now-dns,cable-modem,collegefan,couchpotatofries,mlbfan,mysecuritycamera,nflfan,read-books,ufcfan,hopto,myftp,no-ip,zapto,httpbin,pubtls,my-firewall,myfirewall,spdns,small-web,dsmynas,familyds,edugit,tuxfamily,diskstation,hk,wmflabs,toolforge,wmcloud,za<cn>com>amazonaws>compute>*<eb>cn-north-1,cn-northwest-1<elb>*<cn-north-1>s3<<<instantcloud<nl>amsw,virtueeldomein,co,hosting-cluster,blogspot,khplay,myspreadshop,transurl>*<cistron,demon<io>apigee,b-data,backplaneapp,banzaicloud>app,backyards>*<<bitbucket,bluebite,boxfuse,browsersafetymark,bigv>uk0<cleverapps,dappnode>dyndns<dedyn,drud,definima,fh-muenster,shw,forgerock>id<ghost,github,gitlab,lolipop,hasura-app,hostyhosting,moonscale>*<beebyte>paas<beebyteapp>sekd1<jele,unispace>cloud-fr1<webthings,loginline,barsy,azurecontainer>*<ngrok,nodeart>stage<nodum,nid,pantheonsite,dyn53,pstmn>mock<protonet,qoto,qcx>sys>*<<vaporcloud,vbrplsbx>g<on-k3s>*<on-rio>*<readthedocs,resindevice,resinstaging>devices<hzc,sandcats,shiftcrypto,shiftedit,mo-siemens,lair>apps<stolos>*<spacekit,utwente,s5y>*<telebit,thingdust>dev>cust,reservd<disrec>cust,reservd<prod>cust<testing>cust,reservd<<2038,wedeploy,editorx,basicserver,virtualserver<jp>ne>aseinet>user<gehirn<usercontent,blogspot<vc>gv>d<0e<eus>party>user<<ws>advisor>*<cloud66,dyndns,mypets<ba>rs,blogspot<cloud>banzai>*<elementor,statics>*<axarnet>es-1<diadem,jelastic>vip<jele,jenv-aruba>aruba>eur>it1<<it1<keliweb>cs<oxa>tn,uk<primetel>uk<reclaim>ca,uk,us<trendhosting>ch,de<jotelulu,kuleuven,linkyard,magentosite>*<perspecta,vapor,on-rancher>*<sensiosite>*<trafficplex,urown,voorloper<la>bnr,c<je>of<ch>square7,blogspot,flow>ae>alp1<appengine<linkyard-cloud,dnsking,gotdns,myspreadshop,firenet>*,svc>*<<12hp,2ix,4lima,lima-city<de>bplaced,square7,com,cosidns>dyn<dynamisches-dns,dnsupdater,internet-dns,l-o-g-i-n,dnshome,fuettertdasnetz,isteingeek,istmein,lebtimnetz,leitungsen,traeumtgerade,ddnss>dyn,dyndns<dyndns1,dyn-ip24,home-webserver>dyn<myhome-server,frusky>*<goip,blogspot,xn--gnstigbestellen-zvb,xn--gnstigliefern-wob,hs-heilbronn>it>pages<<dyn-berlin,in-berlin,in-brb,in-butter,in-dsl,in-vpn,mein-iserv,schulserver,test-iserv,keymachine,git-repos,lcube-server,svn-repos,barsy,logoip,firewall-gateway,my-gateway,my-router,spdns,speedpartner>customer<myspreadshop,taifun-dns,12hp,2ix,4lima,lima-city,dd-dns,dray-dns,draydns,dyn-vpn,dynvpn,mein-vigor,my-vigor,my-wan,syno-ds,synology-diskstation,synology-ds,uberspace>*<virtualuser,virtual-user,community-pro,diskussionsbereich<rs>brendly>shop<blogspot,ua,ox<uk>co>bytemark>dh,vm<blogspot,layershift>j<barsy,barsyonline,retrosnub>cust<nh-serv,no-ip,wellbeingzone,adimo,myspreadshop,gwiddle<conn,copro,hosp,gov>service,homeoffice<pymnt,org>glug,lug,lugs,affinitylottery,raffleentry,weeklylottery<barsy<eu>mycd,cloudns,dogado>jelastic<barsy,wellbeingzone,spdns,transurl>*<diskstation<ac>drr<ai>uwu<co>carrd,crd,otap>*<com>blogspot<leadpages,lpages,mypi,n4t,nodum,repl>id<supabase<mp>ju<se>com,blogspot,conf,iopsys,itcouldbewor,myspreadshop,paba>su<<bz>za,gsj<in>web,cloudns,blogspot,barsy,supabase<basketball>aus,nz<am>radio,blogspot,neko,nyaa<fm>radio<group>discourse<team>discourse,jelastic<app>clerk,clerkstage,wnext,platform0,ondigitalocean,edgecompute,fireweb,framer,run>a<web,hasura,loginline,netlify,developer>*<noop,northflank>*<telebit,vercel,bookonline<dev>lcl>*<lclstage>*<stg>*<stgstage>*<pages,workers,curv,deno,deno-staging,fly,githubpreview,gateway>*<iserv,loginline,mediatech,platter-app,shiftcrypto,vercel,webhare>*<<me>c66,daplie>localhost<edgestack,couk,ukco,filegear,filegear-au,filegear-de,filegear-gb,filegear-ie,filegear-jp,filegear-sg,glitch,ravendb,lohmus,barsy,mcpe,mcdir,soundcast,tcp4,brasilia,ddns,dnsfor,hopto,loginto,noip,webhop,vp4,diskstation,dscloud,i234,myds,synology,tbits,wbq,wedeploy,yombo,nohost<zone>cloud66,hs,triton>*<lima<host>cloudaccess,freesite,fastvps,myfast,tempurl,wpmudev,jele,mircloud,pcloud,half<site>cloudera>*<cyon,fnwk,folionetwork,fastvps,jele,lelux,loginline,barsy,mintere,omniwe,opensocial,platformsh>*<tst>*<byen,srht,novecore<cz>co,realm,e4,blogspot,metacentrum>cloud>*<custom<muni>cloud>flt,usr<<<asia>cloudns<biz>cloudns,jozi,dyndns,for-better,for-more,for-some,for-the,selfip,webhop,orx,mmafan,myftp,no-ip,dscloud<club>cloudns,jele,barsy,pony<cc>cloudns,ftpaccess,game-server,myphotos,scrapping,twmail,csx,fantasyleague<info>cloudns,dynamic-dns,dyndns,barrel-of-knowledge,barrell-of-knowledge,for-our,groks-the,groks-this,here-for-more,knowsitall,selfip,webhop,barsy,mayfirst,forumz,nsupdate,dvrcam,ilovecollege,no-ip,dnsupdate,v-info<pro>cloudns,dnstrace>bci<barsy<pw>cloudns,x443<gdn>cnpy<no>co,blogspot,myspreadshop<be>webhosting,blogspot,interhostsolutions>cloud<kuleuven>ezproxy<myspreadshop,transurl>*<<ru>ac,edu,gov,int,mil,test,eurodir,adygeya,bashkiria,bir,cbg,com,dagestan,grozny,kalmykia,kustanai,marine,mordovia,msk,mytis,nalchik,nov,pyatigorsk,spb,vladikavkaz,vladimir,blogspot,na4u,mircloud,regruhosting>jelastic<myjino>hosting>*<landing>*<spectrum>*<vps>*<<cldmail>hb<mcdir>vps<mcpre,net,org,pp,lk3,ras<is>cupcake,blogspot<link>cyon,mypep,dweb>*<<dk>biz,co,firm,reg,store,blogspot,myspreadshop<earth>dapps>*,bzz>*<<<id>my>rss>*<<flap,co>blogspot<forte,bloger,wblog<solutions>diher>*<<th>online,shop<sh>bip,hashbang,platform>bc,ent,eu,us<now,vxl,wedeploy<fi>dy,blogspot,xn--hkkinen-5wa,iki,cloudplatform>fi<datacenter>demo,paas<myspreadshop<tv>dyndns,better-than,on-the-web,worse-than<cx>ath,info<name>her>forgot<his>forgot<<nu>merseine,mine,shacknet,enterprisecloud<rocks>myddns,lima-city,webspace<xyz>blogsite,localzone,crafting,zapto,telebit>*<<online>eero,eero-stage,barsy<cool>elementor,de<fr>en-root,fbx-os,fbxos,freebox-os,freeboxos,blogspot,goupile,on-web,chirurgiens-dentistes-en-france,myspreadshop,ynh<one>onred>staging<service,for,under,homelink<tw>com>mymailer<url,blogspot<su>abkhazia,adygeya,aktyubinsk,arkhangelsk,armenia,ashgabad,azerbaijan,balashov,bashkiria,bryansk,bukhara,chimkent,dagestan,east-kazakhstan,exnet,georgia,grozny,ivanovo,jambyl,kalmykia,kaluga,karacol,karaganda,karelia,khakassia,krasnodar,kurgan,kustanai,lenug,mangyshlak,mordovia,msk,murmansk,nalchik,navoi,north-kazakhstan,nov,obninsk,penza,pokrovsk,sochi,spb,tashkent,termez,togliatti,troitsk,tselinograd,tula,tuva,vladikavkaz,vladimir,vologda<space>myfast,uber,xs4all<il>co>ravpage,blogspot,tabitorder<<at>funkfeuer>wien<futurecms>*,ex>*<in>*<<futurehosting,futuremailing,ortsinfo>ex>*<kunden>*<<co>blogspot<biz,info,priv,myspreadshop,12hp,2ix,4lima,lima-city<ms>lab,minisite<si>gitapp,gitpage,blogspot<community>nog,ravendb,myforum<ro>co,shop,blogspot,barsy<digital>cloudapps>london<<im>ro<goog>cloud,translate<ae>blogspot<al>blogspot<bg>blogspot,barsy<bj>blogspot<cf>blogspot<cl>blogspot<ke>co>blogspot<<nz>co>blogspot<<za>co>blogspot<<ar>com>blogspot<<au>com>blogspot,cloudlets>mel<myspreadshop<<br>com>blogspot,virtualcloud>scale>users<<<leg>ac,al,am,ap,ba,ce,df,es,go,ma,mg,ms,mt,pa,pb,pe,pi,pr,rj,rn,ro,rr,rs,sc,se,sp,to<<by>com>blogspot<mycloud,mediatech<cy>com>blogspot,scaleforce>j<<<ee>com>blogspot<<eg>com>blogspot<<es>com>blogspot<myspreadshop<mt>com>blogspot<<ng>com>blogspot<col,firm,gen,ltd,ngo<tr>com>blogspot<<uy>com>blogspot<<cv>blogspot<gr>blogspot<hk>blogspot,secaas,ltd,inc<hr>blogspot,free<hu>blogspot<ie>blogspot,myspreadshop<it>blogspot,neen>jc<tim>open>jelastic>cloud<<<16-b,32-b,64-b,myspreadshop,syncloud<kr>blogspot<li>blogspot,caa<lt>blogspot<lu>blogspot<md>blogspot,at,de,jp,to<mk>blogspot<mr>blogspot<mx>blogspot<my>blogspot<pe>blogspot<pt>blogspot<qa>blogspot<re>blogspot<sg>blogspot,enscaled<sk>blogspot<sn>blogspot<td>blogspot<ug>blogspot<vn>blogspot<ci>fin,nl<run>hs,development,ravendb,servers,code>*<repl<gl>biz,xx<scot>edu,gov>service<<so>sch<yt>org<kz>jcloud,kazteleport>upaas<<tn>orangecloud<gg>kaas,cya,panel>daemon<<systems>knightpoint<krd>co,edu<business>co<education>co<events>co<financial>co<place>co<technology>co<bs>we<services>loginline<menu>barsy<mobi>barsy,dscloud<pub>barsy<shop>barsy<support>barsy<vu>cn,blog,dev,me<health>hra<casa>nabu>ui<<fashion>of<london>in,of<marketing>from,with<men>for,repair<mom>and,for<sale>for<win>that<work>from,to<news>noticeable<top>now-dns,ntdll<ovh>nerdpol<mn>nyc<lol>omg<hosting>opencraft<pm>own<codes>owo>*<<lc>oy<bn>co<builders>cloudsite<edu>rit>git-pages<<xn--p1acf>xn--90amc,xn--j1aef,xn--j1ael8b,xn--h1ahn,xn--j1adp,xn--c1avg,xn--80aaa0cvac,xn--h1aliz,xn--90a1af,xn--41a<store>sellfy,shopware,storebase<land>static>dev,sites<<farm>storj<pictures>1337<rip>clan<management>router<ax>be,cat,es,eu,gg,mc,us,xy<gp>app<gt>blog,de,to<gy>be<hn>cc<kg>blog,io,jp,tv,uk,us<ls>de<porn>indie<tc>ch,me,we<vg>at<academy>official<faith>ybo<party>ybo<review>ybo<science>ybo<trade>ybo<st>noho<design>bss";

/***/ })

}]);